import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `BigInt` scalar type represents non-fractional signed whole numeric values.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt
   */
  BigInt: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Bytes: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** An arbitrary-precision Decimal type */
  Decimal: { input: any; output: any; }
  /** JSON data */
  JSON: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: any; output: any; }
  /** MongoDB ObjectId scalar type */
  ObjectId: { input: any; output: any; }
};

export type AcceptChapterRequestResponse = {
  __typename?: 'AcceptChapterRequestResponse';
  status: ChapterRequestStatusEnum;
  success: Scalars['Boolean']['output'];
  validationMessages?: Maybe<Array<Maybe<ChapterRequestValidationMessage>>>;
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type Action = {
  __typename?: 'Action';
  ActionTemplate?: Maybe<ActionTemplate>;
  Activities: Array<Activity>;
  Campaigns: Array<Campaign>;
  Causes: Array<Cause>;
  Nonprofit?: Maybe<Organization>;
  Organization: Organization;
  _count: ActionCountOutputType;
  actionTemplateId?: Maybe<Scalars['String']['output']>;
  /** Number of activities */
  activitiesCount?: Maybe<Scalars['Int']['output']>;
  /** bannerImage of action */
  bannerImage?: Maybe<Scalars['String']['output']>;
  campaignIds: Array<Scalars['String']['output']>;
  causes: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  /** description of action */
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  incentives: Array<Incentive>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  locations: Array<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  public?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status: ActionVisibilityStatus;
  /** subTitle of action */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** title of action */
  title?: Maybe<Scalars['String']['output']>;
  /** Only the User`s activities */
  userActivities: Array<Activity>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActionActionTemplateArgs = {
  where?: InputMaybe<ActionTemplateWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActionActivitiesArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ActivityScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ActivityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActionCampaignsArgs = {
  cursor?: InputMaybe<CampaignWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CampaignScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CampaignOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CampaignWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActionCausesArgs = {
  cursor?: InputMaybe<CauseWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CauseScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CauseOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CauseWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActionNonprofitArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type ActionActivityArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionAvgAggregateOutputType = {
  __typename?: 'ActionAvgAggregateOutputType';
  activitiesCount?: Maybe<Scalars['Float']['output']>;
};

export type ActionAvgOrderByAggregateInput = {
  activitiesCount?: InputMaybe<SortOrder>;
};

export type ActionCountAggregateOutputType = {
  __typename?: 'ActionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  actionTemplateId: Scalars['Int']['output'];
  activitiesCount: Scalars['Int']['output'];
  activityIds: Scalars['Int']['output'];
  bannerImage: Scalars['Int']['output'];
  campaignIds: Scalars['Int']['output'];
  causes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifiedBy: Scalars['Int']['output'];
  locations: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  subTitle: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
};

export type ActionCountOrderByAggregateInput = {
  actionTemplateId?: InputMaybe<SortOrder>;
  activitiesCount?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionCountOutputType = {
  __typename?: 'ActionCountOutputType';
  Activities: Scalars['Int']['output'];
  Campaigns: Scalars['Int']['output'];
  Causes: Scalars['Int']['output'];
};

export type ActionCreateInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateManyActionTemplateInput = {
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateManyActionTemplateInputEnvelope = {
  data: ActionCreateManyActionTemplateInput;
};

export type ActionCreateManyInput = {
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateManyNonprofitInput = {
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateManyNonprofitInputEnvelope = {
  data: ActionCreateManyNonprofitInput;
};

export type ActionCreateManyOrganizationInput = {
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateManyOrganizationInputEnvelope = {
  data: ActionCreateManyOrganizationInput;
};

export type ActionCreateNestedManyWithoutActionTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutActionTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutActionTemplateInput>>>;
  createMany?: InputMaybe<ActionCreateManyActionTemplateInputEnvelope>;
};

export type ActionCreateNestedManyWithoutCampaignsInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCampaignsInput>>>;
};

export type ActionCreateNestedManyWithoutCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCausesInput>>>;
};

export type ActionCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<ActionCreateManyNonprofitInputEnvelope>;
};

export type ActionCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionCreateManyOrganizationInputEnvelope>;
};

export type ActionCreateNestedOneWithoutActivitiesInput = {
  connect?: InputMaybe<ActionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActionCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<ActionCreateWithoutActivitiesInput>;
};

export type ActionCreateOrConnectWithoutActionTemplateInput = {
  create: ActionCreateWithoutActionTemplateInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutActivitiesInput = {
  create: ActionCreateWithoutActivitiesInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutCampaignsInput = {
  create: ActionCreateWithoutCampaignsInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutCausesInput = {
  create: ActionCreateWithoutCausesInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutNonprofitInput = {
  create: ActionCreateWithoutNonprofitInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutOrganizationInput = {
  create: ActionCreateWithoutOrganizationInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateWithoutActionTemplateInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateWithoutActivitiesInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateWithoutCampaignsInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateWithoutCausesInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateWithoutNonprofitInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Organization: OrganizationCreateNestedOneWithoutActionOrganizationsInput;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateWithoutOrganizationInput = {
  ActionTemplate?: InputMaybe<ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutActionsInput>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCreateactivityIdsInput = {
  set: Scalars['String']['input'];
};

export type ActionCreatecampaignIdsInput = {
  set: Scalars['String']['input'];
};

export type ActionCreatecausesInput = {
  set: Scalars['String']['input'];
};

export type ActionCreatelocationsInput = {
  set: Scalars['String']['input'];
};

export type ActionListRelationFilter = {
  every?: InputMaybe<ActionWhereInput>;
  none?: InputMaybe<ActionWhereInput>;
  some?: InputMaybe<ActionWhereInput>;
};

export type ActionMaxAggregateOutputType = {
  __typename?: 'ActionMaxAggregateOutputType';
  actionTemplateId?: Maybe<Scalars['String']['output']>;
  activitiesCount?: Maybe<Scalars['Int']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ActionVisibilityStatus>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionMaxOrderByAggregateInput = {
  actionTemplateId?: InputMaybe<SortOrder>;
  activitiesCount?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionMinAggregateOutputType = {
  __typename?: 'ActionMinAggregateOutputType';
  actionTemplateId?: Maybe<Scalars['String']['output']>;
  activitiesCount?: Maybe<Scalars['Int']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ActionVisibilityStatus>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionMinOrderByAggregateInput = {
  actionTemplateId?: InputMaybe<SortOrder>;
  activitiesCount?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActionOrderByWithAggregationInput = {
  _avg?: InputMaybe<ActionAvgOrderByAggregateInput>;
  _count?: InputMaybe<ActionCountOrderByAggregateInput>;
  _max?: InputMaybe<ActionMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActionMinOrderByAggregateInput>;
  _sum?: InputMaybe<ActionSumOrderByAggregateInput>;
  actionTemplateId?: InputMaybe<SortOrder>;
  activitiesCount?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionOrderByWithRelationInput = {
  ActionTemplate?: InputMaybe<ActionTemplateOrderByWithRelationInput>;
  Activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  Campaigns?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  Causes?: InputMaybe<CauseOrderByRelationAggregateInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  actionTemplateId?: InputMaybe<SortOrder>;
  activitiesCount?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  campaignIds?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incentives?: InputMaybe<IncentiveOrderByCompositeAggregateInput>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionRelationFilter = {
  is?: InputMaybe<ActionWhereInput>;
  isNot?: InputMaybe<ActionWhereInput>;
};

export enum ActionScalarFieldEnum {
  ActionTemplateId = 'actionTemplateId',
  ActivitiesCount = 'activitiesCount',
  ActivityIds = 'activityIds',
  BannerImage = 'bannerImage',
  CampaignIds = 'campaignIds',
  Causes = 'causes',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Description = 'description',
  Enabled = 'enabled',
  EndingAt = 'endingAt',
  Id = 'id',
  LastModifiedBy = 'lastModifiedBy',
  Locations = 'locations',
  ModifiedAt = 'modifiedAt',
  NonprofitId = 'nonprofitId',
  OrganizationId = 'organizationId',
  Public = 'public',
  StartingAt = 'startingAt',
  Status = 'status',
  SubTitle = 'subTitle',
  Title = 'title'
}

export type ActionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  actionTemplateId?: InputMaybe<StringNullableFilter>;
  activitiesCount?: InputMaybe<IntNullableFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type ActionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionScalarWhereWithAggregatesInput>>>;
  actionTemplateId?: InputMaybe<StringNullableWithAggregatesFilter>;
  activitiesCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  enabled?: InputMaybe<BoolWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastModifiedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizationId?: InputMaybe<StringWithAggregatesFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusWithAggregatesFilter>;
  subTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ActionStats = {
  __typename?: 'ActionStats';
  incentiveSummary: Array<IncentiveSummary>;
  totalCompletedActivities?: Maybe<Scalars['Int']['output']>;
};

export type ActionStatsCreateInput = {
  incentiveSummary?: InputMaybe<Array<InputMaybe<IncentiveSummaryCreateInput>>>;
  totalCompletedActivities?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionStatsNullableCompositeFilter = {
  equals?: InputMaybe<ActionStatsObjectEqualityInput>;
  is?: InputMaybe<ActionStatsWhereInput>;
  isNot?: InputMaybe<ActionStatsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionStatsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ActionStatsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ActionStatsUpsertInput>;
};

export type ActionStatsObjectEqualityInput = {
  incentiveSummary?: InputMaybe<Array<InputMaybe<IncentiveSummaryObjectEqualityInput>>>;
  totalCompletedActivities?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionStatsOrderByInput = {
  incentiveSummary?: InputMaybe<IncentiveSummaryOrderByCompositeAggregateInput>;
  totalCompletedActivities?: InputMaybe<SortOrder>;
};

export type ActionStatsUpdateInput = {
  incentiveSummary?: InputMaybe<Array<InputMaybe<IncentiveSummaryCreateInput>>>;
  totalCompletedActivities?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ActionStatsUpsertInput = {
  set: ActionStatsCreateInput;
  update: ActionStatsUpdateInput;
};

export type ActionStatsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionStatsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionStatsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionStatsWhereInput>>>;
  incentiveSummary?: InputMaybe<Array<InputMaybe<IncentiveSummaryObjectEqualityInput>>>;
  totalCompletedActivities?: InputMaybe<IntNullableFilter>;
};

export type ActionSumAggregateOutputType = {
  __typename?: 'ActionSumAggregateOutputType';
  activitiesCount?: Maybe<Scalars['Int']['output']>;
};

export type ActionSumOrderByAggregateInput = {
  activitiesCount?: InputMaybe<SortOrder>;
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage), Employee(companyField: organizationId)]) */
export type ActionTemplate = {
  __typename?: 'ActionTemplate';
  Causes: Array<Cause>;
  Organization?: Maybe<Organization>;
  _count: ActionTemplateCountOutputType;
  bannerImage?: Maybe<Scalars['String']['output']>;
  causes: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incentives: Array<Incentive>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  status: ActionVisibilityStatus;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage), Employee(companyField: organizationId)]) */
export type ActionTemplateCausesArgs = {
  cursor?: InputMaybe<CauseWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CauseScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CauseOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CauseWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage), Employee(companyField: organizationId)]) */
export type ActionTemplateOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type ActionTemplateCountAggregateOutputType = {
  __typename?: 'ActionTemplateCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  actionTemplateActionIds: Scalars['Int']['output'];
  bannerImage: Scalars['Int']['output'];
  causes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModifiedBy: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  subTitle: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
};

export type ActionTemplateCountOrderByAggregateInput = {
  actionTemplateActionIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionTemplateCountOutputType = {
  __typename?: 'ActionTemplateCountOutputType';
  ActionTemplateActions: Scalars['Int']['output'];
  Causes: Scalars['Int']['output'];
};

export type ActionTemplateCreateInput = {
  ActionTemplateActions?: InputMaybe<ActionCreateNestedManyWithoutActionTemplateInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionTemplatesInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutActionTemplateOrganizationsInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateManyInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateManyOrganizationInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateManyOrganizationInputEnvelope = {
  data: ActionTemplateCreateManyOrganizationInput;
};

export type ActionTemplateCreateNestedManyWithoutCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutCausesInput>>>;
};

export type ActionTemplateCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionTemplateCreateManyOrganizationInputEnvelope>;
};

export type ActionTemplateCreateNestedOneWithoutActionTemplateActionsInput = {
  connect?: InputMaybe<ActionTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActionTemplateCreateOrConnectWithoutActionTemplateActionsInput>;
  create?: InputMaybe<ActionTemplateCreateWithoutActionTemplateActionsInput>;
};

export type ActionTemplateCreateOrConnectWithoutActionTemplateActionsInput = {
  create: ActionTemplateCreateWithoutActionTemplateActionsInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateCreateOrConnectWithoutCausesInput = {
  create: ActionTemplateCreateWithoutCausesInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateCreateOrConnectWithoutOrganizationInput = {
  create: ActionTemplateCreateWithoutOrganizationInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateCreateWithoutActionTemplateActionsInput = {
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionTemplatesInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutActionTemplateOrganizationsInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateWithoutCausesInput = {
  ActionTemplateActions?: InputMaybe<ActionCreateNestedManyWithoutActionTemplateInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutActionTemplateOrganizationsInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateWithoutOrganizationInput = {
  ActionTemplateActions?: InputMaybe<ActionCreateNestedManyWithoutActionTemplateInput>;
  Causes?: InputMaybe<CauseCreateNestedManyWithoutActionTemplatesInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateCreateactionTemplateActionIdsInput = {
  set: Scalars['String']['input'];
};

export type ActionTemplateCreatecausesInput = {
  set: Scalars['String']['input'];
};

export type ActionTemplateListRelationFilter = {
  every?: InputMaybe<ActionTemplateWhereInput>;
  none?: InputMaybe<ActionTemplateWhereInput>;
  some?: InputMaybe<ActionTemplateWhereInput>;
};

export type ActionTemplateMaxAggregateOutputType = {
  __typename?: 'ActionTemplateMaxAggregateOutputType';
  bannerImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ActionVisibilityStatus>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionTemplateMaxOrderByAggregateInput = {
  bannerImage?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionTemplateMinAggregateOutputType = {
  __typename?: 'ActionTemplateMinAggregateOutputType';
  bannerImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ActionVisibilityStatus>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionTemplateMinOrderByAggregateInput = {
  bannerImage?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionTemplateNullableRelationFilter = {
  is?: InputMaybe<ActionTemplateWhereInput>;
  isNot?: InputMaybe<ActionTemplateWhereInput>;
};

export type ActionTemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActionTemplateOrderByWithAggregationInput = {
  _count?: InputMaybe<ActionTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<ActionTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActionTemplateMinOrderByAggregateInput>;
  actionTemplateActionIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ActionTemplateOrderByWithRelationInput = {
  ActionTemplateActions?: InputMaybe<ActionOrderByRelationAggregateInput>;
  Causes?: InputMaybe<CauseOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  actionTemplateActionIds?: InputMaybe<SortOrder>;
  bannerImage?: InputMaybe<SortOrder>;
  causes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  incentives?: InputMaybe<IncentiveOrderByCompositeAggregateInput>;
  lastModifiedBy?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum ActionTemplateScalarFieldEnum {
  ActionTemplateActionIds = 'actionTemplateActionIds',
  BannerImage = 'bannerImage',
  Causes = 'causes',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Description = 'description',
  Id = 'id',
  LastModifiedBy = 'lastModifiedBy',
  ModifiedAt = 'modifiedAt',
  OrganizationId = 'organizationId',
  Public = 'public',
  Status = 'status',
  SubTitle = 'subTitle',
  Title = 'title'
}

export type ActionTemplateScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  actionTemplateActionIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ActionTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereWithAggregatesInput>>>;
  actionTemplateActionIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastModifiedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusWithAggregatesFilter>;
  subTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type ActionTemplateUncheckedCreateInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutActionTemplateInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionTemplatesInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateUncheckedCreateNestedManyWithoutCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutCausesInput>>>;
};

export type ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionTemplateCreateManyOrganizationInputEnvelope>;
};

export type ActionTemplateUncheckedCreateWithoutActionTemplateActionsInput = {
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionTemplatesInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateUncheckedCreateWithoutCausesInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutActionTemplateInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateUncheckedCreateWithoutOrganizationInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutActionTemplateInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionTemplatesInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ActionTemplateUncheckedUpdateInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedUpdateManyWithoutActionTemplateNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionTemplatesNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateManyInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateManyWithoutCausesInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateManyWithoutCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateWithWhereUniqueWithoutCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateManyWithWhereWithoutCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionTemplateUpsertWithWhereUniqueWithoutCausesInput>>>;
};

export type ActionTemplateUncheckedUpdateManyWithoutOrganizationInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionTemplateCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionTemplateUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActionTemplateUncheckedUpdateWithoutActionTemplateActionsInput = {
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionTemplatesNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateWithoutCausesInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedUpdateManyWithoutActionTemplateNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUncheckedUpdateWithoutOrganizationInput = {
  ActionTemplateActions?: InputMaybe<ActionUncheckedUpdateManyWithoutActionTemplateNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionTemplatesNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateInput = {
  ActionTemplateActions?: InputMaybe<ActionUpdateManyWithoutActionTemplateNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionTemplatesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutActionTemplateOrganizationsNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateManyMutationInput = {
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateManyWithWhereWithoutCausesInput = {
  data: ActionTemplateUpdateManyMutationInput;
  where: ActionTemplateScalarWhereInput;
};

export type ActionTemplateUpdateManyWithWhereWithoutOrganizationInput = {
  data: ActionTemplateUpdateManyMutationInput;
  where: ActionTemplateScalarWhereInput;
};

export type ActionTemplateUpdateManyWithoutCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateWithWhereUniqueWithoutCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateManyWithWhereWithoutCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionTemplateUpsertWithWhereUniqueWithoutCausesInput>>>;
};

export type ActionTemplateUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionTemplateCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionTemplateCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionTemplateCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionTemplateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionTemplateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionTemplateUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionTemplateUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput = {
  connect?: InputMaybe<ActionTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActionTemplateCreateOrConnectWithoutActionTemplateActionsInput>;
  create?: InputMaybe<ActionTemplateCreateWithoutActionTemplateActionsInput>;
  delete?: InputMaybe<ActionTemplateWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ActionTemplateUpdateToOneWithWhereWithoutActionTemplateActionsInput>;
  upsert?: InputMaybe<ActionTemplateUpsertWithoutActionTemplateActionsInput>;
};

export type ActionTemplateUpdateToOneWithWhereWithoutActionTemplateActionsInput = {
  data: ActionTemplateUpdateWithoutActionTemplateActionsInput;
  where?: InputMaybe<ActionTemplateWhereInput>;
};

export type ActionTemplateUpdateWithWhereUniqueWithoutCausesInput = {
  data: ActionTemplateUpdateWithoutCausesInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ActionTemplateUpdateWithoutOrganizationInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateUpdateWithoutActionTemplateActionsInput = {
  Causes?: InputMaybe<CauseUpdateManyWithoutActionTemplatesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutActionTemplateOrganizationsNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateWithoutCausesInput = {
  ActionTemplateActions?: InputMaybe<ActionUpdateManyWithoutActionTemplateNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutActionTemplateOrganizationsNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateWithoutOrganizationInput = {
  ActionTemplateActions?: InputMaybe<ActionUpdateManyWithoutActionTemplateNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionTemplatesNestedInput>;
  actionTemplateActionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionTemplateUpdateactionTemplateActionIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionTemplateUpdatecausesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionTemplateUpsertInputType = {
  bannerImage: Scalars['String']['input'];
  causes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<IncentiveInputType>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  status: ActionVisibilityStatus;
  subTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ActionTemplateUpsertWithWhereUniqueWithoutCausesInput = {
  create: ActionTemplateCreateWithoutCausesInput;
  update: ActionTemplateUpdateWithoutCausesInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ActionTemplateCreateWithoutOrganizationInput;
  update: ActionTemplateUpdateWithoutOrganizationInput;
  where: ActionTemplateWhereUniqueInput;
};

export type ActionTemplateUpsertWithoutActionTemplateActionsInput = {
  create: ActionTemplateCreateWithoutActionTemplateActionsInput;
  update: ActionTemplateUpdateWithoutActionTemplateActionsInput;
  where?: InputMaybe<ActionTemplateWhereInput>;
};

export type ActionTemplateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  ActionTemplateActions?: InputMaybe<ActionListRelationFilter>;
  Causes?: InputMaybe<CauseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  actionTemplateActionIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveObjectEqualityInput>>>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ActionTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  ActionTemplateActions?: InputMaybe<ActionListRelationFilter>;
  Causes?: InputMaybe<CauseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionTemplateWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  actionTemplateActionIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveObjectEqualityInput>>>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type ActionTemplatesResult = {
  __typename?: 'ActionTemplatesResult';
  templates: Array<ActionTemplate>;
  total: Scalars['Int']['output'];
};

export type ActionUncheckedCreateInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateNestedManyWithoutActionTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutActionTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutActionTemplateInput>>>;
  createMany?: InputMaybe<ActionCreateManyActionTemplateInputEnvelope>;
};

export type ActionUncheckedCreateNestedManyWithoutCampaignsInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCampaignsInput>>>;
};

export type ActionUncheckedCreateNestedManyWithoutCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCausesInput>>>;
};

export type ActionUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<ActionCreateManyNonprofitInputEnvelope>;
};

export type ActionUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionCreateManyOrganizationInputEnvelope>;
};

export type ActionUncheckedCreateWithoutActionTemplateInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateWithoutActivitiesInput = {
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateWithoutCampaignsInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateWithoutCausesInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateWithoutNonprofitInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedCreateWithoutOrganizationInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutActionInput>;
  Campaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutActionsInput>;
  Causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutActionsInput>;
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  activitiesCount?: InputMaybe<Scalars['Int']['input']>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActionVisibilityStatus;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionUncheckedUpdateInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyInput = {
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutActionTemplateInput = {
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutActionTemplateNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutActionTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutActionTemplateInput>>>;
  createMany?: InputMaybe<ActionCreateManyActionTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutActionTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutActionTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutActionTemplateInput>>>;
};

export type ActionUncheckedUpdateManyWithoutCampaignsInput = {
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutCampaignsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCampaignsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutCampaignsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutCampaignsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutCampaignsInput>>>;
};

export type ActionUncheckedUpdateManyWithoutCausesInput = {
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutCausesInput>>>;
};

export type ActionUncheckedUpdateManyWithoutNonprofitInput = {
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<ActionCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type ActionUncheckedUpdateManyWithoutOrganizationInput = {
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActionUncheckedUpdateWithoutActionTemplateInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateWithoutActivitiesInput = {
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateWithoutCampaignsInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateWithoutCausesInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateWithoutNonprofitInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUncheckedUpdateWithoutOrganizationInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUncheckedUpdateManyWithoutActionsNestedInput>;
  actionTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateManyMutationInput = {
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateManyWithWhereWithoutActionTemplateInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutCampaignsInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutCausesInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutNonprofitInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutOrganizationInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithoutActionTemplateNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutActionTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutActionTemplateInput>>>;
  createMany?: InputMaybe<ActionCreateManyActionTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutActionTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutActionTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutActionTemplateInput>>>;
};

export type ActionUpdateManyWithoutCampaignsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCampaignsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutCampaignsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutCampaignsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutCampaignsInput>>>;
};

export type ActionUpdateManyWithoutCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutCausesInput>>>;
};

export type ActionUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<ActionCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type ActionUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActionCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActionCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActionCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActionUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActionUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActionUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActionUpdateOneRequiredWithoutActivitiesNestedInput = {
  connect?: InputMaybe<ActionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActionCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<ActionCreateWithoutActivitiesInput>;
  update?: InputMaybe<ActionUpdateToOneWithWhereWithoutActivitiesInput>;
  upsert?: InputMaybe<ActionUpsertWithoutActivitiesInput>;
};

export type ActionUpdateToOneWithWhereWithoutActivitiesInput = {
  data: ActionUpdateWithoutActivitiesInput;
  where?: InputMaybe<ActionWhereInput>;
};

export type ActionUpdateWithWhereUniqueWithoutActionTemplateInput = {
  data: ActionUpdateWithoutActionTemplateInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutCampaignsInput = {
  data: ActionUpdateWithoutCampaignsInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutCausesInput = {
  data: ActionUpdateWithoutCausesInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: ActionUpdateWithoutNonprofitInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ActionUpdateWithoutOrganizationInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithoutActionTemplateInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateWithoutActivitiesInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateWithoutCampaignsInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateWithoutCausesInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateWithoutNonprofitInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateWithoutOrganizationInput = {
  ActionTemplate?: InputMaybe<ActionTemplateUpdateOneWithoutActionTemplateActionsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutActionNestedInput>;
  Campaigns?: InputMaybe<CampaignUpdateManyWithoutActionsNestedInput>;
  Causes?: InputMaybe<CauseUpdateManyWithoutActionsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutActionsNestedInput>;
  activitiesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  lastModifiedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionVisibilityStatusFieldUpdateOperationsInput>;
  subTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActionUpdateactivityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionUpdatecampaignIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionUpdatecausesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionUpdatelocationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ActionUpsertInputType = {
  actionTemplateId?: InputMaybe<Scalars['String']['input']>;
  bannerImage: Scalars['String']['input'];
  campaignIds?: InputMaybe<Array<Scalars['String']['input']>>;
  causes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endingAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<IncentiveInputType>>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['String']['input']>;
  status: ActionVisibilityStatus;
  subTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ActionUpsertWithWhereUniqueWithoutActionTemplateInput = {
  create: ActionCreateWithoutActionTemplateInput;
  update: ActionUpdateWithoutActionTemplateInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutCampaignsInput = {
  create: ActionCreateWithoutCampaignsInput;
  update: ActionUpdateWithoutCampaignsInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutCausesInput = {
  create: ActionCreateWithoutCausesInput;
  update: ActionUpdateWithoutCausesInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: ActionCreateWithoutNonprofitInput;
  update: ActionUpdateWithoutNonprofitInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ActionCreateWithoutOrganizationInput;
  update: ActionUpdateWithoutOrganizationInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithoutActivitiesInput = {
  create: ActionCreateWithoutActivitiesInput;
  update: ActionUpdateWithoutActivitiesInput;
  where?: InputMaybe<ActionWhereInput>;
};

export enum ActionVisibilityStatus {
  Archived = 'archived',
  Draft = 'draft',
  Legacy = 'legacy',
  Published = 'published'
}

export type ActionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  ActionTemplate?: InputMaybe<ActionTemplateNullableRelationFilter>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  Campaigns?: InputMaybe<CampaignListRelationFilter>;
  Causes?: InputMaybe<CauseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  actionTemplateId?: InputMaybe<StringNullableFilter>;
  activitiesCount?: InputMaybe<IntNullableFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveObjectEqualityInput>>>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type ActionWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  ActionTemplate?: InputMaybe<ActionTemplateNullableRelationFilter>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  Campaigns?: InputMaybe<CampaignListRelationFilter>;
  Causes?: InputMaybe<CauseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<ActionWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  actionTemplateId?: InputMaybe<StringNullableFilter>;
  activitiesCount?: InputMaybe<IntNullableFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  campaignIds?: InputMaybe<StringNullableListFilter>;
  causes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  incentives?: InputMaybe<Array<InputMaybe<IncentiveObjectEqualityInput>>>;
  lastModifiedBy?: InputMaybe<StringNullableFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumActionVisibilityStatusFilter>;
  subTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type ActionsImpactType = {
  __typename?: 'ActionsImpactType';
  donationAmount?: Maybe<Scalars['Float']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  totalActionsCompleted?: Maybe<Scalars['Int']['output']>;
  treesPlanted?: Maybe<Scalars['Int']['output']>;
};

export type ActionsImpactTypeCreateInput = {
  donationAmount?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalActionsCompleted?: InputMaybe<Scalars['Int']['input']>;
  treesPlanted?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionsImpactTypeNullableCompositeFilter = {
  equals?: InputMaybe<ActionsImpactTypeObjectEqualityInput>;
  is?: InputMaybe<ActionsImpactTypeWhereInput>;
  isNot?: InputMaybe<ActionsImpactTypeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionsImpactTypeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ActionsImpactTypeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ActionsImpactTypeUpsertInput>;
};

export type ActionsImpactTypeObjectEqualityInput = {
  donationAmount?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalActionsCompleted?: InputMaybe<Scalars['Int']['input']>;
  treesPlanted?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionsImpactTypeOrderByInput = {
  donationAmount?: InputMaybe<SortOrder>;
  lastUpdatedAt?: InputMaybe<SortOrder>;
  totalActionsCompleted?: InputMaybe<SortOrder>;
  treesPlanted?: InputMaybe<SortOrder>;
};

export type ActionsImpactTypeUpdateInput = {
  donationAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lastUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  totalActionsCompleted?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  treesPlanted?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ActionsImpactTypeUpsertInput = {
  set: ActionsImpactTypeCreateInput;
  update: ActionsImpactTypeUpdateInput;
};

export type ActionsImpactTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActionsImpactTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActionsImpactTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActionsImpactTypeWhereInput>>>;
  donationAmount?: InputMaybe<FloatNullableFilter>;
  lastUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  totalActionsCompleted?: InputMaybe<IntNullableFilter>;
  treesPlanted?: InputMaybe<IntNullableFilter>;
};

export type ActionsInputType = {
  ids: Array<Scalars['String']['input']>;
  isExclude: Scalars['Boolean']['input'];
};

/** Pagination data */
export type ActionsMetaType = {
  __typename?: 'ActionsMetaType';
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Actions and pagination metadata */
export type ActionsWithPaginationType = {
  __typename?: 'ActionsWithPaginationType';
  /** actions from your company */
  items?: Maybe<Array<Action>>;
  /** pagination data for actions */
  metadata: ActionsMetaType;
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type Activity = {
  __typename?: 'Activity';
  Action: Action;
  Campaign?: Maybe<Campaign>;
  ChallengeContributions: Array<ChallengeContribution>;
  Donation?: Maybe<Donation>;
  Organization: Organization;
  User: BaseUser;
  _count: ActivityCountOutputType;
  actionId: Scalars['String']['output'];
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  donationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastJoinedAt?: Maybe<Scalars['DateTime']['output']>;
  lastLeftAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['String']['output'];
  status: ActivityStatus;
  userId: Scalars['String']['output'];
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActivityCampaignArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActivityChallengeContributionsArgs = {
  cursor?: InputMaybe<ChallengeContributionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ChallengeContributionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChallengeContributionWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId), Employee(companyField: organizationId)]) */
export type ActivityDonationArgs = {
  where?: InputMaybe<DonationWhereInput>;
};

export type ActivityCountAggregateOutputType = {
  __typename?: 'ActivityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  actionId: Scalars['Int']['output'];
  campaignId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  donationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastCompletedAt: Scalars['Int']['output'];
  lastJoinedAt: Scalars['Int']['output'];
  lastLeftAt: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ActivityCountOrderByAggregateInput = {
  actionId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastCompletedAt?: InputMaybe<SortOrder>;
  lastJoinedAt?: InputMaybe<SortOrder>;
  lastLeftAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ActivityCountOutputType = {
  __typename?: 'ActivityCountOutputType';
  ChallengeContributions: Scalars['Int']['output'];
};

export type ActivityCreateInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateManyActionInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityCreateManyActionInputEnvelope = {
  data: ActivityCreateManyActionInput;
};

export type ActivityCreateManyCampaignInput = {
  actionId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityCreateManyCampaignInputEnvelope = {
  data: ActivityCreateManyCampaignInput;
};

export type ActivityCreateManyDonationInput = {
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityCreateManyDonationInputEnvelope = {
  data: ActivityCreateManyDonationInput;
};

export type ActivityCreateManyInput = {
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityCreateManyOrganizationInput = {
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityCreateManyOrganizationInputEnvelope = {
  data: ActivityCreateManyOrganizationInput;
};

export type ActivityCreateManyUserInput = {
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
};

export type ActivityCreateManyUserInputEnvelope = {
  data: ActivityCreateManyUserInput;
};

export type ActivityCreateNestedManyWithoutActionInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutActionInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutActionInput>>>;
  createMany?: InputMaybe<ActivityCreateManyActionInputEnvelope>;
};

export type ActivityCreateNestedManyWithoutCampaignInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<ActivityCreateManyCampaignInputEnvelope>;
};

export type ActivityCreateNestedManyWithoutDonationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyDonationInputEnvelope>;
};

export type ActivityCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyOrganizationInputEnvelope>;
};

export type ActivityCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ActivityCreateManyUserInputEnvelope>;
};

export type ActivityCreateNestedOneWithoutChallengeContributionsInput = {
  connect?: InputMaybe<ActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActivityCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<ActivityCreateWithoutChallengeContributionsInput>;
};

export type ActivityCreateOrConnectWithoutActionInput = {
  create: ActivityCreateWithoutActionInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutCampaignInput = {
  create: ActivityCreateWithoutCampaignInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutChallengeContributionsInput = {
  create: ActivityCreateWithoutChallengeContributionsInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutDonationInput = {
  create: ActivityCreateWithoutDonationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutOrganizationInput = {
  create: ActivityCreateWithoutOrganizationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateOrConnectWithoutUserInput = {
  create: ActivityCreateWithoutUserInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityCreateWithoutActionInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateWithoutCampaignInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateWithoutChallengeContributionsInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateWithoutDonationInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateWithoutOrganizationInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  User: BaseUserCreateNestedOneWithoutActivitiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityCreateWithoutUserInput = {
  Action: ActionCreateNestedOneWithoutActivitiesInput;
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutActivitiesInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutActivityInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutActivitiesInput>;
  Organization: OrganizationCreateNestedOneWithoutActivityOrganizationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
};

export type ActivityListRelationFilter = {
  every?: InputMaybe<ActivityWhereInput>;
  none?: InputMaybe<ActivityWhereInput>;
  some?: InputMaybe<ActivityWhereInput>;
};

export type ActivityMaxAggregateOutputType = {
  __typename?: 'ActivityMaxAggregateOutputType';
  actionId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  donationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastJoinedAt?: Maybe<Scalars['DateTime']['output']>;
  lastLeftAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActivityStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ActivityMaxOrderByAggregateInput = {
  actionId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastCompletedAt?: InputMaybe<SortOrder>;
  lastJoinedAt?: InputMaybe<SortOrder>;
  lastLeftAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ActivityMinAggregateOutputType = {
  __typename?: 'ActivityMinAggregateOutputType';
  actionId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  donationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastJoinedAt?: Maybe<Scalars['DateTime']['output']>;
  lastLeftAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ActivityStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ActivityMinOrderByAggregateInput = {
  actionId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastCompletedAt?: InputMaybe<SortOrder>;
  lastJoinedAt?: InputMaybe<SortOrder>;
  lastLeftAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivityOrderByWithAggregationInput = {
  _count?: InputMaybe<ActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<ActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActivityMinOrderByAggregateInput>;
  actionId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastCompletedAt?: InputMaybe<SortOrder>;
  lastJoinedAt?: InputMaybe<SortOrder>;
  lastLeftAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ActivityOrderByWithRelationInput = {
  Action?: InputMaybe<ActionOrderByWithRelationInput>;
  Campaign?: InputMaybe<CampaignOrderByWithRelationInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionOrderByRelationAggregateInput>;
  Donation?: InputMaybe<DonationOrderByWithRelationInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  actionId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastCompletedAt?: InputMaybe<SortOrder>;
  lastJoinedAt?: InputMaybe<SortOrder>;
  lastLeftAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ActivityRelationFilter = {
  is?: InputMaybe<ActivityWhereInput>;
  isNot?: InputMaybe<ActivityWhereInput>;
};

export enum ActivityScalarFieldEnum {
  ActionId = 'actionId',
  CampaignId = 'campaignId',
  CreatedAt = 'createdAt',
  DonationId = 'donationId',
  Id = 'id',
  LastCompletedAt = 'lastCompletedAt',
  LastJoinedAt = 'lastJoinedAt',
  LastLeftAt = 'lastLeftAt',
  ModifiedAt = 'modifiedAt',
  OrganizationId = 'organizationId',
  Status = 'status',
  UserId = 'userId'
}

export type ActivityScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  actionId?: InputMaybe<StringFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  donationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  lastJoinedAt?: InputMaybe<DateTimeNullableFilter>;
  lastLeftAt?: InputMaybe<DateTimeNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumActivityStatusFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ActivityScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ActivityScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActivityScalarWhereWithAggregatesInput>>>;
  actionId?: InputMaybe<StringWithAggregatesFilter>;
  campaignId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  donationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastCompletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  lastJoinedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  lastLeftAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  organizationId?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumActivityStatusWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export enum ActivityStatus {
  Completed = 'completed',
  Joined = 'joined',
  Left = 'left'
}

export type ActivityUncheckedCreateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateNestedManyWithoutActionInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutActionInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutActionInput>>>;
  createMany?: InputMaybe<ActivityCreateManyActionInputEnvelope>;
};

export type ActivityUncheckedCreateNestedManyWithoutCampaignInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<ActivityCreateManyCampaignInputEnvelope>;
};

export type ActivityUncheckedCreateNestedManyWithoutDonationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyDonationInputEnvelope>;
};

export type ActivityUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyOrganizationInputEnvelope>;
};

export type ActivityUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ActivityCreateManyUserInputEnvelope>;
};

export type ActivityUncheckedCreateWithoutActionInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateWithoutCampaignInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  actionId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateWithoutChallengeContributionsInput = {
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateWithoutDonationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateWithoutOrganizationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ActivityStatus;
  userId: Scalars['String']['input'];
};

export type ActivityUncheckedCreateWithoutUserInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput>;
  actionId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastJoinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastLeftAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  status: ActivityStatus;
};

export type ActivityUncheckedUpdateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutActionInput = {
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutActionNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutActionInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutActionInput>>>;
  createMany?: InputMaybe<ActivityCreateManyActionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutActionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutActionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutActionInput>>>;
};

export type ActivityUncheckedUpdateManyWithoutCampaignInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutCampaignNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<ActivityCreateManyCampaignInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutCampaignInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutCampaignInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutCampaignInput>>>;
};

export type ActivityUncheckedUpdateManyWithoutDonationInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutDonationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyDonationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutDonationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutDonationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutDonationInput>>>;
};

export type ActivityUncheckedUpdateManyWithoutOrganizationInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActivityUncheckedUpdateManyWithoutUserInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ActivityCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ActivityUncheckedUpdateWithoutActionInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutCampaignInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutChallengeContributionsInput = {
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutDonationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutOrganizationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivityUncheckedUpdateWithoutUserInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput>;
  actionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateManyWithWhereWithoutActionInput = {
  data: ActivityUpdateManyMutationInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithWhereWithoutCampaignInput = {
  data: ActivityUpdateManyMutationInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithWhereWithoutDonationInput = {
  data: ActivityUpdateManyMutationInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithWhereWithoutOrganizationInput = {
  data: ActivityUpdateManyMutationInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithWhereWithoutUserInput = {
  data: ActivityUpdateManyMutationInput;
  where: ActivityScalarWhereInput;
};

export type ActivityUpdateManyWithoutActionNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutActionInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutActionInput>>>;
  createMany?: InputMaybe<ActivityCreateManyActionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutActionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutActionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutActionInput>>>;
};

export type ActivityUpdateManyWithoutCampaignNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<ActivityCreateManyCampaignInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutCampaignInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutCampaignInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutCampaignInput>>>;
};

export type ActivityUpdateManyWithoutDonationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyDonationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutDonationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutDonationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutDonationInput>>>;
};

export type ActivityUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ActivityCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ActivityUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ActivityCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ActivityCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ActivityCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ActivityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ActivityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ActivityUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ActivityUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ActivityUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput = {
  connect?: InputMaybe<ActivityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ActivityCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<ActivityCreateWithoutChallengeContributionsInput>;
  update?: InputMaybe<ActivityUpdateToOneWithWhereWithoutChallengeContributionsInput>;
  upsert?: InputMaybe<ActivityUpsertWithoutChallengeContributionsInput>;
};

export type ActivityUpdateToOneWithWhereWithoutChallengeContributionsInput = {
  data: ActivityUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<ActivityWhereInput>;
};

export type ActivityUpdateWithWhereUniqueWithoutActionInput = {
  data: ActivityUpdateWithoutActionInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithWhereUniqueWithoutCampaignInput = {
  data: ActivityUpdateWithoutCampaignInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithWhereUniqueWithoutDonationInput = {
  data: ActivityUpdateWithoutDonationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ActivityUpdateWithoutOrganizationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithWhereUniqueWithoutUserInput = {
  data: ActivityUpdateWithoutUserInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpdateWithoutActionInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutCampaignInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutChallengeContributionsInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutDonationInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutOrganizationInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutActivitiesNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpdateWithoutUserInput = {
  Action?: InputMaybe<ActionUpdateOneRequiredWithoutActivitiesNestedInput>;
  Campaign?: InputMaybe<CampaignUpdateOneWithoutActivitiesNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutActivityNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutActivitiesNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastJoinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastLeftAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActivityStatusFieldUpdateOperationsInput>;
};

export type ActivityUpsertWithWhereUniqueWithoutActionInput = {
  create: ActivityCreateWithoutActionInput;
  update: ActivityUpdateWithoutActionInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithWhereUniqueWithoutCampaignInput = {
  create: ActivityCreateWithoutCampaignInput;
  update: ActivityUpdateWithoutCampaignInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithWhereUniqueWithoutDonationInput = {
  create: ActivityCreateWithoutDonationInput;
  update: ActivityUpdateWithoutDonationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ActivityCreateWithoutOrganizationInput;
  update: ActivityUpdateWithoutOrganizationInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithWhereUniqueWithoutUserInput = {
  create: ActivityCreateWithoutUserInput;
  update: ActivityUpdateWithoutUserInput;
  where: ActivityWhereUniqueInput;
};

export type ActivityUpsertWithoutChallengeContributionsInput = {
  create: ActivityCreateWithoutChallengeContributionsInput;
  update: ActivityUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<ActivityWhereInput>;
};

export type ActivityUserIdActionIdCampaignIdCompoundUniqueInput = {
  actionId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ActivityUserIdActionIdCompoundUniqueInput = {
  actionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ActivityWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  Action?: InputMaybe<ActionRelationFilter>;
  Campaign?: InputMaybe<CampaignNullableRelationFilter>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Donation?: InputMaybe<DonationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  actionId?: InputMaybe<StringFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  donationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  lastJoinedAt?: InputMaybe<DateTimeNullableFilter>;
  lastLeftAt?: InputMaybe<DateTimeNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumActivityStatusFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ActivityWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  Action?: InputMaybe<ActionRelationFilter>;
  Campaign?: InputMaybe<CampaignNullableRelationFilter>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Donation?: InputMaybe<DonationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ActivityWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  actionId?: InputMaybe<StringFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  donationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  lastJoinedAt?: InputMaybe<DateTimeNullableFilter>;
  lastLeftAt?: InputMaybe<DateTimeNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumActivityStatusFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_actionId?: InputMaybe<ActivityUserIdActionIdCompoundUniqueInput>;
  userId_actionId_campaignId?: InputMaybe<ActivityUserIdActionIdCampaignIdCompoundUniqueInput>;
};

export enum AdapterProvider {
  Merge = 'Merge'
}

export type AdditionalQuestionsAnswersInputType = {
  question: Scalars['String']['input'];
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AddressNullableCompositeFilter = {
  equals?: InputMaybe<AddressObjectEqualityInput>;
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressNullableUpdateEnvelopeInput = {
  set?: InputMaybe<AddressCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<AddressUpsertInput>;
};

export type AddressObjectEqualityInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AddressOrderByInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  line1?: InputMaybe<SortOrder>;
  line2?: InputMaybe<SortOrder>;
  postal_code?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  line1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postal_code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpsertInput = {
  set: AddressCreateInput;
  update: AddressUpdateInput;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AddressWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AddressWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AddressWhereInput>>>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  line1?: InputMaybe<StringNullableFilter>;
  line2?: InputMaybe<StringNullableFilter>;
  postal_code?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
};

/** @Auth(read: [Owner, Organizer(type: Company, privilege: employeeAffiliations:view, organizationField: companyId)]) */
export type Affiliation = {
  __typename?: 'Affiliation';
  Company: Organization;
  Nonprofit: Organization;
  User: BaseUser;
  affiliationType?: Maybe<AffiliationType>;
  boardPosition?: Maybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId: Scalars['String']['output'];
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export enum AffiliationBoardPosition {
  Director = 'Director',
  Member = 'Member',
  President = 'President',
  Secretary = 'Secretary',
  VicePresident = 'VicePresident'
}

export type AffiliationCountAggregateOutputType = {
  __typename?: 'AffiliationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  affiliationType: Scalars['Int']['output'];
  boardPosition: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AffiliationCountOrderByAggregateInput = {
  affiliationType?: InputMaybe<SortOrder>;
  boardPosition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AffiliationCreateInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyAffiliationInput;
  Nonprofit: OrganizationCreateNestedOneWithoutNonProfitAffiliationInput;
  User: BaseUserCreateNestedOneWithoutAffiliationInput;
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationCreateManyCompanyInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationCreateManyCompanyInputEnvelope = {
  data: AffiliationCreateManyCompanyInput;
};

export type AffiliationCreateManyInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationCreateManyNonprofitInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationCreateManyNonprofitInputEnvelope = {
  data: AffiliationCreateManyNonprofitInput;
};

export type AffiliationCreateManyUserInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationCreateManyUserInputEnvelope = {
  data: AffiliationCreateManyUserInput;
};

export type AffiliationCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyCompanyInputEnvelope>;
};

export type AffiliationCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyNonprofitInputEnvelope>;
};

export type AffiliationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyUserInputEnvelope>;
};

export type AffiliationCreateOrConnectWithoutCompanyInput = {
  create: AffiliationCreateWithoutCompanyInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationCreateOrConnectWithoutNonprofitInput = {
  create: AffiliationCreateWithoutNonprofitInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationCreateOrConnectWithoutUserInput = {
  create: AffiliationCreateWithoutUserInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationCreateWithoutCompanyInput = {
  Nonprofit: OrganizationCreateNestedOneWithoutNonProfitAffiliationInput;
  User: BaseUserCreateNestedOneWithoutAffiliationInput;
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationCreateWithoutNonprofitInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyAffiliationInput;
  User: BaseUserCreateNestedOneWithoutAffiliationInput;
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationCreateWithoutUserInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyAffiliationInput;
  Nonprofit: OrganizationCreateNestedOneWithoutNonProfitAffiliationInput;
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationListRelationFilter = {
  every?: InputMaybe<AffiliationWhereInput>;
  none?: InputMaybe<AffiliationWhereInput>;
  some?: InputMaybe<AffiliationWhereInput>;
};

export type AffiliationMaxAggregateOutputType = {
  __typename?: 'AffiliationMaxAggregateOutputType';
  affiliationType?: Maybe<AffiliationType>;
  boardPosition?: Maybe<AffiliationBoardPosition>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AffiliationMaxOrderByAggregateInput = {
  affiliationType?: InputMaybe<SortOrder>;
  boardPosition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AffiliationMinAggregateOutputType = {
  __typename?: 'AffiliationMinAggregateOutputType';
  affiliationType?: Maybe<AffiliationType>;
  boardPosition?: Maybe<AffiliationBoardPosition>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AffiliationMinOrderByAggregateInput = {
  affiliationType?: InputMaybe<SortOrder>;
  boardPosition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AffiliationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AffiliationOrderByWithAggregationInput = {
  _count?: InputMaybe<AffiliationCountOrderByAggregateInput>;
  _max?: InputMaybe<AffiliationMaxOrderByAggregateInput>;
  _min?: InputMaybe<AffiliationMinOrderByAggregateInput>;
  affiliationType?: InputMaybe<SortOrder>;
  boardPosition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AffiliationOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  affiliationType?: InputMaybe<SortOrder>;
  boardPosition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum AffiliationScalarFieldEnum {
  AffiliationType = 'affiliationType',
  BoardPosition = 'boardPosition',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EndingAt = 'endingAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  NonprofitId = 'nonprofitId',
  StartingAt = 'startingAt',
  UserId = 'userId'
}

export type AffiliationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  affiliationType?: InputMaybe<EnumAffiliationTypeNullableFilter>;
  boardPosition?: InputMaybe<EnumAffiliationBoardPositionNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AffiliationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereWithAggregatesInput>>>;
  affiliationType?: InputMaybe<EnumAffiliationTypeNullableWithAggregatesFilter>;
  boardPosition?: InputMaybe<EnumAffiliationBoardPositionNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export enum AffiliationType {
  BoardMember = 'BoardMember',
  Donor = 'Donor',
  FamilyMemberAffiliation = 'FamilyMemberAffiliation',
  PersonalConnection = 'PersonalConnection',
  Volunteer = 'Volunteer'
}

export type AffiliationUncheckedCreateInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyCompanyInputEnvelope>;
};

export type AffiliationUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyNonprofitInputEnvelope>;
};

export type AffiliationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyUserInputEnvelope>;
};

export type AffiliationUncheckedCreateWithoutCompanyInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationUncheckedCreateWithoutNonprofitInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type AffiliationUncheckedCreateWithoutUserInput = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliationUncheckedUpdateInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateManyInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateManyWithoutCompanyInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type AffiliationUncheckedUpdateManyWithoutNonprofitInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type AffiliationUncheckedUpdateManyWithoutUserInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AffiliationUncheckedUpdateWithoutCompanyInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateWithoutNonprofitInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AffiliationUncheckedUpdateWithoutUserInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyAffiliationNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonProfitAffiliationNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAffiliationNestedInput>;
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpdateManyMutationInput = {
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpdateManyWithWhereWithoutCompanyInput = {
  data: AffiliationUpdateManyMutationInput;
  where: AffiliationScalarWhereInput;
};

export type AffiliationUpdateManyWithWhereWithoutNonprofitInput = {
  data: AffiliationUpdateManyMutationInput;
  where: AffiliationScalarWhereInput;
};

export type AffiliationUpdateManyWithWhereWithoutUserInput = {
  data: AffiliationUpdateManyMutationInput;
  where: AffiliationScalarWhereInput;
};

export type AffiliationUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type AffiliationUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type AffiliationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AffiliationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AffiliationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AffiliationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AffiliationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AffiliationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AffiliationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AffiliationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AffiliationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AffiliationUpdateWithWhereUniqueWithoutCompanyInput = {
  data: AffiliationUpdateWithoutCompanyInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: AffiliationUpdateWithoutNonprofitInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationUpdateWithWhereUniqueWithoutUserInput = {
  data: AffiliationUpdateWithoutUserInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationUpdateWithoutCompanyInput = {
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonProfitAffiliationNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAffiliationNestedInput>;
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpdateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyAffiliationNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAffiliationNestedInput>;
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpdateWithoutUserInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyAffiliationNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonProfitAffiliationNestedInput>;
  affiliationType?: InputMaybe<NullableEnumAffiliationTypeFieldUpdateOperationsInput>;
  boardPosition?: InputMaybe<NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type AffiliationUpsertWithWhereUniqueWithoutCompanyInput = {
  create: AffiliationCreateWithoutCompanyInput;
  update: AffiliationUpdateWithoutCompanyInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: AffiliationCreateWithoutNonprofitInput;
  update: AffiliationUpdateWithoutNonprofitInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationUpsertWithWhereUniqueWithoutUserInput = {
  create: AffiliationCreateWithoutUserInput;
  update: AffiliationUpdateWithoutUserInput;
  where: AffiliationWhereUniqueInput;
};

export type AffiliationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  User?: InputMaybe<BaseUserRelationFilter>;
  affiliationType?: InputMaybe<EnumAffiliationTypeNullableFilter>;
  boardPosition?: InputMaybe<EnumAffiliationBoardPositionNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AffiliationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<AffiliationWhereInput>>>;
  User?: InputMaybe<BaseUserRelationFilter>;
  affiliationType?: InputMaybe<EnumAffiliationTypeNullableFilter>;
  boardPosition?: InputMaybe<EnumAffiliationBoardPositionNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AggregateAction = {
  __typename?: 'AggregateAction';
  _avg?: Maybe<ActionAvgAggregateOutputType>;
  _count?: Maybe<ActionCountAggregateOutputType>;
  _max?: Maybe<ActionMaxAggregateOutputType>;
  _min?: Maybe<ActionMinAggregateOutputType>;
  _sum?: Maybe<ActionSumAggregateOutputType>;
};

export type AggregateActionTemplate = {
  __typename?: 'AggregateActionTemplate';
  _count?: Maybe<ActionTemplateCountAggregateOutputType>;
  _max?: Maybe<ActionTemplateMaxAggregateOutputType>;
  _min?: Maybe<ActionTemplateMinAggregateOutputType>;
};

export type AggregateActivity = {
  __typename?: 'AggregateActivity';
  _count?: Maybe<ActivityCountAggregateOutputType>;
  _max?: Maybe<ActivityMaxAggregateOutputType>;
  _min?: Maybe<ActivityMinAggregateOutputType>;
};

export type AggregateAffiliation = {
  __typename?: 'AggregateAffiliation';
  _count?: Maybe<AffiliationCountAggregateOutputType>;
  _max?: Maybe<AffiliationMaxAggregateOutputType>;
  _min?: Maybe<AffiliationMinAggregateOutputType>;
};

export type AggregateAwardedBadge = {
  __typename?: 'AggregateAwardedBadge';
  _count?: Maybe<AwardedBadgeCountAggregateOutputType>;
  _max?: Maybe<AwardedBadgeMaxAggregateOutputType>;
  _min?: Maybe<AwardedBadgeMinAggregateOutputType>;
};

export type AggregateBadge = {
  __typename?: 'AggregateBadge';
  _count?: Maybe<BadgeCountAggregateOutputType>;
  _max?: Maybe<BadgeMaxAggregateOutputType>;
  _min?: Maybe<BadgeMinAggregateOutputType>;
};

export type AggregateBaseUser = {
  __typename?: 'AggregateBaseUser';
  _avg?: Maybe<BaseUserAvgAggregateOutputType>;
  _count?: Maybe<BaseUserCountAggregateOutputType>;
  _max?: Maybe<BaseUserMaxAggregateOutputType>;
  _min?: Maybe<BaseUserMinAggregateOutputType>;
  _sum?: Maybe<BaseUserSumAggregateOutputType>;
};

export type AggregateBudgetAllocation = {
  __typename?: 'AggregateBudgetAllocation';
  _avg?: Maybe<BudgetAllocationAvgAggregateOutputType>;
  _count?: Maybe<BudgetAllocationCountAggregateOutputType>;
  _max?: Maybe<BudgetAllocationMaxAggregateOutputType>;
  _min?: Maybe<BudgetAllocationMinAggregateOutputType>;
  _sum?: Maybe<BudgetAllocationSumAggregateOutputType>;
};

export type AggregateCampaign = {
  __typename?: 'AggregateCampaign';
  _count?: Maybe<CampaignCountAggregateOutputType>;
  _max?: Maybe<CampaignMaxAggregateOutputType>;
  _min?: Maybe<CampaignMinAggregateOutputType>;
};

export type AggregateCause = {
  __typename?: 'AggregateCause';
  _avg?: Maybe<CauseAvgAggregateOutputType>;
  _count?: Maybe<CauseCountAggregateOutputType>;
  _max?: Maybe<CauseMaxAggregateOutputType>;
  _min?: Maybe<CauseMinAggregateOutputType>;
  _sum?: Maybe<CauseSumAggregateOutputType>;
};

export type AggregateChallenge = {
  __typename?: 'AggregateChallenge';
  _avg?: Maybe<ChallengeAvgAggregateOutputType>;
  _count?: Maybe<ChallengeCountAggregateOutputType>;
  _max?: Maybe<ChallengeMaxAggregateOutputType>;
  _min?: Maybe<ChallengeMinAggregateOutputType>;
  _sum?: Maybe<ChallengeSumAggregateOutputType>;
};

export type AggregateChallengeContribution = {
  __typename?: 'AggregateChallengeContribution';
  _avg?: Maybe<ChallengeContributionAvgAggregateOutputType>;
  _count?: Maybe<ChallengeContributionCountAggregateOutputType>;
  _max?: Maybe<ChallengeContributionMaxAggregateOutputType>;
  _min?: Maybe<ChallengeContributionMinAggregateOutputType>;
  _sum?: Maybe<ChallengeContributionSumAggregateOutputType>;
};

export type AggregateCommunity = {
  __typename?: 'AggregateCommunity';
  _count?: Maybe<CommunityCountAggregateOutputType>;
  _max?: Maybe<CommunityMaxAggregateOutputType>;
  _min?: Maybe<CommunityMinAggregateOutputType>;
};

export type AggregateCorporateProgram = {
  __typename?: 'AggregateCorporateProgram';
  _count?: Maybe<CorporateProgramCountAggregateOutputType>;
  _max?: Maybe<CorporateProgramMaxAggregateOutputType>;
  _min?: Maybe<CorporateProgramMinAggregateOutputType>;
};

export type AggregateCurrencyRate = {
  __typename?: 'AggregateCurrencyRate';
  _count?: Maybe<CurrencyRateCountAggregateOutputType>;
  _max?: Maybe<CurrencyRateMaxAggregateOutputType>;
  _min?: Maybe<CurrencyRateMinAggregateOutputType>;
};

export type AggregateDeed = {
  __typename?: 'AggregateDeed';
  _avg?: Maybe<DeedAvgAggregateOutputType>;
  _count?: Maybe<DeedCountAggregateOutputType>;
  _max?: Maybe<DeedMaxAggregateOutputType>;
  _min?: Maybe<DeedMinAggregateOutputType>;
  _sum?: Maybe<DeedSumAggregateOutputType>;
};

export type AggregateDisbursementFee = {
  __typename?: 'AggregateDisbursementFee';
  _avg?: Maybe<DisbursementFeeAvgAggregateOutputType>;
  _count?: Maybe<DisbursementFeeCountAggregateOutputType>;
  _max?: Maybe<DisbursementFeeMaxAggregateOutputType>;
  _min?: Maybe<DisbursementFeeMinAggregateOutputType>;
  _sum?: Maybe<DisbursementFeeSumAggregateOutputType>;
};

export type AggregateDisbursementInstruction = {
  __typename?: 'AggregateDisbursementInstruction';
  _count?: Maybe<DisbursementInstructionCountAggregateOutputType>;
  _max?: Maybe<DisbursementInstructionMaxAggregateOutputType>;
  _min?: Maybe<DisbursementInstructionMinAggregateOutputType>;
};

export type AggregateDonation = {
  __typename?: 'AggregateDonation';
  _avg?: Maybe<DonationAvgAggregateOutputType>;
  _count?: Maybe<DonationCountAggregateOutputType>;
  _max?: Maybe<DonationMaxAggregateOutputType>;
  _min?: Maybe<DonationMinAggregateOutputType>;
  _sum?: Maybe<DonationSumAggregateOutputType>;
};

export type AggregateDonationSchedule = {
  __typename?: 'AggregateDonationSchedule';
  _avg?: Maybe<DonationScheduleAvgAggregateOutputType>;
  _count?: Maybe<DonationScheduleCountAggregateOutputType>;
  _max?: Maybe<DonationScheduleMaxAggregateOutputType>;
  _min?: Maybe<DonationScheduleMinAggregateOutputType>;
  _sum?: Maybe<DonationScheduleSumAggregateOutputType>;
};

export type AggregateForm = {
  __typename?: 'AggregateForm';
  _avg?: Maybe<FormAvgAggregateOutputType>;
  _count?: Maybe<FormCountAggregateOutputType>;
  _max?: Maybe<FormMaxAggregateOutputType>;
  _min?: Maybe<FormMinAggregateOutputType>;
  _sum?: Maybe<FormSumAggregateOutputType>;
};

export type AggregateFormResponse = {
  __typename?: 'AggregateFormResponse';
  _count?: Maybe<FormResponseCountAggregateOutputType>;
  _max?: Maybe<FormResponseMaxAggregateOutputType>;
  _min?: Maybe<FormResponseMinAggregateOutputType>;
};

export type AggregateGivingAccount = {
  __typename?: 'AggregateGivingAccount';
  _count?: Maybe<GivingAccountCountAggregateOutputType>;
  _max?: Maybe<GivingAccountMaxAggregateOutputType>;
  _min?: Maybe<GivingAccountMinAggregateOutputType>;
};

export type AggregateGivingAccountFunding = {
  __typename?: 'AggregateGivingAccountFunding';
  _avg?: Maybe<GivingAccountFundingAvgAggregateOutputType>;
  _count?: Maybe<GivingAccountFundingCountAggregateOutputType>;
  _max?: Maybe<GivingAccountFundingMaxAggregateOutputType>;
  _min?: Maybe<GivingAccountFundingMinAggregateOutputType>;
  _sum?: Maybe<GivingAccountFundingSumAggregateOutputType>;
};

export type AggregateGivingAccountTransferInbound = {
  __typename?: 'AggregateGivingAccountTransferInbound';
  _avg?: Maybe<GivingAccountTransferInboundAvgAggregateOutputType>;
  _count?: Maybe<GivingAccountTransferInboundCountAggregateOutputType>;
  _max?: Maybe<GivingAccountTransferInboundMaxAggregateOutputType>;
  _min?: Maybe<GivingAccountTransferInboundMinAggregateOutputType>;
  _sum?: Maybe<GivingAccountTransferInboundSumAggregateOutputType>;
};

export type AggregateGivingAccountTransferOutbound = {
  __typename?: 'AggregateGivingAccountTransferOutbound';
  _avg?: Maybe<GivingAccountTransferOutboundAvgAggregateOutputType>;
  _count?: Maybe<GivingAccountTransferOutboundCountAggregateOutputType>;
  _max?: Maybe<GivingAccountTransferOutboundMaxAggregateOutputType>;
  _min?: Maybe<GivingAccountTransferOutboundMinAggregateOutputType>;
  _sum?: Maybe<GivingAccountTransferOutboundSumAggregateOutputType>;
};

export type AggregateGivingAccountWithdrawal = {
  __typename?: 'AggregateGivingAccountWithdrawal';
  _avg?: Maybe<GivingAccountWithdrawalAvgAggregateOutputType>;
  _count?: Maybe<GivingAccountWithdrawalCountAggregateOutputType>;
  _max?: Maybe<GivingAccountWithdrawalMaxAggregateOutputType>;
  _min?: Maybe<GivingAccountWithdrawalMinAggregateOutputType>;
  _sum?: Maybe<GivingAccountWithdrawalSumAggregateOutputType>;
};

export type AggregateLocation = {
  __typename?: 'AggregateLocation';
  _avg?: Maybe<LocationAvgAggregateOutputType>;
  _count?: Maybe<LocationCountAggregateOutputType>;
  _max?: Maybe<LocationMaxAggregateOutputType>;
  _min?: Maybe<LocationMinAggregateOutputType>;
  _sum?: Maybe<LocationSumAggregateOutputType>;
};

export type AggregateNonprofit = {
  __typename?: 'AggregateNonprofit';
  _count?: Maybe<NonprofitCountAggregateOutputType>;
  _max?: Maybe<NonprofitMaxAggregateOutputType>;
  _min?: Maybe<NonprofitMinAggregateOutputType>;
};

export type AggregateNonprofitNomination = {
  __typename?: 'AggregateNonprofitNomination';
  _count?: Maybe<NonprofitNominationCountAggregateOutputType>;
  _max?: Maybe<NonprofitNominationMaxAggregateOutputType>;
  _min?: Maybe<NonprofitNominationMinAggregateOutputType>;
};

export type AggregateOpportunity = {
  __typename?: 'AggregateOpportunity';
  _avg?: Maybe<OpportunityAvgAggregateOutputType>;
  _count?: Maybe<OpportunityCountAggregateOutputType>;
  _max?: Maybe<OpportunityMaxAggregateOutputType>;
  _min?: Maybe<OpportunityMinAggregateOutputType>;
  _sum?: Maybe<OpportunitySumAggregateOutputType>;
};

export type AggregateOrganization = {
  __typename?: 'AggregateOrganization';
  _count?: Maybe<OrganizationCountAggregateOutputType>;
  _max?: Maybe<OrganizationMaxAggregateOutputType>;
  _min?: Maybe<OrganizationMinAggregateOutputType>;
};

export type AggregatePartner = {
  __typename?: 'AggregatePartner';
  _count?: Maybe<PartnerCountAggregateOutputType>;
  _max?: Maybe<PartnerMaxAggregateOutputType>;
  _min?: Maybe<PartnerMinAggregateOutputType>;
};

export type AggregatePayrollPayGroup = {
  __typename?: 'AggregatePayrollPayGroup';
  _count?: Maybe<PayrollPayGroupCountAggregateOutputType>;
  _max?: Maybe<PayrollPayGroupMaxAggregateOutputType>;
  _min?: Maybe<PayrollPayGroupMinAggregateOutputType>;
};

export type AggregatePayrollRun = {
  __typename?: 'AggregatePayrollRun';
  _count?: Maybe<PayrollRunCountAggregateOutputType>;
  _max?: Maybe<PayrollRunMaxAggregateOutputType>;
  _min?: Maybe<PayrollRunMinAggregateOutputType>;
};

export type AggregatePayrollRunDeduction = {
  __typename?: 'AggregatePayrollRunDeduction';
  _avg?: Maybe<PayrollRunDeductionAvgAggregateOutputType>;
  _count?: Maybe<PayrollRunDeductionCountAggregateOutputType>;
  _max?: Maybe<PayrollRunDeductionMaxAggregateOutputType>;
  _min?: Maybe<PayrollRunDeductionMinAggregateOutputType>;
  _sum?: Maybe<PayrollRunDeductionSumAggregateOutputType>;
};

export type AggregatePayrollRunFlatFile = {
  __typename?: 'AggregatePayrollRunFlatFile';
  _count?: Maybe<PayrollRunFlatFileCountAggregateOutputType>;
  _max?: Maybe<PayrollRunFlatFileMaxAggregateOutputType>;
  _min?: Maybe<PayrollRunFlatFileMinAggregateOutputType>;
};

export type AggregatePayrollRunRollupConfiguration = {
  __typename?: 'AggregatePayrollRunRollupConfiguration';
  _count?: Maybe<PayrollRunRollupConfigurationCountAggregateOutputType>;
  _max?: Maybe<PayrollRunRollupConfigurationMaxAggregateOutputType>;
  _min?: Maybe<PayrollRunRollupConfigurationMinAggregateOutputType>;
};

export type AggregateReceipt = {
  __typename?: 'AggregateReceipt';
  _count?: Maybe<ReceiptCountAggregateOutputType>;
  _max?: Maybe<ReceiptMaxAggregateOutputType>;
  _min?: Maybe<ReceiptMinAggregateOutputType>;
};

export type AggregateRole = {
  __typename?: 'AggregateRole';
  _count?: Maybe<RoleCountAggregateOutputType>;
  _max?: Maybe<RoleMaxAggregateOutputType>;
  _min?: Maybe<RoleMinAggregateOutputType>;
};

export type AggregateSettings = {
  __typename?: 'AggregateSettings';
  _avg?: Maybe<SettingsAvgAggregateOutputType>;
  _count?: Maybe<SettingsCountAggregateOutputType>;
  _max?: Maybe<SettingsMaxAggregateOutputType>;
  _min?: Maybe<SettingsMinAggregateOutputType>;
  _sum?: Maybe<SettingsSumAggregateOutputType>;
};

export type AggregateSigmaDashboard = {
  __typename?: 'AggregateSigmaDashboard';
  _avg?: Maybe<SigmaDashboardAvgAggregateOutputType>;
  _count?: Maybe<SigmaDashboardCountAggregateOutputType>;
  _max?: Maybe<SigmaDashboardMaxAggregateOutputType>;
  _min?: Maybe<SigmaDashboardMinAggregateOutputType>;
  _sum?: Maybe<SigmaDashboardSumAggregateOutputType>;
};

export type AggregateSigmaReport = {
  __typename?: 'AggregateSigmaReport';
  _count?: Maybe<SigmaReportCountAggregateOutputType>;
  _max?: Maybe<SigmaReportMaxAggregateOutputType>;
  _min?: Maybe<SigmaReportMinAggregateOutputType>;
};

export type AggregateUserNotification = {
  __typename?: 'AggregateUserNotification';
  _count?: Maybe<UserNotificationCountAggregateOutputType>;
  _max?: Maybe<UserNotificationMaxAggregateOutputType>;
  _min?: Maybe<UserNotificationMinAggregateOutputType>;
};

export type AggregateVolunteerReward = {
  __typename?: 'AggregateVolunteerReward';
  _avg?: Maybe<VolunteerRewardAvgAggregateOutputType>;
  _count?: Maybe<VolunteerRewardCountAggregateOutputType>;
  _max?: Maybe<VolunteerRewardMaxAggregateOutputType>;
  _min?: Maybe<VolunteerRewardMinAggregateOutputType>;
  _sum?: Maybe<VolunteerRewardSumAggregateOutputType>;
};

export type AggregateVolunteerTime = {
  __typename?: 'AggregateVolunteerTime';
  _avg?: Maybe<VolunteerTimeAvgAggregateOutputType>;
  _count?: Maybe<VolunteerTimeCountAggregateOutputType>;
  _max?: Maybe<VolunteerTimeMaxAggregateOutputType>;
  _min?: Maybe<VolunteerTimeMinAggregateOutputType>;
  _sum?: Maybe<VolunteerTimeSumAggregateOutputType>;
};

export type AggregateVolunteerTimeOff = {
  __typename?: 'AggregateVolunteerTimeOff';
  _avg?: Maybe<VolunteerTimeOffAvgAggregateOutputType>;
  _count?: Maybe<VolunteerTimeOffCountAggregateOutputType>;
  _max?: Maybe<VolunteerTimeOffMaxAggregateOutputType>;
  _min?: Maybe<VolunteerTimeOffMinAggregateOutputType>;
  _sum?: Maybe<VolunteerTimeOffSumAggregateOutputType>;
};

export type AggregateVolunteerTimeOffSummary = {
  __typename?: 'AggregateVolunteerTimeOffSummary';
  _avg?: Maybe<VolunteerTimeOffSummaryAvgAggregateOutputType>;
  _count?: Maybe<VolunteerTimeOffSummaryCountAggregateOutputType>;
  _max?: Maybe<VolunteerTimeOffSummaryMaxAggregateOutputType>;
  _min?: Maybe<VolunteerTimeOffSummaryMinAggregateOutputType>;
  _sum?: Maybe<VolunteerTimeOffSummarySumAggregateOutputType>;
};

export type Answers = {
  __typename?: 'Answers';
  question: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type AnswersCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<AnswersObjectEqualityInput>>>;
  every?: InputMaybe<AnswersWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AnswersWhereInput>;
  some?: InputMaybe<AnswersWhereInput>;
};

export type AnswersCreateInput = {
  question: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnswersCreatevaluesInput = {
  set: Scalars['String']['input'];
};

export type AnswersDeleteManyInput = {
  where: AnswersWhereInput;
};

export type AnswersListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
};

export type AnswersListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<AnswersDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  updateMany?: InputMaybe<AnswersUpdateManyInput>;
};

export type AnswersObjectEqualityInput = {
  question: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnswersOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnswersUpdateInput = {
  question?: InputMaybe<StringFieldUpdateOperationsInput>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnswersUpdateManyInput = {
  data: AnswersUpdateInput;
  where: AnswersWhereInput;
};

export type AnswersUpdatevaluesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnswersWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AnswersWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AnswersWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AnswersWhereInput>>>;
  question?: InputMaybe<StringFilter>;
  values?: InputMaybe<StringNullableListFilter>;
};

export type ApplicationFees = {
  __typename?: 'ApplicationFees';
  corporate: Scalars['Float']['output'];
  employee: Scalars['Float']['output'];
  match: Scalars['Float']['output'];
};

export type ApplicationFeesCreateInput = {
  corporate?: InputMaybe<Scalars['Float']['input']>;
  employee?: InputMaybe<Scalars['Float']['input']>;
  match?: InputMaybe<Scalars['Float']['input']>;
};

export type ApplicationFeesNullableCompositeFilter = {
  equals?: InputMaybe<ApplicationFeesObjectEqualityInput>;
  is?: InputMaybe<ApplicationFeesWhereInput>;
  isNot?: InputMaybe<ApplicationFeesWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationFeesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ApplicationFeesCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ApplicationFeesUpsertInput>;
};

export type ApplicationFeesObjectEqualityInput = {
  corporate: Scalars['Float']['input'];
  employee: Scalars['Float']['input'];
  match: Scalars['Float']['input'];
};

export type ApplicationFeesOrderByInput = {
  corporate?: InputMaybe<SortOrder>;
  employee?: InputMaybe<SortOrder>;
  match?: InputMaybe<SortOrder>;
};

export type ApplicationFeesUpdateInput = {
  corporate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  employee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  match?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ApplicationFeesUpsertInput = {
  set: ApplicationFeesCreateInput;
  update: ApplicationFeesUpdateInput;
};

export type ApplicationFeesWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ApplicationFeesWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ApplicationFeesWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ApplicationFeesWhereInput>>>;
  corporate?: InputMaybe<FloatFilter>;
  employee?: InputMaybe<FloatFilter>;
  match?: InputMaybe<FloatFilter>;
};

export type Area = {
  coordinates: Array<Scalars['Float']['input']>;
  radius: Scalars['Float']['input'];
};

export type AwardedBadge = {
  __typename?: 'AwardedBadge';
  Badge: Badge;
  Organization?: Maybe<Organization>;
  User: BaseUser;
  badge: Scalars['String']['output'];
  badgeEarningActions: Array<Scalars['String']['output']>;
  badgeEarningDonations: Array<Scalars['String']['output']>;
  badgeEarningVolunteerTimes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  earnedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};


export type AwardedBadgeOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type AwardedBadgeCountAggregateOutputType = {
  __typename?: 'AwardedBadgeCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  badge: Scalars['Int']['output'];
  badgeEarningActions: Scalars['Int']['output'];
  badgeEarningDonations: Scalars['Int']['output'];
  badgeEarningVolunteerTimes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  earnedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  user: Scalars['Int']['output'];
};

export type AwardedBadgeCountOrderByAggregateInput = {
  badge?: InputMaybe<SortOrder>;
  badgeEarningActions?: InputMaybe<SortOrder>;
  badgeEarningDonations?: InputMaybe<SortOrder>;
  badgeEarningVolunteerTimes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  earnedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type AwardedBadgeCreateInput = {
  Badge: BadgeCreateNestedOneWithoutAwardedBadgeInput;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutAwardedBadgeInput>;
  User: BaseUserCreateNestedOneWithoutAwardedBadgeInput;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AwardedBadgeCreateManyBadgeInput = {
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeCreateManyBadgeInputEnvelope = {
  data: AwardedBadgeCreateManyBadgeInput;
};

export type AwardedBadgeCreateManyInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeCreateManyOrganizationInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeCreateManyOrganizationInputEnvelope = {
  data: AwardedBadgeCreateManyOrganizationInput;
};

export type AwardedBadgeCreateManyUserInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
};

export type AwardedBadgeCreateManyUserInputEnvelope = {
  data: AwardedBadgeCreateManyUserInput;
};

export type AwardedBadgeCreateNestedManyWithoutBadgeInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyBadgeInputEnvelope>;
};

export type AwardedBadgeCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyOrganizationInputEnvelope>;
};

export type AwardedBadgeCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyUserInputEnvelope>;
};

export type AwardedBadgeCreateOrConnectWithoutBadgeInput = {
  create: AwardedBadgeCreateWithoutBadgeInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeCreateOrConnectWithoutOrganizationInput = {
  create: AwardedBadgeCreateWithoutOrganizationInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeCreateOrConnectWithoutUserInput = {
  create: AwardedBadgeCreateWithoutUserInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeCreateWithoutBadgeInput = {
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutAwardedBadgeInput>;
  User: BaseUserCreateNestedOneWithoutAwardedBadgeInput;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AwardedBadgeCreateWithoutOrganizationInput = {
  Badge: BadgeCreateNestedOneWithoutAwardedBadgeInput;
  User: BaseUserCreateNestedOneWithoutAwardedBadgeInput;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AwardedBadgeCreateWithoutUserInput = {
  Badge: BadgeCreateNestedOneWithoutAwardedBadgeInput;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutAwardedBadgeInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AwardedBadgeCreatebadgeEarningActionsInput = {
  set: Scalars['String']['input'];
};

export type AwardedBadgeCreatebadgeEarningDonationsInput = {
  set: Scalars['String']['input'];
};

export type AwardedBadgeCreatebadgeEarningVolunteerTimesInput = {
  set: Scalars['String']['input'];
};

export type AwardedBadgeListRelationFilter = {
  every?: InputMaybe<AwardedBadgeWhereInput>;
  none?: InputMaybe<AwardedBadgeWhereInput>;
  some?: InputMaybe<AwardedBadgeWhereInput>;
};

export type AwardedBadgeMaxAggregateOutputType = {
  __typename?: 'AwardedBadgeMaxAggregateOutputType';
  badge?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  earnedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type AwardedBadgeMaxOrderByAggregateInput = {
  badge?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  earnedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type AwardedBadgeMinAggregateOutputType = {
  __typename?: 'AwardedBadgeMinAggregateOutputType';
  badge?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  earnedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type AwardedBadgeMinOrderByAggregateInput = {
  badge?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  earnedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type AwardedBadgeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AwardedBadgeOrderByWithAggregationInput = {
  _count?: InputMaybe<AwardedBadgeCountOrderByAggregateInput>;
  _max?: InputMaybe<AwardedBadgeMaxOrderByAggregateInput>;
  _min?: InputMaybe<AwardedBadgeMinOrderByAggregateInput>;
  badge?: InputMaybe<SortOrder>;
  badgeEarningActions?: InputMaybe<SortOrder>;
  badgeEarningDonations?: InputMaybe<SortOrder>;
  badgeEarningVolunteerTimes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  earnedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type AwardedBadgeOrderByWithRelationInput = {
  Badge?: InputMaybe<BadgeOrderByWithRelationInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  badge?: InputMaybe<SortOrder>;
  badgeEarningActions?: InputMaybe<SortOrder>;
  badgeEarningDonations?: InputMaybe<SortOrder>;
  badgeEarningVolunteerTimes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  earnedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export enum AwardedBadgeScalarFieldEnum {
  Badge = 'badge',
  BadgeEarningActions = 'badgeEarningActions',
  BadgeEarningDonations = 'badgeEarningDonations',
  BadgeEarningVolunteerTimes = 'badgeEarningVolunteerTimes',
  CreatedAt = 'createdAt',
  EarnedAt = 'earnedAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Organization = 'organization',
  User = 'user'
}

export type AwardedBadgeScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  badge?: InputMaybe<StringFilter>;
  badgeEarningActions?: InputMaybe<StringNullableListFilter>;
  badgeEarningDonations?: InputMaybe<StringNullableListFilter>;
  badgeEarningVolunteerTimes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  earnedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringFilter>;
};

export type AwardedBadgeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereWithAggregatesInput>>>;
  badge?: InputMaybe<StringWithAggregatesFilter>;
  badgeEarningActions?: InputMaybe<StringNullableListFilter>;
  badgeEarningDonations?: InputMaybe<StringNullableListFilter>;
  badgeEarningVolunteerTimes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  earnedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  organization?: InputMaybe<StringNullableWithAggregatesFilter>;
  user?: InputMaybe<StringWithAggregatesFilter>;
};

export type AwardedBadgeUncheckedCreateInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeUncheckedCreateNestedManyWithoutBadgeInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyBadgeInputEnvelope>;
};

export type AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyOrganizationInputEnvelope>;
};

export type AwardedBadgeUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyUserInputEnvelope>;
};

export type AwardedBadgeUncheckedCreateWithoutBadgeInput = {
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeUncheckedCreateWithoutOrganizationInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
};

export type AwardedBadgeUncheckedCreateWithoutUserInput = {
  badge: Scalars['String']['input'];
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  earnedAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
};

export type AwardedBadgeUncheckedUpdateInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateManyInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutBadgeInput = {
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutBadgeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyBadgeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutBadgeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutBadgeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutBadgeInput>>>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutOrganizationInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutUserInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AwardedBadgeUncheckedUpdateWithoutBadgeInput = {
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateWithoutOrganizationInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUncheckedUpdateWithoutUserInput = {
  badge?: InputMaybe<StringFieldUpdateOperationsInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdateInput = {
  Badge?: InputMaybe<BadgeUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutAwardedBadgeNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdateManyMutationInput = {
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdateManyWithWhereWithoutBadgeInput = {
  data: AwardedBadgeUpdateManyMutationInput;
  where: AwardedBadgeScalarWhereInput;
};

export type AwardedBadgeUpdateManyWithWhereWithoutOrganizationInput = {
  data: AwardedBadgeUpdateManyMutationInput;
  where: AwardedBadgeScalarWhereInput;
};

export type AwardedBadgeUpdateManyWithWhereWithoutUserInput = {
  data: AwardedBadgeUpdateManyMutationInput;
  where: AwardedBadgeScalarWhereInput;
};

export type AwardedBadgeUpdateManyWithoutBadgeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyBadgeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutBadgeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutBadgeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutBadgeInput>>>;
};

export type AwardedBadgeUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type AwardedBadgeUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AwardedBadgeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AwardedBadgeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AwardedBadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AwardedBadgeUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AwardedBadgeUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AwardedBadgeUpdateWithWhereUniqueWithoutBadgeInput = {
  data: AwardedBadgeUpdateWithoutBadgeInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: AwardedBadgeUpdateWithoutOrganizationInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeUpdateWithWhereUniqueWithoutUserInput = {
  data: AwardedBadgeUpdateWithoutUserInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeUpdateWithoutBadgeInput = {
  Organization?: InputMaybe<OrganizationUpdateOneWithoutAwardedBadgeNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdateWithoutOrganizationInput = {
  Badge?: InputMaybe<BadgeUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdateWithoutUserInput = {
  Badge?: InputMaybe<BadgeUpdateOneRequiredWithoutAwardedBadgeNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutAwardedBadgeNestedInput>;
  badgeEarningActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningDonations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeEarningVolunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  earnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AwardedBadgeUpdatebadgeEarningActionsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AwardedBadgeUpdatebadgeEarningDonationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AwardedBadgeUpdatebadgeEarningVolunteerTimesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AwardedBadgeUpsertWithWhereUniqueWithoutBadgeInput = {
  create: AwardedBadgeCreateWithoutBadgeInput;
  update: AwardedBadgeUpdateWithoutBadgeInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: AwardedBadgeCreateWithoutOrganizationInput;
  update: AwardedBadgeUpdateWithoutOrganizationInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeUpsertWithWhereUniqueWithoutUserInput = {
  create: AwardedBadgeCreateWithoutUserInput;
  update: AwardedBadgeUpdateWithoutUserInput;
  where: AwardedBadgeWhereUniqueInput;
};

export type AwardedBadgeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  Badge?: InputMaybe<BadgeRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  badge?: InputMaybe<StringFilter>;
  badgeEarningActions?: InputMaybe<StringNullableListFilter>;
  badgeEarningDonations?: InputMaybe<StringNullableListFilter>;
  badgeEarningVolunteerTimes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  earnedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringFilter>;
};

export type AwardedBadgeWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  Badge?: InputMaybe<BadgeRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AwardedBadgeWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  badge?: InputMaybe<StringFilter>;
  badgeEarningActions?: InputMaybe<StringNullableListFilter>;
  badgeEarningDonations?: InputMaybe<StringNullableListFilter>;
  badgeEarningVolunteerTimes?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  earnedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringFilter>;
};

export type Badge = {
  __typename?: 'Badge';
  Organization?: Maybe<Organization>;
  _count: BadgeCountOutputType;
  /** Info of awarded badge to user */
  awardedBadge?: Maybe<AwardedBadge>;
  category: BadgeCategory;
  causes: Array<Cause>;
  createdAt: Scalars['DateTime']['output'];
  criteria: Array<BadgeCriteria>;
  description: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  imageURL: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  status: BadgeStatus;
  visibility: BadgeVisibility;
};


export type BadgeOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type BadgeCausesArgs = {
  cursor?: InputMaybe<CauseWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CauseScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CauseOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CauseWhereInput>;
};

export enum BadgeCategory {
  Actions = 'actions',
  Campaigns = 'campaigns',
  Donations = 'donations',
  Volunteering = 'volunteering'
}

export type BadgeCertificate = {
  __typename?: 'BadgeCertificate';
  /** amount of badge */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Header image shown on the badgeCertificate */
  badgeCertificateHeaderImage?: Maybe<Scalars['String']['output']>;
  /** brand color of organization */
  brandColor?: Maybe<Scalars['String']['output']>;
  /** unique identifier for certificate */
  certificateNumber?: Maybe<Scalars['String']['output']>;
  /** date user earned badge */
  earnedAt?: Maybe<Scalars['DateTime']['output']>;
  /** logo of organization */
  logo?: Maybe<Scalars['String']['output']>;
  /** name of the badge */
  name?: Maybe<Scalars['String']['output']>;
  /** name of organization */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** unit of badge */
  unit?: Maybe<Scalars['String']['output']>;
  /** name of the user */
  userName?: Maybe<Scalars['String']['output']>;
};

export type BadgeCountAggregateOutputType = {
  __typename?: 'BadgeCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  category: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageURL: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  periodEnd: Scalars['Int']['output'];
  periodStart: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
};

export type BadgeCountOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageURL?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  visibility?: InputMaybe<SortOrder>;
};

export type BadgeCountOutputType = {
  __typename?: 'BadgeCountOutputType';
  AwardedBadge: Scalars['Int']['output'];
  causes: Scalars['Int']['output'];
};

export type BadgeCreateInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutBadgeInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutBadgesInput>;
  category: BadgeCategory;
  causes?: InputMaybe<CauseCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCreateManyInput = {
  category: BadgeCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCreateManyOrganizationInput = {
  category: BadgeCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCreateManyOrganizationInputEnvelope = {
  data: BadgeCreateManyOrganizationInput;
};

export type BadgeCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BadgeCreateManyOrganizationInputEnvelope>;
};

export type BadgeCreateNestedOneWithoutAwardedBadgeInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BadgeCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<BadgeCreateWithoutAwardedBadgeInput>;
};

export type BadgeCreateNestedOneWithoutCausesInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BadgeCreateOrConnectWithoutCausesInput>;
  create?: InputMaybe<BadgeCreateWithoutCausesInput>;
};

export type BadgeCreateOrConnectWithoutAwardedBadgeInput = {
  create: BadgeCreateWithoutAwardedBadgeInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeCreateOrConnectWithoutCausesInput = {
  create: BadgeCreateWithoutCausesInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeCreateOrConnectWithoutOrganizationInput = {
  create: BadgeCreateWithoutOrganizationInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeCreateWithoutAwardedBadgeInput = {
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutBadgesInput>;
  category: BadgeCategory;
  causes?: InputMaybe<CauseCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCreateWithoutCausesInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutBadgeInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutBadgesInput>;
  category: BadgeCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCreateWithoutOrganizationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutBadgeInput>;
  category: BadgeCategory;
  causes?: InputMaybe<CauseCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeCriteria = {
  __typename?: 'BadgeCriteria';
  amount: Scalars['Int']['output'];
  entityIds: Array<Scalars['String']['output']>;
  entityType?: Maybe<BadgeCriteriaEntityType>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  unit: BadgeCriteriaUnit;
};

export type BadgeCriteriaCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<BadgeCriteriaObjectEqualityInput>>>;
  every?: InputMaybe<BadgeCriteriaWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BadgeCriteriaWhereInput>;
  some?: InputMaybe<BadgeCriteriaWhereInput>;
};

export type BadgeCriteriaCreateInput = {
  amount: Scalars['Int']['input'];
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<BadgeCriteriaEntityType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  unit: BadgeCriteriaUnit;
};

export type BadgeCriteriaCreateentityIdsInput = {
  set: Scalars['String']['input'];
};

export type BadgeCriteriaDeleteManyInput = {
  where: BadgeCriteriaWhereInput;
};

export enum BadgeCriteriaEntityType {
  Campaigns = 'campaigns'
}

export type BadgeCriteriaListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
};

export type BadgeCriteriaListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<BadgeCriteriaDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  updateMany?: InputMaybe<BadgeCriteriaUpdateManyInput>;
};

export type BadgeCriteriaObjectEqualityInput = {
  amount: Scalars['Int']['input'];
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<BadgeCriteriaEntityType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  unit: BadgeCriteriaUnit;
};

export type BadgeCriteriaOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum BadgeCriteriaUnit {
  ActionsCompleted = 'actionsCompleted',
  CustomDonationBadge = 'customDonationBadge',
  DonationsCount = 'donationsCount',
  VolunteerTimeMinutes = 'volunteerTimeMinutes'
}

export type BadgeCriteriaUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<NullableEnumBadgeCriteriaEntityTypeFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumBadgeCriteriaUnitFieldUpdateOperationsInput>;
};

export type BadgeCriteriaUpdateManyInput = {
  data: BadgeCriteriaUpdateInput;
  where: BadgeCriteriaWhereInput;
};

export type BadgeCriteriaUpdateentityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BadgeCriteriaWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BadgeCriteriaWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BadgeCriteriaWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeCriteriaWhereInput>>>;
  amount?: InputMaybe<IntFilter>;
  entityIds?: InputMaybe<StringNullableListFilter>;
  entityType?: InputMaybe<EnumBadgeCriteriaEntityTypeNullableFilter>;
  periodEnd?: InputMaybe<DateTimeNullableFilter>;
  periodStart?: InputMaybe<DateTimeNullableFilter>;
  unit?: InputMaybe<EnumBadgeCriteriaUnitFilter>;
};

export enum BadgeEventType {
  Actions = 'Actions',
  Donations = 'Donations',
  Volunteering = 'Volunteering'
}

export type BadgeListRelationFilter = {
  every?: InputMaybe<BadgeWhereInput>;
  none?: InputMaybe<BadgeWhereInput>;
  some?: InputMaybe<BadgeWhereInput>;
};

export type BadgeMaxAggregateOutputType = {
  __typename?: 'BadgeMaxAggregateOutputType';
  category?: Maybe<BadgeCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BadgeStatus>;
  visibility?: Maybe<BadgeVisibility>;
};

export type BadgeMaxOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageURL?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  visibility?: InputMaybe<SortOrder>;
};

export type BadgeMinAggregateOutputType = {
  __typename?: 'BadgeMinAggregateOutputType';
  category?: Maybe<BadgeCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BadgeStatus>;
  visibility?: Maybe<BadgeVisibility>;
};

export type BadgeMinOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageURL?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  visibility?: InputMaybe<SortOrder>;
};

export type BadgeNullableRelationFilter = {
  is?: InputMaybe<BadgeWhereInput>;
  isNot?: InputMaybe<BadgeWhereInput>;
};

export type BadgeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BadgeOrderByWithAggregationInput = {
  _count?: InputMaybe<BadgeCountOrderByAggregateInput>;
  _max?: InputMaybe<BadgeMaxOrderByAggregateInput>;
  _min?: InputMaybe<BadgeMinOrderByAggregateInput>;
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageURL?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  visibility?: InputMaybe<SortOrder>;
};

export type BadgeOrderByWithRelationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  category?: InputMaybe<SortOrder>;
  causes?: InputMaybe<CauseOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  criteria?: InputMaybe<BadgeCriteriaOrderByCompositeAggregateInput>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageURL?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  visibility?: InputMaybe<SortOrder>;
};

export type BadgeRelationFilter = {
  is?: InputMaybe<BadgeWhereInput>;
  isNot?: InputMaybe<BadgeWhereInput>;
};

export enum BadgeScalarFieldEnum {
  Category = 'category',
  CreatedAt = 'createdAt',
  Description = 'description',
  Enabled = 'enabled',
  Id = 'id',
  ImageUrl = 'imageURL',
  ModifiedAt = 'modifiedAt',
  Name = 'name',
  Organization = 'organization',
  PeriodEnd = 'periodEnd',
  PeriodStart = 'periodStart',
  Status = 'status',
  Visibility = 'visibility'
}

export type BadgeScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BadgeScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BadgeScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeScalarWhereInput>>>;
  category?: InputMaybe<EnumBadgeCategoryFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageURL?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  periodEnd?: InputMaybe<DateTimeNullableFilter>;
  periodStart?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumBadgeStatusFilter>;
  visibility?: InputMaybe<EnumBadgeVisibilityFilter>;
};

export type BadgeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BadgeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BadgeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeScalarWhereWithAggregatesInput>>>;
  category?: InputMaybe<EnumBadgeCategoryWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  enabled?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageURL?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  organization?: InputMaybe<StringNullableWithAggregatesFilter>;
  periodEnd?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  periodStart?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumBadgeStatusWithAggregatesFilter>;
  visibility?: InputMaybe<EnumBadgeVisibilityWithAggregatesFilter>;
};

export enum BadgeStatus {
  Awardable = 'awardable',
  NotAwardable = 'notAwardable'
}

export type BadgeUncheckedCreateInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutBadgeInput>;
  category: BadgeCategory;
  causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BadgeCreateManyOrganizationInputEnvelope>;
};

export type BadgeUncheckedCreateWithoutAwardedBadgeInput = {
  category: BadgeCategory;
  causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeUncheckedCreateWithoutCausesInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutBadgeInput>;
  category: BadgeCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeUncheckedCreateWithoutOrganizationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutBadgeInput>;
  category: BadgeCategory;
  causes?: InputMaybe<CauseUncheckedCreateNestedManyWithoutBadgeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BadgeStatus>;
  visibility?: InputMaybe<BadgeVisibility>;
};

export type BadgeUncheckedUpdateInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutBadgeNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUncheckedUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUncheckedUpdateManyInput = {
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUncheckedUpdateManyWithoutOrganizationInput = {
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BadgeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BadgeUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BadgeUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BadgeUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type BadgeUncheckedUpdateWithoutAwardedBadgeInput = {
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUncheckedUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUncheckedUpdateWithoutCausesInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutBadgeNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUncheckedUpdateWithoutOrganizationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutBadgeNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUncheckedUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpdateInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutBadgeNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutBadgesNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpdateManyMutationInput = {
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpdateManyWithWhereWithoutOrganizationInput = {
  data: BadgeUpdateManyMutationInput;
  where: BadgeScalarWhereInput;
};

export type BadgeUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BadgeCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BadgeCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BadgeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BadgeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BadgeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BadgeUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BadgeUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BadgeUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type BadgeUpdateOneRequiredWithoutAwardedBadgeNestedInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BadgeCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<BadgeCreateWithoutAwardedBadgeInput>;
  update?: InputMaybe<BadgeUpdateToOneWithWhereWithoutAwardedBadgeInput>;
  upsert?: InputMaybe<BadgeUpsertWithoutAwardedBadgeInput>;
};

export type BadgeUpdateOneWithoutCausesNestedInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BadgeCreateOrConnectWithoutCausesInput>;
  create?: InputMaybe<BadgeCreateWithoutCausesInput>;
  delete?: InputMaybe<BadgeWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BadgeUpdateToOneWithWhereWithoutCausesInput>;
  upsert?: InputMaybe<BadgeUpsertWithoutCausesInput>;
};

export type BadgeUpdateToOneWithWhereWithoutAwardedBadgeInput = {
  data: BadgeUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<BadgeWhereInput>;
};

export type BadgeUpdateToOneWithWhereWithoutCausesInput = {
  data: BadgeUpdateWithoutCausesInput;
  where?: InputMaybe<BadgeWhereInput>;
};

export type BadgeUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: BadgeUpdateWithoutOrganizationInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeUpdateWithoutAwardedBadgeInput = {
  Organization?: InputMaybe<OrganizationUpdateOneWithoutBadgesNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpdateWithoutCausesInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutBadgeNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutBadgesNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpdateWithoutOrganizationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutBadgeNestedInput>;
  category?: InputMaybe<EnumBadgeCategoryFieldUpdateOperationsInput>;
  causes?: InputMaybe<CauseUpdateManyWithoutBadgeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaCreateInput>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageURL?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBadgeStatusFieldUpdateOperationsInput>;
  visibility?: InputMaybe<EnumBadgeVisibilityFieldUpdateOperationsInput>;
};

export type BadgeUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: BadgeCreateWithoutOrganizationInput;
  update: BadgeUpdateWithoutOrganizationInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeUpsertWithoutAwardedBadgeInput = {
  create: BadgeCreateWithoutAwardedBadgeInput;
  update: BadgeUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<BadgeWhereInput>;
};

export type BadgeUpsertWithoutCausesInput = {
  create: BadgeCreateWithoutCausesInput;
  update: BadgeUpdateWithoutCausesInput;
  where?: InputMaybe<BadgeWhereInput>;
};

export enum BadgeVisibility {
  VisibleToAll = 'visibleToAll',
  VisibleToAwardedOnly = 'visibleToAwardedOnly',
  VisibleToNone = 'visibleToNone'
}

export type BadgeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  category?: InputMaybe<EnumBadgeCategoryFilter>;
  causes?: InputMaybe<CauseListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaObjectEqualityInput>>>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageURL?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  periodEnd?: InputMaybe<DateTimeNullableFilter>;
  periodStart?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumBadgeStatusFilter>;
  visibility?: InputMaybe<EnumBadgeVisibilityFilter>;
};

export type BadgeWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  category?: InputMaybe<EnumBadgeCategoryFilter>;
  causes?: InputMaybe<CauseListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  criteria?: InputMaybe<Array<InputMaybe<BadgeCriteriaObjectEqualityInput>>>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  periodEnd?: InputMaybe<DateTimeNullableFilter>;
  periodStart?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumBadgeStatusFilter>;
  visibility?: InputMaybe<EnumBadgeVisibilityFilter>;
};

export enum BaseCurrencies {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pln = 'PLN',
  Ron = 'RON',
  Sek = 'SEK',
  Sgd = 'SGD',
  Usd = 'USD'
}

export type BaseUser = {
  __typename?: 'BaseUser';
  Organization?: Maybe<Organization>;
  PayrollPayGroup?: Maybe<PayrollPayGroup>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(privilege: organization:manageUsers, organizationField: organizationId)]) */
  Roles: Array<Role>;
  VolunteerRewardChangedBy: Array<VolunteerReward>;
  _count: BaseUserCountOutputType;
  /** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: actions:manage, organizationField: organizationId)]) */
  activities: Array<Activity>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  additionalData?: Maybe<UserAdditionalData>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: communities:edit, organizationField: organizationId)]) */
  communities: Array<CommunityMembership>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  contactEmails: Array<ContactEmail>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deeds: Array<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  displayCurrency: Scalars['String']['output'];
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  email: Scalars['String']['output'];
  fullName?: Maybe<FullName>;
  id: Scalars['String']['output'];
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  locale?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  locationId?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  locationObject?: Maybe<LimitedLocationObject>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  locations: Array<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  organizationDepartment?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  phone?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id)]) */
  pledges: Array<Pledge>;
  preferredName?: Maybe<PreferredName>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  provider?: Maybe<Scalars['String']['output']>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  roleGrants: Array<RoleGrant>;
  /** @Auth(read: [Owner(ownerField: id), Organizer(privilege: organization:manageUsers, organizationField: organizationId)]) */
  roles: Array<Scalars['String']['output']>;
  type: UserType;
  /** @Auth(read: [Owner(ownerField: id), Organizer(type: Company, privilege: organization:manageUsers, organizationField: organizationId)]) */
  volunteerMinutes?: Maybe<Scalars['Int']['output']>;
};


export type BaseUserOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type BaseUserPayrollPayGroupArgs = {
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};


export type BaseUserRolesArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<RoleScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<RoleOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type BaseUserVolunteerRewardChangedByArgs = {
  cursor?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<VolunteerRewardOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VolunteerRewardWhereInput>;
};


export type BaseUserActivitiesArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ActivityScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ActivityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityWhereInput>;
};

export type BaseUserAdditionalData = {
  __typename?: 'BaseUserAdditionalData';
  hireDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BaseUserAvgAggregateOutputType = {
  __typename?: 'BaseUserAvgAggregateOutputType';
  volunteerMinutes?: Maybe<Scalars['Float']['output']>;
};

export type BaseUserAvgOrderByAggregateInput = {
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserCountAggregateOutputType = {
  __typename?: 'BaseUserCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  companyBySignupDomain: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deeds: Scalars['Int']['output'];
  displayCurrency: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locale: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  locations: Scalars['Int']['output'];
  mainPicture: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organizationDepartment: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  origin: Scalars['Int']['output'];
  payrollPayGroupId: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  roles: Scalars['Int']['output'];
  slack: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  volunteerMinutes: Scalars['Int']['output'];
};

export type BaseUserCountOrderByAggregateInput = {
  companyBySignupDomain?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  displayCurrency?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationDepartment?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  roles?: InputMaybe<SortOrder>;
  slack?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserCountOutputType = {
  __typename?: 'BaseUserCountOutputType';
  Affiliation: Scalars['Int']['output'];
  AwardedBadge: Scalars['Int']['output'];
  ChallengeContributions: Scalars['Int']['output'];
  DonationSchedules: Scalars['Int']['output'];
  Donations: Scalars['Int']['output'];
  FormResponses: Scalars['Int']['output'];
  NonprofitNomination: Scalars['Int']['output'];
  Roles: Scalars['Int']['output'];
  VolunteerRewardChangedBy: Scalars['Int']['output'];
  VolunteerRewards: Scalars['Int']['output'];
  VolunteerTime: Scalars['Int']['output'];
  activities: Scalars['Int']['output'];
  volunteerTimeOffs: Scalars['Int']['output'];
};

export type BaseUserCreateInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateManyInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseUserCreateManyOrganizationInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseUserCreateManyOrganizationInputEnvelope = {
  data: BaseUserCreateManyOrganizationInput;
};

export type BaseUserCreateManyPayrollPayGroupInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseUserCreateManyPayrollPayGroupInputEnvelope = {
  data: BaseUserCreateManyPayrollPayGroupInput;
};

export type BaseUserCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyOrganizationInputEnvelope>;
};

export type BaseUserCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyPayrollPayGroupInputEnvelope>;
};

export type BaseUserCreateNestedManyWithoutRolesInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutRolesInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutRolesInput>>>;
};

export type BaseUserCreateNestedOneWithoutActivitiesInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<BaseUserCreateWithoutActivitiesInput>;
};

export type BaseUserCreateNestedOneWithoutAffiliationInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutAffiliationInput>;
  create?: InputMaybe<BaseUserCreateWithoutAffiliationInput>;
};

export type BaseUserCreateNestedOneWithoutAwardedBadgeInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<BaseUserCreateWithoutAwardedBadgeInput>;
};

export type BaseUserCreateNestedOneWithoutChallengeContributionsInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<BaseUserCreateWithoutChallengeContributionsInput>;
};

export type BaseUserCreateNestedOneWithoutDonationSchedulesInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutDonationSchedulesInput>;
  create?: InputMaybe<BaseUserCreateWithoutDonationSchedulesInput>;
};

export type BaseUserCreateNestedOneWithoutDonationsInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<BaseUserCreateWithoutDonationsInput>;
};

export type BaseUserCreateNestedOneWithoutFormResponsesInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<BaseUserCreateWithoutFormResponsesInput>;
};

export type BaseUserCreateNestedOneWithoutNonprofitNominationInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutNonprofitNominationInput>;
  create?: InputMaybe<BaseUserCreateWithoutNonprofitNominationInput>;
};

export type BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutPointOfContactOrganizationInput>;
  create?: InputMaybe<BaseUserCreateWithoutPointOfContactOrganizationInput>;
};

export type BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerRewardChangedByInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerRewardChangedByInput>;
};

export type BaseUserCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerRewardsInput>;
};

export type BaseUserCreateNestedOneWithoutVolunteerTimeInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeInput>;
};

export type BaseUserCreateNestedOneWithoutVolunteerTimeOffSummaryInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeOffSummaryInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeOffSummaryInput>;
};

export type BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeOffsInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeOffsInput>;
};

export type BaseUserCreateOrConnectWithoutActivitiesInput = {
  create: BaseUserCreateWithoutActivitiesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutAffiliationInput = {
  create: BaseUserCreateWithoutAffiliationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutAwardedBadgeInput = {
  create: BaseUserCreateWithoutAwardedBadgeInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutChallengeContributionsInput = {
  create: BaseUserCreateWithoutChallengeContributionsInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutDonationSchedulesInput = {
  create: BaseUserCreateWithoutDonationSchedulesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutDonationsInput = {
  create: BaseUserCreateWithoutDonationsInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutFormResponsesInput = {
  create: BaseUserCreateWithoutFormResponsesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutNonprofitNominationInput = {
  create: BaseUserCreateWithoutNonprofitNominationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutOrganizationInput = {
  create: BaseUserCreateWithoutOrganizationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutPayrollPayGroupInput = {
  create: BaseUserCreateWithoutPayrollPayGroupInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutPointOfContactOrganizationInput = {
  create: BaseUserCreateWithoutPointOfContactOrganizationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutRolesInput = {
  create: BaseUserCreateWithoutRolesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutVolunteerRewardChangedByInput = {
  create: BaseUserCreateWithoutVolunteerRewardChangedByInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutVolunteerRewardsInput = {
  create: BaseUserCreateWithoutVolunteerRewardsInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutVolunteerTimeInput = {
  create: BaseUserCreateWithoutVolunteerTimeInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutVolunteerTimeOffSummaryInput = {
  create: BaseUserCreateWithoutVolunteerTimeOffSummaryInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateOrConnectWithoutVolunteerTimeOffsInput = {
  create: BaseUserCreateWithoutVolunteerTimeOffsInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserCreateWithoutActivitiesInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutAffiliationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutAwardedBadgeInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutChallengeContributionsInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutDonationSchedulesInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutDonationsInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutFormResponsesInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutNonprofitNominationInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutPayrollPayGroupInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutPointOfContactOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutRolesInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutVolunteerRewardChangedByInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutVolunteerRewardsInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutVolunteerTimeInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutVolunteerTimeOffSummaryInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutUserInput>;
};

export type BaseUserCreateWithoutVolunteerTimeOffsInput = {
  Affiliation?: InputMaybe<AffiliationCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationCreateNestedManyWithoutUserInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUsersInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutBaseUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput>;
};

export type BaseUserCreatedeedsInput = {
  set: Scalars['String']['input'];
};

export type BaseUserCreatelocationsInput = {
  set: Scalars['String']['input'];
};

export type BaseUserCreaterolesInput = {
  set: Scalars['String']['input'];
};

export type BaseUserListRelationFilter = {
  every?: InputMaybe<BaseUserWhereInput>;
  none?: InputMaybe<BaseUserWhereInput>;
  some?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserMaxAggregateOutputType = {
  __typename?: 'BaseUserMaxAggregateOutputType';
  companyBySignupDomain?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayCurrency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationDepartment?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserType>;
  volunteerMinutes?: Maybe<Scalars['Int']['output']>;
};

export type BaseUserMaxOrderByAggregateInput = {
  companyBySignupDomain?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayCurrency?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationDepartment?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserMinAggregateOutputType = {
  __typename?: 'BaseUserMinAggregateOutputType';
  companyBySignupDomain?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayCurrency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationDepartment?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserType>;
  volunteerMinutes?: Maybe<Scalars['Int']['output']>;
};

export type BaseUserMinOrderByAggregateInput = {
  companyBySignupDomain?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayCurrency?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationDepartment?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserNullableRelationFilter = {
  is?: InputMaybe<BaseUserWhereInput>;
  isNot?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BaseUserOrderByWithAggregationInput = {
  _avg?: InputMaybe<BaseUserAvgOrderByAggregateInput>;
  _count?: InputMaybe<BaseUserCountOrderByAggregateInput>;
  _max?: InputMaybe<BaseUserMaxOrderByAggregateInput>;
  _min?: InputMaybe<BaseUserMinOrderByAggregateInput>;
  _sum?: InputMaybe<BaseUserSumOrderByAggregateInput>;
  companyBySignupDomain?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  displayCurrency?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationDepartment?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  roles?: InputMaybe<SortOrder>;
  slack?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserOrderByWithRelationInput = {
  Affiliation?: InputMaybe<AffiliationOrderByRelationAggregateInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeOrderByRelationAggregateInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionOrderByRelationAggregateInput>;
  DonationSchedules?: InputMaybe<DonationScheduleOrderByRelationAggregateInput>;
  Donations?: InputMaybe<DonationOrderByRelationAggregateInput>;
  FormResponses?: InputMaybe<FormResponseOrderByRelationAggregateInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupOrderByWithRelationInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Roles?: InputMaybe<RoleOrderByRelationAggregateInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeOrderByRelationAggregateInput>;
  activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  additionalData?: InputMaybe<UserAdditionalDataOrderByInput>;
  communities?: InputMaybe<CommunityMembershipOrderByCompositeAggregateInput>;
  companyBySignupDomain?: InputMaybe<SortOrder>;
  contactEmails?: InputMaybe<ContactEmailOrderByCompositeAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  displayCurrency?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  failedPayPalVerificationAttempts?: InputMaybe<VerificationFailureOrderByCompositeAggregateInput>;
  fullName?: InputMaybe<FullNameOrderByInput>;
  id?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  locationObject?: InputMaybe<LimitedLocationObjectOrderByInput>;
  locations?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organizationDepartment?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pledges?: InputMaybe<PledgeOrderByCompositeAggregateInput>;
  preferredName?: InputMaybe<PreferredNameOrderByInput>;
  provider?: InputMaybe<SortOrder>;
  roleGrants?: InputMaybe<RoleGrantOrderByCompositeAggregateInput>;
  roles?: InputMaybe<SortOrder>;
  slack?: InputMaybe<SortOrder>;
  sso?: InputMaybe<SsoUserOrderByInput>;
  type?: InputMaybe<SortOrder>;
  volunteerMinutes?: InputMaybe<SortOrder>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryOrderByWithRelationInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffOrderByRelationAggregateInput>;
};

export type BaseUserRelationFilter = {
  is?: InputMaybe<BaseUserWhereInput>;
  isNot?: InputMaybe<BaseUserWhereInput>;
};

export enum BaseUserScalarFieldEnum {
  CompanyBySignupDomain = 'companyBySignupDomain',
  CreatedAt = 'createdAt',
  Deeds = 'deeds',
  DisplayCurrency = 'displayCurrency',
  Email = 'email',
  ExternalId = 'externalId',
  Id = 'id',
  Locale = 'locale',
  LocationId = 'locationId',
  Locations = 'locations',
  MainPicture = 'mainPicture',
  ModifiedAt = 'modifiedAt',
  OrganizationDepartment = 'organizationDepartment',
  OrganizationId = 'organizationId',
  Origin = 'origin',
  PayrollPayGroupId = 'payrollPayGroupId',
  Phone = 'phone',
  Provider = 'provider',
  Roles = 'roles',
  Slack = 'slack',
  Type = 'type',
  VolunteerMinutes = 'volunteerMinutes'
}

export type BaseUserScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  companyBySignupDomain?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  displayCurrency?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationDepartment?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  roles?: InputMaybe<StringNullableListFilter>;
  slack?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  volunteerMinutes?: InputMaybe<IntNullableFilter>;
};

export type BaseUserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereWithAggregatesInput>>>;
  companyBySignupDomain?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  displayCurrency?: InputMaybe<StringWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  locale?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  mainPicture?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  organizationDepartment?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  origin?: InputMaybe<StringNullableWithAggregatesFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  provider?: InputMaybe<StringNullableWithAggregatesFilter>;
  roles?: InputMaybe<StringNullableListFilter>;
  slack?: InputMaybe<JsonNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumUserTypeWithAggregatesFilter>;
  volunteerMinutes?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type BaseUserSumAggregateOutputType = {
  __typename?: 'BaseUserSumAggregateOutputType';
  volunteerMinutes?: Maybe<Scalars['Int']['output']>;
};

export type BaseUserSumOrderByAggregateInput = {
  volunteerMinutes?: InputMaybe<SortOrder>;
};

export type BaseUserUncheckedCreateInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyOrganizationInputEnvelope>;
};

export type BaseUserUncheckedCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyPayrollPayGroupInputEnvelope>;
};

export type BaseUserUncheckedCreateNestedManyWithoutRolesInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutRolesInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutRolesInput>>>;
};

export type BaseUserUncheckedCreateWithoutActivitiesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutAffiliationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutAwardedBadgeInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutChallengeContributionsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutDonationSchedulesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutDonationsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutFormResponsesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutNonprofitNominationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutPayrollPayGroupInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutPointOfContactOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutRolesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutVolunteerRewardChangedByInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutVolunteerRewardsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutVolunteerTimeInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutVolunteerTimeOffSummaryInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput>;
};

export type BaseUserUncheckedCreateWithoutVolunteerTimeOffsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutUserInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutUserInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutUserInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutUserInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutUserInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutUserInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutUserInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput>;
  Roles?: InputMaybe<RoleUncheckedCreateNestedManyWithoutUsersInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutUserInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutUserInput>;
  activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutUserInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCreateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCreateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationDepartment?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCreateEnvelopeInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableCreateEnvelopeInput>;
  type: UserType;
  volunteerMinutes?: InputMaybe<Scalars['Int']['input']>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput>;
};

export type BaseUserUncheckedUpdateInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateManyInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BaseUserUncheckedUpdateManyWithoutOrganizationInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type BaseUserUncheckedUpdateManyWithoutPayrollPayGroupInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BaseUserUncheckedUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type BaseUserUncheckedUpdateManyWithoutRolesInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BaseUserUncheckedUpdateManyWithoutRolesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutRolesInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutRolesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutRolesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutRolesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutRolesInput>>>;
};

export type BaseUserUncheckedUpdateWithoutActivitiesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutAffiliationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutAwardedBadgeInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutChallengeContributionsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutDonationSchedulesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutDonationsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutFormResponsesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutNonprofitNominationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutPayrollPayGroupInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutPointOfContactOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutRolesInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutVolunteerRewardChangedByInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutVolunteerRewardsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutVolunteerTimeInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutVolunteerTimeOffSummaryInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUncheckedUpdateWithoutVolunteerTimeOffsInput = {
  Affiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUncheckedUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput>;
};

export type BaseUserUpdateInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateManyMutationInput = {
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type BaseUserUpdateManyWithWhereWithoutOrganizationInput = {
  data: BaseUserUpdateManyMutationInput;
  where: BaseUserScalarWhereInput;
};

export type BaseUserUpdateManyWithWhereWithoutPayrollPayGroupInput = {
  data: BaseUserUpdateManyMutationInput;
  where: BaseUserScalarWhereInput;
};

export type BaseUserUpdateManyWithWhereWithoutRolesInput = {
  data: BaseUserUpdateManyMutationInput;
  where: BaseUserScalarWhereInput;
};

export type BaseUserUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type BaseUserUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<BaseUserCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type BaseUserUpdateManyWithoutRolesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BaseUserCreateOrConnectWithoutRolesInput>>>;
  create?: InputMaybe<Array<InputMaybe<BaseUserCreateWithoutRolesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BaseUserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BaseUserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BaseUserUpdateWithWhereUniqueWithoutRolesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BaseUserUpdateManyWithWhereWithoutRolesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BaseUserUpsertWithWhereUniqueWithoutRolesInput>>>;
};

export type BaseUserUpdateOneRequiredWithoutActivitiesNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<BaseUserCreateWithoutActivitiesInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutActivitiesInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutActivitiesInput>;
};

export type BaseUserUpdateOneRequiredWithoutAffiliationNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutAffiliationInput>;
  create?: InputMaybe<BaseUserCreateWithoutAffiliationInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutAffiliationInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutAffiliationInput>;
};

export type BaseUserUpdateOneRequiredWithoutAwardedBadgeNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<BaseUserCreateWithoutAwardedBadgeInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutAwardedBadgeInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutAwardedBadgeInput>;
};

export type BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<BaseUserCreateWithoutChallengeContributionsInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutChallengeContributionsInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutChallengeContributionsInput>;
};

export type BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutDonationSchedulesInput>;
  create?: InputMaybe<BaseUserCreateWithoutDonationSchedulesInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutDonationSchedulesInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutDonationSchedulesInput>;
};

export type BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerRewardsInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutVolunteerRewardsInput>;
};

export type BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeInput>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutVolunteerTimeInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutVolunteerTimeInput>;
};

export type BaseUserUpdateOneWithoutDonationsNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<BaseUserCreateWithoutDonationsInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutDonationsInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutDonationsInput>;
};

export type BaseUserUpdateOneWithoutFormResponsesNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<BaseUserCreateWithoutFormResponsesInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutFormResponsesInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutFormResponsesInput>;
};

export type BaseUserUpdateOneWithoutNonprofitNominationNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutNonprofitNominationInput>;
  create?: InputMaybe<BaseUserCreateWithoutNonprofitNominationInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutNonprofitNominationInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutNonprofitNominationInput>;
};

export type BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutPointOfContactOrganizationInput>;
  create?: InputMaybe<BaseUserCreateWithoutPointOfContactOrganizationInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutPointOfContactOrganizationInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutPointOfContactOrganizationInput>;
};

export type BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerRewardChangedByInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerRewardChangedByInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutVolunteerRewardChangedByInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutVolunteerRewardChangedByInput>;
};

export type BaseUserUpdateOneWithoutVolunteerTimeOffSummaryNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeOffSummaryInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeOffSummaryInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutVolunteerTimeOffSummaryInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutVolunteerTimeOffSummaryInput>;
};

export type BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput = {
  connect?: InputMaybe<BaseUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BaseUserCreateOrConnectWithoutVolunteerTimeOffsInput>;
  create?: InputMaybe<BaseUserCreateWithoutVolunteerTimeOffsInput>;
  delete?: InputMaybe<BaseUserWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<BaseUserUpdateToOneWithWhereWithoutVolunteerTimeOffsInput>;
  upsert?: InputMaybe<BaseUserUpsertWithoutVolunteerTimeOffsInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutActivitiesInput = {
  data: BaseUserUpdateWithoutActivitiesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutAffiliationInput = {
  data: BaseUserUpdateWithoutAffiliationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutAwardedBadgeInput = {
  data: BaseUserUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutChallengeContributionsInput = {
  data: BaseUserUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutDonationSchedulesInput = {
  data: BaseUserUpdateWithoutDonationSchedulesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutDonationsInput = {
  data: BaseUserUpdateWithoutDonationsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutFormResponsesInput = {
  data: BaseUserUpdateWithoutFormResponsesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutNonprofitNominationInput = {
  data: BaseUserUpdateWithoutNonprofitNominationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutPointOfContactOrganizationInput = {
  data: BaseUserUpdateWithoutPointOfContactOrganizationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutVolunteerRewardChangedByInput = {
  data: BaseUserUpdateWithoutVolunteerRewardChangedByInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: BaseUserUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutVolunteerTimeInput = {
  data: BaseUserUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutVolunteerTimeOffSummaryInput = {
  data: BaseUserUpdateWithoutVolunteerTimeOffSummaryInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateToOneWithWhereWithoutVolunteerTimeOffsInput = {
  data: BaseUserUpdateWithoutVolunteerTimeOffsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: BaseUserUpdateWithoutOrganizationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpdateWithWhereUniqueWithoutPayrollPayGroupInput = {
  data: BaseUserUpdateWithoutPayrollPayGroupInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpdateWithWhereUniqueWithoutRolesInput = {
  data: BaseUserUpdateWithoutRolesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpdateWithoutActivitiesInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutAffiliationInput = {
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutAwardedBadgeInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutChallengeContributionsInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutDonationSchedulesInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutDonationsInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutFormResponsesInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutNonprofitNominationInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutPayrollPayGroupInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutPointOfContactOrganizationInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutRolesInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutVolunteerRewardChangedByInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutVolunteerRewardsInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutVolunteerTimeInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutVolunteerTimeOffSummaryInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutUserNestedInput>;
};

export type BaseUserUpdateWithoutVolunteerTimeOffsInput = {
  Affiliation?: InputMaybe<AffiliationUpdateManyWithoutUserNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutUserNestedInput>;
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutUserNestedInput>;
  DonationSchedules?: InputMaybe<DonationScheduleUpdateManyWithoutUserNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutUserNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutUserNestedInput>;
  NonprofitNomination?: InputMaybe<NonprofitNominationUpdateManyWithoutUserNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUsersNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutBaseUserNestedInput>;
  PointOfContactOrganization?: InputMaybe<OrganizationUpdateOneWithoutPointOfContactNestedInput>;
  Roles?: InputMaybe<RoleUpdateManyWithoutUsersNestedInput>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutUserNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutUserNestedInput>;
  activities?: InputMaybe<ActivityUpdateManyWithoutUserNestedInput>;
  additionalData?: InputMaybe<UserAdditionalDataNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  companyBySignupDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  fullName?: InputMaybe<FullNameNullableUpdateEnvelopeInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizationDepartment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableUpdateEnvelopeInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  slack?: InputMaybe<Scalars['Json']['input']>;
  sso?: InputMaybe<SsoUserNullableUpdateEnvelopeInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  volunteerMinutes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput>;
};

export type BaseUserUpdatedeedsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BaseUserUpdatelocationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BaseUserUpdaterolesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BaseUserUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: BaseUserCreateWithoutOrganizationInput;
  update: BaseUserUpdateWithoutOrganizationInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpsertWithWhereUniqueWithoutPayrollPayGroupInput = {
  create: BaseUserCreateWithoutPayrollPayGroupInput;
  update: BaseUserUpdateWithoutPayrollPayGroupInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpsertWithWhereUniqueWithoutRolesInput = {
  create: BaseUserCreateWithoutRolesInput;
  update: BaseUserUpdateWithoutRolesInput;
  where: BaseUserWhereUniqueInput;
};

export type BaseUserUpsertWithoutActivitiesInput = {
  create: BaseUserCreateWithoutActivitiesInput;
  update: BaseUserUpdateWithoutActivitiesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutAffiliationInput = {
  create: BaseUserCreateWithoutAffiliationInput;
  update: BaseUserUpdateWithoutAffiliationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutAwardedBadgeInput = {
  create: BaseUserCreateWithoutAwardedBadgeInput;
  update: BaseUserUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutChallengeContributionsInput = {
  create: BaseUserCreateWithoutChallengeContributionsInput;
  update: BaseUserUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutDonationSchedulesInput = {
  create: BaseUserCreateWithoutDonationSchedulesInput;
  update: BaseUserUpdateWithoutDonationSchedulesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutDonationsInput = {
  create: BaseUserCreateWithoutDonationsInput;
  update: BaseUserUpdateWithoutDonationsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutFormResponsesInput = {
  create: BaseUserCreateWithoutFormResponsesInput;
  update: BaseUserUpdateWithoutFormResponsesInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutNonprofitNominationInput = {
  create: BaseUserCreateWithoutNonprofitNominationInput;
  update: BaseUserUpdateWithoutNonprofitNominationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutPointOfContactOrganizationInput = {
  create: BaseUserCreateWithoutPointOfContactOrganizationInput;
  update: BaseUserUpdateWithoutPointOfContactOrganizationInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutVolunteerRewardChangedByInput = {
  create: BaseUserCreateWithoutVolunteerRewardChangedByInput;
  update: BaseUserUpdateWithoutVolunteerRewardChangedByInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutVolunteerRewardsInput = {
  create: BaseUserCreateWithoutVolunteerRewardsInput;
  update: BaseUserUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutVolunteerTimeInput = {
  create: BaseUserCreateWithoutVolunteerTimeInput;
  update: BaseUserUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutVolunteerTimeOffSummaryInput = {
  create: BaseUserCreateWithoutVolunteerTimeOffSummaryInput;
  update: BaseUserUpdateWithoutVolunteerTimeOffSummaryInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserUpsertWithoutVolunteerTimeOffsInput = {
  create: BaseUserCreateWithoutVolunteerTimeOffsInput;
  update: BaseUserUpdateWithoutVolunteerTimeOffsInput;
  where?: InputMaybe<BaseUserWhereInput>;
};

export type BaseUserWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  Affiliation?: InputMaybe<AffiliationListRelationFilter>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  DonationSchedules?: InputMaybe<DonationScheduleListRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  NonprofitNomination?: InputMaybe<NonprofitNominationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupNullableRelationFilter>;
  PointOfContactOrganization?: InputMaybe<OrganizationNullableRelationFilter>;
  Roles?: InputMaybe<RoleListRelationFilter>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeListRelationFilter>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCompositeFilter>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipObjectEqualityInput>>>;
  companyBySignupDomain?: InputMaybe<StringNullableFilter>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailObjectEqualityInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  displayCurrency?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureObjectEqualityInput>>>;
  fullName?: InputMaybe<FullNameNullableCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCompositeFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationDepartment?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeObjectEqualityInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCompositeFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantObjectEqualityInput>>>;
  roles?: InputMaybe<StringNullableListFilter>;
  slack?: InputMaybe<JsonNullableFilter>;
  sso?: InputMaybe<SsoUserNullableCompositeFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  volunteerMinutes?: InputMaybe<IntNullableFilter>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryNullableRelationFilter>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
};

export type BaseUserWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  Affiliation?: InputMaybe<AffiliationListRelationFilter>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  DonationSchedules?: InputMaybe<DonationScheduleListRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  NonprofitNomination?: InputMaybe<NonprofitNominationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<BaseUserWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupNullableRelationFilter>;
  PointOfContactOrganization?: InputMaybe<OrganizationNullableRelationFilter>;
  Roles?: InputMaybe<RoleListRelationFilter>;
  VolunteerRewardChangedBy?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeListRelationFilter>;
  activities?: InputMaybe<ActivityListRelationFilter>;
  additionalData?: InputMaybe<UserAdditionalDataNullableCompositeFilter>;
  communities?: InputMaybe<Array<InputMaybe<CommunityMembershipObjectEqualityInput>>>;
  companyBySignupDomain?: InputMaybe<StringNullableFilter>;
  contactEmails?: InputMaybe<Array<InputMaybe<ContactEmailObjectEqualityInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  displayCurrency?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  failedPayPalVerificationAttempts?: InputMaybe<Array<InputMaybe<VerificationFailureObjectEqualityInput>>>;
  fullName?: InputMaybe<FullNameNullableCompositeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  locationObject?: InputMaybe<LimitedLocationObjectNullableCompositeFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organizationDepartment?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pledges?: InputMaybe<Array<InputMaybe<PledgeObjectEqualityInput>>>;
  preferredName?: InputMaybe<PreferredNameNullableCompositeFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  roleGrants?: InputMaybe<Array<InputMaybe<RoleGrantObjectEqualityInput>>>;
  roles?: InputMaybe<StringNullableListFilter>;
  slack?: InputMaybe<JsonNullableFilter>;
  sso?: InputMaybe<SsoUserNullableCompositeFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  volunteerMinutes?: InputMaybe<IntNullableFilter>;
  volunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryNullableRelationFilter>;
  volunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int']['output'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BillingDetailsCreateInput = {
  address?: InputMaybe<AddressCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BillingDetailsNullableCompositeFilter = {
  equals?: InputMaybe<BillingDetailsObjectEqualityInput>;
  is?: InputMaybe<BillingDetailsWhereInput>;
  isNot?: InputMaybe<BillingDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<BillingDetailsCreateInput>;
};

export type BillingDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<BillingDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<BillingDetailsUpsertInput>;
};

export type BillingDetailsObjectEqualityInput = {
  address?: InputMaybe<AddressObjectEqualityInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BillingDetailsOrderByInput = {
  address?: InputMaybe<AddressOrderByInput>;
  email?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
};

export type BillingDetailsUpdateInput = {
  address?: InputMaybe<AddressNullableUpdateEnvelopeInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BillingDetailsUpsertInput = {
  set: BillingDetailsCreateInput;
  update: BillingDetailsUpdateInput;
};

export type BillingDetailsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BillingDetailsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BillingDetailsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BillingDetailsWhereInput>>>;
  address?: InputMaybe<AddressNullableCompositeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

/** @Auth(read: [Admin, Organizer(type: Company, organizationField: company), Employee(companyField: company)]) */
export type BudgetAllocation = {
  __typename?: 'BudgetAllocation';
  Company: Organization;
  budget: Scalars['String']['output'];
  company: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode: Scalars['String']['output'];
  endingAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAmountPerHour?: Maybe<Scalars['Boolean']['output']>;
  limitPerUser?: Maybe<Scalars['Int']['output']>;
  limitToCurrency?: Maybe<Scalars['Boolean']['output']>;
  limitTotal?: Maybe<Scalars['Int']['output']>;
  matchedAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  rewardAmount?: Maybe<Scalars['Int']['output']>;
  startingAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: BudgetAllocationType;
};

export type BudgetAllocationAvgAggregateOutputType = {
  __typename?: 'BudgetAllocationAvgAggregateOutputType';
  limitPerUser?: Maybe<Scalars['Float']['output']>;
  limitTotal?: Maybe<Scalars['Float']['output']>;
  rewardAmount?: Maybe<Scalars['Float']['output']>;
};

export type BudgetAllocationAvgOrderByAggregateInput = {
  limitPerUser?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
};

export type BudgetAllocationCountAggregateOutputType = {
  __typename?: 'BudgetAllocationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  budget: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAmountPerHour: Scalars['Int']['output'];
  limitPerUser: Scalars['Int']['output'];
  limitToCurrency: Scalars['Int']['output'];
  limitTotal: Scalars['Int']['output'];
  matchedAmountCurrencies: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  rewardAmount: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type BudgetAllocationCountOrderByAggregateInput = {
  budget?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmountPerHour?: InputMaybe<SortOrder>;
  limitPerUser?: InputMaybe<SortOrder>;
  limitToCurrency?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type BudgetAllocationCreateInput = {
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardBudgetAllocationInput;
  budget: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationCreateManyCompanyInput = {
  budget: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationCreateManyCompanyInputEnvelope = {
  data: BudgetAllocationCreateManyCompanyInput;
};

export type BudgetAllocationCreateManyInput = {
  budget: Scalars['String']['input'];
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<BudgetAllocationCreateManyCompanyInputEnvelope>;
};

export type BudgetAllocationCreateOrConnectWithoutCompanyInput = {
  create: BudgetAllocationCreateWithoutCompanyInput;
  where: BudgetAllocationWhereUniqueInput;
};

export type BudgetAllocationCreateWithoutCompanyInput = {
  budget: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationListRelationFilter = {
  every?: InputMaybe<BudgetAllocationWhereInput>;
  none?: InputMaybe<BudgetAllocationWhereInput>;
  some?: InputMaybe<BudgetAllocationWhereInput>;
};

export type BudgetAllocationMaxAggregateOutputType = {
  __typename?: 'BudgetAllocationMaxAggregateOutputType';
  budget?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAmountPerHour?: Maybe<Scalars['Boolean']['output']>;
  limitPerUser?: Maybe<Scalars['Int']['output']>;
  limitToCurrency?: Maybe<Scalars['Boolean']['output']>;
  limitTotal?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  rewardAmount?: Maybe<Scalars['Int']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BudgetAllocationType>;
};

export type BudgetAllocationMaxOrderByAggregateInput = {
  budget?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmountPerHour?: InputMaybe<SortOrder>;
  limitPerUser?: InputMaybe<SortOrder>;
  limitToCurrency?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type BudgetAllocationMinAggregateOutputType = {
  __typename?: 'BudgetAllocationMinAggregateOutputType';
  budget?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAmountPerHour?: Maybe<Scalars['Boolean']['output']>;
  limitPerUser?: Maybe<Scalars['Int']['output']>;
  limitToCurrency?: Maybe<Scalars['Boolean']['output']>;
  limitTotal?: Maybe<Scalars['Int']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  rewardAmount?: Maybe<Scalars['Int']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BudgetAllocationType>;
};

export type BudgetAllocationMinOrderByAggregateInput = {
  budget?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmountPerHour?: InputMaybe<SortOrder>;
  limitPerUser?: InputMaybe<SortOrder>;
  limitToCurrency?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type BudgetAllocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BudgetAllocationOrderByWithAggregationInput = {
  _avg?: InputMaybe<BudgetAllocationAvgOrderByAggregateInput>;
  _count?: InputMaybe<BudgetAllocationCountOrderByAggregateInput>;
  _max?: InputMaybe<BudgetAllocationMaxOrderByAggregateInput>;
  _min?: InputMaybe<BudgetAllocationMinOrderByAggregateInput>;
  _sum?: InputMaybe<BudgetAllocationSumOrderByAggregateInput>;
  budget?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmountPerHour?: InputMaybe<SortOrder>;
  limitPerUser?: InputMaybe<SortOrder>;
  limitToCurrency?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type BudgetAllocationOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  budget?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmountPerHour?: InputMaybe<SortOrder>;
  limitPerUser?: InputMaybe<SortOrder>;
  limitToCurrency?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum BudgetAllocationScalarFieldEnum {
  Budget = 'budget',
  Company = 'company',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  EndingAt = 'endingAt',
  Id = 'id',
  IsAmountPerHour = 'isAmountPerHour',
  LimitPerUser = 'limitPerUser',
  LimitToCurrency = 'limitToCurrency',
  LimitTotal = 'limitTotal',
  MatchedAmountCurrencies = 'matchedAmountCurrencies',
  ModifiedAt = 'modifiedAt',
  RewardAmount = 'rewardAmount',
  StartingAt = 'startingAt',
  Title = 'title',
  Type = 'type'
}

export type BudgetAllocationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereInput>>>;
  budget?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  endingAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isAmountPerHour?: InputMaybe<BoolNullableFilter>;
  limitPerUser?: InputMaybe<IntNullableFilter>;
  limitToCurrency?: InputMaybe<BoolNullableFilter>;
  limitTotal?: InputMaybe<IntNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  rewardAmount?: InputMaybe<IntNullableFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumBudgetAllocationTypeFilter>;
};

export type BudgetAllocationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereWithAggregatesInput>>>;
  budget?: InputMaybe<StringWithAggregatesFilter>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isAmountPerHour?: InputMaybe<BoolNullableWithAggregatesFilter>;
  limitPerUser?: InputMaybe<IntNullableWithAggregatesFilter>;
  limitToCurrency?: InputMaybe<BoolNullableWithAggregatesFilter>;
  limitTotal?: InputMaybe<IntNullableWithAggregatesFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  rewardAmount?: InputMaybe<IntNullableWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumBudgetAllocationTypeWithAggregatesFilter>;
};

export type BudgetAllocationSumAggregateOutputType = {
  __typename?: 'BudgetAllocationSumAggregateOutputType';
  limitPerUser?: Maybe<Scalars['Int']['output']>;
  limitTotal?: Maybe<Scalars['Int']['output']>;
  rewardAmount?: Maybe<Scalars['Int']['output']>;
};

export type BudgetAllocationSumOrderByAggregateInput = {
  limitPerUser?: InputMaybe<SortOrder>;
  limitTotal?: InputMaybe<SortOrder>;
  rewardAmount?: InputMaybe<SortOrder>;
};

export enum BudgetAllocationType {
  CorporateDonationBudgetAllocation = 'CorporateDonationBudgetAllocation',
  VolunteerRewardBudgetAllocation = 'VolunteerRewardBudgetAllocation'
}

export type BudgetAllocationUncheckedCreateInput = {
  budget: Scalars['String']['input'];
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<BudgetAllocationCreateManyCompanyInputEnvelope>;
};

export type BudgetAllocationUncheckedCreateWithoutCompanyInput = {
  budget: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  endingAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerUser?: InputMaybe<Scalars['Int']['input']>;
  limitToCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  limitTotal?: InputMaybe<Scalars['Int']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rewardAmount?: InputMaybe<Scalars['Int']['input']>;
  startingAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: BudgetAllocationType;
};

export type BudgetAllocationUncheckedUpdateInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUncheckedUpdateManyInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUncheckedUpdateManyWithoutCompanyInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<BudgetAllocationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BudgetAllocationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BudgetAllocationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BudgetAllocationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type BudgetAllocationUncheckedUpdateWithoutCompanyInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardBudgetAllocationNestedInput>;
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUpdateManyMutationInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUpdateManyWithWhereWithoutCompanyInput = {
  data: BudgetAllocationUpdateManyMutationInput;
  where: BudgetAllocationScalarWhereInput;
};

export type BudgetAllocationUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<BudgetAllocationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<BudgetAllocationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BudgetAllocationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BudgetAllocationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BudgetAllocationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BudgetAllocationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type BudgetAllocationUpdateWithWhereUniqueWithoutCompanyInput = {
  data: BudgetAllocationUpdateWithoutCompanyInput;
  where: BudgetAllocationWhereUniqueInput;
};

export type BudgetAllocationUpdateWithoutCompanyInput = {
  budget?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isAmountPerHour?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitPerUser?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitToCurrency?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  limitTotal?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rewardAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBudgetAllocationTypeFieldUpdateOperationsInput>;
};

export type BudgetAllocationUpsertWithWhereUniqueWithoutCompanyInput = {
  create: BudgetAllocationCreateWithoutCompanyInput;
  update: BudgetAllocationUpdateWithoutCompanyInput;
  where: BudgetAllocationWhereUniqueInput;
};

export type BudgetAllocationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  budget?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  endingAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isAmountPerHour?: InputMaybe<BoolNullableFilter>;
  limitPerUser?: InputMaybe<IntNullableFilter>;
  limitToCurrency?: InputMaybe<BoolNullableFilter>;
  limitTotal?: InputMaybe<IntNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  rewardAmount?: InputMaybe<IntNullableFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumBudgetAllocationTypeFilter>;
};

export type BudgetAllocationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BudgetAllocationWhereInput>>>;
  budget?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  endingAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAmountPerHour?: InputMaybe<BoolNullableFilter>;
  limitPerUser?: InputMaybe<IntNullableFilter>;
  limitToCurrency?: InputMaybe<BoolNullableFilter>;
  limitTotal?: InputMaybe<IntNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  rewardAmount?: InputMaybe<IntNullableFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumBudgetAllocationTypeFilter>;
};

export type Campaign = {
  __typename?: 'Campaign';
  Organization: Organization;
  _count: CampaignCountOutputType;
  allowOneTimePledge?: Maybe<Scalars['Boolean']['output']>;
  autoTagDonations?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  excludedPayrollRuns: Array<Scalars['String']['output']>;
  hideActivityFeed?: Maybe<Scalars['Boolean']['output']>;
  hideProgressBar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isPledge: Scalars['Boolean']['output'];
  organization: Scalars['String']['output'];
  pledgedDonationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  pledgedDonationStartingAt?: Maybe<Scalars['DateTime']['output']>;
  projectStats: Scalars['Boolean']['output'];
  projectedStats?: Maybe<CampaignProjectedStats>;
  showLinkToDonateSearch?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  videoLink?: Maybe<Scalars['String']['output']>;
};

export type CampaignCountAggregateOutputType = {
  __typename?: 'CampaignCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  actionIds: Scalars['Int']['output'];
  activityIds: Scalars['Int']['output'];
  allowOneTimePledge: Scalars['Int']['output'];
  autoTagDonations: Scalars['Int']['output'];
  backgroundImage: Scalars['Int']['output'];
  companySubsidiaryAccess: Scalars['Int']['output'];
  editors: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  excludedPayrollRuns: Scalars['Int']['output'];
  hideActivityFeed: Scalars['Int']['output'];
  hideProgressBar: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isPledge: Scalars['Int']['output'];
  optedInCompanyIds: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  pledgedDonationEndingAt: Scalars['Int']['output'];
  pledgedDonationStartingAt: Scalars['Int']['output'];
  projectStats: Scalars['Int']['output'];
  showLinkToDonateSearch: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  submitter: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  videoLink: Scalars['Int']['output'];
};

export type CampaignCountOrderByAggregateInput = {
  actionIds?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  allowOneTimePledge?: InputMaybe<SortOrder>;
  autoTagDonations?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  excludedPayrollRuns?: InputMaybe<SortOrder>;
  hideActivityFeed?: InputMaybe<SortOrder>;
  hideProgressBar?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPledge?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  pledgedDonationEndingAt?: InputMaybe<SortOrder>;
  pledgedDonationStartingAt?: InputMaybe<SortOrder>;
  projectStats?: InputMaybe<SortOrder>;
  showLinkToDonateSearch?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  videoLink?: InputMaybe<SortOrder>;
};

export type CampaignCountOutputType = {
  __typename?: 'CampaignCountOutputType';
  Actions: Scalars['Int']['output'];
  Activities: Scalars['Int']['output'];
  DonationSchedule: Scalars['Int']['output'];
  OptedInCompanies: Scalars['Int']['output'];
};

export type CampaignCreateInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInCampaignsInput>;
  Organization: OrganizationCreateNestedOneWithoutCampaignOrganizationsInput;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateManyInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateManyOrganizationInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateManyOrganizationInputEnvelope = {
  data: CampaignCreateManyOrganizationInput;
};

export type CampaignCreateNestedManyWithoutActionsInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutActionsInput>>>;
};

export type CampaignCreateNestedManyWithoutOptedInCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOptedInCompaniesInput>>>;
};

export type CampaignCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<CampaignCreateManyOrganizationInputEnvelope>;
};

export type CampaignCreateNestedOneWithoutActivitiesInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<CampaignCreateWithoutActivitiesInput>;
};

export type CampaignCreateNestedOneWithoutDonationScheduleInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutDonationScheduleInput>;
  create?: InputMaybe<CampaignCreateWithoutDonationScheduleInput>;
};

export type CampaignCreateOrConnectWithoutActionsInput = {
  create: CampaignCreateWithoutActionsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutActivitiesInput = {
  create: CampaignCreateWithoutActivitiesInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutDonationScheduleInput = {
  create: CampaignCreateWithoutDonationScheduleInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutOptedInCompaniesInput = {
  create: CampaignCreateWithoutOptedInCompaniesInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateOrConnectWithoutOrganizationInput = {
  create: CampaignCreateWithoutOrganizationInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignCreateWithoutActionsInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInCampaignsInput>;
  Organization: OrganizationCreateNestedOneWithoutCampaignOrganizationsInput;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateWithoutActivitiesInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCampaignsInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInCampaignsInput>;
  Organization: OrganizationCreateNestedOneWithoutCampaignOrganizationsInput;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateWithoutDonationScheduleInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInCampaignsInput>;
  Organization: OrganizationCreateNestedOneWithoutCampaignOrganizationsInput;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateWithoutOptedInCompaniesInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedManyWithoutCampaignInput>;
  Organization: OrganizationCreateNestedOneWithoutCampaignOrganizationsInput;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateWithoutOrganizationInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInCampaignsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignCreateactionIdsInput = {
  set: Scalars['String']['input'];
};

export type CampaignCreateactivityIdsInput = {
  set: Scalars['String']['input'];
};

export type CampaignCreateeditorsInput = {
  set: Scalars['String']['input'];
};

export type CampaignCreateexcludedPayrollRunsInput = {
  set: Scalars['String']['input'];
};

export type CampaignCreateoptedInCompanyIdsInput = {
  set: Scalars['String']['input'];
};

export type CampaignListRelationFilter = {
  every?: InputMaybe<CampaignWhereInput>;
  none?: InputMaybe<CampaignWhereInput>;
  some?: InputMaybe<CampaignWhereInput>;
};

export type CampaignMaxAggregateOutputType = {
  __typename?: 'CampaignMaxAggregateOutputType';
  allowOneTimePledge?: Maybe<Scalars['Boolean']['output']>;
  autoTagDonations?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  companySubsidiaryAccess?: Maybe<Scalars['Boolean']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  hideActivityFeed?: Maybe<Scalars['Boolean']['output']>;
  hideProgressBar?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPledge?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  pledgedDonationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  pledgedDonationStartingAt?: Maybe<Scalars['DateTime']['output']>;
  projectStats?: Maybe<Scalars['Boolean']['output']>;
  showLinkToDonateSearch?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  submitter?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoLink?: Maybe<Scalars['String']['output']>;
};

export type CampaignMaxOrderByAggregateInput = {
  allowOneTimePledge?: InputMaybe<SortOrder>;
  autoTagDonations?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  hideActivityFeed?: InputMaybe<SortOrder>;
  hideProgressBar?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPledge?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  pledgedDonationEndingAt?: InputMaybe<SortOrder>;
  pledgedDonationStartingAt?: InputMaybe<SortOrder>;
  projectStats?: InputMaybe<SortOrder>;
  showLinkToDonateSearch?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  videoLink?: InputMaybe<SortOrder>;
};

export type CampaignMinAggregateOutputType = {
  __typename?: 'CampaignMinAggregateOutputType';
  allowOneTimePledge?: Maybe<Scalars['Boolean']['output']>;
  autoTagDonations?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  companySubsidiaryAccess?: Maybe<Scalars['Boolean']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  hideActivityFeed?: Maybe<Scalars['Boolean']['output']>;
  hideProgressBar?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPledge?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  pledgedDonationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  pledgedDonationStartingAt?: Maybe<Scalars['DateTime']['output']>;
  projectStats?: Maybe<Scalars['Boolean']['output']>;
  showLinkToDonateSearch?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  submitter?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoLink?: Maybe<Scalars['String']['output']>;
};

export type CampaignMinOrderByAggregateInput = {
  allowOneTimePledge?: InputMaybe<SortOrder>;
  autoTagDonations?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  hideActivityFeed?: InputMaybe<SortOrder>;
  hideProgressBar?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPledge?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  pledgedDonationEndingAt?: InputMaybe<SortOrder>;
  pledgedDonationStartingAt?: InputMaybe<SortOrder>;
  projectStats?: InputMaybe<SortOrder>;
  showLinkToDonateSearch?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  videoLink?: InputMaybe<SortOrder>;
};

export type CampaignNullableRelationFilter = {
  is?: InputMaybe<CampaignWhereInput>;
  isNot?: InputMaybe<CampaignWhereInput>;
};

export type CampaignOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CampaignOrderByWithAggregationInput = {
  _count?: InputMaybe<CampaignCountOrderByAggregateInput>;
  _max?: InputMaybe<CampaignMaxOrderByAggregateInput>;
  _min?: InputMaybe<CampaignMinOrderByAggregateInput>;
  actionIds?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  allowOneTimePledge?: InputMaybe<SortOrder>;
  autoTagDonations?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  excludedPayrollRuns?: InputMaybe<SortOrder>;
  hideActivityFeed?: InputMaybe<SortOrder>;
  hideProgressBar?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPledge?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  pledgedDonationEndingAt?: InputMaybe<SortOrder>;
  pledgedDonationStartingAt?: InputMaybe<SortOrder>;
  projectStats?: InputMaybe<SortOrder>;
  showLinkToDonateSearch?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  videoLink?: InputMaybe<SortOrder>;
};

export type CampaignOrderByWithRelationInput = {
  Actions?: InputMaybe<ActionOrderByRelationAggregateInput>;
  Activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  DonationSchedule?: InputMaybe<DonationScheduleOrderByRelationAggregateInput>;
  OptedInCompanies?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  actionIds?: InputMaybe<SortOrder>;
  activityIds?: InputMaybe<SortOrder>;
  allowOneTimePledge?: InputMaybe<SortOrder>;
  autoTagDonations?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  excludedPayrollRuns?: InputMaybe<SortOrder>;
  hideActivityFeed?: InputMaybe<SortOrder>;
  hideProgressBar?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPledge?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  pledgedDonationEndingAt?: InputMaybe<SortOrder>;
  pledgedDonationStartingAt?: InputMaybe<SortOrder>;
  projectStats?: InputMaybe<SortOrder>;
  projectedStats?: InputMaybe<CampaignProjectedStatsOrderByInput>;
  showLinkToDonateSearch?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  videoLink?: InputMaybe<SortOrder>;
};

export type CampaignProjectedStats = {
  __typename?: 'CampaignProjectedStats';
  actionStats?: Maybe<ActionStats>;
  donatedByUsersAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  employeesAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  matchedAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  oneTimeDonationsTotalAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  otherAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  projectedAt?: Maybe<Scalars['DateTime']['output']>;
  projectedTotalAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  supportersCount?: Maybe<Scalars['Int']['output']>;
  totalDonationsCount?: Maybe<Scalars['Int']['output']>;
  totalRaisedCurrencies?: Maybe<Scalars['Json']['output']>;
};

export type CampaignProjectedStatsCreateInput = {
  actionStats?: InputMaybe<ActionStatsCreateInput>;
  donatedByUsersAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  employeesAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  oneTimeDonationsTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  otherAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  projectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  supportersCount?: InputMaybe<Scalars['Int']['input']>;
  totalDonationsCount?: InputMaybe<Scalars['Int']['input']>;
  totalRaisedCurrencies?: InputMaybe<Scalars['Json']['input']>;
};

export type CampaignProjectedStatsNullableCompositeFilter = {
  equals?: InputMaybe<CampaignProjectedStatsObjectEqualityInput>;
  is?: InputMaybe<CampaignProjectedStatsWhereInput>;
  isNot?: InputMaybe<CampaignProjectedStatsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignProjectedStatsNullableCreateEnvelopeInput = {
  set?: InputMaybe<CampaignProjectedStatsCreateInput>;
};

export type CampaignProjectedStatsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CampaignProjectedStatsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CampaignProjectedStatsUpsertInput>;
};

export type CampaignProjectedStatsObjectEqualityInput = {
  actionStats?: InputMaybe<ActionStatsObjectEqualityInput>;
  donatedByUsersAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  employeesAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  oneTimeDonationsTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  otherAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  projectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  supportersCount?: InputMaybe<Scalars['Int']['input']>;
  totalDonationsCount?: InputMaybe<Scalars['Int']['input']>;
  totalRaisedCurrencies?: InputMaybe<Scalars['Json']['input']>;
};

export type CampaignProjectedStatsOrderByInput = {
  actionStats?: InputMaybe<ActionStatsOrderByInput>;
  donatedByUsersAmountCurrencies?: InputMaybe<SortOrder>;
  employeesAmountCurrencies?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  oneTimeDonationsTotalAmountCurrencies?: InputMaybe<SortOrder>;
  otherAmountCurrencies?: InputMaybe<SortOrder>;
  projectedAt?: InputMaybe<SortOrder>;
  projectedTotalAmountCurrencies?: InputMaybe<SortOrder>;
  supportersCount?: InputMaybe<SortOrder>;
  totalDonationsCount?: InputMaybe<SortOrder>;
  totalRaisedCurrencies?: InputMaybe<SortOrder>;
};

export type CampaignProjectedStatsUpdateInput = {
  actionStats?: InputMaybe<ActionStatsNullableUpdateEnvelopeInput>;
  donatedByUsersAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  employeesAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  oneTimeDonationsTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  otherAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  projectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  supportersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalDonationsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalRaisedCurrencies?: InputMaybe<Scalars['Json']['input']>;
};

export type CampaignProjectedStatsUpsertInput = {
  set: CampaignProjectedStatsCreateInput;
  update: CampaignProjectedStatsUpdateInput;
};

export type CampaignProjectedStatsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CampaignProjectedStatsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CampaignProjectedStatsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignProjectedStatsWhereInput>>>;
  actionStats?: InputMaybe<ActionStatsNullableCompositeFilter>;
  donatedByUsersAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  employeesAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  oneTimeDonationsTotalAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  otherAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  projectedAt?: InputMaybe<DateTimeNullableFilter>;
  projectedTotalAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  supportersCount?: InputMaybe<IntNullableFilter>;
  totalDonationsCount?: InputMaybe<IntNullableFilter>;
  totalRaisedCurrencies?: InputMaybe<JsonNullableFilter>;
};

export enum CampaignScalarFieldEnum {
  ActionIds = 'actionIds',
  ActivityIds = 'activityIds',
  AllowOneTimePledge = 'allowOneTimePledge',
  AutoTagDonations = 'autoTagDonations',
  BackgroundImage = 'backgroundImage',
  CompanySubsidiaryAccess = 'companySubsidiaryAccess',
  Editors = 'editors',
  EndingAt = 'endingAt',
  ExcludedPayrollRuns = 'excludedPayrollRuns',
  HideActivityFeed = 'hideActivityFeed',
  HideProgressBar = 'hideProgressBar',
  Id = 'id',
  IsPledge = 'isPledge',
  OptedInCompanyIds = 'optedInCompanyIds',
  Organization = 'organization',
  PledgedDonationEndingAt = 'pledgedDonationEndingAt',
  PledgedDonationStartingAt = 'pledgedDonationStartingAt',
  ProjectStats = 'projectStats',
  ShowLinkToDonateSearch = 'showLinkToDonateSearch',
  StartingAt = 'startingAt',
  Submitter = 'submitter',
  Title = 'title',
  VideoLink = 'videoLink'
}

export type CampaignScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  actionIds?: InputMaybe<StringNullableListFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  allowOneTimePledge?: InputMaybe<BoolNullableFilter>;
  autoTagDonations?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  excludedPayrollRuns?: InputMaybe<StringNullableListFilter>;
  hideActivityFeed?: InputMaybe<BoolNullableFilter>;
  hideProgressBar?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPledge?: InputMaybe<BoolFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organization?: InputMaybe<StringFilter>;
  pledgedDonationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  pledgedDonationStartingAt?: InputMaybe<DateTimeNullableFilter>;
  projectStats?: InputMaybe<BoolFilter>;
  showLinkToDonateSearch?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  videoLink?: InputMaybe<StringNullableFilter>;
};

export type CampaignScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CampaignScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CampaignScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignScalarWhereWithAggregatesInput>>>;
  actionIds?: InputMaybe<StringNullableListFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  allowOneTimePledge?: InputMaybe<BoolNullableWithAggregatesFilter>;
  autoTagDonations?: InputMaybe<BoolNullableWithAggregatesFilter>;
  backgroundImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableWithAggregatesFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  excludedPayrollRuns?: InputMaybe<StringNullableListFilter>;
  hideActivityFeed?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hideProgressBar?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isPledge?: InputMaybe<BoolWithAggregatesFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organization?: InputMaybe<StringWithAggregatesFilter>;
  pledgedDonationEndingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  pledgedDonationStartingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  projectStats?: InputMaybe<BoolWithAggregatesFilter>;
  showLinkToDonateSearch?: InputMaybe<BoolNullableWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  submitter?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  videoLink?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type CampaignUncheckedCreateInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedCreateNestedManyWithoutActionsInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutActionsInput>>>;
};

export type CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOptedInCompaniesInput>>>;
};

export type CampaignUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<CampaignCreateManyOrganizationInputEnvelope>;
};

export type CampaignUncheckedCreateWithoutActionsInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedCreateWithoutActivitiesInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCampaignsInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedCreateWithoutDonationScheduleInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedCreateWithoutOptedInCompaniesInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization: Scalars['String']['input'];
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedCreateWithoutOrganizationInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCampaignsInput>;
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutCampaignInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<Scalars['Boolean']['input']>;
  autoTagDonations?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<Scalars['Boolean']['input']>;
  hideProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<Scalars['Boolean']['input']>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pledgedDonationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  pledgedDonationStartingAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectStats?: InputMaybe<Scalars['Boolean']['input']>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCreateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<Scalars['Boolean']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignUncheckedUpdateInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateManyInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateManyWithoutActionsInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateManyWithoutActionsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutActionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutActionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutActionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutActionsInput>>>;
};

export type CampaignUncheckedUpdateManyWithoutOptedInCompaniesInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOptedInCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutOptedInCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutOptedInCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutOptedInCompaniesInput>>>;
};

export type CampaignUncheckedUpdateManyWithoutOrganizationInput = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<CampaignCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type CampaignUncheckedUpdateWithoutActionsInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateWithoutActivitiesInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCampaignsNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateWithoutDonationScheduleInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateWithoutOptedInCompaniesInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUncheckedUpdateWithoutOrganizationInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput>;
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInCampaignsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateManyMutationInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateManyWithWhereWithoutActionsInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithWhereWithoutOptedInCompaniesInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithWhereWithoutOrganizationInput = {
  data: CampaignUpdateManyMutationInput;
  where: CampaignScalarWhereInput;
};

export type CampaignUpdateManyWithoutActionsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutActionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutActionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutActionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutActionsInput>>>;
};

export type CampaignUpdateManyWithoutOptedInCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOptedInCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutOptedInCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutOptedInCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutOptedInCompaniesInput>>>;
};

export type CampaignUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CampaignCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CampaignCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<CampaignCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CampaignScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CampaignWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CampaignUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CampaignUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CampaignUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type CampaignUpdateOneWithoutActivitiesNestedInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<CampaignCreateWithoutActivitiesInput>;
  delete?: InputMaybe<CampaignWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<CampaignUpdateToOneWithWhereWithoutActivitiesInput>;
  upsert?: InputMaybe<CampaignUpsertWithoutActivitiesInput>;
};

export type CampaignUpdateOneWithoutDonationScheduleNestedInput = {
  connect?: InputMaybe<CampaignWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CampaignCreateOrConnectWithoutDonationScheduleInput>;
  create?: InputMaybe<CampaignCreateWithoutDonationScheduleInput>;
  delete?: InputMaybe<CampaignWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<CampaignUpdateToOneWithWhereWithoutDonationScheduleInput>;
  upsert?: InputMaybe<CampaignUpsertWithoutDonationScheduleInput>;
};

export type CampaignUpdateToOneWithWhereWithoutActivitiesInput = {
  data: CampaignUpdateWithoutActivitiesInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignUpdateToOneWithWhereWithoutDonationScheduleInput = {
  data: CampaignUpdateWithoutDonationScheduleInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignUpdateWithWhereUniqueWithoutActionsInput = {
  data: CampaignUpdateWithoutActionsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithWhereUniqueWithoutOptedInCompaniesInput = {
  data: CampaignUpdateWithoutOptedInCompaniesInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CampaignUpdateWithoutOrganizationInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpdateWithoutActionsInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInCampaignsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateWithoutActivitiesInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCampaignsNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInCampaignsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateWithoutDonationScheduleInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInCampaignsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateWithoutOptedInCompaniesInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateManyWithoutCampaignNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateWithoutOrganizationInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCampaignsNestedInput>;
  Activities?: InputMaybe<ActivityUpdateManyWithoutCampaignNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateManyWithoutCampaignNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInCampaignsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowOneTimePledge?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoTagDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  excludedPayrollRuns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideActivityFeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideProgressBar?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPledge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pledgedDonationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pledgedDonationStartingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectStats?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableUpdateEnvelopeInput>;
  showLinkToDonateSearch?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  videoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CampaignUpdateactionIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignUpdateactivityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignUpdateeditorsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignUpdateexcludedPayrollRunsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignUpdateoptedInCompanyIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignUpsertWithWhereUniqueWithoutActionsInput = {
  create: CampaignCreateWithoutActionsInput;
  update: CampaignUpdateWithoutActionsInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithWhereUniqueWithoutOptedInCompaniesInput = {
  create: CampaignCreateWithoutOptedInCompaniesInput;
  update: CampaignUpdateWithoutOptedInCompaniesInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CampaignCreateWithoutOrganizationInput;
  update: CampaignUpdateWithoutOrganizationInput;
  where: CampaignWhereUniqueInput;
};

export type CampaignUpsertWithoutActivitiesInput = {
  create: CampaignCreateWithoutActivitiesInput;
  update: CampaignUpdateWithoutActivitiesInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignUpsertWithoutDonationScheduleInput = {
  create: CampaignCreateWithoutDonationScheduleInput;
  update: CampaignUpdateWithoutDonationScheduleInput;
  where?: InputMaybe<CampaignWhereInput>;
};

export type CampaignWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  DonationSchedule?: InputMaybe<DonationScheduleListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  OptedInCompanies?: InputMaybe<OrganizationListRelationFilter>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  actionIds?: InputMaybe<StringNullableListFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  allowOneTimePledge?: InputMaybe<BoolNullableFilter>;
  autoTagDonations?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  excludedPayrollRuns?: InputMaybe<StringNullableListFilter>;
  hideActivityFeed?: InputMaybe<BoolNullableFilter>;
  hideProgressBar?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPledge?: InputMaybe<BoolFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organization?: InputMaybe<StringFilter>;
  pledgedDonationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  pledgedDonationStartingAt?: InputMaybe<DateTimeNullableFilter>;
  projectStats?: InputMaybe<BoolFilter>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCompositeFilter>;
  showLinkToDonateSearch?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  videoLink?: InputMaybe<StringNullableFilter>;
};

export type CampaignWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  DonationSchedule?: InputMaybe<DonationScheduleListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignWhereInput>>>;
  OptedInCompanies?: InputMaybe<OrganizationListRelationFilter>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  actionIds?: InputMaybe<StringNullableListFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  allowOneTimePledge?: InputMaybe<BoolNullableFilter>;
  autoTagDonations?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  excludedPayrollRuns?: InputMaybe<StringNullableListFilter>;
  hideActivityFeed?: InputMaybe<BoolNullableFilter>;
  hideProgressBar?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPledge?: InputMaybe<BoolFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organization?: InputMaybe<StringFilter>;
  pledgedDonationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  pledgedDonationStartingAt?: InputMaybe<DateTimeNullableFilter>;
  projectStats?: InputMaybe<BoolFilter>;
  projectedStats?: InputMaybe<CampaignProjectedStatsNullableCompositeFilter>;
  showLinkToDonateSearch?: InputMaybe<BoolNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  videoLink?: InputMaybe<StringNullableFilter>;
};

export type Cause = {
  __typename?: 'Cause';
  _count: CauseCountOutputType;
  banner?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  gradient?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  individualsOnly?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  type: CauseType;
};

export type CauseAvgAggregateOutputType = {
  __typename?: 'CauseAvgAggregateOutputType';
  number?: Maybe<Scalars['Float']['output']>;
  sorting?: Maybe<Scalars['Float']['output']>;
};

export type CauseAvgOrderByAggregateInput = {
  number?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
};

export type CauseCountAggregateOutputType = {
  __typename?: 'CauseCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  actionTemplates: Scalars['Int']['output'];
  actions: Scalars['Int']['output'];
  badgeId: Scalars['Int']['output'];
  banner: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  color: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  gradient: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  individualsOnly: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  picture: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  sorting: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  volunteerTimes: Scalars['Int']['output'];
};

export type CauseCountOrderByAggregateInput = {
  actionTemplates?: InputMaybe<SortOrder>;
  actions?: InputMaybe<SortOrder>;
  badgeId?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  gradient?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  individualsOnly?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerTimes?: InputMaybe<SortOrder>;
};

export type CauseCountOutputType = {
  __typename?: 'CauseCountOutputType';
  ActionTemplates: Scalars['Int']['output'];
  Actions: Scalars['Int']['output'];
  VolunteerTimes: Scalars['Int']['output'];
};

export type CauseCreateInput = {
  ActionTemplates?: InputMaybe<ActionTemplateCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCausesInput>;
  Badge?: InputMaybe<BadgeCreateNestedOneWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutExternalNonprofitCausesInput>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
};

export type CauseCreateManyBadgeInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseCreateManyBadgeInputEnvelope = {
  data: CauseCreateManyBadgeInput;
};

export type CauseCreateManyInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseCreateNestedManyWithoutActionTemplatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionTemplatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionTemplatesInput>>>;
};

export type CauseCreateNestedManyWithoutActionsInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionsInput>>>;
};

export type CauseCreateNestedManyWithoutBadgeInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<CauseCreateManyBadgeInputEnvelope>;
};

export type CauseCreateNestedManyWithoutVolunteerTimesInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutVolunteerTimesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutVolunteerTimesInput>>>;
};

export type CauseCreateOrConnectWithoutActionTemplatesInput = {
  create: CauseCreateWithoutActionTemplatesInput;
  where: CauseWhereUniqueInput;
};

export type CauseCreateOrConnectWithoutActionsInput = {
  create: CauseCreateWithoutActionsInput;
  where: CauseWhereUniqueInput;
};

export type CauseCreateOrConnectWithoutBadgeInput = {
  create: CauseCreateWithoutBadgeInput;
  where: CauseWhereUniqueInput;
};

export type CauseCreateOrConnectWithoutVolunteerTimesInput = {
  create: CauseCreateWithoutVolunteerTimesInput;
  where: CauseWhereUniqueInput;
};

export type CauseCreateWithoutActionTemplatesInput = {
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCausesInput>;
  Badge?: InputMaybe<BadgeCreateNestedOneWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutExternalNonprofitCausesInput>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
};

export type CauseCreateWithoutActionsInput = {
  ActionTemplates?: InputMaybe<ActionTemplateCreateNestedManyWithoutCausesInput>;
  Badge?: InputMaybe<BadgeCreateNestedOneWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutExternalNonprofitCausesInput>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
};

export type CauseCreateWithoutBadgeInput = {
  ActionTemplates?: InputMaybe<ActionTemplateCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutExternalNonprofitCausesInput>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
};

export type CauseCreateWithoutVolunteerTimesInput = {
  ActionTemplates?: InputMaybe<ActionTemplateCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutCausesInput>;
  Badge?: InputMaybe<BadgeCreateNestedOneWithoutCausesInput>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
};

export type CauseCreateactionTemplatesInput = {
  set: Scalars['String']['input'];
};

export type CauseCreateactionsInput = {
  set: Scalars['String']['input'];
};

export type CauseCreatevolunteerTimesInput = {
  set: Scalars['String']['input'];
};

export type CauseFilter = {
  __typename?: 'CauseFilter';
  isExclude: Scalars['Boolean']['output'];
  list: Array<Scalars['String']['output']>;
};

export type CauseFilterCreateInput = {
  isExclude: Scalars['Boolean']['input'];
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseFilterCreatelistInput = {
  set: Scalars['String']['input'];
};

export type CauseFilterNullableCompositeFilter = {
  equals?: InputMaybe<CauseFilterObjectEqualityInput>;
  is?: InputMaybe<CauseFilterWhereInput>;
  isNot?: InputMaybe<CauseFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CauseFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CauseFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CauseFilterUpsertInput>;
};

export type CauseFilterObjectEqualityInput = {
  isExclude: Scalars['Boolean']['input'];
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseFilterOrderByInput = {
  isExclude?: InputMaybe<SortOrder>;
  list?: InputMaybe<SortOrder>;
};

export type CauseFilterUpdateInput = {
  isExclude?: InputMaybe<BoolFieldUpdateOperationsInput>;
  list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseFilterUpdatelistInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseFilterUpsertInput = {
  set: CauseFilterCreateInput;
  update: CauseFilterUpdateInput;
};

export type CauseFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CauseFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CauseFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CauseFilterWhereInput>>>;
  isExclude?: InputMaybe<BoolFilter>;
  list?: InputMaybe<StringNullableListFilter>;
};

export type CauseListRelationFilter = {
  every?: InputMaybe<CauseWhereInput>;
  none?: InputMaybe<CauseWhereInput>;
  some?: InputMaybe<CauseWhereInput>;
};

export type CauseMaxAggregateOutputType = {
  __typename?: 'CauseMaxAggregateOutputType';
  badgeId?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradient?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  individualsOnly?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CauseType>;
};

export type CauseMaxOrderByAggregateInput = {
  badgeId?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  gradient?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  individualsOnly?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CauseMinAggregateOutputType = {
  __typename?: 'CauseMinAggregateOutputType';
  badgeId?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradient?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  individualsOnly?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CauseType>;
};

export type CauseMinOrderByAggregateInput = {
  badgeId?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  gradient?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  individualsOnly?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CauseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CauseOrderByWithAggregationInput = {
  _avg?: InputMaybe<CauseAvgOrderByAggregateInput>;
  _count?: InputMaybe<CauseCountOrderByAggregateInput>;
  _max?: InputMaybe<CauseMaxOrderByAggregateInput>;
  _min?: InputMaybe<CauseMinOrderByAggregateInput>;
  _sum?: InputMaybe<CauseSumOrderByAggregateInput>;
  actionTemplates?: InputMaybe<SortOrder>;
  actions?: InputMaybe<SortOrder>;
  badgeId?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  gradient?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  individualsOnly?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerTimes?: InputMaybe<SortOrder>;
};

export type CauseOrderByWithRelationInput = {
  ActionTemplates?: InputMaybe<ActionTemplateOrderByRelationAggregateInput>;
  Actions?: InputMaybe<ActionOrderByRelationAggregateInput>;
  Badge?: InputMaybe<BadgeOrderByWithRelationInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeOrderByRelationAggregateInput>;
  actionTemplates?: InputMaybe<SortOrder>;
  actions?: InputMaybe<SortOrder>;
  badgeId?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  gradient?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  individualsOnly?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  volunteerTimes?: InputMaybe<SortOrder>;
};

export enum CauseScalarFieldEnum {
  ActionTemplates = 'actionTemplates',
  Actions = 'actions',
  BadgeId = 'badgeId',
  Banner = 'banner',
  Code = 'code',
  Color = 'color',
  Description = 'description',
  Gradient = 'gradient',
  Id = 'id',
  IndividualsOnly = 'individualsOnly',
  Name = 'name',
  Number = 'number',
  Organization = 'organization',
  Picture = 'picture',
  Public = 'public',
  Sorting = 'sorting',
  Type = 'type',
  VolunteerTimes = 'volunteerTimes'
}

export type CauseScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  actionTemplates?: InputMaybe<StringNullableListFilter>;
  actions?: InputMaybe<StringNullableListFilter>;
  badgeId?: InputMaybe<StringNullableFilter>;
  banner?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  gradient?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  individualsOnly?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  picture?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  sorting?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumCauseTypeFilter>;
  volunteerTimes?: InputMaybe<StringNullableListFilter>;
};

export type CauseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CauseScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CauseScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CauseScalarWhereWithAggregatesInput>>>;
  actionTemplates?: InputMaybe<StringNullableListFilter>;
  actions?: InputMaybe<StringNullableListFilter>;
  badgeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  banner?: InputMaybe<StringNullableWithAggregatesFilter>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  color?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  gradient?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  individualsOnly?: InputMaybe<BoolNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  number?: InputMaybe<IntNullableWithAggregatesFilter>;
  organization?: InputMaybe<StringNullableWithAggregatesFilter>;
  picture?: InputMaybe<StringNullableWithAggregatesFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  sorting?: InputMaybe<IntNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumCauseTypeWithAggregatesFilter>;
  volunteerTimes?: InputMaybe<StringNullableListFilter>;
};

export type CauseSumAggregateOutputType = {
  __typename?: 'CauseSumAggregateOutputType';
  number?: Maybe<Scalars['Int']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
};

export type CauseSumOrderByAggregateInput = {
  number?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
};

export enum CauseType {
  Category = 'Category',
  Erg = 'ERG',
  Pillar = 'Pillar',
  Sdg = 'SDG'
}

export type CauseUncheckedCreateInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutExternalNonprofitCausesInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedCreateNestedManyWithoutActionTemplatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionTemplatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionTemplatesInput>>>;
};

export type CauseUncheckedCreateNestedManyWithoutActionsInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionsInput>>>;
};

export type CauseUncheckedCreateNestedManyWithoutBadgeInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<CauseCreateManyBadgeInputEnvelope>;
};

export type CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutVolunteerTimesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutVolunteerTimesInput>>>;
};

export type CauseUncheckedCreateWithoutActionTemplatesInput = {
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutExternalNonprofitCausesInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedCreateWithoutActionsInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutExternalNonprofitCausesInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedCreateWithoutBadgeInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCausesInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutExternalNonprofitCausesInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedCreateWithoutVolunteerTimesInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutCausesInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutCausesInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gradient?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  type: CauseType;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyWithoutActionTemplatesInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyWithoutActionTemplatesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionTemplatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionTemplatesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutActionTemplatesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutActionTemplatesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutActionTemplatesInput>>>;
};

export type CauseUncheckedUpdateManyWithoutActionsInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyWithoutActionsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutActionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutActionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutActionsInput>>>;
};

export type CauseUncheckedUpdateManyWithoutBadgeInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyWithoutBadgeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<CauseCreateManyBadgeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutBadgeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutBadgeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutBadgeInput>>>;
};

export type CauseUncheckedUpdateManyWithoutVolunteerTimesInput = {
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutVolunteerTimesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutVolunteerTimesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutVolunteerTimesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutVolunteerTimesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutVolunteerTimesInput>>>;
};

export type CauseUncheckedUpdateWithoutActionTemplatesInput = {
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateWithoutActionsInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateWithoutBadgeInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUncheckedUpdateWithoutVolunteerTimesInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutCausesNestedInput>;
  actionTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
  volunteerTimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUpdateInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutCausesNestedInput>;
  Badge?: InputMaybe<BadgeUpdateOneWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateManyMutationInput = {
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateManyWithWhereWithoutActionTemplatesInput = {
  data: CauseUpdateManyMutationInput;
  where: CauseScalarWhereInput;
};

export type CauseUpdateManyWithWhereWithoutActionsInput = {
  data: CauseUpdateManyMutationInput;
  where: CauseScalarWhereInput;
};

export type CauseUpdateManyWithWhereWithoutBadgeInput = {
  data: CauseUpdateManyMutationInput;
  where: CauseScalarWhereInput;
};

export type CauseUpdateManyWithWhereWithoutVolunteerTimesInput = {
  data: CauseUpdateManyMutationInput;
  where: CauseScalarWhereInput;
};

export type CauseUpdateManyWithoutActionTemplatesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionTemplatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionTemplatesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutActionTemplatesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutActionTemplatesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutActionTemplatesInput>>>;
};

export type CauseUpdateManyWithoutActionsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutActionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutActionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutActionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutActionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutActionsInput>>>;
};

export type CauseUpdateManyWithoutBadgeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutBadgeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutBadgeInput>>>;
  createMany?: InputMaybe<CauseCreateManyBadgeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutBadgeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutBadgeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutBadgeInput>>>;
};

export type CauseUpdateManyWithoutVolunteerTimesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CauseCreateOrConnectWithoutVolunteerTimesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CauseCreateWithoutVolunteerTimesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CauseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CauseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CauseUpdateWithWhereUniqueWithoutVolunteerTimesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CauseUpdateManyWithWhereWithoutVolunteerTimesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CauseUpsertWithWhereUniqueWithoutVolunteerTimesInput>>>;
};

export type CauseUpdateWithWhereUniqueWithoutActionTemplatesInput = {
  data: CauseUpdateWithoutActionTemplatesInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpdateWithWhereUniqueWithoutActionsInput = {
  data: CauseUpdateWithoutActionsInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpdateWithWhereUniqueWithoutBadgeInput = {
  data: CauseUpdateWithoutBadgeInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpdateWithWhereUniqueWithoutVolunteerTimesInput = {
  data: CauseUpdateWithoutVolunteerTimesInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpdateWithoutActionTemplatesInput = {
  Actions?: InputMaybe<ActionUpdateManyWithoutCausesNestedInput>;
  Badge?: InputMaybe<BadgeUpdateOneWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateWithoutActionsInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUpdateManyWithoutCausesNestedInput>;
  Badge?: InputMaybe<BadgeUpdateOneWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateWithoutBadgeInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutCausesNestedInput>;
  VolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutExternalNonprofitCausesNestedInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateWithoutVolunteerTimesInput = {
  ActionTemplates?: InputMaybe<ActionTemplateUpdateManyWithoutCausesNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutCausesNestedInput>;
  Badge?: InputMaybe<BadgeUpdateOneWithoutCausesNestedInput>;
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  gradient?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  individualsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sorting?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCauseTypeFieldUpdateOperationsInput>;
};

export type CauseUpdateactionTemplatesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUpdateactionsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUpdatevolunteerTimesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CauseUpsertWithWhereUniqueWithoutActionTemplatesInput = {
  create: CauseCreateWithoutActionTemplatesInput;
  update: CauseUpdateWithoutActionTemplatesInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpsertWithWhereUniqueWithoutActionsInput = {
  create: CauseCreateWithoutActionsInput;
  update: CauseUpdateWithoutActionsInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpsertWithWhereUniqueWithoutBadgeInput = {
  create: CauseCreateWithoutBadgeInput;
  update: CauseUpdateWithoutBadgeInput;
  where: CauseWhereUniqueInput;
};

export type CauseUpsertWithWhereUniqueWithoutVolunteerTimesInput = {
  create: CauseCreateWithoutVolunteerTimesInput;
  update: CauseUpdateWithoutVolunteerTimesInput;
  where: CauseWhereUniqueInput;
};

export type CauseWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  ActionTemplates?: InputMaybe<ActionTemplateListRelationFilter>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  Badge?: InputMaybe<BadgeNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  VolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  actionTemplates?: InputMaybe<StringNullableListFilter>;
  actions?: InputMaybe<StringNullableListFilter>;
  badgeId?: InputMaybe<StringNullableFilter>;
  banner?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  gradient?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  individualsOnly?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  picture?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  sorting?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumCauseTypeFilter>;
  volunteerTimes?: InputMaybe<StringNullableListFilter>;
};

export type CauseWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  ActionTemplates?: InputMaybe<ActionTemplateListRelationFilter>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  Badge?: InputMaybe<BadgeNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CauseWhereInput>>>;
  VolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  actionTemplates?: InputMaybe<StringNullableListFilter>;
  actions?: InputMaybe<StringNullableListFilter>;
  badgeId?: InputMaybe<StringNullableFilter>;
  banner?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  gradient?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualsOnly?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  picture?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  sorting?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumCauseTypeFilter>;
  volunteerTimes?: InputMaybe<StringNullableListFilter>;
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: challenges:view, organizationField: company), Employee(companyField: company)]) */
export type Challenge = {
  __typename?: 'Challenge';
  Company: Organization;
  Teams: Array<Community>;
  _count: ChallengeCountOutputType;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  generalStats: ChallengeGeneralStats;
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  rules: ChallengeRules;
  sorting: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats?: Maybe<ChallengeStats>;
  status: ChallengeStatus;
  teamRankings: ChallengeTeamRanking;
  teamUserRankings: ChallengeTeamUserRankings;
  teams: ParticipatingTeams;
  title: Scalars['String']['output'];
  totalHeadline?: Maybe<Scalars['String']['output']>;
  totalText?: Maybe<Scalars['String']['output']>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: challenges:view, organizationField: company), Employee(companyField: company)]) */
export type ChallengeTeamRankingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: challenges:view, organizationField: company), Employee(companyField: company)]) */
export type ChallengeTeamUserRankingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ChallengeAvgAggregateOutputType = {
  __typename?: 'ChallengeAvgAggregateOutputType';
  sorting?: Maybe<Scalars['Float']['output']>;
};

export type ChallengeAvgOrderByAggregateInput = {
  sorting?: InputMaybe<SortOrder>;
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: challenges:view, organizationField: company), Employee(companyField: company)]) */
export type ChallengeContribution = {
  __typename?: 'ChallengeContribution';
  Activity: Activity;
  Challenge: Challenge;
  Company: Organization;
  Team: Community;
  User: BaseUser;
  activityId: Scalars['String']['output'];
  amount: Scalars['Int']['output'];
  challenge: Scalars['String']['output'];
  company: Scalars['String']['output'];
  contributionDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  team: Scalars['String']['output'];
  unit: ContributionUnit;
  user: Scalars['String']['output'];
};

export type ChallengeContributionAvgAggregateOutputType = {
  __typename?: 'ChallengeContributionAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type ChallengeContributionAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type ChallengeContributionCountAggregateOutputType = {
  __typename?: 'ChallengeContributionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  activityId: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  challenge: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  contributionDate: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  team: Scalars['Int']['output'];
  unit: Scalars['Int']['output'];
  user: Scalars['Int']['output'];
};

export type ChallengeContributionCountOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  contributionDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  team?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type ChallengeContributionCreateInput = {
  Activity: ActivityCreateNestedOneWithoutChallengeContributionsInput;
  Challenge: ChallengeCreateNestedOneWithoutChallengeContributionsInput;
  Company: OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput;
  Team: CommunityCreateNestedOneWithoutChallengeContributionsInput;
  User: BaseUserCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionCreateManyActivityInput = {
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionCreateManyActivityInputEnvelope = {
  data: ChallengeContributionCreateManyActivityInput;
};

export type ChallengeContributionCreateManyChallengeInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionCreateManyChallengeInputEnvelope = {
  data: ChallengeContributionCreateManyChallengeInput;
};

export type ChallengeContributionCreateManyCompanyInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionCreateManyCompanyInputEnvelope = {
  data: ChallengeContributionCreateManyCompanyInput;
};

export type ChallengeContributionCreateManyInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionCreateManyTeamInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionCreateManyTeamInputEnvelope = {
  data: ChallengeContributionCreateManyTeamInput;
};

export type ChallengeContributionCreateManyUserInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
};

export type ChallengeContributionCreateManyUserInputEnvelope = {
  data: ChallengeContributionCreateManyUserInput;
};

export type ChallengeContributionCreateNestedManyWithoutActivityInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutActivityInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutActivityInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyActivityInputEnvelope>;
};

export type ChallengeContributionCreateNestedManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutChallengeInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutChallengeInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyChallengeInputEnvelope>;
};

export type ChallengeContributionCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyCompanyInputEnvelope>;
};

export type ChallengeContributionCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutTeamInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutTeamInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyTeamInputEnvelope>;
};

export type ChallengeContributionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyUserInputEnvelope>;
};

export type ChallengeContributionCreateOrConnectWithoutActivityInput = {
  create: ChallengeContributionCreateWithoutActivityInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionCreateOrConnectWithoutChallengeInput = {
  create: ChallengeContributionCreateWithoutChallengeInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionCreateOrConnectWithoutCompanyInput = {
  create: ChallengeContributionCreateWithoutCompanyInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionCreateOrConnectWithoutTeamInput = {
  create: ChallengeContributionCreateWithoutTeamInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionCreateOrConnectWithoutUserInput = {
  create: ChallengeContributionCreateWithoutUserInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionCreateWithoutActivityInput = {
  Challenge: ChallengeCreateNestedOneWithoutChallengeContributionsInput;
  Company: OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput;
  Team: CommunityCreateNestedOneWithoutChallengeContributionsInput;
  User: BaseUserCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionCreateWithoutChallengeInput = {
  Activity: ActivityCreateNestedOneWithoutChallengeContributionsInput;
  Company: OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput;
  Team: CommunityCreateNestedOneWithoutChallengeContributionsInput;
  User: BaseUserCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionCreateWithoutCompanyInput = {
  Activity: ActivityCreateNestedOneWithoutChallengeContributionsInput;
  Challenge: ChallengeCreateNestedOneWithoutChallengeContributionsInput;
  Team: CommunityCreateNestedOneWithoutChallengeContributionsInput;
  User: BaseUserCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionCreateWithoutTeamInput = {
  Activity: ActivityCreateNestedOneWithoutChallengeContributionsInput;
  Challenge: ChallengeCreateNestedOneWithoutChallengeContributionsInput;
  Company: OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput;
  User: BaseUserCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionCreateWithoutUserInput = {
  Activity: ActivityCreateNestedOneWithoutChallengeContributionsInput;
  Challenge: ChallengeCreateNestedOneWithoutChallengeContributionsInput;
  Company: OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput;
  Team: CommunityCreateNestedOneWithoutChallengeContributionsInput;
  amount: Scalars['Int']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
};

export type ChallengeContributionListRelationFilter = {
  every?: InputMaybe<ChallengeContributionWhereInput>;
  none?: InputMaybe<ChallengeContributionWhereInput>;
  some?: InputMaybe<ChallengeContributionWhereInput>;
};

export type ChallengeContributionMaxAggregateOutputType = {
  __typename?: 'ChallengeContributionMaxAggregateOutputType';
  activityId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  challenge?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contributionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<ContributionUnit>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ChallengeContributionMaxOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  contributionDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  team?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type ChallengeContributionMinAggregateOutputType = {
  __typename?: 'ChallengeContributionMinAggregateOutputType';
  activityId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  challenge?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contributionDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<ContributionUnit>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ChallengeContributionMinOrderByAggregateInput = {
  activityId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  contributionDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  team?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type ChallengeContributionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChallengeContributionOrderByWithAggregationInput = {
  _avg?: InputMaybe<ChallengeContributionAvgOrderByAggregateInput>;
  _count?: InputMaybe<ChallengeContributionCountOrderByAggregateInput>;
  _max?: InputMaybe<ChallengeContributionMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChallengeContributionMinOrderByAggregateInput>;
  _sum?: InputMaybe<ChallengeContributionSumOrderByAggregateInput>;
  activityId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  contributionDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  team?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export type ChallengeContributionOrderByWithRelationInput = {
  Activity?: InputMaybe<ActivityOrderByWithRelationInput>;
  Challenge?: InputMaybe<ChallengeOrderByWithRelationInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Team?: InputMaybe<CommunityOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  activityId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  challenge?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  contributionDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  team?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
};

export enum ChallengeContributionScalarFieldEnum {
  ActivityId = 'activityId',
  Amount = 'amount',
  Challenge = 'challenge',
  Company = 'company',
  ContributionDate = 'contributionDate',
  CreatedAt = 'createdAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Team = 'team',
  Unit = 'unit',
  User = 'user'
}

export type ChallengeContributionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  activityId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<IntFilter>;
  challenge?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  contributionDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  team?: InputMaybe<StringFilter>;
  unit?: InputMaybe<EnumContributionUnitFilter>;
  user?: InputMaybe<StringFilter>;
};

export type ChallengeContributionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereWithAggregatesInput>>>;
  activityId?: InputMaybe<StringWithAggregatesFilter>;
  amount?: InputMaybe<IntWithAggregatesFilter>;
  challenge?: InputMaybe<StringWithAggregatesFilter>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  contributionDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  team?: InputMaybe<StringWithAggregatesFilter>;
  unit?: InputMaybe<EnumContributionUnitWithAggregatesFilter>;
  user?: InputMaybe<StringWithAggregatesFilter>;
};

export type ChallengeContributionSumAggregateOutputType = {
  __typename?: 'ChallengeContributionSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']['output']>;
};

export type ChallengeContributionSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type ChallengeContributionUncheckedCreateInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionUncheckedCreateNestedManyWithoutActivityInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutActivityInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutActivityInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyActivityInputEnvelope>;
};

export type ChallengeContributionUncheckedCreateNestedManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutChallengeInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutChallengeInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyChallengeInputEnvelope>;
};

export type ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyCompanyInputEnvelope>;
};

export type ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutTeamInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutTeamInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyTeamInputEnvelope>;
};

export type ChallengeContributionUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyUserInputEnvelope>;
};

export type ChallengeContributionUncheckedCreateWithoutActivityInput = {
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionUncheckedCreateWithoutChallengeInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionUncheckedCreateWithoutCompanyInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionUncheckedCreateWithoutTeamInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  unit: ContributionUnit;
  user: Scalars['String']['input'];
};

export type ChallengeContributionUncheckedCreateWithoutUserInput = {
  activityId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  challenge: Scalars['String']['input'];
  company: Scalars['String']['input'];
  contributionDate: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  team: Scalars['String']['input'];
  unit: ContributionUnit;
};

export type ChallengeContributionUncheckedUpdateInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutActivityInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutActivityNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutActivityInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutActivityInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyActivityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutActivityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutActivityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutActivityInput>>>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutChallengeInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutChallengeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutChallengeInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutChallengeInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyChallengeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutChallengeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutChallengeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutChallengeInput>>>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutCompanyInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutTeamInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutTeamInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutTeamInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutTeamInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutTeamInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutTeamInput>>>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutUserInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ChallengeContributionUncheckedUpdateWithoutActivityInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateWithoutChallengeInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateWithoutCompanyInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateWithoutTeamInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChallengeContributionUncheckedUpdateWithoutUserInput = {
  activityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  team?: InputMaybe<StringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateInput = {
  Activity?: InputMaybe<ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput>;
  Team?: InputMaybe<CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateManyMutationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateManyWithWhereWithoutActivityInput = {
  data: ChallengeContributionUpdateManyMutationInput;
  where: ChallengeContributionScalarWhereInput;
};

export type ChallengeContributionUpdateManyWithWhereWithoutChallengeInput = {
  data: ChallengeContributionUpdateManyMutationInput;
  where: ChallengeContributionScalarWhereInput;
};

export type ChallengeContributionUpdateManyWithWhereWithoutCompanyInput = {
  data: ChallengeContributionUpdateManyMutationInput;
  where: ChallengeContributionScalarWhereInput;
};

export type ChallengeContributionUpdateManyWithWhereWithoutTeamInput = {
  data: ChallengeContributionUpdateManyMutationInput;
  where: ChallengeContributionScalarWhereInput;
};

export type ChallengeContributionUpdateManyWithWhereWithoutUserInput = {
  data: ChallengeContributionUpdateManyMutationInput;
  where: ChallengeContributionScalarWhereInput;
};

export type ChallengeContributionUpdateManyWithoutActivityNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutActivityInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutActivityInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyActivityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutActivityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutActivityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutActivityInput>>>;
};

export type ChallengeContributionUpdateManyWithoutChallengeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutChallengeInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutChallengeInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyChallengeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutChallengeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutChallengeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutChallengeInput>>>;
};

export type ChallengeContributionUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type ChallengeContributionUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutTeamInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutTeamInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutTeamInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutTeamInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutTeamInput>>>;
};

export type ChallengeContributionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeContributionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ChallengeContributionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeContributionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeContributionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeContributionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ChallengeContributionUpdateWithWhereUniqueWithoutActivityInput = {
  data: ChallengeContributionUpdateWithoutActivityInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpdateWithWhereUniqueWithoutChallengeInput = {
  data: ChallengeContributionUpdateWithoutChallengeInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpdateWithWhereUniqueWithoutCompanyInput = {
  data: ChallengeContributionUpdateWithoutCompanyInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpdateWithWhereUniqueWithoutTeamInput = {
  data: ChallengeContributionUpdateWithoutTeamInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpdateWithWhereUniqueWithoutUserInput = {
  data: ChallengeContributionUpdateWithoutUserInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpdateWithoutActivityInput = {
  Challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput>;
  Team?: InputMaybe<CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateWithoutChallengeInput = {
  Activity?: InputMaybe<ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput>;
  Team?: InputMaybe<CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateWithoutCompanyInput = {
  Activity?: InputMaybe<ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Team?: InputMaybe<CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateWithoutTeamInput = {
  Activity?: InputMaybe<ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpdateWithoutUserInput = {
  Activity?: InputMaybe<ActivityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput>;
  Team?: InputMaybe<CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  contributionDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumContributionUnitFieldUpdateOperationsInput>;
};

export type ChallengeContributionUpsertWithWhereUniqueWithoutActivityInput = {
  create: ChallengeContributionCreateWithoutActivityInput;
  update: ChallengeContributionUpdateWithoutActivityInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpsertWithWhereUniqueWithoutChallengeInput = {
  create: ChallengeContributionCreateWithoutChallengeInput;
  update: ChallengeContributionUpdateWithoutChallengeInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpsertWithWhereUniqueWithoutCompanyInput = {
  create: ChallengeContributionCreateWithoutCompanyInput;
  update: ChallengeContributionUpdateWithoutCompanyInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpsertWithWhereUniqueWithoutTeamInput = {
  create: ChallengeContributionCreateWithoutTeamInput;
  update: ChallengeContributionUpdateWithoutTeamInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionUpsertWithWhereUniqueWithoutUserInput = {
  create: ChallengeContributionCreateWithoutUserInput;
  update: ChallengeContributionUpdateWithoutUserInput;
  where: ChallengeContributionWhereUniqueInput;
};

export type ChallengeContributionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  Activity?: InputMaybe<ActivityRelationFilter>;
  Challenge?: InputMaybe<ChallengeRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  Team?: InputMaybe<CommunityRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  activityId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<IntFilter>;
  challenge?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  contributionDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  team?: InputMaybe<StringFilter>;
  unit?: InputMaybe<EnumContributionUnitFilter>;
  user?: InputMaybe<StringFilter>;
};

export type ChallengeContributionWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  Activity?: InputMaybe<ActivityRelationFilter>;
  Challenge?: InputMaybe<ChallengeRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeContributionWhereInput>>>;
  Team?: InputMaybe<CommunityRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  activityId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<IntFilter>;
  challenge?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringFilter>;
  contributionDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  team?: InputMaybe<StringFilter>;
  unit?: InputMaybe<EnumContributionUnitFilter>;
  user?: InputMaybe<StringFilter>;
};

export type ChallengeCountAggregateOutputType = {
  __typename?: 'ChallengeCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  backgroundImage: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  sorting: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  totalHeadline: Scalars['Int']['output'];
  totalText: Scalars['Int']['output'];
};

export type ChallengeCountOrderByAggregateInput = {
  backgroundImage?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalHeadline?: InputMaybe<SortOrder>;
  totalText?: InputMaybe<SortOrder>;
};

export type ChallengeCountOutputType = {
  __typename?: 'ChallengeCountOutputType';
  ChallengeContributions: Scalars['Int']['output'];
};

export type ChallengeCreateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutChallengeInput>;
  Company: OrganizationCreateNestedOneWithoutChallengesInput;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeCreateManyCompanyInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeCreateManyCompanyInputEnvelope = {
  data: ChallengeCreateManyCompanyInput;
};

export type ChallengeCreateManyInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeCreateManyCompanyInputEnvelope>;
};

export type ChallengeCreateNestedOneWithoutChallengeContributionsInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChallengeCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<ChallengeCreateWithoutChallengeContributionsInput>;
};

export type ChallengeCreateOrConnectWithoutChallengeContributionsInput = {
  create: ChallengeCreateWithoutChallengeContributionsInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeCreateOrConnectWithoutCompanyInput = {
  create: ChallengeCreateWithoutCompanyInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeCreateWithoutChallengeContributionsInput = {
  Company: OrganizationCreateNestedOneWithoutChallengesInput;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeCreateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutChallengeInput>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeGeneralStats = {
  __typename?: 'ChallengeGeneralStats';
  actionsImpact: ActionsImpactType;
  limitedParticipantImages: Array<Scalars['String']['output']>;
  limitedTeamImages: Array<Scalars['String']['output']>;
  remainingDays: Scalars['Int']['output'];
  totalActionsCompleted: Scalars['Int']['output'];
  totalParticipants: Scalars['Int']['output'];
  totalTeams: Scalars['Int']['output'];
  totalUsersWithActionsCompleted: Scalars['Int']['output'];
};

export type ChallengeListRelationFilter = {
  every?: InputMaybe<ChallengeWhereInput>;
  none?: InputMaybe<ChallengeWhereInput>;
  some?: InputMaybe<ChallengeWhereInput>;
};

export type ChallengeMaxAggregateOutputType = {
  __typename?: 'ChallengeMaxAggregateOutputType';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatus>;
  title?: Maybe<Scalars['String']['output']>;
  totalHeadline?: Maybe<Scalars['String']['output']>;
  totalText?: Maybe<Scalars['String']['output']>;
};

export type ChallengeMaxOrderByAggregateInput = {
  backgroundImage?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalHeadline?: InputMaybe<SortOrder>;
  totalText?: InputMaybe<SortOrder>;
};

export type ChallengeMinAggregateOutputType = {
  __typename?: 'ChallengeMinAggregateOutputType';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ChallengeStatus>;
  title?: Maybe<Scalars['String']['output']>;
  totalHeadline?: Maybe<Scalars['String']['output']>;
  totalText?: Maybe<Scalars['String']['output']>;
};

export type ChallengeMinOrderByAggregateInput = {
  backgroundImage?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalHeadline?: InputMaybe<SortOrder>;
  totalText?: InputMaybe<SortOrder>;
};

export type ChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChallengeOrderByWithAggregationInput = {
  _avg?: InputMaybe<ChallengeAvgOrderByAggregateInput>;
  _count?: InputMaybe<ChallengeCountOrderByAggregateInput>;
  _max?: InputMaybe<ChallengeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChallengeMinOrderByAggregateInput>;
  _sum?: InputMaybe<ChallengeSumOrderByAggregateInput>;
  backgroundImage?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sorting?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalHeadline?: InputMaybe<SortOrder>;
  totalText?: InputMaybe<SortOrder>;
};

export type ChallengeOrderByWithRelationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionOrderByRelationAggregateInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  backgroundImage?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  rules?: InputMaybe<ChallengeRulesOrderByInput>;
  sorting?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  stats?: InputMaybe<ChallengeStatsOrderByInput>;
  status?: InputMaybe<SortOrder>;
  teams?: InputMaybe<ParticipatingTeamsOrderByInput>;
  title?: InputMaybe<SortOrder>;
  totalHeadline?: InputMaybe<SortOrder>;
  totalText?: InputMaybe<SortOrder>;
};

export type ChallengeRelationFilter = {
  is?: InputMaybe<ChallengeWhereInput>;
  isNot?: InputMaybe<ChallengeWhereInput>;
};

export type ChallengeRules = {
  __typename?: 'ChallengeRules';
  actionsCompleted: ChallengeRulesActionsCompleted;
};

export type ChallengeRulesActionsCompleted = {
  __typename?: 'ChallengeRulesActionsCompleted';
  ids: Array<Scalars['String']['output']>;
  isExclude: Scalars['Boolean']['output'];
};

export type ChallengeRulesActionsCompletedCompositeFilter = {
  equals?: InputMaybe<ChallengeRulesActionsCompletedObjectEqualityInput>;
  is?: InputMaybe<ChallengeRulesActionsCompletedWhereInput>;
  isNot?: InputMaybe<ChallengeRulesActionsCompletedWhereInput>;
};

export type ChallengeRulesActionsCompletedCreateInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChallengeRulesActionsCompletedCreateidsInput = {
  set: Scalars['String']['input'];
};

export type ChallengeRulesActionsCompletedObjectEqualityInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude: Scalars['Boolean']['input'];
};

export type ChallengeRulesActionsCompletedOrderByInput = {
  ids?: InputMaybe<SortOrder>;
  isExclude?: InputMaybe<SortOrder>;
};

export type ChallengeRulesActionsCompletedUpdateEnvelopeInput = {
  set?: InputMaybe<ChallengeRulesActionsCompletedCreateInput>;
  update?: InputMaybe<ChallengeRulesActionsCompletedUpdateInput>;
};

export type ChallengeRulesActionsCompletedUpdateInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ChallengeRulesActionsCompletedUpdateidsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChallengeRulesActionsCompletedWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeRulesActionsCompletedWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeRulesActionsCompletedWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeRulesActionsCompletedWhereInput>>>;
  ids?: InputMaybe<StringNullableListFilter>;
  isExclude?: InputMaybe<BoolFilter>;
};

export type ChallengeRulesCompositeFilter = {
  equals?: InputMaybe<ChallengeRulesObjectEqualityInput>;
  is?: InputMaybe<ChallengeRulesWhereInput>;
  isNot?: InputMaybe<ChallengeRulesWhereInput>;
};

export type ChallengeRulesCreateEnvelopeInput = {
  set?: InputMaybe<ChallengeRulesCreateInput>;
};

export type ChallengeRulesCreateInput = {
  actionsCompleted: ChallengeRulesActionsCompletedCreateInput;
};

export type ChallengeRulesInputType = {
  actionsCompleted?: InputMaybe<ActionsInputType>;
};

export type ChallengeRulesObjectEqualityInput = {
  actionsCompleted: ChallengeRulesActionsCompletedObjectEqualityInput;
};

export type ChallengeRulesOrderByInput = {
  actionsCompleted?: InputMaybe<ChallengeRulesActionsCompletedOrderByInput>;
};

export type ChallengeRulesUpdateEnvelopeInput = {
  set?: InputMaybe<ChallengeRulesCreateInput>;
  update?: InputMaybe<ChallengeRulesUpdateInput>;
};

export type ChallengeRulesUpdateInput = {
  actionsCompleted?: InputMaybe<ChallengeRulesActionsCompletedUpdateEnvelopeInput>;
};

export type ChallengeRulesWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeRulesWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeRulesWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeRulesWhereInput>>>;
  actionsCompleted?: InputMaybe<ChallengeRulesActionsCompletedCompositeFilter>;
};

export enum ChallengeScalarFieldEnum {
  BackgroundImage = 'backgroundImage',
  Company = 'company',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Sorting = 'sorting',
  StartDate = 'startDate',
  Status = 'status',
  Title = 'title',
  TotalHeadline = 'totalHeadline',
  TotalText = 'totalText'
}

export type ChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereInput>>>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  sorting?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  title?: InputMaybe<StringFilter>;
  totalHeadline?: InputMaybe<StringNullableFilter>;
  totalText?: InputMaybe<StringNullableFilter>;
};

export type ChallengeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereWithAggregatesInput>>>;
  backgroundImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  sorting?: InputMaybe<IntWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumChallengeStatusWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  totalHeadline?: InputMaybe<StringNullableWithAggregatesFilter>;
  totalText?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ChallengeStats = {
  __typename?: 'ChallengeStats';
  actionsCompleted?: Maybe<Scalars['Json']['output']>;
  actionsImpact?: Maybe<ActionsImpactType>;
};

export type ChallengeStatsCreateInput = {
  actionsCompleted?: InputMaybe<Scalars['Json']['input']>;
  actionsImpact?: InputMaybe<ActionsImpactTypeCreateInput>;
};

export type ChallengeStatsNullableCompositeFilter = {
  equals?: InputMaybe<ChallengeStatsObjectEqualityInput>;
  is?: InputMaybe<ChallengeStatsWhereInput>;
  isNot?: InputMaybe<ChallengeStatsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChallengeStatsNullableCreateEnvelopeInput = {
  set?: InputMaybe<ChallengeStatsCreateInput>;
};

export type ChallengeStatsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ChallengeStatsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ChallengeStatsUpsertInput>;
};

export type ChallengeStatsObjectEqualityInput = {
  actionsCompleted?: InputMaybe<Scalars['Json']['input']>;
  actionsImpact?: InputMaybe<ActionsImpactTypeObjectEqualityInput>;
};

export type ChallengeStatsOrderByInput = {
  actionsCompleted?: InputMaybe<SortOrder>;
  actionsImpact?: InputMaybe<ActionsImpactTypeOrderByInput>;
};

export type ChallengeStatsUpdateInput = {
  actionsCompleted?: InputMaybe<Scalars['Json']['input']>;
  actionsImpact?: InputMaybe<ActionsImpactTypeNullableUpdateEnvelopeInput>;
};

export type ChallengeStatsUpsertInput = {
  set: ChallengeStatsCreateInput;
  update: ChallengeStatsUpdateInput;
};

export type ChallengeStatsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeStatsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeStatsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeStatsWhereInput>>>;
  actionsCompleted?: InputMaybe<JsonNullableFilter>;
  actionsImpact?: InputMaybe<ActionsImpactTypeNullableCompositeFilter>;
};

export enum ChallengeStatus {
  Draft = 'draft',
  Published = 'published'
}

export type ChallengeSumAggregateOutputType = {
  __typename?: 'ChallengeSumAggregateOutputType';
  sorting?: Maybe<Scalars['Int']['output']>;
};

export type ChallengeSumOrderByAggregateInput = {
  sorting?: InputMaybe<SortOrder>;
};

export type ChallengeTeamActionsCompleted = {
  __typename?: 'ChallengeTeamActionsCompleted';
  rank: Scalars['Int']['output'];
  team: Community;
  totalCount: Scalars['Int']['output'];
};

export type ChallengeTeamRanking = {
  __typename?: 'ChallengeTeamRanking';
  actionsCompleted: Array<ChallengeTeamActionsCompleted>;
};

export type ChallengeTeamUserActionsCompleted = {
  __typename?: 'ChallengeTeamUserActionsCompleted';
  team: SelectedTeam;
  userRankings: Array<ChallengeUserRanking>;
};

export type ChallengeTeamUserRankings = {
  __typename?: 'ChallengeTeamUserRankings';
  actionsCompleted: Array<ChallengeTeamUserActionsCompleted>;
};

export type ChallengeUncheckedCreateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutChallengeInput>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeCreateManyCompanyInputEnvelope>;
};

export type ChallengeUncheckedCreateWithoutChallengeContributionsInput = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeUncheckedCreateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutChallengeInput>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rules: ChallengeRulesCreateEnvelopeInput;
  sorting: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stats?: InputMaybe<ChallengeStatsNullableCreateEnvelopeInput>;
  status?: InputMaybe<ChallengeStatus>;
  teams: ParticipatingTeamsCreateEnvelopeInput;
  title: Scalars['String']['input'];
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeUncheckedUpdateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutChallengeNestedInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUncheckedUpdateManyInput = {
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUncheckedUpdateManyWithoutCompanyInput = {
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type ChallengeUncheckedUpdateWithoutChallengeContributionsInput = {
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUncheckedUpdateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutChallengeNestedInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUpdateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutChallengeNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengesNestedInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUpdateManyMutationInput = {
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUpdateManyWithWhereWithoutCompanyInput = {
  data: ChallengeUpdateManyMutationInput;
  where: ChallengeScalarWhereInput;
};

export type ChallengeUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ChallengeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChallengeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<ChallengeCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ChallengeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ChallengeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChallengeUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ChallengeUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ChallengeUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type ChallengeUpdateOneRequiredWithoutChallengeContributionsNestedInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChallengeCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<ChallengeCreateWithoutChallengeContributionsInput>;
  update?: InputMaybe<ChallengeUpdateToOneWithWhereWithoutChallengeContributionsInput>;
  upsert?: InputMaybe<ChallengeUpsertWithoutChallengeContributionsInput>;
};

export type ChallengeUpdateToOneWithWhereWithoutChallengeContributionsInput = {
  data: ChallengeUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type ChallengeUpdateWithWhereUniqueWithoutCompanyInput = {
  data: ChallengeUpdateWithoutCompanyInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeUpdateWithoutChallengeContributionsInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutChallengesNestedInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUpdateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutChallengeNestedInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rules?: InputMaybe<ChallengeRulesUpdateEnvelopeInput>;
  sorting?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stats?: InputMaybe<ChallengeStatsNullableUpdateEnvelopeInput>;
  status?: InputMaybe<EnumChallengeStatusFieldUpdateOperationsInput>;
  teams?: InputMaybe<ParticipatingTeamsUpdateEnvelopeInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalHeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ChallengeUpsertInputType = {
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<ChallengeRulesInputType>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChallengeStatus>;
  teams?: InputMaybe<TeamsInputType>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalHeadline?: InputMaybe<Scalars['String']['input']>;
  totalText?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeUpsertWithWhereUniqueWithoutCompanyInput = {
  create: ChallengeCreateWithoutCompanyInput;
  update: ChallengeUpdateWithoutCompanyInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeUpsertWithoutChallengeContributionsInput = {
  create: ChallengeCreateWithoutChallengeContributionsInput;
  update: ChallengeUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type ChallengeUserRanking = {
  __typename?: 'ChallengeUserRanking';
  hasLeft?: Maybe<Scalars['Boolean']['output']>;
  rank: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  user: TeamMember;
};

export type ChallengeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  rules?: InputMaybe<ChallengeRulesCompositeFilter>;
  sorting?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stats?: InputMaybe<ChallengeStatsNullableCompositeFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  teams?: InputMaybe<ParticipatingTeamsCompositeFilter>;
  title?: InputMaybe<StringFilter>;
  totalHeadline?: InputMaybe<StringNullableFilter>;
  totalText?: InputMaybe<StringNullableFilter>;
};

export type ChallengeWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ChallengeWhereInput>>>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  rules?: InputMaybe<ChallengeRulesCompositeFilter>;
  sorting?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  stats?: InputMaybe<ChallengeStatsNullableCompositeFilter>;
  status?: InputMaybe<EnumChallengeStatusFilter>;
  teams?: InputMaybe<ParticipatingTeamsCompositeFilter>;
  title?: InputMaybe<StringFilter>;
  totalHeadline?: InputMaybe<StringNullableFilter>;
  totalText?: InputMaybe<StringNullableFilter>;
};

/** Pagination data */
export type ChallengesMetaType = {
  __typename?: 'ChallengesMetaType';
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Challenges and pagination meta */
export type ChallengesType = {
  __typename?: 'ChallengesType';
  /** challenges from your company */
  items?: Maybe<Array<Challenge>>;
  /** pagination data for challenges */
  metadata: ChallengesMetaType;
};

export type ChapterRequest = {
  __typename?: 'ChapterRequest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<Maybe<NonprofitIdentifierEntryStrict>>;
  locationObject: LocationObject;
  log?: Maybe<Array<Maybe<ChapterRequestLogEntry>>>;
  metadata?: Maybe<ChapterRequestMetadata>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitEntityType?: Maybe<Scalars['String']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  nonprofitName: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  parentNonprofitId: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processedBy?: Maybe<Scalars['ObjectId']['output']>;
  requestedBy: Scalars['ObjectId']['output'];
  requestedByName?: Maybe<Scalars['String']['output']>;
  status: ChapterRequestStatusEnum;
  users: Array<Maybe<ChapterRequestUser>>;
  /** Pre-computed validation for this chapter request */
  validationMessages?: Maybe<Array<Maybe<ChapterRequestValidationMessage>>>;
  zendeskTicketId?: Maybe<Scalars['Int']['output']>;
};

export type ChapterRequestLogEntry = {
  __typename?: 'ChapterRequestLogEntry';
  message: Scalars['String']['output'];
  payload?: Maybe<Scalars['Json']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['DateTime']['output'];
};

export type ChapterRequestMetadata = {
  __typename?: 'ChapterRequestMetadata';
  initialNonprofitEntityId?: Maybe<Scalars['ObjectId']['output']>;
  initialNonprofitOrgId?: Maybe<Scalars['ObjectId']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  touchCount?: Maybe<Scalars['Int']['output']>;
};

export enum ChapterRequestStatusEnum {
  Accepted = 'Accepted',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Revoked = 'Revoked'
}

export type ChapterRequestUser = ChapterRequestUserByReference | ChapterRequestUserDirect;

export type ChapterRequestUserByReference = ChapterRequestUserInterface & {
  __typename?: 'ChapterRequestUserByReference';
  id: Scalars['ObjectId']['output'];
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export type ChapterRequestUserByReferenceInput = {
  id: Scalars['ObjectId']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ChapterRequestUserDirect = ChapterRequestUserInterface & {
  __typename?: 'ChapterRequestUserDirect';
  email: Scalars['String']['output'];
  fullName: FullName;
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export type ChapterRequestUserDirectInput = {
  email: Scalars['String']['input'];
  fullName: FullNameInput;
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ChapterRequestUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<FullNameInput>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ChapterRequestUserInterface = {
  roles: Array<Maybe<Scalars['String']['output']>>;
};

export type ChapterRequestValidationMessage = {
  __typename?: 'ChapterRequestValidationMessage';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  payload?: Maybe<Scalars['Json']['output']>;
  type: Scalars['String']['output'];
};

export type ChapterRequestsType = {
  __typename?: 'ChapterRequestsType';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<ChapterRequest>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CommunitiesMigrationProjection = {
  __typename?: 'CommunitiesMigrationProjection';
  migratedCommunities?: Maybe<Array<CommunityPartial>>;
  toBeMigratedCommunities?: Maybe<Array<CommunityPartial>>;
};

export type CommunitiesMigrationResult = {
  __typename?: 'CommunitiesMigrationResult';
  newlyCreatedCommunities?: Maybe<Array<CommunityPartial>>;
  updatedCommunities?: Maybe<Array<CommunityPartial>>;
};

/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type Community = {
  __typename?: 'Community';
  /** Community Owner Company */
  Company?: Maybe<Organization>;
  /** Deeds tagged in the community */
  Deeds: Array<Deed>;
  /** Nonprofits tagged in the community */
  Nonprofits: Array<Organization>;
  OrganizingDeeds: Array<Deed>;
  _count: CommunityCountOutputType;
  allowAllyMembers?: Maybe<Scalars['Boolean']['output']>;
  allowAnonymousMembers?: Maybe<Scalars['Boolean']['output']>;
  /** Get community anonymous members count */
  anonymousMembersCount: Scalars['Int']['output'];
  backgroundImage?: Maybe<Scalars['String']['output']>;
  /** Get comments for the given activity */
  comments: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deedIds: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** Get Stream feed for the community */
  feed: Scalars['String']['output'];
  feedIntegrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** Get community members (excludes anonymous members unless superadmin) */
  members: Array<CommunityUserMembership>;
  /** Get community members count (includes anonymous members in total) */
  membersCount: Scalars['Int']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current user membership role in this community */
  myMembershipRole?: Maybe<CommunityUserRole>;
  nonprofitIds: Array<Scalars['String']['output']>;
  organizingDeedIds: Array<Scalars['String']['output']>;
  sourceERGId?: Maybe<Scalars['String']['output']>;
  tileImage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Get the total number of completed actions by all current team members. If multiple team members complete the same action, it counts as multiple. */
  totalActionsCompleted: Scalars['Int']['output'];
  /** Get the total amount of donations to fundraisers organized by this community and nonprofits linked by this community */
  totalDonations: Scalars['Float']['output'];
  /** Get the total number of volunteering minutes to deeds organized by this community + to partner nonprofits by company employees */
  totalVolunteering: Scalars['Float']['output'];
  type?: Maybe<CommunityEntityType>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityDeedsArgs = {
  cursor?: InputMaybe<DeedWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DeedScalarFieldEnum>>>;
  includeLinkOnlyDeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includePastDeeds?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<DeedOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeedWhereInput>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityOrganizingDeedsArgs = {
  cursor?: InputMaybe<DeedWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DeedScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DeedOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeedWhereInput>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityCommentsArgs = {
  activityId: Scalars['ID']['input'];
  id_lt?: InputMaybe<Scalars['String']['input']>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityFeedArgs = {
  id_lt?: InputMaybe<Scalars['String']['input']>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityMembersArgs = {
  excludeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderByRole?: InputMaybe<CommunityUserRole>;
  role?: InputMaybe<CommunityUserRole>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** @Auth(read: [Employee, Organizer(type: Company, privilege: communities:view, organizationField: companyId)]) */
export type CommunityMembersCountArgs = {
  role?: InputMaybe<CommunityUserRole>;
};

export type CommunityCountAggregateOutputType = {
  __typename?: 'CommunityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  allowAllyMembers: Scalars['Int']['output'];
  allowAnonymousMembers: Scalars['Int']['output'];
  backgroundImage: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  deedIds: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  feedIntegrationEnabled: Scalars['Int']['output'];
  headerImage: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  isPrivate: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofitIds: Scalars['Int']['output'];
  organizingDeedIds: Scalars['Int']['output'];
  sourceERGId: Scalars['Int']['output'];
  tileImage: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type CommunityCountOrderByAggregateInput = {
  allowAllyMembers?: InputMaybe<SortOrder>;
  allowAnonymousMembers?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deedIds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  feedIntegrationEnabled?: InputMaybe<SortOrder>;
  headerImage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  organizingDeedIds?: InputMaybe<SortOrder>;
  sourceERGId?: InputMaybe<SortOrder>;
  tileImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CommunityCountOutputType = {
  __typename?: 'CommunityCountOutputType';
  ChallengeContributions: Scalars['Int']['output'];
  Deeds: Scalars['Int']['output'];
  Nonprofits: Scalars['Int']['output'];
  OrganizingDeeds: Scalars['Int']['output'];
};

export type CommunityCreateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutTeamInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCommunityCompaniesInput>;
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateInputType = {
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nonprofitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizingDeedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateManyCompanyInput = {
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateManyCompanyInputEnvelope = {
  data: CommunityCreateManyCompanyInput;
};

export type CommunityCreateManyInput = {
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CommunityCreateManyCompanyInputEnvelope>;
};

export type CommunityCreateNestedManyWithoutDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutDeedsInput>>>;
};

export type CommunityCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutNonprofitsInput>>>;
};

export type CommunityCreateNestedManyWithoutOrganizingDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutOrganizingDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutOrganizingDeedsInput>>>;
};

export type CommunityCreateNestedOneWithoutChallengeContributionsInput = {
  connect?: InputMaybe<CommunityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommunityCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<CommunityCreateWithoutChallengeContributionsInput>;
};

export type CommunityCreateOrConnectWithoutChallengeContributionsInput = {
  create: CommunityCreateWithoutChallengeContributionsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityCreateOrConnectWithoutCompanyInput = {
  create: CommunityCreateWithoutCompanyInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityCreateOrConnectWithoutDeedsInput = {
  create: CommunityCreateWithoutDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityCreateOrConnectWithoutNonprofitsInput = {
  create: CommunityCreateWithoutNonprofitsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityCreateOrConnectWithoutOrganizingDeedsInput = {
  create: CommunityCreateWithoutOrganizingDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityCreateWithoutChallengeContributionsInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCommunityCompaniesInput>;
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutTeamInput>;
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateWithoutDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutTeamInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCommunityCompaniesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateWithoutNonprofitsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutTeamInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCommunityCompaniesInput>;
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutCommunitiesInput>;
  OrganizingDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreateWithoutOrganizingDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionCreateNestedManyWithoutTeamInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCommunityCompaniesInput>;
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutCommunityNonprofitsInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityCreatedeedIdsInput = {
  set: Scalars['String']['input'];
};

export type CommunityCreatenonprofitIdsInput = {
  set: Scalars['String']['input'];
};

export type CommunityCreateorganizingDeedIdsInput = {
  set: Scalars['String']['input'];
};

export enum CommunityEntityType {
  Community = 'Community',
  Team = 'Team'
}

export type CommunityListRelationFilter = {
  every?: InputMaybe<CommunityWhereInput>;
  none?: InputMaybe<CommunityWhereInput>;
  some?: InputMaybe<CommunityWhereInput>;
};

export type CommunityMaxAggregateOutputType = {
  __typename?: 'CommunityMaxAggregateOutputType';
  allowAllyMembers?: Maybe<Scalars['Boolean']['output']>;
  allowAnonymousMembers?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feedIntegrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceERGId?: Maybe<Scalars['String']['output']>;
  tileImage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommunityEntityType>;
};

export type CommunityMaxOrderByAggregateInput = {
  allowAllyMembers?: InputMaybe<SortOrder>;
  allowAnonymousMembers?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  feedIntegrationEnabled?: InputMaybe<SortOrder>;
  headerImage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sourceERGId?: InputMaybe<SortOrder>;
  tileImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CommunityMembership = {
  __typename?: 'CommunityMembership';
  communityId: Scalars['String']['output'];
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  role: CommunityUserRole;
};

export type CommunityMembershipCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<CommunityMembershipObjectEqualityInput>>>;
  every?: InputMaybe<CommunityMembershipWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommunityMembershipWhereInput>;
  some?: InputMaybe<CommunityMembershipWhereInput>;
};

export type CommunityMembershipCreateInput = {
  communityId: Scalars['String']['input'];
  joinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: CommunityUserRole;
};

export type CommunityMembershipDeleteManyInput = {
  where: CommunityMembershipWhereInput;
};

export type CommunityMembershipListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
};

export type CommunityMembershipListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<CommunityMembershipDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityMembershipCreateInput>>>;
  updateMany?: InputMaybe<CommunityMembershipUpdateManyInput>;
};

export type CommunityMembershipObjectEqualityInput = {
  communityId: Scalars['String']['input'];
  joinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role: CommunityUserRole;
};

export type CommunityMembershipOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityMembershipUpdateInput = {
  communityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  joinedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumCommunityUserRoleFieldUpdateOperationsInput>;
};

export type CommunityMembershipUpdateManyInput = {
  data: CommunityMembershipUpdateInput;
  where: CommunityMembershipWhereInput;
};

export type CommunityMembershipWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CommunityMembershipWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CommunityMembershipWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CommunityMembershipWhereInput>>>;
  communityId?: InputMaybe<StringFilter>;
  joinedAt?: InputMaybe<DateTimeNullableFilter>;
  role?: InputMaybe<EnumCommunityUserRoleFilter>;
};

export type CommunityMinAggregateOutputType = {
  __typename?: 'CommunityMinAggregateOutputType';
  allowAllyMembers?: Maybe<Scalars['Boolean']['output']>;
  allowAnonymousMembers?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feedIntegrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceERGId?: Maybe<Scalars['String']['output']>;
  tileImage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommunityEntityType>;
};

export type CommunityMinOrderByAggregateInput = {
  allowAllyMembers?: InputMaybe<SortOrder>;
  allowAnonymousMembers?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  feedIntegrationEnabled?: InputMaybe<SortOrder>;
  headerImage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  sourceERGId?: InputMaybe<SortOrder>;
  tileImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CommunityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommunityOrderByWithAggregationInput = {
  _count?: InputMaybe<CommunityCountOrderByAggregateInput>;
  _max?: InputMaybe<CommunityMaxOrderByAggregateInput>;
  _min?: InputMaybe<CommunityMinOrderByAggregateInput>;
  allowAllyMembers?: InputMaybe<SortOrder>;
  allowAnonymousMembers?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deedIds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  feedIntegrationEnabled?: InputMaybe<SortOrder>;
  headerImage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  organizingDeedIds?: InputMaybe<SortOrder>;
  sourceERGId?: InputMaybe<SortOrder>;
  tileImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CommunityOrderByWithRelationInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionOrderByRelationAggregateInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Deeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  Nonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  OrganizingDeeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  allowAllyMembers?: InputMaybe<SortOrder>;
  allowAnonymousMembers?: InputMaybe<SortOrder>;
  backgroundImage?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deedIds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  feedIntegrationEnabled?: InputMaybe<SortOrder>;
  headerImage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  isPrivate?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  organizingDeedIds?: InputMaybe<SortOrder>;
  sourceERGId?: InputMaybe<SortOrder>;
  tileImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CommunityPartial = {
  __typename?: 'CommunityPartial';
  id?: Maybe<Scalars['String']['output']>;
  sourceERGId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CommunityRelationFilter = {
  is?: InputMaybe<CommunityWhereInput>;
  isNot?: InputMaybe<CommunityWhereInput>;
};

export enum CommunityScalarFieldEnum {
  AllowAllyMembers = 'allowAllyMembers',
  AllowAnonymousMembers = 'allowAnonymousMembers',
  BackgroundImage = 'backgroundImage',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeedIds = 'deedIds',
  Description = 'description',
  Enabled = 'enabled',
  FeedIntegrationEnabled = 'feedIntegrationEnabled',
  HeaderImage = 'headerImage',
  Id = 'id',
  Identifier = 'identifier',
  IsPrivate = 'isPrivate',
  ModifiedAt = 'modifiedAt',
  NonprofitIds = 'nonprofitIds',
  OrganizingDeedIds = 'organizingDeedIds',
  SourceErgId = 'sourceERGId',
  TileImage = 'tileImage',
  Title = 'title',
  Type = 'type'
}

export type CommunityScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  allowAllyMembers?: InputMaybe<BoolNullableFilter>;
  allowAnonymousMembers?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deedIds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  feedIntegrationEnabled?: InputMaybe<BoolNullableFilter>;
  headerImage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  isPrivate?: InputMaybe<BoolNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  organizingDeedIds?: InputMaybe<StringNullableListFilter>;
  sourceERGId?: InputMaybe<StringNullableFilter>;
  tileImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCommunityEntityTypeNullableFilter>;
};

export type CommunityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CommunityScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CommunityScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CommunityScalarWhereWithAggregatesInput>>>;
  allowAllyMembers?: InputMaybe<BoolNullableWithAggregatesFilter>;
  allowAnonymousMembers?: InputMaybe<BoolNullableWithAggregatesFilter>;
  backgroundImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  deedIds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  enabled?: InputMaybe<BoolWithAggregatesFilter>;
  feedIntegrationEnabled?: InputMaybe<BoolNullableWithAggregatesFilter>;
  headerImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  isPrivate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  organizingDeedIds?: InputMaybe<StringNullableListFilter>;
  sourceERGId?: InputMaybe<StringNullableWithAggregatesFilter>;
  tileImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumCommunityEntityTypeNullableWithAggregatesFilter>;
};

export type CommunityUncheckedCreateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput>;
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CommunityCreateManyCompanyInputEnvelope>;
};

export type CommunityUncheckedCreateNestedManyWithoutDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutDeedsInput>>>;
};

export type CommunityUncheckedCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutNonprofitsInput>>>;
};

export type CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutOrganizingDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutOrganizingDeedsInput>>>;
};

export type CommunityUncheckedCreateWithoutChallengeContributionsInput = {
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedCreateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput>;
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedCreateWithoutDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedCreateWithoutNonprofitsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput>;
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutCommunitiesInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedCreateWithoutOrganizingDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutTeamInput>;
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutCommunitiesInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput>;
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<Scalars['String']['input']>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUncheckedUpdateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput>;
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyWithoutCompanyInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CommunityCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type CommunityUncheckedUpdateManyWithoutDeedsInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyWithoutDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutDeedsInput>>>;
};

export type CommunityUncheckedUpdateManyWithoutNonprofitsInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type CommunityUncheckedUpdateManyWithoutOrganizingDeedsInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutOrganizingDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutOrganizingDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutOrganizingDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutOrganizingDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutOrganizingDeedsInput>>>;
};

export type CommunityUncheckedUpdateWithoutChallengeContributionsInput = {
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput>;
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateWithoutDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateWithoutNonprofitsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput>;
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutCommunitiesNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUncheckedUpdateWithoutOrganizingDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutTeamNestedInput>;
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutTeamNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutCommunityCompaniesNestedInput>;
  Deeds?: InputMaybe<DeedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateInputType = {
  allowAllyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  allowAnonymousMembers?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<Scalars['String']['input']>;
  deedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  leadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nonprofitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizingDeedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tileImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CommunityEntityType>;
};

export type CommunityUpdateManyMutationInput = {
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateManyWithWhereWithoutCompanyInput = {
  data: CommunityUpdateManyMutationInput;
  where: CommunityScalarWhereInput;
};

export type CommunityUpdateManyWithWhereWithoutDeedsInput = {
  data: CommunityUpdateManyMutationInput;
  where: CommunityScalarWhereInput;
};

export type CommunityUpdateManyWithWhereWithoutNonprofitsInput = {
  data: CommunityUpdateManyMutationInput;
  where: CommunityScalarWhereInput;
};

export type CommunityUpdateManyWithWhereWithoutOrganizingDeedsInput = {
  data: CommunityUpdateManyMutationInput;
  where: CommunityScalarWhereInput;
};

export type CommunityUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CommunityCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type CommunityUpdateManyWithoutDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutDeedsInput>>>;
};

export type CommunityUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type CommunityUpdateManyWithoutOrganizingDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CommunityCreateOrConnectWithoutOrganizingDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunityCreateWithoutOrganizingDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CommunityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CommunityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunityUpdateWithWhereUniqueWithoutOrganizingDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CommunityUpdateManyWithWhereWithoutOrganizingDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CommunityUpsertWithWhereUniqueWithoutOrganizingDeedsInput>>>;
};

export type CommunityUpdateOneRequiredWithoutChallengeContributionsNestedInput = {
  connect?: InputMaybe<CommunityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommunityCreateOrConnectWithoutChallengeContributionsInput>;
  create?: InputMaybe<CommunityCreateWithoutChallengeContributionsInput>;
  update?: InputMaybe<CommunityUpdateToOneWithWhereWithoutChallengeContributionsInput>;
  upsert?: InputMaybe<CommunityUpsertWithoutChallengeContributionsInput>;
};

export type CommunityUpdateToOneWithWhereWithoutChallengeContributionsInput = {
  data: CommunityUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<CommunityWhereInput>;
};

export type CommunityUpdateWithWhereUniqueWithoutCompanyInput = {
  data: CommunityUpdateWithoutCompanyInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpdateWithWhereUniqueWithoutDeedsInput = {
  data: CommunityUpdateWithoutDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpdateWithWhereUniqueWithoutNonprofitsInput = {
  data: CommunityUpdateWithoutNonprofitsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpdateWithWhereUniqueWithoutOrganizingDeedsInput = {
  data: CommunityUpdateWithoutOrganizingDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpdateWithoutChallengeContributionsInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCommunityCompaniesNestedInput>;
  Deeds?: InputMaybe<DeedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateWithoutCompanyInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutTeamNestedInput>;
  Deeds?: InputMaybe<DeedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateWithoutDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutTeamNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutCommunityCompaniesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateWithoutNonprofitsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutTeamNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutCommunityCompaniesNestedInput>;
  Deeds?: InputMaybe<DeedUpdateManyWithoutCommunitiesNestedInput>;
  OrganizingDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizingCommunitiesNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdateWithoutOrganizingDeedsInput = {
  ChallengeContributions?: InputMaybe<ChallengeContributionUpdateManyWithoutTeamNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutCommunityCompaniesNestedInput>;
  Deeds?: InputMaybe<DeedUpdateManyWithoutCommunitiesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput>;
  allowAllyMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowAnonymousMembers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  backgroundImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  feedIntegrationEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  headerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPrivate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organizingDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceERGId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tileImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCommunityEntityTypeFieldUpdateOperationsInput>;
};

export type CommunityUpdatedeedIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityUpdatenonprofitIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityUpdateorganizingDeedIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityUpsertWithWhereUniqueWithoutCompanyInput = {
  create: CommunityCreateWithoutCompanyInput;
  update: CommunityUpdateWithoutCompanyInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpsertWithWhereUniqueWithoutDeedsInput = {
  create: CommunityCreateWithoutDeedsInput;
  update: CommunityUpdateWithoutDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpsertWithWhereUniqueWithoutNonprofitsInput = {
  create: CommunityCreateWithoutNonprofitsInput;
  update: CommunityUpdateWithoutNonprofitsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpsertWithWhereUniqueWithoutOrganizingDeedsInput = {
  create: CommunityCreateWithoutOrganizingDeedsInput;
  update: CommunityUpdateWithoutOrganizingDeedsInput;
  where: CommunityWhereUniqueInput;
};

export type CommunityUpsertWithoutChallengeContributionsInput = {
  create: CommunityCreateWithoutChallengeContributionsInput;
  update: CommunityUpdateWithoutChallengeContributionsInput;
  where?: InputMaybe<CommunityWhereInput>;
};

export type CommunityUserMembership = {
  __typename?: 'CommunityUserMembership';
  User: BaseUser;
  role: CommunityUserRole;
};

export enum CommunityUserRole {
  Ally = 'Ally',
  Anonymous = 'Anonymous',
  Lead = 'Lead',
  Member = 'Member'
}

export type CommunityWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deeds?: InputMaybe<DeedListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  OrganizingDeeds?: InputMaybe<DeedListRelationFilter>;
  allowAllyMembers?: InputMaybe<BoolNullableFilter>;
  allowAnonymousMembers?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deedIds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  feedIntegrationEnabled?: InputMaybe<BoolNullableFilter>;
  headerImage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  isPrivate?: InputMaybe<BoolNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  organizingDeedIds?: InputMaybe<StringNullableListFilter>;
  sourceERGId?: InputMaybe<StringNullableFilter>;
  tileImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCommunityEntityTypeNullableFilter>;
};

export type CommunityWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  ChallengeContributions?: InputMaybe<ChallengeContributionListRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deeds?: InputMaybe<DeedListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<CommunityWhereInput>>>;
  OrganizingDeeds?: InputMaybe<DeedListRelationFilter>;
  allowAllyMembers?: InputMaybe<BoolNullableFilter>;
  allowAnonymousMembers?: InputMaybe<BoolNullableFilter>;
  backgroundImage?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deedIds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  feedIntegrationEnabled?: InputMaybe<BoolNullableFilter>;
  headerImage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<StringNullableFilter>;
  isPrivate?: InputMaybe<BoolNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  organizingDeedIds?: InputMaybe<StringNullableListFilter>;
  sourceERGId?: InputMaybe<StringNullableFilter>;
  tileImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCommunityEntityTypeNullableFilter>;
};

export type CompanyFeature = {
  __typename?: 'CompanyFeature';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  locations: Array<Scalars['String']['output']>;
  locationsExclude?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyFeatureCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyFeatureCreatelocationsInput = {
  set: Scalars['String']['input'];
};

export type CompanyFeatureNullableCompositeFilter = {
  equals?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  is?: InputMaybe<CompanyFeatureWhereInput>;
  isNot?: InputMaybe<CompanyFeatureWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyFeatureNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CompanyFeatureCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CompanyFeatureUpsertInput>;
};

export type CompanyFeatureObjectEqualityInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyFeatureOrderByInput = {
  enabled?: InputMaybe<SortOrder>;
  locations?: InputMaybe<SortOrder>;
  locationsExclude?: InputMaybe<SortOrder>;
};

export type CompanyFeatureUpdateInput = {
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type CompanyFeatureUpdatelocationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyFeatureUpsertInput = {
  set: CompanyFeatureCreateInput;
  update: CompanyFeatureUpdateInput;
};

export type CompanyFeatureWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CompanyFeatureWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CompanyFeatureWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CompanyFeatureWhereInput>>>;
  enabled?: InputMaybe<BoolNullableFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  locationsExclude?: InputMaybe<BoolNullableFilter>;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  actionDonationRewardRequired?: Maybe<Scalars['Boolean']['output']>;
  additionalVolunteerTimeQuestions: Array<Question>;
  allowCampaignAttachmentToLoggedHours?: Maybe<Scalars['Boolean']['output']>;
  allowCustomCoverImageSubmission?: Maybe<Scalars['Boolean']['output']>;
  allowSSOWithoutEmail?: Maybe<Scalars['Boolean']['output']>;
  allowVtoForExternalDeed?: Maybe<Scalars['Boolean']['output']>;
  applicationFees?: Maybe<ApplicationFees>;
  autoApprovalVolunteerTime?: Maybe<Scalars['Boolean']['output']>;
  autoLoggingVolunteerTime?: Maybe<Scalars['Boolean']['output']>;
  autoMatching?: Maybe<Scalars['Boolean']['output']>;
  corporateOnlyToggleDefault?: Maybe<Scalars['Boolean']['output']>;
  deedApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  deedFeeCapUSD?: Maybe<Scalars['Float']['output']>;
  disableEmployeeLocationUpdate?: Maybe<Scalars['Boolean']['output']>;
  disableSocialSharing?: Maybe<Scalars['Boolean']['output']>;
  disabledOpportunityProviders: Array<OpportunityProvider>;
  displayPendingBatchFiles?: Maybe<Scalars['Boolean']['output']>;
  employeeIdSignUpValidation?: Maybe<Scalars['Boolean']['output']>;
  enableGuestUsers?: Maybe<Scalars['Boolean']['output']>;
  enableMatchingRuleSelection?: Maybe<Scalars['Boolean']['output']>;
  ensureCompanyOnlyCampaigns?: Maybe<Scalars['Boolean']['output']>;
  ensureCompanyOnlyDeeds?: Maybe<Scalars['Boolean']['output']>;
  ensurePartnerNonprofitsVerificationStatus?: Maybe<Scalars['Boolean']['output']>;
  externalDonationTypes: Array<ExternalDonationType>;
  externalMatchingMinAmount?: Maybe<Scalars['Float']['output']>;
  externalMatchingMinAmountSetting?: Maybe<Scalars['Boolean']['output']>;
  feeCoveredBy?: Maybe<FeeCoveredBy>;
  guestUsersOnly?: Maybe<Scalars['Boolean']['output']>;
  hideExploreSection?: Maybe<Scalars['Boolean']['output']>;
  hidePaypalPaymentMethod?: Maybe<Scalars['Boolean']['output']>;
  isVTOUsageMandatory?: Maybe<Scalars['Boolean']['output']>;
  logHourPeriodAfterEventForCreatorInDays?: Maybe<Scalars['Int']['output']>;
  logHourPeriodAfterEventForUserInDays?: Maybe<Scalars['Int']['output']>;
  logHoursNotesMandatory?: Maybe<Scalars['Boolean']['output']>;
  mappedCompanyLocationRequired?: Maybe<Scalars['Boolean']['output']>;
  notifications?: Maybe<NotificationSettings>;
  onlyOfficerExternalDonations?: Maybe<Scalars['Boolean']['output']>;
  partnerNonprofitsOnly?: Maybe<Scalars['Boolean']['output']>;
  partnershipLogo?: Maybe<Scalars['String']['output']>;
  partnershipWebsiteUrl?: Maybe<Scalars['String']['output']>;
  paypalDisableFunding?: Maybe<Scalars['Json']['output']>;
  postEventAttendanceConfirmation?: Maybe<Scalars['Boolean']['output']>;
  preferStripe?: Maybe<Scalars['Boolean']['output']>;
  searchNonprofitDB?: Maybe<Scalars['Boolean']['output']>;
  secretKeys: Array<SecretKeySettings>;
  showVisibilityForAffiliations?: Maybe<Scalars['Boolean']['output']>;
  sigmaEditAbility?: Maybe<Scalars['Boolean']['output']>;
  skipSendingWelcomeEmail?: Maybe<Scalars['Boolean']['output']>;
  userImportPlaceholderEmails?: Maybe<Scalars['Json']['output']>;
  validateEmailDomains?: Maybe<Scalars['Boolean']['output']>;
  volunteerReward?: Maybe<VolunteerRewardSettings>;
  vtoIncrementsInHours?: Maybe<Scalars['Boolean']['output']>;
  workdayBaseUri?: Maybe<Scalars['String']['output']>;
  workdaySync?: Maybe<Scalars['Boolean']['output']>;
  workdayTenant?: Maybe<Scalars['String']['output']>;
};

export type CompanySettingsCreateInput = {
  actionDonationRewardRequired?: InputMaybe<Scalars['Boolean']['input']>;
  additionalVolunteerTimeQuestions?: InputMaybe<Array<InputMaybe<QuestionCreateInput>>>;
  allowCampaignAttachmentToLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomCoverImageSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSSOWithoutEmail?: InputMaybe<Scalars['Boolean']['input']>;
  allowVtoForExternalDeed?: InputMaybe<Scalars['Boolean']['input']>;
  applicationFees?: InputMaybe<ApplicationFeesCreateInput>;
  autoApprovalVolunteerTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoLoggingVolunteerTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatching?: InputMaybe<Scalars['Boolean']['input']>;
  corporateOnlyToggleDefault?: InputMaybe<Scalars['Boolean']['input']>;
  deedApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  deedFeeCapUSD?: InputMaybe<Scalars['Float']['input']>;
  disableEmployeeLocationUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  disableSocialSharing?: InputMaybe<Scalars['Boolean']['input']>;
  disabledOpportunityProviders?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  displayPendingBatchFiles?: InputMaybe<Scalars['Boolean']['input']>;
  employeeIdSignUpValidation?: InputMaybe<Scalars['Boolean']['input']>;
  enableGuestUsers?: InputMaybe<Scalars['Boolean']['input']>;
  enableMatchingRuleSelection?: InputMaybe<Scalars['Boolean']['input']>;
  ensureCompanyOnlyCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  ensureCompanyOnlyDeeds?: InputMaybe<Scalars['Boolean']['input']>;
  ensurePartnerNonprofitsVerificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  externalDonationTypes?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  externalMatchingMinAmount?: InputMaybe<Scalars['Float']['input']>;
  externalMatchingMinAmountSetting?: InputMaybe<Scalars['Boolean']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  guestUsersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideExploreSection?: InputMaybe<Scalars['Boolean']['input']>;
  hidePaypalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isVTOUsageMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  logHourPeriodAfterEventForCreatorInDays?: InputMaybe<Scalars['Int']['input']>;
  logHourPeriodAfterEventForUserInDays?: InputMaybe<Scalars['Int']['input']>;
  logHoursNotesMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  mappedCompanyLocationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<NotificationSettingsCreateInput>;
  onlyOfficerExternalDonations?: InputMaybe<Scalars['Boolean']['input']>;
  partnerNonprofitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipLogo?: InputMaybe<Scalars['String']['input']>;
  partnershipWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  paypalDisableFunding?: InputMaybe<Scalars['Json']['input']>;
  postEventAttendanceConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  preferStripe?: InputMaybe<Scalars['Boolean']['input']>;
  searchNonprofitDB?: InputMaybe<Scalars['Boolean']['input']>;
  secretKeys?: InputMaybe<Array<InputMaybe<SecretKeySettingsCreateInput>>>;
  showVisibilityForAffiliations?: InputMaybe<Scalars['Boolean']['input']>;
  sigmaEditAbility?: InputMaybe<Scalars['Boolean']['input']>;
  skipSendingWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  userImportPlaceholderEmails?: InputMaybe<Scalars['Json']['input']>;
  validateEmailDomains?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerReward?: InputMaybe<VolunteerRewardSettingsCreateInput>;
  vtoIncrementsInHours?: InputMaybe<Scalars['Boolean']['input']>;
  workdayBaseUri?: InputMaybe<Scalars['String']['input']>;
  workdaySync?: InputMaybe<Scalars['Boolean']['input']>;
  workdayTenant?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySettingsCreatedisabledOpportunityProvidersInput = {
  set: OpportunityProvider;
};

export type CompanySettingsCreateexternalDonationTypesInput = {
  set: ExternalDonationType;
};

export type CompanySettingsNullableCompositeFilter = {
  equals?: InputMaybe<CompanySettingsObjectEqualityInput>;
  is?: InputMaybe<CompanySettingsWhereInput>;
  isNot?: InputMaybe<CompanySettingsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanySettingsNullableCreateEnvelopeInput = {
  set?: InputMaybe<CompanySettingsCreateInput>;
};

export type CompanySettingsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CompanySettingsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CompanySettingsUpsertInput>;
};

export type CompanySettingsObjectEqualityInput = {
  actionDonationRewardRequired?: InputMaybe<Scalars['Boolean']['input']>;
  additionalVolunteerTimeQuestions?: InputMaybe<Array<InputMaybe<QuestionObjectEqualityInput>>>;
  allowCampaignAttachmentToLoggedHours?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomCoverImageSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSSOWithoutEmail?: InputMaybe<Scalars['Boolean']['input']>;
  allowVtoForExternalDeed?: InputMaybe<Scalars['Boolean']['input']>;
  applicationFees?: InputMaybe<ApplicationFeesObjectEqualityInput>;
  autoApprovalVolunteerTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoLoggingVolunteerTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatching?: InputMaybe<Scalars['Boolean']['input']>;
  corporateOnlyToggleDefault?: InputMaybe<Scalars['Boolean']['input']>;
  deedApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  deedFeeCapUSD?: InputMaybe<Scalars['Float']['input']>;
  disableEmployeeLocationUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  disableSocialSharing?: InputMaybe<Scalars['Boolean']['input']>;
  disabledOpportunityProviders?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  displayPendingBatchFiles?: InputMaybe<Scalars['Boolean']['input']>;
  employeeIdSignUpValidation?: InputMaybe<Scalars['Boolean']['input']>;
  enableGuestUsers?: InputMaybe<Scalars['Boolean']['input']>;
  enableMatchingRuleSelection?: InputMaybe<Scalars['Boolean']['input']>;
  ensureCompanyOnlyCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  ensureCompanyOnlyDeeds?: InputMaybe<Scalars['Boolean']['input']>;
  ensurePartnerNonprofitsVerificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  externalDonationTypes?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  externalMatchingMinAmount?: InputMaybe<Scalars['Float']['input']>;
  externalMatchingMinAmountSetting?: InputMaybe<Scalars['Boolean']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  guestUsersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hideExploreSection?: InputMaybe<Scalars['Boolean']['input']>;
  hidePaypalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isVTOUsageMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  logHourPeriodAfterEventForCreatorInDays?: InputMaybe<Scalars['Int']['input']>;
  logHourPeriodAfterEventForUserInDays?: InputMaybe<Scalars['Int']['input']>;
  logHoursNotesMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  mappedCompanyLocationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<NotificationSettingsObjectEqualityInput>;
  onlyOfficerExternalDonations?: InputMaybe<Scalars['Boolean']['input']>;
  partnerNonprofitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipLogo?: InputMaybe<Scalars['String']['input']>;
  partnershipWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  paypalDisableFunding?: InputMaybe<Scalars['Json']['input']>;
  postEventAttendanceConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  preferStripe?: InputMaybe<Scalars['Boolean']['input']>;
  searchNonprofitDB?: InputMaybe<Scalars['Boolean']['input']>;
  secretKeys?: InputMaybe<Array<InputMaybe<SecretKeySettingsObjectEqualityInput>>>;
  showVisibilityForAffiliations?: InputMaybe<Scalars['Boolean']['input']>;
  sigmaEditAbility?: InputMaybe<Scalars['Boolean']['input']>;
  skipSendingWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  userImportPlaceholderEmails?: InputMaybe<Scalars['Json']['input']>;
  validateEmailDomains?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerReward?: InputMaybe<VolunteerRewardSettingsObjectEqualityInput>;
  vtoIncrementsInHours?: InputMaybe<Scalars['Boolean']['input']>;
  workdayBaseUri?: InputMaybe<Scalars['String']['input']>;
  workdaySync?: InputMaybe<Scalars['Boolean']['input']>;
  workdayTenant?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySettingsOrderByInput = {
  actionDonationRewardRequired?: InputMaybe<SortOrder>;
  additionalVolunteerTimeQuestions?: InputMaybe<QuestionOrderByCompositeAggregateInput>;
  allowCampaignAttachmentToLoggedHours?: InputMaybe<SortOrder>;
  allowCustomCoverImageSubmission?: InputMaybe<SortOrder>;
  allowSSOWithoutEmail?: InputMaybe<SortOrder>;
  allowVtoForExternalDeed?: InputMaybe<SortOrder>;
  applicationFees?: InputMaybe<ApplicationFeesOrderByInput>;
  autoApprovalVolunteerTime?: InputMaybe<SortOrder>;
  autoLoggingVolunteerTime?: InputMaybe<SortOrder>;
  autoMatching?: InputMaybe<SortOrder>;
  corporateOnlyToggleDefault?: InputMaybe<SortOrder>;
  deedApprovalRequired?: InputMaybe<SortOrder>;
  deedFeeCapUSD?: InputMaybe<SortOrder>;
  disableEmployeeLocationUpdate?: InputMaybe<SortOrder>;
  disableSocialSharing?: InputMaybe<SortOrder>;
  disabledOpportunityProviders?: InputMaybe<SortOrder>;
  displayPendingBatchFiles?: InputMaybe<SortOrder>;
  employeeIdSignUpValidation?: InputMaybe<SortOrder>;
  enableGuestUsers?: InputMaybe<SortOrder>;
  enableMatchingRuleSelection?: InputMaybe<SortOrder>;
  ensureCompanyOnlyCampaigns?: InputMaybe<SortOrder>;
  ensureCompanyOnlyDeeds?: InputMaybe<SortOrder>;
  ensurePartnerNonprofitsVerificationStatus?: InputMaybe<SortOrder>;
  externalDonationTypes?: InputMaybe<SortOrder>;
  externalMatchingMinAmount?: InputMaybe<SortOrder>;
  externalMatchingMinAmountSetting?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  guestUsersOnly?: InputMaybe<SortOrder>;
  hideExploreSection?: InputMaybe<SortOrder>;
  hidePaypalPaymentMethod?: InputMaybe<SortOrder>;
  isVTOUsageMandatory?: InputMaybe<SortOrder>;
  logHourPeriodAfterEventForCreatorInDays?: InputMaybe<SortOrder>;
  logHourPeriodAfterEventForUserInDays?: InputMaybe<SortOrder>;
  logHoursNotesMandatory?: InputMaybe<SortOrder>;
  mappedCompanyLocationRequired?: InputMaybe<SortOrder>;
  notifications?: InputMaybe<NotificationSettingsOrderByInput>;
  onlyOfficerExternalDonations?: InputMaybe<SortOrder>;
  partnerNonprofitsOnly?: InputMaybe<SortOrder>;
  partnershipLogo?: InputMaybe<SortOrder>;
  partnershipWebsiteUrl?: InputMaybe<SortOrder>;
  paypalDisableFunding?: InputMaybe<SortOrder>;
  postEventAttendanceConfirmation?: InputMaybe<SortOrder>;
  preferStripe?: InputMaybe<SortOrder>;
  searchNonprofitDB?: InputMaybe<SortOrder>;
  secretKeys?: InputMaybe<SecretKeySettingsOrderByCompositeAggregateInput>;
  showVisibilityForAffiliations?: InputMaybe<SortOrder>;
  sigmaEditAbility?: InputMaybe<SortOrder>;
  skipSendingWelcomeEmail?: InputMaybe<SortOrder>;
  userImportPlaceholderEmails?: InputMaybe<SortOrder>;
  validateEmailDomains?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<VolunteerRewardSettingsOrderByInput>;
  vtoIncrementsInHours?: InputMaybe<SortOrder>;
  workdayBaseUri?: InputMaybe<SortOrder>;
  workdaySync?: InputMaybe<SortOrder>;
  workdayTenant?: InputMaybe<SortOrder>;
};

export type CompanySettingsUpdateInput = {
  actionDonationRewardRequired?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  additionalVolunteerTimeQuestions?: InputMaybe<Array<InputMaybe<QuestionCreateInput>>>;
  allowCampaignAttachmentToLoggedHours?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowCustomCoverImageSubmission?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowSSOWithoutEmail?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowVtoForExternalDeed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  applicationFees?: InputMaybe<ApplicationFeesNullableUpdateEnvelopeInput>;
  autoApprovalVolunteerTime?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoLoggingVolunteerTime?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoMatching?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  corporateOnlyToggleDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deedApprovalRequired?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deedFeeCapUSD?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  disableEmployeeLocationUpdate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  disableSocialSharing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  disabledOpportunityProviders?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  displayPendingBatchFiles?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  employeeIdSignUpValidation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  enableGuestUsers?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  enableMatchingRuleSelection?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ensureCompanyOnlyCampaigns?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ensureCompanyOnlyDeeds?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ensurePartnerNonprofitsVerificationStatus?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  externalDonationTypes?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  externalMatchingMinAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  externalMatchingMinAmountSetting?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  guestUsersOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideExploreSection?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidePaypalPaymentMethod?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isVTOUsageMandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  logHourPeriodAfterEventForCreatorInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  logHourPeriodAfterEventForUserInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  logHoursNotesMandatory?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  mappedCompanyLocationRequired?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationSettingsNullableUpdateEnvelopeInput>;
  onlyOfficerExternalDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnerNonprofitsOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  partnershipLogo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnershipWebsiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paypalDisableFunding?: InputMaybe<Scalars['Json']['input']>;
  postEventAttendanceConfirmation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  preferStripe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  searchNonprofitDB?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  secretKeys?: InputMaybe<Array<InputMaybe<SecretKeySettingsCreateInput>>>;
  showVisibilityForAffiliations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sigmaEditAbility?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipSendingWelcomeEmail?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  userImportPlaceholderEmails?: InputMaybe<Scalars['Json']['input']>;
  validateEmailDomains?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<VolunteerRewardSettingsNullableUpdateEnvelopeInput>;
  vtoIncrementsInHours?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  workdayBaseUri?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workdaySync?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  workdayTenant?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CompanySettingsUpdatedisabledOpportunityProvidersInput = {
  push?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  set?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
};

export type CompanySettingsUpdateexternalDonationTypesInput = {
  push?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  set?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
};

export type CompanySettingsUpsertInput = {
  set: CompanySettingsCreateInput;
  update: CompanySettingsUpdateInput;
};

export type CompanySettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CompanySettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CompanySettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CompanySettingsWhereInput>>>;
  actionDonationRewardRequired?: InputMaybe<BoolNullableFilter>;
  additionalVolunteerTimeQuestions?: InputMaybe<Array<InputMaybe<QuestionObjectEqualityInput>>>;
  allowCampaignAttachmentToLoggedHours?: InputMaybe<BoolNullableFilter>;
  allowCustomCoverImageSubmission?: InputMaybe<BoolNullableFilter>;
  allowSSOWithoutEmail?: InputMaybe<BoolNullableFilter>;
  allowVtoForExternalDeed?: InputMaybe<BoolNullableFilter>;
  applicationFees?: InputMaybe<ApplicationFeesNullableCompositeFilter>;
  autoApprovalVolunteerTime?: InputMaybe<BoolNullableFilter>;
  autoLoggingVolunteerTime?: InputMaybe<BoolNullableFilter>;
  autoMatching?: InputMaybe<BoolNullableFilter>;
  corporateOnlyToggleDefault?: InputMaybe<BoolNullableFilter>;
  deedApprovalRequired?: InputMaybe<BoolNullableFilter>;
  deedFeeCapUSD?: InputMaybe<FloatNullableFilter>;
  disableEmployeeLocationUpdate?: InputMaybe<BoolNullableFilter>;
  disableSocialSharing?: InputMaybe<BoolNullableFilter>;
  disabledOpportunityProviders?: InputMaybe<EnumOpportunityProviderNullableListFilter>;
  displayPendingBatchFiles?: InputMaybe<BoolNullableFilter>;
  employeeIdSignUpValidation?: InputMaybe<BoolNullableFilter>;
  enableGuestUsers?: InputMaybe<BoolNullableFilter>;
  enableMatchingRuleSelection?: InputMaybe<BoolNullableFilter>;
  ensureCompanyOnlyCampaigns?: InputMaybe<BoolNullableFilter>;
  ensureCompanyOnlyDeeds?: InputMaybe<BoolNullableFilter>;
  ensurePartnerNonprofitsVerificationStatus?: InputMaybe<BoolNullableFilter>;
  externalDonationTypes?: InputMaybe<EnumExternalDonationTypeNullableListFilter>;
  externalMatchingMinAmount?: InputMaybe<FloatNullableFilter>;
  externalMatchingMinAmountSetting?: InputMaybe<BoolNullableFilter>;
  feeCoveredBy?: InputMaybe<EnumFeeCoveredByNullableFilter>;
  guestUsersOnly?: InputMaybe<BoolNullableFilter>;
  hideExploreSection?: InputMaybe<BoolNullableFilter>;
  hidePaypalPaymentMethod?: InputMaybe<BoolNullableFilter>;
  isVTOUsageMandatory?: InputMaybe<BoolNullableFilter>;
  logHourPeriodAfterEventForCreatorInDays?: InputMaybe<IntNullableFilter>;
  logHourPeriodAfterEventForUserInDays?: InputMaybe<IntNullableFilter>;
  logHoursNotesMandatory?: InputMaybe<BoolNullableFilter>;
  mappedCompanyLocationRequired?: InputMaybe<BoolNullableFilter>;
  notifications?: InputMaybe<NotificationSettingsNullableCompositeFilter>;
  onlyOfficerExternalDonations?: InputMaybe<BoolNullableFilter>;
  partnerNonprofitsOnly?: InputMaybe<BoolNullableFilter>;
  partnershipLogo?: InputMaybe<StringNullableFilter>;
  partnershipWebsiteUrl?: InputMaybe<StringNullableFilter>;
  paypalDisableFunding?: InputMaybe<JsonNullableFilter>;
  postEventAttendanceConfirmation?: InputMaybe<BoolNullableFilter>;
  preferStripe?: InputMaybe<BoolNullableFilter>;
  searchNonprofitDB?: InputMaybe<BoolNullableFilter>;
  secretKeys?: InputMaybe<Array<InputMaybe<SecretKeySettingsObjectEqualityInput>>>;
  showVisibilityForAffiliations?: InputMaybe<BoolNullableFilter>;
  sigmaEditAbility?: InputMaybe<BoolNullableFilter>;
  skipSendingWelcomeEmail?: InputMaybe<BoolNullableFilter>;
  userImportPlaceholderEmails?: InputMaybe<JsonNullableFilter>;
  validateEmailDomains?: InputMaybe<BoolNullableFilter>;
  volunteerReward?: InputMaybe<VolunteerRewardSettingsNullableCompositeFilter>;
  vtoIncrementsInHours?: InputMaybe<BoolNullableFilter>;
  workdayBaseUri?: InputMaybe<StringNullableFilter>;
  workdaySync?: InputMaybe<BoolNullableFilter>;
  workdayTenant?: InputMaybe<StringNullableFilter>;
};

export type ConfidenceScore = {
  __typename?: 'ConfidenceScore';
  operator: ConfidenceScoreOperator;
  value: Scalars['Float']['output'];
};

export type ConfidenceScoreInput = {
  operator: ConfidenceScoreOperator;
  value: Scalars['Float']['input'];
};

export enum ConfidenceScoreOperator {
  LessOrEqual = 'LESS_OR_EQUAL',
  MoreOrEqual = 'MORE_OR_EQUAL'
}

export type ContactEmail = {
  __typename?: 'ContactEmail';
  email: Scalars['String']['output'];
  verificationExpires?: Maybe<Scalars['DateTime']['output']>;
  verificationToken?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactEmailCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<ContactEmailObjectEqualityInput>>>;
  every?: InputMaybe<ContactEmailWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactEmailWhereInput>;
  some?: InputMaybe<ContactEmailWhereInput>;
};

export type ContactEmailCreateInput = {
  email: Scalars['String']['input'];
  verificationExpires?: InputMaybe<Scalars['DateTime']['input']>;
  verificationToken?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactEmailDeleteManyInput = {
  where: ContactEmailWhereInput;
};

export type ContactEmailListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
};

export type ContactEmailListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<ContactEmailDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<ContactEmailCreateInput>>>;
  updateMany?: InputMaybe<ContactEmailUpdateManyInput>;
};

export type ContactEmailObjectEqualityInput = {
  email: Scalars['String']['input'];
  verificationExpires?: InputMaybe<Scalars['DateTime']['input']>;
  verificationToken?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactEmailOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContactEmailUpdateInput = {
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  verificationExpires?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  verificationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ContactEmailUpdateManyInput = {
  data: ContactEmailUpdateInput;
  where: ContactEmailWhereInput;
};

export type ContactEmailWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ContactEmailWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ContactEmailWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactEmailWhereInput>>>;
  email?: InputMaybe<StringFilter>;
  verificationExpires?: InputMaybe<DateTimeNullableFilter>;
  verificationToken?: InputMaybe<StringNullableFilter>;
  verified?: InputMaybe<BoolNullableFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ContentFilters = {
  __typename?: 'ContentFilters';
  nonprofits?: Maybe<ContentFiltersType>;
};

export type ContentFiltersCreateInput = {
  nonprofits?: InputMaybe<ContentFiltersTypeCreateInput>;
};

export type ContentFiltersNullableCompositeFilter = {
  equals?: InputMaybe<ContentFiltersObjectEqualityInput>;
  is?: InputMaybe<ContentFiltersWhereInput>;
  isNot?: InputMaybe<ContentFiltersWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentFiltersNullableCreateEnvelopeInput = {
  set?: InputMaybe<ContentFiltersCreateInput>;
};

export type ContentFiltersNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ContentFiltersCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ContentFiltersUpsertInput>;
};

export type ContentFiltersObjectEqualityInput = {
  nonprofits?: InputMaybe<ContentFiltersTypeObjectEqualityInput>;
};

export type ContentFiltersOrderByInput = {
  nonprofits?: InputMaybe<ContentFiltersTypeOrderByInput>;
};

export type ContentFiltersType = {
  __typename?: 'ContentFiltersType';
  causes?: Maybe<CauseFilter>;
  eins?: Maybe<StringExcludeFilter>;
  externalCategories?: Maybe<ExternalCategoriesFilter>;
  externalIds?: Maybe<StringExcludeFilter>;
  keywords?: Maybe<StringExcludeFilter>;
  locations?: Maybe<LocationFilter>;
  nonprofitEntityType?: Maybe<NonprofitEntityTypeExcludeFilter>;
  organizationIds?: Maybe<StringAllowFilter>;
  verificationStatus?: Maybe<VerificationStatusExcludeFilter>;
};

export type ContentFiltersTypeCreateInput = {
  causes?: InputMaybe<CauseFilterCreateInput>;
  eins?: InputMaybe<StringExcludeFilterCreateInput>;
  externalCategories?: InputMaybe<ExternalCategoriesFilterCreateInput>;
  externalIds?: InputMaybe<StringExcludeFilterCreateInput>;
  keywords?: InputMaybe<StringExcludeFilterCreateInput>;
  locations?: InputMaybe<LocationFilterCreateInput>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityTypeExcludeFilterCreateInput>;
  organizationIds?: InputMaybe<StringAllowFilterCreateInput>;
  verificationStatus?: InputMaybe<VerificationStatusExcludeFilterCreateInput>;
};

export type ContentFiltersTypeNullableCompositeFilter = {
  equals?: InputMaybe<ContentFiltersTypeObjectEqualityInput>;
  is?: InputMaybe<ContentFiltersTypeWhereInput>;
  isNot?: InputMaybe<ContentFiltersTypeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentFiltersTypeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ContentFiltersTypeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ContentFiltersTypeUpsertInput>;
};

export type ContentFiltersTypeObjectEqualityInput = {
  causes?: InputMaybe<CauseFilterObjectEqualityInput>;
  eins?: InputMaybe<StringExcludeFilterObjectEqualityInput>;
  externalCategories?: InputMaybe<ExternalCategoriesFilterObjectEqualityInput>;
  externalIds?: InputMaybe<StringExcludeFilterObjectEqualityInput>;
  keywords?: InputMaybe<StringExcludeFilterObjectEqualityInput>;
  locations?: InputMaybe<LocationFilterObjectEqualityInput>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityTypeExcludeFilterObjectEqualityInput>;
  organizationIds?: InputMaybe<StringAllowFilterObjectEqualityInput>;
  verificationStatus?: InputMaybe<VerificationStatusExcludeFilterObjectEqualityInput>;
};

export type ContentFiltersTypeOrderByInput = {
  causes?: InputMaybe<CauseFilterOrderByInput>;
  eins?: InputMaybe<StringExcludeFilterOrderByInput>;
  externalCategories?: InputMaybe<ExternalCategoriesFilterOrderByInput>;
  externalIds?: InputMaybe<StringExcludeFilterOrderByInput>;
  keywords?: InputMaybe<StringExcludeFilterOrderByInput>;
  locations?: InputMaybe<LocationFilterOrderByInput>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityTypeExcludeFilterOrderByInput>;
  organizationIds?: InputMaybe<StringAllowFilterOrderByInput>;
  verificationStatus?: InputMaybe<VerificationStatusExcludeFilterOrderByInput>;
};

export type ContentFiltersTypeUpdateInput = {
  causes?: InputMaybe<CauseFilterNullableUpdateEnvelopeInput>;
  eins?: InputMaybe<StringExcludeFilterNullableUpdateEnvelopeInput>;
  externalCategories?: InputMaybe<ExternalCategoriesFilterNullableUpdateEnvelopeInput>;
  externalIds?: InputMaybe<StringExcludeFilterNullableUpdateEnvelopeInput>;
  keywords?: InputMaybe<StringExcludeFilterNullableUpdateEnvelopeInput>;
  locations?: InputMaybe<LocationFilterNullableUpdateEnvelopeInput>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityTypeExcludeFilterNullableUpdateEnvelopeInput>;
  organizationIds?: InputMaybe<StringAllowFilterNullableUpdateEnvelopeInput>;
  verificationStatus?: InputMaybe<VerificationStatusExcludeFilterNullableUpdateEnvelopeInput>;
};

export type ContentFiltersTypeUpsertInput = {
  set: ContentFiltersTypeCreateInput;
  update: ContentFiltersTypeUpdateInput;
};

export type ContentFiltersTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ContentFiltersTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ContentFiltersTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentFiltersTypeWhereInput>>>;
  causes?: InputMaybe<CauseFilterNullableCompositeFilter>;
  eins?: InputMaybe<StringExcludeFilterNullableCompositeFilter>;
  externalCategories?: InputMaybe<ExternalCategoriesFilterNullableCompositeFilter>;
  externalIds?: InputMaybe<StringExcludeFilterNullableCompositeFilter>;
  keywords?: InputMaybe<StringExcludeFilterNullableCompositeFilter>;
  locations?: InputMaybe<LocationFilterNullableCompositeFilter>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityTypeExcludeFilterNullableCompositeFilter>;
  organizationIds?: InputMaybe<StringAllowFilterNullableCompositeFilter>;
  verificationStatus?: InputMaybe<VerificationStatusExcludeFilterNullableCompositeFilter>;
};

export type ContentFiltersUpdateInput = {
  nonprofits?: InputMaybe<ContentFiltersTypeNullableUpdateEnvelopeInput>;
};

export type ContentFiltersUpsertInput = {
  set: ContentFiltersCreateInput;
  update: ContentFiltersUpdateInput;
};

export type ContentFiltersWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ContentFiltersWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ContentFiltersWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentFiltersWhereInput>>>;
  nonprofits?: InputMaybe<ContentFiltersTypeNullableCompositeFilter>;
};

export enum ContributionUnit {
  ActionsCompleted = 'actionsCompleted'
}

export type CorporateProgram = {
  __typename?: 'CorporateProgram';
  Company: Organization;
  Donation: Array<Donation>;
  Partners: Array<Partner>;
  _count: CorporateProgramCountOutputType;
  attributeDefinition?: Maybe<Scalars['Json']['output']>;
  companyId: Scalars['String']['output'];
  defaultAttributeOption?: Maybe<Scalars['String']['output']>;
  disbursementPipeline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<CorporateProgramMetaData>;
  name: Scalars['String']['output'];
  status: CorporateProgramStatus;
};


export type CorporateProgramDonationArgs = {
  cursor?: InputMaybe<DonationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DonationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DonationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DonationWhereInput>;
};


export type CorporateProgramPartnersArgs = {
  cursor?: InputMaybe<PartnerWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<PartnerScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<PartnerOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerWhereInput>;
};

export type CorporateProgramCompanyIdNameCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CorporateProgramCountAggregateOutputType = {
  __typename?: 'CorporateProgramCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  attributeDefinition: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  defaultAttributeOption: Scalars['Int']['output'];
  disbursementPipeline: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type CorporateProgramCountOrderByAggregateInput = {
  attributeDefinition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
  disbursementPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CorporateProgramCountOutputType = {
  __typename?: 'CorporateProgramCountOutputType';
  Donation: Scalars['Int']['output'];
  Partners: Scalars['Int']['output'];
};

export type CorporateProgramCreateInput = {
  Company: OrganizationCreateNestedOneWithoutCorporateProgramsInput;
  Donation?: InputMaybe<DonationCreateNestedManyWithoutCorporateProgramInput>;
  Partners?: InputMaybe<PartnerCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramCreateManyCompanyInput = {
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramCreateManyCompanyInputEnvelope = {
  data: CorporateProgramCreateManyCompanyInput;
};

export type CorporateProgramCreateManyInput = {
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId: Scalars['String']['input'];
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CorporateProgramCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CorporateProgramCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CorporateProgramCreateManyCompanyInputEnvelope>;
};

export type CorporateProgramCreateNestedOneWithoutDonationInput = {
  connect?: InputMaybe<CorporateProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CorporateProgramCreateOrConnectWithoutDonationInput>;
  create?: InputMaybe<CorporateProgramCreateWithoutDonationInput>;
};

export type CorporateProgramCreateNestedOneWithoutPartnersInput = {
  connect?: InputMaybe<CorporateProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CorporateProgramCreateOrConnectWithoutPartnersInput>;
  create?: InputMaybe<CorporateProgramCreateWithoutPartnersInput>;
};

export type CorporateProgramCreateOrConnectWithoutCompanyInput = {
  create: CorporateProgramCreateWithoutCompanyInput;
  where: CorporateProgramWhereUniqueInput;
};

export type CorporateProgramCreateOrConnectWithoutDonationInput = {
  create: CorporateProgramCreateWithoutDonationInput;
  where: CorporateProgramWhereUniqueInput;
};

export type CorporateProgramCreateOrConnectWithoutPartnersInput = {
  create: CorporateProgramCreateWithoutPartnersInput;
  where: CorporateProgramWhereUniqueInput;
};

export type CorporateProgramCreateWithoutCompanyInput = {
  Donation?: InputMaybe<DonationCreateNestedManyWithoutCorporateProgramInput>;
  Partners?: InputMaybe<PartnerCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramCreateWithoutDonationInput = {
  Company: OrganizationCreateNestedOneWithoutCorporateProgramsInput;
  Partners?: InputMaybe<PartnerCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramCreateWithoutPartnersInput = {
  Company: OrganizationCreateNestedOneWithoutCorporateProgramsInput;
  Donation?: InputMaybe<DonationCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramListRelationFilter = {
  every?: InputMaybe<CorporateProgramWhereInput>;
  none?: InputMaybe<CorporateProgramWhereInput>;
  some?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramMaxAggregateOutputType = {
  __typename?: 'CorporateProgramMaxAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  defaultAttributeOption?: Maybe<Scalars['String']['output']>;
  disbursementPipeline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CorporateProgramStatus>;
};

export type CorporateProgramMaxOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
  disbursementPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CorporateProgramMetaData = {
  __typename?: 'CorporateProgramMetaData';
  applicationFees?: Maybe<ApplicationFees>;
  donationProvider?: Maybe<Scalars['String']['output']>;
  hideMatchTracker?: Maybe<Scalars['Boolean']['output']>;
  postDonation?: Maybe<CorporateProgramMetaDataPostDonation>;
  taxBenefitInformation?: Maybe<Scalars['String']['output']>;
};

export type CorporateProgramMetaDataCreateInput = {
  applicationFees?: InputMaybe<ApplicationFeesCreateInput>;
  donationProvider?: InputMaybe<Scalars['String']['input']>;
  hideMatchTracker?: InputMaybe<Scalars['Boolean']['input']>;
  postDonation?: InputMaybe<CorporateProgramMetaDataPostDonationCreateInput>;
  taxBenefitInformation?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateProgramMetaDataNullableCompositeFilter = {
  equals?: InputMaybe<CorporateProgramMetaDataObjectEqualityInput>;
  is?: InputMaybe<CorporateProgramMetaDataWhereInput>;
  isNot?: InputMaybe<CorporateProgramMetaDataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CorporateProgramMetaDataNullableCreateEnvelopeInput = {
  set?: InputMaybe<CorporateProgramMetaDataCreateInput>;
};

export type CorporateProgramMetaDataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CorporateProgramMetaDataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CorporateProgramMetaDataUpsertInput>;
};

export type CorporateProgramMetaDataObjectEqualityInput = {
  applicationFees?: InputMaybe<ApplicationFeesObjectEqualityInput>;
  donationProvider?: InputMaybe<Scalars['String']['input']>;
  hideMatchTracker?: InputMaybe<Scalars['Boolean']['input']>;
  postDonation?: InputMaybe<CorporateProgramMetaDataPostDonationObjectEqualityInput>;
  taxBenefitInformation?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateProgramMetaDataOrderByInput = {
  applicationFees?: InputMaybe<ApplicationFeesOrderByInput>;
  donationProvider?: InputMaybe<SortOrder>;
  hideMatchTracker?: InputMaybe<SortOrder>;
  postDonation?: InputMaybe<CorporateProgramMetaDataPostDonationOrderByInput>;
  taxBenefitInformation?: InputMaybe<SortOrder>;
};

export type CorporateProgramMetaDataPostDonation = {
  __typename?: 'CorporateProgramMetaDataPostDonation';
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CorporateProgramMetaDataPostDonationCreateInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateProgramMetaDataPostDonationNullableCompositeFilter = {
  equals?: InputMaybe<CorporateProgramMetaDataPostDonationObjectEqualityInput>;
  is?: InputMaybe<CorporateProgramMetaDataPostDonationWhereInput>;
  isNot?: InputMaybe<CorporateProgramMetaDataPostDonationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CorporateProgramMetaDataPostDonationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CorporateProgramMetaDataPostDonationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<CorporateProgramMetaDataPostDonationUpsertInput>;
};

export type CorporateProgramMetaDataPostDonationObjectEqualityInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateProgramMetaDataPostDonationOrderByInput = {
  text?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type CorporateProgramMetaDataPostDonationUpdateInput = {
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CorporateProgramMetaDataPostDonationUpsertInput = {
  set: CorporateProgramMetaDataPostDonationCreateInput;
  update: CorporateProgramMetaDataPostDonationUpdateInput;
};

export type CorporateProgramMetaDataPostDonationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataPostDonationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataPostDonationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataPostDonationWhereInput>>>;
  text?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type CorporateProgramMetaDataUpdateInput = {
  applicationFees?: InputMaybe<ApplicationFeesNullableUpdateEnvelopeInput>;
  donationProvider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hideMatchTracker?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  postDonation?: InputMaybe<CorporateProgramMetaDataPostDonationNullableUpdateEnvelopeInput>;
  taxBenefitInformation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CorporateProgramMetaDataUpsertInput = {
  set: CorporateProgramMetaDataCreateInput;
  update: CorporateProgramMetaDataUpdateInput;
};

export type CorporateProgramMetaDataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramMetaDataWhereInput>>>;
  applicationFees?: InputMaybe<ApplicationFeesNullableCompositeFilter>;
  donationProvider?: InputMaybe<StringNullableFilter>;
  hideMatchTracker?: InputMaybe<BoolNullableFilter>;
  postDonation?: InputMaybe<CorporateProgramMetaDataPostDonationNullableCompositeFilter>;
  taxBenefitInformation?: InputMaybe<StringNullableFilter>;
};

export type CorporateProgramMinAggregateOutputType = {
  __typename?: 'CorporateProgramMinAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  defaultAttributeOption?: Maybe<Scalars['String']['output']>;
  disbursementPipeline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CorporateProgramStatus>;
};

export type CorporateProgramMinOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
  disbursementPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CorporateProgramNullableRelationFilter = {
  is?: InputMaybe<CorporateProgramWhereInput>;
  isNot?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CorporateProgramOrderByWithAggregationInput = {
  _count?: InputMaybe<CorporateProgramCountOrderByAggregateInput>;
  _max?: InputMaybe<CorporateProgramMaxOrderByAggregateInput>;
  _min?: InputMaybe<CorporateProgramMinOrderByAggregateInput>;
  attributeDefinition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
  disbursementPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CorporateProgramOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Donation?: InputMaybe<DonationOrderByRelationAggregateInput>;
  Partners?: InputMaybe<PartnerOrderByRelationAggregateInput>;
  attributeDefinition?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
  disbursementPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<CorporateProgramMetaDataOrderByInput>;
  name?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CorporateProgramRelationFilter = {
  is?: InputMaybe<CorporateProgramWhereInput>;
  isNot?: InputMaybe<CorporateProgramWhereInput>;
};

export enum CorporateProgramScalarFieldEnum {
  AttributeDefinition = 'attributeDefinition',
  CompanyId = 'companyId',
  DefaultAttributeOption = 'defaultAttributeOption',
  DisbursementPipeline = 'disbursementPipeline',
  Id = 'id',
  Name = 'name',
  Status = 'status'
}

export type CorporateProgramScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereInput>>>;
  attributeDefinition?: InputMaybe<JsonNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  defaultAttributeOption?: InputMaybe<StringNullableFilter>;
  disbursementPipeline?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumCorporateProgramStatusFilter>;
};

export type CorporateProgramScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereWithAggregatesInput>>>;
  attributeDefinition?: InputMaybe<JsonNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  defaultAttributeOption?: InputMaybe<StringNullableWithAggregatesFilter>;
  disbursementPipeline?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumCorporateProgramStatusWithAggregatesFilter>;
};

export enum CorporateProgramStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type CorporateProgramUncheckedCreateInput = {
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  Partners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId: Scalars['String']['input'];
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CorporateProgramCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CorporateProgramCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CorporateProgramCreateManyCompanyInputEnvelope>;
};

export type CorporateProgramUncheckedCreateWithoutCompanyInput = {
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  Partners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramUncheckedCreateWithoutDonationInput = {
  Partners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId: Scalars['String']['input'];
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramUncheckedCreateWithoutPartnersInput = {
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCorporateProgramInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId: Scalars['String']['input'];
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
  disbursementPipeline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  status: CorporateProgramStatus;
};

export type CorporateProgramUncheckedUpdateInput = {
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  Partners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUncheckedUpdateManyInput = {
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUncheckedUpdateManyWithoutCompanyInput = {
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CorporateProgramCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CorporateProgramCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CorporateProgramCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CorporateProgramUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CorporateProgramUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CorporateProgramUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type CorporateProgramUncheckedUpdateWithoutCompanyInput = {
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  Partners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUncheckedUpdateWithoutDonationInput = {
  Partners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUncheckedUpdateWithoutPartnersInput = {
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCorporateProgramsNestedInput>;
  Donation?: InputMaybe<DonationUpdateManyWithoutCorporateProgramNestedInput>;
  Partners?: InputMaybe<PartnerUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpdateManyMutationInput = {
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpdateManyWithWhereWithoutCompanyInput = {
  data: CorporateProgramUpdateManyMutationInput;
  where: CorporateProgramScalarWhereInput;
};

export type CorporateProgramUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CorporateProgramCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<CorporateProgramCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<CorporateProgramCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CorporateProgramScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CorporateProgramWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CorporateProgramUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CorporateProgramUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CorporateProgramUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type CorporateProgramUpdateOneRequiredWithoutPartnersNestedInput = {
  connect?: InputMaybe<CorporateProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CorporateProgramCreateOrConnectWithoutPartnersInput>;
  create?: InputMaybe<CorporateProgramCreateWithoutPartnersInput>;
  update?: InputMaybe<CorporateProgramUpdateToOneWithWhereWithoutPartnersInput>;
  upsert?: InputMaybe<CorporateProgramUpsertWithoutPartnersInput>;
};

export type CorporateProgramUpdateOneWithoutDonationNestedInput = {
  connect?: InputMaybe<CorporateProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CorporateProgramCreateOrConnectWithoutDonationInput>;
  create?: InputMaybe<CorporateProgramCreateWithoutDonationInput>;
  delete?: InputMaybe<CorporateProgramWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<CorporateProgramUpdateToOneWithWhereWithoutDonationInput>;
  upsert?: InputMaybe<CorporateProgramUpsertWithoutDonationInput>;
};

export type CorporateProgramUpdateToOneWithWhereWithoutDonationInput = {
  data: CorporateProgramUpdateWithoutDonationInput;
  where?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramUpdateToOneWithWhereWithoutPartnersInput = {
  data: CorporateProgramUpdateWithoutPartnersInput;
  where?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramUpdateWithWhereUniqueWithoutCompanyInput = {
  data: CorporateProgramUpdateWithoutCompanyInput;
  where: CorporateProgramWhereUniqueInput;
};

export type CorporateProgramUpdateWithoutCompanyInput = {
  Donation?: InputMaybe<DonationUpdateManyWithoutCorporateProgramNestedInput>;
  Partners?: InputMaybe<PartnerUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpdateWithoutDonationInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCorporateProgramsNestedInput>;
  Partners?: InputMaybe<PartnerUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpdateWithoutPartnersInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCorporateProgramsNestedInput>;
  Donation?: InputMaybe<DonationUpdateManyWithoutCorporateProgramNestedInput>;
  attributeDefinition?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disbursementPipeline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCorporateProgramStatusFieldUpdateOperationsInput>;
};

export type CorporateProgramUpsertWithWhereUniqueWithoutCompanyInput = {
  create: CorporateProgramCreateWithoutCompanyInput;
  update: CorporateProgramUpdateWithoutCompanyInput;
  where: CorporateProgramWhereUniqueInput;
};

export type CorporateProgramUpsertWithoutDonationInput = {
  create: CorporateProgramCreateWithoutDonationInput;
  update: CorporateProgramUpdateWithoutDonationInput;
  where?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramUpsertWithoutPartnersInput = {
  create: CorporateProgramCreateWithoutPartnersInput;
  update: CorporateProgramUpdateWithoutPartnersInput;
  where?: InputMaybe<CorporateProgramWhereInput>;
};

export type CorporateProgramWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Donation?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  Partners?: InputMaybe<PartnerListRelationFilter>;
  attributeDefinition?: InputMaybe<JsonNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  defaultAttributeOption?: InputMaybe<StringNullableFilter>;
  disbursementPipeline?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCompositeFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumCorporateProgramStatusFilter>;
};

export type CorporateProgramWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Donation?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateProgramWhereInput>>>;
  Partners?: InputMaybe<PartnerListRelationFilter>;
  attributeDefinition?: InputMaybe<JsonNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  companyId_name?: InputMaybe<CorporateProgramCompanyIdNameCompoundUniqueInput>;
  defaultAttributeOption?: InputMaybe<StringNullableFilter>;
  disbursementPipeline?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CorporateProgramMetaDataNullableCompositeFilter>;
  name?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumCorporateProgramStatusFilter>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
};

export type CountryCode = {
  __typename?: 'CountryCode';
  countryCode?: Maybe<Scalars['String']['output']>;
};

export type CountryCodeCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<CountryCodeObjectEqualityInput>>>;
  every?: InputMaybe<CountryCodeWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CountryCodeWhereInput>;
  some?: InputMaybe<CountryCodeWhereInput>;
};

export type CountryCodeCreateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryCodeDeleteManyInput = {
  where: CountryCodeWhereInput;
};

export type CountryCodeListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<CountryCodeDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<CountryCodeCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<CountryCodeCreateInput>>>;
  updateMany?: InputMaybe<CountryCodeUpdateManyInput>;
};

export type CountryCodeObjectEqualityInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryCodeOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CountryCodeUpdateInput = {
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CountryCodeUpdateManyInput = {
  data: CountryCodeUpdateInput;
  where: CountryCodeWhereInput;
};

export type CountryCodeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CountryCodeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CountryCodeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CountryCodeWhereInput>>>;
  countryCode?: InputMaybe<StringNullableFilter>;
};

export type CreateChapterRequestInput = {
  email: Scalars['String']['input'];
  identifiers: Array<InputMaybe<NonprofitIdentifierEntryStrictInput>>;
  locationObject: LocationInput;
  nonprofitName: Scalars['String']['input'];
  parentNonprofitId: Scalars['String']['input'];
  users: Array<InputMaybe<ChapterRequestUserInput>>;
};

export type CreateVolunteerTimesResponseItem = {
  __typename?: 'CreateVolunteerTimesResponseItem';
  errorCode?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  volunteerTime?: Maybe<VolunteerTime>;
};

/** A map of currencies */
export type CurrenciesMap = {
  __typename?: 'CurrenciesMap';
  ARS?: Maybe<Scalars['Float']['output']>;
  AUD?: Maybe<Scalars['Float']['output']>;
  BOB?: Maybe<Scalars['Float']['output']>;
  BRL?: Maybe<Scalars['Float']['output']>;
  CAD?: Maybe<Scalars['Float']['output']>;
  CHF?: Maybe<Scalars['Float']['output']>;
  CLP?: Maybe<Scalars['Float']['output']>;
  CNY?: Maybe<Scalars['Float']['output']>;
  COP?: Maybe<Scalars['Float']['output']>;
  CRC?: Maybe<Scalars['Float']['output']>;
  CZK?: Maybe<Scalars['Float']['output']>;
  DKK?: Maybe<Scalars['Float']['output']>;
  EUR?: Maybe<Scalars['Float']['output']>;
  GBP?: Maybe<Scalars['Float']['output']>;
  HKD?: Maybe<Scalars['Float']['output']>;
  HUF?: Maybe<Scalars['Float']['output']>;
  IDR?: Maybe<Scalars['Float']['output']>;
  ILS?: Maybe<Scalars['Float']['output']>;
  INR?: Maybe<Scalars['Float']['output']>;
  JPY?: Maybe<Scalars['Float']['output']>;
  KRW?: Maybe<Scalars['Float']['output']>;
  KZT?: Maybe<Scalars['Float']['output']>;
  MXN?: Maybe<Scalars['Float']['output']>;
  NOK?: Maybe<Scalars['Float']['output']>;
  NZD?: Maybe<Scalars['Float']['output']>;
  PEN?: Maybe<Scalars['Float']['output']>;
  PHP?: Maybe<Scalars['Float']['output']>;
  PLN?: Maybe<Scalars['Float']['output']>;
  RON?: Maybe<Scalars['Float']['output']>;
  SEK?: Maybe<Scalars['Float']['output']>;
  SGD?: Maybe<Scalars['Float']['output']>;
  THB?: Maybe<Scalars['Float']['output']>;
  TRY?: Maybe<Scalars['Float']['output']>;
  UAH?: Maybe<Scalars['Float']['output']>;
  USD?: Maybe<Scalars['Float']['output']>;
  VND?: Maybe<Scalars['Float']['output']>;
  ZAR?: Maybe<Scalars['Float']['output']>;
};

export enum Currency {
  Ars = 'ARS',
  Aud = 'AUD',
  Bob = 'BOB',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Kzt = 'KZT',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pen = 'PEN',
  Php = 'PHP',
  Pln = 'PLN',
  Ron = 'RON',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Uah = 'UAH',
  Usd = 'USD',
  Vnd = 'VND',
  Zar = 'ZAR'
}

/** currency mapping */
export type CurrencyMapping = {
  __typename?: 'CurrencyMapping';
  ARS?: Maybe<Scalars['Float']['output']>;
  AUD?: Maybe<Scalars['Float']['output']>;
  BOB?: Maybe<Scalars['Float']['output']>;
  BRL?: Maybe<Scalars['Float']['output']>;
  CAD?: Maybe<Scalars['Float']['output']>;
  CHF?: Maybe<Scalars['Float']['output']>;
  CLP?: Maybe<Scalars['Float']['output']>;
  CNY?: Maybe<Scalars['Float']['output']>;
  COP?: Maybe<Scalars['Float']['output']>;
  CRC?: Maybe<Scalars['Float']['output']>;
  CZK?: Maybe<Scalars['Float']['output']>;
  DKK?: Maybe<Scalars['Float']['output']>;
  EUR?: Maybe<Scalars['Float']['output']>;
  GBP?: Maybe<Scalars['Float']['output']>;
  HKD?: Maybe<Scalars['Float']['output']>;
  HUF?: Maybe<Scalars['Float']['output']>;
  IDR?: Maybe<Scalars['Float']['output']>;
  ILS?: Maybe<Scalars['Float']['output']>;
  INR?: Maybe<Scalars['Float']['output']>;
  JPY?: Maybe<Scalars['Float']['output']>;
  KRW?: Maybe<Scalars['Float']['output']>;
  KZT?: Maybe<Scalars['Float']['output']>;
  MXN?: Maybe<Scalars['Float']['output']>;
  NOK?: Maybe<Scalars['Float']['output']>;
  NZD?: Maybe<Scalars['Float']['output']>;
  PEN?: Maybe<Scalars['Float']['output']>;
  PHP?: Maybe<Scalars['Float']['output']>;
  PLN?: Maybe<Scalars['Float']['output']>;
  RON?: Maybe<Scalars['Float']['output']>;
  SEK?: Maybe<Scalars['Float']['output']>;
  SGD?: Maybe<Scalars['Float']['output']>;
  THB?: Maybe<Scalars['Float']['output']>;
  TRY?: Maybe<Scalars['Float']['output']>;
  UAH?: Maybe<Scalars['Float']['output']>;
  USD?: Maybe<Scalars['Float']['output']>;
  VND?: Maybe<Scalars['Float']['output']>;
  ZAR?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rates: Scalars['Json']['output'];
};

export type CurrencyRateCountAggregateOutputType = {
  __typename?: 'CurrencyRateCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rates: Scalars['Int']['output'];
};

export type CurrencyRateCountOrderByAggregateInput = {
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
};

export type CurrencyRateCreateInput = {
  date: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  rates: Scalars['Json']['input'];
};

export type CurrencyRateCreateManyInput = {
  date: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  rates: Scalars['Json']['input'];
};

export type CurrencyRateMaxAggregateOutputType = {
  __typename?: 'CurrencyRateMaxAggregateOutputType';
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CurrencyRateMaxOrderByAggregateInput = {
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CurrencyRateMinAggregateOutputType = {
  __typename?: 'CurrencyRateMinAggregateOutputType';
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CurrencyRateMinOrderByAggregateInput = {
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CurrencyRateOrderByWithAggregationInput = {
  _count?: InputMaybe<CurrencyRateCountOrderByAggregateInput>;
  _max?: InputMaybe<CurrencyRateMaxOrderByAggregateInput>;
  _min?: InputMaybe<CurrencyRateMinOrderByAggregateInput>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
};

export type CurrencyRateOrderByWithRelationInput = {
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
};

export enum CurrencyRateScalarFieldEnum {
  Date = 'date',
  Id = 'id',
  Rates = 'rates'
}

export type CurrencyRateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CurrencyRateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CurrencyRateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CurrencyRateScalarWhereWithAggregatesInput>>>;
  date?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  rates?: InputMaybe<JsonWithAggregatesFilter>;
};

export type CurrencyRateUncheckedCreateInput = {
  date: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  rates: Scalars['Json']['input'];
};

export type CurrencyRateUncheckedUpdateInput = {
  date?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<Scalars['Json']['input']>;
};

export type CurrencyRateUncheckedUpdateManyInput = {
  date?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<Scalars['Json']['input']>;
};

export type CurrencyRateUpdateInput = {
  date?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<Scalars['Json']['input']>;
};

export type CurrencyRateUpdateManyMutationInput = {
  date?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<Scalars['Json']['input']>;
};

export type CurrencyRateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  date?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  rates?: InputMaybe<JsonFilter>;
};

export type CurrencyRateWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CurrencyRateWhereInput>>>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rates?: InputMaybe<JsonFilter>;
};

export type CustomAwardedBadgeWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type DateTimeNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  has?: InputMaybe<Scalars['DateTime']['input']>;
  hasEvery?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  hasSome?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum DeductionTransferMode {
  LooseCluster = 'LooseCluster',
  Standalone = 'Standalone',
  StrictCluster = 'StrictCluster'
}

export type Deed = {
  __typename?: 'Deed';
  Communities: Array<Community>;
  ERGs: Array<Scalars['String']['output']>;
  /** Deed Nonprofits */
  Nonprofits: Array<Organization>;
  Organization?: Maybe<Organization>;
  /** Communities organizing the deed */
  OrganizingCommunities: Array<Community>;
  Partner?: Maybe<Organization>;
  SDGs: Array<Scalars['String']['output']>;
  _count: DeedCountOutputType;
  attendeeLimit?: Maybe<Scalars['Int']['output']>;
  attendees: Array<Scalars['String']['output']>;
  /** Get the attendees count for the event */
  attendeesCount: Scalars['Int']['output'];
  campaigns: Array<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  communityIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  editors: Array<Scalars['String']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  externalRegistrations?: Maybe<Scalars['Json']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  linkOnly?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<GeoJson>;
  locationObject?: Maybe<LocationObject>;
  milestones?: Maybe<Scalars['Json']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  mustKnows?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitIds: Array<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizerEmail?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  organizerPhone?: Maybe<Scalars['String']['output']>;
  organizingCommunityIds: Array<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  pictures: Array<Scalars['String']['output']>;
  pillars: Array<Scalars['String']['output']>;
  provider?: Maybe<OpportunityProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  provisionalNonprofitData?: Maybe<NonprofitData>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  requireAuthentication?: Maybe<Scalars['Boolean']['output']>;
  sourceOpportunityId?: Maybe<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DeedStatus>;
  submitter?: Maybe<Scalars['String']['output']>;
  syncedWithOpportunityAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type: DeedType;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};


export type DeedCommunitiesArgs = {
  cursor?: InputMaybe<CommunityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CommunityScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CommunityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityWhereInput>;
};


export type DeedNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type DeedOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type DeedOrganizingCommunitiesArgs = {
  cursor?: InputMaybe<CommunityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CommunityScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CommunityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityWhereInput>;
};


export type DeedPartnerArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type DeedAvgAggregateOutputType = {
  __typename?: 'DeedAvgAggregateOutputType';
  attendeeLimit?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type DeedAvgOrderByAggregateInput = {
  attendeeLimit?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
};

export type DeedCountAggregateOutputType = {
  __typename?: 'DeedCountAggregateOutputType';
  ERGs: Scalars['Int']['output'];
  SDGs: Scalars['Int']['output'];
  _all: Scalars['Int']['output'];
  additionalProviderData: Scalars['Int']['output'];
  allowedCountries: Scalars['Int']['output'];
  allowedStates: Scalars['Int']['output'];
  attendeeLimit: Scalars['Int']['output'];
  attendees: Scalars['Int']['output'];
  blocked: Scalars['Int']['output'];
  campaigns: Scalars['Int']['output'];
  categories: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  communityIds: Scalars['Int']['output'];
  companySubsidiaryAccess: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  editors: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  externalLink: Scalars['Int']['output'];
  externalRegistrations: Scalars['Int']['output'];
  featured: Scalars['Int']['output'];
  formIds: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  linkOnly: Scalars['Int']['output'];
  milestones: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  mustKnows: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nonprofitIds: Scalars['Int']['output'];
  optedInCompanyIds: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizerEmail: Scalars['Int']['output'];
  organizerName: Scalars['Int']['output'];
  organizerPhone: Scalars['Int']['output'];
  organizingCommunityIds: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  pictures: Scalars['Int']['output'];
  pillars: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  providerId: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
  registrationEndingAt: Scalars['Int']['output'];
  requireAuthentication: Scalars['Int']['output'];
  shareFormResponses: Scalars['Int']['output'];
  sharedWithCompanyIds: Scalars['Int']['output'];
  sourceOpportunityId: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  submitter: Scalars['Int']['output'];
  syncedWithOpportunityAt: Scalars['Int']['output'];
  timeZone: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  virtual: Scalars['Int']['output'];
  volunteerRewardIds: Scalars['Int']['output'];
};

export type DeedCountOrderByAggregateInput = {
  ERGs?: InputMaybe<SortOrder>;
  SDGs?: InputMaybe<SortOrder>;
  additionalProviderData?: InputMaybe<SortOrder>;
  allowedCountries?: InputMaybe<SortOrder>;
  allowedStates?: InputMaybe<SortOrder>;
  attendeeLimit?: InputMaybe<SortOrder>;
  attendees?: InputMaybe<SortOrder>;
  blocked?: InputMaybe<SortOrder>;
  campaigns?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityIds?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  externalRegistrations?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  formIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkOnly?: InputMaybe<SortOrder>;
  milestones?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  organizerEmail?: InputMaybe<SortOrder>;
  organizerName?: InputMaybe<SortOrder>;
  organizerPhone?: InputMaybe<SortOrder>;
  organizingCommunityIds?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  requireAuthentication?: InputMaybe<SortOrder>;
  shareFormResponses?: InputMaybe<SortOrder>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  sourceOpportunityId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  syncedWithOpportunityAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
  volunteerRewardIds?: InputMaybe<SortOrder>;
};

export type DeedCountOutputType = {
  __typename?: 'DeedCountOutputType';
  Communities: Scalars['Int']['output'];
  FormResponses: Scalars['Int']['output'];
  Forms: Scalars['Int']['output'];
  Nonprofits: Scalars['Int']['output'];
  OptedInCompanies: Scalars['Int']['output'];
  OrganizingCommunities: Scalars['Int']['output'];
  SharedWithCompanies: Scalars['Int']['output'];
  VolunteerRewards: Scalars['Int']['output'];
  VolunteerTime: Scalars['Int']['output'];
  VolunteerTimeOffs: Scalars['Int']['output'];
};

export type DeedCreateErGsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateManyInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateManyOrganizationInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateManyOrganizationInputEnvelope = {
  data: DeedCreateManyOrganizationInput;
};

export type DeedCreateManyPartnerInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateManyPartnerInputEnvelope = {
  data: DeedCreateManyPartnerInput;
};

export type DeedCreateNestedManyWithoutCommunitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutCommunitiesInput>>>;
};

export type DeedCreateNestedManyWithoutFormsInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutFormsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutFormsInput>>>;
};

export type DeedCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutNonprofitsInput>>>;
};

export type DeedCreateNestedManyWithoutOptedInCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOptedInCompaniesInput>>>;
};

export type DeedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<DeedCreateManyOrganizationInputEnvelope>;
};

export type DeedCreateNestedManyWithoutOrganizingCommunitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizingCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizingCommunitiesInput>>>;
};

export type DeedCreateNestedManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutPartnerInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutPartnerInput>>>;
  createMany?: InputMaybe<DeedCreateManyPartnerInputEnvelope>;
};

export type DeedCreateNestedManyWithoutSharedWithCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutSharedWithCompaniesInput>>>;
};

export type DeedCreateNestedOneWithoutFormResponsesInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<DeedCreateWithoutFormResponsesInput>;
};

export type DeedCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerRewardsInput>;
};

export type DeedCreateNestedOneWithoutVolunteerTimeInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerTimeInput>;
};

export type DeedCreateNestedOneWithoutVolunteerTimeOffsInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerTimeOffsInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerTimeOffsInput>;
};

export type DeedCreateOrConnectWithoutCommunitiesInput = {
  create: DeedCreateWithoutCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutFormResponsesInput = {
  create: DeedCreateWithoutFormResponsesInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutFormsInput = {
  create: DeedCreateWithoutFormsInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutNonprofitsInput = {
  create: DeedCreateWithoutNonprofitsInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutOptedInCompaniesInput = {
  create: DeedCreateWithoutOptedInCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutOrganizationInput = {
  create: DeedCreateWithoutOrganizationInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutOrganizingCommunitiesInput = {
  create: DeedCreateWithoutOrganizingCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutPartnerInput = {
  create: DeedCreateWithoutPartnerInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutSharedWithCompaniesInput = {
  create: DeedCreateWithoutSharedWithCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutVolunteerRewardsInput = {
  create: DeedCreateWithoutVolunteerRewardsInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutVolunteerTimeInput = {
  create: DeedCreateWithoutVolunteerTimeInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateOrConnectWithoutVolunteerTimeOffsInput = {
  create: DeedCreateWithoutVolunteerTimeOffsInput;
  where: DeedWhereUniqueInput;
};

export type DeedCreateSdGsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateWithoutCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutFormResponsesInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutFormsInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutNonprofitsInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutOptedInCompaniesInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutOrganizationInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutOrganizingCommunitiesInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutPartnerInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutSharedWithCompaniesInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutVolunteerRewardsInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutVolunteerTimeInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateWithoutVolunteerTimeOffsInput = {
  Communities?: InputMaybe<CommunityCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutOptedInDeedsInput>;
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrganizationDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityCreateNestedManyWithoutOrganizingDeedsInput>;
  Partner?: InputMaybe<OrganizationCreateNestedOneWithoutPartnerDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedCreateallowedCountriesInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateallowedStatesInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateattendeesInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatecampaignsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatecommunityIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateeditorsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateformIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatenonprofitIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateoptedInCompanyIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreateorganizingCommunityIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatepicturesInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatepillarsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatesharedWithCompanyIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedCreatevolunteerRewardIdsInput = {
  set: Scalars['String']['input'];
};

export type DeedListRelationFilter = {
  every?: InputMaybe<DeedWhereInput>;
  none?: InputMaybe<DeedWhereInput>;
  some?: InputMaybe<DeedWhereInput>;
};

export type DeedMaxAggregateOutputType = {
  __typename?: 'DeedMaxAggregateOutputType';
  attendeeLimit?: Maybe<Scalars['Int']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  companySubsidiaryAccess?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkOnly?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  mustKnows?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizerEmail?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  organizerPhone?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<OpportunityProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  requireAuthentication?: Maybe<Scalars['Boolean']['output']>;
  shareFormResponses?: Maybe<Scalars['Boolean']['output']>;
  sourceOpportunityId?: Maybe<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DeedStatus>;
  submitter?: Maybe<Scalars['String']['output']>;
  syncedWithOpportunityAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DeedType>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export type DeedMaxOrderByAggregateInput = {
  attendeeLimit?: InputMaybe<SortOrder>;
  blocked?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkOnly?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  organizerEmail?: InputMaybe<SortOrder>;
  organizerName?: InputMaybe<SortOrder>;
  organizerPhone?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  requireAuthentication?: InputMaybe<SortOrder>;
  shareFormResponses?: InputMaybe<SortOrder>;
  sourceOpportunityId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  syncedWithOpportunityAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export type DeedMinAggregateOutputType = {
  __typename?: 'DeedMinAggregateOutputType';
  attendeeLimit?: Maybe<Scalars['Int']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  companySubsidiaryAccess?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkOnly?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  mustKnows?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizerEmail?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  organizerPhone?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<OpportunityProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  requireAuthentication?: Maybe<Scalars['Boolean']['output']>;
  shareFormResponses?: Maybe<Scalars['Boolean']['output']>;
  sourceOpportunityId?: Maybe<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DeedStatus>;
  submitter?: Maybe<Scalars['String']['output']>;
  syncedWithOpportunityAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DeedType>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export type DeedMinOrderByAggregateInput = {
  attendeeLimit?: InputMaybe<SortOrder>;
  blocked?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkOnly?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  organizerEmail?: InputMaybe<SortOrder>;
  organizerName?: InputMaybe<SortOrder>;
  organizerPhone?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  requireAuthentication?: InputMaybe<SortOrder>;
  shareFormResponses?: InputMaybe<SortOrder>;
  sourceOpportunityId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  syncedWithOpportunityAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

/** Nonprofit details */
export type DeedNonprofit = {
  __typename?: 'DeedNonprofit';
  SDGs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  acceptsDonations?: Maybe<Scalars['Boolean']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  donateViaNonprofitId?: Maybe<Scalars['String']['output']>;
  donationProvider?: Maybe<Scalars['String']['output']>;
  donationProviders?: Maybe<DonationProviderMapType>;
  donationProvidersAvailability?: Maybe<DonationProviderMapType>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifiers?: Maybe<Array<Maybe<NonprofitIdentifierEntryType>>>;
  isChapter?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  locationObject?: Maybe<LocationObject>;
  logo?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  matchForSearchTerm?: Maybe<Scalars['String']['output']>;
  matchableRule?: Maybe<MatchableRule>;
  matchableRules?: Maybe<Scalars['Json']['output']>;
  matchingBudgetId?: Maybe<Scalars['String']['output']>;
  matchingMaximumCurrencies?: Maybe<CurrencyMapping>;
  matchingPaymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  matchingPaymentMethodsExclude?: Maybe<Scalars['Boolean']['output']>;
  matchingPercentage?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<NonprofitMeta>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<Scalars['String']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  payPalModel?: Maybe<Scalars['String']['output']>;
  paypalCharityType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  searchTermMatchScore?: Maybe<Scalars['Float']['output']>;
  taxonomy?: Maybe<Taxonomy>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type DeedNullableRelationFilter = {
  is?: InputMaybe<DeedWhereInput>;
  isNot?: InputMaybe<DeedWhereInput>;
};

export type DeedOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DeedOrderByWithAggregationInput = {
  ERGs?: InputMaybe<SortOrder>;
  SDGs?: InputMaybe<SortOrder>;
  _avg?: InputMaybe<DeedAvgOrderByAggregateInput>;
  _count?: InputMaybe<DeedCountOrderByAggregateInput>;
  _max?: InputMaybe<DeedMaxOrderByAggregateInput>;
  _min?: InputMaybe<DeedMinOrderByAggregateInput>;
  _sum?: InputMaybe<DeedSumOrderByAggregateInput>;
  additionalProviderData?: InputMaybe<SortOrder>;
  allowedCountries?: InputMaybe<SortOrder>;
  allowedStates?: InputMaybe<SortOrder>;
  attendeeLimit?: InputMaybe<SortOrder>;
  attendees?: InputMaybe<SortOrder>;
  blocked?: InputMaybe<SortOrder>;
  campaigns?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityIds?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  externalRegistrations?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  formIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkOnly?: InputMaybe<SortOrder>;
  milestones?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  organizerEmail?: InputMaybe<SortOrder>;
  organizerName?: InputMaybe<SortOrder>;
  organizerPhone?: InputMaybe<SortOrder>;
  organizingCommunityIds?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  requireAuthentication?: InputMaybe<SortOrder>;
  shareFormResponses?: InputMaybe<SortOrder>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  sourceOpportunityId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  syncedWithOpportunityAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
  volunteerRewardIds?: InputMaybe<SortOrder>;
};

export type DeedOrderByWithRelationInput = {
  Communities?: InputMaybe<CommunityOrderByRelationAggregateInput>;
  ERGs?: InputMaybe<SortOrder>;
  FormResponses?: InputMaybe<FormResponseOrderByRelationAggregateInput>;
  Forms?: InputMaybe<FormOrderByRelationAggregateInput>;
  Nonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  OptedInCompanies?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  OrganizingCommunities?: InputMaybe<CommunityOrderByRelationAggregateInput>;
  Partner?: InputMaybe<OrganizationOrderByWithRelationInput>;
  SDGs?: InputMaybe<SortOrder>;
  SharedWithCompanies?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeOrderByRelationAggregateInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffOrderByRelationAggregateInput>;
  additionalProviderData?: InputMaybe<SortOrder>;
  allowedCountries?: InputMaybe<SortOrder>;
  allowedStates?: InputMaybe<SortOrder>;
  attendeeLimit?: InputMaybe<SortOrder>;
  attendees?: InputMaybe<SortOrder>;
  blocked?: InputMaybe<SortOrder>;
  campaigns?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityIds?: InputMaybe<SortOrder>;
  companySubsidiaryAccess?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  editors?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  externalLinkFollows?: InputMaybe<ExternalLinkFollowsOrderByCompositeAggregateInput>;
  externalRegistrations?: InputMaybe<SortOrder>;
  featured?: InputMaybe<SortOrder>;
  formIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  linkOnly?: InputMaybe<SortOrder>;
  location?: InputMaybe<GeoJsonOrderByInput>;
  locationObject?: InputMaybe<LocationObjectOrderByInput>;
  milestones?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitIds?: InputMaybe<SortOrder>;
  optedInCompanyIds?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  organizerEmail?: InputMaybe<SortOrder>;
  organizerName?: InputMaybe<SortOrder>;
  organizerPhone?: InputMaybe<SortOrder>;
  organizingCommunityIds?: InputMaybe<SortOrder>;
  partnerId?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataOrderByInput>;
  public?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  requireAuthentication?: InputMaybe<SortOrder>;
  roles?: InputMaybe<DeedRoleOrderByCompositeAggregateInput>;
  shareFormResponses?: InputMaybe<SortOrder>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  sourceOpportunityId?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  submitter?: InputMaybe<SortOrder>;
  syncedWithOpportunityAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
  volunteerRewardIds?: InputMaybe<SortOrder>;
};

export type DeedProviderProviderIdPartnerIdCompoundUniqueInput = {
  partnerId: Scalars['String']['input'];
  provider: OpportunityProvider;
  providerId: Scalars['String']['input'];
};

export type DeedRole = {
  __typename?: 'DeedRole';
  applicants: Array<Scalars['String']['output']>;
  approved: Array<Scalars['String']['output']>;
  autoApproval?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationMax: Scalars['Int']['output'];
  durationMin: Scalars['Int']['output'];
  durationUnit: DurationUnit;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  estimatedHoursMax?: Maybe<Scalars['Int']['output']>;
  estimatedHoursMin?: Maybe<Scalars['Int']['output']>;
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  mode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rejected: Array<Scalars['String']['output']>;
  reminders?: Maybe<Scalars['Json']['output']>;
  requiredAmount?: Maybe<Scalars['Int']['output']>;
  skills: Array<Skill>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeedRoleCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<DeedRoleObjectEqualityInput>>>;
  every?: InputMaybe<DeedRoleWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeedRoleWhereInput>;
  some?: InputMaybe<DeedRoleWhereInput>;
};

export type DeedRoleCreateInput = {
  applicants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoApproval?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMax: Scalars['Int']['input'];
  durationMin: Scalars['Int']['input'];
  durationUnit: DurationUnit;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHoursMax?: InputMaybe<Scalars['Int']['input']>;
  estimatedHoursMin?: InputMaybe<Scalars['Int']['input']>;
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rejected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reminders?: InputMaybe<Scalars['Json']['input']>;
  requiredAmount?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<SkillCreateInput>>>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeedRoleCreateapplicantsInput = {
  set: Scalars['String']['input'];
};

export type DeedRoleCreateapprovedInput = {
  set: Scalars['String']['input'];
};

export type DeedRoleCreaterejectedInput = {
  set: Scalars['String']['input'];
};

export type DeedRoleDeleteManyInput = {
  where: DeedRoleWhereInput;
};

export type DeedRoleListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
};

export type DeedRoleListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<DeedRoleDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  updateMany?: InputMaybe<DeedRoleUpdateManyInput>;
};

export type DeedRoleNullableCompositeFilter = {
  equals?: InputMaybe<DeedRoleObjectEqualityInput>;
  is?: InputMaybe<DeedRoleWhereInput>;
  isNot?: InputMaybe<DeedRoleWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeedRoleNullableCreateEnvelopeInput = {
  set?: InputMaybe<DeedRoleCreateInput>;
};

export type DeedRoleNullableUpdateEnvelopeInput = {
  set?: InputMaybe<DeedRoleCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<DeedRoleUpsertInput>;
};

export type DeedRoleObjectEqualityInput = {
  applicants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoApproval?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMax: Scalars['Int']['input'];
  durationMin: Scalars['Int']['input'];
  durationUnit: DurationUnit;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHoursMax?: InputMaybe<Scalars['Int']['input']>;
  estimatedHoursMin?: InputMaybe<Scalars['Int']['input']>;
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rejected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reminders?: InputMaybe<Scalars['Json']['input']>;
  requiredAmount?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<SkillObjectEqualityInput>>>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeedRoleOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DeedRoleOrderByInput = {
  applicants?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  autoApproval?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  durationMax?: InputMaybe<SortOrder>;
  durationMin?: InputMaybe<SortOrder>;
  durationUnit?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  estimatedHoursMax?: InputMaybe<SortOrder>;
  estimatedHoursMin?: InputMaybe<SortOrder>;
  estimatedValue?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mode?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  rejected?: InputMaybe<SortOrder>;
  reminders?: InputMaybe<SortOrder>;
  requiredAmount?: InputMaybe<SortOrder>;
  skills?: InputMaybe<SkillOrderByCompositeAggregateInput>;
  startingAt?: InputMaybe<SortOrder>;
};

export type DeedRoleReduced = {
  __typename?: 'DeedRoleReduced';
  applicants?: Maybe<Array<Maybe<UserObject>>>;
  name?: Maybe<Scalars['String']['output']>;
  requiredAmount?: Maybe<Scalars['Int']['output']>;
};

export type DeedRoleUpdateInput = {
  applicants?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoApproval?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  durationMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  durationMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  durationUnit?: InputMaybe<EnumDurationUnitFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  estimatedHoursMax?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedHoursMin?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  estimatedValue?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  rejected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reminders?: InputMaybe<Scalars['Json']['input']>;
  requiredAmount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  skills?: InputMaybe<Array<InputMaybe<SkillCreateInput>>>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DeedRoleUpdateManyInput = {
  data: DeedRoleUpdateInput;
  where: DeedRoleWhereInput;
};

export type DeedRoleUpdateapplicantsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedRoleUpdateapprovedInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedRoleUpdaterejectedInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedRoleUpsertInput = {
  set: DeedRoleCreateInput;
  update: DeedRoleUpdateInput;
};

export type DeedRoleWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DeedRoleWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DeedRoleWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DeedRoleWhereInput>>>;
  applicants?: InputMaybe<StringNullableListFilter>;
  approved?: InputMaybe<StringNullableListFilter>;
  autoApproval?: InputMaybe<BoolNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  durationMax?: InputMaybe<IntFilter>;
  durationMin?: InputMaybe<IntFilter>;
  durationUnit?: InputMaybe<EnumDurationUnitFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  estimatedHoursMax?: InputMaybe<IntNullableFilter>;
  estimatedHoursMin?: InputMaybe<IntNullableFilter>;
  estimatedValue?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mode?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  rejected?: InputMaybe<StringNullableListFilter>;
  reminders?: InputMaybe<JsonNullableFilter>;
  requiredAmount?: InputMaybe<IntNullableFilter>;
  skills?: InputMaybe<Array<InputMaybe<SkillObjectEqualityInput>>>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum DeedScalarFieldEnum {
  ErGs = 'ERGs',
  SdGs = 'SDGs',
  AdditionalProviderData = 'additionalProviderData',
  AllowedCountries = 'allowedCountries',
  AllowedStates = 'allowedStates',
  AttendeeLimit = 'attendeeLimit',
  Attendees = 'attendees',
  Blocked = 'blocked',
  Campaigns = 'campaigns',
  Categories = 'categories',
  Code = 'code',
  CommunityIds = 'communityIds',
  CompanySubsidiaryAccess = 'companySubsidiaryAccess',
  CreatedAt = 'createdAt',
  Description = 'description',
  Duration = 'duration',
  Editors = 'editors',
  EndingAt = 'endingAt',
  ExternalId = 'externalId',
  ExternalLink = 'externalLink',
  ExternalRegistrations = 'externalRegistrations',
  Featured = 'featured',
  FormIds = 'formIds',
  Id = 'id',
  LinkOnly = 'linkOnly',
  Milestones = 'milestones',
  ModifiedAt = 'modifiedAt',
  MustKnows = 'mustKnows',
  Name = 'name',
  NonprofitIds = 'nonprofitIds',
  OptedInCompanyIds = 'optedInCompanyIds',
  OrganizationId = 'organizationId',
  OrganizerEmail = 'organizerEmail',
  OrganizerName = 'organizerName',
  OrganizerPhone = 'organizerPhone',
  OrganizingCommunityIds = 'organizingCommunityIds',
  PartnerId = 'partnerId',
  Pictures = 'pictures',
  Pillars = 'pillars',
  Provider = 'provider',
  ProviderId = 'providerId',
  Public = 'public',
  Rating = 'rating',
  RegistrationEndingAt = 'registrationEndingAt',
  RequireAuthentication = 'requireAuthentication',
  ShareFormResponses = 'shareFormResponses',
  SharedWithCompanyIds = 'sharedWithCompanyIds',
  SourceOpportunityId = 'sourceOpportunityId',
  StartingAt = 'startingAt',
  Status = 'status',
  Submitter = 'submitter',
  SyncedWithOpportunityAt = 'syncedWithOpportunityAt',
  TimeZone = 'timeZone',
  Type = 'type',
  Virtual = 'virtual',
  VolunteerRewardIds = 'volunteerRewardIds'
}

export type DeedScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  additionalProviderData?: InputMaybe<JsonNullableFilter>;
  allowedCountries?: InputMaybe<StringNullableListFilter>;
  allowedStates?: InputMaybe<StringNullableListFilter>;
  attendeeLimit?: InputMaybe<IntNullableFilter>;
  attendees?: InputMaybe<StringNullableListFilter>;
  blocked?: InputMaybe<BoolNullableFilter>;
  campaigns?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityIds?: InputMaybe<StringNullableListFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalLink?: InputMaybe<StringNullableFilter>;
  externalRegistrations?: InputMaybe<JsonNullableFilter>;
  featured?: InputMaybe<BoolNullableFilter>;
  formIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  linkOnly?: InputMaybe<BoolNullableFilter>;
  milestones?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  mustKnows?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizerEmail?: InputMaybe<StringNullableFilter>;
  organizerName?: InputMaybe<StringNullableFilter>;
  organizerPhone?: InputMaybe<StringNullableFilter>;
  organizingCommunityIds?: InputMaybe<StringNullableListFilter>;
  partnerId?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  provider?: InputMaybe<EnumOpportunityProviderNullableFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  rating?: InputMaybe<IntNullableFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  requireAuthentication?: InputMaybe<BoolNullableFilter>;
  shareFormResponses?: InputMaybe<BoolNullableFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sourceOpportunityId?: InputMaybe<StringNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumDeedStatusNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  syncedWithOpportunityAt?: InputMaybe<DateTimeNullableFilter>;
  timeZone?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDeedTypeFilter>;
  virtual?: InputMaybe<BoolNullableFilter>;
  volunteerRewardIds?: InputMaybe<StringNullableListFilter>;
};

export type DeedScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DeedScalarWhereWithAggregatesInput>>>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DeedScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DeedScalarWhereWithAggregatesInput>>>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  additionalProviderData?: InputMaybe<JsonNullableWithAggregatesFilter>;
  allowedCountries?: InputMaybe<StringNullableListFilter>;
  allowedStates?: InputMaybe<StringNullableListFilter>;
  attendeeLimit?: InputMaybe<IntNullableWithAggregatesFilter>;
  attendees?: InputMaybe<StringNullableListFilter>;
  blocked?: InputMaybe<BoolNullableWithAggregatesFilter>;
  campaigns?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  communityIds?: InputMaybe<StringNullableListFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalLink?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalRegistrations?: InputMaybe<JsonNullableWithAggregatesFilter>;
  featured?: InputMaybe<BoolNullableWithAggregatesFilter>;
  formIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  linkOnly?: InputMaybe<BoolNullableWithAggregatesFilter>;
  milestones?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  mustKnows?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizerEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizerName?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizerPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
  organizingCommunityIds?: InputMaybe<StringNullableListFilter>;
  partnerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  provider?: InputMaybe<EnumOpportunityProviderNullableWithAggregatesFilter>;
  providerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  rating?: InputMaybe<IntNullableWithAggregatesFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  requireAuthentication?: InputMaybe<BoolNullableWithAggregatesFilter>;
  shareFormResponses?: InputMaybe<BoolNullableWithAggregatesFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sourceOpportunityId?: InputMaybe<StringNullableWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumDeedStatusNullableWithAggregatesFilter>;
  submitter?: InputMaybe<StringNullableWithAggregatesFilter>;
  syncedWithOpportunityAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  timeZone?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDeedTypeWithAggregatesFilter>;
  virtual?: InputMaybe<BoolNullableWithAggregatesFilter>;
  volunteerRewardIds?: InputMaybe<StringNullableListFilter>;
};

export enum DeedStatus {
  Archived = 'archived',
  Draft = 'draft',
  Inactive = 'inactive',
  Pending = 'pending',
  Published = 'published'
}

export enum DeedSubmitter {
  Employees = 'employees',
  Organizers = 'organizers'
}

export type DeedSumAggregateOutputType = {
  __typename?: 'DeedSumAggregateOutputType';
  attendeeLimit?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type DeedSumOrderByAggregateInput = {
  attendeeLimit?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
};

export enum DeedType {
  BaseEvent = 'BaseEvent',
  Campaign = 'Campaign',
  Consultation = 'Consultation',
  Event = 'Event',
  Project = 'Project',
  Service = 'Service'
}

export enum DeedTypeFilters {
  BaseEvent = 'BaseEvent',
  Campaign = 'Campaign',
  Event = 'Event',
  Project = 'Project'
}

export type DeedUncheckedCreateInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateNestedManyWithoutCommunitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutCommunitiesInput>>>;
};

export type DeedUncheckedCreateNestedManyWithoutFormsInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutFormsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutFormsInput>>>;
};

export type DeedUncheckedCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutNonprofitsInput>>>;
};

export type DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOptedInCompaniesInput>>>;
};

export type DeedUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<DeedCreateManyOrganizationInputEnvelope>;
};

export type DeedUncheckedCreateNestedManyWithoutOrganizingCommunitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizingCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizingCommunitiesInput>>>;
};

export type DeedUncheckedCreateNestedManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutPartnerInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutPartnerInput>>>;
  createMany?: InputMaybe<DeedCreateManyPartnerInputEnvelope>;
};

export type DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutSharedWithCompaniesInput>>>;
};

export type DeedUncheckedCreateWithoutCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutFormResponsesInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutFormsInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutNonprofitsInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutOptedInCompaniesInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutOrganizationInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutOrganizingCommunitiesInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutPartnerInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutSharedWithCompaniesInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutVolunteerRewardsInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutVolunteerTimeInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedCreateWithoutVolunteerTimeOffsInput = {
  Communities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutDeedsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutDeedInput>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutDeedsInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutOrganizingDeedsInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<Scalars['Int']['input']>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeoJsonNullableCreateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizerEmail?: InputMaybe<Scalars['String']['input']>;
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerPhone?: InputMaybe<Scalars['String']['input']>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<OpportunityProvider>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCreateEnvelopeInput>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  requireAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DeedStatus>;
  submitter?: InputMaybe<Scalars['String']['input']>;
  syncedWithOpportunityAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: DeedType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutCommunitiesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutCommunitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutCommunitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutCommunitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutCommunitiesInput>>>;
};

export type DeedUncheckedUpdateManyWithoutFormsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutFormsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutFormsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutFormsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutFormsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutFormsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutFormsInput>>>;
};

export type DeedUncheckedUpdateManyWithoutNonprofitsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DeedUncheckedUpdateManyWithoutOptedInCompaniesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOptedInCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOptedInCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOptedInCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOptedInCompaniesInput>>>;
};

export type DeedUncheckedUpdateManyWithoutOrganizationInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<DeedCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type DeedUncheckedUpdateManyWithoutOrganizingCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutOrganizingCommunitiesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizingCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizingCommunitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOrganizingCommunitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOrganizingCommunitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOrganizingCommunitiesInput>>>;
};

export type DeedUncheckedUpdateManyWithoutPartnerInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutPartnerNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutPartnerInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutPartnerInput>>>;
  createMany?: InputMaybe<DeedCreateManyPartnerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutPartnerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutPartnerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutPartnerInput>>>;
};

export type DeedUncheckedUpdateManyWithoutSharedWithCompaniesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutSharedWithCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutSharedWithCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
};

export type DeedUncheckedUpdateWithoutCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutFormResponsesInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutFormsInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutNonprofitsInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutOptedInCompaniesInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutOrganizationInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutOrganizingCommunitiesInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutPartnerInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutSharedWithCompaniesInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutVolunteerRewardsInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutVolunteerTimeInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUncheckedUpdateWithoutVolunteerTimeOffsInput = {
  Communities?: InputMaybe<CommunityUncheckedUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUncheckedUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizingCommunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateErGsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateManyMutationInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateManyWithWhereWithoutCommunitiesInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutFormsInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutNonprofitsInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutOptedInCompaniesInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutOrganizationInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutOrganizingCommunitiesInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutPartnerInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithWhereWithoutSharedWithCompaniesInput = {
  data: DeedUpdateManyMutationInput;
  where: DeedScalarWhereInput;
};

export type DeedUpdateManyWithoutCommunitiesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutCommunitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutCommunitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutCommunitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutCommunitiesInput>>>;
};

export type DeedUpdateManyWithoutFormsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutFormsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutFormsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutFormsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutFormsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutFormsInput>>>;
};

export type DeedUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DeedUpdateManyWithoutOptedInCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOptedInCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOptedInCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOptedInCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOptedInCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOptedInCompaniesInput>>>;
};

export type DeedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<DeedCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type DeedUpdateManyWithoutOrganizingCommunitiesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutOrganizingCommunitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutOrganizingCommunitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutOrganizingCommunitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutOrganizingCommunitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutOrganizingCommunitiesInput>>>;
};

export type DeedUpdateManyWithoutPartnerNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutPartnerInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutPartnerInput>>>;
  createMany?: InputMaybe<DeedCreateManyPartnerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutPartnerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutPartnerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutPartnerInput>>>;
};

export type DeedUpdateManyWithoutSharedWithCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DeedCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<DeedCreateWithoutSharedWithCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DeedScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DeedWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DeedUpdateWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DeedUpdateManyWithWhereWithoutSharedWithCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DeedUpsertWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
};

export type DeedUpdateOneWithoutFormResponsesNestedInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<DeedCreateWithoutFormResponsesInput>;
  delete?: InputMaybe<DeedWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DeedUpdateToOneWithWhereWithoutFormResponsesInput>;
  upsert?: InputMaybe<DeedUpsertWithoutFormResponsesInput>;
};

export type DeedUpdateOneWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerRewardsInput>;
  delete?: InputMaybe<DeedWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DeedUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<DeedUpsertWithoutVolunteerRewardsInput>;
};

export type DeedUpdateOneWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerTimeInput>;
  delete?: InputMaybe<DeedWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DeedUpdateToOneWithWhereWithoutVolunteerTimeInput>;
  upsert?: InputMaybe<DeedUpsertWithoutVolunteerTimeInput>;
};

export type DeedUpdateOneWithoutVolunteerTimeOffsNestedInput = {
  connect?: InputMaybe<DeedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeedCreateOrConnectWithoutVolunteerTimeOffsInput>;
  create?: InputMaybe<DeedCreateWithoutVolunteerTimeOffsInput>;
  delete?: InputMaybe<DeedWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DeedUpdateToOneWithWhereWithoutVolunteerTimeOffsInput>;
  upsert?: InputMaybe<DeedUpsertWithoutVolunteerTimeOffsInput>;
};

export type DeedUpdateSdGsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateToOneWithWhereWithoutFormResponsesInput = {
  data: DeedUpdateWithoutFormResponsesInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: DeedUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpdateToOneWithWhereWithoutVolunteerTimeInput = {
  data: DeedUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpdateToOneWithWhereWithoutVolunteerTimeOffsInput = {
  data: DeedUpdateWithoutVolunteerTimeOffsInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpdateWithWhereUniqueWithoutCommunitiesInput = {
  data: DeedUpdateWithoutCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutFormsInput = {
  data: DeedUpdateWithoutFormsInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutNonprofitsInput = {
  data: DeedUpdateWithoutNonprofitsInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutOptedInCompaniesInput = {
  data: DeedUpdateWithoutOptedInCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: DeedUpdateWithoutOrganizationInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutOrganizingCommunitiesInput = {
  data: DeedUpdateWithoutOrganizingCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutPartnerInput = {
  data: DeedUpdateWithoutPartnerInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithWhereUniqueWithoutSharedWithCompaniesInput = {
  data: DeedUpdateWithoutSharedWithCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpdateWithoutCommunitiesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutFormResponsesInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutFormsInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutNonprofitsInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutOptedInCompaniesInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutOrganizationInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutOrganizingCommunitiesInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutPartnerInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutSharedWithCompaniesInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutVolunteerRewardsInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutVolunteerTimeInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateWithoutVolunteerTimeOffsInput = {
  Communities?: InputMaybe<CommunityUpdateManyWithoutDeedsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutDeedNestedInput>;
  Forms?: InputMaybe<FormUpdateManyWithoutDeedsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutNonprofitDeedsNestedInput>;
  OptedInCompanies?: InputMaybe<OrganizationUpdateManyWithoutOptedInDeedsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneWithoutOrganizationDeedsNestedInput>;
  OrganizingCommunities?: InputMaybe<CommunityUpdateManyWithoutOrganizingDeedsNestedInput>;
  Partner?: InputMaybe<OrganizationUpdateOneWithoutPartnerDeedsNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDeedNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateManyWithoutDeedNestedInput>;
  additionalProviderData?: InputMaybe<Scalars['Json']['input']>;
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendeeLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blocked?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companySubsidiaryAccess?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  editors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  externalRegistrations?: InputMaybe<Scalars['Json']['input']>;
  featured?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  linkOnly?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  milestones?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider?: InputMaybe<NullableEnumOpportunityProviderFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableUpdateEnvelopeInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  rating?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireAuthentication?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleCreateInput>>>;
  shareFormResponses?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sourceOpportunityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDeedStatusFieldUpdateOperationsInput>;
  submitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  syncedWithOpportunityAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDeedTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  volunteerRewardIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateallowedCountriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateallowedStatesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateattendeesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatecampaignsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatecommunityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateeditorsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateformIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatenonprofitIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateoptedInCompanyIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdateorganizingCommunityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatepicturesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatepillarsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatesharedWithCompanyIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpdatevolunteerRewardIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DeedUpsertWithWhereUniqueWithoutCommunitiesInput = {
  create: DeedCreateWithoutCommunitiesInput;
  update: DeedUpdateWithoutCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutFormsInput = {
  create: DeedCreateWithoutFormsInput;
  update: DeedUpdateWithoutFormsInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutNonprofitsInput = {
  create: DeedCreateWithoutNonprofitsInput;
  update: DeedUpdateWithoutNonprofitsInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutOptedInCompaniesInput = {
  create: DeedCreateWithoutOptedInCompaniesInput;
  update: DeedUpdateWithoutOptedInCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: DeedCreateWithoutOrganizationInput;
  update: DeedUpdateWithoutOrganizationInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutOrganizingCommunitiesInput = {
  create: DeedCreateWithoutOrganizingCommunitiesInput;
  update: DeedUpdateWithoutOrganizingCommunitiesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutPartnerInput = {
  create: DeedCreateWithoutPartnerInput;
  update: DeedUpdateWithoutPartnerInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithWhereUniqueWithoutSharedWithCompaniesInput = {
  create: DeedCreateWithoutSharedWithCompaniesInput;
  update: DeedUpdateWithoutSharedWithCompaniesInput;
  where: DeedWhereUniqueInput;
};

export type DeedUpsertWithoutFormResponsesInput = {
  create: DeedCreateWithoutFormResponsesInput;
  update: DeedUpdateWithoutFormResponsesInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpsertWithoutVolunteerRewardsInput = {
  create: DeedCreateWithoutVolunteerRewardsInput;
  update: DeedUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpsertWithoutVolunteerTimeInput = {
  create: DeedCreateWithoutVolunteerTimeInput;
  update: DeedUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedUpsertWithoutVolunteerTimeOffsInput = {
  create: DeedCreateWithoutVolunteerTimeOffsInput;
  update: DeedUpdateWithoutVolunteerTimeOffsInput;
  where?: InputMaybe<DeedWhereInput>;
};

export type DeedWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  Communities?: InputMaybe<CommunityListRelationFilter>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  Forms?: InputMaybe<FormListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  OptedInCompanies?: InputMaybe<OrganizationListRelationFilter>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  OrganizingCommunities?: InputMaybe<CommunityListRelationFilter>;
  Partner?: InputMaybe<OrganizationNullableRelationFilter>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  SharedWithCompanies?: InputMaybe<OrganizationListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeListRelationFilter>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  additionalProviderData?: InputMaybe<JsonNullableFilter>;
  allowedCountries?: InputMaybe<StringNullableListFilter>;
  allowedStates?: InputMaybe<StringNullableListFilter>;
  attendeeLimit?: InputMaybe<IntNullableFilter>;
  attendees?: InputMaybe<StringNullableListFilter>;
  blocked?: InputMaybe<BoolNullableFilter>;
  campaigns?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityIds?: InputMaybe<StringNullableListFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalLink?: InputMaybe<StringNullableFilter>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsObjectEqualityInput>>>;
  externalRegistrations?: InputMaybe<JsonNullableFilter>;
  featured?: InputMaybe<BoolNullableFilter>;
  formIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  linkOnly?: InputMaybe<BoolNullableFilter>;
  location?: InputMaybe<GeoJsonNullableCompositeFilter>;
  locationObject?: InputMaybe<LocationObjectNullableCompositeFilter>;
  milestones?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  mustKnows?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizerEmail?: InputMaybe<StringNullableFilter>;
  organizerName?: InputMaybe<StringNullableFilter>;
  organizerPhone?: InputMaybe<StringNullableFilter>;
  organizingCommunityIds?: InputMaybe<StringNullableListFilter>;
  partnerId?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  provider?: InputMaybe<EnumOpportunityProviderNullableFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCompositeFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  rating?: InputMaybe<IntNullableFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  requireAuthentication?: InputMaybe<BoolNullableFilter>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleObjectEqualityInput>>>;
  shareFormResponses?: InputMaybe<BoolNullableFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sourceOpportunityId?: InputMaybe<StringNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumDeedStatusNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  syncedWithOpportunityAt?: InputMaybe<DateTimeNullableFilter>;
  timeZone?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDeedTypeFilter>;
  virtual?: InputMaybe<BoolNullableFilter>;
  volunteerRewardIds?: InputMaybe<StringNullableListFilter>;
};

export type DeedWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  Communities?: InputMaybe<CommunityListRelationFilter>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  Forms?: InputMaybe<FormListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DeedWhereInput>>>;
  OptedInCompanies?: InputMaybe<OrganizationListRelationFilter>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  OrganizingCommunities?: InputMaybe<CommunityListRelationFilter>;
  Partner?: InputMaybe<OrganizationNullableRelationFilter>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  SharedWithCompanies?: InputMaybe<OrganizationListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeListRelationFilter>;
  VolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  additionalProviderData?: InputMaybe<JsonNullableFilter>;
  allowedCountries?: InputMaybe<StringNullableListFilter>;
  allowedStates?: InputMaybe<StringNullableListFilter>;
  attendeeLimit?: InputMaybe<IntNullableFilter>;
  attendees?: InputMaybe<StringNullableListFilter>;
  blocked?: InputMaybe<BoolNullableFilter>;
  campaigns?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityIds?: InputMaybe<StringNullableListFilter>;
  companySubsidiaryAccess?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  editors?: InputMaybe<StringNullableListFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalLink?: InputMaybe<StringNullableFilter>;
  externalLinkFollows?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsObjectEqualityInput>>>;
  externalRegistrations?: InputMaybe<JsonNullableFilter>;
  featured?: InputMaybe<BoolNullableFilter>;
  formIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  linkOnly?: InputMaybe<BoolNullableFilter>;
  location?: InputMaybe<GeoJsonNullableCompositeFilter>;
  locationObject?: InputMaybe<LocationObjectNullableCompositeFilter>;
  milestones?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  mustKnows?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nonprofitIds?: InputMaybe<StringNullableListFilter>;
  optedInCompanyIds?: InputMaybe<StringNullableListFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizerEmail?: InputMaybe<StringNullableFilter>;
  organizerName?: InputMaybe<StringNullableFilter>;
  organizerPhone?: InputMaybe<StringNullableFilter>;
  organizingCommunityIds?: InputMaybe<StringNullableListFilter>;
  partnerId?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  provider?: InputMaybe<EnumOpportunityProviderNullableFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  provider_providerId_partnerId?: InputMaybe<DeedProviderProviderIdPartnerIdCompoundUniqueInput>;
  provisionalNonprofitData?: InputMaybe<NonprofitDataNullableCompositeFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  rating?: InputMaybe<IntNullableFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  requireAuthentication?: InputMaybe<BoolNullableFilter>;
  roles?: InputMaybe<Array<InputMaybe<DeedRoleObjectEqualityInput>>>;
  shareFormResponses?: InputMaybe<BoolNullableFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sourceOpportunityId?: InputMaybe<StringNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumDeedStatusNullableFilter>;
  submitter?: InputMaybe<StringNullableFilter>;
  syncedWithOpportunityAt?: InputMaybe<DateTimeNullableFilter>;
  timeZone?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDeedTypeFilter>;
  virtual?: InputMaybe<BoolNullableFilter>;
  volunteerRewardIds?: InputMaybe<StringNullableListFilter>;
};

export type DeedsResult = {
  __typename?: 'DeedsResult';
  deeds: Array<ReducedDeed>;
  total: Scalars['Int']['output'];
};

export type DeedsStats = {
  __typename?: 'DeedsStats';
  draftDeedsTotal?: Maybe<Scalars['Float']['output']>;
  pendingReviewDeedsTotal?: Maybe<Scalars['Float']['output']>;
  sharedDeedsTotal?: Maybe<Scalars['Float']['output']>;
};

export type DefaultCorporateProgam = {
  __typename?: 'DefaultCorporateProgam';
  attributeOptions?: Maybe<Scalars['Json']['output']>;
  defaultAttributeOption?: Maybe<Scalars['String']['output']>;
};

export type DefaultCorporateProgamCreateInput = {
  attributeOptions?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultCorporateProgamNullableCompositeFilter = {
  equals?: InputMaybe<DefaultCorporateProgamObjectEqualityInput>;
  is?: InputMaybe<DefaultCorporateProgamWhereInput>;
  isNot?: InputMaybe<DefaultCorporateProgamWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultCorporateProgamNullableUpdateEnvelopeInput = {
  set?: InputMaybe<DefaultCorporateProgamCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<DefaultCorporateProgamUpsertInput>;
};

export type DefaultCorporateProgamObjectEqualityInput = {
  attributeOptions?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultCorporateProgamOrderByInput = {
  attributeOptions?: InputMaybe<SortOrder>;
  defaultAttributeOption?: InputMaybe<SortOrder>;
};

export type DefaultCorporateProgamUpdateInput = {
  attributeOptions?: InputMaybe<Scalars['Json']['input']>;
  defaultAttributeOption?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DefaultCorporateProgamUpsertInput = {
  set: DefaultCorporateProgamCreateInput;
  update: DefaultCorporateProgamUpdateInput;
};

export type DefaultCorporateProgamWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DefaultCorporateProgamWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DefaultCorporateProgamWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DefaultCorporateProgamWhereInput>>>;
  attributeOptions?: InputMaybe<JsonNullableFilter>;
  defaultAttributeOption?: InputMaybe<StringNullableFilter>;
};

export type DisbursementFee = {
  __typename?: 'DisbursementFee';
  applicationFeeAmount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode: BaseCurrencies;
  donationId: Scalars['String']['output'];
  feeType: DisbursementFeeType;
  givingAccountWithdrawalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  provider: ProviderType;
  providerFeeAmount: Scalars['Float']['output'];
};

export type DisbursementFeeAvgAggregateOutputType = {
  __typename?: 'DisbursementFeeAvgAggregateOutputType';
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  providerFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type DisbursementFeeAvgOrderByAggregateInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export type DisbursementFeeCountAggregateOutputType = {
  __typename?: 'DisbursementFeeCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  applicationFeeAmount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  donationId: Scalars['Int']['output'];
  feeType: Scalars['Int']['output'];
  givingAccountWithdrawalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  providerFeeAmount: Scalars['Int']['output'];
};

export type DisbursementFeeCountOrderByAggregateInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  feeType?: InputMaybe<SortOrder>;
  givingAccountWithdrawalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export type DisbursementFeeCreateInput = {
  applicationFeeAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: BaseCurrencies;
  donationId: Scalars['String']['input'];
  feeType: DisbursementFeeType;
  givingAccountWithdrawalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
  providerFeeAmount: Scalars['Float']['input'];
};

export type DisbursementFeeCreateManyInput = {
  applicationFeeAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: BaseCurrencies;
  donationId: Scalars['String']['input'];
  feeType: DisbursementFeeType;
  givingAccountWithdrawalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
  providerFeeAmount: Scalars['Float']['input'];
};

export type DisbursementFeeDonationIdGivingAccountWithdrawalIdFeeTypeCompoundUniqueInput = {
  donationId: Scalars['String']['input'];
  feeType: DisbursementFeeType;
  givingAccountWithdrawalId: Scalars['String']['input'];
};

export type DisbursementFeeMaxAggregateOutputType = {
  __typename?: 'DisbursementFeeMaxAggregateOutputType';
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<BaseCurrencies>;
  donationId?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<DisbursementFeeType>;
  givingAccountWithdrawalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  providerFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type DisbursementFeeMaxOrderByAggregateInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  feeType?: InputMaybe<SortOrder>;
  givingAccountWithdrawalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export type DisbursementFeeMinAggregateOutputType = {
  __typename?: 'DisbursementFeeMinAggregateOutputType';
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<BaseCurrencies>;
  donationId?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<DisbursementFeeType>;
  givingAccountWithdrawalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
  providerFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type DisbursementFeeMinOrderByAggregateInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  feeType?: InputMaybe<SortOrder>;
  givingAccountWithdrawalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export type DisbursementFeeOrderByWithAggregationInput = {
  _avg?: InputMaybe<DisbursementFeeAvgOrderByAggregateInput>;
  _count?: InputMaybe<DisbursementFeeCountOrderByAggregateInput>;
  _max?: InputMaybe<DisbursementFeeMaxOrderByAggregateInput>;
  _min?: InputMaybe<DisbursementFeeMinOrderByAggregateInput>;
  _sum?: InputMaybe<DisbursementFeeSumOrderByAggregateInput>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  feeType?: InputMaybe<SortOrder>;
  givingAccountWithdrawalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export type DisbursementFeeOrderByWithRelationInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  donationId?: InputMaybe<SortOrder>;
  feeType?: InputMaybe<SortOrder>;
  givingAccountWithdrawalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export enum DisbursementFeeScalarFieldEnum {
  ApplicationFeeAmount = 'applicationFeeAmount',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  DonationId = 'donationId',
  FeeType = 'feeType',
  GivingAccountWithdrawalId = 'givingAccountWithdrawalId',
  Id = 'id',
  Provider = 'provider',
  ProviderFeeAmount = 'providerFeeAmount'
}

export type DisbursementFeeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementFeeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementFeeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementFeeScalarWhereWithAggregatesInput>>>;
  applicationFeeAmount?: InputMaybe<FloatWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesWithAggregatesFilter>;
  donationId?: InputMaybe<StringWithAggregatesFilter>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeWithAggregatesFilter>;
  givingAccountWithdrawalId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  provider?: InputMaybe<EnumProviderTypeWithAggregatesFilter>;
  providerFeeAmount?: InputMaybe<FloatWithAggregatesFilter>;
};

export type DisbursementFeeSumAggregateOutputType = {
  __typename?: 'DisbursementFeeSumAggregateOutputType';
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  providerFeeAmount?: Maybe<Scalars['Float']['output']>;
};

export type DisbursementFeeSumOrderByAggregateInput = {
  applicationFeeAmount?: InputMaybe<SortOrder>;
  providerFeeAmount?: InputMaybe<SortOrder>;
};

export enum DisbursementFeeType {
  Corporate = 'Corporate',
  Match = 'Match',
  Payroll = 'Payroll'
}

export type DisbursementFeeUncheckedCreateInput = {
  applicationFeeAmount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: BaseCurrencies;
  donationId: Scalars['String']['input'];
  feeType: DisbursementFeeType;
  givingAccountWithdrawalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
  providerFeeAmount: Scalars['Float']['input'];
};

export type DisbursementFeeUncheckedUpdateInput = {
  applicationFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFieldUpdateOperationsInput>;
  donationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFieldUpdateOperationsInput>;
  givingAccountWithdrawalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  providerFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type DisbursementFeeUncheckedUpdateManyInput = {
  applicationFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFieldUpdateOperationsInput>;
  donationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFieldUpdateOperationsInput>;
  givingAccountWithdrawalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  providerFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type DisbursementFeeUpdateInput = {
  applicationFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFieldUpdateOperationsInput>;
  donationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFieldUpdateOperationsInput>;
  givingAccountWithdrawalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  providerFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type DisbursementFeeUpdateManyMutationInput = {
  applicationFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFieldUpdateOperationsInput>;
  donationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFieldUpdateOperationsInput>;
  givingAccountWithdrawalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  providerFeeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type DisbursementFeeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  applicationFeeAmount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFilter>;
  donationId?: InputMaybe<StringFilter>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFilter>;
  givingAccountWithdrawalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  providerFeeAmount?: InputMaybe<FloatFilter>;
};

export type DisbursementFeeWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementFeeWhereInput>>>;
  applicationFeeAmount?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<EnumBaseCurrenciesFilter>;
  donationId?: InputMaybe<StringFilter>;
  donationId_givingAccountWithdrawalId_feeType?: InputMaybe<DisbursementFeeDonationIdGivingAccountWithdrawalIdFeeTypeCompoundUniqueInput>;
  feeType?: InputMaybe<EnumDisbursementFeeTypeFilter>;
  givingAccountWithdrawalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  providerFeeAmount?: InputMaybe<FloatFilter>;
};

export enum DisbursementInformationFileContentType {
  Csv = 'csv',
  Json = 'json',
  Raw = 'raw',
  Txt = 'txt'
}

export type DisbursementInstruction = {
  __typename?: 'DisbursementInstruction';
  contentType: DisbursementInformationFileContentType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  fileContent?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: DonationProvider;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: DisbursementStatus;
  types: Array<DisbursementType>;
};

export type DisbursementInstructionCountAggregateOutputType = {
  __typename?: 'DisbursementInstructionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  contentType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  fileContent: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  publishedAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  types: Scalars['Int']['output'];
};

export type DisbursementInstructionCountOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  types?: InputMaybe<SortOrder>;
};

export type DisbursementInstructionCreateInput = {
  contentType: DisbursementInformationFileContentType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: DonationProvider;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: DisbursementStatus;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionCreateManyInput = {
  contentType: DisbursementInformationFileContentType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: DonationProvider;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: DisbursementStatus;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionCreatetypesInput = {
  set: DisbursementType;
};

export type DisbursementInstructionMaxAggregateOutputType = {
  __typename?: 'DisbursementInstructionMaxAggregateOutputType';
  contentType?: Maybe<DisbursementInformationFileContentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<DonationProvider>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DisbursementStatus>;
};

export type DisbursementInstructionMaxOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DisbursementInstructionMinAggregateOutputType = {
  __typename?: 'DisbursementInstructionMinAggregateOutputType';
  contentType?: Maybe<DisbursementInformationFileContentType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<DonationProvider>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DisbursementStatus>;
};

export type DisbursementInstructionMinOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DisbursementInstructionOrderByWithAggregationInput = {
  _count?: InputMaybe<DisbursementInstructionCountOrderByAggregateInput>;
  _max?: InputMaybe<DisbursementInstructionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DisbursementInstructionMinOrderByAggregateInput>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  types?: InputMaybe<SortOrder>;
};

export type DisbursementInstructionOrderByWithRelationInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  types?: InputMaybe<SortOrder>;
};

export enum DisbursementInstructionScalarFieldEnum {
  ContentType = 'contentType',
  CreatedAt = 'createdAt',
  Description = 'description',
  FileContent = 'fileContent',
  Id = 'id',
  Identifier = 'identifier',
  ModifiedAt = 'modifiedAt',
  ProcessedAt = 'processedAt',
  Provider = 'provider',
  PublishedAt = 'publishedAt',
  Status = 'status',
  Types = 'types'
}

export type DisbursementInstructionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementInstructionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementInstructionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementInstructionScalarWhereWithAggregatesInput>>>;
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  fileContent?: InputMaybe<JsonNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identifier?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  processedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  provider?: InputMaybe<EnumDonationProviderWithAggregatesFilter>;
  publishedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumDisbursementStatusWithAggregatesFilter>;
  types?: InputMaybe<EnumDisbursementTypeNullableListFilter>;
};

export type DisbursementInstructionUncheckedCreateInput = {
  contentType: DisbursementInformationFileContentType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: DonationProvider;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: DisbursementStatus;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionUncheckedUpdateInput = {
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisbursementStatusFieldUpdateOperationsInput>;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionUncheckedUpdateManyInput = {
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisbursementStatusFieldUpdateOperationsInput>;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionUpdateInput = {
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisbursementStatusFieldUpdateOperationsInput>;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionUpdateManyMutationInput = {
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<Scalars['Json']['input']>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisbursementStatusFieldUpdateOperationsInput>;
  types?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionUpdatetypesInput = {
  push?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
  set?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
};

export type DisbursementInstructionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  fileContent?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumDonationProviderFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumDisbursementStatusFilter>;
  types?: InputMaybe<EnumDisbursementTypeNullableListFilter>;
};

export type DisbursementInstructionWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisbursementInstructionWhereInput>>>;
  contentType?: InputMaybe<EnumDisbursementInformationFileContentTypeFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringFilter>;
  fileContent?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumDonationProviderFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumDisbursementStatusFilter>;
  types?: InputMaybe<EnumDisbursementTypeNullableListFilter>;
};

export enum DisbursementStatus {
  Pending = 'pending',
  Processed = 'processed',
  Processing = 'processing',
  Rejected = 'rejected',
  Stranded = 'stranded'
}

export enum DisbursementType {
  CoveredFee = 'coveredFee',
  DeedCredit = 'deedCredit',
  Donation = 'donation',
  Match = 'match'
}

export type Disclaimer = {
  __typename?: 'Disclaimer';
  buttonText?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentType: DisclaimerContentType;
  disclaimerExpire?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  locations: Array<Scalars['String']['output']>;
  locationsExclude: Scalars['Boolean']['output'];
  startingAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DisclaimerCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<DisclaimerObjectEqualityInput>>>;
  every?: InputMaybe<DisclaimerWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DisclaimerWhereInput>;
  some?: InputMaybe<DisclaimerWhereInput>;
};

export enum DisclaimerContentType {
  Image = 'IMAGE',
  Text = 'TEXT'
}

export type DisclaimerCreateInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  contentType: DisclaimerContentType;
  disclaimerExpire?: InputMaybe<Scalars['Int']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude: Scalars['Boolean']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerCreatelocationsInput = {
  set: Scalars['String']['input'];
};

export type DisclaimerDeleteManyInput = {
  where: DisclaimerWhereInput;
};

export type DisclaimerListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
};

export type DisclaimerListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<DisclaimerDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  updateMany?: InputMaybe<DisclaimerUpdateManyInput>;
};

export type DisclaimerObjectEqualityInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  contentType: DisclaimerContentType;
  disclaimerExpire?: InputMaybe<Scalars['Int']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude: Scalars['Boolean']['input'];
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DisclaimerOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DisclaimerUpdateInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<EnumDisclaimerContentTypeFieldUpdateOperationsInput>;
  disclaimerExpire?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationsExclude?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DisclaimerUpdateManyInput = {
  data: DisclaimerUpdateInput;
  where: DisclaimerWhereInput;
};

export type DisclaimerUpdatelocationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DisclaimerWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DisclaimerWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DisclaimerWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DisclaimerWhereInput>>>;
  buttonText?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<StringFilter>;
  contentType?: InputMaybe<EnumDisclaimerContentTypeFilter>;
  disclaimerExpire?: InputMaybe<IntNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<StringNullableListFilter>;
  locationsExclude?: InputMaybe<BoolFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
};

/** @Pal.omit */
export type Donation = {
  __typename?: 'Donation';
  Company?: Maybe<Organization>;
  CorporateProgram?: Maybe<CorporateProgram>;
  DonationSchedule?: Maybe<DonationSchedule>;
  GivingAccountWithdrawal: GivingAccountWithdrawal;
  Nonprofits: Array<Organization>;
  PayeeNonprofits: Array<Organization>;
  PayrollPayGroup?: Maybe<PayrollPayGroup>;
  PayrollRun?: Maybe<PayrollRun>;
  PayrollRunFlatFile?: Maybe<PayrollRunFlatFile>;
  User?: Maybe<BaseUser>;
  _count: DonationCountOutputType;
  amount: Scalars['Float']['output'];
  amountCurrencies?: Maybe<Scalars['Json']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  billingDetails?: Maybe<BillingDetails>;
  budgetAllocationId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  corporateProgramId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  date: Scalars['DateTime']['output'];
  dedication?: Maybe<Scalars['String']['output']>;
  deductionActual?: Maybe<PayrollDeduction>;
  deductionIntent?: Maybe<PayrollDeduction>;
  description: Scalars['String']['output'];
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementErrors: Array<ProviderDisbursementError>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  donationSchedule?: Maybe<Scalars['String']['output']>;
  donationWithdrawalStatus?: Maybe<Scalars['String']['output']>;
  executionFailure?: Maybe<DonationExecutionFailure>;
  externalDonationType?: Maybe<ExternalDonationType>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  feeCoveredBy?: Maybe<FeeCoveredBy>;
  givingAccountWithdrawal?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForCoveredFees?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForMatch?: Maybe<Scalars['String']['output']>;
  grantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  imported: Scalars['Boolean']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  livemode: Scalars['Boolean']['output'];
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementErrors: Array<ProviderDisbursementError>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  matchedAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  matchingRequestStatus?: Maybe<MatchRequestStatus>;
  metadata?: Maybe<Scalars['Json']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  nonprofitPayoutMapping: Array<NonprofitPayoutMapEntry>;
  nonprofits: Array<Scalars['String']['output']>;
  payeeNonprofits: Array<Scalars['String']['output']>;
  paymentMethodDetails?: Maybe<PaymentMethodDetails>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  payrollRunFlatFileId?: Maybe<Scalars['String']['output']>;
  payrollRunId?: Maybe<Scalars['String']['output']>;
  privacy: DonationPrivacy;
  provider: DonationProvider;
  rescheduledFrom?: Maybe<Scalars['String']['output']>;
  rescheduledTo?: Maybe<Scalars['String']['output']>;
  status: DonationStatus;
  subtype?: Maybe<DonationSubtype>;
  total: Scalars['Float']['output'];
  type?: Maybe<DonationType>;
  userId?: Maybe<Scalars['String']['output']>;
  volunteerRewardId?: Maybe<Scalars['String']['output']>;
  volunteerTimeId?: Maybe<Scalars['String']['output']>;
};


/** @Pal.omit */
export type DonationCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Pal.omit */
export type DonationCorporateProgramArgs = {
  where?: InputMaybe<CorporateProgramWhereInput>;
};


/** @Pal.omit */
export type DonationDonationScheduleArgs = {
  where?: InputMaybe<DonationScheduleWhereInput>;
};


/** @Pal.omit */
export type DonationNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Pal.omit */
export type DonationPayeeNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Pal.omit */
export type DonationPayrollPayGroupArgs = {
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};


/** @Pal.omit */
export type DonationPayrollRunArgs = {
  where?: InputMaybe<PayrollRunWhereInput>;
};


/** @Pal.omit */
export type DonationPayrollRunFlatFileArgs = {
  where?: InputMaybe<PayrollRunFlatFileWhereInput>;
};


/** @Pal.omit */
export type DonationUserArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};

export type DonationAvgAggregateOutputType = {
  __typename?: 'DonationAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type DonationAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
};

export type DonationCountAggregateOutputType = {
  __typename?: 'DonationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  activityIds: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  amountCurrencies: Scalars['Int']['output'];
  applicationFeeAmount: Scalars['Int']['output'];
  budgetAllocationId: Scalars['Int']['output'];
  campaignId: Scalars['Int']['output'];
  cancelledAt: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  corporateProgramId: Scalars['Int']['output'];
  coverFee: Scalars['Int']['output'];
  coveredFeeDisbursedAt: Scalars['Int']['output'];
  coveredFeeDisbursementInstruction: Scalars['Int']['output'];
  coveredFeeDisbursementTransactionIdentifier: Scalars['Int']['output'];
  coveredFeeDisbursementTransactionUrl: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  dedication: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  designation: Scalars['Int']['output'];
  desiredMatchAmount: Scalars['Int']['output'];
  desiredMatchingRule: Scalars['Int']['output'];
  donationDisbursedAt: Scalars['Int']['output'];
  donationDisbursementInstruction: Scalars['Int']['output'];
  donationDisbursementTransactionIdentifier: Scalars['Int']['output'];
  donationDisbursementTransactionUrl: Scalars['Int']['output'];
  donationSchedule: Scalars['Int']['output'];
  externalDonationType: Scalars['Int']['output'];
  feeAmount: Scalars['Int']['output'];
  feeCoveredBy: Scalars['Int']['output'];
  givingAccountWithdrawal: Scalars['Int']['output'];
  givingAccountWithdrawalForCoveredFees: Scalars['Int']['output'];
  givingAccountWithdrawalForMatch: Scalars['Int']['output'];
  grantId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  imported: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  isNew: Scalars['Int']['output'];
  livemode: Scalars['Int']['output'];
  matchDisbursedAt: Scalars['Int']['output'];
  matchDisbursementInstruction: Scalars['Int']['output'];
  matchDisbursementTransactionIdentifier: Scalars['Int']['output'];
  matchDisbursementTransactionUrl: Scalars['Int']['output'];
  matchedAmount: Scalars['Int']['output'];
  matchedAmountCurrencies: Scalars['Int']['output'];
  matchingRequestStatus: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofits: Scalars['Int']['output'];
  payeeNonprofits: Scalars['Int']['output'];
  payrollPayGroupId: Scalars['Int']['output'];
  payrollRunFlatFileId: Scalars['Int']['output'];
  payrollRunId: Scalars['Int']['output'];
  privacy: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  rescheduledFrom: Scalars['Int']['output'];
  rescheduledTo: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  subtype: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  volunteerRewardId: Scalars['Int']['output'];
  volunteerTimeId: Scalars['Int']['output'];
};

export type DonationCountOrderByAggregateInput = {
  activityIds?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  amountCurrencies?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  budgetAllocationId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  donationDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  donationDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  donationSchedule?: InputMaybe<SortOrder>;
  externalDonationType?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  givingAccountWithdrawal?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForMatch?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNew?: InputMaybe<SortOrder>;
  livemode?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  matchDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  matchDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  matchingRequestStatus?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  payrollRunFlatFileId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  rescheduledFrom?: InputMaybe<SortOrder>;
  rescheduledTo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerRewardId?: InputMaybe<SortOrder>;
  volunteerTimeId?: InputMaybe<SortOrder>;
};

export type DonationCountOutputType = {
  __typename?: 'DonationCountOutputType';
  Activities: Scalars['Int']['output'];
  Nonprofits: Scalars['Int']['output'];
  PayeeNonprofits: Scalars['Int']['output'];
  VolunteerRewards: Scalars['Int']['output'];
};

export type DonationCreateInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyCompanyInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyCompanyInputEnvelope = {
  data: DonationCreateManyCompanyInput;
};

export type DonationCreateManyCorporateProgramInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyCorporateProgramInputEnvelope = {
  data: DonationCreateManyCorporateProgramInput;
};

export type DonationCreateManyDonationScheduleInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyDonationScheduleInputEnvelope = {
  data: DonationCreateManyDonationScheduleInput;
};

export type DonationCreateManyInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyPayrollPayGroupInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyPayrollPayGroupInputEnvelope = {
  data: DonationCreateManyPayrollPayGroupInput;
};

export type DonationCreateManyPayrollRunFlatFileInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyPayrollRunFlatFileInputEnvelope = {
  data: DonationCreateManyPayrollRunFlatFileInput;
};

export type DonationCreateManyPayrollRunInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyPayrollRunInputEnvelope = {
  data: DonationCreateManyPayrollRunInput;
};

export type DonationCreateManyUserInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateManyUserInputEnvelope = {
  data: DonationCreateManyUserInput;
};

export type DonationCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationCreateManyCompanyInputEnvelope>;
};

export type DonationCreateNestedManyWithoutCorporateProgramInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<DonationCreateManyCorporateProgramInputEnvelope>;
};

export type DonationCreateNestedManyWithoutDonationScheduleInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutDonationScheduleInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutDonationScheduleInput>>>;
  createMany?: InputMaybe<DonationCreateManyDonationScheduleInputEnvelope>;
};

export type DonationCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutNonprofitsInput>>>;
};

export type DonationCreateNestedManyWithoutPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayeeNonprofitsInput>>>;
};

export type DonationCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollPayGroupInputEnvelope>;
};

export type DonationCreateNestedManyWithoutPayrollRunFlatFileInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunFlatFileInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunFlatFileInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunFlatFileInputEnvelope>;
};

export type DonationCreateNestedManyWithoutPayrollRunInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunInputEnvelope>;
};

export type DonationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationCreateManyUserInputEnvelope>;
};

export type DonationCreateNestedOneWithoutActivitiesInput = {
  connect?: InputMaybe<DonationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<DonationCreateWithoutActivitiesInput>;
};

export type DonationCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<DonationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<DonationCreateWithoutVolunteerRewardsInput>;
};

export type DonationCreateOrConnectWithoutActivitiesInput = {
  create: DonationCreateWithoutActivitiesInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutCompanyInput = {
  create: DonationCreateWithoutCompanyInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutCorporateProgramInput = {
  create: DonationCreateWithoutCorporateProgramInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutDonationScheduleInput = {
  create: DonationCreateWithoutDonationScheduleInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutNonprofitsInput = {
  create: DonationCreateWithoutNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutPayeeNonprofitsInput = {
  create: DonationCreateWithoutPayeeNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutPayrollPayGroupInput = {
  create: DonationCreateWithoutPayrollPayGroupInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutPayrollRunFlatFileInput = {
  create: DonationCreateWithoutPayrollRunFlatFileInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutPayrollRunInput = {
  create: DonationCreateWithoutPayrollRunInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutUserInput = {
  create: DonationCreateWithoutUserInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateOrConnectWithoutVolunteerRewardsInput = {
  create: DonationCreateWithoutVolunteerRewardsInput;
  where: DonationWhereUniqueInput;
};

export type DonationCreateWithoutActivitiesInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutCompanyInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutCorporateProgramInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutDonationScheduleInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutNonprofitsInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutPayeeNonprofitsInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutPayrollPayGroupInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutPayrollRunFlatFileInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutPayrollRunInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutUserInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateWithoutVolunteerRewardsInput = {
  Activities?: InputMaybe<ActivityCreateNestedManyWithoutDonationInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationsInput>;
  CorporateProgram?: InputMaybe<CorporateProgramCreateNestedOneWithoutDonationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleCreateNestedOneWithoutDonationsInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupCreateNestedOneWithoutDonationInput>;
  PayrollRun?: InputMaybe<PayrollRunCreateNestedOneWithoutDonationsInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedOneWithoutDonationsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutDonationsInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationCreateactivityIdsInput = {
  set: Scalars['String']['input'];
};

export type DonationCreatenonprofitsInput = {
  set: Scalars['String']['input'];
};

export type DonationCreatepayeeNonprofitsInput = {
  set: Scalars['String']['input'];
};

/** Type of corporate giving donation disbursement */
export enum DonationDisbursementCorporateGivingType {
  CorporateDonation = 'CorporateDonation',
  CoveredFees = 'CoveredFees',
  DeedCredit = 'DeedCredit',
  Matching = 'Matching'
}

/** Type of donation disbursement */
export enum DonationDisbursementType {
  CorporateDonation = 'CorporateDonation',
  CoveredFees = 'CoveredFees',
  DeedCredit = 'DeedCredit',
  Matching = 'Matching',
  PayrollDonation = 'PayrollDonation'
}

export type DonationExecutionFailure = {
  __typename?: 'DonationExecutionFailure';
  date: Scalars['DateTime']['output'];
  errorCode: DonationExecutionFailureErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type DonationExecutionFailureCreateInput = {
  date: Scalars['DateTime']['input'];
  errorCode: DonationExecutionFailureErrorCode;
  errorMessage: Scalars['String']['input'];
};

export enum DonationExecutionFailureErrorCode {
  DeductionEventCreationFailed = 'Deduction_event_creation_failed',
  DeductionFailed = 'Deduction_failed',
  DeductionMissing = 'Deduction_missing',
  DeductionOrphaned = 'Deduction_orphaned',
  DeductionRetrying = 'Deduction_retrying',
  DeductionValueMismatch = 'Deduction_value_mismatch'
}

export type DonationExecutionFailureNullableCompositeFilter = {
  equals?: InputMaybe<DonationExecutionFailureObjectEqualityInput>;
  is?: InputMaybe<DonationExecutionFailureWhereInput>;
  isNot?: InputMaybe<DonationExecutionFailureWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationExecutionFailureNullableCreateEnvelopeInput = {
  set?: InputMaybe<DonationExecutionFailureCreateInput>;
};

export type DonationExecutionFailureNullableUpdateEnvelopeInput = {
  set?: InputMaybe<DonationExecutionFailureCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<DonationExecutionFailureUpsertInput>;
};

export type DonationExecutionFailureObjectEqualityInput = {
  date: Scalars['DateTime']['input'];
  errorCode: DonationExecutionFailureErrorCode;
  errorMessage: Scalars['String']['input'];
};

export type DonationExecutionFailureOrderByInput = {
  date?: InputMaybe<SortOrder>;
  errorCode?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
};

export type DonationExecutionFailureUpdateInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errorCode?: InputMaybe<EnumDonationExecutionFailureErrorCodeFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationExecutionFailureUpsertInput = {
  set: DonationExecutionFailureCreateInput;
  update: DonationExecutionFailureUpdateInput;
};

export type DonationExecutionFailureWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationExecutionFailureWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationExecutionFailureWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationExecutionFailureWhereInput>>>;
  date?: InputMaybe<DateTimeFilter>;
  errorCode?: InputMaybe<EnumDonationExecutionFailureErrorCodeFilter>;
  errorMessage?: InputMaybe<StringFilter>;
};

export enum DonationFrequency {
  OneTime = 'OneTime',
  P1D = 'P1D',
  P1M = 'P1M',
  P1Y = 'P1Y',
  P3M = 'P3M',
  Pt1H = 'PT1H',
  Payroll = 'Payroll'
}

export type DonationListRelationFilter = {
  every?: InputMaybe<DonationWhereInput>;
  none?: InputMaybe<DonationWhereInput>;
  some?: InputMaybe<DonationWhereInput>;
};

export type DonationMaxAggregateOutputType = {
  __typename?: 'DonationMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  budgetAllocationId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  corporateProgramId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']['output']>;
  dedication?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  donationSchedule?: Maybe<Scalars['String']['output']>;
  externalDonationType?: Maybe<ExternalDonationType>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  feeCoveredBy?: Maybe<FeeCoveredBy>;
  givingAccountWithdrawal?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForCoveredFees?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForMatch?: Maybe<Scalars['String']['output']>;
  grantId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  matchingRequestStatus?: Maybe<MatchRequestStatus>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  payrollRunFlatFileId?: Maybe<Scalars['String']['output']>;
  payrollRunId?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<DonationPrivacy>;
  provider?: Maybe<DonationProvider>;
  rescheduledFrom?: Maybe<Scalars['String']['output']>;
  rescheduledTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DonationStatus>;
  subtype?: Maybe<DonationSubtype>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<DonationType>;
  userId?: Maybe<Scalars['String']['output']>;
  volunteerRewardId?: Maybe<Scalars['String']['output']>;
  volunteerTimeId?: Maybe<Scalars['String']['output']>;
};

export type DonationMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  budgetAllocationId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  donationDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  donationDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  donationSchedule?: InputMaybe<SortOrder>;
  externalDonationType?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  givingAccountWithdrawal?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForMatch?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNew?: InputMaybe<SortOrder>;
  livemode?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  matchDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  matchDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  matchingRequestStatus?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  payrollRunFlatFileId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  rescheduledFrom?: InputMaybe<SortOrder>;
  rescheduledTo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerRewardId?: InputMaybe<SortOrder>;
  volunteerTimeId?: InputMaybe<SortOrder>;
};

export type DonationMinAggregateOutputType = {
  __typename?: 'DonationMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  budgetAllocationId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  corporateProgramId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['DateTime']['output']>;
  dedication?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  donationDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  donationSchedule?: Maybe<Scalars['String']['output']>;
  externalDonationType?: Maybe<ExternalDonationType>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  feeCoveredBy?: Maybe<FeeCoveredBy>;
  givingAccountWithdrawal?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForCoveredFees?: Maybe<Scalars['String']['output']>;
  givingAccountWithdrawalForMatch?: Maybe<Scalars['String']['output']>;
  grantId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  matchDisbursementTransactionUrl?: Maybe<Scalars['String']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  matchingRequestStatus?: Maybe<MatchRequestStatus>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  payrollRunFlatFileId?: Maybe<Scalars['String']['output']>;
  payrollRunId?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<DonationPrivacy>;
  provider?: Maybe<DonationProvider>;
  rescheduledFrom?: Maybe<Scalars['String']['output']>;
  rescheduledTo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DonationStatus>;
  subtype?: Maybe<DonationSubtype>;
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<DonationType>;
  userId?: Maybe<Scalars['String']['output']>;
  volunteerRewardId?: Maybe<Scalars['String']['output']>;
  volunteerTimeId?: Maybe<Scalars['String']['output']>;
};

export type DonationMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  budgetAllocationId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  donationDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  donationDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  donationSchedule?: InputMaybe<SortOrder>;
  externalDonationType?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  givingAccountWithdrawal?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForMatch?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNew?: InputMaybe<SortOrder>;
  livemode?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  matchDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  matchDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  matchingRequestStatus?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  payrollRunFlatFileId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  rescheduledFrom?: InputMaybe<SortOrder>;
  rescheduledTo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerRewardId?: InputMaybe<SortOrder>;
  volunteerTimeId?: InputMaybe<SortOrder>;
};

export type DonationNullableRelationFilter = {
  is?: InputMaybe<DonationWhereInput>;
  isNot?: InputMaybe<DonationWhereInput>;
};

export type DonationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DonationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DonationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DonationCountOrderByAggregateInput>;
  _max?: InputMaybe<DonationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DonationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DonationSumOrderByAggregateInput>;
  activityIds?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  amountCurrencies?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  budgetAllocationId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  donationDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  donationDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  donationSchedule?: InputMaybe<SortOrder>;
  externalDonationType?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  givingAccountWithdrawal?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForMatch?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNew?: InputMaybe<SortOrder>;
  livemode?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  matchDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  matchDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  matchingRequestStatus?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  payrollRunFlatFileId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  rescheduledFrom?: InputMaybe<SortOrder>;
  rescheduledTo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerRewardId?: InputMaybe<SortOrder>;
  volunteerTimeId?: InputMaybe<SortOrder>;
};

export type DonationOrderByWithRelationInput = {
  Activities?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  CorporateProgram?: InputMaybe<CorporateProgramOrderByWithRelationInput>;
  DonationSchedule?: InputMaybe<DonationScheduleOrderByWithRelationInput>;
  Nonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  PayeeNonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupOrderByWithRelationInput>;
  PayrollRun?: InputMaybe<PayrollRunOrderByWithRelationInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  activityIds?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  amountCurrencies?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  billingDetails?: InputMaybe<BillingDetailsOrderByInput>;
  budgetAllocationId?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  deductionActual?: InputMaybe<PayrollDeductionOrderByInput>;
  deductionIntent?: InputMaybe<PayrollDeductionOrderByInput>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementErrors?: InputMaybe<ProviderDisbursementErrorOrderByCompositeAggregateInput>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  donationDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  donationDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  donationSchedule?: InputMaybe<SortOrder>;
  executionFailure?: InputMaybe<DonationExecutionFailureOrderByInput>;
  externalDonationType?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  feeCoveredBy?: InputMaybe<SortOrder>;
  givingAccountWithdrawal?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<SortOrder>;
  givingAccountWithdrawalForMatch?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNew?: InputMaybe<SortOrder>;
  livemode?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementErrors?: InputMaybe<ProviderDisbursementErrorOrderByCompositeAggregateInput>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  matchDisbursementTransactionIdentifier?: InputMaybe<SortOrder>;
  matchDisbursementTransactionUrl?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  matchedAmountCurrencies?: InputMaybe<SortOrder>;
  matchingRequestStatus?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitPayoutMapping?: InputMaybe<NonprofitPayoutMapEntryOrderByCompositeAggregateInput>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsOrderByInput>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  payrollRunFlatFileId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  rescheduledFrom?: InputMaybe<SortOrder>;
  rescheduledTo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerRewardId?: InputMaybe<SortOrder>;
  volunteerTimeId?: InputMaybe<SortOrder>;
};

export enum DonationPayrollPaymentOptionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum DonationPrivacy {
  Anonymous = 'Anonymous',
  Limited = 'Limited',
  Public = 'Public'
}

export enum DonationProvider {
  Betterplace = 'Betterplace',
  Caf = 'CAF',
  Dcgf = 'DCGF',
  External = 'External',
  Give2Asia = 'Give2Asia',
  GiveIndia = 'GiveIndia',
  GlobalGiving = 'GlobalGiving',
  Nfg = 'NFG',
  PayPal = 'PayPal',
  Stripe = 'Stripe'
}

/** Donation provider map */
export type DonationProviderMapType = {
  __typename?: 'DonationProviderMapType';
  Betterplace?: Maybe<Scalars['Boolean']['output']>;
  CAF?: Maybe<Scalars['Boolean']['output']>;
  External?: Maybe<Scalars['Boolean']['output']>;
  Give2Asia?: Maybe<Scalars['Boolean']['output']>;
  GiveIndia?: Maybe<Scalars['Boolean']['output']>;
  GlobalGiving?: Maybe<Scalars['Boolean']['output']>;
  NFG?: Maybe<Scalars['Boolean']['output']>;
  PayPal?: Maybe<Scalars['Boolean']['output']>;
  Stripe?: Maybe<Scalars['Boolean']['output']>;
};

export type DonationProviders = {
  __typename?: 'DonationProviders';
  Betterplace: Scalars['Boolean']['output'];
  CAF: Scalars['Boolean']['output'];
  DCGF: Scalars['Boolean']['output'];
  External: Scalars['Boolean']['output'];
  GiveIndia: Scalars['Boolean']['output'];
  GlobalGiving: Scalars['Boolean']['output'];
  NFG: Scalars['Boolean']['output'];
  PayPal: Scalars['Boolean']['output'];
  Stripe: Scalars['Boolean']['output'];
};

export type DonationProvidersCreateInput = {
  Betterplace?: InputMaybe<Scalars['Boolean']['input']>;
  CAF?: InputMaybe<Scalars['Boolean']['input']>;
  DCGF?: InputMaybe<Scalars['Boolean']['input']>;
  External?: InputMaybe<Scalars['Boolean']['input']>;
  GiveIndia?: InputMaybe<Scalars['Boolean']['input']>;
  GlobalGiving?: InputMaybe<Scalars['Boolean']['input']>;
  NFG?: InputMaybe<Scalars['Boolean']['input']>;
  PayPal?: InputMaybe<Scalars['Boolean']['input']>;
  Stripe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationProvidersNullableCompositeFilter = {
  equals?: InputMaybe<DonationProvidersObjectEqualityInput>;
  is?: InputMaybe<DonationProvidersWhereInput>;
  isNot?: InputMaybe<DonationProvidersWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationProvidersNullableCreateEnvelopeInput = {
  set?: InputMaybe<DonationProvidersCreateInput>;
};

export type DonationProvidersNullableUpdateEnvelopeInput = {
  set?: InputMaybe<DonationProvidersCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<DonationProvidersUpsertInput>;
};

export type DonationProvidersObjectEqualityInput = {
  Betterplace: Scalars['Boolean']['input'];
  CAF: Scalars['Boolean']['input'];
  DCGF: Scalars['Boolean']['input'];
  External: Scalars['Boolean']['input'];
  GiveIndia: Scalars['Boolean']['input'];
  GlobalGiving: Scalars['Boolean']['input'];
  NFG: Scalars['Boolean']['input'];
  PayPal: Scalars['Boolean']['input'];
  Stripe: Scalars['Boolean']['input'];
};

export type DonationProvidersOrderByInput = {
  Betterplace?: InputMaybe<SortOrder>;
  CAF?: InputMaybe<SortOrder>;
  DCGF?: InputMaybe<SortOrder>;
  External?: InputMaybe<SortOrder>;
  GiveIndia?: InputMaybe<SortOrder>;
  GlobalGiving?: InputMaybe<SortOrder>;
  NFG?: InputMaybe<SortOrder>;
  PayPal?: InputMaybe<SortOrder>;
  Stripe?: InputMaybe<SortOrder>;
};

export type DonationProvidersUpdateInput = {
  Betterplace?: InputMaybe<BoolFieldUpdateOperationsInput>;
  CAF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  DCGF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  External?: InputMaybe<BoolFieldUpdateOperationsInput>;
  GiveIndia?: InputMaybe<BoolFieldUpdateOperationsInput>;
  GlobalGiving?: InputMaybe<BoolFieldUpdateOperationsInput>;
  NFG?: InputMaybe<BoolFieldUpdateOperationsInput>;
  PayPal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  Stripe?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DonationProvidersUpsertInput = {
  set: DonationProvidersCreateInput;
  update: DonationProvidersUpdateInput;
};

export type DonationProvidersWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationProvidersWhereInput>>>;
  Betterplace?: InputMaybe<BoolFilter>;
  CAF?: InputMaybe<BoolFilter>;
  DCGF?: InputMaybe<BoolFilter>;
  External?: InputMaybe<BoolFilter>;
  GiveIndia?: InputMaybe<BoolFilter>;
  GlobalGiving?: InputMaybe<BoolFilter>;
  NFG?: InputMaybe<BoolFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DonationProvidersWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationProvidersWhereInput>>>;
  PayPal?: InputMaybe<BoolFilter>;
  Stripe?: InputMaybe<BoolFilter>;
};

export type DonationReceipt = {
  __typename?: 'DonationReceipt';
  id: Scalars['String']['output'];
  parsedReceiptData?: Maybe<ReceiptData>;
  preliminaryConfidenceScore?: Maybe<Scalars['Float']['output']>;
};

export enum DonationScalarFieldEnum {
  ActivityIds = 'activityIds',
  Amount = 'amount',
  AmountCurrencies = 'amountCurrencies',
  ApplicationFeeAmount = 'applicationFeeAmount',
  BudgetAllocationId = 'budgetAllocationId',
  CampaignId = 'campaignId',
  CancelledAt = 'cancelledAt',
  CompanyId = 'companyId',
  CorporateProgramId = 'corporateProgramId',
  CoverFee = 'coverFee',
  CoveredFeeDisbursedAt = 'coveredFeeDisbursedAt',
  CoveredFeeDisbursementInstruction = 'coveredFeeDisbursementInstruction',
  CoveredFeeDisbursementTransactionIdentifier = 'coveredFeeDisbursementTransactionIdentifier',
  CoveredFeeDisbursementTransactionUrl = 'coveredFeeDisbursementTransactionUrl',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Date = 'date',
  Dedication = 'dedication',
  Description = 'description',
  Designation = 'designation',
  DesiredMatchAmount = 'desiredMatchAmount',
  DesiredMatchingRule = 'desiredMatchingRule',
  DonationDisbursedAt = 'donationDisbursedAt',
  DonationDisbursementInstruction = 'donationDisbursementInstruction',
  DonationDisbursementTransactionIdentifier = 'donationDisbursementTransactionIdentifier',
  DonationDisbursementTransactionUrl = 'donationDisbursementTransactionUrl',
  DonationSchedule = 'donationSchedule',
  ExternalDonationType = 'externalDonationType',
  FeeAmount = 'feeAmount',
  FeeCoveredBy = 'feeCoveredBy',
  GivingAccountWithdrawal = 'givingAccountWithdrawal',
  GivingAccountWithdrawalForCoveredFees = 'givingAccountWithdrawalForCoveredFees',
  GivingAccountWithdrawalForMatch = 'givingAccountWithdrawalForMatch',
  GrantId = 'grantId',
  Id = 'id',
  Identifier = 'identifier',
  Imported = 'imported',
  IsActive = 'isActive',
  IsNew = 'isNew',
  Livemode = 'livemode',
  MatchDisbursedAt = 'matchDisbursedAt',
  MatchDisbursementInstruction = 'matchDisbursementInstruction',
  MatchDisbursementTransactionIdentifier = 'matchDisbursementTransactionIdentifier',
  MatchDisbursementTransactionUrl = 'matchDisbursementTransactionUrl',
  MatchedAmount = 'matchedAmount',
  MatchedAmountCurrencies = 'matchedAmountCurrencies',
  MatchingRequestStatus = 'matchingRequestStatus',
  Metadata = 'metadata',
  ModifiedAt = 'modifiedAt',
  Nonprofits = 'nonprofits',
  PayeeNonprofits = 'payeeNonprofits',
  PayrollPayGroupId = 'payrollPayGroupId',
  PayrollRunFlatFileId = 'payrollRunFlatFileId',
  PayrollRunId = 'payrollRunId',
  Privacy = 'privacy',
  Provider = 'provider',
  RescheduledFrom = 'rescheduledFrom',
  RescheduledTo = 'rescheduledTo',
  Status = 'status',
  Subtype = 'subtype',
  Total = 'total',
  Type = 'type',
  UserId = 'userId',
  VolunteerRewardId = 'volunteerRewardId',
  VolunteerTimeId = 'volunteerTimeId'
}

export type DonationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  amount?: InputMaybe<FloatFilter>;
  amountCurrencies?: InputMaybe<JsonNullableFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  budgetAllocationId?: InputMaybe<StringNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  corporateProgramId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  donationSchedule?: InputMaybe<StringNullableFilter>;
  externalDonationType?: InputMaybe<EnumExternalDonationTypeNullableFilter>;
  feeAmount?: InputMaybe<FloatNullableFilter>;
  feeCoveredBy?: InputMaybe<EnumFeeCoveredByNullableFilter>;
  givingAccountWithdrawal?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForMatch?: InputMaybe<StringNullableFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringFilter>;
  imported?: InputMaybe<BoolFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  isNew?: InputMaybe<BoolNullableFilter>;
  livemode?: InputMaybe<BoolFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  matchedAmount?: InputMaybe<FloatNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  matchingRequestStatus?: InputMaybe<EnumMatchRequestStatusNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  payrollRunFlatFileId?: InputMaybe<StringNullableFilter>;
  payrollRunId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyFilter>;
  provider?: InputMaybe<EnumDonationProviderFilter>;
  rescheduledFrom?: InputMaybe<StringNullableFilter>;
  rescheduledTo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDonationStatusFilter>;
  subtype?: InputMaybe<EnumDonationSubtypeNullableFilter>;
  total?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumDonationTypeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  volunteerRewardId?: InputMaybe<StringNullableFilter>;
  volunteerTimeId?: InputMaybe<StringNullableFilter>;
};

export type DonationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationScalarWhereWithAggregatesInput>>>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  amountCurrencies?: InputMaybe<JsonNullableWithAggregatesFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  budgetAllocationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  campaignId?: InputMaybe<StringNullableWithAggregatesFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  corporateProgramId?: InputMaybe<StringNullableWithAggregatesFilter>;
  coverFee?: InputMaybe<BoolNullableWithAggregatesFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currency?: InputMaybe<EnumCurrencyWithAggregatesFilter>;
  date?: InputMaybe<DateTimeWithAggregatesFilter>;
  dedication?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  designation?: InputMaybe<StringNullableWithAggregatesFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationDisbursementTransactionIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationDisbursementTransactionUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationSchedule?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalDonationType?: InputMaybe<EnumExternalDonationTypeNullableWithAggregatesFilter>;
  feeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  feeCoveredBy?: InputMaybe<EnumFeeCoveredByNullableWithAggregatesFilter>;
  givingAccountWithdrawal?: InputMaybe<StringNullableWithAggregatesFilter>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<StringNullableWithAggregatesFilter>;
  givingAccountWithdrawalForMatch?: InputMaybe<StringNullableWithAggregatesFilter>;
  grantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identifier?: InputMaybe<StringWithAggregatesFilter>;
  imported?: InputMaybe<BoolWithAggregatesFilter>;
  isActive?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isNew?: InputMaybe<BoolNullableWithAggregatesFilter>;
  livemode?: InputMaybe<BoolWithAggregatesFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  matchDisbursementTransactionIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  matchDisbursementTransactionUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  matchedAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableWithAggregatesFilter>;
  matchingRequestStatus?: InputMaybe<EnumMatchRequestStatusNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  payrollRunFlatFileId?: InputMaybe<StringNullableWithAggregatesFilter>;
  payrollRunId?: InputMaybe<StringNullableWithAggregatesFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyWithAggregatesFilter>;
  provider?: InputMaybe<EnumDonationProviderWithAggregatesFilter>;
  rescheduledFrom?: InputMaybe<StringNullableWithAggregatesFilter>;
  rescheduledTo?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumDonationStatusWithAggregatesFilter>;
  subtype?: InputMaybe<EnumDonationSubtypeNullableWithAggregatesFilter>;
  total?: InputMaybe<FloatWithAggregatesFilter>;
  type?: InputMaybe<EnumDonationTypeNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringNullableWithAggregatesFilter>;
  volunteerRewardId?: InputMaybe<StringNullableWithAggregatesFilter>;
  volunteerTimeId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationSchedule = {
  __typename?: 'DonationSchedule';
  Campaign?: Maybe<Campaign>;
  Company?: Maybe<Organization>;
  /** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:view, organizationField: companyId)]) */
  Donations: Array<Donation>;
  Nonprofits: Array<Organization>;
  PayeeNonprofits: Array<Organization>;
  User: BaseUser;
  _count: DonationScheduleCountOutputType;
  amount: Scalars['Float']['output'];
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode: Scalars['String']['output'];
  dedication?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donorPrivacy?: Maybe<DonorPrivacy>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  executionFailure: Array<DonationScheduleExecutionFailure>;
  frequency: DonationFrequency;
  grantId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitPayoutMapping: Array<NonprofitPayoutMapEntry>;
  nonprofits: Array<Scalars['String']['output']>;
  payeeNonprofits: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethodDetails;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<DonationPrivacy>;
  projectedTotalAmount?: Maybe<Scalars['Float']['output']>;
  projectedTotalAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['output'];
  status?: Maybe<DonationScheduleStatus>;
  userId: Scalars['String']['output'];
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationScheduleCampaignArgs = {
  where?: InputMaybe<CampaignWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationScheduleCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationScheduleDonationsArgs = {
  cursor?: InputMaybe<DonationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DonationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DonationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DonationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationScheduleNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: donation:schedule:view, organizationField: companyId)]) */
export type DonationSchedulePayeeNonprofitsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<OrganizationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<OrganizationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type DonationScheduleAvgAggregateOutputType = {
  __typename?: 'DonationScheduleAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  projectedTotalAmount?: Maybe<Scalars['Float']['output']>;
};

export type DonationScheduleAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
};

export type DonationScheduleCountAggregateOutputType = {
  __typename?: 'DonationScheduleCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  campaignId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  coverFee: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  dedication: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  designation: Scalars['Int']['output'];
  desiredMatchAmount: Scalars['Int']['output'];
  desiredMatchingRule: Scalars['Int']['output'];
  donorPrivacy: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  frequency: Scalars['Int']['output'];
  grantId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inactivatedAt: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofits: Scalars['Int']['output'];
  payeeNonprofits: Scalars['Int']['output'];
  payrollPayGroupId: Scalars['Int']['output'];
  privacy: Scalars['Int']['output'];
  projectedTotalAmount: Scalars['Int']['output'];
  projectedTotalAmountCurrencies: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type DonationScheduleCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donorPrivacy?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inactivatedAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
  projectedTotalAmountCurrencies?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DonationScheduleCountOutputType = {
  __typename?: 'DonationScheduleCountOutputType';
  Donations: Scalars['Int']['output'];
  Nonprofits: Scalars['Int']['output'];
  PayeeNonprofits: Scalars['Int']['output'];
};

export type DonationScheduleCreateInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateManyCampaignInput = {
  amount: Scalars['Float']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleCreateManyCampaignInputEnvelope = {
  data: DonationScheduleCreateManyCampaignInput;
};

export type DonationScheduleCreateManyCompanyInput = {
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleCreateManyCompanyInputEnvelope = {
  data: DonationScheduleCreateManyCompanyInput;
};

export type DonationScheduleCreateManyInput = {
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleCreateManyUserInput = {
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateManyUserInputEnvelope = {
  data: DonationScheduleCreateManyUserInput;
};

export type DonationScheduleCreateNestedManyWithoutCampaignInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCampaignInputEnvelope>;
};

export type DonationScheduleCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCompanyInputEnvelope>;
};

export type DonationScheduleCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutNonprofitsInput>>>;
};

export type DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutPayeeNonprofitsInput>>>;
};

export type DonationScheduleCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyUserInputEnvelope>;
};

export type DonationScheduleCreateNestedOneWithoutDonationsInput = {
  connect?: InputMaybe<DonationScheduleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationScheduleCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<DonationScheduleCreateWithoutDonationsInput>;
};

export type DonationScheduleCreateOrConnectWithoutCampaignInput = {
  create: DonationScheduleCreateWithoutCampaignInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateOrConnectWithoutCompanyInput = {
  create: DonationScheduleCreateWithoutCompanyInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateOrConnectWithoutDonationsInput = {
  create: DonationScheduleCreateWithoutDonationsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateOrConnectWithoutNonprofitsInput = {
  create: DonationScheduleCreateWithoutNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateOrConnectWithoutPayeeNonprofitsInput = {
  create: DonationScheduleCreateWithoutPayeeNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateOrConnectWithoutUserInput = {
  create: DonationScheduleCreateWithoutUserInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleCreateWithoutCampaignInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateWithoutCompanyInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateWithoutDonationsInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateWithoutNonprofitsInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateWithoutPayeeNonprofitsInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  User: BaseUserCreateNestedOneWithoutDonationSchedulesInput;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreateWithoutUserInput = {
  Campaign?: InputMaybe<CampaignCreateNestedOneWithoutDonationScheduleInput>;
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleCreatenonprofitsInput = {
  set: Scalars['String']['input'];
};

export type DonationScheduleCreatepayeeNonprofitsInput = {
  set: Scalars['String']['input'];
};

export type DonationScheduleExecutionFailure = {
  __typename?: 'DonationScheduleExecutionFailure';
  code?: Maybe<Scalars['String']['output']>;
  failedAt: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
};

export type DonationScheduleExecutionFailureCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureObjectEqualityInput>>>;
  every?: InputMaybe<DonationScheduleExecutionFailureWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DonationScheduleExecutionFailureWhereInput>;
  some?: InputMaybe<DonationScheduleExecutionFailureWhereInput>;
};

export type DonationScheduleExecutionFailureCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  failedAt: Scalars['DateTime']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  retryCount: Scalars['Int']['input'];
};

export type DonationScheduleExecutionFailureDeleteManyInput = {
  where: DonationScheduleExecutionFailureWhereInput;
};

export type DonationScheduleExecutionFailureListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
};

export type DonationScheduleExecutionFailureListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<DonationScheduleExecutionFailureDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  updateMany?: InputMaybe<DonationScheduleExecutionFailureUpdateManyInput>;
};

export type DonationScheduleExecutionFailureObjectEqualityInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  failedAt: Scalars['DateTime']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  retryCount: Scalars['Int']['input'];
};

export type DonationScheduleExecutionFailureOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DonationScheduleExecutionFailureUpdateInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  retryCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DonationScheduleExecutionFailureUpdateManyInput = {
  data: DonationScheduleExecutionFailureUpdateInput;
  where: DonationScheduleExecutionFailureWhereInput;
};

export type DonationScheduleExecutionFailureWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureWhereInput>>>;
  code?: InputMaybe<StringNullableFilter>;
  failedAt?: InputMaybe<DateTimeFilter>;
  message?: InputMaybe<StringNullableFilter>;
  reason?: InputMaybe<StringNullableFilter>;
  retryCount?: InputMaybe<IntFilter>;
};

export type DonationScheduleListRelationFilter = {
  every?: InputMaybe<DonationScheduleWhereInput>;
  none?: InputMaybe<DonationScheduleWhereInput>;
  some?: InputMaybe<DonationScheduleWhereInput>;
};

export type DonationScheduleMaxAggregateOutputType = {
  __typename?: 'DonationScheduleMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  dedication?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donorPrivacy?: Maybe<DonorPrivacy>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<DonationFrequency>;
  grantId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<DonationPrivacy>;
  projectedTotalAmount?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<ProviderType>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DonationScheduleStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type DonationScheduleMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donorPrivacy?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inactivatedAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DonationScheduleMinAggregateOutputType = {
  __typename?: 'DonationScheduleMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  coverFee?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  dedication?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchingRule?: Maybe<Scalars['String']['output']>;
  donorPrivacy?: Maybe<DonorPrivacy>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<DonationFrequency>;
  grantId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<DonationPrivacy>;
  projectedTotalAmount?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<ProviderType>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DonationScheduleStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type DonationScheduleMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donorPrivacy?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inactivatedAt?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DonationScheduleNullableRelationFilter = {
  is?: InputMaybe<DonationScheduleWhereInput>;
  isNot?: InputMaybe<DonationScheduleWhereInput>;
};

export type DonationScheduleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DonationScheduleOrderByWithAggregationInput = {
  _avg?: InputMaybe<DonationScheduleAvgOrderByAggregateInput>;
  _count?: InputMaybe<DonationScheduleCountOrderByAggregateInput>;
  _max?: InputMaybe<DonationScheduleMaxOrderByAggregateInput>;
  _min?: InputMaybe<DonationScheduleMinOrderByAggregateInput>;
  _sum?: InputMaybe<DonationScheduleSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donorPrivacy?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inactivatedAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
  projectedTotalAmountCurrencies?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DonationScheduleOrderByWithRelationInput = {
  Campaign?: InputMaybe<CampaignOrderByWithRelationInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Donations?: InputMaybe<DonationOrderByRelationAggregateInput>;
  Nonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  PayeeNonprofits?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  coverFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  dedication?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designation?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  desiredMatchingRule?: InputMaybe<SortOrder>;
  donorPrivacy?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  executionFailure?: InputMaybe<DonationScheduleExecutionFailureOrderByCompositeAggregateInput>;
  frequency?: InputMaybe<SortOrder>;
  grantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inactivatedAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitPayoutMapping?: InputMaybe<NonprofitPayoutMapEntryOrderByCompositeAggregateInput>;
  nonprofits?: InputMaybe<SortOrder>;
  payeeNonprofits?: InputMaybe<SortOrder>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsOrderByInput>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  privacy?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
  projectedTotalAmountCurrencies?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum DonationScheduleScalarFieldEnum {
  Amount = 'amount',
  CampaignId = 'campaignId',
  CompanyId = 'companyId',
  CoverFee = 'coverFee',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  Dedication = 'dedication',
  Description = 'description',
  Designation = 'designation',
  DesiredMatchAmount = 'desiredMatchAmount',
  DesiredMatchingRule = 'desiredMatchingRule',
  DonorPrivacy = 'donorPrivacy',
  EndingAt = 'endingAt',
  Frequency = 'frequency',
  GrantId = 'grantId',
  Id = 'id',
  InactivatedAt = 'inactivatedAt',
  Metadata = 'metadata',
  ModifiedAt = 'modifiedAt',
  Nonprofits = 'nonprofits',
  PayeeNonprofits = 'payeeNonprofits',
  PayrollPayGroupId = 'payrollPayGroupId',
  Privacy = 'privacy',
  ProjectedTotalAmount = 'projectedTotalAmount',
  ProjectedTotalAmountCurrencies = 'projectedTotalAmountCurrencies',
  Provider = 'provider',
  StartingAt = 'startingAt',
  Status = 'status',
  UserId = 'userId'
}

export type DonationScheduleScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donorPrivacy?: InputMaybe<EnumDonorPrivacyNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  frequency?: InputMaybe<EnumDonationFrequencyFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inactivatedAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyNullableFilter>;
  projectedTotalAmount?: InputMaybe<FloatNullableFilter>;
  projectedTotalAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumDonationScheduleStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DonationScheduleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  campaignId?: InputMaybe<StringNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  coverFee?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringWithAggregatesFilter>;
  dedication?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  designation?: InputMaybe<StringNullableWithAggregatesFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableWithAggregatesFilter>;
  donorPrivacy?: InputMaybe<EnumDonorPrivacyNullableWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  frequency?: InputMaybe<EnumDonationFrequencyWithAggregatesFilter>;
  grantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  inactivatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyNullableWithAggregatesFilter>;
  projectedTotalAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  projectedTotalAmountCurrencies?: InputMaybe<JsonNullableWithAggregatesFilter>;
  provider?: InputMaybe<EnumProviderTypeWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  status?: InputMaybe<EnumDonationScheduleStatusNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export enum DonationScheduleStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type DonationScheduleSumAggregateOutputType = {
  __typename?: 'DonationScheduleSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  projectedTotalAmount?: Maybe<Scalars['Float']['output']>;
};

export type DonationScheduleSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  projectedTotalAmount?: InputMaybe<SortOrder>;
};

export type DonationScheduleUncheckedCreateInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateNestedManyWithoutCampaignInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCampaignInputEnvelope>;
};

export type DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCompanyInputEnvelope>;
};

export type DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutNonprofitsInput>>>;
};

export type DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutPayeeNonprofitsInput>>>;
};

export type DonationScheduleUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyUserInputEnvelope>;
};

export type DonationScheduleUncheckedCreateWithoutCampaignInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateWithoutDonationsInput = {
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateWithoutNonprofitsInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateWithoutPayeeNonprofitsInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
  userId: Scalars['String']['input'];
};

export type DonationScheduleUncheckedCreateWithoutUserInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutDonationScheduleInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput>;
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode: Scalars['String']['input'];
  dedication?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donorPrivacy?: InputMaybe<DonorPrivacy>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency: DonationFrequency;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod: PaymentMethodDetailsCreateEnvelopeInput;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  projectedTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider: ProviderType;
  startingAt: Scalars['DateTime']['input'];
  status?: InputMaybe<DonationScheduleStatus>;
};

export type DonationScheduleUncheckedUpdateInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutCampaignInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutCampaignNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCampaignInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutCampaignInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutCampaignInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutCampaignInput>>>;
};

export type DonationScheduleUncheckedUpdateManyWithoutCompanyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type DonationScheduleUncheckedUpdateManyWithoutNonprofitsInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
};

export type DonationScheduleUncheckedUpdateManyWithoutUserInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DonationScheduleUncheckedUpdateWithoutCampaignInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateWithoutDonationsInput = {
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateWithoutNonprofitsInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateWithoutPayeeNonprofitsInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DonationScheduleUncheckedUpdateWithoutUserInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateInputType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
};

export type DonationScheduleUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateManyWithWhereWithoutCampaignInput = {
  data: DonationScheduleUpdateManyMutationInput;
  where: DonationScheduleScalarWhereInput;
};

export type DonationScheduleUpdateManyWithWhereWithoutCompanyInput = {
  data: DonationScheduleUpdateManyMutationInput;
  where: DonationScheduleScalarWhereInput;
};

export type DonationScheduleUpdateManyWithWhereWithoutNonprofitsInput = {
  data: DonationScheduleUpdateManyMutationInput;
  where: DonationScheduleScalarWhereInput;
};

export type DonationScheduleUpdateManyWithWhereWithoutPayeeNonprofitsInput = {
  data: DonationScheduleUpdateManyMutationInput;
  where: DonationScheduleScalarWhereInput;
};

export type DonationScheduleUpdateManyWithWhereWithoutUserInput = {
  data: DonationScheduleUpdateManyMutationInput;
  where: DonationScheduleScalarWhereInput;
};

export type DonationScheduleUpdateManyWithoutCampaignNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCampaignInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCampaignInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCampaignInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutCampaignInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutCampaignInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutCampaignInput>>>;
};

export type DonationScheduleUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type DonationScheduleUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
};

export type DonationScheduleUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationScheduleCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationScheduleCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationScheduleCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScheduleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationScheduleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationScheduleUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationScheduleUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DonationScheduleUpdateOneWithoutDonationsNestedInput = {
  connect?: InputMaybe<DonationScheduleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationScheduleCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<DonationScheduleCreateWithoutDonationsInput>;
  delete?: InputMaybe<DonationScheduleWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DonationScheduleUpdateToOneWithWhereWithoutDonationsInput>;
  upsert?: InputMaybe<DonationScheduleUpsertWithoutDonationsInput>;
};

export type DonationScheduleUpdateToOneWithWhereWithoutDonationsInput = {
  data: DonationScheduleUpdateWithoutDonationsInput;
  where?: InputMaybe<DonationScheduleWhereInput>;
};

export type DonationScheduleUpdateWithWhereUniqueWithoutCampaignInput = {
  data: DonationScheduleUpdateWithoutCampaignInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpdateWithWhereUniqueWithoutCompanyInput = {
  data: DonationScheduleUpdateWithoutCompanyInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpdateWithWhereUniqueWithoutNonprofitsInput = {
  data: DonationScheduleUpdateWithoutNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpdateWithWhereUniqueWithoutPayeeNonprofitsInput = {
  data: DonationScheduleUpdateWithoutPayeeNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpdateWithWhereUniqueWithoutUserInput = {
  data: DonationScheduleUpdateWithoutUserInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpdateWithoutCampaignInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateWithoutCompanyInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateWithoutDonationsInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateWithoutNonprofitsInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateWithoutPayeeNonprofitsInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutDonationSchedulesNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdateWithoutUserInput = {
  Campaign?: InputMaybe<CampaignUpdateOneWithoutDonationScheduleNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutDonationScheduleNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donorPrivacy?: InputMaybe<NullableEnumDonorPrivacyFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureCreateInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<NullableEnumDonationPrivacyFieldUpdateOperationsInput>;
  projectedTotalAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  projectedTotalAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumDonationScheduleStatusFieldUpdateOperationsInput>;
};

export type DonationScheduleUpdatenonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationScheduleUpdatepayeeNonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationScheduleUpsertWithWhereUniqueWithoutCampaignInput = {
  create: DonationScheduleCreateWithoutCampaignInput;
  update: DonationScheduleUpdateWithoutCampaignInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpsertWithWhereUniqueWithoutCompanyInput = {
  create: DonationScheduleCreateWithoutCompanyInput;
  update: DonationScheduleUpdateWithoutCompanyInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpsertWithWhereUniqueWithoutNonprofitsInput = {
  create: DonationScheduleCreateWithoutNonprofitsInput;
  update: DonationScheduleUpdateWithoutNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpsertWithWhereUniqueWithoutPayeeNonprofitsInput = {
  create: DonationScheduleCreateWithoutPayeeNonprofitsInput;
  update: DonationScheduleUpdateWithoutPayeeNonprofitsInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpsertWithWhereUniqueWithoutUserInput = {
  create: DonationScheduleCreateWithoutUserInput;
  update: DonationScheduleUpdateWithoutUserInput;
  where: DonationScheduleWhereUniqueInput;
};

export type DonationScheduleUpsertWithoutDonationsInput = {
  create: DonationScheduleCreateWithoutDonationsInput;
  update: DonationScheduleUpdateWithoutDonationsInput;
  where?: InputMaybe<DonationScheduleWhereInput>;
};

export type DonationScheduleWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  Campaign?: InputMaybe<CampaignNullableRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  PayeeNonprofits?: InputMaybe<OrganizationListRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  amount?: InputMaybe<FloatFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donorPrivacy?: InputMaybe<EnumDonorPrivacyNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureObjectEqualityInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inactivatedAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryObjectEqualityInput>>>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsCompositeFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyNullableFilter>;
  projectedTotalAmount?: InputMaybe<FloatNullableFilter>;
  projectedTotalAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumDonationScheduleStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DonationScheduleWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  Campaign?: InputMaybe<CampaignNullableRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DonationScheduleWhereInput>>>;
  PayeeNonprofits?: InputMaybe<OrganizationListRelationFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  amount?: InputMaybe<FloatFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donorPrivacy?: InputMaybe<EnumDonorPrivacyNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  executionFailure?: InputMaybe<Array<InputMaybe<DonationScheduleExecutionFailureObjectEqualityInput>>>;
  frequency?: InputMaybe<EnumDonationFrequencyFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryObjectEqualityInput>>>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  paymentMethod?: InputMaybe<PaymentMethodDetailsCompositeFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyNullableFilter>;
  projectedTotalAmount?: InputMaybe<FloatNullableFilter>;
  projectedTotalAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  startingAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumDonationScheduleStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum DonationStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Reversed = 'Reversed',
  Success = 'Success',
  Unresolved = 'Unresolved'
}

export enum DonationSubtype {
  VolunteerRewardDonation = 'VolunteerRewardDonation'
}

export type DonationSumAggregateOutputType = {
  __typename?: 'DonationSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  desiredMatchAmount?: Maybe<Scalars['Float']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type DonationSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  desiredMatchAmount?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  matchedAmount?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
};

export enum DonationType {
  CompanyDonationOnUserBehalf = 'CompanyDonationOnUserBehalf',
  CorporateDonation = 'CorporateDonation',
  PayrollDonation = 'PayrollDonation',
  PayrollFlatFileDonation = 'PayrollFlatFileDonation'
}

export type DonationUncheckedCreateInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationCreateManyCompanyInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutCorporateProgramInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<DonationCreateManyCorporateProgramInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutDonationScheduleInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutDonationScheduleInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutDonationScheduleInput>>>;
  createMany?: InputMaybe<DonationCreateManyDonationScheduleInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutNonprofitsInput>>>;
};

export type DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayeeNonprofitsInput>>>;
};

export type DonationUncheckedCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollPayGroupInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutPayrollRunFlatFileInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunFlatFileInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunFlatFileInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunFlatFileInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutPayrollRunInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunInputEnvelope>;
};

export type DonationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationCreateManyUserInputEnvelope>;
};

export type DonationUncheckedCreateWithoutActivitiesInput = {
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutCompanyInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutCorporateProgramInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutDonationScheduleInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutNonprofitsInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutPayeeNonprofitsInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutPayrollPayGroupInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutPayrollRunFlatFileInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutPayrollRunInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutUserInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedCreateWithoutVolunteerRewardsInput = {
  Activities?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutDonationInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount: Scalars['Float']['input'];
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails?: InputMaybe<BillingDetailsNullableCreateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  corporateProgramId?: InputMaybe<Scalars['String']['input']>;
  coverFee?: InputMaybe<Scalars['Boolean']['input']>;
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Currency;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dedication?: InputMaybe<Scalars['String']['input']>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCreateEnvelopeInput>;
  description: Scalars['String']['input'];
  designation?: InputMaybe<Scalars['String']['input']>;
  desiredMatchAmount?: InputMaybe<Scalars['Float']['input']>;
  desiredMatchingRule?: InputMaybe<Scalars['String']['input']>;
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  donationDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  donationSchedule?: InputMaybe<Scalars['String']['input']>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCreateEnvelopeInput>;
  externalDonationType?: InputMaybe<ExternalDonationType>;
  feeAmount?: InputMaybe<Scalars['Float']['input']>;
  feeCoveredBy?: InputMaybe<FeeCoveredBy>;
  givingAccountWithdrawal?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<Scalars['String']['input']>;
  givingAccountWithdrawalForMatch?: InputMaybe<Scalars['String']['input']>;
  grantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  livemode: Scalars['Boolean']['input'];
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursementTransactionUrl?: InputMaybe<Scalars['String']['input']>;
  matchedAmount?: InputMaybe<Scalars['Float']['input']>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<MatchRequestStatus>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCreateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<Scalars['String']['input']>;
  payrollRunFlatFileId?: InputMaybe<Scalars['String']['input']>;
  payrollRunId?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<DonationPrivacy>;
  provider: DonationProvider;
  rescheduledFrom?: InputMaybe<Scalars['String']['input']>;
  rescheduledTo?: InputMaybe<Scalars['String']['input']>;
  status: DonationStatus;
  subtype?: InputMaybe<DonationSubtype>;
  total: Scalars['Float']['input'];
  type?: InputMaybe<DonationType>;
  userId?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<Scalars['String']['input']>;
};

export type DonationUncheckedUpdateInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutCompanyInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type DonationUncheckedUpdateManyWithoutCorporateProgramInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutCorporateProgramNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<DonationCreateManyCorporateProgramInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutCorporateProgramInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutCorporateProgramInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutCorporateProgramInput>>>;
};

export type DonationUncheckedUpdateManyWithoutDonationScheduleInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutDonationScheduleNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutDonationScheduleInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutDonationScheduleInput>>>;
  createMany?: InputMaybe<DonationCreateManyDonationScheduleInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutDonationScheduleInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutDonationScheduleInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutDonationScheduleInput>>>;
};

export type DonationUncheckedUpdateManyWithoutNonprofitsInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DonationUncheckedUpdateManyWithoutPayeeNonprofitsInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
};

export type DonationUncheckedUpdateManyWithoutPayrollPayGroupInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type DonationUncheckedUpdateManyWithoutPayrollRunFlatFileInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutPayrollRunFlatFileNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunFlatFileInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunFlatFileInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunFlatFileInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollRunFlatFileInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollRunFlatFileInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollRunFlatFileInput>>>;
};

export type DonationUncheckedUpdateManyWithoutPayrollRunInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutPayrollRunNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollRunInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollRunInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollRunInput>>>;
};

export type DonationUncheckedUpdateManyWithoutUserInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DonationUncheckedUpdateWithoutActivitiesInput = {
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutCompanyInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutCorporateProgramInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutDonationScheduleInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutNonprofitsInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutPayeeNonprofitsInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutPayrollPayGroupInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutPayrollRunFlatFileInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutPayrollRunInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutUserInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUncheckedUpdateWithoutVolunteerRewardsInput = {
  Activities?: InputMaybe<ActivityUncheckedUpdateManyWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationSchedule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  nonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  payrollPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunFlatFileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateManyMutationInput = {
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateManyWithWhereWithoutCompanyInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutCorporateProgramInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutDonationScheduleInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutNonprofitsInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutPayeeNonprofitsInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutPayrollPayGroupInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutPayrollRunFlatFileInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutPayrollRunInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithWhereWithoutUserInput = {
  data: DonationUpdateManyMutationInput;
  where: DonationScalarWhereInput;
};

export type DonationUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<DonationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type DonationUpdateManyWithoutCorporateProgramNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<DonationCreateManyCorporateProgramInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutCorporateProgramInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutCorporateProgramInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutCorporateProgramInput>>>;
};

export type DonationUpdateManyWithoutDonationScheduleNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutDonationScheduleInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutDonationScheduleInput>>>;
  createMany?: InputMaybe<DonationCreateManyDonationScheduleInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutDonationScheduleInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutDonationScheduleInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutDonationScheduleInput>>>;
};

export type DonationUpdateManyWithoutNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutNonprofitsInput>>>;
};

export type DonationUpdateManyWithoutPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayeeNonprofitsInput>>>;
};

export type DonationUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type DonationUpdateManyWithoutPayrollRunFlatFileNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunFlatFileInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunFlatFileInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunFlatFileInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollRunFlatFileInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollRunFlatFileInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollRunFlatFileInput>>>;
};

export type DonationUpdateManyWithoutPayrollRunNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutPayrollRunInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutPayrollRunInput>>>;
  createMany?: InputMaybe<DonationCreateManyPayrollRunInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutPayrollRunInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutPayrollRunInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutPayrollRunInput>>>;
};

export type DonationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DonationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DonationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DonationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DonationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DonationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DonationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DonationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DonationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DonationUpdateOneWithoutActivitiesNestedInput = {
  connect?: InputMaybe<DonationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationCreateOrConnectWithoutActivitiesInput>;
  create?: InputMaybe<DonationCreateWithoutActivitiesInput>;
  delete?: InputMaybe<DonationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DonationUpdateToOneWithWhereWithoutActivitiesInput>;
  upsert?: InputMaybe<DonationUpsertWithoutActivitiesInput>;
};

export type DonationUpdateOneWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<DonationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DonationCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<DonationCreateWithoutVolunteerRewardsInput>;
  delete?: InputMaybe<DonationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<DonationUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<DonationUpsertWithoutVolunteerRewardsInput>;
};

export type DonationUpdateToOneWithWhereWithoutActivitiesInput = {
  data: DonationUpdateWithoutActivitiesInput;
  where?: InputMaybe<DonationWhereInput>;
};

export type DonationUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: DonationUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<DonationWhereInput>;
};

export type DonationUpdateWithWhereUniqueWithoutCompanyInput = {
  data: DonationUpdateWithoutCompanyInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutCorporateProgramInput = {
  data: DonationUpdateWithoutCorporateProgramInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutDonationScheduleInput = {
  data: DonationUpdateWithoutDonationScheduleInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutNonprofitsInput = {
  data: DonationUpdateWithoutNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutPayeeNonprofitsInput = {
  data: DonationUpdateWithoutPayeeNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutPayrollPayGroupInput = {
  data: DonationUpdateWithoutPayrollPayGroupInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutPayrollRunFlatFileInput = {
  data: DonationUpdateWithoutPayrollRunFlatFileInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutPayrollRunInput = {
  data: DonationUpdateWithoutPayrollRunInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithWhereUniqueWithoutUserInput = {
  data: DonationUpdateWithoutUserInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpdateWithoutActivitiesInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutCompanyInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutCorporateProgramInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutDonationScheduleInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutNonprofitsInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutPayeeNonprofitsInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutPayrollPayGroupInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutPayrollRunFlatFileInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutPayrollRunInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutUserInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutDonationNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateWithoutVolunteerRewardsInput = {
  Activities?: InputMaybe<ActivityUpdateManyWithoutDonationNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneWithoutDonationsNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneWithoutDonationNestedInput>;
  DonationSchedule?: InputMaybe<DonationScheduleUpdateOneWithoutDonationsNestedInput>;
  Nonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedNestedInput>;
  PayeeNonprofits?: InputMaybe<OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneWithoutDonationNestedInput>;
  PayrollRun?: InputMaybe<PayrollRunUpdateOneWithoutDonationsNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutDonationsNestedInput>;
  activityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  billingDetails?: InputMaybe<BillingDetailsNullableUpdateEnvelopeInput>;
  budgetAllocationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coverFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dedication?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deductionActual?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableUpdateEnvelopeInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  desiredMatchAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  desiredMatchingRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableUpdateEnvelopeInput>;
  externalDonationType?: InputMaybe<NullableEnumExternalDonationTypeFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  feeCoveredBy?: InputMaybe<NullableEnumFeeCoveredByFieldUpdateOperationsInput>;
  givingAccountWithdrawal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountWithdrawalForMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  imported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isNew?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  livemode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursementTransactionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  matchedAmountCurrencies?: InputMaybe<Scalars['Json']['input']>;
  matchingRequestStatus?: InputMaybe<NullableEnumMatchRequestStatusFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableUpdateEnvelopeInput>;
  privacy?: InputMaybe<EnumDonationPrivacyFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumDonationProviderFieldUpdateOperationsInput>;
  rescheduledFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rescheduledTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDonationStatusFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableEnumDonationSubtypeFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumDonationTypeFieldUpdateOperationsInput>;
  volunteerRewardId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTimeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DonationUpdateactivityIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationUpdatenonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationUpdatepayeeNonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DonationUpsertWithWhereUniqueWithoutCompanyInput = {
  create: DonationCreateWithoutCompanyInput;
  update: DonationUpdateWithoutCompanyInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutCorporateProgramInput = {
  create: DonationCreateWithoutCorporateProgramInput;
  update: DonationUpdateWithoutCorporateProgramInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutDonationScheduleInput = {
  create: DonationCreateWithoutDonationScheduleInput;
  update: DonationUpdateWithoutDonationScheduleInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutNonprofitsInput = {
  create: DonationCreateWithoutNonprofitsInput;
  update: DonationUpdateWithoutNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutPayeeNonprofitsInput = {
  create: DonationCreateWithoutPayeeNonprofitsInput;
  update: DonationUpdateWithoutPayeeNonprofitsInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutPayrollPayGroupInput = {
  create: DonationCreateWithoutPayrollPayGroupInput;
  update: DonationUpdateWithoutPayrollPayGroupInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutPayrollRunFlatFileInput = {
  create: DonationCreateWithoutPayrollRunFlatFileInput;
  update: DonationUpdateWithoutPayrollRunFlatFileInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutPayrollRunInput = {
  create: DonationCreateWithoutPayrollRunInput;
  update: DonationUpdateWithoutPayrollRunInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithWhereUniqueWithoutUserInput = {
  create: DonationCreateWithoutUserInput;
  update: DonationUpdateWithoutUserInput;
  where: DonationWhereUniqueInput;
};

export type DonationUpsertWithoutActivitiesInput = {
  create: DonationCreateWithoutActivitiesInput;
  update: DonationUpdateWithoutActivitiesInput;
  where?: InputMaybe<DonationWhereInput>;
};

export type DonationUpsertWithoutVolunteerRewardsInput = {
  create: DonationCreateWithoutVolunteerRewardsInput;
  update: DonationUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<DonationWhereInput>;
};

export type DonationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  CorporateProgram?: InputMaybe<CorporateProgramNullableRelationFilter>;
  DonationSchedule?: InputMaybe<DonationScheduleNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  PayeeNonprofits?: InputMaybe<OrganizationListRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupNullableRelationFilter>;
  PayrollRun?: InputMaybe<PayrollRunNullableRelationFilter>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileNullableRelationFilter>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  amount?: InputMaybe<FloatFilter>;
  amountCurrencies?: InputMaybe<JsonNullableFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  billingDetails?: InputMaybe<BillingDetailsNullableCompositeFilter>;
  budgetAllocationId?: InputMaybe<StringNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  corporateProgramId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCompositeFilter>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCompositeFilter>;
  description?: InputMaybe<StringFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorObjectEqualityInput>>>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  donationSchedule?: InputMaybe<StringNullableFilter>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCompositeFilter>;
  externalDonationType?: InputMaybe<EnumExternalDonationTypeNullableFilter>;
  feeAmount?: InputMaybe<FloatNullableFilter>;
  feeCoveredBy?: InputMaybe<EnumFeeCoveredByNullableFilter>;
  givingAccountWithdrawal?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForMatch?: InputMaybe<StringNullableFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringFilter>;
  imported?: InputMaybe<BoolFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  isNew?: InputMaybe<BoolNullableFilter>;
  livemode?: InputMaybe<BoolFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorObjectEqualityInput>>>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  matchedAmount?: InputMaybe<FloatNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  matchingRequestStatus?: InputMaybe<EnumMatchRequestStatusNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryObjectEqualityInput>>>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCompositeFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  payrollRunFlatFileId?: InputMaybe<StringNullableFilter>;
  payrollRunId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyFilter>;
  provider?: InputMaybe<EnumDonationProviderFilter>;
  rescheduledFrom?: InputMaybe<StringNullableFilter>;
  rescheduledTo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDonationStatusFilter>;
  subtype?: InputMaybe<EnumDonationSubtypeNullableFilter>;
  total?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumDonationTypeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  volunteerRewardId?: InputMaybe<StringNullableFilter>;
  volunteerTimeId?: InputMaybe<StringNullableFilter>;
};

export type DonationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  Activities?: InputMaybe<ActivityListRelationFilter>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  CorporateProgram?: InputMaybe<CorporateProgramNullableRelationFilter>;
  DonationSchedule?: InputMaybe<DonationScheduleNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  Nonprofits?: InputMaybe<OrganizationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<DonationWhereInput>>>;
  PayeeNonprofits?: InputMaybe<OrganizationListRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupNullableRelationFilter>;
  PayrollRun?: InputMaybe<PayrollRunNullableRelationFilter>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileNullableRelationFilter>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  activityIds?: InputMaybe<StringNullableListFilter>;
  amount?: InputMaybe<FloatFilter>;
  amountCurrencies?: InputMaybe<JsonNullableFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  billingDetails?: InputMaybe<BillingDetailsNullableCompositeFilter>;
  budgetAllocationId?: InputMaybe<StringNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  corporateProgramId?: InputMaybe<StringNullableFilter>;
  coverFee?: InputMaybe<BoolNullableFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  coveredFeeDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dedication?: InputMaybe<StringNullableFilter>;
  deductionActual?: InputMaybe<PayrollDeductionNullableCompositeFilter>;
  deductionIntent?: InputMaybe<PayrollDeductionNullableCompositeFilter>;
  description?: InputMaybe<StringFilter>;
  designation?: InputMaybe<StringNullableFilter>;
  desiredMatchAmount?: InputMaybe<FloatNullableFilter>;
  desiredMatchingRule?: InputMaybe<StringNullableFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorObjectEqualityInput>>>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  donationDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  donationSchedule?: InputMaybe<StringNullableFilter>;
  executionFailure?: InputMaybe<DonationExecutionFailureNullableCompositeFilter>;
  externalDonationType?: InputMaybe<EnumExternalDonationTypeNullableFilter>;
  feeAmount?: InputMaybe<FloatNullableFilter>;
  feeCoveredBy?: InputMaybe<EnumFeeCoveredByNullableFilter>;
  givingAccountWithdrawal?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForCoveredFees?: InputMaybe<StringNullableFilter>;
  givingAccountWithdrawalForMatch?: InputMaybe<StringNullableFilter>;
  grantId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<BoolFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  isNew?: InputMaybe<BoolNullableFilter>;
  livemode?: InputMaybe<BoolFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementErrors?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorObjectEqualityInput>>>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionIdentifier?: InputMaybe<StringNullableFilter>;
  matchDisbursementTransactionUrl?: InputMaybe<StringNullableFilter>;
  matchedAmount?: InputMaybe<FloatNullableFilter>;
  matchedAmountCurrencies?: InputMaybe<JsonNullableFilter>;
  matchingRequestStatus?: InputMaybe<EnumMatchRequestStatusNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofitPayoutMapping?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryObjectEqualityInput>>>;
  nonprofits?: InputMaybe<StringNullableListFilter>;
  payeeNonprofits?: InputMaybe<StringNullableListFilter>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsNullableCompositeFilter>;
  payrollPayGroupId?: InputMaybe<StringNullableFilter>;
  payrollRunFlatFileId?: InputMaybe<StringNullableFilter>;
  payrollRunId?: InputMaybe<StringNullableFilter>;
  privacy?: InputMaybe<EnumDonationPrivacyFilter>;
  provider?: InputMaybe<EnumDonationProviderFilter>;
  rescheduledFrom?: InputMaybe<StringNullableFilter>;
  rescheduledTo?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDonationStatusFilter>;
  subtype?: InputMaybe<EnumDonationSubtypeNullableFilter>;
  total?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumDonationTypeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  volunteerRewardId?: InputMaybe<Scalars['String']['input']>;
  volunteerTimeId?: InputMaybe<StringNullableFilter>;
};

export type DonationsPledge = {
  __typename?: 'DonationsPledge';
  amount: Scalars['Float']['output'];
  currencyCode: Currency;
  donated: Scalars['Float']['output'];
};

export type DonationsPledgeCreateInput = {
  amount: Scalars['Float']['input'];
  currencyCode: Currency;
};

export type DonationsPledgeNullableCompositeFilter = {
  equals?: InputMaybe<DonationsPledgeObjectEqualityInput>;
  is?: InputMaybe<DonationsPledgeWhereInput>;
  isNot?: InputMaybe<DonationsPledgeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DonationsPledgeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<DonationsPledgeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<DonationsPledgeUpsertInput>;
};

export type DonationsPledgeObjectEqualityInput = {
  amount: Scalars['Float']['input'];
  currencyCode: Currency;
};

export type DonationsPledgeUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
};

export type DonationsPledgeUpsertInput = {
  set: DonationsPledgeCreateInput;
  update: DonationsPledgeUpdateInput;
};

export type DonationsPledgeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DonationsPledgeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DonationsPledgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DonationsPledgeWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  currencyCode?: InputMaybe<EnumCurrencyFilter>;
};

export enum DonorPrivacy {
  Anonymous = 'Anonymous',
  ProvideAll = 'ProvideAll',
  ProvideNameAndEmailOnly = 'ProvideNameAndEmailOnly'
}

export enum DurationUnit {
  Days = 'days',
  Hours = 'hours',
  Months = 'months',
  Weeks = 'weeks'
}

export enum EligibilityFormStatus {
  Eligible = 'eligible',
  NotEligible = 'notEligible',
  NotRequired = 'notRequired',
  Pending = 'pending'
}

export type EmailSignature = {
  __typename?: 'EmailSignature';
  main?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
};

export type EmailSignatureCreateInput = {
  main?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSignatureNullableCompositeFilter = {
  equals?: InputMaybe<EmailSignatureObjectEqualityInput>;
  is?: InputMaybe<EmailSignatureWhereInput>;
  isNot?: InputMaybe<EmailSignatureWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailSignatureNullableCreateEnvelopeInput = {
  set?: InputMaybe<EmailSignatureCreateInput>;
};

export type EmailSignatureNullableUpdateEnvelopeInput = {
  set?: InputMaybe<EmailSignatureCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<EmailSignatureUpsertInput>;
};

export type EmailSignatureObjectEqualityInput = {
  main?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSignatureOrderByInput = {
  main?: InputMaybe<SortOrder>;
  secondary?: InputMaybe<SortOrder>;
};

export type EmailSignatureUpdateInput = {
  main?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmailSignatureUpsertInput = {
  set: EmailSignatureCreateInput;
  update: EmailSignatureUpdateInput;
};

export type EmailSignatureWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EmailSignatureWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EmailSignatureWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EmailSignatureWhereInput>>>;
  main?: InputMaybe<StringNullableFilter>;
  secondary?: InputMaybe<StringNullableFilter>;
};

/** Email Template Metadata */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  bodyHtml: Scalars['String']['output'];
  id: Scalars['String']['output'];
  preHeader: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmployeeAffiliationCreateInputType = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  companyId: Scalars['String']['input'];
  endingAt?: InputMaybe<Scalars['String']['input']>;
  nonprofitId: Scalars['String']['input'];
  startingAt?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type EmployeeAffiliationDeleteInput = {
  __typename?: 'EmployeeAffiliationDeleteInput';
  id?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAffiliationUpdateInputType = {
  affiliationType?: InputMaybe<AffiliationType>;
  boardPosition?: InputMaybe<AffiliationBoardPosition>;
  endingAt?: InputMaybe<Scalars['String']['input']>;
  startingAt?: InputMaybe<Scalars['String']['input']>;
};

export type EncryptionConfiguration = {
  __typename?: 'EncryptionConfiguration';
  clientSecretId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  type?: Maybe<EncryptionType>;
};

export type EncryptionConfigurationCreateInput = {
  clientSecretId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EncryptionType>;
};

export type EncryptionConfigurationNullableCompositeFilter = {
  equals?: InputMaybe<EncryptionConfigurationObjectEqualityInput>;
  is?: InputMaybe<EncryptionConfigurationWhereInput>;
  isNot?: InputMaybe<EncryptionConfigurationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncryptionConfigurationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<EncryptionConfigurationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<EncryptionConfigurationUpsertInput>;
};

export type EncryptionConfigurationObjectEqualityInput = {
  clientSecretId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  type?: InputMaybe<EncryptionType>;
};

export type EncryptionConfigurationOrderByInput = {
  clientSecretId?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type EncryptionConfigurationUpdateInput = {
  clientSecretId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumEncryptionTypeFieldUpdateOperationsInput>;
};

export type EncryptionConfigurationUpsertInput = {
  set: EncryptionConfigurationCreateInput;
  update: EncryptionConfigurationUpdateInput;
};

export type EncryptionConfigurationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EncryptionConfigurationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EncryptionConfigurationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EncryptionConfigurationWhereInput>>>;
  clientSecretId?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumEncryptionTypeNullableFilter>;
};

export enum EncryptionType {
  Pgp = 'PGP'
}

export enum EngagementType {
  Both = 'Both',
  Donate = 'Donate',
  Other = 'Other',
  Volunteer = 'Volunteer'
}

export type EnumActionVisibilityStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ActionVisibilityStatus>;
};

export type EnumActionVisibilityStatusFilter = {
  equals?: InputMaybe<ActionVisibilityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
  not?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
};

export type EnumActionVisibilityStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  _min?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  equals?: InputMaybe<ActionVisibilityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
  not?: InputMaybe<NestedEnumActionVisibilityStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
};

export type EnumActivityStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ActivityStatus>;
};

export type EnumActivityStatusFilter = {
  equals?: InputMaybe<ActivityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
  not?: InputMaybe<NestedEnumActivityStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
};

export type EnumActivityStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActivityStatusFilter>;
  _min?: InputMaybe<NestedEnumActivityStatusFilter>;
  equals?: InputMaybe<ActivityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
  not?: InputMaybe<NestedEnumActivityStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
};

export type EnumAdapterProviderNullableFilter = {
  equals?: InputMaybe<AdapterProvider>;
  in?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
};

export type EnumAdapterProviderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  _min?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  equals?: InputMaybe<AdapterProvider>;
  in?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAdapterProviderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
};

export type EnumAffiliationBoardPositionNullableFilter = {
  equals?: InputMaybe<AffiliationBoardPosition>;
  in?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
};

export type EnumAffiliationBoardPositionNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  _min?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  equals?: InputMaybe<AffiliationBoardPosition>;
  in?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationBoardPositionNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
};

export type EnumAffiliationTypeNullableFilter = {
  equals?: InputMaybe<AffiliationType>;
  in?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
};

export type EnumAffiliationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  equals?: InputMaybe<AffiliationType>;
  in?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
};

export type EnumBadgeCategoryFieldUpdateOperationsInput = {
  set?: InputMaybe<BadgeCategory>;
};

export type EnumBadgeCategoryFilter = {
  equals?: InputMaybe<BadgeCategory>;
  in?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
  not?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
};

export type EnumBadgeCategoryWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  _min?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  equals?: InputMaybe<BadgeCategory>;
  in?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
  not?: InputMaybe<NestedEnumBadgeCategoryWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
};

export type EnumBadgeCriteriaEntityTypeNullableFilter = {
  equals?: InputMaybe<BadgeCriteriaEntityType>;
  in?: InputMaybe<Array<InputMaybe<BadgeCriteriaEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumBadgeCriteriaEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCriteriaEntityType>>>;
};

export type EnumBadgeCriteriaUnitFieldUpdateOperationsInput = {
  set?: InputMaybe<BadgeCriteriaUnit>;
};

export type EnumBadgeCriteriaUnitFilter = {
  equals?: InputMaybe<BadgeCriteriaUnit>;
  in?: InputMaybe<Array<InputMaybe<BadgeCriteriaUnit>>>;
  not?: InputMaybe<NestedEnumBadgeCriteriaUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCriteriaUnit>>>;
};

export type EnumBadgeStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<BadgeStatus>;
};

export type EnumBadgeStatusFilter = {
  equals?: InputMaybe<BadgeStatus>;
  in?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
  not?: InputMaybe<NestedEnumBadgeStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
};

export type EnumBadgeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeStatusFilter>;
  _min?: InputMaybe<NestedEnumBadgeStatusFilter>;
  equals?: InputMaybe<BadgeStatus>;
  in?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
  not?: InputMaybe<NestedEnumBadgeStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
};

export type EnumBadgeVisibilityFieldUpdateOperationsInput = {
  set?: InputMaybe<BadgeVisibility>;
};

export type EnumBadgeVisibilityFilter = {
  equals?: InputMaybe<BadgeVisibility>;
  in?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
  not?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
};

export type EnumBadgeVisibilityWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  _min?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  equals?: InputMaybe<BadgeVisibility>;
  in?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
  not?: InputMaybe<NestedEnumBadgeVisibilityWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
};

export type EnumBaseCurrenciesFieldUpdateOperationsInput = {
  set?: InputMaybe<BaseCurrencies>;
};

export type EnumBaseCurrenciesFilter = {
  equals?: InputMaybe<BaseCurrencies>;
  in?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
  not?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
};

export type EnumBaseCurrenciesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  _min?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  equals?: InputMaybe<BaseCurrencies>;
  in?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
  not?: InputMaybe<NestedEnumBaseCurrenciesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
};

export type EnumBudgetAllocationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BudgetAllocationType>;
};

export type EnumBudgetAllocationTypeFilter = {
  equals?: InputMaybe<BudgetAllocationType>;
  in?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
  not?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
};

export type EnumBudgetAllocationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  _min?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  equals?: InputMaybe<BudgetAllocationType>;
  in?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
  not?: InputMaybe<NestedEnumBudgetAllocationTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
};

export type EnumCauseTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CauseType>;
};

export type EnumCauseTypeFilter = {
  equals?: InputMaybe<CauseType>;
  in?: InputMaybe<Array<InputMaybe<CauseType>>>;
  not?: InputMaybe<NestedEnumCauseTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CauseType>>>;
};

export type EnumCauseTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCauseTypeFilter>;
  _min?: InputMaybe<NestedEnumCauseTypeFilter>;
  equals?: InputMaybe<CauseType>;
  in?: InputMaybe<Array<InputMaybe<CauseType>>>;
  not?: InputMaybe<NestedEnumCauseTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CauseType>>>;
};

export type EnumChallengeStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ChallengeStatus>;
};

export type EnumChallengeStatusFilter = {
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
  not?: InputMaybe<NestedEnumChallengeStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
};

export type EnumChallengeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumChallengeStatusFilter>;
  _min?: InputMaybe<NestedEnumChallengeStatusFilter>;
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
  not?: InputMaybe<NestedEnumChallengeStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
};

export type EnumCommunityEntityTypeNullableFilter = {
  equals?: InputMaybe<CommunityEntityType>;
  in?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
};

export type EnumCommunityEntityTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  equals?: InputMaybe<CommunityEntityType>;
  in?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumCommunityEntityTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
};

export type EnumCommunityUserRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<CommunityUserRole>;
};

export type EnumCommunityUserRoleFilter = {
  equals?: InputMaybe<CommunityUserRole>;
  in?: InputMaybe<Array<InputMaybe<CommunityUserRole>>>;
  not?: InputMaybe<NestedEnumCommunityUserRoleFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityUserRole>>>;
};

export type EnumContributionUnitFieldUpdateOperationsInput = {
  set?: InputMaybe<ContributionUnit>;
};

export type EnumContributionUnitFilter = {
  equals?: InputMaybe<ContributionUnit>;
  in?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
  not?: InputMaybe<NestedEnumContributionUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
};

export type EnumContributionUnitWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumContributionUnitFilter>;
  _min?: InputMaybe<NestedEnumContributionUnitFilter>;
  equals?: InputMaybe<ContributionUnit>;
  in?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
  not?: InputMaybe<NestedEnumContributionUnitWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
};

export type EnumCorporateProgramStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<CorporateProgramStatus>;
};

export type EnumCorporateProgramStatusFilter = {
  equals?: InputMaybe<CorporateProgramStatus>;
  in?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
  not?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
};

export type EnumCorporateProgramStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  _min?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  equals?: InputMaybe<CorporateProgramStatus>;
  in?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
  not?: InputMaybe<NestedEnumCorporateProgramStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
};

export type EnumCurrencyFieldUpdateOperationsInput = {
  set?: InputMaybe<Currency>;
};

export type EnumCurrencyFilter = {
  equals?: InputMaybe<Currency>;
  in?: InputMaybe<Array<InputMaybe<Currency>>>;
  not?: InputMaybe<NestedEnumCurrencyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Currency>>>;
};

export type EnumCurrencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCurrencyFilter>;
  _min?: InputMaybe<NestedEnumCurrencyFilter>;
  equals?: InputMaybe<Currency>;
  in?: InputMaybe<Array<InputMaybe<Currency>>>;
  not?: InputMaybe<NestedEnumCurrencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Currency>>>;
};

export type EnumDeductionTransferModeNullableFilter = {
  equals?: InputMaybe<DeductionTransferMode>;
  in?: InputMaybe<Array<InputMaybe<DeductionTransferMode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeductionTransferModeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeductionTransferMode>>>;
};

export type EnumDeedStatusNullableFilter = {
  equals?: InputMaybe<DeedStatus>;
  in?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
};

export type EnumDeedStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  equals?: InputMaybe<DeedStatus>;
  in?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeedStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
};

export type EnumDeedTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DeedType>;
};

export type EnumDeedTypeFilter = {
  equals?: InputMaybe<DeedType>;
  in?: InputMaybe<Array<InputMaybe<DeedType>>>;
  not?: InputMaybe<NestedEnumDeedTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedType>>>;
};

export type EnumDeedTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDeedTypeFilter>;
  _min?: InputMaybe<NestedEnumDeedTypeFilter>;
  equals?: InputMaybe<DeedType>;
  in?: InputMaybe<Array<InputMaybe<DeedType>>>;
  not?: InputMaybe<NestedEnumDeedTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedType>>>;
};

export type EnumDisbursementFeeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DisbursementFeeType>;
};

export type EnumDisbursementFeeTypeFilter = {
  equals?: InputMaybe<DisbursementFeeType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
  not?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
};

export type EnumDisbursementFeeTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  _min?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  equals?: InputMaybe<DisbursementFeeType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
  not?: InputMaybe<NestedEnumDisbursementFeeTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
};

export type EnumDisbursementInformationFileContentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DisbursementInformationFileContentType>;
};

export type EnumDisbursementInformationFileContentTypeFilter = {
  equals?: InputMaybe<DisbursementInformationFileContentType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
  not?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
};

export type EnumDisbursementInformationFileContentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  _min?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  equals?: InputMaybe<DisbursementInformationFileContentType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
  not?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
};

export type EnumDisbursementStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DisbursementStatus>;
};

export type EnumDisbursementStatusFilter = {
  equals?: InputMaybe<DisbursementStatus>;
  in?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
  not?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
};

export type EnumDisbursementStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  _min?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  equals?: InputMaybe<DisbursementStatus>;
  in?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
  not?: InputMaybe<NestedEnumDisbursementStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
};

export type EnumDisbursementTypeNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
  has?: InputMaybe<DisbursementType>;
  hasEvery?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
  hasSome?: InputMaybe<Array<InputMaybe<DisbursementType>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumDisclaimerContentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DisclaimerContentType>;
};

export type EnumDisclaimerContentTypeFilter = {
  equals?: InputMaybe<DisclaimerContentType>;
  in?: InputMaybe<Array<InputMaybe<DisclaimerContentType>>>;
  not?: InputMaybe<NestedEnumDisclaimerContentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisclaimerContentType>>>;
};

export type EnumDonationExecutionFailureErrorCodeFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationExecutionFailureErrorCode>;
};

export type EnumDonationExecutionFailureErrorCodeFilter = {
  equals?: InputMaybe<DonationExecutionFailureErrorCode>;
  in?: InputMaybe<Array<InputMaybe<DonationExecutionFailureErrorCode>>>;
  not?: InputMaybe<NestedEnumDonationExecutionFailureErrorCodeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationExecutionFailureErrorCode>>>;
};

export type EnumDonationFrequencyFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationFrequency>;
};

export type EnumDonationFrequencyFilter = {
  equals?: InputMaybe<DonationFrequency>;
  in?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
  not?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
};

export type EnumDonationFrequencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  _min?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  equals?: InputMaybe<DonationFrequency>;
  in?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
  not?: InputMaybe<NestedEnumDonationFrequencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
};

export type EnumDonationPayrollPaymentOptionStatusNullableFilter = {
  equals?: InputMaybe<DonationPayrollPaymentOptionStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationPayrollPaymentOptionStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPayrollPaymentOptionStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPayrollPaymentOptionStatus>>>;
};

export type EnumDonationPrivacyFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationPrivacy>;
};

export type EnumDonationPrivacyFilter = {
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  not?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type EnumDonationPrivacyNullableFilter = {
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type EnumDonationPrivacyNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPrivacyNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type EnumDonationPrivacyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  _min?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  not?: InputMaybe<NestedEnumDonationPrivacyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type EnumDonationProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationProvider>;
};

export type EnumDonationProviderFilter = {
  equals?: InputMaybe<DonationProvider>;
  in?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
  not?: InputMaybe<NestedEnumDonationProviderFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
};

export type EnumDonationProviderWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationProviderFilter>;
  _min?: InputMaybe<NestedEnumDonationProviderFilter>;
  equals?: InputMaybe<DonationProvider>;
  in?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
  not?: InputMaybe<NestedEnumDonationProviderWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
};

export type EnumDonationScheduleStatusNullableFilter = {
  equals?: InputMaybe<DonationScheduleStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
};

export type EnumDonationScheduleStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  equals?: InputMaybe<DonationScheduleStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationScheduleStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
};

export type EnumDonationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationStatus>;
};

export type EnumDonationStatusFilter = {
  equals?: InputMaybe<DonationStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
  not?: InputMaybe<NestedEnumDonationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
};

export type EnumDonationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationStatusFilter>;
  _min?: InputMaybe<NestedEnumDonationStatusFilter>;
  equals?: InputMaybe<DonationStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
  not?: InputMaybe<NestedEnumDonationStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
};

export type EnumDonationSubtypeNullableFilter = {
  equals?: InputMaybe<DonationSubtype>;
  in?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
};

export type EnumDonationSubtypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  equals?: InputMaybe<DonationSubtype>;
  in?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationSubtypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
};

export type EnumDonationTypeNullableFilter = {
  equals?: InputMaybe<DonationType>;
  in?: InputMaybe<Array<InputMaybe<DonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationType>>>;
};

export type EnumDonationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  equals?: InputMaybe<DonationType>;
  in?: InputMaybe<Array<InputMaybe<DonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationType>>>;
};

export type EnumDonorPrivacyNullableFilter = {
  equals?: InputMaybe<DonorPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
};

export type EnumDonorPrivacyNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  _min?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  equals?: InputMaybe<DonorPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonorPrivacyNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
};

export type EnumDurationUnitFieldUpdateOperationsInput = {
  set?: InputMaybe<DurationUnit>;
};

export type EnumDurationUnitFilter = {
  equals?: InputMaybe<DurationUnit>;
  in?: InputMaybe<Array<InputMaybe<DurationUnit>>>;
  not?: InputMaybe<NestedEnumDurationUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DurationUnit>>>;
};

export type EnumEligibilityFormStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<EligibilityFormStatus>;
};

export type EnumEligibilityFormStatusFilter = {
  equals?: InputMaybe<EligibilityFormStatus>;
  in?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
  not?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
};

export type EnumEligibilityFormStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  _min?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  equals?: InputMaybe<EligibilityFormStatus>;
  in?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
  not?: InputMaybe<NestedEnumEligibilityFormStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
};

export type EnumEncryptionTypeNullableFilter = {
  equals?: InputMaybe<EncryptionType>;
  in?: InputMaybe<Array<InputMaybe<EncryptionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumEncryptionTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EncryptionType>>>;
};

export type EnumEngagementTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<EngagementType>;
};

export type EnumEngagementTypeFilter = {
  equals?: InputMaybe<EngagementType>;
  in?: InputMaybe<Array<InputMaybe<EngagementType>>>;
  not?: InputMaybe<NestedEnumEngagementTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EngagementType>>>;
};

export type EnumEngagementTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEngagementTypeFilter>;
  _min?: InputMaybe<NestedEnumEngagementTypeFilter>;
  equals?: InputMaybe<EngagementType>;
  in?: InputMaybe<Array<InputMaybe<EngagementType>>>;
  not?: InputMaybe<NestedEnumEngagementTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EngagementType>>>;
};

export type EnumExternalDashboardScopeNullableFilter = {
  equals?: InputMaybe<ExternalDashboardScope>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
};

export type EnumExternalDashboardScopeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  _min?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  equals?: InputMaybe<ExternalDashboardScope>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDashboardScopeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
};

export type EnumExternalDashboardTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalDashboardType>;
};

export type EnumExternalDashboardTypeFilter = {
  equals?: InputMaybe<ExternalDashboardType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
  not?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
};

export type EnumExternalDashboardTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  _min?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  equals?: InputMaybe<ExternalDashboardType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
  not?: InputMaybe<NestedEnumExternalDashboardTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
};

export type EnumExternalDonationTypeNullableFilter = {
  equals?: InputMaybe<ExternalDonationType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
};

export type EnumExternalDonationTypeNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  has?: InputMaybe<ExternalDonationType>;
  hasEvery?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  hasSome?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumExternalDonationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  equals?: InputMaybe<ExternalDonationType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDonationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
};

export type EnumExternalReportTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalReportType>;
};

export type EnumExternalReportTypeFilter = {
  equals?: InputMaybe<ExternalReportType>;
  in?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
  not?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
};

export type EnumExternalReportTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  _min?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  equals?: InputMaybe<ExternalReportType>;
  in?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
  not?: InputMaybe<NestedEnumExternalReportTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
};

export type EnumFailedPayrollRunDeductionStatusOverridesNullableFilter = {
  equals?: InputMaybe<FailedPayrollRunDeductionStatusOverrides>;
  in?: InputMaybe<Array<InputMaybe<FailedPayrollRunDeductionStatusOverrides>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFailedPayrollRunDeductionStatusOverridesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FailedPayrollRunDeductionStatusOverrides>>>;
};

export type EnumFeeCoveredByNullableFilter = {
  equals?: InputMaybe<FeeCoveredBy>;
  in?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
};

export type EnumFeeCoveredByNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  _min?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  equals?: InputMaybe<FeeCoveredBy>;
  in?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFeeCoveredByNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
};

export type EnumFlatFileNamePartNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  has?: InputMaybe<FlatFileNamePart>;
  hasEvery?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  hasSome?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumFlatFileTemplateNullableFilter = {
  equals?: InputMaybe<FlatFileTemplate>;
  in?: InputMaybe<Array<InputMaybe<FlatFileTemplate>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFlatFileTemplateNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FlatFileTemplate>>>;
};

export type EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<GivingAccountWithdrawalStatus>;
};

export type EnumGivingAccountWithdrawalStatusFilter = {
  equals?: InputMaybe<GivingAccountWithdrawalStatus>;
  in?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
  not?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
};

export type EnumGivingAccountWithdrawalStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  _min?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  equals?: InputMaybe<GivingAccountWithdrawalStatus>;
  in?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
  not?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
};

export type EnumIncentiveTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<IncentiveType>;
};

export type EnumIncentiveTypeFilter = {
  equals?: InputMaybe<IncentiveType>;
  in?: InputMaybe<Array<InputMaybe<IncentiveType>>>;
  not?: InputMaybe<NestedEnumIncentiveTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<IncentiveType>>>;
};

export type EnumInputTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<InputType>;
};

export type EnumInputTypeFilter = {
  equals?: InputMaybe<InputType>;
  in?: InputMaybe<Array<InputMaybe<InputType>>>;
  not?: InputMaybe<NestedEnumInputTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<InputType>>>;
};

export type EnumMatchRequestStatusNullableFilter = {
  equals?: InputMaybe<MatchRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
};

export type EnumMatchRequestStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  equals?: InputMaybe<MatchRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumMatchRequestStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
};

export type EnumNonprofitAddressChangeRequestStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<NonprofitAddressChangeRequestStatus>;
};

export type EnumNonprofitAddressChangeRequestStatusFilter = {
  equals?: InputMaybe<NonprofitAddressChangeRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestStatus>>>;
  not?: InputMaybe<NestedEnumNonprofitAddressChangeRequestStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestStatus>>>;
};

export type EnumNonprofitEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NonprofitEntityType>;
};

export type EnumNonprofitEntityTypeFilter = {
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type EnumNonprofitEntityTypeNullableFilter = {
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type EnumNonprofitEntityTypeNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  has?: InputMaybe<NonprofitEntityType>;
  hasEvery?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  hasSome?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumNonprofitEntityTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type EnumNonprofitEntityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  _min?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type EnumNonprofitIdentifierTypeNullableFilter = {
  equals?: InputMaybe<NonprofitIdentifierType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitIdentifierType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitIdentifierTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitIdentifierType>>>;
};

export type EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NonprofitNominationStatusType>;
};

export type EnumNonprofitNominationStatusTypeFilter = {
  equals?: InputMaybe<NonprofitNominationStatusType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
  not?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
};

export type EnumNonprofitNominationStatusTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  _min?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  equals?: InputMaybe<NonprofitNominationStatusType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
  not?: InputMaybe<NestedEnumNonprofitNominationStatusTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
};

export type EnumOpportunityProviderNullableFilter = {
  equals?: InputMaybe<OpportunityProvider>;
  in?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
};

export type EnumOpportunityProviderNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  has?: InputMaybe<OpportunityProvider>;
  hasEvery?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  hasSome?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumOpportunityProviderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  _min?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  equals?: InputMaybe<OpportunityProvider>;
  in?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumOpportunityProviderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
};

export type EnumOpportunityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OpportunityType>;
};

export type EnumOpportunityTypeFilter = {
  equals?: InputMaybe<OpportunityType>;
  in?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
  not?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
};

export type EnumOpportunityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  _min?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  equals?: InputMaybe<OpportunityType>;
  in?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
  not?: InputMaybe<NestedEnumOpportunityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
};

export type EnumOrganizationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OrganizationType>;
};

export type EnumOrganizationTypeFilter = {
  equals?: InputMaybe<OrganizationType>;
  in?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  not?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type EnumOrganizationTypeNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  has?: InputMaybe<OrganizationType>;
  hasEvery?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  hasSome?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumOrganizationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  _min?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  equals?: InputMaybe<OrganizationType>;
  in?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  not?: InputMaybe<NestedEnumOrganizationTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type EnumPartnerStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PartnerStatus>;
};

export type EnumPartnerStatusFilter = {
  equals?: InputMaybe<PartnerStatus>;
  in?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
  not?: InputMaybe<NestedEnumPartnerStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
};

export type EnumPartnerStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPartnerStatusFilter>;
  _min?: InputMaybe<NestedEnumPartnerStatusFilter>;
  equals?: InputMaybe<PartnerStatus>;
  in?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
  not?: InputMaybe<NestedEnumPartnerStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
};

export type EnumPayGroupStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PayGroupStatus>;
};

export type EnumPayGroupStatusFilter = {
  equals?: InputMaybe<PayGroupStatus>;
  in?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
  not?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
};

export type EnumPayGroupStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  _min?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  equals?: InputMaybe<PayGroupStatus>;
  in?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
  not?: InputMaybe<NestedEnumPayGroupStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
};

export type EnumPayPalVerificationStatusNullableFilter = {
  equals?: InputMaybe<PayPalVerificationStatus>;
  in?: InputMaybe<Array<InputMaybe<PayPalVerificationStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayPalVerificationStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayPalVerificationStatus>>>;
};

export type EnumPaymentMethodTypeNullableFilter = {
  equals?: InputMaybe<PaymentMethodType>;
  in?: InputMaybe<Array<InputMaybe<PaymentMethodType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentMethodType>>>;
};

export type EnumPayrollDonationFrequencyOptionsNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  has?: InputMaybe<PayrollDonationFrequencyOptions>;
  hasEvery?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  hasSome?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumPayrollFlatFileFileExtensionNullableFilter = {
  equals?: InputMaybe<PayrollFlatFileFileExtension>;
  in?: InputMaybe<Array<InputMaybe<PayrollFlatFileFileExtension>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollFlatFileFileExtensionNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollFlatFileFileExtension>>>;
};

export type EnumPayrollProcessorTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollProcessorType>;
};

export type EnumPayrollProcessorTypeFilter = {
  equals?: InputMaybe<PayrollProcessorType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProcessorType>>>;
  not?: InputMaybe<NestedEnumPayrollProcessorTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProcessorType>>>;
};

export type EnumPayrollProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollProvider>;
};

export type EnumPayrollProviderFilter = {
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  not?: InputMaybe<NestedEnumPayrollProviderFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type EnumPayrollProviderNullableFilter = {
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type EnumPayrollProviderTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollProviderType>;
};

export type EnumPayrollProviderTypeFilter = {
  equals?: InputMaybe<PayrollProviderType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
  not?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
};

export type EnumPayrollProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  equals?: InputMaybe<PayrollProviderType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
  not?: InputMaybe<NestedEnumPayrollProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
};

export type EnumPayrollProviderWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollProviderFilter>;
  _min?: InputMaybe<NestedEnumPayrollProviderFilter>;
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  not?: InputMaybe<NestedEnumPayrollProviderWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type EnumPayrollRunDeductionFrequencyNullableFilter = {
  equals?: InputMaybe<PayrollRunDeductionFrequency>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionFrequency>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionFrequencyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionFrequency>>>;
};

export type EnumPayrollRunDeductionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollRunDeductionStatus>;
};

export type EnumPayrollRunDeductionStatusFilter = {
  equals?: InputMaybe<PayrollRunDeductionStatus>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
};

export type EnumPayrollRunDeductionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  equals?: InputMaybe<PayrollRunDeductionStatus>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
};

export type EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollRunFlatFileStateType>;
};

export type EnumPayrollRunFlatFileStateTypeFilter = {
  equals?: InputMaybe<PayrollRunFlatFileStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
};

export type EnumPayrollRunFlatFileStateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  equals?: InputMaybe<PayrollRunFlatFileStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
};

export type EnumPayrollRunRollupLevelNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
  has?: InputMaybe<PayrollRunRollupLevel>;
  hasEvery?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
  hasSome?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumPayrollRunStateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollRunStateType>;
};

export type EnumPayrollRunStateTypeFilter = {
  equals?: InputMaybe<PayrollRunStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
};

export type EnumPayrollRunStateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  equals?: InputMaybe<PayrollRunStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunStateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
};

export type EnumPayrollRunTypeNullableFilter = {
  equals?: InputMaybe<PayrollRunType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
};

export type EnumPayrollRunTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  equals?: InputMaybe<PayrollRunType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
};

export type EnumProviderPaymentReconciliationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ProviderPaymentReconciliationStatus>;
};

export type EnumProviderPaymentReconciliationStatusFilter = {
  equals?: InputMaybe<ProviderPaymentReconciliationStatus>;
  in?: InputMaybe<Array<InputMaybe<ProviderPaymentReconciliationStatus>>>;
  not?: InputMaybe<NestedEnumProviderPaymentReconciliationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderPaymentReconciliationStatus>>>;
};

export type EnumProviderTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ProviderType>;
};

export type EnumProviderTypeFilter = {
  equals?: InputMaybe<ProviderType>;
  in?: InputMaybe<Array<InputMaybe<ProviderType>>>;
  not?: InputMaybe<NestedEnumProviderTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderType>>>;
};

export type EnumProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumProviderTypeFilter>;
  equals?: InputMaybe<ProviderType>;
  in?: InputMaybe<Array<InputMaybe<ProviderType>>>;
  not?: InputMaybe<NestedEnumProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderType>>>;
};

export type EnumReceiptTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ReceiptType>;
};

export type EnumReceiptTypeFilter = {
  equals?: InputMaybe<ReceiptType>;
  in?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
  not?: InputMaybe<NestedEnumReceiptTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
};

export type EnumReceiptTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumReceiptTypeFilter>;
  _min?: InputMaybe<NestedEnumReceiptTypeFilter>;
  equals?: InputMaybe<ReceiptType>;
  in?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
  not?: InputMaybe<NestedEnumReceiptTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
};

export type EnumRecipientTypesForUserNotificationFieldUpdateOperationsInput = {
  set?: InputMaybe<RecipientTypesForUserNotification>;
};

export type EnumRecipientTypesForUserNotificationFilter = {
  equals?: InputMaybe<RecipientTypesForUserNotification>;
  in?: InputMaybe<Array<InputMaybe<RecipientTypesForUserNotification>>>;
  not?: InputMaybe<NestedEnumRecipientTypesForUserNotificationFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RecipientTypesForUserNotification>>>;
};

export type EnumRoleCodeNullableFilter = {
  equals?: InputMaybe<RoleCode>;
  in?: InputMaybe<Array<InputMaybe<RoleCode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleCode>>>;
};

export type EnumRoleCodeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  _min?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  equals?: InputMaybe<RoleCode>;
  in?: InputMaybe<Array<InputMaybe<RoleCode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleCodeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleCode>>>;
};

export type EnumRoleGrantSourceNullableFilter = {
  equals?: InputMaybe<RoleGrantSource>;
  in?: InputMaybe<Array<InputMaybe<RoleGrantSource>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleGrantSourceNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleGrantSource>>>;
};

export type EnumSftpModeFieldUpdateOperationsInput = {
  set?: InputMaybe<SftpMode>;
};

export type EnumSftpModeFilter = {
  equals?: InputMaybe<SftpMode>;
  in?: InputMaybe<Array<InputMaybe<SftpMode>>>;
  not?: InputMaybe<NestedEnumSftpModeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<SftpMode>>>;
};

export type EnumSupportedEntitiesForUserNotificationFieldUpdateOperationsInput = {
  set?: InputMaybe<SupportedEntitiesForUserNotification>;
};

export type EnumSupportedEntitiesForUserNotificationFilter = {
  equals?: InputMaybe<SupportedEntitiesForUserNotification>;
  in?: InputMaybe<Array<InputMaybe<SupportedEntitiesForUserNotification>>>;
  not?: InputMaybe<NestedEnumSupportedEntitiesForUserNotificationFilter>;
  notIn?: InputMaybe<Array<InputMaybe<SupportedEntitiesForUserNotification>>>;
};

export type EnumTimeOffStatusNullableFilter = {
  equals?: InputMaybe<TimeOffStatus>;
  in?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
};

export type EnumTimeOffStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  equals?: InputMaybe<TimeOffStatus>;
  in?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTimeOffStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
};

export type EnumTransactionTypeNullableFilter = {
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};

export type EnumTransactionTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTransactionTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};

export type EnumUnresolvedPayrollRunDeductionStatusOverridesNullableFilter = {
  equals?: InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  in?: InputMaybe<Array<InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUnresolvedPayrollRunDeductionStatusOverridesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>>>;
};

export type EnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter = {
  equals?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  in?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
};

export type EnumUserFacingVolunteerRewardCreationFailureReasonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  _min?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  equals?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  in?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
};

export type EnumUserNotificationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserNotificationStatus>;
};

export type EnumUserNotificationStatusFilter = {
  equals?: InputMaybe<UserNotificationStatus>;
  in?: InputMaybe<Array<InputMaybe<UserNotificationStatus>>>;
  not?: InputMaybe<NestedEnumUserNotificationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserNotificationStatus>>>;
};

export type EnumUserTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserType>;
};

export type EnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<InputMaybe<UserType>>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserType>>>;
};

export type EnumUserTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserTypeFilter>;
  _min?: InputMaybe<NestedEnumUserTypeFilter>;
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<InputMaybe<UserType>>>;
  not?: InputMaybe<NestedEnumUserTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserType>>>;
};

export type EnumVerificationStatusesFieldUpdateOperationsInput = {
  set?: InputMaybe<VerificationStatuses>;
};

export type EnumVerificationStatusesFilter = {
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  not?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type EnumVerificationStatusesNullableFilter = {
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type EnumVerificationStatusesNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  has?: InputMaybe<VerificationStatuses>;
  hasEvery?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  hasSome?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumVerificationStatusesNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  _min?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumVerificationStatusesNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type EnumVerificationStatusesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  _min?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  not?: InputMaybe<NestedEnumVerificationStatusesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<VolunteerRewardApprovalStatus>;
};

export type EnumVolunteerRewardApprovalStatusFilter = {
  equals?: InputMaybe<VolunteerRewardApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
  not?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
};

export type EnumVolunteerRewardApprovalStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  _min?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  equals?: InputMaybe<VolunteerRewardApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
  not?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
};

export type EnumVolunteerTimeApprovalFieldUpdateOperationsInput = {
  set?: InputMaybe<VolunteerTimeApproval>;
};

export type EnumVolunteerTimeApprovalFilter = {
  equals?: InputMaybe<VolunteerTimeApproval>;
  in?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
  not?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
};

export type EnumVolunteerTimeApprovalWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  _min?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  equals?: InputMaybe<VolunteerTimeApproval>;
  in?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
  not?: InputMaybe<NestedEnumVolunteerTimeApprovalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
};

/** Extended Nonprofit details */
export type ExtendedDeedNonprofit = {
  __typename?: 'ExtendedDeedNonprofit';
  ERGs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SDGs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  acceptsDonations?: Maybe<Scalars['Boolean']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deeds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  donateViaNonprofitId?: Maybe<Scalars['String']['output']>;
  donationProvider?: Maybe<Scalars['String']['output']>;
  donationProviders?: Maybe<DonationProviderMapType>;
  donationProvidersAvailability?: Maybe<DonationProviderMapType>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  facebookPage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifiers?: Maybe<Array<Maybe<NonprofitIdentifierEntryType>>>;
  instagram?: Maybe<Scalars['String']['output']>;
  isPartnerNonprofit?: Maybe<Scalars['Boolean']['output']>;
  locationObject?: Maybe<LocationObject>;
  logo?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  matchableRule?: Maybe<MatchableRule>;
  matchableRules?: Maybe<Scalars['Json']['output']>;
  matchingBudgetId?: Maybe<Scalars['String']['output']>;
  matchingMaximumCurrencies?: Maybe<CurrencyMapping>;
  matchingPaymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  matchingPaymentMethodsExclude?: Maybe<Scalars['Boolean']['output']>;
  matchingPercentage?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<NonprofitMeta>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<Scalars['String']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  payPalModel?: Maybe<Scalars['String']['output']>;
  paypalCharityType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pictures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pillars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shareLink?: Maybe<Scalars['String']['output']>;
  stripe?: Maybe<Stripe>;
  taxonomy?: Maybe<Taxonomy>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ExtendedLocationObjectInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  area: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  geo: GeoInput;
  placeId: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ExternalCategoriesFilter = {
  __typename?: 'ExternalCategoriesFilter';
  charityNavigator?: Maybe<StringExcludeFilter>;
};

export type ExternalCategoriesFilterCreateInput = {
  charityNavigator?: InputMaybe<StringExcludeFilterCreateInput>;
};

export type ExternalCategoriesFilterNullableCompositeFilter = {
  equals?: InputMaybe<ExternalCategoriesFilterObjectEqualityInput>;
  is?: InputMaybe<ExternalCategoriesFilterWhereInput>;
  isNot?: InputMaybe<ExternalCategoriesFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalCategoriesFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ExternalCategoriesFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ExternalCategoriesFilterUpsertInput>;
};

export type ExternalCategoriesFilterObjectEqualityInput = {
  charityNavigator?: InputMaybe<StringExcludeFilterObjectEqualityInput>;
};

export type ExternalCategoriesFilterOrderByInput = {
  charityNavigator?: InputMaybe<StringExcludeFilterOrderByInput>;
};

export type ExternalCategoriesFilterUpdateInput = {
  charityNavigator?: InputMaybe<StringExcludeFilterNullableUpdateEnvelopeInput>;
};

export type ExternalCategoriesFilterUpsertInput = {
  set: ExternalCategoriesFilterCreateInput;
  update: ExternalCategoriesFilterUpdateInput;
};

export type ExternalCategoriesFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ExternalCategoriesFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ExternalCategoriesFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ExternalCategoriesFilterWhereInput>>>;
  charityNavigator?: InputMaybe<StringExcludeFilterNullableCompositeFilter>;
};

export enum ExternalDashboardScope {
  Custom = 'Custom',
  Default = 'Default'
}

export enum ExternalDashboardType {
  Actions = 'actions',
  AdvancedEngagement = 'advancedEngagement',
  Badges = 'badges',
  Campaigns = 'campaigns',
  Communities = 'communities',
  CorporateDonationsAndGrants = 'corporateDonationsAndGrants',
  Custom = 'custom',
  Donations = 'donations',
  DonationsReport = 'donationsReport',
  EngageEsg = 'engageEsg',
  Engagement = 'engagement',
  GivingSeasonSpotlight = 'givingSeasonSpotlight',
  Grants = 'grants',
  ImpactOverview = 'impactOverview',
  ManagersSpotlight = 'managersSpotlight',
  NonVolunteering = 'nonVolunteering',
  Sdgs = 'sdgs',
  StoresSpotlight = 'storesSpotlight',
  Volunteering = 'volunteering',
  VolunteeringReport = 'volunteeringReport',
  Yearendimpact = 'yearendimpact'
}

export enum ExternalDonationType {
  Crypto = 'Crypto',
  Daf = 'DAF',
  InKind = 'InKind',
  OutOfPocket = 'OutOfPocket',
  Stock = 'Stock'
}

export type ExternalLinkFollows = {
  __typename?: 'ExternalLinkFollows';
  activityDates: Array<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type ExternalLinkFollowsCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsObjectEqualityInput>>>;
  every?: InputMaybe<ExternalLinkFollowsWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ExternalLinkFollowsWhereInput>;
  some?: InputMaybe<ExternalLinkFollowsWhereInput>;
};

export type ExternalLinkFollowsCreateInput = {
  activityDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type ExternalLinkFollowsCreateactivityDatesInput = {
  set: Scalars['DateTime']['input'];
};

export type ExternalLinkFollowsDeleteManyInput = {
  where: ExternalLinkFollowsWhereInput;
};

export type ExternalLinkFollowsListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
};

export type ExternalLinkFollowsListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<ExternalLinkFollowsDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsCreateInput>>>;
  updateMany?: InputMaybe<ExternalLinkFollowsUpdateManyInput>;
};

export type ExternalLinkFollowsObjectEqualityInput = {
  activityDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type ExternalLinkFollowsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExternalLinkFollowsUpdateInput = {
  activityDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ExternalLinkFollowsUpdateManyInput = {
  data: ExternalLinkFollowsUpdateInput;
  where: ExternalLinkFollowsWhereInput;
};

export type ExternalLinkFollowsUpdateactivityDatesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type ExternalLinkFollowsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ExternalLinkFollowsWhereInput>>>;
  activityDates?: InputMaybe<DateTimeNullableListFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ExternalMatchRequestRule = {
  __typename?: 'ExternalMatchRequestRule';
  active: Scalars['Boolean']['output'];
  confidenceScore?: Maybe<ConfidenceScore>;
  employeeLocations?: Maybe<Array<Scalars['String']['output']>>;
  endingAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxAmount: Scalars['Int']['output'];
  minAmount: Scalars['Int']['output'];
  startingAt?: Maybe<Scalars['String']['output']>;
  type: ExternalMatchRequestRuleType;
};

export type ExternalMatchRequestRuleInput = {
  active: Scalars['Boolean']['input'];
  confidenceScore?: InputMaybe<ConfidenceScoreInput>;
  employeeLocations: Array<Scalars['String']['input']>;
  endingAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxAmount: Scalars['Int']['input'];
  minAmount: Scalars['Int']['input'];
  startingAt?: InputMaybe<Scalars['String']['input']>;
  type: ExternalMatchRequestRuleType;
};

export enum ExternalMatchRequestRuleType {
  Approval = 'approval',
  Rejection = 'rejection'
}

export enum ExternalReportType {
  Actions = 'actions',
  Affiliations = 'affiliations',
  Badges = 'badges',
  CampaignDonationsSummary = 'campaignDonationsSummary',
  Campaigns = 'campaigns',
  Communities = 'communities',
  DonationsByDepartment = 'donationsByDepartment',
  DonationsComprehensive = 'donationsComprehensive',
  DonationsComprehensiveDataExtract = 'donationsComprehensiveDataExtract',
  DonationsCustom = 'donationsCustom',
  EngagementComprehensive = 'engagementComprehensive',
  FundraiserDonationsSummary = 'fundraiserDonationsSummary',
  Grants = 'grants',
  NonVolunteeringComprehensive = 'nonVolunteeringComprehensive',
  NonprofitCauseAreas = 'nonprofitCauseAreas',
  NonprofitSdg = 'nonprofitSdg',
  NonprofitSpotlight = 'nonprofitSpotlight',
  NpoOnboardingReports = 'npoOnboardingReports',
  PledgesReport = 'pledgesReport',
  PledgesReportDataExtract = 'pledgesReportDataExtract',
  Ratings = 'ratings',
  UsersReport = 'usersReport',
  VolunteeringComprehensive = 'volunteeringComprehensive',
  VolunteeringComprehensiveDataExtract = 'volunteeringComprehensiveDataExtract'
}

export enum FailedPayrollRunDeductionStatusOverrides {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Unresolved = 'Unresolved'
}

export type Features = {
  __typename?: 'Features';
  actions?: Maybe<CompanyFeature>;
  advancedDashboards?: Maybe<CompanyFeature>;
  advancedReporting?: Maybe<CompanyFeature>;
  autoSourceDeeds?: Maybe<CompanyFeature>;
  badges?: Maybe<CompanyFeature>;
  basicDashboards?: Maybe<CompanyFeature>;
  browsingExternalOpportunities?: Maybe<CompanyFeature>;
  challenges?: Maybe<CompanyFeature>;
  communities?: Maybe<CompanyFeature>;
  communitiesSuperLeads?: Maybe<CompanyFeature>;
  corporateDonations?: Maybe<CompanyFeature>;
  donationCredit?: Maybe<CompanyFeature>;
  donationMatching?: Maybe<CompanyFeature>;
  donations?: Maybe<CompanyFeature>;
  editDonationAmount?: Maybe<CompanyFeature>;
  employeeAffiliations?: Maybe<CompanyFeature>;
  events?: Maybe<CompanyFeature>;
  externalCorporateDonations?: Maybe<CompanyFeature>;
  externalDonations?: Maybe<CompanyFeature>;
  externalMatching?: Maybe<CompanyFeature>;
  fundraisers?: Maybe<CompanyFeature>;
  givingPledgeCampaigns?: Maybe<CompanyFeature>;
  grants?: Maybe<CompanyFeature>;
  impersonation?: Maybe<CompanyFeature>;
  microsoftTeams?: Maybe<CompanyFeature>;
  multipleShifts?: Maybe<CompanyFeature>;
  partialMatching?: Maybe<CompanyFeature>;
  payPalCommerceLink?: Maybe<CompanyFeature>;
  payrollApi?: Maybe<CompanyFeature>;
  payrollFlatFile?: Maybe<CompanyFeature>;
  pledge?: Maybe<CompanyFeature>;
  premiumDashboards?: Maybe<CompanyFeature>;
  recurringDonations?: Maybe<CompanyFeature>;
  reports?: Maybe<CompanyFeature>;
  slack?: Maybe<CompanyFeature>;
  surveys?: Maybe<CompanyFeature>;
  teams?: Maybe<CompanyFeature>;
  usePaginatedDeedSearch?: Maybe<CompanyFeature>;
  userCreateDeed?: Maybe<CompanyFeature>;
  userDraftDeed?: Maybe<CompanyFeature>;
  userLogOfflineHours?: Maybe<CompanyFeature>;
  userNominateNonprofit?: Maybe<CompanyFeature>;
  userNominateNonprofitForMatching?: Maybe<CompanyFeature>;
  userPublishDeed?: Maybe<CompanyFeature>;
  volunteerReward?: Maybe<CompanyFeature>;
  volunteerTimeOff?: Maybe<CompanyFeature>;
  volunteering?: Maybe<CompanyFeature>;
};

export type FeaturesCreateInput = {
  actions?: InputMaybe<CompanyFeatureCreateInput>;
  advancedDashboards?: InputMaybe<CompanyFeatureCreateInput>;
  advancedReporting?: InputMaybe<CompanyFeatureCreateInput>;
  autoSourceDeeds?: InputMaybe<CompanyFeatureCreateInput>;
  badges?: InputMaybe<CompanyFeatureCreateInput>;
  basicDashboards?: InputMaybe<CompanyFeatureCreateInput>;
  browsingExternalOpportunities?: InputMaybe<CompanyFeatureCreateInput>;
  challenges?: InputMaybe<CompanyFeatureCreateInput>;
  communities?: InputMaybe<CompanyFeatureCreateInput>;
  communitiesSuperLeads?: InputMaybe<CompanyFeatureCreateInput>;
  corporateDonations?: InputMaybe<CompanyFeatureCreateInput>;
  donationCredit?: InputMaybe<CompanyFeatureCreateInput>;
  donationMatching?: InputMaybe<CompanyFeatureCreateInput>;
  donations?: InputMaybe<CompanyFeatureCreateInput>;
  editDonationAmount?: InputMaybe<CompanyFeatureCreateInput>;
  employeeAffiliations?: InputMaybe<CompanyFeatureCreateInput>;
  events?: InputMaybe<CompanyFeatureCreateInput>;
  externalCorporateDonations?: InputMaybe<CompanyFeatureCreateInput>;
  externalDonations?: InputMaybe<CompanyFeatureCreateInput>;
  externalMatching?: InputMaybe<CompanyFeatureCreateInput>;
  fundraisers?: InputMaybe<CompanyFeatureCreateInput>;
  givingPledgeCampaigns?: InputMaybe<CompanyFeatureCreateInput>;
  grants?: InputMaybe<CompanyFeatureCreateInput>;
  impersonation?: InputMaybe<CompanyFeatureCreateInput>;
  microsoftTeams?: InputMaybe<CompanyFeatureCreateInput>;
  multipleShifts?: InputMaybe<CompanyFeatureCreateInput>;
  partialMatching?: InputMaybe<CompanyFeatureCreateInput>;
  payPalCommerceLink?: InputMaybe<CompanyFeatureCreateInput>;
  payrollApi?: InputMaybe<CompanyFeatureCreateInput>;
  payrollFlatFile?: InputMaybe<CompanyFeatureCreateInput>;
  pledge?: InputMaybe<CompanyFeatureCreateInput>;
  premiumDashboards?: InputMaybe<CompanyFeatureCreateInput>;
  recurringDonations?: InputMaybe<CompanyFeatureCreateInput>;
  reports?: InputMaybe<CompanyFeatureCreateInput>;
  slack?: InputMaybe<CompanyFeatureCreateInput>;
  surveys?: InputMaybe<CompanyFeatureCreateInput>;
  teams?: InputMaybe<CompanyFeatureCreateInput>;
  usePaginatedDeedSearch?: InputMaybe<CompanyFeatureCreateInput>;
  userCreateDeed?: InputMaybe<CompanyFeatureCreateInput>;
  userDraftDeed?: InputMaybe<CompanyFeatureCreateInput>;
  userLogOfflineHours?: InputMaybe<CompanyFeatureCreateInput>;
  userNominateNonprofit?: InputMaybe<CompanyFeatureCreateInput>;
  userNominateNonprofitForMatching?: InputMaybe<CompanyFeatureCreateInput>;
  userPublishDeed?: InputMaybe<CompanyFeatureCreateInput>;
  volunteerReward?: InputMaybe<CompanyFeatureCreateInput>;
  volunteerTimeOff?: InputMaybe<CompanyFeatureCreateInput>;
  volunteering?: InputMaybe<CompanyFeatureCreateInput>;
};

export type FeaturesNullableCompositeFilter = {
  equals?: InputMaybe<FeaturesObjectEqualityInput>;
  is?: InputMaybe<FeaturesWhereInput>;
  isNot?: InputMaybe<FeaturesWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeaturesNullableCreateEnvelopeInput = {
  set?: InputMaybe<FeaturesCreateInput>;
};

export type FeaturesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FeaturesCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<FeaturesUpsertInput>;
};

export type FeaturesObjectEqualityInput = {
  actions?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  advancedDashboards?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  advancedReporting?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  autoSourceDeeds?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  badges?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  basicDashboards?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  browsingExternalOpportunities?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  challenges?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  communities?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  communitiesSuperLeads?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  corporateDonations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  donationCredit?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  donationMatching?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  donations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  editDonationAmount?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  employeeAffiliations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  events?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  externalCorporateDonations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  externalDonations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  externalMatching?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  fundraisers?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  givingPledgeCampaigns?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  grants?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  impersonation?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  microsoftTeams?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  multipleShifts?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  partialMatching?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  payPalCommerceLink?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  payrollApi?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  payrollFlatFile?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  pledge?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  premiumDashboards?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  recurringDonations?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  reports?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  slack?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  surveys?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  teams?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  usePaginatedDeedSearch?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userCreateDeed?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userDraftDeed?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userLogOfflineHours?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userNominateNonprofit?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userNominateNonprofitForMatching?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  userPublishDeed?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  volunteerReward?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  volunteerTimeOff?: InputMaybe<CompanyFeatureObjectEqualityInput>;
  volunteering?: InputMaybe<CompanyFeatureObjectEqualityInput>;
};

export type FeaturesOrderByInput = {
  actions?: InputMaybe<CompanyFeatureOrderByInput>;
  advancedDashboards?: InputMaybe<CompanyFeatureOrderByInput>;
  advancedReporting?: InputMaybe<CompanyFeatureOrderByInput>;
  autoSourceDeeds?: InputMaybe<CompanyFeatureOrderByInput>;
  badges?: InputMaybe<CompanyFeatureOrderByInput>;
  basicDashboards?: InputMaybe<CompanyFeatureOrderByInput>;
  browsingExternalOpportunities?: InputMaybe<CompanyFeatureOrderByInput>;
  challenges?: InputMaybe<CompanyFeatureOrderByInput>;
  communities?: InputMaybe<CompanyFeatureOrderByInput>;
  communitiesSuperLeads?: InputMaybe<CompanyFeatureOrderByInput>;
  corporateDonations?: InputMaybe<CompanyFeatureOrderByInput>;
  donationCredit?: InputMaybe<CompanyFeatureOrderByInput>;
  donationMatching?: InputMaybe<CompanyFeatureOrderByInput>;
  donations?: InputMaybe<CompanyFeatureOrderByInput>;
  editDonationAmount?: InputMaybe<CompanyFeatureOrderByInput>;
  employeeAffiliations?: InputMaybe<CompanyFeatureOrderByInput>;
  events?: InputMaybe<CompanyFeatureOrderByInput>;
  externalCorporateDonations?: InputMaybe<CompanyFeatureOrderByInput>;
  externalDonations?: InputMaybe<CompanyFeatureOrderByInput>;
  externalMatching?: InputMaybe<CompanyFeatureOrderByInput>;
  fundraisers?: InputMaybe<CompanyFeatureOrderByInput>;
  givingPledgeCampaigns?: InputMaybe<CompanyFeatureOrderByInput>;
  grants?: InputMaybe<CompanyFeatureOrderByInput>;
  impersonation?: InputMaybe<CompanyFeatureOrderByInput>;
  microsoftTeams?: InputMaybe<CompanyFeatureOrderByInput>;
  multipleShifts?: InputMaybe<CompanyFeatureOrderByInput>;
  partialMatching?: InputMaybe<CompanyFeatureOrderByInput>;
  payPalCommerceLink?: InputMaybe<CompanyFeatureOrderByInput>;
  payrollApi?: InputMaybe<CompanyFeatureOrderByInput>;
  payrollFlatFile?: InputMaybe<CompanyFeatureOrderByInput>;
  pledge?: InputMaybe<CompanyFeatureOrderByInput>;
  premiumDashboards?: InputMaybe<CompanyFeatureOrderByInput>;
  recurringDonations?: InputMaybe<CompanyFeatureOrderByInput>;
  reports?: InputMaybe<CompanyFeatureOrderByInput>;
  slack?: InputMaybe<CompanyFeatureOrderByInput>;
  surveys?: InputMaybe<CompanyFeatureOrderByInput>;
  teams?: InputMaybe<CompanyFeatureOrderByInput>;
  usePaginatedDeedSearch?: InputMaybe<CompanyFeatureOrderByInput>;
  userCreateDeed?: InputMaybe<CompanyFeatureOrderByInput>;
  userDraftDeed?: InputMaybe<CompanyFeatureOrderByInput>;
  userLogOfflineHours?: InputMaybe<CompanyFeatureOrderByInput>;
  userNominateNonprofit?: InputMaybe<CompanyFeatureOrderByInput>;
  userNominateNonprofitForMatching?: InputMaybe<CompanyFeatureOrderByInput>;
  userPublishDeed?: InputMaybe<CompanyFeatureOrderByInput>;
  volunteerReward?: InputMaybe<CompanyFeatureOrderByInput>;
  volunteerTimeOff?: InputMaybe<CompanyFeatureOrderByInput>;
  volunteering?: InputMaybe<CompanyFeatureOrderByInput>;
};

export type FeaturesUpdateInput = {
  actions?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  advancedDashboards?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  advancedReporting?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  autoSourceDeeds?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  badges?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  basicDashboards?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  browsingExternalOpportunities?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  challenges?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  communities?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  communitiesSuperLeads?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  corporateDonations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  donationCredit?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  donationMatching?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  donations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  editDonationAmount?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  employeeAffiliations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  events?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  externalCorporateDonations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  externalDonations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  externalMatching?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  fundraisers?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  givingPledgeCampaigns?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  grants?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  impersonation?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  microsoftTeams?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  multipleShifts?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  partialMatching?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  payPalCommerceLink?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  payrollApi?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  pledge?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  premiumDashboards?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  recurringDonations?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  reports?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  slack?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  surveys?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  teams?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  usePaginatedDeedSearch?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userCreateDeed?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userDraftDeed?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userLogOfflineHours?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userNominateNonprofit?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userNominateNonprofitForMatching?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  userPublishDeed?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  volunteerReward?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  volunteerTimeOff?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
  volunteering?: InputMaybe<CompanyFeatureNullableUpdateEnvelopeInput>;
};

export type FeaturesUpsertInput = {
  set: FeaturesCreateInput;
  update: FeaturesUpdateInput;
};

export type FeaturesWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FeaturesWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FeaturesWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FeaturesWhereInput>>>;
  actions?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  advancedDashboards?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  advancedReporting?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  autoSourceDeeds?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  badges?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  basicDashboards?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  browsingExternalOpportunities?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  challenges?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  communities?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  communitiesSuperLeads?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  corporateDonations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  donationCredit?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  donationMatching?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  donations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  editDonationAmount?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  employeeAffiliations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  events?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  externalCorporateDonations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  externalDonations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  externalMatching?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  fundraisers?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  givingPledgeCampaigns?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  grants?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  impersonation?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  microsoftTeams?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  multipleShifts?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  partialMatching?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  payPalCommerceLink?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  payrollApi?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  payrollFlatFile?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  pledge?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  premiumDashboards?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  recurringDonations?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  reports?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  slack?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  surveys?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  teams?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  usePaginatedDeedSearch?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userCreateDeed?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userDraftDeed?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userLogOfflineHours?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userNominateNonprofit?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userNominateNonprofitForMatching?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  userPublishDeed?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  volunteerReward?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  volunteerTimeOff?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
  volunteering?: InputMaybe<CompanyFeatureNullableCompositeFilter>;
};

export enum FeeCoveredBy {
  Company = 'Company',
  Deed = 'Deed',
  User = 'User'
}

export type FileNamingConfigurationByFileType = {
  __typename?: 'FileNamingConfigurationByFileType';
  deduction: FileNamingTemplateConfiguration;
  reconciliation: FileNamingTemplateConfiguration;
};

export type FileNamingConfigurationByFileTypeCompositeFilter = {
  equals?: InputMaybe<FileNamingConfigurationByFileTypeObjectEqualityInput>;
  is?: InputMaybe<FileNamingConfigurationByFileTypeWhereInput>;
  isNot?: InputMaybe<FileNamingConfigurationByFileTypeWhereInput>;
};

export type FileNamingConfigurationByFileTypeCreateInput = {
  deduction: FileNamingTemplateConfigurationCreateInput;
  reconciliation: FileNamingTemplateConfigurationCreateInput;
};

export type FileNamingConfigurationByFileTypeObjectEqualityInput = {
  deduction: FileNamingTemplateConfigurationObjectEqualityInput;
  reconciliation: FileNamingTemplateConfigurationObjectEqualityInput;
};

export type FileNamingConfigurationByFileTypeOrderByInput = {
  deduction?: InputMaybe<FileNamingTemplateConfigurationOrderByInput>;
  reconciliation?: InputMaybe<FileNamingTemplateConfigurationOrderByInput>;
};

export type FileNamingConfigurationByFileTypeUpdateEnvelopeInput = {
  set?: InputMaybe<FileNamingConfigurationByFileTypeCreateInput>;
  update?: InputMaybe<FileNamingConfigurationByFileTypeUpdateInput>;
};

export type FileNamingConfigurationByFileTypeUpdateInput = {
  deduction?: InputMaybe<FileNamingTemplateConfigurationUpdateEnvelopeInput>;
  reconciliation?: InputMaybe<FileNamingTemplateConfigurationUpdateEnvelopeInput>;
};

export type FileNamingConfigurationByFileTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FileNamingConfigurationByFileTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FileNamingConfigurationByFileTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FileNamingConfigurationByFileTypeWhereInput>>>;
  deduction?: InputMaybe<FileNamingTemplateConfigurationCompositeFilter>;
  reconciliation?: InputMaybe<FileNamingTemplateConfigurationCompositeFilter>;
};

export type FileNamingTemplateConfiguration = {
  __typename?: 'FileNamingTemplateConfiguration';
  dateFormat: Scalars['String']['output'];
  extension?: Maybe<PayrollFlatFileFileExtension>;
  nameContainsUnknowns: Scalars['Boolean']['output'];
  orderedFileNameParts: Array<FlatFileNamePart>;
  prefix?: Maybe<Scalars['String']['output']>;
  separator: Scalars['String']['output'];
};

export type FileNamingTemplateConfigurationCompositeFilter = {
  equals?: InputMaybe<FileNamingTemplateConfigurationObjectEqualityInput>;
  is?: InputMaybe<FileNamingTemplateConfigurationWhereInput>;
  isNot?: InputMaybe<FileNamingTemplateConfigurationWhereInput>;
};

export type FileNamingTemplateConfigurationCreateInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<PayrollFlatFileFileExtension>;
  nameContainsUnknowns?: InputMaybe<Scalars['Boolean']['input']>;
  orderedFileNameParts?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
};

export type FileNamingTemplateConfigurationCreateorderedFileNamePartsInput = {
  set: FlatFileNamePart;
};

export type FileNamingTemplateConfigurationObjectEqualityInput = {
  dateFormat: Scalars['String']['input'];
  extension?: InputMaybe<PayrollFlatFileFileExtension>;
  nameContainsUnknowns: Scalars['Boolean']['input'];
  orderedFileNameParts?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  separator: Scalars['String']['input'];
};

export type FileNamingTemplateConfigurationOrderByInput = {
  dateFormat?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  nameContainsUnknowns?: InputMaybe<SortOrder>;
  orderedFileNameParts?: InputMaybe<SortOrder>;
  prefix?: InputMaybe<SortOrder>;
  separator?: InputMaybe<SortOrder>;
};

export type FileNamingTemplateConfigurationUpdateEnvelopeInput = {
  set?: InputMaybe<FileNamingTemplateConfigurationCreateInput>;
  update?: InputMaybe<FileNamingTemplateConfigurationUpdateInput>;
};

export type FileNamingTemplateConfigurationUpdateInput = {
  dateFormat?: InputMaybe<StringFieldUpdateOperationsInput>;
  extension?: InputMaybe<NullableEnumPayrollFlatFileFileExtensionFieldUpdateOperationsInput>;
  nameContainsUnknowns?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderedFileNameParts?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  separator?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileNamingTemplateConfigurationUpdateorderedFileNamePartsInput = {
  push?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
  set?: InputMaybe<Array<InputMaybe<FlatFileNamePart>>>;
};

export type FileNamingTemplateConfigurationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FileNamingTemplateConfigurationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FileNamingTemplateConfigurationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FileNamingTemplateConfigurationWhereInput>>>;
  dateFormat?: InputMaybe<StringFilter>;
  extension?: InputMaybe<EnumPayrollFlatFileFileExtensionNullableFilter>;
  nameContainsUnknowns?: InputMaybe<BoolFilter>;
  orderedFileNameParts?: InputMaybe<EnumFlatFileNamePartNullableListFilter>;
  prefix?: InputMaybe<StringNullableFilter>;
  separator?: InputMaybe<StringFilter>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  fileUri: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['String']['output'];
};

export type FileUploadCreateInput = {
  fileUri: Scalars['String']['input'];
  uploadedAt: Scalars['DateTime']['input'];
  uploadedBy: Scalars['String']['input'];
};

export type FileUploadNullableCompositeFilter = {
  equals?: InputMaybe<FileUploadObjectEqualityInput>;
  is?: InputMaybe<FileUploadWhereInput>;
  isNot?: InputMaybe<FileUploadWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadNullableCreateEnvelopeInput = {
  set?: InputMaybe<FileUploadCreateInput>;
};

export type FileUploadNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FileUploadCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<FileUploadUpsertInput>;
};

export type FileUploadObjectEqualityInput = {
  fileUri: Scalars['String']['input'];
  uploadedAt: Scalars['DateTime']['input'];
  uploadedBy: Scalars['String']['input'];
};

export type FileUploadOrderByInput = {
  fileUri?: InputMaybe<SortOrder>;
  uploadedAt?: InputMaybe<SortOrder>;
  uploadedBy?: InputMaybe<SortOrder>;
};

export type FileUploadUpdateInput = {
  fileUri?: InputMaybe<StringFieldUpdateOperationsInput>;
  uploadedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uploadedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUploadUpsertInput = {
  set: FileUploadCreateInput;
  update: FileUploadUpdateInput;
};

export type FileUploadWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FileUploadWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FileUploadWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FileUploadWhereInput>>>;
  fileUri?: InputMaybe<StringFilter>;
  uploadedAt?: InputMaybe<DateTimeFilter>;
  uploadedBy?: InputMaybe<StringFilter>;
};

export enum FilterOptions {
  All = 'all',
  Draft = 'draft',
  Ongoing = 'ongoing',
  Past = 'past',
  Pending = 'pending',
  Shared = 'shared',
  Upcoming = 'upcoming'
}

export type FinchApiConfig = {
  __typename?: 'FinchApiConfig';
  accountToken: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type FinchApiConfigCreateInput = {
  accountToken: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type FinchApiConfigNullableCompositeFilter = {
  equals?: InputMaybe<FinchApiConfigObjectEqualityInput>;
  is?: InputMaybe<FinchApiConfigWhereInput>;
  isNot?: InputMaybe<FinchApiConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinchApiConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<FinchApiConfigCreateInput>;
};

export type FinchApiConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FinchApiConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<FinchApiConfigUpsertInput>;
};

export type FinchApiConfigObjectEqualityInput = {
  accountToken: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type FinchApiConfigOrderByInput = {
  accountToken?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type FinchApiConfigUpdateInput = {
  accountToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinchApiConfigUpsertInput = {
  set: FinchApiConfigCreateInput;
  update: FinchApiConfigUpdateInput;
};

export type FinchApiConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FinchApiConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FinchApiConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FinchApiConfigWhereInput>>>;
  accountToken?: InputMaybe<StringFilter>;
  provider?: InputMaybe<StringFilter>;
};

export enum FlatFileNamePart {
  DeedPayCycleEndDate = 'DeedPayCycleEndDate',
  DeedPayCycleStartDate = 'DeedPayCycleStartDate',
  PayCycleEndDate = 'PayCycleEndDate',
  PayCycleId = 'PayCycleId',
  PayCycleStartDate = 'PayCycleStartDate',
  PayDate = 'PayDate',
  PayGroupName = 'PayGroupName',
  TransmissionDate = 'TransmissionDate'
}

export type FlatFileSyncConfig = {
  __typename?: 'FlatFileSyncConfig';
  deactivateMissingEmployees?: Maybe<Scalars['Boolean']['output']>;
  employeeActiveStatuses?: Maybe<Scalars['Json']['output']>;
  encryption?: Maybe<EncryptionConfiguration>;
  hrisColumnHeaderMapping?: Maybe<Scalars['Json']['output']>;
  hrisDirectory?: Maybe<Scalars['String']['output']>;
  hrisSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  locationsDirectory?: Maybe<Scalars['String']['output']>;
  locationsSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  sftp?: Maybe<SftpConfig>;
  useS3Sync?: Maybe<Scalars['Boolean']['output']>;
};

export type FlatFileSyncConfigCreateInput = {
  deactivateMissingEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  employeeActiveStatuses?: InputMaybe<Scalars['Json']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationCreateInput>;
  hrisColumnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  hrisDirectory?: InputMaybe<Scalars['String']['input']>;
  hrisSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationsDirectory?: InputMaybe<Scalars['String']['input']>;
  locationsSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sftp?: InputMaybe<SftpConfigCreateInput>;
  useS3Sync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlatFileSyncConfigNullableCompositeFilter = {
  equals?: InputMaybe<FlatFileSyncConfigObjectEqualityInput>;
  is?: InputMaybe<FlatFileSyncConfigWhereInput>;
  isNot?: InputMaybe<FlatFileSyncConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlatFileSyncConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<FlatFileSyncConfigCreateInput>;
};

export type FlatFileSyncConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FlatFileSyncConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<FlatFileSyncConfigUpsertInput>;
};

export type FlatFileSyncConfigObjectEqualityInput = {
  deactivateMissingEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  employeeActiveStatuses?: InputMaybe<Scalars['Json']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationObjectEqualityInput>;
  hrisColumnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  hrisDirectory?: InputMaybe<Scalars['String']['input']>;
  hrisSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationsDirectory?: InputMaybe<Scalars['String']['input']>;
  locationsSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sftp?: InputMaybe<SftpConfigObjectEqualityInput>;
  useS3Sync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlatFileSyncConfigOrderByInput = {
  deactivateMissingEmployees?: InputMaybe<SortOrder>;
  employeeActiveStatuses?: InputMaybe<SortOrder>;
  encryption?: InputMaybe<EncryptionConfigurationOrderByInput>;
  hrisColumnHeaderMapping?: InputMaybe<SortOrder>;
  hrisDirectory?: InputMaybe<SortOrder>;
  hrisSyncEnabled?: InputMaybe<SortOrder>;
  locationsDirectory?: InputMaybe<SortOrder>;
  locationsSyncEnabled?: InputMaybe<SortOrder>;
  sftp?: InputMaybe<SftpConfigOrderByInput>;
  useS3Sync?: InputMaybe<SortOrder>;
};

export type FlatFileSyncConfigUpdateInput = {
  deactivateMissingEmployees?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  employeeActiveStatuses?: InputMaybe<Scalars['Json']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationNullableUpdateEnvelopeInput>;
  hrisColumnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  hrisDirectory?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hrisSyncEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  locationsDirectory?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationsSyncEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sftp?: InputMaybe<SftpConfigNullableUpdateEnvelopeInput>;
  useS3Sync?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type FlatFileSyncConfigUpsertInput = {
  set: FlatFileSyncConfigCreateInput;
  update: FlatFileSyncConfigUpdateInput;
};

export type FlatFileSyncConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FlatFileSyncConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FlatFileSyncConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FlatFileSyncConfigWhereInput>>>;
  deactivateMissingEmployees?: InputMaybe<BoolNullableFilter>;
  employeeActiveStatuses?: InputMaybe<JsonNullableFilter>;
  encryption?: InputMaybe<EncryptionConfigurationNullableCompositeFilter>;
  hrisColumnHeaderMapping?: InputMaybe<JsonNullableFilter>;
  hrisDirectory?: InputMaybe<StringNullableFilter>;
  hrisSyncEnabled?: InputMaybe<BoolNullableFilter>;
  locationsDirectory?: InputMaybe<StringNullableFilter>;
  locationsSyncEnabled?: InputMaybe<BoolNullableFilter>;
  sftp?: InputMaybe<SftpConfigNullableCompositeFilter>;
  useS3Sync?: InputMaybe<BoolNullableFilter>;
};

export enum FlatFileTemplate {
  Checkr = 'Checkr',
  Default = 'Default',
  NeimanMarcus = 'NeimanMarcus',
  Nestle = 'Nestle',
  Nutanix = 'Nutanix',
  SchneiderElectric = 'SchneiderElectric',
  Synchrony = 'Synchrony',
  UnitedAirlines = 'UnitedAirlines',
  Walmart = 'Walmart',
  Wedbush = 'Wedbush'
}

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FloatNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  has?: InputMaybe<Scalars['Float']['input']>;
  hasEvery?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  hasSome?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** @Auth(read: [Admin, Organizer(type: Company, organizationField: organization), Employee(companyField: organization)]) */
export type Form = {
  __typename?: 'Form';
  Deeds: Array<Deed>;
  Organization: Organization;
  _count: FormCountOutputType;
  confirmationText?: Maybe<Scalars['String']['output']>;
  deeds: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSurvey: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  questions: Array<FormQuestion>;
  requireLogin?: Maybe<Scalars['Boolean']['output']>;
  responsesAggregation?: Maybe<Scalars['Json']['output']>;
  responsesCount?: Maybe<Scalars['Int']['output']>;
  subtitle: Scalars['String']['output'];
};


/** @Auth(read: [Admin, Organizer(type: Company, organizationField: organization), Employee(companyField: organization)]) */
export type FormDeedsArgs = {
  cursor?: InputMaybe<DeedWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DeedScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DeedOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeedWhereInput>;
};

export type FormAvgAggregateOutputType = {
  __typename?: 'FormAvgAggregateOutputType';
  responsesCount?: Maybe<Scalars['Float']['output']>;
};

export type FormAvgOrderByAggregateInput = {
  responsesCount?: InputMaybe<SortOrder>;
};

export type FormCountAggregateOutputType = {
  __typename?: 'FormCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  confirmationText: Scalars['Int']['output'];
  deeds: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  document: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSurvey: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  requireLogin: Scalars['Int']['output'];
  responsesAggregation: Scalars['Int']['output'];
  responsesCount: Scalars['Int']['output'];
  subtitle: Scalars['Int']['output'];
};

export type FormCountOrderByAggregateInput = {
  confirmationText?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  document?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSurvey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  requireLogin?: InputMaybe<SortOrder>;
  responsesAggregation?: InputMaybe<SortOrder>;
  responsesCount?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type FormCountOutputType = {
  __typename?: 'FormCountOutputType';
  Deeds: Scalars['Int']['output'];
  FormResponses: Scalars['Int']['output'];
  VolunteerRewards: Scalars['Int']['output'];
};

export type FormCreateInput = {
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutFormInput>;
  Organization: OrganizationCreateNestedOneWithoutFormsInput;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateManyInput = {
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateManyOrganizationInput = {
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateManyOrganizationInputEnvelope = {
  data: FormCreateManyOrganizationInput;
};

export type FormCreateNestedManyWithoutDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutDeedsInput>>>;
};

export type FormCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<FormCreateManyOrganizationInputEnvelope>;
};

export type FormCreateNestedOneWithoutFormResponsesInput = {
  connect?: InputMaybe<FormWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<FormCreateWithoutFormResponsesInput>;
};

export type FormCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<FormWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<FormCreateWithoutVolunteerRewardsInput>;
};

export type FormCreateOrConnectWithoutDeedsInput = {
  create: FormCreateWithoutDeedsInput;
  where: FormWhereUniqueInput;
};

export type FormCreateOrConnectWithoutFormResponsesInput = {
  create: FormCreateWithoutFormResponsesInput;
  where: FormWhereUniqueInput;
};

export type FormCreateOrConnectWithoutOrganizationInput = {
  create: FormCreateWithoutOrganizationInput;
  where: FormWhereUniqueInput;
};

export type FormCreateOrConnectWithoutVolunteerRewardsInput = {
  create: FormCreateWithoutVolunteerRewardsInput;
  where: FormWhereUniqueInput;
};

export type FormCreateWithoutDeedsInput = {
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutFormInput>;
  Organization: OrganizationCreateNestedOneWithoutFormsInput;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateWithoutFormResponsesInput = {
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutFormsInput>;
  Organization: OrganizationCreateNestedOneWithoutFormsInput;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateWithoutOrganizationInput = {
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutFormInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreateWithoutVolunteerRewardsInput = {
  Deeds?: InputMaybe<DeedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutFormInput>;
  Organization: OrganizationCreateNestedOneWithoutFormsInput;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormCreatedeedsInput = {
  set: Scalars['String']['input'];
};

export type FormListRelationFilter = {
  every?: InputMaybe<FormWhereInput>;
  none?: InputMaybe<FormWhereInput>;
  some?: InputMaybe<FormWhereInput>;
};

export type FormMaxAggregateOutputType = {
  __typename?: 'FormMaxAggregateOutputType';
  confirmationText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSurvey?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  requireLogin?: Maybe<Scalars['Boolean']['output']>;
  responsesCount?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type FormMaxOrderByAggregateInput = {
  confirmationText?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  document?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSurvey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  requireLogin?: InputMaybe<SortOrder>;
  responsesCount?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type FormMinAggregateOutputType = {
  __typename?: 'FormMinAggregateOutputType';
  confirmationText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSurvey?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  requireLogin?: Maybe<Scalars['Boolean']['output']>;
  responsesCount?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type FormMinOrderByAggregateInput = {
  confirmationText?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  document?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSurvey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  requireLogin?: InputMaybe<SortOrder>;
  responsesCount?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type FormNullableRelationFilter = {
  is?: InputMaybe<FormWhereInput>;
  isNot?: InputMaybe<FormWhereInput>;
};

export type FormOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FormOrderByWithAggregationInput = {
  _avg?: InputMaybe<FormAvgOrderByAggregateInput>;
  _count?: InputMaybe<FormCountOrderByAggregateInput>;
  _max?: InputMaybe<FormMaxOrderByAggregateInput>;
  _min?: InputMaybe<FormMinOrderByAggregateInput>;
  _sum?: InputMaybe<FormSumOrderByAggregateInput>;
  confirmationText?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  document?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSurvey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  requireLogin?: InputMaybe<SortOrder>;
  responsesAggregation?: InputMaybe<SortOrder>;
  responsesCount?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type FormOrderByWithRelationInput = {
  Deeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  FormResponses?: InputMaybe<FormResponseOrderByRelationAggregateInput>;
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  confirmationText?: InputMaybe<SortOrder>;
  deeds?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  document?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSurvey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  questions?: InputMaybe<FormQuestionOrderByCompositeAggregateInput>;
  requireLogin?: InputMaybe<SortOrder>;
  responsesAggregation?: InputMaybe<SortOrder>;
  responsesCount?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
};

export type FormQuestion = {
  __typename?: 'FormQuestion';
  correctAnswers?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  previousResponse?: Maybe<Scalars['Json']['output']>;
  questionType: Scalars['String']['output'];
  title: Scalars['String']['output'];
  typeConfiguration?: Maybe<Scalars['Json']['output']>;
  typeOptions?: Maybe<Scalars['Json']['output']>;
};

export type FormQuestionCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<FormQuestionObjectEqualityInput>>>;
  every?: InputMaybe<FormQuestionWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormQuestionWhereInput>;
  some?: InputMaybe<FormQuestionWhereInput>;
};

export type FormQuestionCreateInput = {
  correctAnswers?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  previousResponse?: InputMaybe<Scalars['Json']['input']>;
  questionType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  typeConfiguration?: InputMaybe<Scalars['Json']['input']>;
  typeOptions?: InputMaybe<Scalars['Json']['input']>;
};

export type FormQuestionDeleteManyInput = {
  where: FormQuestionWhereInput;
};

export type FormQuestionListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
};

export type FormQuestionListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<FormQuestionDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  updateMany?: InputMaybe<FormQuestionUpdateManyInput>;
};

export type FormQuestionObjectEqualityInput = {
  correctAnswers?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  previousResponse?: InputMaybe<Scalars['Json']['input']>;
  questionType: Scalars['String']['input'];
  title: Scalars['String']['input'];
  typeConfiguration?: InputMaybe<Scalars['Json']['input']>;
  typeOptions?: InputMaybe<Scalars['Json']['input']>;
};

export type FormQuestionOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FormQuestionUpdateInput = {
  correctAnswers?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  previousResponse?: InputMaybe<Scalars['Json']['input']>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  typeConfiguration?: InputMaybe<Scalars['Json']['input']>;
  typeOptions?: InputMaybe<Scalars['Json']['input']>;
};

export type FormQuestionUpdateManyInput = {
  data: FormQuestionUpdateInput;
  where: FormQuestionWhereInput;
};

export type FormQuestionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FormQuestionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FormQuestionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormQuestionWhereInput>>>;
  correctAnswers?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  previousResponse?: InputMaybe<JsonNullableFilter>;
  questionType?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  typeConfiguration?: InputMaybe<JsonNullableFilter>;
  typeOptions?: InputMaybe<JsonNullableFilter>;
};

export type FormRelationFilter = {
  is?: InputMaybe<FormWhereInput>;
  isNot?: InputMaybe<FormWhereInput>;
};

export type FormResponse = {
  __typename?: 'FormResponse';
  Deed?: Maybe<Deed>;
  Form: Form;
  User?: Maybe<BaseUser>;
  VolunteerTime?: Maybe<VolunteerTime>;
  _count: FormResponseCountOutputType;
  data?: Maybe<Scalars['Json']['output']>;
  deed?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  volunteerTime?: Maybe<Scalars['String']['output']>;
};


export type FormResponseDeedArgs = {
  where?: InputMaybe<DeedWhereInput>;
};


export type FormResponseUserArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};


export type FormResponseVolunteerTimeArgs = {
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type FormResponseCountAggregateOutputType = {
  __typename?: 'FormResponseCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  deed: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  user: Scalars['Int']['output'];
  volunteerTime: Scalars['Int']['output'];
};

export type FormResponseCountOrderByAggregateInput = {
  data?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type FormResponseCountOutputType = {
  __typename?: 'FormResponseCountOutputType';
  VolunteerRewards: Scalars['Int']['output'];
};

export type FormResponseCreateInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutFormResponsesInput>;
  Form: FormCreateNestedOneWithoutFormResponsesInput;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutFormResponsesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormResponseInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutFormResponsesInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyDeedInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyDeedInputEnvelope = {
  data: FormResponseCreateManyDeedInput;
};

export type FormResponseCreateManyFormInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyFormInputEnvelope = {
  data: FormResponseCreateManyFormInput;
};

export type FormResponseCreateManyInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyUserInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyUserInputEnvelope = {
  data: FormResponseCreateManyUserInput;
};

export type FormResponseCreateManyVolunteerTimeInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateManyVolunteerTimeInputEnvelope = {
  data: FormResponseCreateManyVolunteerTimeInput;
};

export type FormResponseCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyDeedInputEnvelope>;
};

export type FormResponseCreateNestedManyWithoutFormInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutFormInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyFormInputEnvelope>;
};

export type FormResponseCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutUserInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyUserInputEnvelope>;
};

export type FormResponseCreateNestedManyWithoutVolunteerTimeInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutVolunteerTimeInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutVolunteerTimeInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyVolunteerTimeInputEnvelope>;
};

export type FormResponseCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<FormResponseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormResponseCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<FormResponseCreateWithoutVolunteerRewardsInput>;
};

export type FormResponseCreateOrConnectWithoutDeedInput = {
  create: FormResponseCreateWithoutDeedInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseCreateOrConnectWithoutFormInput = {
  create: FormResponseCreateWithoutFormInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseCreateOrConnectWithoutUserInput = {
  create: FormResponseCreateWithoutUserInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseCreateOrConnectWithoutVolunteerRewardsInput = {
  create: FormResponseCreateWithoutVolunteerRewardsInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseCreateOrConnectWithoutVolunteerTimeInput = {
  create: FormResponseCreateWithoutVolunteerTimeInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseCreateWithoutDeedInput = {
  Form: FormCreateNestedOneWithoutFormResponsesInput;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutFormResponsesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormResponseInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutFormResponsesInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateWithoutFormInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutFormResponsesInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutFormResponsesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormResponseInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutFormResponsesInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateWithoutUserInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutFormResponsesInput>;
  Form: FormCreateNestedOneWithoutFormResponsesInput;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormResponseInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutFormResponsesInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateWithoutVolunteerRewardsInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutFormResponsesInput>;
  Form: FormCreateNestedOneWithoutFormResponsesInput;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutFormResponsesInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutFormResponsesInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseCreateWithoutVolunteerTimeInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutFormResponsesInput>;
  Form: FormCreateNestedOneWithoutFormResponsesInput;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutFormResponsesInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseListRelationFilter = {
  every?: InputMaybe<FormResponseWhereInput>;
  none?: InputMaybe<FormResponseWhereInput>;
  some?: InputMaybe<FormResponseWhereInput>;
};

export type FormResponseMaxAggregateOutputType = {
  __typename?: 'FormResponseMaxAggregateOutputType';
  deed?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  volunteerTime?: Maybe<Scalars['String']['output']>;
};

export type FormResponseMaxOrderByAggregateInput = {
  deed?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type FormResponseMinAggregateOutputType = {
  __typename?: 'FormResponseMinAggregateOutputType';
  deed?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  volunteerTime?: Maybe<Scalars['String']['output']>;
};

export type FormResponseMinOrderByAggregateInput = {
  deed?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type FormResponseNullableRelationFilter = {
  is?: InputMaybe<FormResponseWhereInput>;
  isNot?: InputMaybe<FormResponseWhereInput>;
};

export type FormResponseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FormResponseOrderByWithAggregationInput = {
  _count?: InputMaybe<FormResponseCountOrderByAggregateInput>;
  _max?: InputMaybe<FormResponseMaxOrderByAggregateInput>;
  _min?: InputMaybe<FormResponseMinOrderByAggregateInput>;
  data?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type FormResponseOrderByWithRelationInput = {
  Deed?: InputMaybe<DeedOrderByWithRelationInput>;
  Form?: InputMaybe<FormOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeOrderByWithRelationInput>;
  data?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export enum FormResponseScalarFieldEnum {
  Data = 'data',
  Deed = 'deed',
  Form = 'form',
  Id = 'id',
  Status = 'status',
  User = 'user',
  VolunteerTime = 'volunteerTime'
}

export type FormResponseScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  data?: InputMaybe<JsonNullableFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  form?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringNullableFilter>;
  volunteerTime?: InputMaybe<StringNullableFilter>;
};

export type FormResponseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereWithAggregatesInput>>>;
  data?: InputMaybe<JsonNullableWithAggregatesFilter>;
  deed?: InputMaybe<StringNullableWithAggregatesFilter>;
  form?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<StringNullableWithAggregatesFilter>;
  user?: InputMaybe<StringNullableWithAggregatesFilter>;
  volunteerTime?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type FormResponseUncheckedCreateInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyDeedInputEnvelope>;
};

export type FormResponseUncheckedCreateNestedManyWithoutFormInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutFormInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyFormInputEnvelope>;
};

export type FormResponseUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutUserInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyUserInputEnvelope>;
};

export type FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutVolunteerTimeInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutVolunteerTimeInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyVolunteerTimeInputEnvelope>;
};

export type FormResponseUncheckedCreateWithoutDeedInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedCreateWithoutFormInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedCreateWithoutUserInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedCreateWithoutVolunteerRewardsInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedCreateWithoutVolunteerTimeInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  form: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type FormResponseUncheckedUpdateInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyWithoutDeedInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type FormResponseUncheckedUpdateManyWithoutFormInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyWithoutFormNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutFormInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyFormInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutFormInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutFormInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutFormInput>>>;
};

export type FormResponseUncheckedUpdateManyWithoutUserInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutUserInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type FormResponseUncheckedUpdateManyWithoutVolunteerTimeInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutVolunteerTimeInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutVolunteerTimeInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyVolunteerTimeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutVolunteerTimeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutVolunteerTimeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutVolunteerTimeInput>>>;
};

export type FormResponseUncheckedUpdateWithoutDeedInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateWithoutFormInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateWithoutUserInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateWithoutVolunteerRewardsInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUncheckedUpdateWithoutVolunteerTimeInput = {
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  form?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutFormResponsesNestedInput>;
  Form?: InputMaybe<FormUpdateOneRequiredWithoutFormResponsesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutFormResponsesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormResponseNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutFormResponsesNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateManyWithWhereWithoutDeedInput = {
  data: FormResponseUpdateManyMutationInput;
  where: FormResponseScalarWhereInput;
};

export type FormResponseUpdateManyWithWhereWithoutFormInput = {
  data: FormResponseUpdateManyMutationInput;
  where: FormResponseScalarWhereInput;
};

export type FormResponseUpdateManyWithWhereWithoutUserInput = {
  data: FormResponseUpdateManyMutationInput;
  where: FormResponseScalarWhereInput;
};

export type FormResponseUpdateManyWithWhereWithoutVolunteerTimeInput = {
  data: FormResponseUpdateManyMutationInput;
  where: FormResponseScalarWhereInput;
};

export type FormResponseUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type FormResponseUpdateManyWithoutFormNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutFormInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyFormInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutFormInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutFormInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutFormInput>>>;
};

export type FormResponseUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutUserInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type FormResponseUpdateManyWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormResponseCreateOrConnectWithoutVolunteerTimeInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormResponseCreateWithoutVolunteerTimeInput>>>;
  createMany?: InputMaybe<FormResponseCreateManyVolunteerTimeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormResponseScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormResponseWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormResponseUpdateWithWhereUniqueWithoutVolunteerTimeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormResponseUpdateManyWithWhereWithoutVolunteerTimeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormResponseUpsertWithWhereUniqueWithoutVolunteerTimeInput>>>;
};

export type FormResponseUpdateOneWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<FormResponseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormResponseCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<FormResponseCreateWithoutVolunteerRewardsInput>;
  delete?: InputMaybe<FormResponseWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<FormResponseUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<FormResponseUpsertWithoutVolunteerRewardsInput>;
};

export type FormResponseUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: FormResponseUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<FormResponseWhereInput>;
};

export type FormResponseUpdateWithWhereUniqueWithoutDeedInput = {
  data: FormResponseUpdateWithoutDeedInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpdateWithWhereUniqueWithoutFormInput = {
  data: FormResponseUpdateWithoutFormInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpdateWithWhereUniqueWithoutUserInput = {
  data: FormResponseUpdateWithoutUserInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpdateWithWhereUniqueWithoutVolunteerTimeInput = {
  data: FormResponseUpdateWithoutVolunteerTimeInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpdateWithoutDeedInput = {
  Form?: InputMaybe<FormUpdateOneRequiredWithoutFormResponsesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutFormResponsesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormResponseNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutFormResponsesNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateWithoutFormInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutFormResponsesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutFormResponsesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormResponseNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutFormResponsesNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateWithoutUserInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutFormResponsesNestedInput>;
  Form?: InputMaybe<FormUpdateOneRequiredWithoutFormResponsesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormResponseNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutFormResponsesNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateWithoutVolunteerRewardsInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutFormResponsesNestedInput>;
  Form?: InputMaybe<FormUpdateOneRequiredWithoutFormResponsesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutFormResponsesNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutFormResponsesNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpdateWithoutVolunteerTimeInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutFormResponsesNestedInput>;
  Form?: InputMaybe<FormUpdateOneRequiredWithoutFormResponsesNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutFormResponsesNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormResponseNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FormResponseUpsertWithWhereUniqueWithoutDeedInput = {
  create: FormResponseCreateWithoutDeedInput;
  update: FormResponseUpdateWithoutDeedInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpsertWithWhereUniqueWithoutFormInput = {
  create: FormResponseCreateWithoutFormInput;
  update: FormResponseUpdateWithoutFormInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpsertWithWhereUniqueWithoutUserInput = {
  create: FormResponseCreateWithoutUserInput;
  update: FormResponseUpdateWithoutUserInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpsertWithWhereUniqueWithoutVolunteerTimeInput = {
  create: FormResponseCreateWithoutVolunteerTimeInput;
  update: FormResponseUpdateWithoutVolunteerTimeInput;
  where: FormResponseWhereUniqueInput;
};

export type FormResponseUpsertWithoutVolunteerRewardsInput = {
  create: FormResponseCreateWithoutVolunteerRewardsInput;
  update: FormResponseUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<FormResponseWhereInput>;
};

export type FormResponseWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  Form?: InputMaybe<FormRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeNullableRelationFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  form?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringNullableFilter>;
  volunteerTime?: InputMaybe<StringNullableFilter>;
};

export type FormResponseWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  Form?: InputMaybe<FormRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormResponseWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeNullableRelationFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  form?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<StringNullableFilter>;
  volunteerTime?: InputMaybe<StringNullableFilter>;
};

export enum FormScalarFieldEnum {
  ConfirmationText = 'confirmationText',
  Deeds = 'deeds',
  Description = 'description',
  Document = 'document',
  Id = 'id',
  IsSurvey = 'isSurvey',
  Name = 'name',
  Organization = 'organization',
  RequireLogin = 'requireLogin',
  ResponsesAggregation = 'responsesAggregation',
  ResponsesCount = 'responsesCount',
  Subtitle = 'subtitle'
}

export type FormScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  confirmationText?: InputMaybe<StringNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringFilter>;
  document?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isSurvey?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringFilter>;
  requireLogin?: InputMaybe<BoolNullableFilter>;
  responsesAggregation?: InputMaybe<JsonNullableFilter>;
  responsesCount?: InputMaybe<IntNullableFilter>;
  subtitle?: InputMaybe<StringFilter>;
};

export type FormScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<FormScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FormScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormScalarWhereWithAggregatesInput>>>;
  confirmationText?: InputMaybe<StringNullableWithAggregatesFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  document?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isSurvey?: InputMaybe<BoolWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  organization?: InputMaybe<StringWithAggregatesFilter>;
  requireLogin?: InputMaybe<BoolNullableWithAggregatesFilter>;
  responsesAggregation?: InputMaybe<JsonNullableWithAggregatesFilter>;
  responsesCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  subtitle?: InputMaybe<StringWithAggregatesFilter>;
};

export type FormSumAggregateOutputType = {
  __typename?: 'FormSumAggregateOutputType';
  responsesCount?: Maybe<Scalars['Int']['output']>;
};

export type FormSumOrderByAggregateInput = {
  responsesCount?: InputMaybe<SortOrder>;
};

export type FormUncheckedCreateInput = {
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutFormInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormUncheckedCreateNestedManyWithoutDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutDeedsInput>>>;
};

export type FormUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<FormCreateManyOrganizationInputEnvelope>;
};

export type FormUncheckedCreateWithoutDeedsInput = {
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutFormInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormUncheckedCreateWithoutFormResponsesInput = {
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutFormsInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormUncheckedCreateWithoutOrganizationInput = {
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutFormInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormUncheckedCreateWithoutVolunteerRewardsInput = {
  Deeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutFormsInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutFormInput>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<Scalars['Boolean']['input']>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<Scalars['Int']['input']>;
  subtitle: Scalars['String']['input'];
};

export type FormUncheckedUpdateInput = {
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutFormNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateManyInput = {
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateManyWithoutDeedsInput = {
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateManyWithoutDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormUpdateWithWhereUniqueWithoutDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormUpdateManyWithWhereWithoutDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormUpsertWithWhereUniqueWithoutDeedsInput>>>;
};

export type FormUncheckedUpdateManyWithoutOrganizationInput = {
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<FormCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type FormUncheckedUpdateWithoutDeedsInput = {
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutFormNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateWithoutFormResponsesInput = {
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutFormsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateWithoutOrganizationInput = {
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutFormNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUncheckedUpdateWithoutVolunteerRewardsInput = {
  Deeds?: InputMaybe<DeedUncheckedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deeds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateInput = {
  Deeds?: InputMaybe<DeedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutFormNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutFormsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateManyMutationInput = {
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateManyWithWhereWithoutDeedsInput = {
  data: FormUpdateManyMutationInput;
  where: FormScalarWhereInput;
};

export type FormUpdateManyWithWhereWithoutOrganizationInput = {
  data: FormUpdateManyMutationInput;
  where: FormScalarWhereInput;
};

export type FormUpdateManyWithoutDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormUpdateWithWhereUniqueWithoutDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormUpdateManyWithWhereWithoutDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormUpsertWithWhereUniqueWithoutDeedsInput>>>;
};

export type FormUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<FormCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<FormCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<FormCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<FormScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<FormWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FormUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<FormUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<FormUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type FormUpdateOneRequiredWithoutFormResponsesNestedInput = {
  connect?: InputMaybe<FormWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<FormCreateWithoutFormResponsesInput>;
  update?: InputMaybe<FormUpdateToOneWithWhereWithoutFormResponsesInput>;
  upsert?: InputMaybe<FormUpsertWithoutFormResponsesInput>;
};

export type FormUpdateOneWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<FormWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FormCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<FormCreateWithoutVolunteerRewardsInput>;
  delete?: InputMaybe<FormWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<FormUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<FormUpsertWithoutVolunteerRewardsInput>;
};

export type FormUpdateToOneWithWhereWithoutFormResponsesInput = {
  data: FormUpdateWithoutFormResponsesInput;
  where?: InputMaybe<FormWhereInput>;
};

export type FormUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: FormUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<FormWhereInput>;
};

export type FormUpdateWithWhereUniqueWithoutDeedsInput = {
  data: FormUpdateWithoutDeedsInput;
  where: FormWhereUniqueInput;
};

export type FormUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: FormUpdateWithoutOrganizationInput;
  where: FormWhereUniqueInput;
};

export type FormUpdateWithoutDeedsInput = {
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutFormNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutFormsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateWithoutFormResponsesInput = {
  Deeds?: InputMaybe<DeedUpdateManyWithoutFormsNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutFormsNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateWithoutOrganizationInput = {
  Deeds?: InputMaybe<DeedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutFormNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutFormNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdateWithoutVolunteerRewardsInput = {
  Deeds?: InputMaybe<DeedUpdateManyWithoutFormsNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutFormNestedInput>;
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutFormsNestedInput>;
  confirmationText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  document?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSurvey?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionCreateInput>>>;
  requireLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  responsesAggregation?: InputMaybe<Scalars['Json']['input']>;
  responsesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FormUpdatedeedsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormUpsertWithWhereUniqueWithoutDeedsInput = {
  create: FormCreateWithoutDeedsInput;
  update: FormUpdateWithoutDeedsInput;
  where: FormWhereUniqueInput;
};

export type FormUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: FormCreateWithoutOrganizationInput;
  update: FormUpdateWithoutOrganizationInput;
  where: FormWhereUniqueInput;
};

export type FormUpsertWithoutFormResponsesInput = {
  create: FormCreateWithoutFormResponsesInput;
  update: FormUpdateWithoutFormResponsesInput;
  where?: InputMaybe<FormWhereInput>;
};

export type FormUpsertWithoutVolunteerRewardsInput = {
  create: FormCreateWithoutVolunteerRewardsInput;
  update: FormUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<FormWhereInput>;
};

export type FormWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  Deeds?: InputMaybe<DeedListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  confirmationText?: InputMaybe<StringNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringFilter>;
  document?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isSurvey?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringFilter>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionObjectEqualityInput>>>;
  requireLogin?: InputMaybe<BoolNullableFilter>;
  responsesAggregation?: InputMaybe<JsonNullableFilter>;
  responsesCount?: InputMaybe<IntNullableFilter>;
  subtitle?: InputMaybe<StringFilter>;
};

export type FormWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  Deeds?: InputMaybe<DeedListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FormWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  confirmationText?: InputMaybe<StringNullableFilter>;
  deeds?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringFilter>;
  document?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSurvey?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<StringFilter>;
  questions?: InputMaybe<Array<InputMaybe<FormQuestionObjectEqualityInput>>>;
  requireLogin?: InputMaybe<BoolNullableFilter>;
  responsesAggregation?: InputMaybe<JsonNullableFilter>;
  responsesCount?: InputMaybe<IntNullableFilter>;
  subtitle?: InputMaybe<StringFilter>;
};

export type FullName = {
  __typename?: 'FullName';
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
};

export type FullNameCreateInput = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};

export type FullNameInput = {
  first: Scalars['String']['input'];
  last: Scalars['String']['input'];
};

export type FullNameNullableCompositeFilter = {
  equals?: InputMaybe<FullNameObjectEqualityInput>;
  is?: InputMaybe<FullNameWhereInput>;
  isNot?: InputMaybe<FullNameWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FullNameNullableCreateEnvelopeInput = {
  set?: InputMaybe<FullNameCreateInput>;
};

export type FullNameNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FullNameCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<FullNameUpsertInput>;
};

export type FullNameObjectEqualityInput = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};

export type FullNameOrderByInput = {
  first?: InputMaybe<SortOrder>;
  last?: InputMaybe<SortOrder>;
};

export type FullNameUpdateInput = {
  first?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FullNameUpsertInput = {
  set: FullNameCreateInput;
  update: FullNameUpdateInput;
};

export type FullNameWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<FullNameWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<FullNameWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<FullNameWhereInput>>>;
  first?: InputMaybe<StringNullableFilter>;
  last?: InputMaybe<StringNullableFilter>;
};

export type GeoInput = {
  coordinates: Array<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type GeoJson = {
  __typename?: 'GeoJSON';
  coordinates: Array<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoJsonCreateInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GeoJsonCreatecoordinatesInput = {
  set: Scalars['Float']['input'];
};

export type GeoJsonNullableCompositeFilter = {
  equals?: InputMaybe<GeoJsonObjectEqualityInput>;
  is?: InputMaybe<GeoJsonWhereInput>;
  isNot?: InputMaybe<GeoJsonWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeoJsonNullableCreateEnvelopeInput = {
  set?: InputMaybe<GeoJsonCreateInput>;
};

export type GeoJsonNullableUpdateEnvelopeInput = {
  set?: InputMaybe<GeoJsonCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<GeoJsonUpsertInput>;
};

export type GeoJsonObjectEqualityInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GeoJsonOrderByInput = {
  coordinates?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GeoJsonUpdateInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GeoJsonUpdatecoordinatesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GeoJsonUpsertInput = {
  set: GeoJsonCreateInput;
  update: GeoJsonUpdateInput;
};

export type GeoJsonWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GeoJsonWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GeoJsonWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GeoJsonWhereInput>>>;
  coordinates?: InputMaybe<FloatNullableListFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccount = {
  __typename?: 'GivingAccount';
  Company: Organization;
  Fundings: Array<GivingAccountFunding>;
  GivingAccountTransferInbound: Array<GivingAccountTransferInbound>;
  GivingAccountTransferOutbound: Array<GivingAccountTransferOutbound>;
  Withdrawals: Array<GivingAccountWithdrawal>;
  _count: GivingAccountCountOutputType;
  /** Get current account balance */
  balance: Scalars['Float']['output'];
  /** Get current account balance in all supported currencies */
  balanceCurrencies: CurrenciesMap;
  /** Get current account balance in user currency */
  balanceUserCurrency: Scalars['Float']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider: ProviderType;
  /** Return all transaction for the given account sorted by `creationDate` */
  transactions: Array<GivingAccountTransaction>;
};


/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccountFundingsArgs = {
  cursor?: InputMaybe<GivingAccountFundingWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<GivingAccountFundingOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GivingAccountFundingWhereInput>;
};


/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccountGivingAccountTransferInboundArgs = {
  cursor?: InputMaybe<GivingAccountTransferInboundWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};


/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccountGivingAccountTransferOutboundArgs = {
  cursor?: InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
};


/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccountWithdrawalsArgs = {
  cursor?: InputMaybe<GivingAccountWithdrawalWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GivingAccountWithdrawalWhereInput>;
};


/** @Auth(read: [Organizer(type: Company, privilege: budgetLedger:view, organizationField: companyId)]) */
export type GivingAccountTransactionsArgs = {
  createdAtSince?: InputMaybe<Scalars['String']['input']>;
  createdAtTill?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountCountAggregateOutputType = {
  __typename?: 'GivingAccountCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
};

export type GivingAccountCountOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type GivingAccountCountOutputType = {
  __typename?: 'GivingAccountCountOutputType';
  Fundings: Scalars['Int']['output'];
  GivingAccountTransferInbound: Scalars['Int']['output'];
  GivingAccountTransferOutbound: Scalars['Int']['output'];
  Withdrawals: Scalars['Int']['output'];
};

export type GivingAccountCreateInput = {
  Company: OrganizationCreateNestedOneWithoutGivingAccountsInput;
  Fundings?: InputMaybe<GivingAccountFundingCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateManyCompanyInput = {
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateManyCompanyInputEnvelope = {
  data: GivingAccountCreateManyCompanyInput;
};

export type GivingAccountCreateManyInput = {
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<GivingAccountCreateManyCompanyInputEnvelope>;
};

export type GivingAccountCreateNestedOneWithoutFundingsInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutFundingsInput>;
  create?: InputMaybe<GivingAccountCreateWithoutFundingsInput>;
};

export type GivingAccountCreateNestedOneWithoutGivingAccountTransferInboundInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutGivingAccountTransferInboundInput>;
  create?: InputMaybe<GivingAccountCreateWithoutGivingAccountTransferInboundInput>;
};

export type GivingAccountCreateNestedOneWithoutGivingAccountTransferOutboundInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountCreateWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountCreateNestedOneWithoutWithdrawalsInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutWithdrawalsInput>;
  create?: InputMaybe<GivingAccountCreateWithoutWithdrawalsInput>;
};

export type GivingAccountCreateOrConnectWithoutCompanyInput = {
  create: GivingAccountCreateWithoutCompanyInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountCreateOrConnectWithoutFundingsInput = {
  create: GivingAccountCreateWithoutFundingsInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountCreateOrConnectWithoutGivingAccountTransferInboundInput = {
  create: GivingAccountCreateWithoutGivingAccountTransferInboundInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountCreateOrConnectWithoutGivingAccountTransferOutboundInput = {
  create: GivingAccountCreateWithoutGivingAccountTransferOutboundInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountCreateOrConnectWithoutWithdrawalsInput = {
  create: GivingAccountCreateWithoutWithdrawalsInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountCreateWithoutCompanyInput = {
  Fundings?: InputMaybe<GivingAccountFundingCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateWithoutFundingsInput = {
  Company: OrganizationCreateNestedOneWithoutGivingAccountsInput;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateWithoutGivingAccountTransferInboundInput = {
  Company: OrganizationCreateNestedOneWithoutGivingAccountsInput;
  Fundings?: InputMaybe<GivingAccountFundingCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateWithoutGivingAccountTransferOutboundInput = {
  Company: OrganizationCreateNestedOneWithoutGivingAccountsInput;
  Fundings?: InputMaybe<GivingAccountFundingCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountCreateWithoutWithdrawalsInput = {
  Company: OrganizationCreateNestedOneWithoutGivingAccountsInput;
  Fundings?: InputMaybe<GivingAccountFundingCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

/** @Auth(read: [Organizer,Admin]) */
export type GivingAccountFunding = {
  __typename?: 'GivingAccountFunding';
  GivingAccount: GivingAccount;
  amount: Scalars['Float']['output'];
  author: Scalars['String']['output'];
  /** not stored in DB, populated later in Nexus */
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  givingAccountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @Auth(read: [Admin]) */
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: ProviderType;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  /** not stored in DB, only needed for Union mapping in Nexus */
  type?: Maybe<TransactionType>;
};

export type GivingAccountFundingAvgAggregateOutputType = {
  __typename?: 'GivingAccountFundingAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountFundingAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingCountAggregateOutputType = {
  __typename?: 'GivingAccountFundingCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  author: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  givingAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  receiptUrl: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type GivingAccountFundingCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingCreateInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutFundingsInput;
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingCreateInputType = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  givingAccountId: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountFundingCreateManyGivingAccountInput = {
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingCreateManyGivingAccountInputEnvelope = {
  data: GivingAccountFundingCreateManyGivingAccountInput;
};

export type GivingAccountFundingCreateManyInput = {
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountFundingCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountFundingCreateOrConnectWithoutGivingAccountInput = {
  create: GivingAccountFundingCreateWithoutGivingAccountInput;
  where: GivingAccountFundingWhereUniqueInput;
};

export type GivingAccountFundingCreateWithoutGivingAccountInput = {
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingListRelationFilter = {
  every?: InputMaybe<GivingAccountFundingWhereInput>;
  none?: InputMaybe<GivingAccountFundingWhereInput>;
  some?: InputMaybe<GivingAccountFundingWhereInput>;
};

export type GivingAccountFundingMaxAggregateOutputType = {
  __typename?: 'GivingAccountFundingMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<ProviderType>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountFundingMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingMinAggregateOutputType = {
  __typename?: 'GivingAccountFundingMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<ProviderType>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountFundingMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingOrderByWithAggregationInput = {
  _avg?: InputMaybe<GivingAccountFundingAvgOrderByAggregateInput>;
  _count?: InputMaybe<GivingAccountFundingCountOrderByAggregateInput>;
  _max?: InputMaybe<GivingAccountFundingMaxOrderByAggregateInput>;
  _min?: InputMaybe<GivingAccountFundingMinOrderByAggregateInput>;
  _sum?: InputMaybe<GivingAccountFundingSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingOrderByWithRelationInput = {
  GivingAccount?: InputMaybe<GivingAccountOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum GivingAccountFundingScalarFieldEnum {
  Amount = 'amount',
  Author = 'author',
  Balance = 'balance',
  CreatedAt = 'createdAt',
  Description = 'description',
  GivingAccountId = 'givingAccountId',
  Id = 'id',
  Identifier = 'identifier',
  ModifiedAt = 'modifiedAt',
  Note = 'note',
  ProcessedAt = 'processedAt',
  Provider = 'provider',
  ReceiptUrl = 'receiptUrl',
  Type = 'type'
}

export type GivingAccountFundingScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountFundingScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  author?: InputMaybe<StringWithAggregatesFilter>;
  balance?: InputMaybe<FloatNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  givingAccountId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  note?: InputMaybe<StringNullableWithAggregatesFilter>;
  processedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  provider?: InputMaybe<EnumProviderTypeWithAggregatesFilter>;
  receiptUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableWithAggregatesFilter>;
};

export type GivingAccountFundingSumAggregateOutputType = {
  __typename?: 'GivingAccountFundingSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountFundingSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountFundingUncheckedCreateInput = {
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountFundingCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountFundingUncheckedCreateWithoutGivingAccountInput = {
  amount: Scalars['Float']['input'];
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountFundingUncheckedUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUncheckedUpdateManyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountFundingCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountFundingUncheckedUpdateWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUpdateInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutFundingsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUpdateManyWithWhereWithoutGivingAccountInput = {
  data: GivingAccountFundingUpdateManyMutationInput;
  where: GivingAccountFundingScalarWhereInput;
};

export type GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountFundingCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountFundingCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountFundingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountFundingUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountFundingUpdateWithWhereUniqueWithoutGivingAccountInput = {
  data: GivingAccountFundingUpdateWithoutGivingAccountInput;
  where: GivingAccountFundingWhereUniqueInput;
};

export type GivingAccountFundingUpdateWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountFundingUpsertWithWhereUniqueWithoutGivingAccountInput = {
  create: GivingAccountFundingCreateWithoutGivingAccountInput;
  update: GivingAccountFundingUpdateWithoutGivingAccountInput;
  where: GivingAccountFundingWhereUniqueInput;
};

export type GivingAccountFundingWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountFundingWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountFundingWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountListRelationFilter = {
  every?: InputMaybe<GivingAccountWhereInput>;
  none?: InputMaybe<GivingAccountWhereInput>;
  some?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountMaxAggregateOutputType = {
  __typename?: 'GivingAccountMaxAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
};

export type GivingAccountMaxOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type GivingAccountMinAggregateOutputType = {
  __typename?: 'GivingAccountMinAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderType>;
};

export type GivingAccountMinOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type GivingAccountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GivingAccountOrderByWithAggregationInput = {
  _count?: InputMaybe<GivingAccountCountOrderByAggregateInput>;
  _max?: InputMaybe<GivingAccountMaxOrderByAggregateInput>;
  _min?: InputMaybe<GivingAccountMinOrderByAggregateInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type GivingAccountOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Fundings?: InputMaybe<GivingAccountFundingOrderByRelationAggregateInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundOrderByRelationAggregateInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundOrderByRelationAggregateInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalOrderByRelationAggregateInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type GivingAccountRelationFilter = {
  is?: InputMaybe<GivingAccountWhereInput>;
  isNot?: InputMaybe<GivingAccountWhereInput>;
};

export enum GivingAccountScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Name = 'name',
  Provider = 'provider'
}

export type GivingAccountScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereInput>>>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
};

export type GivingAccountScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereWithAggregatesInput>>>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  provider?: InputMaybe<EnumProviderTypeWithAggregatesFilter>;
};

/** @Auth(read:[Organizer,Admin]) */
export type GivingAccountTransaction = GivingAccountFunding | GivingAccountTransferInbound | GivingAccountTransferOutbound | GivingAccountWithdrawal;

/** @Auth(read: [Organizer,Admin]) */
export type GivingAccountTransferInbound = {
  __typename?: 'GivingAccountTransferInbound';
  GivingAccount: GivingAccount;
  GivingAccountTransferOutbound: GivingAccountTransferOutbound;
  amount: Scalars['Float']['output'];
  /** not stored in DB, populated later in Nexus */
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  givingAccountId: Scalars['String']['output'];
  givingAccountTransferOutboundId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** @Auth(read: [Admin]) */
  note?: Maybe<Scalars['String']['output']>;
  /** not stored in DB, only needed for Union mapping in Nexus */
  type?: Maybe<TransactionType>;
};

export type GivingAccountTransferInboundAvgAggregateOutputType = {
  __typename?: 'GivingAccountTransferInboundAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountTransferInboundAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundCountAggregateOutputType = {
  __typename?: 'GivingAccountTransferInboundCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  givingAccountId: Scalars['Int']['output'];
  givingAccountTransferOutboundId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type GivingAccountTransferInboundCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  givingAccountTransferOutboundId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundCreateInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutGivingAccountTransferInboundInput;
  GivingAccountTransferOutbound: GivingAccountTransferOutboundCreateNestedOneWithoutGivingAccountTransferInboundInput;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundCreateManyGivingAccountInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountTransferOutboundId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundCreateManyGivingAccountInputEnvelope = {
  data: GivingAccountTransferInboundCreateManyGivingAccountInput;
};

export type GivingAccountTransferInboundCreateManyInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  givingAccountTransferOutboundId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferInboundCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountTransferInboundCreateNestedOneWithoutGivingAccountTransferOutboundInput = {
  connect?: InputMaybe<GivingAccountTransferInboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountInput = {
  create: GivingAccountTransferInboundCreateWithoutGivingAccountInput;
  where: GivingAccountTransferInboundWhereUniqueInput;
};

export type GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountTransferOutboundInput = {
  create: GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput;
  where: GivingAccountTransferInboundWhereUniqueInput;
};

export type GivingAccountTransferInboundCreateWithoutGivingAccountInput = {
  GivingAccountTransferOutbound: GivingAccountTransferOutboundCreateNestedOneWithoutGivingAccountTransferInboundInput;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutGivingAccountTransferInboundInput;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundListRelationFilter = {
  every?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  none?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  some?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};

export type GivingAccountTransferInboundMaxAggregateOutputType = {
  __typename?: 'GivingAccountTransferInboundMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  givingAccountTransferOutboundId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountTransferInboundMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  givingAccountTransferOutboundId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundMinAggregateOutputType = {
  __typename?: 'GivingAccountTransferInboundMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  givingAccountTransferOutboundId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountTransferInboundMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  givingAccountTransferOutboundId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundNullableRelationFilter = {
  is?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  isNot?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};

export type GivingAccountTransferInboundOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundOrderByWithAggregationInput = {
  _avg?: InputMaybe<GivingAccountTransferInboundAvgOrderByAggregateInput>;
  _count?: InputMaybe<GivingAccountTransferInboundCountOrderByAggregateInput>;
  _max?: InputMaybe<GivingAccountTransferInboundMaxOrderByAggregateInput>;
  _min?: InputMaybe<GivingAccountTransferInboundMinOrderByAggregateInput>;
  _sum?: InputMaybe<GivingAccountTransferInboundSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  givingAccountTransferOutboundId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundOrderByWithRelationInput = {
  GivingAccount?: InputMaybe<GivingAccountOrderByWithRelationInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  givingAccountTransferOutboundId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum GivingAccountTransferInboundScalarFieldEnum {
  Amount = 'amount',
  Balance = 'balance',
  CreatedAt = 'createdAt',
  GivingAccountId = 'givingAccountId',
  GivingAccountTransferOutboundId = 'givingAccountTransferOutboundId',
  Id = 'id',
  Note = 'note',
  Type = 'type'
}

export type GivingAccountTransferInboundScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  givingAccountTransferOutboundId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountTransferInboundScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  balance?: InputMaybe<FloatNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  givingAccountId?: InputMaybe<StringWithAggregatesFilter>;
  givingAccountTransferOutboundId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  note?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableWithAggregatesFilter>;
};

export type GivingAccountTransferInboundSumAggregateOutputType = {
  __typename?: 'GivingAccountTransferInboundSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountTransferInboundSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferInboundUncheckedCreateInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  givingAccountTransferOutboundId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferInboundCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountTransferInboundUncheckedCreateNestedOneWithoutGivingAccountTransferOutboundInput = {
  connect?: InputMaybe<GivingAccountTransferInboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountTransferInboundUncheckedCreateWithoutGivingAccountInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountTransferOutboundId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundUncheckedCreateWithoutGivingAccountTransferOutboundInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferInboundUncheckedUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  givingAccountTransferOutboundId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUncheckedUpdateManyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  givingAccountTransferOutboundId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountTransferOutboundId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferInboundCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountTransferInboundUncheckedUpdateOneWithoutGivingAccountTransferOutboundNestedInput = {
  connect?: InputMaybe<GivingAccountTransferInboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput>;
  delete?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  disconnect?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  update?: InputMaybe<GivingAccountTransferInboundUpdateToOneWithWhereWithoutGivingAccountTransferOutboundInput>;
  upsert?: InputMaybe<GivingAccountTransferInboundUpsertWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountTransferInboundUncheckedUpdateWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountTransferOutboundId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUncheckedUpdateWithoutGivingAccountTransferOutboundInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUpdateInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUpdateManyWithWhereWithoutGivingAccountInput = {
  data: GivingAccountTransferInboundUpdateManyMutationInput;
  where: GivingAccountTransferInboundScalarWhereInput;
};

export type GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferInboundCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountTransferInboundUpdateOneWithoutGivingAccountTransferOutboundNestedInput = {
  connect?: InputMaybe<GivingAccountTransferInboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferInboundCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput>;
  delete?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  disconnect?: InputMaybe<GivingAccountTransferInboundWhereInput>;
  update?: InputMaybe<GivingAccountTransferInboundUpdateToOneWithWhereWithoutGivingAccountTransferOutboundInput>;
  upsert?: InputMaybe<GivingAccountTransferInboundUpsertWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountTransferInboundUpdateToOneWithWhereWithoutGivingAccountTransferOutboundInput = {
  data: GivingAccountTransferInboundUpdateWithoutGivingAccountTransferOutboundInput;
  where?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};

export type GivingAccountTransferInboundUpdateWithWhereUniqueWithoutGivingAccountInput = {
  data: GivingAccountTransferInboundUpdateWithoutGivingAccountInput;
  where: GivingAccountTransferInboundWhereUniqueInput;
};

export type GivingAccountTransferInboundUpdateWithoutGivingAccountInput = {
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUpdateWithoutGivingAccountTransferOutboundInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferInboundUpsertWithWhereUniqueWithoutGivingAccountInput = {
  create: GivingAccountTransferInboundCreateWithoutGivingAccountInput;
  update: GivingAccountTransferInboundUpdateWithoutGivingAccountInput;
  where: GivingAccountTransferInboundWhereUniqueInput;
};

export type GivingAccountTransferInboundUpsertWithoutGivingAccountTransferOutboundInput = {
  create: GivingAccountTransferInboundCreateWithoutGivingAccountTransferOutboundInput;
  update: GivingAccountTransferInboundUpdateWithoutGivingAccountTransferOutboundInput;
  where?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};

export type GivingAccountTransferInboundWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  givingAccountTransferOutboundId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountTransferInboundWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferInboundWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  givingAccountTransferOutboundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

/** @Auth(read: [Organizer,Admin]) */
export type GivingAccountTransferOutbound = {
  __typename?: 'GivingAccountTransferOutbound';
  GivingAccount: GivingAccount;
  GivingAccountTransferInbound?: Maybe<GivingAccountTransferInbound>;
  amount: Scalars['Float']['output'];
  /** not stored in DB, populated later in Nexus */
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  givingAccountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** @Auth(read: [Admin]) */
  note?: Maybe<Scalars['String']['output']>;
  /** not stored in DB, only needed for Union mapping in Nexus */
  type?: Maybe<TransactionType>;
};


/** @Auth(read: [Organizer,Admin]) */
export type GivingAccountTransferOutboundGivingAccountTransferInboundArgs = {
  where?: InputMaybe<GivingAccountTransferInboundWhereInput>;
};

export type GivingAccountTransferOutboundAvgAggregateOutputType = {
  __typename?: 'GivingAccountTransferOutboundAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountTransferOutboundAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundCountAggregateOutputType = {
  __typename?: 'GivingAccountTransferOutboundCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  givingAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type GivingAccountTransferOutboundCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundCreateInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutGivingAccountTransferOutboundInput;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedOneWithoutGivingAccountTransferOutboundInput>;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundCreateManyGivingAccountInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundCreateManyGivingAccountInputEnvelope = {
  data: GivingAccountTransferOutboundCreateManyGivingAccountInput;
};

export type GivingAccountTransferOutboundCreateManyInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferOutboundCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountTransferOutboundCreateNestedOneWithoutGivingAccountTransferInboundInput = {
  connect?: InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountTransferInboundInput>;
  create?: InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountTransferInboundInput>;
};

export type GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountInput = {
  create: GivingAccountTransferOutboundCreateWithoutGivingAccountInput;
  where: GivingAccountTransferOutboundWhereUniqueInput;
};

export type GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountTransferInboundInput = {
  create: GivingAccountTransferOutboundCreateWithoutGivingAccountTransferInboundInput;
  where: GivingAccountTransferOutboundWhereUniqueInput;
};

export type GivingAccountTransferOutboundCreateWithoutGivingAccountInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundCreateNestedOneWithoutGivingAccountTransferOutboundInput>;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundCreateWithoutGivingAccountTransferInboundInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutGivingAccountTransferOutboundInput;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundListRelationFilter = {
  every?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
  none?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
  some?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
};

export type GivingAccountTransferOutboundMaxAggregateOutputType = {
  __typename?: 'GivingAccountTransferOutboundMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountTransferOutboundMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundMinAggregateOutputType = {
  __typename?: 'GivingAccountTransferOutboundMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TransactionType>;
};

export type GivingAccountTransferOutboundMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundOrderByWithAggregationInput = {
  _avg?: InputMaybe<GivingAccountTransferOutboundAvgOrderByAggregateInput>;
  _count?: InputMaybe<GivingAccountTransferOutboundCountOrderByAggregateInput>;
  _max?: InputMaybe<GivingAccountTransferOutboundMaxOrderByAggregateInput>;
  _min?: InputMaybe<GivingAccountTransferOutboundMinOrderByAggregateInput>;
  _sum?: InputMaybe<GivingAccountTransferOutboundSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundOrderByWithRelationInput = {
  GivingAccount?: InputMaybe<GivingAccountOrderByWithRelationInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundRelationFilter = {
  is?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
  isNot?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
};

export enum GivingAccountTransferOutboundScalarFieldEnum {
  Amount = 'amount',
  Balance = 'balance',
  CreatedAt = 'createdAt',
  GivingAccountId = 'givingAccountId',
  Id = 'id',
  Note = 'note',
  Type = 'type'
}

export type GivingAccountTransferOutboundScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountTransferOutboundScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  balance?: InputMaybe<FloatNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  givingAccountId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  note?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableWithAggregatesFilter>;
};

export type GivingAccountTransferOutboundSumAggregateOutputType = {
  __typename?: 'GivingAccountTransferOutboundSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountTransferOutboundSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
};

export type GivingAccountTransferOutboundUncheckedCreateInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedOneWithoutGivingAccountTransferOutboundInput>;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferOutboundCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountTransferOutboundUncheckedCreateWithoutGivingAccountInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedOneWithoutGivingAccountTransferOutboundInput>;
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundUncheckedCreateWithoutGivingAccountTransferInboundInput = {
  amount: Scalars['Float']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  createdAt: Scalars['DateTime']['input'];
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type GivingAccountTransferOutboundUncheckedUpdateInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateOneWithoutGivingAccountTransferOutboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUncheckedUpdateManyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferOutboundCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountTransferOutboundUncheckedUpdateWithoutGivingAccountInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateOneWithoutGivingAccountTransferOutboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUncheckedUpdateWithoutGivingAccountTransferInboundInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUpdateInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutGivingAccountTransferOutboundNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateOneWithoutGivingAccountTransferOutboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUpdateManyWithWhereWithoutGivingAccountInput = {
  data: GivingAccountTransferOutboundUpdateManyMutationInput;
  where: GivingAccountTransferOutboundScalarWhereInput;
};

export type GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountTransferOutboundCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountTransferOutboundUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput = {
  connect?: InputMaybe<GivingAccountTransferOutboundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountTransferOutboundCreateOrConnectWithoutGivingAccountTransferInboundInput>;
  create?: InputMaybe<GivingAccountTransferOutboundCreateWithoutGivingAccountTransferInboundInput>;
  update?: InputMaybe<GivingAccountTransferOutboundUpdateToOneWithWhereWithoutGivingAccountTransferInboundInput>;
  upsert?: InputMaybe<GivingAccountTransferOutboundUpsertWithoutGivingAccountTransferInboundInput>;
};

export type GivingAccountTransferOutboundUpdateToOneWithWhereWithoutGivingAccountTransferInboundInput = {
  data: GivingAccountTransferOutboundUpdateWithoutGivingAccountTransferInboundInput;
  where?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
};

export type GivingAccountTransferOutboundUpdateWithWhereUniqueWithoutGivingAccountInput = {
  data: GivingAccountTransferOutboundUpdateWithoutGivingAccountInput;
  where: GivingAccountTransferOutboundWhereUniqueInput;
};

export type GivingAccountTransferOutboundUpdateWithoutGivingAccountInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateOneWithoutGivingAccountTransferOutboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUpdateWithoutGivingAccountTransferInboundInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutGivingAccountTransferOutboundNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
};

export type GivingAccountTransferOutboundUpsertWithWhereUniqueWithoutGivingAccountInput = {
  create: GivingAccountTransferOutboundCreateWithoutGivingAccountInput;
  update: GivingAccountTransferOutboundUpdateWithoutGivingAccountInput;
  where: GivingAccountTransferOutboundWhereUniqueInput;
};

export type GivingAccountTransferOutboundUpsertWithoutGivingAccountTransferInboundInput = {
  create: GivingAccountTransferOutboundCreateWithoutGivingAccountTransferInboundInput;
  update: GivingAccountTransferOutboundUpdateWithoutGivingAccountTransferInboundInput;
  where?: InputMaybe<GivingAccountTransferOutboundWhereInput>;
};

export type GivingAccountTransferOutboundWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountTransferOutboundWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountTransferOutboundWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
};

export type GivingAccountUncheckedCreateInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<GivingAccountCreateManyCompanyInputEnvelope>;
};

export type GivingAccountUncheckedCreateWithoutCompanyInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedCreateWithoutFundingsInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedCreateWithoutGivingAccountTransferInboundInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedCreateWithoutGivingAccountTransferOutboundInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedCreateWithoutWithdrawalsInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedCreateNestedManyWithoutGivingAccountInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};

export type GivingAccountUncheckedUpdateInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateManyInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateManyWithoutCompanyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<GivingAccountCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type GivingAccountUncheckedUpdateWithoutCompanyInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateWithoutFundingsInput = {
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateWithoutGivingAccountTransferInboundInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateWithoutGivingAccountTransferOutboundInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUncheckedUpdateWithoutWithdrawalsInput = {
  Fundings?: InputMaybe<GivingAccountFundingUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUncheckedUpdateManyWithoutGivingAccountNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput>;
  Fundings?: InputMaybe<GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateManyWithWhereWithoutCompanyInput = {
  data: GivingAccountUpdateManyMutationInput;
  where: GivingAccountScalarWhereInput;
};

export type GivingAccountUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<GivingAccountCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type GivingAccountUpdateOneRequiredWithoutFundingsNestedInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutFundingsInput>;
  create?: InputMaybe<GivingAccountCreateWithoutFundingsInput>;
  update?: InputMaybe<GivingAccountUpdateToOneWithWhereWithoutFundingsInput>;
  upsert?: InputMaybe<GivingAccountUpsertWithoutFundingsInput>;
};

export type GivingAccountUpdateOneRequiredWithoutGivingAccountTransferInboundNestedInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutGivingAccountTransferInboundInput>;
  create?: InputMaybe<GivingAccountCreateWithoutGivingAccountTransferInboundInput>;
  update?: InputMaybe<GivingAccountUpdateToOneWithWhereWithoutGivingAccountTransferInboundInput>;
  upsert?: InputMaybe<GivingAccountUpsertWithoutGivingAccountTransferInboundInput>;
};

export type GivingAccountUpdateOneRequiredWithoutGivingAccountTransferOutboundNestedInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutGivingAccountTransferOutboundInput>;
  create?: InputMaybe<GivingAccountCreateWithoutGivingAccountTransferOutboundInput>;
  update?: InputMaybe<GivingAccountUpdateToOneWithWhereWithoutGivingAccountTransferOutboundInput>;
  upsert?: InputMaybe<GivingAccountUpsertWithoutGivingAccountTransferOutboundInput>;
};

export type GivingAccountUpdateOneRequiredWithoutWithdrawalsNestedInput = {
  connect?: InputMaybe<GivingAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GivingAccountCreateOrConnectWithoutWithdrawalsInput>;
  create?: InputMaybe<GivingAccountCreateWithoutWithdrawalsInput>;
  update?: InputMaybe<GivingAccountUpdateToOneWithWhereWithoutWithdrawalsInput>;
  upsert?: InputMaybe<GivingAccountUpsertWithoutWithdrawalsInput>;
};

export type GivingAccountUpdateToOneWithWhereWithoutFundingsInput = {
  data: GivingAccountUpdateWithoutFundingsInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpdateToOneWithWhereWithoutGivingAccountTransferInboundInput = {
  data: GivingAccountUpdateWithoutGivingAccountTransferInboundInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpdateToOneWithWhereWithoutGivingAccountTransferOutboundInput = {
  data: GivingAccountUpdateWithoutGivingAccountTransferOutboundInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpdateToOneWithWhereWithoutWithdrawalsInput = {
  data: GivingAccountUpdateWithoutWithdrawalsInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpdateWithWhereUniqueWithoutCompanyInput = {
  data: GivingAccountUpdateWithoutCompanyInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountUpdateWithoutCompanyInput = {
  Fundings?: InputMaybe<GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateWithoutFundingsInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateWithoutGivingAccountTransferInboundInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput>;
  Fundings?: InputMaybe<GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateWithoutGivingAccountTransferOutboundInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput>;
  Fundings?: InputMaybe<GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpdateWithoutWithdrawalsInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput>;
  Fundings?: InputMaybe<GivingAccountFundingUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundUpdateManyWithoutGivingAccountNestedInput>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundUpdateManyWithoutGivingAccountNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
};

export type GivingAccountUpsertWithWhereUniqueWithoutCompanyInput = {
  create: GivingAccountCreateWithoutCompanyInput;
  update: GivingAccountUpdateWithoutCompanyInput;
  where: GivingAccountWhereUniqueInput;
};

export type GivingAccountUpsertWithoutFundingsInput = {
  create: GivingAccountCreateWithoutFundingsInput;
  update: GivingAccountUpdateWithoutFundingsInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpsertWithoutGivingAccountTransferInboundInput = {
  create: GivingAccountCreateWithoutGivingAccountTransferInboundInput;
  update: GivingAccountUpdateWithoutGivingAccountTransferInboundInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpsertWithoutGivingAccountTransferOutboundInput = {
  create: GivingAccountCreateWithoutGivingAccountTransferOutboundInput;
  update: GivingAccountUpdateWithoutGivingAccountTransferOutboundInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountUpsertWithoutWithdrawalsInput = {
  create: GivingAccountCreateWithoutWithdrawalsInput;
  update: GivingAccountUpdateWithoutWithdrawalsInput;
  where?: InputMaybe<GivingAccountWhereInput>;
};

export type GivingAccountWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Fundings?: InputMaybe<GivingAccountFundingListRelationFilter>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundListRelationFilter>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalListRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
};

export type GivingAccountWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Fundings?: InputMaybe<GivingAccountFundingListRelationFilter>;
  GivingAccountTransferInbound?: InputMaybe<GivingAccountTransferInboundListRelationFilter>;
  GivingAccountTransferOutbound?: InputMaybe<GivingAccountTransferOutboundListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWhereInput>>>;
  Withdrawals?: InputMaybe<GivingAccountWithdrawalListRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
};

/** @Auth(read: [Organizer]) */
export type GivingAccountWithdrawal = {
  __typename?: 'GivingAccountWithdrawal';
  GivingAccount: GivingAccount;
  /** Amount in the currency of the given transaction */
  amount: Scalars['Float']['output'];
  /** Application fee amount in the currency of the given transaction */
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  author: Scalars['String']['output'];
  /** not stored in DB, populated later in Nexus */
  balance?: Maybe<Scalars['Float']['output']>;
  batchFilename: Scalars['String']['output'];
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Currency Code of current transaction */
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  /** Total fee amount in the currency of the given transaction. Fee amount = processing fee + application fee */
  feeAmount: Scalars['Float']['output'];
  /** Fee Amount converted to the account currency. Returns null if transaction hasn't been processed yet */
  feeAmountAccountCurrency?: Maybe<Scalars['Float']['output']>;
  fileContent?: Maybe<Scalars['String']['output']>;
  givingAccountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @Auth(read: [Admin]) */
  note?: Maybe<Scalars['String']['output']>;
  /** Processing date. Populated manually after processing has been completed */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: ProviderType;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: GivingAccountWithdrawalStatus;
  /** Total amount in the currency of the given transaction */
  total: Scalars['Float']['output'];
  /** Total amount in account currency. Needed to calculate totals aggregations quickly. Populated manually after processing has been completed */
  totalAccountCurrency?: Maybe<Scalars['Float']['output']>;
  /** not stored in DB, only needed for Union mapping in Nexus */
  type?: Maybe<TransactionType>;
  withdrawalType?: Maybe<Scalars['String']['output']>;
};

export type GivingAccountWithdrawalAvgAggregateOutputType = {
  __typename?: 'GivingAccountWithdrawalAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAccountCurrency?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountWithdrawalAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalCountAggregateOutputType = {
  __typename?: 'GivingAccountWithdrawalCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  applicationFeeAmount: Scalars['Int']['output'];
  author: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  batchFilename: Scalars['Int']['output'];
  coveredFeeDisbursedAt: Scalars['Int']['output'];
  coveredFeeDisbursementInstruction: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  donationDisbursedAt: Scalars['Int']['output'];
  donationDisbursementInstruction: Scalars['Int']['output'];
  feeAmount: Scalars['Int']['output'];
  fileContent: Scalars['Int']['output'];
  givingAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  matchDisbursedAt: Scalars['Int']['output'];
  matchDisbursementInstruction: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  receiptUrl: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalAccountCurrency: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  withdrawalType: Scalars['Int']['output'];
};

export type GivingAccountWithdrawalCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  batchFilename?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  withdrawalType?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalCreateInput = {
  GivingAccount: GivingAccountCreateNestedOneWithoutWithdrawalsInput;
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalCreateManyGivingAccountInput = {
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalCreateManyGivingAccountInputEnvelope = {
  data: GivingAccountWithdrawalCreateManyGivingAccountInput;
};

export type GivingAccountWithdrawalCreateManyInput = {
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountWithdrawalCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountWithdrawalCreateOrConnectWithoutGivingAccountInput = {
  create: GivingAccountWithdrawalCreateWithoutGivingAccountInput;
  where: GivingAccountWithdrawalWhereUniqueInput;
};

export type GivingAccountWithdrawalCreateWithoutGivingAccountInput = {
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalListRelationFilter = {
  every?: InputMaybe<GivingAccountWithdrawalWhereInput>;
  none?: InputMaybe<GivingAccountWithdrawalWhereInput>;
  some?: InputMaybe<GivingAccountWithdrawalWhereInput>;
};

export type GivingAccountWithdrawalMarkAsProcessedInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt: Scalars['String']['input'];
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  totalAccountCurrency: Scalars['Float']['input'];
};

export type GivingAccountWithdrawalMarkAsProcessingInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalMarkAsReadyForProcessingInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalMaxAggregateOutputType = {
  __typename?: 'GivingAccountWithdrawalMaxAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  batchFilename?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  fileContent?: Maybe<Scalars['String']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<ProviderType>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GivingAccountWithdrawalStatus>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAccountCurrency?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<TransactionType>;
  withdrawalType?: Maybe<Scalars['String']['output']>;
};

export type GivingAccountWithdrawalMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  batchFilename?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  withdrawalType?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalMinAggregateOutputType = {
  __typename?: 'GivingAccountWithdrawalMinAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  batchFilename?: Maybe<Scalars['String']['output']>;
  coveredFeeDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  coveredFeeDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  donationDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  donationDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  fileContent?: Maybe<Scalars['String']['output']>;
  givingAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  matchDisbursedAt?: Maybe<Scalars['DateTime']['output']>;
  matchDisbursementInstruction?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<ProviderType>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GivingAccountWithdrawalStatus>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAccountCurrency?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<TransactionType>;
  withdrawalType?: Maybe<Scalars['String']['output']>;
};

export type GivingAccountWithdrawalMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  batchFilename?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  withdrawalType?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalOrderByWithAggregationInput = {
  _avg?: InputMaybe<GivingAccountWithdrawalAvgOrderByAggregateInput>;
  _count?: InputMaybe<GivingAccountWithdrawalCountOrderByAggregateInput>;
  _max?: InputMaybe<GivingAccountWithdrawalMaxOrderByAggregateInput>;
  _min?: InputMaybe<GivingAccountWithdrawalMinOrderByAggregateInput>;
  _sum?: InputMaybe<GivingAccountWithdrawalSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  batchFilename?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  withdrawalType?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalOrderByWithRelationInput = {
  GivingAccount?: InputMaybe<GivingAccountOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  batchFilename?: InputMaybe<SortOrder>;
  coveredFeeDisbursedAt?: InputMaybe<SortOrder>;
  coveredFeeDisbursementInstruction?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  donationDisbursedAt?: InputMaybe<SortOrder>;
  donationDisbursementInstruction?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  fileContent?: InputMaybe<SortOrder>;
  givingAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  matchDisbursedAt?: InputMaybe<SortOrder>;
  matchDisbursementInstruction?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  withdrawalType?: InputMaybe<SortOrder>;
};

export enum GivingAccountWithdrawalScalarFieldEnum {
  Amount = 'amount',
  ApplicationFeeAmount = 'applicationFeeAmount',
  Author = 'author',
  Balance = 'balance',
  BatchFilename = 'batchFilename',
  CoveredFeeDisbursedAt = 'coveredFeeDisbursedAt',
  CoveredFeeDisbursementInstruction = 'coveredFeeDisbursementInstruction',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  Description = 'description',
  DonationDisbursedAt = 'donationDisbursedAt',
  DonationDisbursementInstruction = 'donationDisbursementInstruction',
  FeeAmount = 'feeAmount',
  FileContent = 'fileContent',
  GivingAccountId = 'givingAccountId',
  Id = 'id',
  Identifier = 'identifier',
  MatchDisbursedAt = 'matchDisbursedAt',
  MatchDisbursementInstruction = 'matchDisbursementInstruction',
  Metadata = 'metadata',
  ModifiedAt = 'modifiedAt',
  Note = 'note',
  ProcessedAt = 'processedAt',
  Provider = 'provider',
  ReceiptUrl = 'receiptUrl',
  Status = 'status',
  Total = 'total',
  TotalAccountCurrency = 'totalAccountCurrency',
  Type = 'type',
  WithdrawalType = 'withdrawalType'
}

export type GivingAccountWithdrawalScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  batchFilename?: InputMaybe<StringFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  feeAmount?: InputMaybe<FloatFilter>;
  fileContent?: InputMaybe<StringNullableFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFilter>;
  total?: InputMaybe<FloatFilter>;
  totalAccountCurrency?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
  withdrawalType?: InputMaybe<StringNullableFilter>;
};

export type GivingAccountWithdrawalScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableWithAggregatesFilter>;
  author?: InputMaybe<StringWithAggregatesFilter>;
  balance?: InputMaybe<FloatNullableWithAggregatesFilter>;
  batchFilename?: InputMaybe<StringWithAggregatesFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  feeAmount?: InputMaybe<FloatWithAggregatesFilter>;
  fileContent?: InputMaybe<StringNullableWithAggregatesFilter>;
  givingAccountId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  note?: InputMaybe<StringNullableWithAggregatesFilter>;
  processedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  provider?: InputMaybe<EnumProviderTypeWithAggregatesFilter>;
  receiptUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusWithAggregatesFilter>;
  total?: InputMaybe<FloatWithAggregatesFilter>;
  totalAccountCurrency?: InputMaybe<FloatNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableWithAggregatesFilter>;
  withdrawalType?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum GivingAccountWithdrawalStatus {
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  Pending = 'Pending',
  Processed = 'Processed',
  Processing = 'Processing',
  ReadyForProcessing = 'ReadyForProcessing'
}

export type GivingAccountWithdrawalSumAggregateOutputType = {
  __typename?: 'GivingAccountWithdrawalSumAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAccountCurrency?: Maybe<Scalars['Float']['output']>;
};

export type GivingAccountWithdrawalSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  applicationFeeAmount?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  feeAmount?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalAccountCurrency?: InputMaybe<SortOrder>;
};

export type GivingAccountWithdrawalUncheckedCreateInput = {
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  givingAccountId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalUncheckedCreateNestedManyWithoutGivingAccountInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountWithdrawalCreateManyGivingAccountInputEnvelope>;
};

export type GivingAccountWithdrawalUncheckedCreateWithoutGivingAccountInput = {
  amount: Scalars['Float']['input'];
  applicationFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  author: Scalars['String']['input'];
  balance?: InputMaybe<Scalars['Float']['input']>;
  batchFilename: Scalars['String']['input'];
  coveredFeeDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coveredFeeDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  donationDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  feeAmount: Scalars['Float']['input'];
  fileContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  matchDisbursedAt?: InputMaybe<Scalars['DateTime']['input']>;
  matchDisbursementInstruction?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  provider: ProviderType;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GivingAccountWithdrawalStatus>;
  total: Scalars['Float']['input'];
  totalAccountCurrency?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TransactionType>;
  withdrawalType?: InputMaybe<Scalars['String']['input']>;
};

export type GivingAccountWithdrawalUncheckedUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUncheckedUpdateManyInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  givingAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUncheckedUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountWithdrawalCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountWithdrawalUncheckedUpdateWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUpdateInput = {
  GivingAccount?: InputMaybe<GivingAccountUpdateOneRequiredWithoutWithdrawalsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUpdateManyWithWhereWithoutGivingAccountInput = {
  data: GivingAccountWithdrawalUpdateManyMutationInput;
  where: GivingAccountWithdrawalScalarWhereInput;
};

export type GivingAccountWithdrawalUpdateManyWithoutGivingAccountNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateOrConnectWithoutGivingAccountInput>>>;
  create?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalCreateWithoutGivingAccountInput>>>;
  createMany?: InputMaybe<GivingAccountWithdrawalCreateManyGivingAccountInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpdateWithWhereUniqueWithoutGivingAccountInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpdateManyWithWhereWithoutGivingAccountInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalUpsertWithWhereUniqueWithoutGivingAccountInput>>>;
};

export type GivingAccountWithdrawalUpdateWithWhereUniqueWithoutGivingAccountInput = {
  data: GivingAccountWithdrawalUpdateWithoutGivingAccountInput;
  where: GivingAccountWithdrawalWhereUniqueInput;
};

export type GivingAccountWithdrawalUpdateWithoutGivingAccountInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicationFeeAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  balance?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  batchFilename?: InputMaybe<StringFieldUpdateOperationsInput>;
  coveredFeeDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  coveredFeeDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  donationDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  donationDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  feeAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fileContent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  matchDisbursedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  matchDisbursementInstruction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumProviderTypeFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalAccountCurrency?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumTransactionTypeFieldUpdateOperationsInput>;
  withdrawalType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type GivingAccountWithdrawalUpsertWithWhereUniqueWithoutGivingAccountInput = {
  create: GivingAccountWithdrawalCreateWithoutGivingAccountInput;
  update: GivingAccountWithdrawalUpdateWithoutGivingAccountInput;
  where: GivingAccountWithdrawalWhereUniqueInput;
};

export type GivingAccountWithdrawalWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  batchFilename?: InputMaybe<StringFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  feeAmount?: InputMaybe<FloatFilter>;
  fileContent?: InputMaybe<StringNullableFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFilter>;
  total?: InputMaybe<FloatFilter>;
  totalAccountCurrency?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
  withdrawalType?: InputMaybe<StringNullableFilter>;
};

export type GivingAccountWithdrawalWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  GivingAccount?: InputMaybe<GivingAccountRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  applicationFeeAmount?: InputMaybe<FloatNullableFilter>;
  author?: InputMaybe<StringFilter>;
  balance?: InputMaybe<FloatNullableFilter>;
  batchFilename?: InputMaybe<StringFilter>;
  coveredFeeDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  coveredFeeDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  donationDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  donationDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  feeAmount?: InputMaybe<FloatFilter>;
  fileContent?: InputMaybe<StringNullableFilter>;
  givingAccountId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<StringNullableFilter>;
  matchDisbursedAt?: InputMaybe<DateTimeNullableFilter>;
  matchDisbursementInstruction?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  provider?: InputMaybe<EnumProviderTypeFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumGivingAccountWithdrawalStatusFilter>;
  total?: InputMaybe<FloatFilter>;
  totalAccountCurrency?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumTransactionTypeNullableFilter>;
  withdrawalType?: InputMaybe<StringNullableFilter>;
};

export type GivingGoalConfig = {
  __typename?: 'GivingGoalConfig';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  isEditableByEmployee?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type GivingGoalConfigCreateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEditableByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GivingGoalConfigNullableCompositeFilter = {
  equals?: InputMaybe<GivingGoalConfigObjectEqualityInput>;
  is?: InputMaybe<GivingGoalConfigWhereInput>;
  isNot?: InputMaybe<GivingGoalConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GivingGoalConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<GivingGoalConfigCreateInput>;
};

export type GivingGoalConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<GivingGoalConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<GivingGoalConfigUpsertInput>;
};

export type GivingGoalConfigObjectEqualityInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEditableByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GivingGoalConfigOrderByInput = {
  endDate?: InputMaybe<SortOrder>;
  isEditableByEmployee?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type GivingGoalConfigUpdateInput = {
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isEditableByEmployee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type GivingGoalConfigUpsertInput = {
  set: GivingGoalConfigCreateInput;
  update: GivingGoalConfigUpdateInput;
};

export type GivingGoalConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<GivingGoalConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<GivingGoalConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<GivingGoalConfigWhereInput>>>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  isEditableByEmployee?: InputMaybe<BoolNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
};

export type GooderaBookOpportunityPayload = {
  /** Goodera-supported country in which the event has to be created */
  country?: InputMaybe<GooderaCountry>;
  /** Email of the user booking the event */
  email?: InputMaybe<Scalars['String']['input']>;
  /** End time of the event */
  endingAt: Scalars['DateTime']['input'];
  /** Expected number of volunteers attending the event */
  expectedVolunteerCount: Scalars['Int']['input'];
  extendedLocationObject?: InputMaybe<ExtendedLocationObjectInput>;
  /** Goodera-supported language in which the event has to be created */
  language?: InputMaybe<GooderaLanguage>;
  /** Name of the user booking the event */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start time of the event */
  startingAt: Scalars['DateTime']['input'];
  /** A string from the list of timezones */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum GooderaCountry {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Erg = 'ERG',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Global = 'GLOBAL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum GooderaLanguage {
  Afr = 'AFR',
  Amh = 'AMH',
  Ara = 'ARA',
  Ben = 'BEN',
  Bul = 'BUL',
  Bur = 'BUR',
  Cantonese = 'CANTONESE',
  Chi = 'CHI',
  Cpf = 'CPF',
  Czech = 'CZECH',
  Dut = 'DUT',
  Eng = 'ENG',
  Fil = 'FIL',
  Fre = 'FRE',
  Ger = 'GER',
  Guj = 'GUJ',
  Heb = 'HEB',
  Hin = 'HIN',
  Hun = 'HUN',
  Ind = 'IND',
  Ita = 'ITA',
  Jap = 'JAP',
  Kan = 'KAN',
  Khm = 'KHM',
  Korean = 'KOREAN',
  Mal = 'MAL',
  Mandarin = 'MANDARIN',
  Mar = 'MAR',
  Ori = 'ORI',
  Pan = 'PAN',
  Pol = 'POL',
  Por = 'POR',
  Rom = 'ROM',
  Rus = 'RUS',
  Sign = 'SIGN',
  Sin = 'SIN',
  Spa = 'SPA',
  Tam = 'TAM',
  Tel = 'TEL',
  Tha = 'THA',
  Turkish = 'TURKISH',
  Twn = 'TWN',
  Ukr = 'UKR',
  Urd = 'URD',
  Vie = 'VIE'
}

export type HrisLocation = {
  __typename?: 'HRISLocation';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postal_code: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type HrisLocationCreateInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type HrisLocationNullableCompositeFilter = {
  equals?: InputMaybe<HrisLocationObjectEqualityInput>;
  is?: InputMaybe<HrisLocationWhereInput>;
  isNot?: InputMaybe<HrisLocationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HrisLocationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<HrisLocationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<HrisLocationUpsertInput>;
};

export type HrisLocationObjectEqualityInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type HrisLocationOrderByInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  line1?: InputMaybe<SortOrder>;
  line2?: InputMaybe<SortOrder>;
  postal_code?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type HrisLocationUpdateInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  line1?: InputMaybe<StringFieldUpdateOperationsInput>;
  line2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postal_code?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HrisLocationUpsertInput = {
  set: HrisLocationCreateInput;
  update: HrisLocationUpdateInput;
};

export type HrisLocationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<HrisLocationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<HrisLocationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<HrisLocationWhereInput>>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  line1?: InputMaybe<StringFilter>;
  line2?: InputMaybe<StringNullableFilter>;
  postal_code?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
};

/** Message category, used to group notifications in the UI */
export enum IgnorableNotificationMessageCategory {
  Account = 'Account',
  Approval = 'Approval',
  OrganizerAccount = 'OrganizerAccount',
  Suggested = 'Suggested'
}

/** All the messages that we are allowed to ignore */
export enum IgnorableNotificationMessageIds {
  AccountDeletionRequestForCs = 'accountDeletionRequestForCS',
  ActionReminderTemplate = 'actionReminderTemplate',
  AdminCreatedDeedTemplate = 'adminCreatedDeedTemplate',
  AdminTakeActionTemplate = 'adminTakeActionTemplate',
  ApprovedTemplate = 'approvedTemplate',
  BatchErrorsTemplate = 'batchErrorsTemplate',
  CampaignActionReminderTemplate = 'campaignActionReminderTemplate',
  CancelTemplate = 'cancelTemplate',
  CommunityJoined = 'communityJoined',
  CommunityLeft = 'communityLeft',
  ConfirmEmailTemplate = 'confirmEmailTemplate',
  ConfirmOrganizerEmailTemplate = 'confirmOrganizerEmailTemplate',
  ConfirmTemplate = 'confirmTemplate',
  ConfirmWaitlistTemplate = 'confirmWaitlistTemplate',
  ContactAttendees = 'contactAttendees',
  DeedIsPublishedTemplate = 'deedIsPublishedTemplate',
  DisbursementInstructionGenerationFailure = 'disbursementInstructionGenerationFailure',
  DisbursementInstructionNoWorkFound = 'disbursementInstructionNoWorkFound',
  DisbursementInstructionSuccess = 'disbursementInstructionSuccess',
  DonatedTemplate = 'donatedTemplate',
  DonationCreditInstantWithdrawalForVolunteeringTemplate = 'donationCreditInstantWithdrawalForVolunteeringTemplate',
  DonationCreditReceivedForVolunteeringTemplate = 'donationCreditReceivedForVolunteeringTemplate',
  DonationCreditReminderTemplate = 'donationCreditReminderTemplate',
  DonationManuallyMatchedTemplate = 'donationManuallyMatchedTemplate',
  DonationReceivedNonprofitWithOrganizerNeedDonorFollowUp = 'donationReceivedNonprofitWithOrganizerNeedDonorFollowUp',
  DonationReceivedNonprofitWithOrganizerNoDonorFollowUp = 'donationReceivedNonprofitWithOrganizerNoDonorFollowUp',
  DonationReceivedNonprofitWithoutOrganizerNeedDonorFollowUp = 'donationReceivedNonprofitWithoutOrganizerNeedDonorFollowUp',
  DonationReceivedNonprofitWithoutOrganizerNoDonorFollowUp = 'donationReceivedNonprofitWithoutOrganizerNoDonorFollowUp',
  DueBatchFilesReviewEmailTemplate = 'dueBatchFilesReviewEmailTemplate',
  EarnedBadgesTemplate = 'earnedBadgesTemplate',
  ExternalDonationRequestApprovalTemplate = 'externalDonationRequestApprovalTemplate',
  ExternalDonationRequestRejectionTemplate = 'externalDonationRequestRejectionTemplate',
  ExternalDonationRequestSubmittedTemplate = 'externalDonationRequestSubmittedTemplate',
  InviteNonVolunteeringTemplate = 'inviteNonVolunteeringTemplate',
  InviteNonVolunteeringVirtualTemplate = 'inviteNonVolunteeringVirtualTemplate',
  InviteTemplate = 'inviteTemplate',
  InviteVirtualTemplate = 'inviteVirtualTemplate',
  LateCancelTemplate = 'lateCancelTemplate',
  LogHoursApproval = 'logHoursApproval',
  LogHoursRejection = 'logHoursRejection',
  LogHoursReminderEventTemplate = 'logHoursReminderEventTemplate',
  LogHoursReminderProjectTemplate = 'logHoursReminderProjectTemplate',
  NewOrganizerTemplate = 'newOrganizerTemplate',
  NonAuthenticatedWelcomeTemplate = 'nonAuthenticatedWelcomeTemplate',
  NonVirtualEventStarting = 'nonVirtualEventStarting',
  NonprofitDocumentUploadedInternalTemplate = 'nonprofitDocumentUploadedInternalTemplate',
  NonprofitManualVerificationApprovedTemplate = 'nonprofitManualVerificationApprovedTemplate',
  NonprofitManualVerificationRejectedTemplate = 'nonprofitManualVerificationRejectedTemplate',
  NonprofitNominationAcceptedTemplate = 'nonprofitNominationAcceptedTemplate',
  NonprofitNominationDeclinedTemplate = 'nonprofitNominationDeclinedTemplate',
  NonprofitNominationFilteredOutUserTemplate = 'nonprofitNominationFilteredOutUserTemplate',
  NonprofitNominationNoResponseTemplate = 'nonprofitNominationNoResponseTemplate',
  NonprofitNominationOnboardingUserTemplate = 'nonprofitNominationOnboardingUserTemplate',
  NonprofitNominationOrganizationFoundTemplate = 'nonprofitNominationOrganizationFoundTemplate',
  NonprofitNominationOutreachFinal = 'nonprofitNominationOutreachFinal',
  NonprofitNominationOutreachFinalUser = 'nonprofitNominationOutreachFinalUser',
  NonprofitNominationOutreachInactiveOrgFinal = 'nonprofitNominationOutreachInactiveOrgFinal',
  NonprofitNominationOutreachInactiveOrgInitial = 'nonprofitNominationOutreachInactiveOrgInitial',
  NonprofitNominationOutreachInitial = 'nonprofitNominationOutreachInitial',
  NonprofitNominationOutreachStartedUser = 'nonprofitNominationOutreachStartedUser',
  NonprofitNominationSubmittedInternalTemplate = 'nonprofitNominationSubmittedInternalTemplate',
  NonprofitNominationSubmittedTemplate = 'nonprofitNominationSubmittedTemplate',
  NonprofitPendingApprovalInternal = 'nonprofitPendingApprovalInternal',
  NonprofitVerificationApproved = 'nonprofitVerificationApproved',
  NonprofitVerificationRejected = 'nonprofitVerificationRejected',
  NotifyAdminOnNonprofitInactivation = 'notifyAdminOnNonprofitInactivation',
  NotifyAdminToReviewADeedOnUpdate = 'notifyAdminToReviewADeedOnUpdate',
  NotifyAdminToReviewADeedTemplate = 'notifyAdminToReviewADeedTemplate',
  NotifyAttendeesOfCancellationTemplate = 'notifyAttendeesOfCancellationTemplate',
  NotifyAttendeesOfModificationTemplate = 'notifyAttendeesOfModificationTemplate',
  NotifyCommunityMembersOfDeedTemplate = 'notifyCommunityMembersOfDeedTemplate',
  NotifyDonorOfRecurringDonation = 'notifyDonorOfRecurringDonation',
  NotifyFailedPayrollCompletionTemplate = 'notifyFailedPayrollCompletionTemplate',
  NotifyFailedPayrollDeductionTemplate = 'notifyFailedPayrollDeductionTemplate',
  NotifyFailedRecurringDonation = 'notifyFailedRecurringDonation',
  NotifyOrganizerOfRoleApplicationTemplate = 'notifyOrganizerOfRoleApplicationTemplate',
  OpenSpotOrganizerTemplate = 'openSpotOrganizerTemplate',
  OpenSpotTemplate = 'openSpotTemplate',
  OrganizerCreatedDeedTemplate = 'organizerCreatedDeedTemplate',
  PayrollDeductionTransferOrchestrationReportTemplate = 'payrollDeductionTransferOrchestrationReportTemplate',
  PayrollDonationCompletionTemplate = 'payrollDonationCompletionTemplate',
  PayrollDonationConfirmationTemplate = 'payrollDonationConfirmationTemplate',
  PayrollRunFlatFileAdminNoDeductionsTemplate = 'payrollRunFlatFileAdminNoDeductionsTemplate',
  PayrollRunFlatFileDeductionGenerationTemplate = 'payrollRunFlatFileDeductionGenerationTemplate',
  PayrollRunFlatFileDeductionReconciliationCompletionTemplate = 'payrollRunFlatFileDeductionReconciliationCompletionTemplate',
  PayrollRunFlatFileDeductionReconciliationDelayedTemplate = 'payrollRunFlatFileDeductionReconciliationDelayedTemplate',
  PayrollRunFlatFileDeductionReconciliationFailureTemplate = 'payrollRunFlatFileDeductionReconciliationFailureTemplate',
  PayrollRunFlatFileDeductionReconciliationSuccessTemplate = 'payrollRunFlatFileDeductionReconciliationSuccessTemplate',
  PayrollRunFlatFileDeductionReconciliationUnresolvedTemplate = 'payrollRunFlatFileDeductionReconciliationUnresolvedTemplate',
  PayrollRunFlatFileImportCompletionTemplate = 'payrollRunFlatFileImportCompletionTemplate',
  PayrollRunFlatFileImportFailureTemplate = 'payrollRunFlatFileImportFailureTemplate',
  PayrollRunFlatFileImportHandledFailureTemplate = 'payrollRunFlatFileImportHandledFailureTemplate',
  PayrollRunFlatFileOneTimeDonationTemplate = 'payrollRunFlatFileOneTimeDonationTemplate',
  PayrollRunFlatFileSuccessfulDeductionUploadTemplate = 'payrollRunFlatFileSuccessfulDeductionUploadTemplate',
  PendingApprovalOrganizerTemplate = 'pendingApprovalOrganizerTemplate',
  PendingApprovalUserTemplate = 'pendingApprovalUserTemplate',
  ProjectStartedTemplate = 'projectStartedTemplate',
  ReadyForProcessingNotificationInternal = 'readyForProcessingNotificationInternal',
  ReceivedDonationCredits = 'receivedDonationCredits',
  RemindOrganizerTemplate = 'remindOrganizerTemplate',
  RemindVirtualTemplate = 'remindVirtualTemplate',
  RolloverPayrollDonationConfirmationTemplate = 'rolloverPayrollDonationConfirmationTemplate',
  SendAutoApprovalRoleCancellationTemplate = 'sendAutoApprovalRoleCancellationTemplate',
  SendAutoApprovalRoleConfirmationNotificationTemplate = 'sendAutoApprovalRoleConfirmationNotificationTemplate',
  SendRoleApplicationCancellationTemplate = 'sendRoleApplicationCancellationTemplate',
  SendRoleApplicationThankyouTemplate = 'sendRoleApplicationThankyouTemplate',
  SendRoleFilledNotificationTemplate = 'sendRoleFilledNotificationTemplate',
  SendRoleStatusNotificationTemplate = 'sendRoleStatusNotificationTemplate',
  VirtualEvent24hReminderTemplate = 'virtualEvent24hReminderTemplate',
  VirtualEventStartingTemplate = 'virtualEventStartingTemplate',
  VolunteerRewardApprovedTemplate = 'volunteerRewardApprovedTemplate',
  VolunteerRewardRejectedTemplate = 'volunteerRewardRejectedTemplate',
  VolunteerTimeAddedTemplate = 'volunteerTimeAddedTemplate',
  VolunteerTimeNonprofitApprovalReminderTemplate = 'volunteerTimeNonprofitApprovalReminderTemplate',
  VolunteerTimeOffRequestApprovalTemplate = 'volunteerTimeOffRequestApprovalTemplate',
  VolunteerTimeOffRequestDeniedTemplate = 'volunteerTimeOffRequestDeniedTemplate',
  WelcomeTemplate = 'welcomeTemplate'
}

export type ImpactAiPreset = {
  __typename?: 'ImpactAiPreset';
  /** The actions to perform for this preset */
  actions: Array<ImpactAiPresetAction>;
  /** The color for this preset */
  color: Scalars['String']['output'];
  /** The description of the preset */
  description: Scalars['String']['output'];
  /** Whether the preset is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The icon name for this preset */
  iconName: Scalars['String']['output'];
  /** The id of the preset */
  id: Scalars['String']['output'];
  /** Initial context data for the preset */
  initialContext?: Maybe<Scalars['Json']['output']>;
  /** The organizations this preset is available for */
  organizations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of preset IDs that might be referenced by variables in actions */
  relatedPresets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of privileges required to access this preset */
  requiredPrivileges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The sort order index for this preset */
  sortIndex?: Maybe<Scalars['Int']['output']>;
  /** The title of the preset */
  title: Scalars['String']['output'];
};

export type ImpactAiPresetAction = {
  __typename?: 'ImpactAiPresetAction';
  /** All other action properties as flexible JSON */
  data?: Maybe<Scalars['Json']['output']>;
  /** The type of action */
  type: Scalars['String']['output'];
};

export type ImpactAiPresetActionInput = {
  /** All other action properties as flexible JSON */
  data?: InputMaybe<Scalars['Json']['input']>;
  /** The type of action */
  type: Scalars['String']['input'];
};

export type ImpactAiPresetCreateInput = {
  /** The actions to perform for this preset */
  actions: Array<ImpactAiPresetActionInput>;
  /** The color for this preset */
  color: Scalars['String']['input'];
  /** The description of the preset */
  description: Scalars['String']['input'];
  /** Whether the preset is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The icon name for this preset */
  iconName: Scalars['String']['input'];
  /** Initial context data for the preset */
  initialContext?: InputMaybe<Scalars['Json']['input']>;
  /** The organizations this preset is available for */
  organizations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of preset IDs that might be referenced by variables in actions */
  relatedPresets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of privileges required to access this preset */
  requiredPrivileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The sort order index for this preset */
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The title of the preset */
  title: Scalars['String']['input'];
};

export type ImpactAiPresetUpdateInput = {
  /** The actions to perform for this preset */
  actions?: InputMaybe<Array<ImpactAiPresetActionInput>>;
  /** The color for this preset */
  color?: InputMaybe<Scalars['String']['input']>;
  /** The description of the preset */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the preset is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The icon name for this preset */
  iconName?: InputMaybe<Scalars['String']['input']>;
  /** Initial context data for the preset */
  initialContext?: InputMaybe<Scalars['Json']['input']>;
  /** The organizations this preset is available for */
  organizations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of preset IDs that might be referenced by variables in actions */
  relatedPresets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of privileges required to access this preset */
  requiredPrivileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The sort order index for this preset */
  sortIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The title of the preset */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImpactAiPresets = {
  __typename?: 'ImpactAiPresets';
  /** List of ImpactAiPresets */
  items: Array<ImpactAiPreset>;
  /** Total number of ImpactAiPresets */
  totalCount: Scalars['Int']['output'];
};

export type Incentive = {
  __typename?: 'Incentive';
  amount: Scalars['Int']['output'];
  type: IncentiveType;
  unit: Scalars['String']['output'];
};

export type IncentiveCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<IncentiveObjectEqualityInput>>>;
  every?: InputMaybe<IncentiveWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IncentiveWhereInput>;
  some?: InputMaybe<IncentiveWhereInput>;
};

export type IncentiveCreateInput = {
  amount: Scalars['Int']['input'];
  type: IncentiveType;
  unit: Scalars['String']['input'];
};

export type IncentiveDeleteManyInput = {
  where: IncentiveWhereInput;
};

export type IncentiveInputType = {
  amount: Scalars['Float']['input'];
  type: IncentiveType;
  unit: Scalars['String']['input'];
};

export type IncentiveListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
};

export type IncentiveListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<IncentiveDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<IncentiveCreateInput>>>;
  updateMany?: InputMaybe<IncentiveUpdateManyInput>;
};

export type IncentiveObjectEqualityInput = {
  amount: Scalars['Int']['input'];
  type: IncentiveType;
  unit: Scalars['String']['input'];
};

export type IncentiveOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IncentiveSummary = {
  __typename?: 'IncentiveSummary';
  amount: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
};

export type IncentiveSummaryCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<IncentiveSummaryObjectEqualityInput>>>;
  every?: InputMaybe<IncentiveSummaryWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IncentiveSummaryWhereInput>;
  some?: InputMaybe<IncentiveSummaryWhereInput>;
};

export type IncentiveSummaryCreateInput = {
  amount: Scalars['Int']['input'];
  unit: Scalars['String']['input'];
};

export type IncentiveSummaryDeleteManyInput = {
  where: IncentiveSummaryWhereInput;
};

export type IncentiveSummaryListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<IncentiveSummaryDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<IncentiveSummaryCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<IncentiveSummaryCreateInput>>>;
  updateMany?: InputMaybe<IncentiveSummaryUpdateManyInput>;
};

export type IncentiveSummaryObjectEqualityInput = {
  amount: Scalars['Int']['input'];
  unit: Scalars['String']['input'];
};

export type IncentiveSummaryOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IncentiveSummaryUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  unit?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IncentiveSummaryUpdateManyInput = {
  data: IncentiveSummaryUpdateInput;
  where: IncentiveSummaryWhereInput;
};

export type IncentiveSummaryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<IncentiveSummaryWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<IncentiveSummaryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<IncentiveSummaryWhereInput>>>;
  amount?: InputMaybe<IntFilter>;
  unit?: InputMaybe<StringFilter>;
};

export enum IncentiveType {
  Impact = 'impact',
  Reward = 'reward'
}

export type IncentiveUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumIncentiveTypeFieldUpdateOperationsInput>;
  unit?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IncentiveUpdateManyInput = {
  data: IncentiveUpdateInput;
  where: IncentiveWhereInput;
};

export type IncentiveWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<IncentiveWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<IncentiveWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<IncentiveWhereInput>>>;
  amount?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumIncentiveTypeFilter>;
  unit?: InputMaybe<StringFilter>;
};

export enum InputType {
  Radio = 'Radio'
}

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  company: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  currencyCode: Currency;
  disbursementsDocumentURL: Scalars['String']['output'];
  givingAccount: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  invoiceDocumentURL: Scalars['String']['output'];
  invoiceLines: Array<InvoiceLine>;
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentDocumentURL?: Maybe<Scalars['String']['output']>;
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: InvoiceStatus;
  types: Array<DonationDisbursementType>;
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  amount: Scalars['Float']['output'];
  itemLabel?: Maybe<Scalars['String']['output']>;
  itemRef?: Maybe<Scalars['ID']['output']>;
  itemType: DonationDisbursementType;
};

/** Status of the invoice */
export enum InvoiceStatus {
  Draft = 'DRAFT',
  Paid = 'PAID',
  Sent = 'SENT',
  Voided = 'VOIDED'
}

export type InvoicesPayload = {
  __typename?: 'InvoicesPayload';
  items: Array<Invoice>;
  metadata: PaginationMetadata;
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['Json']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type LimitedLocationObject = {
  __typename?: 'LimitedLocationObject';
  area?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  manualEntry?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type LimitedLocationObjectCreateInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LimitedLocationObjectNullableCompositeFilter = {
  equals?: InputMaybe<LimitedLocationObjectObjectEqualityInput>;
  is?: InputMaybe<LimitedLocationObjectWhereInput>;
  isNot?: InputMaybe<LimitedLocationObjectWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LimitedLocationObjectNullableCreateEnvelopeInput = {
  set?: InputMaybe<LimitedLocationObjectCreateInput>;
};

export type LimitedLocationObjectNullableUpdateEnvelopeInput = {
  set?: InputMaybe<LimitedLocationObjectCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<LimitedLocationObjectUpsertInput>;
};

export type LimitedLocationObjectObjectEqualityInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LimitedLocationObjectOrderByInput = {
  area?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  manualEntry?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LimitedLocationObjectUpdateInput = {
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manualEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LimitedLocationObjectUpsertInput = {
  set: LimitedLocationObjectCreateInput;
  update: LimitedLocationObjectUpdateInput;
};

export type LimitedLocationObjectWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LimitedLocationObjectWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LimitedLocationObjectWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LimitedLocationObjectWhereInput>>>;
  area?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  manualEntry?: InputMaybe<BoolNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
};

/** @Auth(read: [Public]) */
export type Location = {
  __typename?: 'Location';
  code?: Maybe<Scalars['String']['output']>;
  coordinates: Array<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type LocationAvgAggregateOutputType = {
  __typename?: 'LocationAvgAggregateOutputType';
  coordinates?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type LocationAvgOrderByAggregateInput = {
  coordinates?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
};

export type LocationCountAggregateOutputType = {
  __typename?: 'LocationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  coordinates: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  countryCode: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  picture: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  radius: Scalars['Int']['output'];
  region: Scalars['Int']['output'];
  state: Scalars['Int']['output'];
  stateCode: Scalars['Int']['output'];
};

export type LocationCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  coordinates?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LocationCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreateManyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreatecoordinatesInput = {
  set: Scalars['Float']['input'];
};

export type LocationFilter = {
  __typename?: 'LocationFilter';
  isExclude: Scalars['Boolean']['output'];
  list: Array<CountryCode>;
};

export type LocationFilterCreateInput = {
  isExclude: Scalars['Boolean']['input'];
  list?: InputMaybe<Array<InputMaybe<CountryCodeCreateInput>>>;
};

export type LocationFilterNullableCompositeFilter = {
  equals?: InputMaybe<LocationFilterObjectEqualityInput>;
  is?: InputMaybe<LocationFilterWhereInput>;
  isNot?: InputMaybe<LocationFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<LocationFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<LocationFilterUpsertInput>;
};

export type LocationFilterObjectEqualityInput = {
  isExclude: Scalars['Boolean']['input'];
  list?: InputMaybe<Array<InputMaybe<CountryCodeObjectEqualityInput>>>;
};

export type LocationFilterOrderByInput = {
  isExclude?: InputMaybe<SortOrder>;
  list?: InputMaybe<CountryCodeOrderByCompositeAggregateInput>;
};

export type LocationFilterUpdateInput = {
  isExclude?: InputMaybe<BoolFieldUpdateOperationsInput>;
  list?: InputMaybe<Array<InputMaybe<CountryCodeCreateInput>>>;
};

export type LocationFilterUpsertInput = {
  set: LocationFilterCreateInput;
  update: LocationFilterUpdateInput;
};

export type LocationFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LocationFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LocationFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationFilterWhereInput>>>;
  isExclude?: InputMaybe<BoolFilter>;
  list?: InputMaybe<Array<InputMaybe<CountryCodeObjectEqualityInput>>>;
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geo?: InputMaybe<GeoJsonCreateInput>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationMaxAggregateOutputType = {
  __typename?: 'LocationMaxAggregateOutputType';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type LocationMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LocationMinAggregateOutputType = {
  __typename?: 'LocationMinAggregateOutputType';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type LocationMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LocationObject = {
  __typename?: 'LocationObject';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<GeoJson>;
  manualEntry?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type LocationObjectCompositeFilter = {
  equals?: InputMaybe<LocationObjectObjectEqualityInput>;
  is?: InputMaybe<LocationObjectWhereInput>;
  isNot?: InputMaybe<LocationObjectWhereInput>;
};

export type LocationObjectCreateEnvelopeInput = {
  set?: InputMaybe<LocationObjectCreateInput>;
};

export type LocationObjectCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geo?: InputMaybe<GeoJsonCreateInput>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationObjectNullableCompositeFilter = {
  equals?: InputMaybe<LocationObjectObjectEqualityInput>;
  is?: InputMaybe<LocationObjectWhereInput>;
  isNot?: InputMaybe<LocationObjectWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationObjectNullableCreateEnvelopeInput = {
  set?: InputMaybe<LocationObjectCreateInput>;
};

export type LocationObjectNullableUpdateEnvelopeInput = {
  set?: InputMaybe<LocationObjectCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<LocationObjectUpsertInput>;
};

export type LocationObjectObjectEqualityInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geo?: InputMaybe<GeoJsonObjectEqualityInput>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationObjectOrderByInput = {
  address?: InputMaybe<SortOrder>;
  address2?: InputMaybe<SortOrder>;
  area?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  geo?: InputMaybe<GeoJsonOrderByInput>;
  manualEntry?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LocationObjectUpdateEnvelopeInput = {
  set?: InputMaybe<LocationObjectCreateInput>;
  update?: InputMaybe<LocationObjectUpdateInput>;
};

export type LocationObjectUpdateInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geo?: InputMaybe<GeoJsonNullableUpdateEnvelopeInput>;
  manualEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LocationObjectUpsertInput = {
  set: LocationObjectCreateInput;
  update: LocationObjectUpdateInput;
};

export type LocationObjectWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LocationObjectWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LocationObjectWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationObjectWhereInput>>>;
  address?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  area?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  geo?: InputMaybe<GeoJsonNullableCompositeFilter>;
  manualEntry?: InputMaybe<BoolNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
};

export type LocationOrderByWithAggregationInput = {
  _avg?: InputMaybe<LocationAvgOrderByAggregateInput>;
  _count?: InputMaybe<LocationCountOrderByAggregateInput>;
  _max?: InputMaybe<LocationMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocationMinOrderByAggregateInput>;
  _sum?: InputMaybe<LocationSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  coordinates?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export type LocationOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  coordinates?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  picture?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateCode?: InputMaybe<SortOrder>;
};

export enum LocationScalarFieldEnum {
  Code = 'code',
  Coordinates = 'coordinates',
  Country = 'country',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Name = 'name',
  Phone = 'phone',
  Picture = 'picture',
  Public = 'public',
  Radius = 'radius',
  Region = 'region',
  State = 'state',
  StateCode = 'stateCode'
}

export type LocationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<LocationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LocationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationScalarWhereWithAggregatesInput>>>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  coordinates?: InputMaybe<FloatNullableListFilter>;
  country?: InputMaybe<StringNullableWithAggregatesFilter>;
  countryCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  phone?: InputMaybe<BoolNullableWithAggregatesFilter>;
  picture?: InputMaybe<StringNullableWithAggregatesFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  radius?: InputMaybe<FloatNullableWithAggregatesFilter>;
  region?: InputMaybe<StringNullableWithAggregatesFilter>;
  state?: InputMaybe<StringNullableWithAggregatesFilter>;
  stateCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type LocationSumAggregateOutputType = {
  __typename?: 'LocationSumAggregateOutputType';
  coordinates?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type LocationSumOrderByAggregateInput = {
  coordinates?: InputMaybe<SortOrder>;
  radius?: InputMaybe<SortOrder>;
};

export type LocationUncheckedCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationUncheckedUpdateInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LocationUncheckedUpdateManyInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LocationUpdateInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LocationUpdateManyMutationInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  picture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  radius?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LocationUpdatecoordinatesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type LocationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  code?: InputMaybe<StringNullableFilter>;
  coordinates?: InputMaybe<FloatNullableListFilter>;
  country?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<BoolNullableFilter>;
  picture?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  radius?: InputMaybe<FloatNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
};

export type LocationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationWhereInput>>>;
  code?: InputMaybe<StringNullableFilter>;
  coordinates?: InputMaybe<FloatNullableListFilter>;
  country?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<BoolNullableFilter>;
  picture?: InputMaybe<StringNullableFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  radius?: InputMaybe<FloatNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
};

export enum MatchRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

/** matchable rule */
export type MatchableRule = {
  __typename?: 'MatchableRule';
  budget?: Maybe<Scalars['String']['output']>;
  bypassBudgetLimitPerUser?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  matchingPercentage?: Maybe<Scalars['Int']['output']>;
  paymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paymentMethodsExclude?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MergeApiConfig = {
  __typename?: 'MergeApiConfig';
  accountToken?: Maybe<Scalars['String']['output']>;
  excludedEmploymentTypes?: Maybe<Scalars['Json']['output']>;
  hrisSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<PayrollProvider>;
  remoteDataMapping?: Maybe<Scalars['Json']['output']>;
  useEmployeeHomeLocations?: Maybe<Scalars['Json']['output']>;
};

export type MergeApiConfigCreateInput = {
  accountToken?: InputMaybe<Scalars['String']['input']>;
  excludedEmploymentTypes?: InputMaybe<Scalars['Json']['input']>;
  hrisSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<PayrollProvider>;
  remoteDataMapping?: InputMaybe<Scalars['Json']['input']>;
  useEmployeeHomeLocations?: InputMaybe<Scalars['Json']['input']>;
};

export type MergeApiConfigNullableCompositeFilter = {
  equals?: InputMaybe<MergeApiConfigObjectEqualityInput>;
  is?: InputMaybe<MergeApiConfigWhereInput>;
  isNot?: InputMaybe<MergeApiConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MergeApiConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<MergeApiConfigCreateInput>;
};

export type MergeApiConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<MergeApiConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<MergeApiConfigUpsertInput>;
};

export type MergeApiConfigObjectEqualityInput = {
  accountToken?: InputMaybe<Scalars['String']['input']>;
  excludedEmploymentTypes?: InputMaybe<Scalars['Json']['input']>;
  hrisSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<PayrollProvider>;
  remoteDataMapping?: InputMaybe<Scalars['Json']['input']>;
  useEmployeeHomeLocations?: InputMaybe<Scalars['Json']['input']>;
};

export type MergeApiConfigOrderByInput = {
  accountToken?: InputMaybe<SortOrder>;
  excludedEmploymentTypes?: InputMaybe<SortOrder>;
  hrisSyncEnabled?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  remoteDataMapping?: InputMaybe<SortOrder>;
  useEmployeeHomeLocations?: InputMaybe<SortOrder>;
};

export type MergeApiConfigUpdateInput = {
  accountToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  excludedEmploymentTypes?: InputMaybe<Scalars['Json']['input']>;
  hrisSyncEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableEnumPayrollProviderFieldUpdateOperationsInput>;
  remoteDataMapping?: InputMaybe<Scalars['Json']['input']>;
  useEmployeeHomeLocations?: InputMaybe<Scalars['Json']['input']>;
};

export type MergeApiConfigUpsertInput = {
  set: MergeApiConfigCreateInput;
  update: MergeApiConfigUpdateInput;
};

export type MergeApiConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MergeApiConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MergeApiConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MergeApiConfigWhereInput>>>;
  accountToken?: InputMaybe<StringNullableFilter>;
  excludedEmploymentTypes?: InputMaybe<JsonNullableFilter>;
  hrisSyncEnabled?: InputMaybe<BoolNullableFilter>;
  provider?: InputMaybe<EnumPayrollProviderNullableFilter>;
  remoteDataMapping?: InputMaybe<JsonNullableFilter>;
  useEmployeeHomeLocations?: InputMaybe<JsonNullableFilter>;
};

export type Metadata = {
  __typename?: 'Metadata';
  autoApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  autoLogged?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalNonprofit?: Maybe<Scalars['Json']['output']>;
  externalVolunteerTimeSubmissionType?: Maybe<Scalars['String']['output']>;
  externalVolunteerTimeType?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  importId?: Maybe<Scalars['Int']['output']>;
};

export type MetadataCreateInput = {
  autoApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  autoLogged?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofit?: InputMaybe<Scalars['Json']['input']>;
  externalVolunteerTimeSubmissionType?: InputMaybe<Scalars['String']['input']>;
  externalVolunteerTimeType?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  importId?: InputMaybe<Scalars['Int']['input']>;
};

export type MetadataNullableCompositeFilter = {
  equals?: InputMaybe<MetadataObjectEqualityInput>;
  is?: InputMaybe<MetadataWhereInput>;
  isNot?: InputMaybe<MetadataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetadataNullableCreateEnvelopeInput = {
  set?: InputMaybe<MetadataCreateInput>;
};

export type MetadataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<MetadataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<MetadataUpsertInput>;
};

export type MetadataObjectEqualityInput = {
  autoApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  autoLogged?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofit?: InputMaybe<Scalars['Json']['input']>;
  externalVolunteerTimeSubmissionType?: InputMaybe<Scalars['String']['input']>;
  externalVolunteerTimeType?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  importId?: InputMaybe<Scalars['Int']['input']>;
};

export type MetadataOrderByInput = {
  autoApprovedAt?: InputMaybe<SortOrder>;
  autoLogged?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  externalNonprofit?: InputMaybe<SortOrder>;
  externalVolunteerTimeSubmissionType?: InputMaybe<SortOrder>;
  externalVolunteerTimeType?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  importId?: InputMaybe<SortOrder>;
};

export type MetadataUpdateInput = {
  autoApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  autoLogged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofit?: InputMaybe<Scalars['Json']['input']>;
  externalVolunteerTimeSubmissionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalVolunteerTimeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  from?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  importId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MetadataUpsertInput = {
  set: MetadataCreateInput;
  update: MetadataUpdateInput;
};

export type MetadataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MetadataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MetadataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MetadataWhereInput>>>;
  autoApprovedAt?: InputMaybe<DateTimeNullableFilter>;
  autoLogged?: InputMaybe<BoolNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  externalNonprofit?: InputMaybe<JsonNullableFilter>;
  externalVolunteerTimeSubmissionType?: InputMaybe<StringNullableFilter>;
  externalVolunteerTimeType?: InputMaybe<StringNullableFilter>;
  from?: InputMaybe<StringNullableFilter>;
  importId?: InputMaybe<IntNullableFilter>;
};

export type MsTeams = {
  __typename?: 'MsTeams';
  tenantIds: Array<Scalars['String']['output']>;
};

export type MsTeamsCreateInput = {
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MsTeamsCreatetenantIdsInput = {
  set: Scalars['String']['input'];
};

export type MsTeamsNullableCompositeFilter = {
  equals?: InputMaybe<MsTeamsObjectEqualityInput>;
  is?: InputMaybe<MsTeamsWhereInput>;
  isNot?: InputMaybe<MsTeamsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MsTeamsNullableCreateEnvelopeInput = {
  set?: InputMaybe<MsTeamsCreateInput>;
};

export type MsTeamsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<MsTeamsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<MsTeamsUpsertInput>;
};

export type MsTeamsObjectEqualityInput = {
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MsTeamsOrderByInput = {
  tenantIds?: InputMaybe<SortOrder>;
};

export type MsTeamsUpdateInput = {
  tenantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MsTeamsUpdatetenantIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MsTeamsUpsertInput = {
  set: MsTeamsCreateInput;
  update: MsTeamsUpdateInput;
};

export type MsTeamsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MsTeamsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MsTeamsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MsTeamsWhereInput>>>;
  tenantIds?: InputMaybe<StringNullableListFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a chapter request (super admin only) */
  acceptChapterRequest?: Maybe<AcceptChapterRequestResponse>;
  /** Add users to a community */
  addCommunityUsers?: Maybe<Scalars['Boolean']['output']>;
  approveVolunteerTime?: Maybe<VolunteerTime>;
  /** Block an organizer user within the requester's current organization */
  blockOrganizerUserInOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel a payroll deduction */
  cancelDeduction?: Maybe<Scalars['Boolean']['output']>;
  cancelDonationSchedule?: Maybe<DonationSchedule>;
  cancelPayrollDonationFlatFile?: Maybe<Donation>;
  confirmVolunteerTime?: Maybe<Scalars['String']['output']>;
  /** Create an action from an action template */
  createActionFromTemplate?: Maybe<Action>;
  /** Create a new chapter request */
  createChapterRequest: ChapterRequest;
  /** Create a community */
  createCommunity?: Maybe<Community>;
  createEmployeeAffiliation?: Maybe<Affiliation>;
  createGivingAccount?: Maybe<GivingAccount>;
  createGivingAccountFunding?: Maybe<GivingAccountFunding>;
  /** Create a new ImpactAiPreset (admin only) */
  createImpactAiPreset?: Maybe<ImpactAiPreset>;
  createInvoiceForCorporateGiving?: Maybe<Invoice>;
  createInvoiceForPayroll?: Maybe<Invoice>;
  createNonprofitNomination?: Maybe<NonprofitNomination>;
  createVolunteerTime?: Maybe<VolunteerTime>;
  createVolunteerTimes?: Maybe<Array<Maybe<CreateVolunteerTimesResponseItem>>>;
  /** Delete communities (only in testing environment) */
  deleteCommunities?: Maybe<Scalars['Boolean']['output']>;
  deleteEmployeeAffiliation?: Maybe<Affiliation>;
  /** Delete an ImpactAiPreset (admin only) */
  deleteImpactAiPreset?: Maybe<Scalars['Boolean']['output']>;
  deletePayrollFlatFileSftpConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteVolunteerTime?: Maybe<VolunteerTime>;
  /** Delete `VolunteerTimeOff` */
  deleteVolunteerTimeOff?: Maybe<Scalars['Boolean']['output']>;
  /** Post a new activity to a community feed */
  feedAddActivity?: Maybe<Scalars['String']['output']>;
  /** Remove an activity from a community feed */
  feedDeleteActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a reaction from a community feed */
  feedDeleteReaction?: Maybe<Scalars['Boolean']['output']>;
  /** Handle nonprofit address change request and resolve the Zendesk ticket */
  handleNonprofitAddressChange?: Maybe<Scalars['Boolean']['output']>;
  /** Approve nonprofit name change request and resolve the Zendesk ticket */
  handleNonprofitNameChange?: Maybe<Scalars['Boolean']['output']>;
  /** Approve verification request and resolve the Zendesk ticket */
  handleVerificationRequest?: Maybe<Scalars['Boolean']['output']>;
  /** LLM based content generation for the ImpactAi bot */
  impactAiGeneration?: Maybe<Scalars['Json']['output']>;
  /** Import an external opportunity */
  importOpportunity?: Maybe<Deed>;
  /** Join a community */
  joinCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** Leave a community */
  leaveCommunity?: Maybe<Scalars['Boolean']['output']>;
  markGivingAccountWithdrawalAsPending?: Maybe<GivingAccountWithdrawal>;
  markGivingAccountWithdrawalAsProcessed?: Maybe<GivingAccountWithdrawal>;
  markGivingAccountWithdrawalAsProcessing?: Maybe<GivingAccountWithdrawal>;
  markGivingAccountWithdrawalAsReadyForProcessing?: Maybe<GivingAccountWithdrawal>;
  markInvoiceAsPaid?: Maybe<Invoice>;
  markInvoiceAsSent?: Maybe<Invoice>;
  markInvoiceAsVoided?: Maybe<Invoice>;
  /** Migrate ERGs to Communities */
  migrateERGsToCommunities: CommunitiesMigrationResult;
  /** Add a new Donation Credit Seed Receipt to a organization */
  mutationCreateDonationCreditSeedReceipt: Receipt;
  /** Retrigger award of badges */
  mutationRetriggerBadgeAwarding?: Maybe<Scalars['Boolean']['output']>;
  /** Create or Update an Action */
  mutationUpsertAction?: Maybe<Action>;
  /** Create or Update an Activity */
  mutationUpsertActionActivity?: Maybe<Activity>;
  /** Create or Update an ActionTemplate */
  mutationUpsertActionTemplate?: Maybe<ActionTemplate>;
  outreachNonprofitNomination?: Maybe<NonprofitNomination>;
  /** Upload a government information letter while onboarding */
  persistGovernmentInformationLetter?: Maybe<Scalars['Boolean']['output']>;
  processDonationReceipt?: Maybe<DonationReceipt>;
  recreateDonationForTheNextPayrollRun?: Maybe<Scalars['Boolean']['output']>;
  recreateDonationForTheNextPayrollRunFlatFile?: Maybe<Scalars['Boolean']['output']>;
  /** Reject a chapter request (admin only) */
  rejectChapterRequest?: Maybe<Scalars['Boolean']['output']>;
  rejectVolunteerTime?: Maybe<VolunteerTime>;
  /** Remove users from a community */
  removeCommunityUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Get access to a nonprofit in a blocked state and notify the nonprofit admin */
  requestNonprofitAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Request nonprofit address change */
  requestNonprofitAddressChange?: Maybe<Scalars['Boolean']['output']>;
  /** Reqeust nonprofit name change */
  requestNonprofitNameChange?: Maybe<Scalars['Boolean']['output']>;
  /** Request verification */
  requestVerification?: Maybe<Scalars['Boolean']['output']>;
  /** Revoke (soft delete) a chapter request */
  revokeChapterRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Proxy calls to Segment */
  sendSegmentEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Add a campaignId to an array of actions */
  setCampaignActions?: Maybe<Scalars['Boolean']['output']>;
  /** Set pledge for the current year */
  setCurrentPledge?: Maybe<Pledge>;
  /** Set rules for external match requests */
  setExternalMatchRequestRules?: Maybe<Array<ExternalMatchRequestRule>>;
  /** Enable or disable a certain notification category */
  setOrganizationNotificationCategorySetting?: Maybe<NotificationSettings>;
  /** Enable or disable a certain notification message */
  setOrganizationNotificationMessageSetting?: Maybe<NotificationSettings>;
  setPayrollFlatFileSftpConfig?: Maybe<SftpConfigWithoutSecret>;
  /** Switch organizer user organization based on role grants */
  switchOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Unblock an organizer user within the requester's current organizationmutationVerifyOrganizerUserWithPayPal.test.ts */
  unblockOrganizerUserInOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing chapter request */
  updateChapterRequest?: Maybe<ChapterRequest>;
  /** Update a community */
  updateCommunity?: Maybe<Community>;
  /** Updates a recurring donation */
  updateDonationSchedule?: Maybe<DonationSchedule>;
  updateEmployeeAffiliation?: Maybe<Affiliation>;
  updateGivingAccount?: Maybe<GivingAccount>;
  /** Update an existing ImpactAiPreset (admin only) */
  updateImpactAiPreset?: Maybe<ImpactAiPreset>;
  /** Update a user's membership role in a community */
  updateMembership?: Maybe<Scalars['Boolean']['output']>;
  updateNonprofitNomination?: Maybe<NonprofitNomination>;
  /** Updates multiple existing volunteer rewards */
  updateVolunteerRewards?: Maybe<Array<Maybe<VolunteerReward>>>;
  updateVolunteerTime?: Maybe<VolunteerTime>;
  /** Update `VolunteerTimeOff` */
  updateVolunteerTimeOff: VolunteerTimeOff;
  /** Updates multiple existing volunteer times */
  updateVolunteerTimes?: Maybe<Array<Maybe<VolunteerTime>>>;
  /** Create or Update a Challenge */
  upsertChallenge?: Maybe<Challenge>;
  /** Verify an organizer user as an owner of the current organization based on Deed admin's authority */
  verifyOrganizerUserByDeed?: Maybe<Scalars['Boolean']['output']>;
  /** Verify an organizer user as an owner of his current organization based on PayPal account access */
  verifyOrganizerUserWithPayPal?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptChapterRequestArgs = {
  hash: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateChapterRequestInput>;
};


export type MutationAddCommunityUsersArgs = {
  communityId: Scalars['ID']['input'];
  role?: InputMaybe<CommunityUserRole>;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationApproveVolunteerTimeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBlockOrganizerUserInOrganizationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationCancelDeductionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelDonationScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPayrollDonationFlatFileArgs = {
  donationId: Scalars['ID']['input'];
  newStatus: NewDonationStatus;
};


export type MutationConfirmVolunteerTimeArgs = {
  deedId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateActionFromTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationCreateChapterRequestArgs = {
  input: CreateChapterRequestInput;
};


export type MutationCreateCommunityArgs = {
  data: CommunityCreateInputType;
};


export type MutationCreateEmployeeAffiliationArgs = {
  data: EmployeeAffiliationCreateInputType;
};


export type MutationCreateGivingAccountArgs = {
  currencyCode: Currency;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: ProviderType;
};


export type MutationCreateGivingAccountFundingArgs = {
  data: GivingAccountFundingCreateInputType;
};


export type MutationCreateImpactAiPresetArgs = {
  data: ImpactAiPresetCreateInput;
};


export type MutationCreateInvoiceForCorporateGivingArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo: Scalars['DateTime']['input'];
  donationDisbursementType: DonationDisbursementCorporateGivingType;
  givingAccountId?: InputMaybe<Scalars['ID']['input']>;
  paymentDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInvoiceForPayrollArgs = {
  paymentDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollRunIds: Array<Scalars['ID']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNonprofitNominationArgs = {
  data: NonprofitNominationCreateInputType;
};


export type MutationCreateVolunteerTimeArgs = {
  data: VolunteerTimeCreateInputType;
};


export type MutationCreateVolunteerTimesArgs = {
  data: Array<InputMaybe<VolunteerTimeCreateInputType>>;
};


export type MutationDeleteCommunitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmployeeAffiliationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteImpactAiPresetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVolunteerTimeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVolunteerTimeOffArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFeedAddActivityArgs = {
  activityString: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationFeedDeleteActivityArgs = {
  activityId: Scalars['ID']['input'];
  communityId: Scalars['ID']['input'];
};


export type MutationFeedDeleteReactionArgs = {
  communityId: Scalars['ID']['input'];
  reactionId: Scalars['ID']['input'];
};


export type MutationHandleNonprofitAddressChangeArgs = {
  approve: Scalars['Boolean']['input'];
  nonprofitId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationHandleNonprofitNameChangeArgs = {
  newName: Scalars['String']['input'];
  nonprofitId: Scalars['ID']['input'];
  ticketId: Scalars['Int']['input'];
};


export type MutationHandleVerificationRequestArgs = {
  nonprofitId: Scalars['ID']['input'];
  ticketId: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationImpactAiGenerationArgs = {
  generationId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['Json']['input']>;
  variables: Scalars['Json']['input'];
};


export type MutationImportOpportunityArgs = {
  gooderaBookOpportunityPayload?: InputMaybe<GooderaBookOpportunityPayload>;
  provider: OpportunityProvider;
  providerId: Scalars['String']['input'];
};


export type MutationJoinCommunityArgs = {
  id: Scalars['ID']['input'];
  role?: InputMaybe<CommunityUserRole>;
};


export type MutationLeaveCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkGivingAccountWithdrawalAsPendingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkGivingAccountWithdrawalAsProcessedArgs = {
  data: GivingAccountWithdrawalMarkAsProcessedInputType;
  id: Scalars['ID']['input'];
};


export type MutationMarkGivingAccountWithdrawalAsProcessingArgs = {
  data?: InputMaybe<GivingAccountWithdrawalMarkAsProcessingInputType>;
  id: Scalars['ID']['input'];
};


export type MutationMarkGivingAccountWithdrawalAsReadyForProcessingArgs = {
  data?: InputMaybe<GivingAccountWithdrawalMarkAsReadyForProcessingInputType>;
  id: Scalars['ID']['input'];
};


export type MutationMarkInvoiceAsPaidArgs = {
  invoiceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paymentDocumentURL: Scalars['String']['input'];
  processedAt: Scalars['String']['input'];
};


export type MutationMarkInvoiceAsSentArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationMarkInvoiceAsVoidedArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type MutationMutationCreateDonationCreditSeedReceiptArgs = {
  createUsers: Scalars['Boolean']['input'];
  donationCreditRuleId: Scalars['String']['input'];
  importedUrl: Scalars['String']['input'];
  note: Scalars['String']['input'];
  notifyUser: Scalars['Boolean']['input'];
};


export type MutationMutationRetriggerBadgeAwardingArgs = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: BadgeEventType;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationMutationUpsertActionArgs = {
  actionData: ActionUpsertInputType;
};


export type MutationMutationUpsertActionActivityArgs = {
  actionId: Scalars['ID']['input'];
  activityId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ActivityStatus>;
};


export type MutationMutationUpsertActionTemplateArgs = {
  data: ActionTemplateUpsertInputType;
};


export type MutationOutreachNonprofitNominationArgs = {
  emailId: OutreachEmailId;
  id: Scalars['ID']['input'];
  templateLocaleCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPersistGovernmentInformationLetterArgs = {
  governmentInformationLetterUri: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  letterOfAssociationUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessDonationReceiptArgs = {
  receiptUrl: Scalars['String']['input'];
};


export type MutationRecreateDonationForTheNextPayrollRunArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecreateDonationForTheNextPayrollRunFlatFileArgs = {
  donationId: Scalars['ID']['input'];
  markAsResolved?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCancel: Scalars['Boolean']['input'];
};


export type MutationRejectChapterRequestArgs = {
  hash: Scalars['String']['input'];
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectVolunteerTimeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCommunityUsersArgs = {
  communityId: Scalars['ID']['input'];
  isExcludingMembers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationRequestNonprofitAccessArgs = {
  nonprofitId: Scalars['String']['input'];
};


export type MutationRequestNonprofitAddressChangeArgs = {
  newAddress: LocationInput;
  reason: Scalars['String']['input'];
};


export type MutationRequestNonprofitNameChangeArgs = {
  newName: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRequestVerificationArgs = {
  role: Scalars['String']['input'];
  supportingDocuments: Array<Scalars['String']['input']>;
};


export type MutationRevokeChapterRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendSegmentEventArgs = {
  event: Scalars['String']['input'];
};


export type MutationSetCampaignActionsArgs = {
  actionIds: Array<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
};


export type MutationSetCurrentPledgeArgs = {
  donations?: InputMaybe<PledgeDonationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  volunteering?: InputMaybe<PledgeVolunteeringInput>;
};


export type MutationSetExternalMatchRequestRulesArgs = {
  rules: Array<ExternalMatchRequestRuleInput>;
};


export type MutationSetOrganizationNotificationCategorySettingArgs = {
  categoryId: IgnorableNotificationMessageCategory;
  channel: NotificationChannelType;
  muted: Scalars['Boolean']['input'];
};


export type MutationSetOrganizationNotificationMessageSettingArgs = {
  channel: NotificationChannelType;
  messageId: IgnorableNotificationMessageIds;
  muted: Scalars['Boolean']['input'];
};


export type MutationSetPayrollFlatFileSftpConfigArgs = {
  data: SftpConfigSetInput;
};


export type MutationSwitchOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationUnblockOrganizerUserInOrganizationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateChapterRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChapterRequestInput;
};


export type MutationUpdateCommunityArgs = {
  data: CommunityUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDonationScheduleArgs = {
  data: DonationScheduleUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEmployeeAffiliationArgs = {
  data: EmployeeAffiliationUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateGivingAccountArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateImpactAiPresetArgs = {
  data: ImpactAiPresetUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateMembershipArgs = {
  communityId: Scalars['ID']['input'];
  newRole: CommunityUserRole;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateNonprofitNominationArgs = {
  data: NonprofitNominationUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVolunteerRewardsArgs = {
  data: VolunteerRewardInputType;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateVolunteerTimeArgs = {
  data: VolunteerTimeUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVolunteerTimeOffArgs = {
  data: VolunteerTimeOffUpdateInputType;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVolunteerTimesArgs = {
  data: VolunteerTimesUpdateInputType;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpsertChallengeArgs = {
  data: ChallengeUpsertInputType;
};


export type MutationVerifyOrganizerUserByDeedArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationVerifyOrganizerUserWithPayPalArgs = {
  code: Scalars['String']['input'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type NestedEnumActionVisibilityStatusFilter = {
  equals?: InputMaybe<ActionVisibilityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
  not?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
};

export type NestedEnumActionVisibilityStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  _min?: InputMaybe<NestedEnumActionVisibilityStatusFilter>;
  equals?: InputMaybe<ActionVisibilityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
  not?: InputMaybe<NestedEnumActionVisibilityStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActionVisibilityStatus>>>;
};

export type NestedEnumActivityStatusFilter = {
  equals?: InputMaybe<ActivityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
  not?: InputMaybe<NestedEnumActivityStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
};

export type NestedEnumActivityStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActivityStatusFilter>;
  _min?: InputMaybe<NestedEnumActivityStatusFilter>;
  equals?: InputMaybe<ActivityStatus>;
  in?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
  not?: InputMaybe<NestedEnumActivityStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ActivityStatus>>>;
};

export type NestedEnumAdapterProviderNullableFilter = {
  equals?: InputMaybe<AdapterProvider>;
  in?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
};

export type NestedEnumAdapterProviderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  _min?: InputMaybe<NestedEnumAdapterProviderNullableFilter>;
  equals?: InputMaybe<AdapterProvider>;
  in?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAdapterProviderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AdapterProvider>>>;
};

export type NestedEnumAffiliationBoardPositionNullableFilter = {
  equals?: InputMaybe<AffiliationBoardPosition>;
  in?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
};

export type NestedEnumAffiliationBoardPositionNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  _min?: InputMaybe<NestedEnumAffiliationBoardPositionNullableFilter>;
  equals?: InputMaybe<AffiliationBoardPosition>;
  in?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationBoardPositionNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationBoardPosition>>>;
};

export type NestedEnumAffiliationTypeNullableFilter = {
  equals?: InputMaybe<AffiliationType>;
  in?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
};

export type NestedEnumAffiliationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumAffiliationTypeNullableFilter>;
  equals?: InputMaybe<AffiliationType>;
  in?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumAffiliationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<AffiliationType>>>;
};

export type NestedEnumBadgeCategoryFilter = {
  equals?: InputMaybe<BadgeCategory>;
  in?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
  not?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
};

export type NestedEnumBadgeCategoryWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  _min?: InputMaybe<NestedEnumBadgeCategoryFilter>;
  equals?: InputMaybe<BadgeCategory>;
  in?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
  not?: InputMaybe<NestedEnumBadgeCategoryWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCategory>>>;
};

export type NestedEnumBadgeCriteriaEntityTypeNullableFilter = {
  equals?: InputMaybe<BadgeCriteriaEntityType>;
  in?: InputMaybe<Array<InputMaybe<BadgeCriteriaEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumBadgeCriteriaEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCriteriaEntityType>>>;
};

export type NestedEnumBadgeCriteriaUnitFilter = {
  equals?: InputMaybe<BadgeCriteriaUnit>;
  in?: InputMaybe<Array<InputMaybe<BadgeCriteriaUnit>>>;
  not?: InputMaybe<NestedEnumBadgeCriteriaUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeCriteriaUnit>>>;
};

export type NestedEnumBadgeStatusFilter = {
  equals?: InputMaybe<BadgeStatus>;
  in?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
  not?: InputMaybe<NestedEnumBadgeStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
};

export type NestedEnumBadgeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeStatusFilter>;
  _min?: InputMaybe<NestedEnumBadgeStatusFilter>;
  equals?: InputMaybe<BadgeStatus>;
  in?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
  not?: InputMaybe<NestedEnumBadgeStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeStatus>>>;
};

export type NestedEnumBadgeVisibilityFilter = {
  equals?: InputMaybe<BadgeVisibility>;
  in?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
  not?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
};

export type NestedEnumBadgeVisibilityWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  _min?: InputMaybe<NestedEnumBadgeVisibilityFilter>;
  equals?: InputMaybe<BadgeVisibility>;
  in?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
  not?: InputMaybe<NestedEnumBadgeVisibilityWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BadgeVisibility>>>;
};

export type NestedEnumBaseCurrenciesFilter = {
  equals?: InputMaybe<BaseCurrencies>;
  in?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
  not?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
};

export type NestedEnumBaseCurrenciesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  _min?: InputMaybe<NestedEnumBaseCurrenciesFilter>;
  equals?: InputMaybe<BaseCurrencies>;
  in?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
  not?: InputMaybe<NestedEnumBaseCurrenciesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BaseCurrencies>>>;
};

export type NestedEnumBudgetAllocationTypeFilter = {
  equals?: InputMaybe<BudgetAllocationType>;
  in?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
  not?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
};

export type NestedEnumBudgetAllocationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  _min?: InputMaybe<NestedEnumBudgetAllocationTypeFilter>;
  equals?: InputMaybe<BudgetAllocationType>;
  in?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
  not?: InputMaybe<NestedEnumBudgetAllocationTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<BudgetAllocationType>>>;
};

export type NestedEnumCauseTypeFilter = {
  equals?: InputMaybe<CauseType>;
  in?: InputMaybe<Array<InputMaybe<CauseType>>>;
  not?: InputMaybe<NestedEnumCauseTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CauseType>>>;
};

export type NestedEnumCauseTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCauseTypeFilter>;
  _min?: InputMaybe<NestedEnumCauseTypeFilter>;
  equals?: InputMaybe<CauseType>;
  in?: InputMaybe<Array<InputMaybe<CauseType>>>;
  not?: InputMaybe<NestedEnumCauseTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CauseType>>>;
};

export type NestedEnumChallengeStatusFilter = {
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
  not?: InputMaybe<NestedEnumChallengeStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
};

export type NestedEnumChallengeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumChallengeStatusFilter>;
  _min?: InputMaybe<NestedEnumChallengeStatusFilter>;
  equals?: InputMaybe<ChallengeStatus>;
  in?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
  not?: InputMaybe<NestedEnumChallengeStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
};

export type NestedEnumCommunityEntityTypeNullableFilter = {
  equals?: InputMaybe<CommunityEntityType>;
  in?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
};

export type NestedEnumCommunityEntityTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCommunityEntityTypeNullableFilter>;
  equals?: InputMaybe<CommunityEntityType>;
  in?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumCommunityEntityTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityEntityType>>>;
};

export type NestedEnumCommunityUserRoleFilter = {
  equals?: InputMaybe<CommunityUserRole>;
  in?: InputMaybe<Array<InputMaybe<CommunityUserRole>>>;
  not?: InputMaybe<NestedEnumCommunityUserRoleFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CommunityUserRole>>>;
};

export type NestedEnumContributionUnitFilter = {
  equals?: InputMaybe<ContributionUnit>;
  in?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
  not?: InputMaybe<NestedEnumContributionUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
};

export type NestedEnumContributionUnitWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumContributionUnitFilter>;
  _min?: InputMaybe<NestedEnumContributionUnitFilter>;
  equals?: InputMaybe<ContributionUnit>;
  in?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
  not?: InputMaybe<NestedEnumContributionUnitWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ContributionUnit>>>;
};

export type NestedEnumCorporateProgramStatusFilter = {
  equals?: InputMaybe<CorporateProgramStatus>;
  in?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
  not?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
};

export type NestedEnumCorporateProgramStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  _min?: InputMaybe<NestedEnumCorporateProgramStatusFilter>;
  equals?: InputMaybe<CorporateProgramStatus>;
  in?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
  not?: InputMaybe<NestedEnumCorporateProgramStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CorporateProgramStatus>>>;
};

export type NestedEnumCurrencyFilter = {
  equals?: InputMaybe<Currency>;
  in?: InputMaybe<Array<InputMaybe<Currency>>>;
  not?: InputMaybe<NestedEnumCurrencyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Currency>>>;
};

export type NestedEnumCurrencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCurrencyFilter>;
  _min?: InputMaybe<NestedEnumCurrencyFilter>;
  equals?: InputMaybe<Currency>;
  in?: InputMaybe<Array<InputMaybe<Currency>>>;
  not?: InputMaybe<NestedEnumCurrencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Currency>>>;
};

export type NestedEnumDeductionTransferModeNullableFilter = {
  equals?: InputMaybe<DeductionTransferMode>;
  in?: InputMaybe<Array<InputMaybe<DeductionTransferMode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeductionTransferModeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeductionTransferMode>>>;
};

export type NestedEnumDeedStatusNullableFilter = {
  equals?: InputMaybe<DeedStatus>;
  in?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
};

export type NestedEnumDeedStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDeedStatusNullableFilter>;
  equals?: InputMaybe<DeedStatus>;
  in?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDeedStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedStatus>>>;
};

export type NestedEnumDeedTypeFilter = {
  equals?: InputMaybe<DeedType>;
  in?: InputMaybe<Array<InputMaybe<DeedType>>>;
  not?: InputMaybe<NestedEnumDeedTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedType>>>;
};

export type NestedEnumDeedTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDeedTypeFilter>;
  _min?: InputMaybe<NestedEnumDeedTypeFilter>;
  equals?: InputMaybe<DeedType>;
  in?: InputMaybe<Array<InputMaybe<DeedType>>>;
  not?: InputMaybe<NestedEnumDeedTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DeedType>>>;
};

export type NestedEnumDisbursementFeeTypeFilter = {
  equals?: InputMaybe<DisbursementFeeType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
  not?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
};

export type NestedEnumDisbursementFeeTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  _min?: InputMaybe<NestedEnumDisbursementFeeTypeFilter>;
  equals?: InputMaybe<DisbursementFeeType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
  not?: InputMaybe<NestedEnumDisbursementFeeTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementFeeType>>>;
};

export type NestedEnumDisbursementInformationFileContentTypeFilter = {
  equals?: InputMaybe<DisbursementInformationFileContentType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
  not?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
};

export type NestedEnumDisbursementInformationFileContentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  _min?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeFilter>;
  equals?: InputMaybe<DisbursementInformationFileContentType>;
  in?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
  not?: InputMaybe<NestedEnumDisbursementInformationFileContentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementInformationFileContentType>>>;
};

export type NestedEnumDisbursementStatusFilter = {
  equals?: InputMaybe<DisbursementStatus>;
  in?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
  not?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
};

export type NestedEnumDisbursementStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  _min?: InputMaybe<NestedEnumDisbursementStatusFilter>;
  equals?: InputMaybe<DisbursementStatus>;
  in?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
  not?: InputMaybe<NestedEnumDisbursementStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisbursementStatus>>>;
};

export type NestedEnumDisclaimerContentTypeFilter = {
  equals?: InputMaybe<DisclaimerContentType>;
  in?: InputMaybe<Array<InputMaybe<DisclaimerContentType>>>;
  not?: InputMaybe<NestedEnumDisclaimerContentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DisclaimerContentType>>>;
};

export type NestedEnumDonationExecutionFailureErrorCodeFilter = {
  equals?: InputMaybe<DonationExecutionFailureErrorCode>;
  in?: InputMaybe<Array<InputMaybe<DonationExecutionFailureErrorCode>>>;
  not?: InputMaybe<NestedEnumDonationExecutionFailureErrorCodeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationExecutionFailureErrorCode>>>;
};

export type NestedEnumDonationFrequencyFilter = {
  equals?: InputMaybe<DonationFrequency>;
  in?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
  not?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
};

export type NestedEnumDonationFrequencyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  _min?: InputMaybe<NestedEnumDonationFrequencyFilter>;
  equals?: InputMaybe<DonationFrequency>;
  in?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
  not?: InputMaybe<NestedEnumDonationFrequencyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationFrequency>>>;
};

export type NestedEnumDonationPayrollPaymentOptionStatusNullableFilter = {
  equals?: InputMaybe<DonationPayrollPaymentOptionStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationPayrollPaymentOptionStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPayrollPaymentOptionStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPayrollPaymentOptionStatus>>>;
};

export type NestedEnumDonationPrivacyFilter = {
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  not?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type NestedEnumDonationPrivacyNullableFilter = {
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type NestedEnumDonationPrivacyNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationPrivacyNullableFilter>;
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationPrivacyNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type NestedEnumDonationPrivacyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  _min?: InputMaybe<NestedEnumDonationPrivacyFilter>;
  equals?: InputMaybe<DonationPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
  not?: InputMaybe<NestedEnumDonationPrivacyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationPrivacy>>>;
};

export type NestedEnumDonationProviderFilter = {
  equals?: InputMaybe<DonationProvider>;
  in?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
  not?: InputMaybe<NestedEnumDonationProviderFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
};

export type NestedEnumDonationProviderWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationProviderFilter>;
  _min?: InputMaybe<NestedEnumDonationProviderFilter>;
  equals?: InputMaybe<DonationProvider>;
  in?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
  not?: InputMaybe<NestedEnumDonationProviderWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationProvider>>>;
};

export type NestedEnumDonationScheduleStatusNullableFilter = {
  equals?: InputMaybe<DonationScheduleStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
};

export type NestedEnumDonationScheduleStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationScheduleStatusNullableFilter>;
  equals?: InputMaybe<DonationScheduleStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationScheduleStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationScheduleStatus>>>;
};

export type NestedEnumDonationStatusFilter = {
  equals?: InputMaybe<DonationStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
  not?: InputMaybe<NestedEnumDonationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
};

export type NestedEnumDonationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDonationStatusFilter>;
  _min?: InputMaybe<NestedEnumDonationStatusFilter>;
  equals?: InputMaybe<DonationStatus>;
  in?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
  not?: InputMaybe<NestedEnumDonationStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationStatus>>>;
};

export type NestedEnumDonationSubtypeNullableFilter = {
  equals?: InputMaybe<DonationSubtype>;
  in?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
};

export type NestedEnumDonationSubtypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationSubtypeNullableFilter>;
  equals?: InputMaybe<DonationSubtype>;
  in?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationSubtypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationSubtype>>>;
};

export type NestedEnumDonationTypeNullableFilter = {
  equals?: InputMaybe<DonationType>;
  in?: InputMaybe<Array<InputMaybe<DonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationType>>>;
};

export type NestedEnumDonationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDonationTypeNullableFilter>;
  equals?: InputMaybe<DonationType>;
  in?: InputMaybe<Array<InputMaybe<DonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonationType>>>;
};

export type NestedEnumDonorPrivacyNullableFilter = {
  equals?: InputMaybe<DonorPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
};

export type NestedEnumDonorPrivacyNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  _min?: InputMaybe<NestedEnumDonorPrivacyNullableFilter>;
  equals?: InputMaybe<DonorPrivacy>;
  in?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumDonorPrivacyNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DonorPrivacy>>>;
};

export type NestedEnumDurationUnitFilter = {
  equals?: InputMaybe<DurationUnit>;
  in?: InputMaybe<Array<InputMaybe<DurationUnit>>>;
  not?: InputMaybe<NestedEnumDurationUnitFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DurationUnit>>>;
};

export type NestedEnumEligibilityFormStatusFilter = {
  equals?: InputMaybe<EligibilityFormStatus>;
  in?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
  not?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
};

export type NestedEnumEligibilityFormStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  _min?: InputMaybe<NestedEnumEligibilityFormStatusFilter>;
  equals?: InputMaybe<EligibilityFormStatus>;
  in?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
  not?: InputMaybe<NestedEnumEligibilityFormStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EligibilityFormStatus>>>;
};

export type NestedEnumEncryptionTypeNullableFilter = {
  equals?: InputMaybe<EncryptionType>;
  in?: InputMaybe<Array<InputMaybe<EncryptionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumEncryptionTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EncryptionType>>>;
};

export type NestedEnumEngagementTypeFilter = {
  equals?: InputMaybe<EngagementType>;
  in?: InputMaybe<Array<InputMaybe<EngagementType>>>;
  not?: InputMaybe<NestedEnumEngagementTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EngagementType>>>;
};

export type NestedEnumEngagementTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEngagementTypeFilter>;
  _min?: InputMaybe<NestedEnumEngagementTypeFilter>;
  equals?: InputMaybe<EngagementType>;
  in?: InputMaybe<Array<InputMaybe<EngagementType>>>;
  not?: InputMaybe<NestedEnumEngagementTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<EngagementType>>>;
};

export type NestedEnumExternalDashboardScopeNullableFilter = {
  equals?: InputMaybe<ExternalDashboardScope>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
};

export type NestedEnumExternalDashboardScopeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  _min?: InputMaybe<NestedEnumExternalDashboardScopeNullableFilter>;
  equals?: InputMaybe<ExternalDashboardScope>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDashboardScopeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardScope>>>;
};

export type NestedEnumExternalDashboardTypeFilter = {
  equals?: InputMaybe<ExternalDashboardType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
  not?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
};

export type NestedEnumExternalDashboardTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  _min?: InputMaybe<NestedEnumExternalDashboardTypeFilter>;
  equals?: InputMaybe<ExternalDashboardType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
  not?: InputMaybe<NestedEnumExternalDashboardTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDashboardType>>>;
};

export type NestedEnumExternalDonationTypeNullableFilter = {
  equals?: InputMaybe<ExternalDonationType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
};

export type NestedEnumExternalDonationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumExternalDonationTypeNullableFilter>;
  equals?: InputMaybe<ExternalDonationType>;
  in?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumExternalDonationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalDonationType>>>;
};

export type NestedEnumExternalReportTypeFilter = {
  equals?: InputMaybe<ExternalReportType>;
  in?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
  not?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
};

export type NestedEnumExternalReportTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  _min?: InputMaybe<NestedEnumExternalReportTypeFilter>;
  equals?: InputMaybe<ExternalReportType>;
  in?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
  not?: InputMaybe<NestedEnumExternalReportTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ExternalReportType>>>;
};

export type NestedEnumFailedPayrollRunDeductionStatusOverridesNullableFilter = {
  equals?: InputMaybe<FailedPayrollRunDeductionStatusOverrides>;
  in?: InputMaybe<Array<InputMaybe<FailedPayrollRunDeductionStatusOverrides>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFailedPayrollRunDeductionStatusOverridesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FailedPayrollRunDeductionStatusOverrides>>>;
};

export type NestedEnumFeeCoveredByNullableFilter = {
  equals?: InputMaybe<FeeCoveredBy>;
  in?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
};

export type NestedEnumFeeCoveredByNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  _min?: InputMaybe<NestedEnumFeeCoveredByNullableFilter>;
  equals?: InputMaybe<FeeCoveredBy>;
  in?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFeeCoveredByNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FeeCoveredBy>>>;
};

export type NestedEnumFlatFileTemplateNullableFilter = {
  equals?: InputMaybe<FlatFileTemplate>;
  in?: InputMaybe<Array<InputMaybe<FlatFileTemplate>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumFlatFileTemplateNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<FlatFileTemplate>>>;
};

export type NestedEnumGivingAccountWithdrawalStatusFilter = {
  equals?: InputMaybe<GivingAccountWithdrawalStatus>;
  in?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
  not?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
};

export type NestedEnumGivingAccountWithdrawalStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  _min?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusFilter>;
  equals?: InputMaybe<GivingAccountWithdrawalStatus>;
  in?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
  not?: InputMaybe<NestedEnumGivingAccountWithdrawalStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<GivingAccountWithdrawalStatus>>>;
};

export type NestedEnumIncentiveTypeFilter = {
  equals?: InputMaybe<IncentiveType>;
  in?: InputMaybe<Array<InputMaybe<IncentiveType>>>;
  not?: InputMaybe<NestedEnumIncentiveTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<IncentiveType>>>;
};

export type NestedEnumInputTypeFilter = {
  equals?: InputMaybe<InputType>;
  in?: InputMaybe<Array<InputMaybe<InputType>>>;
  not?: InputMaybe<NestedEnumInputTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<InputType>>>;
};

export type NestedEnumMatchRequestStatusNullableFilter = {
  equals?: InputMaybe<MatchRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
};

export type NestedEnumMatchRequestStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumMatchRequestStatusNullableFilter>;
  equals?: InputMaybe<MatchRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumMatchRequestStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MatchRequestStatus>>>;
};

export type NestedEnumNonprofitAddressChangeRequestStatusFilter = {
  equals?: InputMaybe<NonprofitAddressChangeRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestStatus>>>;
  not?: InputMaybe<NestedEnumNonprofitAddressChangeRequestStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestStatus>>>;
};

export type NestedEnumNonprofitEntityTypeFilter = {
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NestedEnumNonprofitEntityTypeNullableFilter = {
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NestedEnumNonprofitEntityTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumNonprofitEntityTypeNullableFilter>;
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NestedEnumNonprofitEntityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  _min?: InputMaybe<NestedEnumNonprofitEntityTypeFilter>;
  equals?: InputMaybe<NonprofitEntityType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  not?: InputMaybe<NestedEnumNonprofitEntityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NestedEnumNonprofitIdentifierTypeNullableFilter = {
  equals?: InputMaybe<NonprofitIdentifierType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitIdentifierType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumNonprofitIdentifierTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitIdentifierType>>>;
};

export type NestedEnumNonprofitNominationStatusTypeFilter = {
  equals?: InputMaybe<NonprofitNominationStatusType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
  not?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
};

export type NestedEnumNonprofitNominationStatusTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  _min?: InputMaybe<NestedEnumNonprofitNominationStatusTypeFilter>;
  equals?: InputMaybe<NonprofitNominationStatusType>;
  in?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
  not?: InputMaybe<NestedEnumNonprofitNominationStatusTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<NonprofitNominationStatusType>>>;
};

export type NestedEnumOpportunityProviderNullableFilter = {
  equals?: InputMaybe<OpportunityProvider>;
  in?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
};

export type NestedEnumOpportunityProviderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  _min?: InputMaybe<NestedEnumOpportunityProviderNullableFilter>;
  equals?: InputMaybe<OpportunityProvider>;
  in?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumOpportunityProviderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityProvider>>>;
};

export type NestedEnumOpportunityTypeFilter = {
  equals?: InputMaybe<OpportunityType>;
  in?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
  not?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
};

export type NestedEnumOpportunityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  _min?: InputMaybe<NestedEnumOpportunityTypeFilter>;
  equals?: InputMaybe<OpportunityType>;
  in?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
  not?: InputMaybe<NestedEnumOpportunityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OpportunityType>>>;
};

export type NestedEnumOrganizationTypeFilter = {
  equals?: InputMaybe<OrganizationType>;
  in?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  not?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type NestedEnumOrganizationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  _min?: InputMaybe<NestedEnumOrganizationTypeFilter>;
  equals?: InputMaybe<OrganizationType>;
  in?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  not?: InputMaybe<NestedEnumOrganizationTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type NestedEnumPartnerStatusFilter = {
  equals?: InputMaybe<PartnerStatus>;
  in?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
  not?: InputMaybe<NestedEnumPartnerStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
};

export type NestedEnumPartnerStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPartnerStatusFilter>;
  _min?: InputMaybe<NestedEnumPartnerStatusFilter>;
  equals?: InputMaybe<PartnerStatus>;
  in?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
  not?: InputMaybe<NestedEnumPartnerStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PartnerStatus>>>;
};

export type NestedEnumPayGroupStatusFilter = {
  equals?: InputMaybe<PayGroupStatus>;
  in?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
  not?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
};

export type NestedEnumPayGroupStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  _min?: InputMaybe<NestedEnumPayGroupStatusFilter>;
  equals?: InputMaybe<PayGroupStatus>;
  in?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
  not?: InputMaybe<NestedEnumPayGroupStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayGroupStatus>>>;
};

export type NestedEnumPayPalVerificationStatusNullableFilter = {
  equals?: InputMaybe<PayPalVerificationStatus>;
  in?: InputMaybe<Array<InputMaybe<PayPalVerificationStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayPalVerificationStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayPalVerificationStatus>>>;
};

export type NestedEnumPaymentMethodTypeNullableFilter = {
  equals?: InputMaybe<PaymentMethodType>;
  in?: InputMaybe<Array<InputMaybe<PaymentMethodType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPaymentMethodTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentMethodType>>>;
};

export type NestedEnumPayrollFlatFileFileExtensionNullableFilter = {
  equals?: InputMaybe<PayrollFlatFileFileExtension>;
  in?: InputMaybe<Array<InputMaybe<PayrollFlatFileFileExtension>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollFlatFileFileExtensionNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollFlatFileFileExtension>>>;
};

export type NestedEnumPayrollProcessorTypeFilter = {
  equals?: InputMaybe<PayrollProcessorType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProcessorType>>>;
  not?: InputMaybe<NestedEnumPayrollProcessorTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProcessorType>>>;
};

export type NestedEnumPayrollProviderFilter = {
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  not?: InputMaybe<NestedEnumPayrollProviderFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type NestedEnumPayrollProviderNullableFilter = {
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollProviderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type NestedEnumPayrollProviderTypeFilter = {
  equals?: InputMaybe<PayrollProviderType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
  not?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
};

export type NestedEnumPayrollProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollProviderTypeFilter>;
  equals?: InputMaybe<PayrollProviderType>;
  in?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
  not?: InputMaybe<NestedEnumPayrollProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProviderType>>>;
};

export type NestedEnumPayrollProviderWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollProviderFilter>;
  _min?: InputMaybe<NestedEnumPayrollProviderFilter>;
  equals?: InputMaybe<PayrollProvider>;
  in?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
  not?: InputMaybe<NestedEnumPayrollProviderWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollProvider>>>;
};

export type NestedEnumPayrollRunDeductionFrequencyNullableFilter = {
  equals?: InputMaybe<PayrollRunDeductionFrequency>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionFrequency>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionFrequencyNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionFrequency>>>;
};

export type NestedEnumPayrollRunDeductionStatusFilter = {
  equals?: InputMaybe<PayrollRunDeductionStatus>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
};

export type NestedEnumPayrollRunDeductionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunDeductionStatusFilter>;
  equals?: InputMaybe<PayrollRunDeductionStatus>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
  not?: InputMaybe<NestedEnumPayrollRunDeductionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunDeductionStatus>>>;
};

export type NestedEnumPayrollRunFlatFileStateTypeFilter = {
  equals?: InputMaybe<PayrollRunFlatFileStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
};

export type NestedEnumPayrollRunFlatFileStateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeFilter>;
  equals?: InputMaybe<PayrollRunFlatFileStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunFlatFileStateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileStateType>>>;
};

export type NestedEnumPayrollRunStateTypeFilter = {
  equals?: InputMaybe<PayrollRunStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
};

export type NestedEnumPayrollRunStateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunStateTypeFilter>;
  equals?: InputMaybe<PayrollRunStateType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
  not?: InputMaybe<NestedEnumPayrollRunStateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunStateType>>>;
};

export type NestedEnumPayrollRunTypeNullableFilter = {
  equals?: InputMaybe<PayrollRunType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
};

export type NestedEnumPayrollRunTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPayrollRunTypeNullableFilter>;
  equals?: InputMaybe<PayrollRunType>;
  in?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumPayrollRunTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PayrollRunType>>>;
};

export type NestedEnumProviderPaymentReconciliationStatusFilter = {
  equals?: InputMaybe<ProviderPaymentReconciliationStatus>;
  in?: InputMaybe<Array<InputMaybe<ProviderPaymentReconciliationStatus>>>;
  not?: InputMaybe<NestedEnumProviderPaymentReconciliationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderPaymentReconciliationStatus>>>;
};

export type NestedEnumProviderTypeFilter = {
  equals?: InputMaybe<ProviderType>;
  in?: InputMaybe<Array<InputMaybe<ProviderType>>>;
  not?: InputMaybe<NestedEnumProviderTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderType>>>;
};

export type NestedEnumProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumProviderTypeFilter>;
  equals?: InputMaybe<ProviderType>;
  in?: InputMaybe<Array<InputMaybe<ProviderType>>>;
  not?: InputMaybe<NestedEnumProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProviderType>>>;
};

export type NestedEnumReceiptTypeFilter = {
  equals?: InputMaybe<ReceiptType>;
  in?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
  not?: InputMaybe<NestedEnumReceiptTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
};

export type NestedEnumReceiptTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumReceiptTypeFilter>;
  _min?: InputMaybe<NestedEnumReceiptTypeFilter>;
  equals?: InputMaybe<ReceiptType>;
  in?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
  not?: InputMaybe<NestedEnumReceiptTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ReceiptType>>>;
};

export type NestedEnumRecipientTypesForUserNotificationFilter = {
  equals?: InputMaybe<RecipientTypesForUserNotification>;
  in?: InputMaybe<Array<InputMaybe<RecipientTypesForUserNotification>>>;
  not?: InputMaybe<NestedEnumRecipientTypesForUserNotificationFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RecipientTypesForUserNotification>>>;
};

export type NestedEnumRoleCodeNullableFilter = {
  equals?: InputMaybe<RoleCode>;
  in?: InputMaybe<Array<InputMaybe<RoleCode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleCode>>>;
};

export type NestedEnumRoleCodeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  _min?: InputMaybe<NestedEnumRoleCodeNullableFilter>;
  equals?: InputMaybe<RoleCode>;
  in?: InputMaybe<Array<InputMaybe<RoleCode>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleCodeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleCode>>>;
};

export type NestedEnumRoleGrantSourceNullableFilter = {
  equals?: InputMaybe<RoleGrantSource>;
  in?: InputMaybe<Array<InputMaybe<RoleGrantSource>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumRoleGrantSourceNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<RoleGrantSource>>>;
};

export type NestedEnumSftpModeFilter = {
  equals?: InputMaybe<SftpMode>;
  in?: InputMaybe<Array<InputMaybe<SftpMode>>>;
  not?: InputMaybe<NestedEnumSftpModeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<SftpMode>>>;
};

export type NestedEnumSupportedEntitiesForUserNotificationFilter = {
  equals?: InputMaybe<SupportedEntitiesForUserNotification>;
  in?: InputMaybe<Array<InputMaybe<SupportedEntitiesForUserNotification>>>;
  not?: InputMaybe<NestedEnumSupportedEntitiesForUserNotificationFilter>;
  notIn?: InputMaybe<Array<InputMaybe<SupportedEntitiesForUserNotification>>>;
};

export type NestedEnumTimeOffStatusNullableFilter = {
  equals?: InputMaybe<TimeOffStatus>;
  in?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
};

export type NestedEnumTimeOffStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumTimeOffStatusNullableFilter>;
  equals?: InputMaybe<TimeOffStatus>;
  in?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTimeOffStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TimeOffStatus>>>;
};

export type NestedEnumTransactionTypeNullableFilter = {
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};

export type NestedEnumTransactionTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumTransactionTypeNullableFilter>;
  equals?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumTransactionTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};

export type NestedEnumUnresolvedPayrollRunDeductionStatusOverridesNullableFilter = {
  equals?: InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  in?: InputMaybe<Array<InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUnresolvedPayrollRunDeductionStatusOverridesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>>>;
};

export type NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter = {
  equals?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  in?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
};

export type NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  _min?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  equals?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  in?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumUserFacingVolunteerRewardCreationFailureReasonNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserFacingVolunteerRewardCreationFailureReason>>>;
};

export type NestedEnumUserNotificationStatusFilter = {
  equals?: InputMaybe<UserNotificationStatus>;
  in?: InputMaybe<Array<InputMaybe<UserNotificationStatus>>>;
  not?: InputMaybe<NestedEnumUserNotificationStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserNotificationStatus>>>;
};

export type NestedEnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<InputMaybe<UserType>>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserType>>>;
};

export type NestedEnumUserTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserTypeFilter>;
  _min?: InputMaybe<NestedEnumUserTypeFilter>;
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<InputMaybe<UserType>>>;
  not?: InputMaybe<NestedEnumUserTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<UserType>>>;
};

export type NestedEnumVerificationStatusesFilter = {
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  not?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type NestedEnumVerificationStatusesNullableFilter = {
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type NestedEnumVerificationStatusesNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  _min?: InputMaybe<NestedEnumVerificationStatusesNullableFilter>;
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedEnumVerificationStatusesNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type NestedEnumVerificationStatusesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  _min?: InputMaybe<NestedEnumVerificationStatusesFilter>;
  equals?: InputMaybe<VerificationStatuses>;
  in?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  not?: InputMaybe<NestedEnumVerificationStatusesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type NestedEnumVolunteerRewardApprovalStatusFilter = {
  equals?: InputMaybe<VolunteerRewardApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
  not?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
};

export type NestedEnumVolunteerRewardApprovalStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  _min?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusFilter>;
  equals?: InputMaybe<VolunteerRewardApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
  not?: InputMaybe<NestedEnumVolunteerRewardApprovalStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerRewardApprovalStatus>>>;
};

export type NestedEnumVolunteerTimeApprovalFilter = {
  equals?: InputMaybe<VolunteerTimeApproval>;
  in?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
  not?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
};

export type NestedEnumVolunteerTimeApprovalWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  _min?: InputMaybe<NestedEnumVolunteerTimeApprovalFilter>;
  equals?: InputMaybe<VolunteerTimeApproval>;
  in?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
  not?: InputMaybe<NestedEnumVolunteerTimeApprovalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<VolunteerTimeApproval>>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type NestedJsonFilter = {
  equals?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type NestedJsonNullableFilter = {
  equals?: InputMaybe<Scalars['Json']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum NewDonationStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed'
}

export type Nonprofit = {
  __typename?: 'Nonprofit';
  _count: NonprofitCountOutputType;
  affiliations: Array<NonprofitAffiliation>;
  aliases: Array<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  content: NonprofitContent;
  deedAccountId?: Maybe<Scalars['String']['output']>;
  donationProviders: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifiers: Array<NonprofitIdentifierEntry>;
  legalName: Scalars['String']['output'];
  location: LocationObject;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nonprofitDataValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['output'];
  nonprofitProviders: Array<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  partnerNonprofitId: Scalars['String']['output'];
  people: Array<Person>;
  pictures: NonprofitPictures;
  providerId: Scalars['String']['output'];
  registeredAt: Scalars['DateTime']['output'];
  sdgs: Array<Scalars['String']['output']>;
  taxonomy?: Maybe<Taxonomy>;
  updatedAt: Scalars['DateTime']['output'];
  verificationSources: Array<Scalars['String']['output']>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['output'];
  website: Scalars['String']['output'];
};

/** What level of access do you have for this nonprofit? */
export enum NonprofitAccess {
  Granted = 'granted',
  None = 'none',
  Requested = 'requested'
}

export type NonprofitAddressChangeRequest = {
  __typename?: 'NonprofitAddressChangeRequest';
  handledAt?: Maybe<Scalars['DateTime']['output']>;
  newAddress: LocationObject;
  nonprofit: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  status: NonprofitAddressChangeRequestStatus;
};

export type NonprofitAddressChangeRequestCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestObjectEqualityInput>>>;
  every?: InputMaybe<NonprofitAddressChangeRequestWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NonprofitAddressChangeRequestWhereInput>;
  some?: InputMaybe<NonprofitAddressChangeRequestWhereInput>;
};

export type NonprofitAddressChangeRequestCreateInput = {
  handledAt?: InputMaybe<Scalars['DateTime']['input']>;
  newAddress: LocationObjectCreateInput;
  nonprofit: Scalars['String']['input'];
  requestedAt: Scalars['DateTime']['input'];
  status: NonprofitAddressChangeRequestStatus;
};

export type NonprofitAddressChangeRequestDeleteManyInput = {
  where: NonprofitAddressChangeRequestWhereInput;
};

export type NonprofitAddressChangeRequestListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<NonprofitAddressChangeRequestDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestCreateInput>>>;
  updateMany?: InputMaybe<NonprofitAddressChangeRequestUpdateManyInput>;
};

export type NonprofitAddressChangeRequestObjectEqualityInput = {
  handledAt?: InputMaybe<Scalars['DateTime']['input']>;
  newAddress: LocationObjectObjectEqualityInput;
  nonprofit: Scalars['String']['input'];
  requestedAt: Scalars['DateTime']['input'];
  status: NonprofitAddressChangeRequestStatus;
};

export type NonprofitAddressChangeRequestOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum NonprofitAddressChangeRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type NonprofitAddressChangeRequestUpdateInput = {
  handledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  newAddress?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitAddressChangeRequestStatusFieldUpdateOperationsInput>;
};

export type NonprofitAddressChangeRequestUpdateManyInput = {
  data: NonprofitAddressChangeRequestUpdateInput;
  where: NonprofitAddressChangeRequestWhereInput;
};

export type NonprofitAddressChangeRequestWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestWhereInput>>>;
  handledAt?: InputMaybe<DateTimeNullableFilter>;
  newAddress?: InputMaybe<LocationObjectCompositeFilter>;
  nonprofit?: InputMaybe<StringFilter>;
  requestedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumNonprofitAddressChangeRequestStatusFilter>;
};

export type NonprofitAffiliation = {
  __typename?: 'NonprofitAffiliation';
  company: Scalars['String']['output'];
  status: PartnerStatus;
};

export type NonprofitAffiliationCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<NonprofitAffiliationObjectEqualityInput>>>;
  every?: InputMaybe<NonprofitAffiliationWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NonprofitAffiliationWhereInput>;
  some?: InputMaybe<NonprofitAffiliationWhereInput>;
};

export type NonprofitAffiliationCreateInput = {
  company: Scalars['String']['input'];
  status: PartnerStatus;
};

export type NonprofitAffiliationDeleteManyInput = {
  where: NonprofitAffiliationWhereInput;
};

export type NonprofitAffiliationListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
};

export type NonprofitAffiliationListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<NonprofitAffiliationDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  updateMany?: InputMaybe<NonprofitAffiliationUpdateManyInput>;
};

export type NonprofitAffiliationObjectEqualityInput = {
  company: Scalars['String']['input'];
  status: PartnerStatus;
};

export type NonprofitAffiliationOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NonprofitAffiliationUpdateInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type NonprofitAffiliationUpdateManyInput = {
  data: NonprofitAffiliationUpdateInput;
  where: NonprofitAffiliationWhereInput;
};

export type NonprofitAffiliationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitAffiliationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitAffiliationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitAffiliationWhereInput>>>;
  company?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumPartnerStatusFilter>;
};

export type NonprofitAvailability = {
  __typename?: 'NonprofitAvailability';
  /** A nonprofit with such id exists */
  exists: Scalars['Boolean']['output'];
  /** This nonprofit exists, but falls under company content filters */
  filteredOut: Scalars['Boolean']['output'];
  /** There are multiple nonprofits sharing this id */
  multiple: Scalars['Boolean']['output'];
  /** Nonprofit id of a clear winner */
  nonprofitId?: Maybe<Scalars['String']['output']>;
  /** This nonprofit exists, but is volunteering only */
  volunteeringOnly: Scalars['Boolean']['output'];
};

export type NonprofitContent = {
  __typename?: 'NonprofitContent';
  brief: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type NonprofitContentCompositeFilter = {
  equals?: InputMaybe<NonprofitContentObjectEqualityInput>;
  is?: InputMaybe<NonprofitContentWhereInput>;
  isNot?: InputMaybe<NonprofitContentWhereInput>;
};

export type NonprofitContentCreateEnvelopeInput = {
  set?: InputMaybe<NonprofitContentCreateInput>;
};

export type NonprofitContentCreateInput = {
  brief: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type NonprofitContentObjectEqualityInput = {
  brief: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type NonprofitContentOrderByInput = {
  brief?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
};

export type NonprofitContentUpdateEnvelopeInput = {
  set?: InputMaybe<NonprofitContentCreateInput>;
  update?: InputMaybe<NonprofitContentUpdateInput>;
};

export type NonprofitContentUpdateInput = {
  brief?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitContentWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitContentWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitContentWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitContentWhereInput>>>;
  brief?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
};

export type NonprofitCountAggregateOutputType = {
  __typename?: 'NonprofitCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  aliases: Scalars['Int']['output'];
  categories: Scalars['Int']['output'];
  deedAccountId: Scalars['Int']['output'];
  donationProviders: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  externalIds: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legalName: Scalars['Int']['output'];
  mainPicture: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nonprofitDataValidatedAt: Scalars['Int']['output'];
  nonprofitEntityType: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  nonprofitProviders: Scalars['Int']['output'];
  parent: Scalars['Int']['output'];
  partnerNonprofitId: Scalars['Int']['output'];
  providerId: Scalars['Int']['output'];
  registeredAt: Scalars['Int']['output'];
  sdgs: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  verificationSources: Scalars['Int']['output'];
  verificationStatus: Scalars['Int']['output'];
  verificationStatusSyncedAt: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type NonprofitCountOrderByAggregateInput = {
  aliases?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  deedAccountId?: InputMaybe<SortOrder>;
  donationProviders?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDataValidatedAt?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitProviders?: InputMaybe<SortOrder>;
  parent?: InputMaybe<SortOrder>;
  partnerNonprofitId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationSources?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitCountOutputType = {
  __typename?: 'NonprofitCountOutputType';
  Children: Scalars['Int']['output'];
};

export type NonprofitCreateInput = {
  Children?: InputMaybe<NonprofitCreateNestedManyWithoutParentInput>;
  DeedNonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitInput>;
  Parent?: InputMaybe<NonprofitCreateNestedOneWithoutChildrenInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateManyDeedNonprofitInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateManyDeedNonprofitInputEnvelope = {
  data: NonprofitCreateManyDeedNonprofitInput;
};

export type NonprofitCreateManyInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  deedAccountId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateManyParentInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  deedAccountId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateManyParentInputEnvelope = {
  data: NonprofitCreateManyParentInput;
};

export type NonprofitCreateNestedManyWithoutDeedNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutDeedNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutDeedNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyDeedNonprofitInputEnvelope>;
};

export type NonprofitCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutParentInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyParentInputEnvelope>;
};

export type NonprofitCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<NonprofitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NonprofitCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<NonprofitCreateWithoutChildrenInput>;
};

export type NonprofitCreateOrConnectWithoutChildrenInput = {
  create: NonprofitCreateWithoutChildrenInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitCreateOrConnectWithoutDeedNonprofitInput = {
  create: NonprofitCreateWithoutDeedNonprofitInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitCreateOrConnectWithoutParentInput = {
  create: NonprofitCreateWithoutParentInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitCreateWithoutChildrenInput = {
  DeedNonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitInput>;
  Parent?: InputMaybe<NonprofitCreateNestedOneWithoutChildrenInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateWithoutDeedNonprofitInput = {
  Children?: InputMaybe<NonprofitCreateNestedManyWithoutParentInput>;
  Parent?: InputMaybe<NonprofitCreateNestedOneWithoutChildrenInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreateWithoutParentInput = {
  Children?: InputMaybe<NonprofitCreateNestedManyWithoutParentInput>;
  DeedNonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitCreatealiasesInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreatedonationProvidersInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreateexternalIdsInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreatenonprofitProvidersInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreatesdgsInput = {
  set: Scalars['String']['input'];
};

export type NonprofitCreateverificationSourcesInput = {
  set: Scalars['String']['input'];
};

export type NonprofitData = {
  __typename?: 'NonprofitData';
  SDGs: Array<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  locationObject?: Maybe<LocationObject>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pictures: Array<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type NonprofitDataCreateInput = {
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brief?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LocationObjectCreateInput>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type NonprofitDataCreateSdGsInput = {
  set: Scalars['String']['input'];
};

export type NonprofitDataCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type NonprofitDataCreatepicturesInput = {
  set: Scalars['String']['input'];
};

export type NonprofitDataNullableCompositeFilter = {
  equals?: InputMaybe<NonprofitDataObjectEqualityInput>;
  is?: InputMaybe<NonprofitDataWhereInput>;
  isNot?: InputMaybe<NonprofitDataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NonprofitDataNullableCreateEnvelopeInput = {
  set?: InputMaybe<NonprofitDataCreateInput>;
};

export type NonprofitDataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<NonprofitDataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<NonprofitDataUpsertInput>;
};

export type NonprofitDataObjectEqualityInput = {
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brief?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  locationObject?: InputMaybe<LocationObjectObjectEqualityInput>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type NonprofitDataOrderByInput = {
  SDGs?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  locationObject?: InputMaybe<LocationObjectOrderByInput>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  tagLine?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitDataUpdateInput = {
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NonprofitDataUpdateSdGsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitDataUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitDataUpdatepicturesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitDataUpsertInput = {
  set: NonprofitDataCreateInput;
  update: NonprofitDataUpdateInput;
};

export type NonprofitDataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitDataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitDataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitDataWhereInput>>>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  brief?: InputMaybe<StringNullableFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  locationObject?: InputMaybe<LocationObjectNullableCompositeFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  tagLine?: InputMaybe<StringNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export enum NonprofitEntityType {
  GovernmentEntity = 'governmentEntity',
  MemberAssociatedEntity = 'memberAssociatedEntity',
  Nonprofit = 'nonprofit',
  School = 'school'
}

export type NonprofitEntityTypeExcludeFilter = {
  __typename?: 'NonprofitEntityTypeExcludeFilter';
  exclude: Array<NonprofitEntityType>;
};

export type NonprofitEntityTypeExcludeFilterCreateInput = {
  exclude?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NonprofitEntityTypeExcludeFilterCreateexcludeInput = {
  set: NonprofitEntityType;
};

export type NonprofitEntityTypeExcludeFilterNullableCompositeFilter = {
  equals?: InputMaybe<NonprofitEntityTypeExcludeFilterObjectEqualityInput>;
  is?: InputMaybe<NonprofitEntityTypeExcludeFilterWhereInput>;
  isNot?: InputMaybe<NonprofitEntityTypeExcludeFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NonprofitEntityTypeExcludeFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<NonprofitEntityTypeExcludeFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<NonprofitEntityTypeExcludeFilterUpsertInput>;
};

export type NonprofitEntityTypeExcludeFilterObjectEqualityInput = {
  exclude?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NonprofitEntityTypeExcludeFilterOrderByInput = {
  exclude?: InputMaybe<SortOrder>;
};

export type NonprofitEntityTypeExcludeFilterUpdateInput = {
  exclude?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NonprofitEntityTypeExcludeFilterUpdateexcludeInput = {
  push?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type NonprofitEntityTypeExcludeFilterUpsertInput = {
  set: NonprofitEntityTypeExcludeFilterCreateInput;
  update: NonprofitEntityTypeExcludeFilterUpdateInput;
};

export type NonprofitEntityTypeExcludeFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitEntityTypeExcludeFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitEntityTypeExcludeFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitEntityTypeExcludeFilterWhereInput>>>;
  exclude?: InputMaybe<EnumNonprofitEntityTypeNullableListFilter>;
};

export type NonprofitIdentifierEntry = {
  __typename?: 'NonprofitIdentifierEntry';
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type?: Maybe<NonprofitIdentifierType>;
};

export type NonprofitIdentifierEntryCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryObjectEqualityInput>>>;
  every?: InputMaybe<NonprofitIdentifierEntryWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NonprofitIdentifierEntryWhereInput>;
  some?: InputMaybe<NonprofitIdentifierEntryWhereInput>;
};

export type NonprofitIdentifierEntryCreateInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  type?: InputMaybe<NonprofitIdentifierType>;
};

export type NonprofitIdentifierEntryDeleteManyInput = {
  where: NonprofitIdentifierEntryWhereInput;
};

export type NonprofitIdentifierEntryListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
};

export type NonprofitIdentifierEntryListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<NonprofitIdentifierEntryDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  updateMany?: InputMaybe<NonprofitIdentifierEntryUpdateManyInput>;
};

export type NonprofitIdentifierEntryObjectEqualityInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  type?: InputMaybe<NonprofitIdentifierType>;
};

export type NonprofitIdentifierEntryOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NonprofitIdentifierEntryStrict = {
  __typename?: 'NonprofitIdentifierEntryStrict';
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type?: Maybe<NonprofitIdentifierTypeEnum>;
};

export type NonprofitIdentifierEntryStrictInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  type: NonprofitIdentifierTypeEnum;
};

/** Nonprofit identifier entry */
export type NonprofitIdentifierEntryType = {
  __typename?: 'NonprofitIdentifierEntryType';
  countryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NonprofitIdentifierEntryUpdateInput = {
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNonprofitIdentifierTypeFieldUpdateOperationsInput>;
};

export type NonprofitIdentifierEntryUpdateManyInput = {
  data: NonprofitIdentifierEntryUpdateInput;
  where: NonprofitIdentifierEntryWhereInput;
};

export type NonprofitIdentifierEntryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryWhereInput>>>;
  countryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNonprofitIdentifierTypeNullableFilter>;
};

export enum NonprofitIdentifierType {
  Abn = 'abn',
  CafId = 'cafId',
  Cra = 'cra',
  Ein = 'ein',
  Nces = 'nces',
  Rcn = 'rcn',
  TaxId = 'taxId',
  Uid = 'uid'
}

export enum NonprofitIdentifierTypeEnum {
  Abn = 'abn',
  CafId = 'cafId',
  Cra = 'cra',
  Cybergrants = 'cybergrants',
  Ein = 'ein',
  Give2asiaId = 'give2asiaId',
  Nces = 'nces',
  PaypalNonprofitId = 'paypalNonprofitId',
  PaypalPayerId = 'paypalPayerId',
  Rcn = 'rcn',
  TaxId = 'taxId',
  Uid = 'uid'
}

export type NonprofitInfo = {
  __typename?: 'NonprofitInfo';
  /** The organization has at least one admin user */
  hasAdmins?: Maybe<Scalars['Boolean']['output']>;
  /** The organization has at least one verified user */
  hasVerifiedUsers?: Maybe<Scalars['Boolean']['output']>;
  /** The verified users of the organization */
  verifiedUsers?: Maybe<Array<VerifiedUser>>;
};

export type NonprofitListRelationFilter = {
  every?: InputMaybe<NonprofitWhereInput>;
  none?: InputMaybe<NonprofitWhereInput>;
  some?: InputMaybe<NonprofitWhereInput>;
};

export type NonprofitMaxAggregateOutputType = {
  __typename?: 'NonprofitMaxAggregateOutputType';
  deedAccountId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitDataValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  partnerNonprofitId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationStatus?: Maybe<VerificationStatuses>;
  verificationStatusSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type NonprofitMaxOrderByAggregateInput = {
  deedAccountId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDataValidatedAt?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  parent?: InputMaybe<SortOrder>;
  partnerNonprofitId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

/** Nonprofit search meta */
export type NonprofitMeta = {
  __typename?: 'NonprofitMeta';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type NonprofitMinAggregateOutputType = {
  __typename?: 'NonprofitMinAggregateOutputType';
  deedAccountId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitDataValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  partnerNonprofitId?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationStatus?: Maybe<VerificationStatuses>;
  verificationStatusSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type NonprofitMinOrderByAggregateInput = {
  deedAccountId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDataValidatedAt?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  parent?: InputMaybe<SortOrder>;
  partnerNonprofitId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: nonprofitNominations:view, organizationField: companyId), OrganizerGlobalAccess(privilege: deedInternal:handleNonprofitNominations)]) */
export type NonprofitNomination = {
  __typename?: 'NonprofitNomination';
  Company: Organization;
  Nonprofit?: Maybe<Organization>;
  /** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: nonprofitNominations:viewPII, organizationField: companyId)]) */
  User?: Maybe<BaseUser>;
  companyId: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<NonprofitNominationEmails>;
  engagementType: EngagementType;
  existingOrganization?: Maybe<Organization>;
  existingOrganizationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  ncesIdentifier?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  nonprofitName: Scalars['String']['output'];
  otherNote?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
  zendeskMetadata?: Maybe<ZendeskMetadata>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: nonprofitNominations:view, organizationField: companyId), OrganizerGlobalAccess(privilege: deedInternal:handleNonprofitNominations)]) */
export type NonprofitNominationNonprofitArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: nonprofitNominations:view, organizationField: companyId), OrganizerGlobalAccess(privilege: deedInternal:handleNonprofitNominations)]) */
export type NonprofitNominationUserArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: nonprofitNominations:view, organizationField: companyId), OrganizerGlobalAccess(privilege: deedInternal:handleNonprofitNominations)]) */
export type NonprofitNominationExistingOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type NonprofitNominationCountAggregateOutputType = {
  __typename?: 'NonprofitNominationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  ein: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  engagementType: Scalars['Int']['output'];
  existingOrganizationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalNote: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  ncesIdentifier: Scalars['Int']['output'];
  nonprofitEntityType: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  nonprofitName: Scalars['Int']['output'];
  otherNote: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type NonprofitNominationCountOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  engagementType?: InputMaybe<SortOrder>;
  existingOrganizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  ncesIdentifier?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitName?: InputMaybe<SortOrder>;
  otherNote?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitNominationCreateInput = {
  Company: OrganizationCreateNestedOneWithoutNonprofitNominationsForCompanyInput;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForNonprofitInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutNonprofitNominationInput>;
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForExistingOrgInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateInputType = {
  country: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type NonprofitNominationCreateManyCompanyInput = {
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateManyCompanyInputEnvelope = {
  data: NonprofitNominationCreateManyCompanyInput;
};

export type NonprofitNominationCreateManyExistingOrganizationInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateManyExistingOrganizationInputEnvelope = {
  data: NonprofitNominationCreateManyExistingOrganizationInput;
};

export type NonprofitNominationCreateManyInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateManyNonprofitInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateManyNonprofitInputEnvelope = {
  data: NonprofitNominationCreateManyNonprofitInput;
};

export type NonprofitNominationCreateManyUserInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateManyUserInputEnvelope = {
  data: NonprofitNominationCreateManyUserInput;
};

export type NonprofitNominationCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyCompanyInputEnvelope>;
};

export type NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutExistingOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutExistingOrganizationInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyExistingOrganizationInputEnvelope>;
};

export type NonprofitNominationCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyNonprofitInputEnvelope>;
};

export type NonprofitNominationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyUserInputEnvelope>;
};

export type NonprofitNominationCreateOrConnectWithoutCompanyInput = {
  create: NonprofitNominationCreateWithoutCompanyInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationCreateOrConnectWithoutExistingOrganizationInput = {
  create: NonprofitNominationCreateWithoutExistingOrganizationInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationCreateOrConnectWithoutNonprofitInput = {
  create: NonprofitNominationCreateWithoutNonprofitInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationCreateOrConnectWithoutUserInput = {
  create: NonprofitNominationCreateWithoutUserInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationCreateWithoutCompanyInput = {
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForNonprofitInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutNonprofitNominationInput>;
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForExistingOrgInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateWithoutExistingOrganizationInput = {
  Company: OrganizationCreateNestedOneWithoutNonprofitNominationsForCompanyInput;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForNonprofitInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutNonprofitNominationInput>;
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateWithoutNonprofitInput = {
  Company: OrganizationCreateNestedOneWithoutNonprofitNominationsForCompanyInput;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutNonprofitNominationInput>;
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForExistingOrgInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationCreateWithoutUserInput = {
  Company: OrganizationCreateNestedOneWithoutNonprofitNominationsForCompanyInput;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForNonprofitInput>;
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitNominationsForExistingOrgInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationEmails = {
  __typename?: 'NonprofitNominationEmails';
  nonprofitNominationOutreachFinal?: Maybe<Scalars['DateTime']['output']>;
  nonprofitNominationOutreachInitial?: Maybe<Scalars['DateTime']['output']>;
  nonprofitNominationOutreachReminder?: Maybe<Scalars['DateTime']['output']>;
};

export type NonprofitNominationEmailsCreateInput = {
  nonprofitNominationOutreachFinal?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitNominationOutreachInitial?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitNominationOutreachReminder?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NonprofitNominationEmailsNullableCompositeFilter = {
  equals?: InputMaybe<NonprofitNominationEmailsObjectEqualityInput>;
  is?: InputMaybe<NonprofitNominationEmailsWhereInput>;
  isNot?: InputMaybe<NonprofitNominationEmailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NonprofitNominationEmailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<NonprofitNominationEmailsCreateInput>;
};

export type NonprofitNominationEmailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<NonprofitNominationEmailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<NonprofitNominationEmailsUpsertInput>;
};

export type NonprofitNominationEmailsObjectEqualityInput = {
  nonprofitNominationOutreachFinal?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitNominationOutreachInitial?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitNominationOutreachReminder?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NonprofitNominationEmailsOrderByInput = {
  nonprofitNominationOutreachFinal?: InputMaybe<SortOrder>;
  nonprofitNominationOutreachInitial?: InputMaybe<SortOrder>;
  nonprofitNominationOutreachReminder?: InputMaybe<SortOrder>;
};

export type NonprofitNominationEmailsUpdateInput = {
  nonprofitNominationOutreachFinal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitNominationOutreachInitial?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitNominationOutreachReminder?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type NonprofitNominationEmailsUpsertInput = {
  set: NonprofitNominationEmailsCreateInput;
  update: NonprofitNominationEmailsUpdateInput;
};

export type NonprofitNominationEmailsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitNominationEmailsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitNominationEmailsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitNominationEmailsWhereInput>>>;
  nonprofitNominationOutreachFinal?: InputMaybe<DateTimeNullableFilter>;
  nonprofitNominationOutreachInitial?: InputMaybe<DateTimeNullableFilter>;
  nonprofitNominationOutreachReminder?: InputMaybe<DateTimeNullableFilter>;
};

export type NonprofitNominationListRelationFilter = {
  every?: InputMaybe<NonprofitNominationWhereInput>;
  none?: InputMaybe<NonprofitNominationWhereInput>;
  some?: InputMaybe<NonprofitNominationWhereInput>;
};

export type NonprofitNominationMaxAggregateOutputType = {
  __typename?: 'NonprofitNominationMaxAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  engagementType?: Maybe<EngagementType>;
  existingOrganizationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  ncesIdentifier?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  nonprofitName?: Maybe<Scalars['String']['output']>;
  otherNote?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NonprofitNominationStatusType>;
  userId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type NonprofitNominationMaxOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  engagementType?: InputMaybe<SortOrder>;
  existingOrganizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  ncesIdentifier?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitName?: InputMaybe<SortOrder>;
  otherNote?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitNominationMinAggregateOutputType = {
  __typename?: 'NonprofitNominationMinAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  engagementType?: Maybe<EngagementType>;
  existingOrganizationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  ncesIdentifier?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  nonprofitName?: Maybe<Scalars['String']['output']>;
  otherNote?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<NonprofitNominationStatusType>;
  userId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type NonprofitNominationMinOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  engagementType?: InputMaybe<SortOrder>;
  existingOrganizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  ncesIdentifier?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitName?: InputMaybe<SortOrder>;
  otherNote?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitNominationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NonprofitNominationOrderByWithAggregationInput = {
  _count?: InputMaybe<NonprofitNominationCountOrderByAggregateInput>;
  _max?: InputMaybe<NonprofitNominationMaxOrderByAggregateInput>;
  _min?: InputMaybe<NonprofitNominationMinOrderByAggregateInput>;
  companyId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  engagementType?: InputMaybe<SortOrder>;
  existingOrganizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  ncesIdentifier?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitName?: InputMaybe<SortOrder>;
  otherNote?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitNominationOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emails?: InputMaybe<NonprofitNominationEmailsOrderByInput>;
  engagementType?: InputMaybe<SortOrder>;
  existingOrganization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  existingOrganizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  ncesIdentifier?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitName?: InputMaybe<SortOrder>;
  otherNote?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataOrderByInput>;
};

export enum NonprofitNominationScalarFieldEnum {
  CompanyId = 'companyId',
  Country = 'country',
  CreatedAt = 'createdAt',
  Ein = 'ein',
  Email = 'email',
  EngagementType = 'engagementType',
  ExistingOrganizationId = 'existingOrganizationId',
  Id = 'id',
  InternalNote = 'internalNote',
  ModifiedAt = 'modifiedAt',
  NcesIdentifier = 'ncesIdentifier',
  NonprofitEntityType = 'nonprofitEntityType',
  NonprofitId = 'nonprofitId',
  NonprofitName = 'nonprofitName',
  OtherNote = 'otherNote',
  Phone = 'phone',
  Status = 'status',
  UserId = 'userId',
  Website = 'website'
}

export type NonprofitNominationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  companyId?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  engagementType?: InputMaybe<EnumEngagementTypeFilter>;
  existingOrganizationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalNote?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  ncesIdentifier?: InputMaybe<StringNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  nonprofitName?: InputMaybe<StringFilter>;
  otherNote?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFilter>;
  userId?: InputMaybe<StringFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type NonprofitNominationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereWithAggregatesInput>>>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  country?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  ein?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  engagementType?: InputMaybe<EnumEngagementTypeWithAggregatesFilter>;
  existingOrganizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  internalNote?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  ncesIdentifier?: InputMaybe<StringNullableWithAggregatesFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  nonprofitName?: InputMaybe<StringWithAggregatesFilter>;
  otherNote?: InputMaybe<StringNullableWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  website?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum NonprofitNominationStatusType {
  FilteredOut = 'FilteredOut',
  NoResponse = 'NoResponse',
  NominationAccepted = 'NominationAccepted',
  NominationDeclined = 'NominationDeclined',
  Onboarding = 'Onboarding',
  OrganizationFound = 'OrganizationFound',
  Outreach = 'Outreach',
  Submitted = 'Submitted',
  Troubleshooting = 'Troubleshooting'
}

export type NonprofitNominationUncheckedCreateInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyCompanyInputEnvelope>;
};

export type NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutExistingOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutExistingOrganizationInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyExistingOrganizationInputEnvelope>;
};

export type NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyNonprofitInputEnvelope>;
};

export type NonprofitNominationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyUserInputEnvelope>;
};

export type NonprofitNominationUncheckedCreateWithoutCompanyInput = {
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationUncheckedCreateWithoutExistingOrganizationInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationUncheckedCreateWithoutNonprofitInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  userId: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationUncheckedCreateWithoutUserInput = {
  companyId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCreateEnvelopeInput>;
  engagementType: EngagementType;
  existingOrganizationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ncesIdentifier?: InputMaybe<Scalars['String']['input']>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  nonprofitName: Scalars['String']['input'];
  otherNote?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status: NonprofitNominationStatusType;
  website?: InputMaybe<Scalars['String']['input']>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCreateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutCompanyInput = {
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutExistingOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutExistingOrganizationInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyExistingOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutExistingOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutExistingOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutExistingOrganizationInput>>>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutNonprofitInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutUserInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type NonprofitNominationUncheckedUpdateWithoutCompanyInput = {
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateWithoutExistingOrganizationInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateWithoutNonprofitInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUncheckedUpdateWithoutUserInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitNominationsForCompanyNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForNonprofitNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutNonprofitNominationNestedInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganization?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForExistingOrgNestedInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateInputType = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  nonprofitLink?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NonprofitNominationStatusType>;
};

export type NonprofitNominationUpdateManyMutationInput = {
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateManyWithWhereWithoutCompanyInput = {
  data: NonprofitNominationUpdateManyMutationInput;
  where: NonprofitNominationScalarWhereInput;
};

export type NonprofitNominationUpdateManyWithWhereWithoutExistingOrganizationInput = {
  data: NonprofitNominationUpdateManyMutationInput;
  where: NonprofitNominationScalarWhereInput;
};

export type NonprofitNominationUpdateManyWithWhereWithoutNonprofitInput = {
  data: NonprofitNominationUpdateManyMutationInput;
  where: NonprofitNominationScalarWhereInput;
};

export type NonprofitNominationUpdateManyWithWhereWithoutUserInput = {
  data: NonprofitNominationUpdateManyMutationInput;
  where: NonprofitNominationScalarWhereInput;
};

export type NonprofitNominationUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutExistingOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutExistingOrganizationInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyExistingOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutExistingOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutExistingOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutExistingOrganizationInput>>>;
};

export type NonprofitNominationUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type NonprofitNominationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitNominationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NonprofitNominationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitNominationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitNominationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type NonprofitNominationUpdateWithWhereUniqueWithoutCompanyInput = {
  data: NonprofitNominationUpdateWithoutCompanyInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpdateWithWhereUniqueWithoutExistingOrganizationInput = {
  data: NonprofitNominationUpdateWithoutExistingOrganizationInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: NonprofitNominationUpdateWithoutNonprofitInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpdateWithWhereUniqueWithoutUserInput = {
  data: NonprofitNominationUpdateWithoutUserInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpdateWithoutCompanyInput = {
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForNonprofitNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutNonprofitNominationNestedInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganization?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForExistingOrgNestedInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateWithoutExistingOrganizationInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitNominationsForCompanyNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForNonprofitNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutNonprofitNominationNestedInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitNominationsForCompanyNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutNonprofitNominationNestedInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganization?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForExistingOrgNestedInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpdateWithoutUserInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitNominationsForCompanyNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForNonprofitNestedInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableUpdateEnvelopeInput>;
  engagementType?: InputMaybe<EnumEngagementTypeFieldUpdateOperationsInput>;
  existingOrganization?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNominationsForExistingOrgNestedInput>;
  internalNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ncesIdentifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitName?: InputMaybe<StringFieldUpdateOperationsInput>;
  otherNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableUpdateEnvelopeInput>;
};

export type NonprofitNominationUpsertWithWhereUniqueWithoutCompanyInput = {
  create: NonprofitNominationCreateWithoutCompanyInput;
  update: NonprofitNominationUpdateWithoutCompanyInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpsertWithWhereUniqueWithoutExistingOrganizationInput = {
  create: NonprofitNominationCreateWithoutExistingOrganizationInput;
  update: NonprofitNominationUpdateWithoutExistingOrganizationInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: NonprofitNominationCreateWithoutNonprofitInput;
  update: NonprofitNominationUpdateWithoutNonprofitInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationUpsertWithWhereUniqueWithoutUserInput = {
  create: NonprofitNominationCreateWithoutUserInput;
  update: NonprofitNominationUpdateWithoutUserInput;
  where: NonprofitNominationWhereUniqueInput;
};

export type NonprofitNominationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCompositeFilter>;
  engagementType?: InputMaybe<EnumEngagementTypeFilter>;
  existingOrganization?: InputMaybe<OrganizationNullableRelationFilter>;
  existingOrganizationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalNote?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  ncesIdentifier?: InputMaybe<StringNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  nonprofitName?: InputMaybe<StringFilter>;
  otherNote?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFilter>;
  userId?: InputMaybe<StringFilter>;
  website?: InputMaybe<StringNullableFilter>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCompositeFilter>;
};

export type NonprofitNominationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitNominationWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emails?: InputMaybe<NonprofitNominationEmailsNullableCompositeFilter>;
  engagementType?: InputMaybe<EnumEngagementTypeFilter>;
  existingOrganization?: InputMaybe<OrganizationNullableRelationFilter>;
  existingOrganizationId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  ncesIdentifier?: InputMaybe<StringNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  nonprofitName?: InputMaybe<StringFilter>;
  otherNote?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumNonprofitNominationStatusTypeFilter>;
  userId?: InputMaybe<StringFilter>;
  website?: InputMaybe<StringNullableFilter>;
  zendeskMetadata?: InputMaybe<ZendeskMetadataNullableCompositeFilter>;
};

export type NonprofitNullableRelationFilter = {
  is?: InputMaybe<NonprofitWhereInput>;
  isNot?: InputMaybe<NonprofitWhereInput>;
};

export type NonprofitOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NonprofitOrderByWithAggregationInput = {
  _count?: InputMaybe<NonprofitCountOrderByAggregateInput>;
  _max?: InputMaybe<NonprofitMaxOrderByAggregateInput>;
  _min?: InputMaybe<NonprofitMinOrderByAggregateInput>;
  aliases?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  deedAccountId?: InputMaybe<SortOrder>;
  donationProviders?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDataValidatedAt?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitProviders?: InputMaybe<SortOrder>;
  parent?: InputMaybe<SortOrder>;
  partnerNonprofitId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationSources?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type NonprofitOrderByWithRelationInput = {
  Children?: InputMaybe<NonprofitOrderByRelationAggregateInput>;
  DeedNonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Parent?: InputMaybe<NonprofitOrderByWithRelationInput>;
  affiliations?: InputMaybe<NonprofitAffiliationOrderByCompositeAggregateInput>;
  aliases?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  content?: InputMaybe<NonprofitContentOrderByInput>;
  deedAccountId?: InputMaybe<SortOrder>;
  donationProviders?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  externalIds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<NonprofitIdentifierEntryOrderByCompositeAggregateInput>;
  legalName?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationObjectOrderByInput>;
  mainPicture?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDataValidatedAt?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  nonprofitProviders?: InputMaybe<SortOrder>;
  parent?: InputMaybe<SortOrder>;
  partnerNonprofitId?: InputMaybe<SortOrder>;
  people?: InputMaybe<PersonOrderByCompositeAggregateInput>;
  pictures?: InputMaybe<NonprofitPicturesOrderByInput>;
  providerId?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  taxonomy?: InputMaybe<TaxonomyOrderByInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verificationSources?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

/** Nonprofit partial details */
export type NonprofitPartial = {
  __typename?: 'NonprofitPartial';
  access?: Maybe<NonprofitAccess>;
  ein?: Maybe<Scalars['String']['output']>;
  invisible?: Maybe<Scalars['Boolean']['output']>;
  isParent?: Maybe<Scalars['Boolean']['output']>;
  locationObject?: Maybe<LocationObject>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
};

export type NonprofitPayoutMapEntry = {
  __typename?: 'NonprofitPayoutMapEntry';
  payee: Scalars['String']['output'];
  routedTo: Scalars['String']['output'];
};

export type NonprofitPayoutMapEntryCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryObjectEqualityInput>>>;
  every?: InputMaybe<NonprofitPayoutMapEntryWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NonprofitPayoutMapEntryWhereInput>;
  some?: InputMaybe<NonprofitPayoutMapEntryWhereInput>;
};

export type NonprofitPayoutMapEntryCreateInput = {
  payee: Scalars['String']['input'];
  routedTo: Scalars['String']['input'];
};

export type NonprofitPayoutMapEntryDeleteManyInput = {
  where: NonprofitPayoutMapEntryWhereInput;
};

export type NonprofitPayoutMapEntryListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
};

export type NonprofitPayoutMapEntryListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<NonprofitPayoutMapEntryDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryCreateInput>>>;
  updateMany?: InputMaybe<NonprofitPayoutMapEntryUpdateManyInput>;
};

export type NonprofitPayoutMapEntryObjectEqualityInput = {
  payee: Scalars['String']['input'];
  routedTo: Scalars['String']['input'];
};

export type NonprofitPayoutMapEntryOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NonprofitPayoutMapEntryUpdateInput = {
  payee?: InputMaybe<StringFieldUpdateOperationsInput>;
  routedTo?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitPayoutMapEntryUpdateManyInput = {
  data: NonprofitPayoutMapEntryUpdateInput;
  where: NonprofitPayoutMapEntryWhereInput;
};

export type NonprofitPayoutMapEntryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitPayoutMapEntryWhereInput>>>;
  payee?: InputMaybe<StringFilter>;
  routedTo?: InputMaybe<StringFilter>;
};

export type NonprofitPictures = {
  __typename?: 'NonprofitPictures';
  banner?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type NonprofitPicturesCompositeFilter = {
  equals?: InputMaybe<NonprofitPicturesObjectEqualityInput>;
  is?: InputMaybe<NonprofitPicturesWhereInput>;
  isNot?: InputMaybe<NonprofitPicturesWhereInput>;
};

export type NonprofitPicturesCreateEnvelopeInput = {
  set?: InputMaybe<NonprofitPicturesCreateInput>;
};

export type NonprofitPicturesCreateInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type NonprofitPicturesObjectEqualityInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type NonprofitPicturesOrderByInput = {
  banner?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrder>;
};

export type NonprofitPicturesUpdateEnvelopeInput = {
  set?: InputMaybe<NonprofitPicturesCreateInput>;
  update?: InputMaybe<NonprofitPicturesUpdateInput>;
};

export type NonprofitPicturesUpdateInput = {
  banner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NonprofitPicturesWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitPicturesWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitPicturesWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitPicturesWhereInput>>>;
  banner?: InputMaybe<StringNullableFilter>;
  logo?: InputMaybe<StringNullableFilter>;
};

export enum NonprofitScalarFieldEnum {
  Aliases = 'aliases',
  Categories = 'categories',
  DeedAccountId = 'deedAccountId',
  DonationProviders = 'donationProviders',
  Email = 'email',
  ExternalIds = 'externalIds',
  Id = 'id',
  LegalName = 'legalName',
  MainPicture = 'mainPicture',
  Name = 'name',
  NonprofitDataValidatedAt = 'nonprofitDataValidatedAt',
  NonprofitEntityType = 'nonprofitEntityType',
  NonprofitId = 'nonprofitId',
  NonprofitProviders = 'nonprofitProviders',
  Parent = 'parent',
  PartnerNonprofitId = 'partnerNonprofitId',
  ProviderId = 'providerId',
  RegisteredAt = 'registeredAt',
  Sdgs = 'sdgs',
  UpdatedAt = 'updatedAt',
  VerificationSources = 'verificationSources',
  VerificationStatus = 'verificationStatus',
  VerificationStatusSyncedAt = 'verificationStatusSyncedAt',
  Website = 'website'
}

export type NonprofitScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  aliases?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  deedAccountId?: InputMaybe<StringNullableFilter>;
  donationProviders?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  externalIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  legalName?: InputMaybe<StringFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDataValidatedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  nonprofitProviders?: InputMaybe<StringNullableListFilter>;
  parent?: InputMaybe<StringNullableFilter>;
  partnerNonprofitId?: InputMaybe<StringFilter>;
  providerId?: InputMaybe<StringFilter>;
  registeredAt?: InputMaybe<DateTimeFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationSources?: InputMaybe<StringNullableListFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringFilter>;
};

export type NonprofitScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereWithAggregatesInput>>>;
  aliases?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  deedAccountId?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationProviders?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  externalIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  legalName?: InputMaybe<StringWithAggregatesFilter>;
  mainPicture?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  nonprofitDataValidatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringWithAggregatesFilter>;
  nonprofitProviders?: InputMaybe<StringNullableListFilter>;
  parent?: InputMaybe<StringNullableWithAggregatesFilter>;
  partnerNonprofitId?: InputMaybe<StringWithAggregatesFilter>;
  providerId?: InputMaybe<StringWithAggregatesFilter>;
  registeredAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  verificationSources?: InputMaybe<StringNullableListFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesWithAggregatesFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  website?: InputMaybe<StringWithAggregatesFilter>;
};

export type NonprofitUncheckedCreateInput = {
  Children?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutParentInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  deedAccountId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutDeedNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutDeedNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyDeedNonprofitInputEnvelope>;
};

export type NonprofitUncheckedCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutParentInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyParentInputEnvelope>;
};

export type NonprofitUncheckedCreateWithoutChildrenInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  deedAccountId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitUncheckedCreateWithoutDeedNonprofitInput = {
  Children?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutParentInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitUncheckedCreateWithoutParentInput = {
  Children?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutParentInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: NonprofitContentCreateEnvelopeInput;
  deedAccountId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName: Scalars['String']['input'];
  location: LocationObjectCreateEnvelopeInput;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nonprofitDataValidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitEntityType: NonprofitEntityType;
  nonprofitId: Scalars['String']['input'];
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId: Scalars['String']['input'];
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures: NonprofitPicturesCreateEnvelopeInput;
  providerId: Scalars['String']['input'];
  registeredAt: Scalars['DateTime']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableCreateEnvelopeInput>;
  updatedAt: Scalars['DateTime']['input'];
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus: VerificationStatuses;
  verificationStatusSyncedAt: Scalars['DateTime']['input'];
  website: Scalars['String']['input'];
};

export type NonprofitUncheckedUpdateInput = {
  Children?: InputMaybe<NonprofitUncheckedUpdateManyWithoutParentNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  deedAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateManyInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  deedAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateManyWithoutDeedNonprofitInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutDeedNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutDeedNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyDeedNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitUpdateWithWhereUniqueWithoutDeedNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitUpdateManyWithWhereWithoutDeedNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitUpsertWithWhereUniqueWithoutDeedNonprofitInput>>>;
};

export type NonprofitUncheckedUpdateManyWithoutParentInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  deedAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutParentInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitUpdateWithWhereUniqueWithoutParentInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitUpdateManyWithWhereWithoutParentInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitUpsertWithWhereUniqueWithoutParentInput>>>;
};

export type NonprofitUncheckedUpdateWithoutChildrenInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  deedAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateWithoutDeedNonprofitInput = {
  Children?: InputMaybe<NonprofitUncheckedUpdateManyWithoutParentNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUncheckedUpdateWithoutParentInput = {
  Children?: InputMaybe<NonprofitUncheckedUpdateManyWithoutParentNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  deedAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdateInput = {
  Children?: InputMaybe<NonprofitUpdateManyWithoutParentNestedInput>;
  DeedNonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNestedInput>;
  Parent?: InputMaybe<NonprofitUpdateOneWithoutChildrenNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdateManyMutationInput = {
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdateManyWithWhereWithoutDeedNonprofitInput = {
  data: NonprofitUpdateManyMutationInput;
  where: NonprofitScalarWhereInput;
};

export type NonprofitUpdateManyWithWhereWithoutParentInput = {
  data: NonprofitUpdateManyMutationInput;
  where: NonprofitScalarWhereInput;
};

export type NonprofitUpdateManyWithoutDeedNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutDeedNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutDeedNonprofitInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyDeedNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitUpdateWithWhereUniqueWithoutDeedNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitUpdateManyWithWhereWithoutDeedNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitUpsertWithWhereUniqueWithoutDeedNonprofitInput>>>;
};

export type NonprofitUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NonprofitCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<NonprofitCreateWithoutParentInput>>>;
  createMany?: InputMaybe<NonprofitCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NonprofitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NonprofitUpdateWithWhereUniqueWithoutParentInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NonprofitUpdateManyWithWhereWithoutParentInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NonprofitUpsertWithWhereUniqueWithoutParentInput>>>;
};

export type NonprofitUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<NonprofitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NonprofitCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<NonprofitCreateWithoutChildrenInput>;
  delete?: InputMaybe<NonprofitWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<NonprofitUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<NonprofitUpsertWithoutChildrenInput>;
};

export type NonprofitUpdateToOneWithWhereWithoutChildrenInput = {
  data: NonprofitUpdateWithoutChildrenInput;
  where?: InputMaybe<NonprofitWhereInput>;
};

export type NonprofitUpdateWithWhereUniqueWithoutDeedNonprofitInput = {
  data: NonprofitUpdateWithoutDeedNonprofitInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitUpdateWithWhereUniqueWithoutParentInput = {
  data: NonprofitUpdateWithoutParentInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitUpdateWithoutChildrenInput = {
  DeedNonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNestedInput>;
  Parent?: InputMaybe<NonprofitUpdateOneWithoutChildrenNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdateWithoutDeedNonprofitInput = {
  Children?: InputMaybe<NonprofitUpdateManyWithoutParentNestedInput>;
  Parent?: InputMaybe<NonprofitUpdateOneWithoutChildrenNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdateWithoutParentInput = {
  Children?: InputMaybe<NonprofitUpdateManyWithoutParentNestedInput>;
  DeedNonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitNestedInput>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationCreateInput>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<NonprofitContentUpdateEnvelopeInput>;
  donationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectUpdateEnvelopeInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDataValidatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerNonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  people?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  pictures?: InputMaybe<NonprofitPicturesUpdateEnvelopeInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  registeredAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taxonomy?: InputMaybe<TaxonomyNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NonprofitUpdatealiasesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdatedonationProvidersInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdateexternalIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdatenonprofitProvidersInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdatesdgsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpdateverificationSourcesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NonprofitUpsertWithWhereUniqueWithoutDeedNonprofitInput = {
  create: NonprofitCreateWithoutDeedNonprofitInput;
  update: NonprofitUpdateWithoutDeedNonprofitInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitUpsertWithWhereUniqueWithoutParentInput = {
  create: NonprofitCreateWithoutParentInput;
  update: NonprofitUpdateWithoutParentInput;
  where: NonprofitWhereUniqueInput;
};

export type NonprofitUpsertWithoutChildrenInput = {
  create: NonprofitCreateWithoutChildrenInput;
  update: NonprofitUpdateWithoutChildrenInput;
  where?: InputMaybe<NonprofitWhereInput>;
};

export type NonprofitWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  Children?: InputMaybe<NonprofitListRelationFilter>;
  DeedNonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  Parent?: InputMaybe<NonprofitNullableRelationFilter>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationObjectEqualityInput>>>;
  aliases?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<NonprofitContentCompositeFilter>;
  deedAccountId?: InputMaybe<StringNullableFilter>;
  donationProviders?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  externalIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryObjectEqualityInput>>>;
  legalName?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationObjectCompositeFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDataValidatedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  nonprofitProviders?: InputMaybe<StringNullableListFilter>;
  parent?: InputMaybe<StringNullableFilter>;
  partnerNonprofitId?: InputMaybe<StringFilter>;
  people?: InputMaybe<Array<InputMaybe<PersonObjectEqualityInput>>>;
  pictures?: InputMaybe<NonprofitPicturesCompositeFilter>;
  providerId?: InputMaybe<StringFilter>;
  registeredAt?: InputMaybe<DateTimeFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  taxonomy?: InputMaybe<TaxonomyNullableCompositeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationSources?: InputMaybe<StringNullableListFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringFilter>;
};

export type NonprofitWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  Children?: InputMaybe<NonprofitListRelationFilter>;
  DeedNonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NonprofitWhereInput>>>;
  Parent?: InputMaybe<NonprofitNullableRelationFilter>;
  affiliations?: InputMaybe<Array<InputMaybe<NonprofitAffiliationObjectEqualityInput>>>;
  aliases?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<NonprofitContentCompositeFilter>;
  deedAccountId?: InputMaybe<StringNullableFilter>;
  donationProviders?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  externalIds?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryObjectEqualityInput>>>;
  legalName?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationObjectCompositeFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDataValidatedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  nonprofitProviders?: InputMaybe<StringNullableListFilter>;
  parent?: InputMaybe<StringNullableFilter>;
  partnerNonprofitId?: InputMaybe<StringFilter>;
  people?: InputMaybe<Array<InputMaybe<PersonObjectEqualityInput>>>;
  pictures?: InputMaybe<NonprofitPicturesCompositeFilter>;
  providerId?: InputMaybe<StringFilter>;
  registeredAt?: InputMaybe<DateTimeFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  taxonomy?: InputMaybe<TaxonomyNullableCompositeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verificationSources?: InputMaybe<StringNullableListFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringFilter>;
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  bccAdminOnMessage?: Maybe<Scalars['Json']['output']>;
  mutedCategories: Array<Scalars['String']['output']>;
  mutedMessages: Array<Scalars['String']['output']>;
};

export type NotificationChannelCreateInput = {
  bccAdminOnMessage?: InputMaybe<Scalars['Json']['input']>;
  mutedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannelCreatemutedCategoriesInput = {
  set: Scalars['String']['input'];
};

export type NotificationChannelCreatemutedMessagesInput = {
  set: Scalars['String']['input'];
};

export type NotificationChannelNullableCompositeFilter = {
  equals?: InputMaybe<NotificationChannelObjectEqualityInput>;
  is?: InputMaybe<NotificationChannelWhereInput>;
  isNot?: InputMaybe<NotificationChannelWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationChannelNullableUpdateEnvelopeInput = {
  set?: InputMaybe<NotificationChannelCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<NotificationChannelUpsertInput>;
};

export type NotificationChannelObjectEqualityInput = {
  bccAdminOnMessage?: InputMaybe<Scalars['Json']['input']>;
  mutedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannelOrderByInput = {
  bccAdminOnMessage?: InputMaybe<SortOrder>;
  mutedCategories?: InputMaybe<SortOrder>;
  mutedMessages?: InputMaybe<SortOrder>;
};

/** Notification channel type. So far we only support `email` */
export enum NotificationChannelType {
  Email = 'email',
  Slack = 'slack',
  Sms = 'sms'
}

export type NotificationChannelUpdateInput = {
  bccAdminOnMessage?: InputMaybe<Scalars['Json']['input']>;
  mutedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutedMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannelUpdatemutedCategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannelUpdatemutedMessagesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationChannelUpsertInput = {
  set: NotificationChannelCreateInput;
  update: NotificationChannelUpdateInput;
};

export type NotificationChannelWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NotificationChannelWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NotificationChannelWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationChannelWhereInput>>>;
  bccAdminOnMessage?: InputMaybe<JsonNullableFilter>;
  mutedCategories?: InputMaybe<StringNullableListFilter>;
  mutedMessages?: InputMaybe<StringNullableListFilter>;
};

/** Message Metadata */
export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  category: Scalars['String']['output'];
  channel?: Maybe<NotificationChannelType>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unignorable?: Maybe<Scalars['Boolean']['output']>;
};

/** Message Category Metadata */
export type NotificationMessageCategory = {
  __typename?: 'NotificationMessageCategory';
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationMetadata = {
  __typename?: 'NotificationMetadata';
  categories: Array<Maybe<NotificationMessageCategory>>;
  messages: Array<Maybe<NotificationMessage>>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  email?: Maybe<NotificationChannel>;
  slack?: Maybe<NotificationChannel>;
  sms?: Maybe<NotificationChannel>;
};

export type NotificationSettingsCreateInput = {
  email?: InputMaybe<NotificationChannelCreateInput>;
  slack?: InputMaybe<NotificationChannelCreateInput>;
  sms?: InputMaybe<NotificationChannelCreateInput>;
};

export type NotificationSettingsNullableCompositeFilter = {
  equals?: InputMaybe<NotificationSettingsObjectEqualityInput>;
  is?: InputMaybe<NotificationSettingsWhereInput>;
  isNot?: InputMaybe<NotificationSettingsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationSettingsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<NotificationSettingsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<NotificationSettingsUpsertInput>;
};

export type NotificationSettingsObjectEqualityInput = {
  email?: InputMaybe<NotificationChannelObjectEqualityInput>;
  slack?: InputMaybe<NotificationChannelObjectEqualityInput>;
  sms?: InputMaybe<NotificationChannelObjectEqualityInput>;
};

export type NotificationSettingsOrderByInput = {
  email?: InputMaybe<NotificationChannelOrderByInput>;
  slack?: InputMaybe<NotificationChannelOrderByInput>;
  sms?: InputMaybe<NotificationChannelOrderByInput>;
};

export type NotificationSettingsUpdateInput = {
  email?: InputMaybe<NotificationChannelNullableUpdateEnvelopeInput>;
  slack?: InputMaybe<NotificationChannelNullableUpdateEnvelopeInput>;
  sms?: InputMaybe<NotificationChannelNullableUpdateEnvelopeInput>;
};

export type NotificationSettingsUpsertInput = {
  set: NotificationSettingsCreateInput;
  update: NotificationSettingsUpdateInput;
};

export type NotificationSettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NotificationSettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NotificationSettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationSettingsWhereInput>>>;
  email?: InputMaybe<NotificationChannelNullableCompositeFilter>;
  slack?: InputMaybe<NotificationChannelNullableCompositeFilter>;
  sms?: InputMaybe<NotificationChannelNullableCompositeFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumAdapterProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<AdapterProvider>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumAffiliationBoardPositionFieldUpdateOperationsInput = {
  set?: InputMaybe<AffiliationBoardPosition>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumAffiliationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AffiliationType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumBadgeCriteriaEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BadgeCriteriaEntityType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumCommunityEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CommunityEntityType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDeductionTransferModeFieldUpdateOperationsInput = {
  set?: InputMaybe<DeductionTransferMode>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDeedStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DeedStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonationPayrollPaymentOptionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationPayrollPaymentOptionStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonationPrivacyFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationPrivacy>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonationScheduleStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationScheduleStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonationSubtypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationSubtype>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DonationType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumDonorPrivacyFieldUpdateOperationsInput = {
  set?: InputMaybe<DonorPrivacy>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumEncryptionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<EncryptionType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumExternalDashboardScopeFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalDashboardScope>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumExternalDonationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ExternalDonationType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumFailedPayrollRunDeductionStatusOverridesFieldUpdateOperationsInput = {
  set?: InputMaybe<FailedPayrollRunDeductionStatusOverrides>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumFeeCoveredByFieldUpdateOperationsInput = {
  set?: InputMaybe<FeeCoveredBy>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumFlatFileTemplateFieldUpdateOperationsInput = {
  set?: InputMaybe<FlatFileTemplate>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumMatchRequestStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<MatchRequestStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NonprofitEntityType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumNonprofitIdentifierTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NonprofitIdentifierType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumOpportunityProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<OpportunityProvider>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPayPalVerificationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PayPalVerificationStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPaymentMethodTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentMethodType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPayrollFlatFileFileExtensionFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollFlatFileFileExtension>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPayrollProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollProvider>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPayrollRunDeductionFrequencyFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollRunDeductionFrequency>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumPayrollRunTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PayrollRunType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumRoleCodeFieldUpdateOperationsInput = {
  set?: InputMaybe<RoleCode>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumRoleGrantSourceFieldUpdateOperationsInput = {
  set?: InputMaybe<RoleGrantSource>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumTimeOffStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TimeOffStatus>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumTransactionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TransactionType>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumUnresolvedPayrollRunDeductionStatusOverridesFieldUpdateOperationsInput = {
  set?: InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableEnumVerificationStatusesFieldUpdateOperationsInput = {
  set?: InputMaybe<VerificationStatuses>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OauthCredential = {
  __typename?: 'OauthCredential';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type OauthCredentialCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type OauthCredentialNullableCompositeFilter = {
  equals?: InputMaybe<OauthCredentialObjectEqualityInput>;
  is?: InputMaybe<OauthCredentialWhereInput>;
  isNot?: InputMaybe<OauthCredentialWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OauthCredentialNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OauthCredentialCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OauthCredentialUpsertInput>;
};

export type OauthCredentialObjectEqualityInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type OauthCredentialUpdateInput = {
  clientId?: InputMaybe<StringFieldUpdateOperationsInput>;
  clientSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OauthCredentialUpsertInput = {
  set: OauthCredentialCreateInput;
  update: OauthCredentialUpdateInput;
};

export type OauthCredentialWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OauthCredentialWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OauthCredentialWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OauthCredentialWhereInput>>>;
  clientId?: InputMaybe<StringFilter>;
  clientSecret?: InputMaybe<StringFilter>;
  refreshToken?: InputMaybe<StringFilter>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  categories: Array<Scalars['String']['output']>;
  content: OpportunityContentMap;
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<LocationObject>;
  nonprofit?: Maybe<OpportunityNonprofit>;
  participantsLimit?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  providerIds: OpportunityProviderIds;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  sdgs: Array<Scalars['String']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type: OpportunityType;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export enum OpportunityAttendence {
  InPerson = 'InPerson',
  Virtual = 'Virtual'
}

export type OpportunityAvgAggregateOutputType = {
  __typename?: 'OpportunityAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']['output']>;
  participantsLimit?: Maybe<Scalars['Float']['output']>;
};

export type OpportunityAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
};

export type OpportunityContact = {
  __typename?: 'OpportunityContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type OpportunityContactCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityContactNullableCompositeFilter = {
  equals?: InputMaybe<OpportunityContactObjectEqualityInput>;
  is?: InputMaybe<OpportunityContactWhereInput>;
  isNot?: InputMaybe<OpportunityContactWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityContactNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OpportunityContactCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OpportunityContactUpsertInput>;
};

export type OpportunityContactObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityContactOrderByInput = {
  email?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
};

export type OpportunityContactUpdateInput = {
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OpportunityContactUpsertInput = {
  set: OpportunityContactCreateInput;
  update: OpportunityContactUpdateInput;
};

export type OpportunityContactWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityContactWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityContactWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityContactWhereInput>>>;
  email?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
};

export type OpportunityContent = {
  __typename?: 'OpportunityContent';
  contact?: Maybe<OpportunityContact>;
  description?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  mustKnows?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictures: Array<Scalars['String']['output']>;
};

export type OpportunityContentCreateInput = {
  contact?: InputMaybe<OpportunityContactCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityContentCreatepicturesInput = {
  set: Scalars['String']['input'];
};

export type OpportunityContentMap = {
  __typename?: 'OpportunityContentMap';
  Betterplace?: Maybe<OpportunityContent>;
  Catchafire?: Maybe<OpportunityContent>;
  GlobalGiving?: Maybe<OpportunityContent>;
  Goodera?: Maybe<OpportunityContent>;
  Idealist?: Maybe<OpportunityContent>;
  PointsOfLight?: Maybe<OpportunityContent>;
  VolunteerGov?: Maybe<OpportunityContent>;
  VolunteerMatch?: Maybe<OpportunityContent>;
};

export type OpportunityContentMapCompositeFilter = {
  equals?: InputMaybe<OpportunityContentMapObjectEqualityInput>;
  is?: InputMaybe<OpportunityContentMapWhereInput>;
  isNot?: InputMaybe<OpportunityContentMapWhereInput>;
};

export type OpportunityContentMapCreateEnvelopeInput = {
  set?: InputMaybe<OpportunityContentMapCreateInput>;
};

export type OpportunityContentMapCreateInput = {
  Betterplace?: InputMaybe<OpportunityContentCreateInput>;
  Catchafire?: InputMaybe<OpportunityContentCreateInput>;
  GlobalGiving?: InputMaybe<OpportunityContentCreateInput>;
  Goodera?: InputMaybe<OpportunityContentCreateInput>;
  Idealist?: InputMaybe<OpportunityContentCreateInput>;
  PointsOfLight?: InputMaybe<OpportunityContentCreateInput>;
  VolunteerGov?: InputMaybe<OpportunityContentCreateInput>;
  VolunteerMatch?: InputMaybe<OpportunityContentCreateInput>;
};

export type OpportunityContentMapObjectEqualityInput = {
  Betterplace?: InputMaybe<OpportunityContentObjectEqualityInput>;
  Catchafire?: InputMaybe<OpportunityContentObjectEqualityInput>;
  GlobalGiving?: InputMaybe<OpportunityContentObjectEqualityInput>;
  Goodera?: InputMaybe<OpportunityContentObjectEqualityInput>;
  Idealist?: InputMaybe<OpportunityContentObjectEqualityInput>;
  PointsOfLight?: InputMaybe<OpportunityContentObjectEqualityInput>;
  VolunteerGov?: InputMaybe<OpportunityContentObjectEqualityInput>;
  VolunteerMatch?: InputMaybe<OpportunityContentObjectEqualityInput>;
};

export type OpportunityContentMapOrderByInput = {
  Betterplace?: InputMaybe<OpportunityContentOrderByInput>;
  Catchafire?: InputMaybe<OpportunityContentOrderByInput>;
  GlobalGiving?: InputMaybe<OpportunityContentOrderByInput>;
  Goodera?: InputMaybe<OpportunityContentOrderByInput>;
  Idealist?: InputMaybe<OpportunityContentOrderByInput>;
  PointsOfLight?: InputMaybe<OpportunityContentOrderByInput>;
  VolunteerGov?: InputMaybe<OpportunityContentOrderByInput>;
  VolunteerMatch?: InputMaybe<OpportunityContentOrderByInput>;
};

export type OpportunityContentMapUpdateEnvelopeInput = {
  set?: InputMaybe<OpportunityContentMapCreateInput>;
  update?: InputMaybe<OpportunityContentMapUpdateInput>;
};

export type OpportunityContentMapUpdateInput = {
  Betterplace?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  Catchafire?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  GlobalGiving?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  Goodera?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  Idealist?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  PointsOfLight?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  VolunteerGov?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
  VolunteerMatch?: InputMaybe<OpportunityContentNullableUpdateEnvelopeInput>;
};

export type OpportunityContentMapWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityContentMapWhereInput>>>;
  Betterplace?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  Catchafire?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  GlobalGiving?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  Goodera?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  Idealist?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityContentMapWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityContentMapWhereInput>>>;
  PointsOfLight?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  VolunteerGov?: InputMaybe<OpportunityContentNullableCompositeFilter>;
  VolunteerMatch?: InputMaybe<OpportunityContentNullableCompositeFilter>;
};

export type OpportunityContentNullableCompositeFilter = {
  equals?: InputMaybe<OpportunityContentObjectEqualityInput>;
  is?: InputMaybe<OpportunityContentWhereInput>;
  isNot?: InputMaybe<OpportunityContentWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityContentNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OpportunityContentCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OpportunityContentUpsertInput>;
};

export type OpportunityContentObjectEqualityInput = {
  contact?: InputMaybe<OpportunityContactObjectEqualityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  mustKnows?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityContentOrderByInput = {
  contact?: InputMaybe<OpportunityContactOrderByInput>;
  description?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  mustKnows?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
};

export type OpportunityContentUpdateInput = {
  contact?: InputMaybe<OpportunityContactNullableUpdateEnvelopeInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mustKnows?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityContentUpdatepicturesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityContentUpsertInput = {
  set: OpportunityContentCreateInput;
  update: OpportunityContentUpdateInput;
};

export type OpportunityContentWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityContentWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityContentWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityContentWhereInput>>>;
  contact?: InputMaybe<OpportunityContactNullableCompositeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  externalLink?: InputMaybe<StringNullableFilter>;
  mustKnows?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
};

export type OpportunityCountAggregateOutputType = {
  __typename?: 'OpportunityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  categories: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  participantsLimit: Scalars['Int']['output'];
  partner: Scalars['Int']['output'];
  registrationEndingAt: Scalars['Int']['output'];
  sdgs: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  syncedAt: Scalars['Int']['output'];
  timeZone: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  virtual: Scalars['Int']['output'];
};

export type OpportunityCountOrderByAggregateInput = {
  categories?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
  partner?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  syncedAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export type OpportunityCreateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: OpportunityContentMapCreateEnvelopeInput;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableCreateEnvelopeInput>;
  participantsLimit?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  providerIds: OpportunityProviderIdsCreateEnvelopeInput;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: OpportunityType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityCreateManyInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: OpportunityContentMapCreateEnvelopeInput;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableCreateEnvelopeInput>;
  participantsLimit?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  providerIds: OpportunityProviderIdsCreateEnvelopeInput;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: OpportunityType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type OpportunityCreatesdgsInput = {
  set: Scalars['String']['input'];
};

export type OpportunityMaxAggregateOutputType = {
  __typename?: 'OpportunityMaxAggregateOutputType';
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participantsLimit?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export type OpportunityMaxOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
  partner?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  syncedAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export type OpportunityMinAggregateOutputType = {
  __typename?: 'OpportunityMinAggregateOutputType';
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participantsLimit?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export type OpportunityMinOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
  partner?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  syncedAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export type OpportunityNonprofit = {
  __typename?: 'OpportunityNonprofit';
  categories: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationObject>;
  mission?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pictures: Array<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  sdgs: Array<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OpportunityNonprofitCreateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectCreateInput>;
  mission?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId: Scalars['String']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityNonprofitCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type OpportunityNonprofitCreatepicturesInput = {
  set: Scalars['String']['input'];
};

export type OpportunityNonprofitCreatesdgsInput = {
  set: Scalars['String']['input'];
};

export type OpportunityNonprofitNullableCompositeFilter = {
  equals?: InputMaybe<OpportunityNonprofitObjectEqualityInput>;
  is?: InputMaybe<OpportunityNonprofitWhereInput>;
  isNot?: InputMaybe<OpportunityNonprofitWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityNonprofitNullableCreateEnvelopeInput = {
  set?: InputMaybe<OpportunityNonprofitCreateInput>;
};

export type OpportunityNonprofitNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OpportunityNonprofitCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OpportunityNonprofitUpsertInput>;
};

export type OpportunityNonprofitObjectEqualityInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectObjectEqualityInput>;
  mission?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId: Scalars['String']['input'];
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityNonprofitOrderByInput = {
  categories?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationObjectOrderByInput>;
  mission?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type OpportunityNonprofitUpdateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  mission?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OpportunityNonprofitUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityNonprofitUpdatepicturesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityNonprofitUpdatesdgsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityNonprofitUpsertInput = {
  set: OpportunityNonprofitCreateInput;
  update: OpportunityNonprofitUpdateInput;
};

export type OpportunityNonprofitWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityNonprofitWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityNonprofitWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityNonprofitWhereInput>>>;
  categories?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationObjectNullableCompositeFilter>;
  mission?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  providerId?: InputMaybe<StringFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type OpportunityOrderByWithAggregationInput = {
  _avg?: InputMaybe<OpportunityAvgOrderByAggregateInput>;
  _count?: InputMaybe<OpportunityCountOrderByAggregateInput>;
  _max?: InputMaybe<OpportunityMaxOrderByAggregateInput>;
  _min?: InputMaybe<OpportunityMinOrderByAggregateInput>;
  _sum?: InputMaybe<OpportunitySumOrderByAggregateInput>;
  categories?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
  partner?: InputMaybe<SortOrder>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  syncedAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export type OpportunityOrderByWithRelationInput = {
  categories?: InputMaybe<SortOrder>;
  content?: InputMaybe<OpportunityContentMapOrderByInput>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationObjectOrderByInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitOrderByInput>;
  participantsLimit?: InputMaybe<SortOrder>;
  partner?: InputMaybe<SortOrder>;
  providerIds?: InputMaybe<OpportunityProviderIdsOrderByInput>;
  registrationEndingAt?: InputMaybe<SortOrder>;
  sdgs?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  syncedAt?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  virtual?: InputMaybe<SortOrder>;
};

export enum OpportunityProvider {
  Betterplace = 'Betterplace',
  Catchafire = 'Catchafire',
  GlobalGiving = 'GlobalGiving',
  Goodera = 'Goodera',
  Idealist = 'Idealist',
  PointsOfLight = 'PointsOfLight',
  SurveyMonkey = 'SurveyMonkey',
  VolunteerGov = 'VolunteerGov',
  VolunteerMatch = 'VolunteerMatch'
}

export type OpportunityProviderIds = {
  __typename?: 'OpportunityProviderIds';
  Betterplace?: Maybe<Scalars['String']['output']>;
  Catchafire?: Maybe<Scalars['String']['output']>;
  GlobalGiving?: Maybe<Scalars['String']['output']>;
  Goodera?: Maybe<Scalars['String']['output']>;
  Idealist?: Maybe<Scalars['String']['output']>;
  PointsOfLight?: Maybe<Scalars['String']['output']>;
  SurveyMonkey?: Maybe<Scalars['String']['output']>;
  VolunteerGov?: Maybe<Scalars['String']['output']>;
  VolunteerMatch?: Maybe<Scalars['String']['output']>;
};

export type OpportunityProviderIdsCompositeFilter = {
  equals?: InputMaybe<OpportunityProviderIdsObjectEqualityInput>;
  is?: InputMaybe<OpportunityProviderIdsWhereInput>;
  isNot?: InputMaybe<OpportunityProviderIdsWhereInput>;
};

export type OpportunityProviderIdsCreateEnvelopeInput = {
  set?: InputMaybe<OpportunityProviderIdsCreateInput>;
};

export type OpportunityProviderIdsCreateInput = {
  Betterplace?: InputMaybe<Scalars['String']['input']>;
  Catchafire?: InputMaybe<Scalars['String']['input']>;
  GlobalGiving?: InputMaybe<Scalars['String']['input']>;
  Goodera?: InputMaybe<Scalars['String']['input']>;
  Idealist?: InputMaybe<Scalars['String']['input']>;
  PointsOfLight?: InputMaybe<Scalars['String']['input']>;
  SurveyMonkey?: InputMaybe<Scalars['String']['input']>;
  VolunteerGov?: InputMaybe<Scalars['String']['input']>;
  VolunteerMatch?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityProviderIdsObjectEqualityInput = {
  Betterplace?: InputMaybe<Scalars['String']['input']>;
  Catchafire?: InputMaybe<Scalars['String']['input']>;
  GlobalGiving?: InputMaybe<Scalars['String']['input']>;
  Goodera?: InputMaybe<Scalars['String']['input']>;
  Idealist?: InputMaybe<Scalars['String']['input']>;
  PointsOfLight?: InputMaybe<Scalars['String']['input']>;
  SurveyMonkey?: InputMaybe<Scalars['String']['input']>;
  VolunteerGov?: InputMaybe<Scalars['String']['input']>;
  VolunteerMatch?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityProviderIdsOrderByInput = {
  Betterplace?: InputMaybe<SortOrder>;
  Catchafire?: InputMaybe<SortOrder>;
  GlobalGiving?: InputMaybe<SortOrder>;
  Goodera?: InputMaybe<SortOrder>;
  Idealist?: InputMaybe<SortOrder>;
  PointsOfLight?: InputMaybe<SortOrder>;
  SurveyMonkey?: InputMaybe<SortOrder>;
  VolunteerGov?: InputMaybe<SortOrder>;
  VolunteerMatch?: InputMaybe<SortOrder>;
};

export type OpportunityProviderIdsUpdateEnvelopeInput = {
  set?: InputMaybe<OpportunityProviderIdsCreateInput>;
  update?: InputMaybe<OpportunityProviderIdsUpdateInput>;
};

export type OpportunityProviderIdsUpdateInput = {
  Betterplace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Catchafire?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  GlobalGiving?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Goodera?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Idealist?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  PointsOfLight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  SurveyMonkey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  VolunteerGov?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  VolunteerMatch?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OpportunityProviderIdsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityProviderIdsWhereInput>>>;
  Betterplace?: InputMaybe<StringNullableFilter>;
  Catchafire?: InputMaybe<StringNullableFilter>;
  GlobalGiving?: InputMaybe<StringNullableFilter>;
  Goodera?: InputMaybe<StringNullableFilter>;
  Idealist?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityProviderIdsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityProviderIdsWhereInput>>>;
  PointsOfLight?: InputMaybe<StringNullableFilter>;
  SurveyMonkey?: InputMaybe<StringNullableFilter>;
  VolunteerGov?: InputMaybe<StringNullableFilter>;
  VolunteerMatch?: InputMaybe<StringNullableFilter>;
};

export enum OpportunityScalarFieldEnum {
  Categories = 'categories',
  Duration = 'duration',
  EndingAt = 'endingAt',
  Id = 'id',
  ParticipantsLimit = 'participantsLimit',
  Partner = 'partner',
  RegistrationEndingAt = 'registrationEndingAt',
  Sdgs = 'sdgs',
  StartingAt = 'startingAt',
  SyncedAt = 'syncedAt',
  TimeZone = 'timeZone',
  Type = 'type',
  Virtual = 'virtual'
}

export type OpportunityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityScalarWhereWithAggregatesInput>>>;
  categories?: InputMaybe<StringNullableListFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  participantsLimit?: InputMaybe<IntNullableWithAggregatesFilter>;
  partner?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  syncedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  timeZone?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumOpportunityTypeWithAggregatesFilter>;
  virtual?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export type OpportunitySumAggregateOutputType = {
  __typename?: 'OpportunitySumAggregateOutputType';
  duration?: Maybe<Scalars['Int']['output']>;
  participantsLimit?: Maybe<Scalars['Int']['output']>;
};

export type OpportunitySumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  participantsLimit?: InputMaybe<SortOrder>;
};

export enum OpportunityType {
  Event = 'Event',
  Project = 'Project'
}

export type OpportunityUncheckedCreateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: OpportunityContentMapCreateEnvelopeInput;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableCreateEnvelopeInput>;
  participantsLimit?: InputMaybe<Scalars['Int']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  providerIds: OpportunityProviderIdsCreateEnvelopeInput;
  registrationEndingAt?: InputMaybe<Scalars['DateTime']['input']>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: OpportunityType;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityUncheckedUpdateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<OpportunityContentMapUpdateEnvelopeInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableUpdateEnvelopeInput>;
  participantsLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  partner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerIds?: InputMaybe<OpportunityProviderIdsUpdateEnvelopeInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOpportunityTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OpportunityUncheckedUpdateManyInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<OpportunityContentMapUpdateEnvelopeInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableUpdateEnvelopeInput>;
  participantsLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  partner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerIds?: InputMaybe<OpportunityProviderIdsUpdateEnvelopeInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOpportunityTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OpportunityUpdateInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<OpportunityContentMapUpdateEnvelopeInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableUpdateEnvelopeInput>;
  participantsLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  partner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerIds?: InputMaybe<OpportunityProviderIdsUpdateEnvelopeInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOpportunityTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OpportunityUpdateManyMutationInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content?: InputMaybe<OpportunityContentMapUpdateEnvelopeInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableUpdateEnvelopeInput>;
  participantsLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  partner?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerIds?: InputMaybe<OpportunityProviderIdsUpdateEnvelopeInput>;
  registrationEndingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOpportunityTypeFieldUpdateOperationsInput>;
  virtual?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type OpportunityUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityUpdatesdgsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OpportunityWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<OpportunityContentMapCompositeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationObjectNullableCompositeFilter>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableCompositeFilter>;
  participantsLimit?: InputMaybe<IntNullableFilter>;
  partner?: InputMaybe<StringNullableFilter>;
  providerIds?: InputMaybe<OpportunityProviderIdsCompositeFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  syncedAt?: InputMaybe<DateTimeNullableFilter>;
  timeZone?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumOpportunityTypeFilter>;
  virtual?: InputMaybe<BoolNullableFilter>;
};

export type OpportunityWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OpportunityWhereInput>>>;
  categories?: InputMaybe<StringNullableListFilter>;
  content?: InputMaybe<OpportunityContentMapCompositeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationObjectNullableCompositeFilter>;
  nonprofit?: InputMaybe<OpportunityNonprofitNullableCompositeFilter>;
  participantsLimit?: InputMaybe<IntNullableFilter>;
  partner?: InputMaybe<StringNullableFilter>;
  providerIds?: InputMaybe<OpportunityProviderIdsCompositeFilter>;
  registrationEndingAt?: InputMaybe<DateTimeNullableFilter>;
  sdgs?: InputMaybe<StringNullableListFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  syncedAt?: InputMaybe<DateTimeNullableFilter>;
  timeZone?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumOpportunityTypeFilter>;
  virtual?: InputMaybe<BoolNullableFilter>;
};

/** List org nonprofits */
export type OrgNonprofit = {
  __typename?: 'OrgNonprofit';
  results?: Maybe<Array<Maybe<ExtendedDeedNonprofit>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  CompanyPartners: Array<Partner>;
  CorporatePrograms: Array<CorporateProgram>;
  ERGs: Array<Scalars['String']['output']>;
  NonprofitNominationsForExistingOrg: Array<NonprofitNomination>;
  NonprofitPartners: Array<Partner>;
  PointOfContact?: Maybe<BaseUser>;
  SDGs: Array<Scalars['String']['output']>;
  UserNotification: Array<UserNotification>;
  _count: OrganizationCountOutputType;
  acceptsDonations?: Maybe<Scalars['Boolean']['output']>;
  appVanityDomain?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  badgeCertificateHeaderImage?: Maybe<Scalars['String']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  disclaimers: Array<Disclaimer>;
  donateViaNonprofitId?: Maybe<Scalars['String']['output']>;
  donationProviders?: Maybe<DonationProviders>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifiers: Array<NonprofitIdentifierEntry>;
  legalName?: Maybe<Scalars['String']['output']>;
  locationMap?: Maybe<Scalars['Json']['output']>;
  locationObject?: Maybe<LocationObject>;
  logo?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parentNonprofitId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pictures: Array<Scalars['String']['output']>;
  pillars: Array<Scalars['String']['output']>;
  pointOfContactId?: Maybe<Scalars['String']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  type: OrganizationType;
  verificationStatus?: Maybe<VerificationStatuses>;
  verificationStatusSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationCompanyPartnersArgs = {
  cursor?: InputMaybe<PartnerWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<PartnerScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<PartnerOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerWhereInput>;
};


export type OrganizationCorporateProgramsArgs = {
  cursor?: InputMaybe<CorporateProgramWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CorporateProgramScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CorporateProgramOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorporateProgramWhereInput>;
};


export type OrganizationNonprofitNominationsForExistingOrgArgs = {
  cursor?: InputMaybe<NonprofitNominationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<NonprofitNominationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<NonprofitNominationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NonprofitNominationWhereInput>;
};


export type OrganizationNonprofitPartnersArgs = {
  cursor?: InputMaybe<PartnerWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<PartnerScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<PartnerOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartnerWhereInput>;
};


export type OrganizationPointOfContactArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};


export type OrganizationUserNotificationArgs = {
  cursor?: InputMaybe<UserNotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UserNotificationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<UserNotificationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserNotificationWhereInput>;
};

export type OrganizationCountAggregateOutputType = {
  __typename?: 'OrganizationCountAggregateOutputType';
  ERGs: Scalars['Int']['output'];
  SDGs: Scalars['Int']['output'];
  _all: Scalars['Int']['output'];
  acceptsDonations: Scalars['Int']['output'];
  actionNonprofitIds: Scalars['Int']['output'];
  actionOrganizationIds: Scalars['Int']['output'];
  actionTemplateOrganizationIds: Scalars['Int']['output'];
  activityOrganizationIds: Scalars['Int']['output'];
  appVanityDomain: Scalars['Int']['output'];
  approved: Scalars['Int']['output'];
  badgeCertificateHeaderImage: Scalars['Int']['output'];
  brandColor: Scalars['Int']['output'];
  brief: Scalars['Int']['output'];
  campaignOrganizationIds: Scalars['Int']['output'];
  categories: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  communityCompanyIds: Scalars['Int']['output'];
  communityNonprofitIds: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currencyCode: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  donateViaNonprofitId: Scalars['Int']['output'];
  donationSchedulesNonprofits: Scalars['Int']['output'];
  donationSchedulesPayeeNonprofits: Scalars['Int']['output'];
  donationsReceivedIds: Scalars['Int']['output'];
  donationsReceivedPayeeIds: Scalars['Int']['output'];
  ein: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emailSenderName: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invisible: Scalars['Int']['output'];
  legalName: Scalars['Int']['output'];
  locationMap: Scalars['Int']['output'];
  logo: Scalars['Int']['output'];
  mainPicture: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nonprofitDeedIds: Scalars['Int']['output'];
  nonprofitEntityType: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  optedInCampaignIds: Scalars['Int']['output'];
  optedInDeedIds: Scalars['Int']['output'];
  origin: Scalars['Int']['output'];
  parentId: Scalars['Int']['output'];
  parentNonprofitId: Scalars['Int']['output'];
  payPalModel: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  pictures: Scalars['Int']['output'];
  pillars: Scalars['Int']['output'];
  pointOfContactId: Scalars['Int']['output'];
  sharedWithCompanyIds: Scalars['Int']['output'];
  tagLine: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  verificationStatus: Scalars['Int']['output'];
  verificationStatusSyncedAt: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type OrganizationCountOrderByAggregateInput = {
  ERGs?: InputMaybe<SortOrder>;
  SDGs?: InputMaybe<SortOrder>;
  acceptsDonations?: InputMaybe<SortOrder>;
  actionNonprofitIds?: InputMaybe<SortOrder>;
  actionOrganizationIds?: InputMaybe<SortOrder>;
  actionTemplateOrganizationIds?: InputMaybe<SortOrder>;
  activityOrganizationIds?: InputMaybe<SortOrder>;
  appVanityDomain?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  badgeCertificateHeaderImage?: InputMaybe<SortOrder>;
  brandColor?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  campaignOrganizationIds?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityCompanyIds?: InputMaybe<SortOrder>;
  communityNonprofitIds?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  donateViaNonprofitId?: InputMaybe<SortOrder>;
  donationSchedulesNonprofits?: InputMaybe<SortOrder>;
  donationSchedulesPayeeNonprofits?: InputMaybe<SortOrder>;
  donationsReceivedIds?: InputMaybe<SortOrder>;
  donationsReceivedPayeeIds?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailSenderName?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invisible?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  locationMap?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDeedIds?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  optedInCampaignIds?: InputMaybe<SortOrder>;
  optedInDeedIds?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentNonprofitId?: InputMaybe<SortOrder>;
  payPalModel?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  pointOfContactId?: InputMaybe<SortOrder>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  tagLine?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type OrganizationCountOutputType = {
  __typename?: 'OrganizationCountOutputType';
  ActionOrganizations: Scalars['Int']['output'];
  ActionTemplateOrganizations: Scalars['Int']['output'];
  Actions: Scalars['Int']['output'];
  ActivityOrganizations: Scalars['Int']['output'];
  AwardedBadge: Scalars['Int']['output'];
  Badges: Scalars['Int']['output'];
  CampaignOrganizations: Scalars['Int']['output'];
  ChallengeContributionGroups: Scalars['Int']['output'];
  Challenges: Scalars['Int']['output'];
  CommunityCompanies: Scalars['Int']['output'];
  CommunityNonprofits: Scalars['Int']['output'];
  CompanyAffiliation: Scalars['Int']['output'];
  CompanyPartners: Scalars['Int']['output'];
  CompanyVolunteerTimeOffs: Scalars['Int']['output'];
  CompanyVolunteerTimes: Scalars['Int']['output'];
  CorporatePrograms: Scalars['Int']['output'];
  DonationSchedulesCompanies: Scalars['Int']['output'];
  DonationSchedulesNonprofits: Scalars['Int']['output'];
  DonationSchedulesPayeeNonprofits: Scalars['Int']['output'];
  Donations: Scalars['Int']['output'];
  DonationsReceived: Scalars['Int']['output'];
  DonationsReceivedPayee: Scalars['Int']['output'];
  Forms: Scalars['Int']['output'];
  GivingAccounts: Scalars['Int']['output'];
  NonProfitAffiliation: Scalars['Int']['output'];
  Nonprofit: Scalars['Int']['output'];
  NonprofitDeeds: Scalars['Int']['output'];
  NonprofitNominationsForCompany: Scalars['Int']['output'];
  NonprofitNominationsForExistingOrg: Scalars['Int']['output'];
  NonprofitNominationsForNonprofit: Scalars['Int']['output'];
  NonprofitPartners: Scalars['Int']['output'];
  NonprofitVolunteerRewards: Scalars['Int']['output'];
  NonprofitVolunteerTimeOffs: Scalars['Int']['output'];
  NonprofitVolunteerTimes: Scalars['Int']['output'];
  OptedInCampaigns: Scalars['Int']['output'];
  OptedInDeeds: Scalars['Int']['output'];
  OrganizationDeeds: Scalars['Int']['output'];
  PartnerDeeds: Scalars['Int']['output'];
  PayrollRunFlatFile: Scalars['Int']['output'];
  PayrollRunRollupConfiguration: Scalars['Int']['output'];
  Receipt: Scalars['Int']['output'];
  SharedWithCompanies: Scalars['Int']['output'];
  SigmaDashboard: Scalars['Int']['output'];
  SigmaReport: Scalars['Int']['output'];
  UserNotification: Scalars['Int']['output'];
  Users: Scalars['Int']['output'];
  VolunteerRewardBudgetAllocation: Scalars['Int']['output'];
  VolunteerRewards: Scalars['Int']['output'];
  VolunteerTimeOffSummary: Scalars['Int']['output'];
};

export type OrganizationCreateErGsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateManyInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateNestedManyWithoutCommunityNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutCommunityNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutCommunityNonprofitsInput>>>;
};

export type OrganizationCreateNestedManyWithoutDonationSchedulesNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesNonprofitsInput>>>;
};

export type OrganizationCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput>>>;
};

export type OrganizationCreateNestedManyWithoutDonationsReceivedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedInput>>>;
};

export type OrganizationCreateNestedManyWithoutDonationsReceivedPayeeInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedPayeeInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedPayeeInput>>>;
};

export type OrganizationCreateNestedManyWithoutNonprofitDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutNonprofitDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutNonprofitDeedsInput>>>;
};

export type OrganizationCreateNestedManyWithoutOptedInCampaignsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInCampaignsInput>>>;
};

export type OrganizationCreateNestedManyWithoutOptedInDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInDeedsInput>>>;
};

export type OrganizationCreateNestedManyWithoutSharedWithCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutSharedWithCompaniesInput>>>;
};

export type OrganizationCreateNestedOneWithoutActionOrganizationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionOrganizationsInput>;
};

export type OrganizationCreateNestedOneWithoutActionTemplateOrganizationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionTemplateOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionTemplateOrganizationsInput>;
};

export type OrganizationCreateNestedOneWithoutActionsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionsInput>;
};

export type OrganizationCreateNestedOneWithoutActivityOrganizationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActivityOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActivityOrganizationsInput>;
};

export type OrganizationCreateNestedOneWithoutAwardedBadgeInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<OrganizationCreateWithoutAwardedBadgeInput>;
};

export type OrganizationCreateNestedOneWithoutBadgesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBadgesInput>;
  create?: InputMaybe<OrganizationCreateWithoutBadgesInput>;
};

export type OrganizationCreateNestedOneWithoutCampaignOrganizationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCampaignOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCampaignOrganizationsInput>;
};

export type OrganizationCreateNestedOneWithoutChallengeContributionGroupsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutChallengeContributionGroupsInput>;
  create?: InputMaybe<OrganizationCreateWithoutChallengeContributionGroupsInput>;
};

export type OrganizationCreateNestedOneWithoutChallengesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutChallengesInput>;
  create?: InputMaybe<OrganizationCreateWithoutChallengesInput>;
};

export type OrganizationCreateNestedOneWithoutCommunityCompaniesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCommunityCompaniesInput>;
  create?: InputMaybe<OrganizationCreateWithoutCommunityCompaniesInput>;
};

export type OrganizationCreateNestedOneWithoutCompanyAffiliationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyAffiliationInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyAffiliationInput>;
};

export type OrganizationCreateNestedOneWithoutCompanyPartnersInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyPartnersInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyPartnersInput>;
};

export type OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyVolunteerTimeOffsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyVolunteerTimeOffsInput>;
};

export type OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyVolunteerTimesInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyVolunteerTimesInput>;
};

export type OrganizationCreateNestedOneWithoutCorporateProgramsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCorporateProgramsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCorporateProgramsInput>;
};

export type OrganizationCreateNestedOneWithoutDonationSchedulesCompaniesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesCompaniesInput>;
  create?: InputMaybe<OrganizationCreateWithoutDonationSchedulesCompaniesInput>;
};

export type OrganizationCreateNestedOneWithoutDonationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutDonationsInput>;
};

export type OrganizationCreateNestedOneWithoutFormsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFormsInput>;
  create?: InputMaybe<OrganizationCreateWithoutFormsInput>;
};

export type OrganizationCreateNestedOneWithoutGivingAccountsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutGivingAccountsInput>;
  create?: InputMaybe<OrganizationCreateWithoutGivingAccountsInput>;
};

export type OrganizationCreateNestedOneWithoutNonProfitAffiliationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonProfitAffiliationInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonProfitAffiliationInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitNominationsForCompanyInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForCompanyInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForCompanyInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitNominationsForExistingOrgInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForExistingOrgInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForExistingOrgInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitNominationsForNonprofitInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForNonprofitInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForNonprofitInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitPartnersInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitPartnersInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitPartnersInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerRewardsInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerRewardsInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerTimeOffsInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerTimeOffsInput>;
};

export type OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerTimesInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerTimesInput>;
};

export type OrganizationCreateNestedOneWithoutOrganizationDeedsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationDeedsInput>;
  create?: InputMaybe<OrganizationCreateWithoutOrganizationDeedsInput>;
};

export type OrganizationCreateNestedOneWithoutPartnerDeedsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPartnerDeedsInput>;
  create?: InputMaybe<OrganizationCreateWithoutPartnerDeedsInput>;
};

export type OrganizationCreateNestedOneWithoutPayrollRunFlatFileInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayrollRunFlatFileInput>;
  create?: InputMaybe<OrganizationCreateWithoutPayrollRunFlatFileInput>;
};

export type OrganizationCreateNestedOneWithoutPayrollRunRollupConfigurationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayrollRunRollupConfigurationInput>;
  create?: InputMaybe<OrganizationCreateWithoutPayrollRunRollupConfigurationInput>;
};

export type OrganizationCreateNestedOneWithoutPointOfContactInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPointOfContactInput>;
  create?: InputMaybe<OrganizationCreateWithoutPointOfContactInput>;
};

export type OrganizationCreateNestedOneWithoutReceiptInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutReceiptInput>;
  create?: InputMaybe<OrganizationCreateWithoutReceiptInput>;
};

export type OrganizationCreateNestedOneWithoutSigmaDashboardInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSigmaDashboardInput>;
  create?: InputMaybe<OrganizationCreateWithoutSigmaDashboardInput>;
};

export type OrganizationCreateNestedOneWithoutSigmaReportInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSigmaReportInput>;
  create?: InputMaybe<OrganizationCreateWithoutSigmaReportInput>;
};

export type OrganizationCreateNestedOneWithoutUserNotificationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserNotificationInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserNotificationInput>;
};

export type OrganizationCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<OrganizationCreateWithoutUsersInput>;
};

export type OrganizationCreateNestedOneWithoutVolunteerRewardBudgetAllocationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerRewardBudgetAllocationInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerRewardBudgetAllocationInput>;
};

export type OrganizationCreateNestedOneWithoutVolunteerRewardsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerRewardsInput>;
};

export type OrganizationCreateNestedOneWithoutVolunteerTimeOffSummaryInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerTimeOffSummaryInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerTimeOffSummaryInput>;
};

export type OrganizationCreateOrConnectWithoutActionOrganizationsInput = {
  create: OrganizationCreateWithoutActionOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutActionTemplateOrganizationsInput = {
  create: OrganizationCreateWithoutActionTemplateOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutActionsInput = {
  create: OrganizationCreateWithoutActionsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutActivityOrganizationsInput = {
  create: OrganizationCreateWithoutActivityOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutAwardedBadgeInput = {
  create: OrganizationCreateWithoutAwardedBadgeInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutBadgesInput = {
  create: OrganizationCreateWithoutBadgesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCampaignOrganizationsInput = {
  create: OrganizationCreateWithoutCampaignOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutChallengeContributionGroupsInput = {
  create: OrganizationCreateWithoutChallengeContributionGroupsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutChallengesInput = {
  create: OrganizationCreateWithoutChallengesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCommunityCompaniesInput = {
  create: OrganizationCreateWithoutCommunityCompaniesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCommunityNonprofitsInput = {
  create: OrganizationCreateWithoutCommunityNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCompanyAffiliationInput = {
  create: OrganizationCreateWithoutCompanyAffiliationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCompanyPartnersInput = {
  create: OrganizationCreateWithoutCompanyPartnersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCompanyVolunteerTimeOffsInput = {
  create: OrganizationCreateWithoutCompanyVolunteerTimeOffsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCompanyVolunteerTimesInput = {
  create: OrganizationCreateWithoutCompanyVolunteerTimesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCorporateProgramsInput = {
  create: OrganizationCreateWithoutCorporateProgramsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationSchedulesCompaniesInput = {
  create: OrganizationCreateWithoutDonationSchedulesCompaniesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationSchedulesNonprofitsInput = {
  create: OrganizationCreateWithoutDonationSchedulesNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationSchedulesPayeeNonprofitsInput = {
  create: OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationsInput = {
  create: OrganizationCreateWithoutDonationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationsReceivedInput = {
  create: OrganizationCreateWithoutDonationsReceivedInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDonationsReceivedPayeeInput = {
  create: OrganizationCreateWithoutDonationsReceivedPayeeInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutFormsInput = {
  create: OrganizationCreateWithoutFormsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutGivingAccountsInput = {
  create: OrganizationCreateWithoutGivingAccountsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonProfitAffiliationInput = {
  create: OrganizationCreateWithoutNonProfitAffiliationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitDeedsInput = {
  create: OrganizationCreateWithoutNonprofitDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitInput = {
  create: OrganizationCreateWithoutNonprofitInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitNominationsForCompanyInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForCompanyInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitNominationsForExistingOrgInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForExistingOrgInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitNominationsForNonprofitInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForNonprofitInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitPartnersInput = {
  create: OrganizationCreateWithoutNonprofitPartnersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitVolunteerRewardsInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerRewardsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitVolunteerTimeOffsInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerTimeOffsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutNonprofitVolunteerTimesInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerTimesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOptedInCampaignsInput = {
  create: OrganizationCreateWithoutOptedInCampaignsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOptedInDeedsInput = {
  create: OrganizationCreateWithoutOptedInDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrganizationDeedsInput = {
  create: OrganizationCreateWithoutOrganizationDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPartnerDeedsInput = {
  create: OrganizationCreateWithoutPartnerDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPayrollRunFlatFileInput = {
  create: OrganizationCreateWithoutPayrollRunFlatFileInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPayrollRunRollupConfigurationInput = {
  create: OrganizationCreateWithoutPayrollRunRollupConfigurationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPointOfContactInput = {
  create: OrganizationCreateWithoutPointOfContactInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutReceiptInput = {
  create: OrganizationCreateWithoutReceiptInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSharedWithCompaniesInput = {
  create: OrganizationCreateWithoutSharedWithCompaniesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSigmaDashboardInput = {
  create: OrganizationCreateWithoutSigmaDashboardInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSigmaReportInput = {
  create: OrganizationCreateWithoutSigmaReportInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutUserNotificationInput = {
  create: OrganizationCreateWithoutUserNotificationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutUsersInput = {
  create: OrganizationCreateWithoutUsersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutVolunteerRewardBudgetAllocationInput = {
  create: OrganizationCreateWithoutVolunteerRewardBudgetAllocationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutVolunteerRewardsInput = {
  create: OrganizationCreateWithoutVolunteerRewardsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutVolunteerTimeOffSummaryInput = {
  create: OrganizationCreateWithoutVolunteerTimeOffSummaryInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateSdGsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateWithoutActionOrganizationsInput = {
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutActionTemplateOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutActionsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutActivityOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutAwardedBadgeInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutBadgesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCampaignOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutChallengeContributionGroupsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutChallengesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCommunityCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCommunityNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCompanyAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCompanyPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCompanyVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCompanyVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCorporateProgramsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationSchedulesCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationSchedulesNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationsReceivedInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDonationsReceivedPayeeInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutFormsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutGivingAccountsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonProfitAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitNominationsForCompanyInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitNominationsForExistingOrgInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitNominationsForNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutNonprofitVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOptedInCampaignsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOptedInDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOrganizationDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPartnerDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPayrollRunFlatFileInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPayrollRunRollupConfigurationInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPointOfContactInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutReceiptInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSharedWithCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSigmaDashboardInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSigmaReportInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutUserNotificationInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutUsersInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutVolunteerRewardBudgetAllocationInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutVolunteerTimeOffSummaryInput = {
  ActionOrganizations?: InputMaybe<ActionCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput>;
  PointOfContact?: InputMaybe<BaseUserCreateNestedOneWithoutPointOfContactOrganizationInput>;
  Receipt?: InputMaybe<ReceiptCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateactionNonprofitIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateactionOrganizationIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateactionTemplateOrganizationIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateactivityOrganizationIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatecampaignOrganizationIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatecategoriesInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatecommunityCompanyIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatecommunityNonprofitIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatedonationSchedulesNonprofitsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatedonationSchedulesPayeeNonprofitsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatedonationsReceivedIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatedonationsReceivedPayeeIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatenonprofitDeedIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateoptedInCampaignIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreateoptedInDeedIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatepicturesInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatepillarsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationCreatesharedWithCompanyIdsInput = {
  set: Scalars['String']['input'];
};

export type OrganizationDisbursmentMethods = {
  __typename?: 'OrganizationDisbursmentMethods';
  NFG?: Maybe<Scalars['String']['output']>;
};

export type OrganizationDisbursmentMethodsCreateInput = {
  NFG?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDisbursmentMethodsNullableCompositeFilter = {
  equals?: InputMaybe<OrganizationDisbursmentMethodsObjectEqualityInput>;
  is?: InputMaybe<OrganizationDisbursmentMethodsWhereInput>;
  isNot?: InputMaybe<OrganizationDisbursmentMethodsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationDisbursmentMethodsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OrganizationDisbursmentMethodsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OrganizationDisbursmentMethodsUpsertInput>;
};

export type OrganizationDisbursmentMethodsObjectEqualityInput = {
  NFG?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDisbursmentMethodsOrderByInput = {
  NFG?: InputMaybe<SortOrder>;
};

export type OrganizationDisbursmentMethodsUpdateInput = {
  NFG?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationDisbursmentMethodsUpsertInput = {
  set: OrganizationDisbursmentMethodsCreateInput;
  update: OrganizationDisbursmentMethodsUpdateInput;
};

export type OrganizationDisbursmentMethodsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationDisbursmentMethodsWhereInput>>>;
  NFG?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationDisbursmentMethodsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationDisbursmentMethodsWhereInput>>>;
};

export type OrganizationListRelationFilter = {
  every?: InputMaybe<OrganizationWhereInput>;
  none?: InputMaybe<OrganizationWhereInput>;
  some?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationMaxAggregateOutputType = {
  __typename?: 'OrganizationMaxAggregateOutputType';
  acceptsDonations?: Maybe<Scalars['Boolean']['output']>;
  appVanityDomain?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  badgeCertificateHeaderImage?: Maybe<Scalars['String']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  donateViaNonprofitId?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailSenderName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invisible?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentNonprofitId?: Maybe<Scalars['String']['output']>;
  payPalModel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pointOfContactId?: Maybe<Scalars['String']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganizationType>;
  verificationStatus?: Maybe<VerificationStatuses>;
  verificationStatusSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMaxOrderByAggregateInput = {
  acceptsDonations?: InputMaybe<SortOrder>;
  appVanityDomain?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  badgeCertificateHeaderImage?: InputMaybe<SortOrder>;
  brandColor?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  donateViaNonprofitId?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailSenderName?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invisible?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentNonprofitId?: InputMaybe<SortOrder>;
  payPalModel?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pointOfContactId?: InputMaybe<SortOrder>;
  tagLine?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type OrganizationMetadata = {
  __typename?: 'OrganizationMetadata';
  disbursementMethods?: Maybe<OrganizationDisbursmentMethods>;
  payPalName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMetadataCreateInput = {
  disbursementMethods?: InputMaybe<OrganizationDisbursmentMethodsCreateInput>;
  payPalName?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadataNullableCompositeFilter = {
  equals?: InputMaybe<OrganizationMetadataObjectEqualityInput>;
  is?: InputMaybe<OrganizationMetadataWhereInput>;
  isNot?: InputMaybe<OrganizationMetadataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationMetadataNullableCreateEnvelopeInput = {
  set?: InputMaybe<OrganizationMetadataCreateInput>;
};

export type OrganizationMetadataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<OrganizationMetadataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<OrganizationMetadataUpsertInput>;
};

export type OrganizationMetadataObjectEqualityInput = {
  disbursementMethods?: InputMaybe<OrganizationDisbursmentMethodsObjectEqualityInput>;
  payPalName?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadataOrderByInput = {
  disbursementMethods?: InputMaybe<OrganizationDisbursmentMethodsOrderByInput>;
  payPalName?: InputMaybe<SortOrder>;
};

export type OrganizationMetadataUpdateInput = {
  disbursementMethods?: InputMaybe<OrganizationDisbursmentMethodsNullableUpdateEnvelopeInput>;
  payPalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationMetadataUpsertInput = {
  set: OrganizationMetadataCreateInput;
  update: OrganizationMetadataUpdateInput;
};

export type OrganizationMetadataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationMetadataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationMetadataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationMetadataWhereInput>>>;
  disbursementMethods?: InputMaybe<OrganizationDisbursmentMethodsNullableCompositeFilter>;
  payPalName?: InputMaybe<StringNullableFilter>;
};

export type OrganizationMinAggregateOutputType = {
  __typename?: 'OrganizationMinAggregateOutputType';
  acceptsDonations?: Maybe<Scalars['Boolean']['output']>;
  appVanityDomain?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  badgeCertificateHeaderImage?: Maybe<Scalars['String']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  donateViaNonprofitId?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailSenderName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invisible?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofitEntityType?: Maybe<NonprofitEntityType>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentNonprofitId?: Maybe<Scalars['String']['output']>;
  payPalModel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pointOfContactId?: Maybe<Scalars['String']['output']>;
  tagLine?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganizationType>;
  verificationStatus?: Maybe<VerificationStatuses>;
  verificationStatusSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMinOrderByAggregateInput = {
  acceptsDonations?: InputMaybe<SortOrder>;
  appVanityDomain?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  badgeCertificateHeaderImage?: InputMaybe<SortOrder>;
  brandColor?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  donateViaNonprofitId?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailSenderName?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invisible?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentNonprofitId?: InputMaybe<SortOrder>;
  payPalModel?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pointOfContactId?: InputMaybe<SortOrder>;
  tagLine?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type OrganizationNullableRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrganizationOrderByWithAggregationInput = {
  ERGs?: InputMaybe<SortOrder>;
  SDGs?: InputMaybe<SortOrder>;
  _count?: InputMaybe<OrganizationCountOrderByAggregateInput>;
  _max?: InputMaybe<OrganizationMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrganizationMinOrderByAggregateInput>;
  acceptsDonations?: InputMaybe<SortOrder>;
  actionNonprofitIds?: InputMaybe<SortOrder>;
  actionOrganizationIds?: InputMaybe<SortOrder>;
  actionTemplateOrganizationIds?: InputMaybe<SortOrder>;
  activityOrganizationIds?: InputMaybe<SortOrder>;
  appVanityDomain?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  badgeCertificateHeaderImage?: InputMaybe<SortOrder>;
  brandColor?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  campaignOrganizationIds?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityCompanyIds?: InputMaybe<SortOrder>;
  communityNonprofitIds?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  donateViaNonprofitId?: InputMaybe<SortOrder>;
  donationSchedulesNonprofits?: InputMaybe<SortOrder>;
  donationSchedulesPayeeNonprofits?: InputMaybe<SortOrder>;
  donationsReceivedIds?: InputMaybe<SortOrder>;
  donationsReceivedPayeeIds?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailSenderName?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invisible?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  locationMap?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nonprofitDeedIds?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  optedInCampaignIds?: InputMaybe<SortOrder>;
  optedInDeedIds?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentNonprofitId?: InputMaybe<SortOrder>;
  payPalModel?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  pointOfContactId?: InputMaybe<SortOrder>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  tagLine?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type OrganizationOrderByWithRelationInput = {
  ActionOrganizations?: InputMaybe<ActionOrderByRelationAggregateInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateOrderByRelationAggregateInput>;
  Actions?: InputMaybe<ActionOrderByRelationAggregateInput>;
  ActivityOrganizations?: InputMaybe<ActivityOrderByRelationAggregateInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeOrderByRelationAggregateInput>;
  Badges?: InputMaybe<BadgeOrderByRelationAggregateInput>;
  CampaignOrganizations?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionOrderByRelationAggregateInput>;
  Challenges?: InputMaybe<ChallengeOrderByRelationAggregateInput>;
  CommunityCompanies?: InputMaybe<CommunityOrderByRelationAggregateInput>;
  CommunityNonprofits?: InputMaybe<CommunityOrderByRelationAggregateInput>;
  CompanyAffiliation?: InputMaybe<AffiliationOrderByRelationAggregateInput>;
  CompanyPartners?: InputMaybe<PartnerOrderByRelationAggregateInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffOrderByRelationAggregateInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeOrderByRelationAggregateInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramOrderByRelationAggregateInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleOrderByRelationAggregateInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleOrderByRelationAggregateInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleOrderByRelationAggregateInput>;
  Donations?: InputMaybe<DonationOrderByRelationAggregateInput>;
  DonationsReceived?: InputMaybe<DonationOrderByRelationAggregateInput>;
  DonationsReceivedPayee?: InputMaybe<DonationOrderByRelationAggregateInput>;
  ERGs?: InputMaybe<SortOrder>;
  Forms?: InputMaybe<FormOrderByRelationAggregateInput>;
  GivingAccounts?: InputMaybe<GivingAccountOrderByRelationAggregateInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationOrderByRelationAggregateInput>;
  Nonprofit?: InputMaybe<NonprofitOrderByRelationAggregateInput>;
  NonprofitDeeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationOrderByRelationAggregateInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationOrderByRelationAggregateInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationOrderByRelationAggregateInput>;
  NonprofitPartners?: InputMaybe<PartnerOrderByRelationAggregateInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffOrderByRelationAggregateInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeOrderByRelationAggregateInput>;
  OptedInCampaigns?: InputMaybe<CampaignOrderByRelationAggregateInput>;
  OptedInDeeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  OrganizationDeeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  PartnerDeeds?: InputMaybe<DeedOrderByRelationAggregateInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileOrderByRelationAggregateInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationOrderByRelationAggregateInput>;
  PointOfContact?: InputMaybe<BaseUserOrderByWithRelationInput>;
  Receipt?: InputMaybe<ReceiptOrderByRelationAggregateInput>;
  SDGs?: InputMaybe<SortOrder>;
  SharedWithCompanies?: InputMaybe<DeedOrderByRelationAggregateInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardOrderByRelationAggregateInput>;
  SigmaReport?: InputMaybe<SigmaReportOrderByRelationAggregateInput>;
  UserNotification?: InputMaybe<UserNotificationOrderByRelationAggregateInput>;
  Users?: InputMaybe<BaseUserOrderByRelationAggregateInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationOrderByRelationAggregateInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardOrderByRelationAggregateInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryOrderByRelationAggregateInput>;
  acceptsDonations?: InputMaybe<SortOrder>;
  actionNonprofitIds?: InputMaybe<SortOrder>;
  actionOrganizationIds?: InputMaybe<SortOrder>;
  actionTemplateOrganizationIds?: InputMaybe<SortOrder>;
  activityOrganizationIds?: InputMaybe<SortOrder>;
  appVanityDomain?: InputMaybe<SortOrder>;
  approved?: InputMaybe<SortOrder>;
  badgeCertificateHeaderImage?: InputMaybe<SortOrder>;
  brandColor?: InputMaybe<SortOrder>;
  brief?: InputMaybe<SortOrder>;
  campaignOrganizationIds?: InputMaybe<SortOrder>;
  categories?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  communityCompanyIds?: InputMaybe<SortOrder>;
  communityNonprofitIds?: InputMaybe<SortOrder>;
  contentFilters?: InputMaybe<ContentFiltersOrderByInput>;
  createdAt?: InputMaybe<SortOrder>;
  currencyCode?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  disclaimers?: InputMaybe<DisclaimerOrderByCompositeAggregateInput>;
  donateViaNonprofitId?: InputMaybe<SortOrder>;
  donationProviders?: InputMaybe<DonationProvidersOrderByInput>;
  donationSchedulesNonprofits?: InputMaybe<SortOrder>;
  donationSchedulesPayeeNonprofits?: InputMaybe<SortOrder>;
  donationsReceivedIds?: InputMaybe<SortOrder>;
  donationsReceivedPayeeIds?: InputMaybe<SortOrder>;
  ein?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailSenderName?: InputMaybe<SortOrder>;
  emailSignature?: InputMaybe<EmailSignatureOrderByInput>;
  externalId?: InputMaybe<SortOrder>;
  features?: InputMaybe<FeaturesOrderByInput>;
  finchApi?: InputMaybe<FinchApiConfigOrderByInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigOrderByInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigOrderByInput>;
  governmentInformationLetter?: InputMaybe<FileUploadOrderByInput>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<NonprofitIdentifierEntryOrderByCompositeAggregateInput>;
  invisible?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  letterOfAssociation?: InputMaybe<FileUploadOrderByInput>;
  locationMap?: InputMaybe<SortOrder>;
  locationObject?: InputMaybe<LocationObjectOrderByInput>;
  logo?: InputMaybe<SortOrder>;
  mainPicture?: InputMaybe<SortOrder>;
  mergeApi?: InputMaybe<MergeApiConfigOrderByInput>;
  metadata?: InputMaybe<OrganizationMetadataOrderByInput>;
  modifiedAt?: InputMaybe<SortOrder>;
  msTeams?: InputMaybe<MsTeamsOrderByInput>;
  name?: InputMaybe<SortOrder>;
  nonprofitDeedIds?: InputMaybe<SortOrder>;
  nonprofitEntityType?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  optedInCampaignIds?: InputMaybe<SortOrder>;
  optedInDeedIds?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentNonprofitId?: InputMaybe<SortOrder>;
  payPalModel?: InputMaybe<SortOrder>;
  payroll?: InputMaybe<PayrollConfigOrderByInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigOrderByInput>;
  phone?: InputMaybe<SortOrder>;
  pictures?: InputMaybe<SortOrder>;
  pillars?: InputMaybe<SortOrder>;
  pointOfContactId?: InputMaybe<SortOrder>;
  settings?: InputMaybe<CompanySettingsOrderByInput>;
  sharedWithCompanyIds?: InputMaybe<SortOrder>;
  sso?: InputMaybe<SsoCompanyOrderByInput>;
  sso2?: InputMaybe<SsoCompanyOrderByInput>;
  tagLine?: InputMaybe<SortOrder>;
  timeOffSync?: InputMaybe<TimeOffSyncConfigOrderByCompositeAggregateInput>;
  type?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
  verificationStatusSyncedAt?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
};

export type OrganizationRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export enum OrganizationScalarFieldEnum {
  ErGs = 'ERGs',
  SdGs = 'SDGs',
  AcceptsDonations = 'acceptsDonations',
  ActionNonprofitIds = 'actionNonprofitIds',
  ActionOrganizationIds = 'actionOrganizationIds',
  ActionTemplateOrganizationIds = 'actionTemplateOrganizationIds',
  ActivityOrganizationIds = 'activityOrganizationIds',
  AppVanityDomain = 'appVanityDomain',
  Approved = 'approved',
  BadgeCertificateHeaderImage = 'badgeCertificateHeaderImage',
  BrandColor = 'brandColor',
  Brief = 'brief',
  CampaignOrganizationIds = 'campaignOrganizationIds',
  Categories = 'categories',
  Code = 'code',
  CommunityCompanyIds = 'communityCompanyIds',
  CommunityNonprofitIds = 'communityNonprofitIds',
  CreatedAt = 'createdAt',
  CurrencyCode = 'currencyCode',
  DeletedAt = 'deletedAt',
  DonateViaNonprofitId = 'donateViaNonprofitId',
  DonationSchedulesNonprofits = 'donationSchedulesNonprofits',
  DonationSchedulesPayeeNonprofits = 'donationSchedulesPayeeNonprofits',
  DonationsReceivedIds = 'donationsReceivedIds',
  DonationsReceivedPayeeIds = 'donationsReceivedPayeeIds',
  Ein = 'ein',
  Email = 'email',
  EmailSenderName = 'emailSenderName',
  ExternalId = 'externalId',
  Id = 'id',
  Invisible = 'invisible',
  LegalName = 'legalName',
  LocationMap = 'locationMap',
  Logo = 'logo',
  MainPicture = 'mainPicture',
  ModifiedAt = 'modifiedAt',
  Name = 'name',
  NonprofitDeedIds = 'nonprofitDeedIds',
  NonprofitEntityType = 'nonprofitEntityType',
  NonprofitId = 'nonprofitId',
  OptedInCampaignIds = 'optedInCampaignIds',
  OptedInDeedIds = 'optedInDeedIds',
  Origin = 'origin',
  ParentId = 'parentId',
  ParentNonprofitId = 'parentNonprofitId',
  PayPalModel = 'payPalModel',
  Phone = 'phone',
  Pictures = 'pictures',
  Pillars = 'pillars',
  PointOfContactId = 'pointOfContactId',
  SharedWithCompanyIds = 'sharedWithCompanyIds',
  TagLine = 'tagLine',
  Type = 'type',
  VerificationStatus = 'verificationStatus',
  VerificationStatusSyncedAt = 'verificationStatusSyncedAt',
  Website = 'website'
}

export type OrganizationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  acceptsDonations?: InputMaybe<BoolNullableFilter>;
  actionNonprofitIds?: InputMaybe<StringNullableListFilter>;
  actionOrganizationIds?: InputMaybe<StringNullableListFilter>;
  actionTemplateOrganizationIds?: InputMaybe<StringNullableListFilter>;
  activityOrganizationIds?: InputMaybe<StringNullableListFilter>;
  appVanityDomain?: InputMaybe<StringNullableFilter>;
  approved?: InputMaybe<BoolNullableFilter>;
  badgeCertificateHeaderImage?: InputMaybe<StringNullableFilter>;
  brandColor?: InputMaybe<StringNullableFilter>;
  brief?: InputMaybe<StringNullableFilter>;
  campaignOrganizationIds?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityCompanyIds?: InputMaybe<StringNullableListFilter>;
  communityNonprofitIds?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  donateViaNonprofitId?: InputMaybe<StringNullableFilter>;
  donationSchedulesNonprofits?: InputMaybe<StringNullableListFilter>;
  donationSchedulesPayeeNonprofits?: InputMaybe<StringNullableListFilter>;
  donationsReceivedIds?: InputMaybe<StringNullableListFilter>;
  donationsReceivedPayeeIds?: InputMaybe<StringNullableListFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailSenderName?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invisible?: InputMaybe<BoolNullableFilter>;
  legalName?: InputMaybe<StringNullableFilter>;
  locationMap?: InputMaybe<JsonNullableFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDeedIds?: InputMaybe<StringNullableListFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  optedInCampaignIds?: InputMaybe<StringNullableListFilter>;
  optedInDeedIds?: InputMaybe<StringNullableListFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  parentNonprofitId?: InputMaybe<StringNullableFilter>;
  payPalModel?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  pointOfContactId?: InputMaybe<StringNullableFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  tagLine?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumOrganizationTypeFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesNullableFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type OrganizationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereWithAggregatesInput>>>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereWithAggregatesInput>>>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  acceptsDonations?: InputMaybe<BoolNullableWithAggregatesFilter>;
  actionNonprofitIds?: InputMaybe<StringNullableListFilter>;
  actionOrganizationIds?: InputMaybe<StringNullableListFilter>;
  actionTemplateOrganizationIds?: InputMaybe<StringNullableListFilter>;
  activityOrganizationIds?: InputMaybe<StringNullableListFilter>;
  appVanityDomain?: InputMaybe<StringNullableWithAggregatesFilter>;
  approved?: InputMaybe<BoolNullableWithAggregatesFilter>;
  badgeCertificateHeaderImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  brandColor?: InputMaybe<StringNullableWithAggregatesFilter>;
  brief?: InputMaybe<StringNullableWithAggregatesFilter>;
  campaignOrganizationIds?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  communityCompanyIds?: InputMaybe<StringNullableListFilter>;
  communityNonprofitIds?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currencyCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  donateViaNonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationSchedulesNonprofits?: InputMaybe<StringNullableListFilter>;
  donationSchedulesPayeeNonprofits?: InputMaybe<StringNullableListFilter>;
  donationsReceivedIds?: InputMaybe<StringNullableListFilter>;
  donationsReceivedPayeeIds?: InputMaybe<StringNullableListFilter>;
  ein?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailSenderName?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  invisible?: InputMaybe<BoolNullableWithAggregatesFilter>;
  legalName?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationMap?: InputMaybe<JsonNullableWithAggregatesFilter>;
  logo?: InputMaybe<StringNullableWithAggregatesFilter>;
  mainPicture?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  nonprofitDeedIds?: InputMaybe<StringNullableListFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  optedInCampaignIds?: InputMaybe<StringNullableListFilter>;
  optedInDeedIds?: InputMaybe<StringNullableListFilter>;
  origin?: InputMaybe<StringNullableWithAggregatesFilter>;
  parentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  parentNonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  payPalModel?: InputMaybe<StringNullableWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  pointOfContactId?: InputMaybe<StringNullableWithAggregatesFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  tagLine?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumOrganizationTypeWithAggregatesFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesNullableWithAggregatesFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  website?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum OrganizationType {
  Company = 'Company',
  Nonprofit = 'Nonprofit'
}

export type OrganizationUncheckedCreateInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateNestedManyWithoutCommunityNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutCommunityNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutCommunityNonprofitsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesNonprofitsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutDonationSchedulesPayeeNonprofitsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutDonationsReceivedPayeeInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedPayeeInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedPayeeInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutNonprofitDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutNonprofitDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutNonprofitDeedsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutOptedInCampaignsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInCampaignsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutOptedInDeedsInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInDeedsInput>>>;
};

export type OrganizationUncheckedCreateNestedManyWithoutSharedWithCompaniesInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutSharedWithCompaniesInput>>>;
};

export type OrganizationUncheckedCreateNestedOneWithoutPointOfContactInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPointOfContactInput>;
  create?: InputMaybe<OrganizationCreateWithoutPointOfContactInput>;
};

export type OrganizationUncheckedCreateWithoutActionOrganizationsInput = {
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutActionTemplateOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutActionsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutActivityOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutAwardedBadgeInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutBadgesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCampaignOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutChallengeContributionGroupsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutChallengesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCommunityCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCommunityNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCompanyAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCompanyPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCompanyVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCompanyVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutCorporateProgramsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationSchedulesCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationSchedulesNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationSchedulesPayeeNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationsReceivedInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutDonationsReceivedPayeeInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutFormsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutGivingAccountsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonProfitAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitNominationsForCompanyInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitNominationsForExistingOrgInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitNominationsForNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutNonprofitVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutOptedInCampaignsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutOptedInDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutOrganizationDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutPartnerDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutPayrollRunFlatFileInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutPayrollRunRollupConfigurationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutPointOfContactInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutReceiptInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutSharedWithCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutSigmaDashboardInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutSigmaReportInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutUserNotificationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutUsersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutVolunteerRewardBudgetAllocationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedCreateWithoutVolunteerTimeOffSummaryInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedCreateNestedManyWithoutOrganizationInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedCreateNestedManyWithoutOrganizationInput>;
  Actions?: InputMaybe<ActionUncheckedCreateNestedManyWithoutNonprofitInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedCreateNestedManyWithoutOrganizationInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  Badges?: InputMaybe<BadgeUncheckedCreateNestedManyWithoutOrganizationInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOrganizationInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedCreateNestedManyWithoutCompanyInput>;
  Challenges?: InputMaybe<ChallengeUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutCompanyInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedCreateNestedManyWithoutNonprofitsInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutCompanyInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedCreateNestedManyWithoutNonprofitsInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayeeNonprofitsInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedCreateNestedManyWithoutOrganizationInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedCreateNestedManyWithoutCompanyInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedCreateNestedManyWithoutNonprofitInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedCreateNestedManyWithoutDeedNonprofitInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutNonprofitsInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutCompanyInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutExistingOrganizationInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOptedInCompaniesInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutOrganizationInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedCreateNestedManyWithoutPartnerInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Receipt?: InputMaybe<ReceiptUncheckedCreateNestedManyWithoutOrganizationInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedCreateNestedManyWithoutSharedWithCompaniesInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput>;
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutOrganizationInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedCreateNestedManyWithoutCompanyInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput>;
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  badgeCertificateHeaderImage?: InputMaybe<Scalars['String']['input']>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['String']['input']>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  createdAt: Scalars['DateTime']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<Scalars['String']['input']>;
  donationProviders?: InputMaybe<DonationProvidersNullableCreateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailSenderName?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<EmailSignatureNullableCreateEnvelopeInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCreateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableCreateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCreateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCreateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCreateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableCreateEnvelopeInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mainPicture?: InputMaybe<Scalars['String']['input']>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCreateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  msTeams?: InputMaybe<MsTeamsNullableCreateEnvelopeInput>;
  name: Scalars['String']['input'];
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NonprofitEntityType>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  payPalModel?: InputMaybe<Scalars['String']['input']>;
  payroll?: InputMaybe<PayrollConfigNullableCreateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCreateEnvelopeInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCreateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableCreateEnvelopeInput>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type: OrganizationType;
  verificationStatus?: InputMaybe<VerificationStatuses>;
  verificationStatusSyncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUncheckedUpdateInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutCommunityNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutCommunityNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutCommunityNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutCommunityNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutCommunityNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutCommunityNonprofitsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationSchedulesNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationSchedulesNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesNonprofitsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationsReceivedInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationsReceivedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationsReceivedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutDonationsReceivedPayeeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedPayeeInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedPayeeInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedPayeeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationsReceivedPayeeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedPayeeInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutNonprofitDeedsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutNonprofitDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutNonprofitDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutNonprofitDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutNonprofitDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutNonprofitDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutNonprofitDeedsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutOptedInCampaignsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutOptedInCampaignsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInCampaignsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutOptedInCampaignsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutOptedInCampaignsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutOptedInCampaignsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutOptedInDeedsInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutOptedInDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutOptedInDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutOptedInDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutOptedInDeedsInput>>>;
};

export type OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutSharedWithCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutSharedWithCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
};

export type OrganizationUncheckedUpdateOneWithoutPointOfContactNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPointOfContactInput>;
  create?: InputMaybe<OrganizationCreateWithoutPointOfContactInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPointOfContactInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPointOfContactInput>;
};

export type OrganizationUncheckedUpdateWithoutActionOrganizationsInput = {
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutActionTemplateOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutActionsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutActivityOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutAwardedBadgeInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutBadgesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCampaignOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutChallengeContributionGroupsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutChallengesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCommunityCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCommunityNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCompanyAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCompanyPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCompanyVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCompanyVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutCorporateProgramsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationSchedulesCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationSchedulesNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationSchedulesPayeeNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationsReceivedInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutDonationsReceivedPayeeInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutFormsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutGivingAccountsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonProfitAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitNominationsForCompanyInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitNominationsForExistingOrgInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitNominationsForNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutNonprofitVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutOptedInCampaignsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutOptedInDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutOrganizationDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutPartnerDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutPayrollRunFlatFileInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutPayrollRunRollupConfigurationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutPointOfContactInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutReceiptInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutSharedWithCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutSigmaDashboardInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutSigmaReportInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutUserNotificationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutUsersInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutVolunteerRewardBudgetAllocationInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUncheckedUpdateWithoutVolunteerTimeOffSummaryInput = {
  ActionOrganizations?: InputMaybe<ActionUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUncheckedUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUncheckedUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUncheckedUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUncheckedUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUncheckedUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUncheckedUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUncheckedUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUncheckedUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUncheckedUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUncheckedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUncheckedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUncheckedUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  communityNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  donationSchedulesNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationSchedulesPayeeNonprofits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  donationsReceivedPayeeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedInCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optedInDeedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pointOfContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sharedWithCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateErGsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateManyMutationInput = {
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateManyWithWhereWithoutCommunityNonprofitsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutDonationSchedulesNonprofitsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutDonationSchedulesPayeeNonprofitsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutDonationsReceivedInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutDonationsReceivedPayeeInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutNonprofitDeedsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutOptedInCampaignsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutOptedInDeedsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutSharedWithCompaniesInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithoutCommunityNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutCommunityNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutCommunityNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutCommunityNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutCommunityNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutCommunityNonprofitsInput>>>;
};

export type OrganizationUpdateManyWithoutDonationSchedulesNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationSchedulesNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesNonprofitsInput>>>;
};

export type OrganizationUpdateManyWithoutDonationSchedulesPayeeNonprofitsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationSchedulesPayeeNonprofitsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput>>>;
};

export type OrganizationUpdateManyWithoutDonationsReceivedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationsReceivedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedInput>>>;
};

export type OrganizationUpdateManyWithoutDonationsReceivedPayeeNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutDonationsReceivedPayeeInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutDonationsReceivedPayeeInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedPayeeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutDonationsReceivedPayeeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedPayeeInput>>>;
};

export type OrganizationUpdateManyWithoutNonprofitDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutNonprofitDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutNonprofitDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutNonprofitDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutNonprofitDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutNonprofitDeedsInput>>>;
};

export type OrganizationUpdateManyWithoutOptedInCampaignsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInCampaignsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInCampaignsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutOptedInCampaignsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutOptedInCampaignsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutOptedInCampaignsInput>>>;
};

export type OrganizationUpdateManyWithoutOptedInDeedsNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutOptedInDeedsInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutOptedInDeedsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutOptedInDeedsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutOptedInDeedsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutOptedInDeedsInput>>>;
};

export type OrganizationUpdateManyWithoutSharedWithCompaniesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<OrganizationCreateOrConnectWithoutSharedWithCompaniesInput>>>;
  create?: InputMaybe<Array<InputMaybe<OrganizationCreateWithoutSharedWithCompaniesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<OrganizationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrganizationUpdateWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<OrganizationUpdateManyWithWhereWithoutSharedWithCompaniesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<OrganizationUpsertWithWhereUniqueWithoutSharedWithCompaniesInput>>>;
};

export type OrganizationUpdateOneRequiredWithoutActionOrganizationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionOrganizationsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutActionOrganizationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutActionOrganizationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutActivityOrganizationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActivityOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActivityOrganizationsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutActivityOrganizationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutActivityOrganizationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutCampaignOrganizationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCampaignOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCampaignOrganizationsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCampaignOrganizationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCampaignOrganizationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutChallengeContributionGroupsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutChallengeContributionGroupsInput>;
  create?: InputMaybe<OrganizationCreateWithoutChallengeContributionGroupsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutChallengeContributionGroupsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutChallengeContributionGroupsInput>;
};

export type OrganizationUpdateOneRequiredWithoutChallengesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutChallengesInput>;
  create?: InputMaybe<OrganizationCreateWithoutChallengesInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutChallengesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutChallengesInput>;
};

export type OrganizationUpdateOneRequiredWithoutCompanyAffiliationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyAffiliationInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyAffiliationInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCompanyAffiliationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCompanyAffiliationInput>;
};

export type OrganizationUpdateOneRequiredWithoutCompanyPartnersNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyPartnersInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyPartnersInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCompanyPartnersInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCompanyPartnersInput>;
};

export type OrganizationUpdateOneRequiredWithoutCorporateProgramsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCorporateProgramsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCorporateProgramsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCorporateProgramsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCorporateProgramsInput>;
};

export type OrganizationUpdateOneRequiredWithoutFormsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFormsInput>;
  create?: InputMaybe<OrganizationCreateWithoutFormsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutFormsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutFormsInput>;
};

export type OrganizationUpdateOneRequiredWithoutGivingAccountsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutGivingAccountsInput>;
  create?: InputMaybe<OrganizationCreateWithoutGivingAccountsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutGivingAccountsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutGivingAccountsInput>;
};

export type OrganizationUpdateOneRequiredWithoutNonProfitAffiliationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonProfitAffiliationInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonProfitAffiliationInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonProfitAffiliationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonProfitAffiliationInput>;
};

export type OrganizationUpdateOneRequiredWithoutNonprofitNominationsForCompanyNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForCompanyInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForCompanyInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForCompanyInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitNominationsForCompanyInput>;
};

export type OrganizationUpdateOneRequiredWithoutNonprofitPartnersNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitPartnersInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitPartnersInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitPartnersInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitPartnersInput>;
};

export type OrganizationUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayrollRunFlatFileInput>;
  create?: InputMaybe<OrganizationCreateWithoutPayrollRunFlatFileInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPayrollRunFlatFileInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPayrollRunFlatFileInput>;
};

export type OrganizationUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPayrollRunRollupConfigurationInput>;
  create?: InputMaybe<OrganizationCreateWithoutPayrollRunRollupConfigurationInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPayrollRunRollupConfigurationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPayrollRunRollupConfigurationInput>;
};

export type OrganizationUpdateOneRequiredWithoutVolunteerRewardBudgetAllocationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerRewardBudgetAllocationInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerRewardBudgetAllocationInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutVolunteerRewardBudgetAllocationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutVolunteerRewardBudgetAllocationInput>;
};

export type OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerRewardsInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerRewardsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutVolunteerRewardsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutVolunteerRewardsInput>;
};

export type OrganizationUpdateOneWithoutActionTemplateOrganizationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionTemplateOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionTemplateOrganizationsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutActionTemplateOrganizationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutActionTemplateOrganizationsInput>;
};

export type OrganizationUpdateOneWithoutActionsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<OrganizationCreateWithoutActionsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutActionsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutActionsInput>;
};

export type OrganizationUpdateOneWithoutAwardedBadgeNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAwardedBadgeInput>;
  create?: InputMaybe<OrganizationCreateWithoutAwardedBadgeInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutAwardedBadgeInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutAwardedBadgeInput>;
};

export type OrganizationUpdateOneWithoutBadgesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBadgesInput>;
  create?: InputMaybe<OrganizationCreateWithoutBadgesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutBadgesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutBadgesInput>;
};

export type OrganizationUpdateOneWithoutCommunityCompaniesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCommunityCompaniesInput>;
  create?: InputMaybe<OrganizationCreateWithoutCommunityCompaniesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCommunityCompaniesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCommunityCompaniesInput>;
};

export type OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyVolunteerTimeOffsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyVolunteerTimeOffsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCompanyVolunteerTimeOffsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCompanyVolunteerTimeOffsInput>;
};

export type OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCompanyVolunteerTimesInput>;
  create?: InputMaybe<OrganizationCreateWithoutCompanyVolunteerTimesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCompanyVolunteerTimesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCompanyVolunteerTimesInput>;
};

export type OrganizationUpdateOneWithoutDonationSchedulesCompaniesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDonationSchedulesCompaniesInput>;
  create?: InputMaybe<OrganizationCreateWithoutDonationSchedulesCompaniesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDonationSchedulesCompaniesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutDonationSchedulesCompaniesInput>;
};

export type OrganizationUpdateOneWithoutDonationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutDonationsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDonationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutDonationsInput>;
};

export type OrganizationUpdateOneWithoutNonprofitNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitInput>;
};

export type OrganizationUpdateOneWithoutNonprofitNominationsForExistingOrgNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForExistingOrgInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForExistingOrgInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForExistingOrgInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitNominationsForExistingOrgInput>;
};

export type OrganizationUpdateOneWithoutNonprofitNominationsForNonprofitNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitNominationsForNonprofitInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitNominationsForNonprofitInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForNonprofitInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitNominationsForNonprofitInput>;
};

export type OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerRewardsInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerRewardsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerRewardsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitVolunteerRewardsInput>;
};

export type OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerTimeOffsInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerTimeOffsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerTimeOffsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitVolunteerTimeOffsInput>;
};

export type OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutNonprofitVolunteerTimesInput>;
  create?: InputMaybe<OrganizationCreateWithoutNonprofitVolunteerTimesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerTimesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutNonprofitVolunteerTimesInput>;
};

export type OrganizationUpdateOneWithoutOrganizationDeedsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrganizationDeedsInput>;
  create?: InputMaybe<OrganizationCreateWithoutOrganizationDeedsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutOrganizationDeedsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutOrganizationDeedsInput>;
};

export type OrganizationUpdateOneWithoutPartnerDeedsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPartnerDeedsInput>;
  create?: InputMaybe<OrganizationCreateWithoutPartnerDeedsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPartnerDeedsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPartnerDeedsInput>;
};

export type OrganizationUpdateOneWithoutPointOfContactNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPointOfContactInput>;
  create?: InputMaybe<OrganizationCreateWithoutPointOfContactInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPointOfContactInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPointOfContactInput>;
};

export type OrganizationUpdateOneWithoutReceiptNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutReceiptInput>;
  create?: InputMaybe<OrganizationCreateWithoutReceiptInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutReceiptInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutReceiptInput>;
};

export type OrganizationUpdateOneWithoutSigmaDashboardNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSigmaDashboardInput>;
  create?: InputMaybe<OrganizationCreateWithoutSigmaDashboardInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSigmaDashboardInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSigmaDashboardInput>;
};

export type OrganizationUpdateOneWithoutSigmaReportNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSigmaReportInput>;
  create?: InputMaybe<OrganizationCreateWithoutSigmaReportInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSigmaReportInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSigmaReportInput>;
};

export type OrganizationUpdateOneWithoutUserNotificationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserNotificationInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserNotificationInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutUserNotificationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutUserNotificationInput>;
};

export type OrganizationUpdateOneWithoutUsersNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<OrganizationCreateWithoutUsersInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutUsersInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutUsersInput>;
};

export type OrganizationUpdateOneWithoutVolunteerTimeOffSummaryNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVolunteerTimeOffSummaryInput>;
  create?: InputMaybe<OrganizationCreateWithoutVolunteerTimeOffSummaryInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutVolunteerTimeOffSummaryInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutVolunteerTimeOffSummaryInput>;
};

export type OrganizationUpdateSdGsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateToOneWithWhereWithoutActionOrganizationsInput = {
  data: OrganizationUpdateWithoutActionOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutActionTemplateOrganizationsInput = {
  data: OrganizationUpdateWithoutActionTemplateOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutActionsInput = {
  data: OrganizationUpdateWithoutActionsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutActivityOrganizationsInput = {
  data: OrganizationUpdateWithoutActivityOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutAwardedBadgeInput = {
  data: OrganizationUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutBadgesInput = {
  data: OrganizationUpdateWithoutBadgesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCampaignOrganizationsInput = {
  data: OrganizationUpdateWithoutCampaignOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutChallengeContributionGroupsInput = {
  data: OrganizationUpdateWithoutChallengeContributionGroupsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutChallengesInput = {
  data: OrganizationUpdateWithoutChallengesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCommunityCompaniesInput = {
  data: OrganizationUpdateWithoutCommunityCompaniesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCompanyAffiliationInput = {
  data: OrganizationUpdateWithoutCompanyAffiliationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCompanyPartnersInput = {
  data: OrganizationUpdateWithoutCompanyPartnersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCompanyVolunteerTimeOffsInput = {
  data: OrganizationUpdateWithoutCompanyVolunteerTimeOffsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCompanyVolunteerTimesInput = {
  data: OrganizationUpdateWithoutCompanyVolunteerTimesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCorporateProgramsInput = {
  data: OrganizationUpdateWithoutCorporateProgramsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDonationSchedulesCompaniesInput = {
  data: OrganizationUpdateWithoutDonationSchedulesCompaniesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDonationsInput = {
  data: OrganizationUpdateWithoutDonationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutFormsInput = {
  data: OrganizationUpdateWithoutFormsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutGivingAccountsInput = {
  data: OrganizationUpdateWithoutGivingAccountsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonProfitAffiliationInput = {
  data: OrganizationUpdateWithoutNonProfitAffiliationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitInput = {
  data: OrganizationUpdateWithoutNonprofitInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForCompanyInput = {
  data: OrganizationUpdateWithoutNonprofitNominationsForCompanyInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForExistingOrgInput = {
  data: OrganizationUpdateWithoutNonprofitNominationsForExistingOrgInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitNominationsForNonprofitInput = {
  data: OrganizationUpdateWithoutNonprofitNominationsForNonprofitInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitPartnersInput = {
  data: OrganizationUpdateWithoutNonprofitPartnersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerRewardsInput = {
  data: OrganizationUpdateWithoutNonprofitVolunteerRewardsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerTimeOffsInput = {
  data: OrganizationUpdateWithoutNonprofitVolunteerTimeOffsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutNonprofitVolunteerTimesInput = {
  data: OrganizationUpdateWithoutNonprofitVolunteerTimesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrganizationDeedsInput = {
  data: OrganizationUpdateWithoutOrganizationDeedsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPartnerDeedsInput = {
  data: OrganizationUpdateWithoutPartnerDeedsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPayrollRunFlatFileInput = {
  data: OrganizationUpdateWithoutPayrollRunFlatFileInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPayrollRunRollupConfigurationInput = {
  data: OrganizationUpdateWithoutPayrollRunRollupConfigurationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPointOfContactInput = {
  data: OrganizationUpdateWithoutPointOfContactInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutReceiptInput = {
  data: OrganizationUpdateWithoutReceiptInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSigmaDashboardInput = {
  data: OrganizationUpdateWithoutSigmaDashboardInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSigmaReportInput = {
  data: OrganizationUpdateWithoutSigmaReportInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutUserNotificationInput = {
  data: OrganizationUpdateWithoutUserNotificationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutUsersInput = {
  data: OrganizationUpdateWithoutUsersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutVolunteerRewardBudgetAllocationInput = {
  data: OrganizationUpdateWithoutVolunteerRewardBudgetAllocationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutVolunteerRewardsInput = {
  data: OrganizationUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutVolunteerTimeOffSummaryInput = {
  data: OrganizationUpdateWithoutVolunteerTimeOffSummaryInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateWithWhereUniqueWithoutCommunityNonprofitsInput = {
  data: OrganizationUpdateWithoutCommunityNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesNonprofitsInput = {
  data: OrganizationUpdateWithoutDonationSchedulesNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput = {
  data: OrganizationUpdateWithoutDonationSchedulesPayeeNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedInput = {
  data: OrganizationUpdateWithoutDonationsReceivedInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutDonationsReceivedPayeeInput = {
  data: OrganizationUpdateWithoutDonationsReceivedPayeeInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutNonprofitDeedsInput = {
  data: OrganizationUpdateWithoutNonprofitDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutOptedInCampaignsInput = {
  data: OrganizationUpdateWithoutOptedInCampaignsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutOptedInDeedsInput = {
  data: OrganizationUpdateWithoutOptedInDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutSharedWithCompaniesInput = {
  data: OrganizationUpdateWithoutSharedWithCompaniesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithoutActionOrganizationsInput = {
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutActionTemplateOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutActionsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutActivityOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutAwardedBadgeInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutBadgesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCampaignOrganizationsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutChallengeContributionGroupsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutChallengesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCommunityCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCommunityNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCompanyAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCompanyPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCompanyVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCompanyVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCorporateProgramsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationSchedulesCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationSchedulesNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationSchedulesPayeeNonprofitsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationsReceivedInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDonationsReceivedPayeeInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutFormsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutGivingAccountsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonProfitAffiliationInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitNominationsForCompanyInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitNominationsForExistingOrgInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitNominationsForNonprofitInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitPartnersInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitVolunteerTimeOffsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutNonprofitVolunteerTimesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOptedInCampaignsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOptedInDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOrganizationDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPartnerDeedsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPayrollRunFlatFileInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPayrollRunRollupConfigurationInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPointOfContactInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutReceiptInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSharedWithCompaniesInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSigmaDashboardInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSigmaReportInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutUserNotificationInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutUsersInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutVolunteerRewardBudgetAllocationInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutVolunteerRewardsInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutVolunteerTimeOffSummaryInput = {
  ActionOrganizations?: InputMaybe<ActionUpdateManyWithoutOrganizationNestedInput>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateUpdateManyWithoutOrganizationNestedInput>;
  Actions?: InputMaybe<ActionUpdateManyWithoutNonprofitNestedInput>;
  ActivityOrganizations?: InputMaybe<ActivityUpdateManyWithoutOrganizationNestedInput>;
  AwardedBadge?: InputMaybe<AwardedBadgeUpdateManyWithoutOrganizationNestedInput>;
  Badges?: InputMaybe<BadgeUpdateManyWithoutOrganizationNestedInput>;
  CampaignOrganizations?: InputMaybe<CampaignUpdateManyWithoutOrganizationNestedInput>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionUpdateManyWithoutCompanyNestedInput>;
  Challenges?: InputMaybe<ChallengeUpdateManyWithoutCompanyNestedInput>;
  CommunityCompanies?: InputMaybe<CommunityUpdateManyWithoutCompanyNestedInput>;
  CommunityNonprofits?: InputMaybe<CommunityUpdateManyWithoutNonprofitsNestedInput>;
  CompanyAffiliation?: InputMaybe<AffiliationUpdateManyWithoutCompanyNestedInput>;
  CompanyPartners?: InputMaybe<PartnerUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutCompanyNestedInput>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutCompanyNestedInput>;
  CorporatePrograms?: InputMaybe<CorporateProgramUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleUpdateManyWithoutCompanyNestedInput>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutNonprofitsNestedInput>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleUpdateManyWithoutPayeeNonprofitsNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutCompanyNestedInput>;
  DonationsReceived?: InputMaybe<DonationUpdateManyWithoutNonprofitsNestedInput>;
  DonationsReceivedPayee?: InputMaybe<DonationUpdateManyWithoutPayeeNonprofitsNestedInput>;
  ERGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Forms?: InputMaybe<FormUpdateManyWithoutOrganizationNestedInput>;
  GivingAccounts?: InputMaybe<GivingAccountUpdateManyWithoutCompanyNestedInput>;
  NonProfitAffiliation?: InputMaybe<AffiliationUpdateManyWithoutNonprofitNestedInput>;
  Nonprofit?: InputMaybe<NonprofitUpdateManyWithoutDeedNonprofitNestedInput>;
  NonprofitDeeds?: InputMaybe<DeedUpdateManyWithoutNonprofitsNestedInput>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationUpdateManyWithoutCompanyNestedInput>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationUpdateManyWithoutExistingOrganizationNestedInput>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationUpdateManyWithoutNonprofitNestedInput>;
  NonprofitPartners?: InputMaybe<PartnerUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeUpdateManyWithoutNonprofitNestedInput>;
  OptedInCampaigns?: InputMaybe<CampaignUpdateManyWithoutOptedInCompaniesNestedInput>;
  OptedInDeeds?: InputMaybe<DeedUpdateManyWithoutOptedInCompaniesNestedInput>;
  OrganizationDeeds?: InputMaybe<DeedUpdateManyWithoutOrganizationNestedInput>;
  PartnerDeeds?: InputMaybe<DeedUpdateManyWithoutPartnerNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput>;
  PointOfContact?: InputMaybe<BaseUserUpdateOneWithoutPointOfContactOrganizationNestedInput>;
  Receipt?: InputMaybe<ReceiptUpdateManyWithoutOrganizationNestedInput>;
  SDGs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SharedWithCompanies?: InputMaybe<DeedUpdateManyWithoutSharedWithCompaniesNestedInput>;
  SigmaDashboard?: InputMaybe<SigmaDashboardUpdateManyWithoutOrganizationNestedInput>;
  SigmaReport?: InputMaybe<SigmaReportUpdateManyWithoutOrganizationNestedInput>;
  UserNotification?: InputMaybe<UserNotificationUpdateManyWithoutOrganizationNestedInput>;
  Users?: InputMaybe<BaseUserUpdateManyWithoutOrganizationNestedInput>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationUpdateManyWithoutCompanyNestedInput>;
  VolunteerRewards?: InputMaybe<VolunteerRewardUpdateManyWithoutCompanyNestedInput>;
  acceptsDonations?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  actionNonprofitIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionTemplateOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appVanityDomain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badgeCertificateHeaderImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  brief?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  campaignOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  communityCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currencyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerCreateInput>>>;
  donateViaNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationProviders?: InputMaybe<DonationProvidersNullableUpdateEnvelopeInput>;
  ein?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSenderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSignature?: InputMaybe<EmailSignatureNullableUpdateEnvelopeInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  features?: InputMaybe<FeaturesNullableUpdateEnvelopeInput>;
  finchApi?: InputMaybe<FinchApiConfigNullableUpdateEnvelopeInput>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableUpdateEnvelopeInput>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableUpdateEnvelopeInput>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryCreateInput>>>;
  invisible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  legalName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  letterOfAssociation?: InputMaybe<FileUploadNullableUpdateEnvelopeInput>;
  locationMap?: InputMaybe<Scalars['Json']['input']>;
  locationObject?: InputMaybe<LocationObjectNullableUpdateEnvelopeInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainPicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeApi?: InputMaybe<MergeApiConfigNullableUpdateEnvelopeInput>;
  metadata?: InputMaybe<OrganizationMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  msTeams?: InputMaybe<MsTeamsNullableUpdateEnvelopeInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitEntityType?: InputMaybe<NullableEnumNonprofitEntityTypeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payPalModel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payroll?: InputMaybe<PayrollConfigNullableUpdateEnvelopeInput>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableUpdateEnvelopeInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pictures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings?: InputMaybe<CompanySettingsNullableUpdateEnvelopeInput>;
  sso?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  sso2?: InputMaybe<SsoCompanyNullableUpdateEnvelopeInput>;
  tagLine?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumVerificationStatusesFieldUpdateOperationsInput>;
  verificationStatusSyncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateactionNonprofitIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateactionOrganizationIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateactionTemplateOrganizationIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateactivityOrganizationIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatecampaignOrganizationIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatecategoriesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatecommunityCompanyIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatecommunityNonprofitIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatedonationSchedulesNonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatedonationSchedulesPayeeNonprofitsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatedonationsReceivedIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatedonationsReceivedPayeeIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatenonprofitDeedIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateoptedInCampaignIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdateoptedInDeedIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatepicturesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatepillarsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpdatesharedWithCompanyIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrganizationUpsertWithWhereUniqueWithoutCommunityNonprofitsInput = {
  create: OrganizationCreateWithoutCommunityNonprofitsInput;
  update: OrganizationUpdateWithoutCommunityNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesNonprofitsInput = {
  create: OrganizationCreateWithoutDonationSchedulesNonprofitsInput;
  update: OrganizationUpdateWithoutDonationSchedulesNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutDonationSchedulesPayeeNonprofitsInput = {
  create: OrganizationCreateWithoutDonationSchedulesPayeeNonprofitsInput;
  update: OrganizationUpdateWithoutDonationSchedulesPayeeNonprofitsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedInput = {
  create: OrganizationCreateWithoutDonationsReceivedInput;
  update: OrganizationUpdateWithoutDonationsReceivedInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutDonationsReceivedPayeeInput = {
  create: OrganizationCreateWithoutDonationsReceivedPayeeInput;
  update: OrganizationUpdateWithoutDonationsReceivedPayeeInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutNonprofitDeedsInput = {
  create: OrganizationCreateWithoutNonprofitDeedsInput;
  update: OrganizationUpdateWithoutNonprofitDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutOptedInCampaignsInput = {
  create: OrganizationCreateWithoutOptedInCampaignsInput;
  update: OrganizationUpdateWithoutOptedInCampaignsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutOptedInDeedsInput = {
  create: OrganizationCreateWithoutOptedInDeedsInput;
  update: OrganizationUpdateWithoutOptedInDeedsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutSharedWithCompaniesInput = {
  create: OrganizationCreateWithoutSharedWithCompaniesInput;
  update: OrganizationUpdateWithoutSharedWithCompaniesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithoutActionOrganizationsInput = {
  create: OrganizationCreateWithoutActionOrganizationsInput;
  update: OrganizationUpdateWithoutActionOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutActionTemplateOrganizationsInput = {
  create: OrganizationCreateWithoutActionTemplateOrganizationsInput;
  update: OrganizationUpdateWithoutActionTemplateOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutActionsInput = {
  create: OrganizationCreateWithoutActionsInput;
  update: OrganizationUpdateWithoutActionsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutActivityOrganizationsInput = {
  create: OrganizationCreateWithoutActivityOrganizationsInput;
  update: OrganizationUpdateWithoutActivityOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutAwardedBadgeInput = {
  create: OrganizationCreateWithoutAwardedBadgeInput;
  update: OrganizationUpdateWithoutAwardedBadgeInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutBadgesInput = {
  create: OrganizationCreateWithoutBadgesInput;
  update: OrganizationUpdateWithoutBadgesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCampaignOrganizationsInput = {
  create: OrganizationCreateWithoutCampaignOrganizationsInput;
  update: OrganizationUpdateWithoutCampaignOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutChallengeContributionGroupsInput = {
  create: OrganizationCreateWithoutChallengeContributionGroupsInput;
  update: OrganizationUpdateWithoutChallengeContributionGroupsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutChallengesInput = {
  create: OrganizationCreateWithoutChallengesInput;
  update: OrganizationUpdateWithoutChallengesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCommunityCompaniesInput = {
  create: OrganizationCreateWithoutCommunityCompaniesInput;
  update: OrganizationUpdateWithoutCommunityCompaniesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCompanyAffiliationInput = {
  create: OrganizationCreateWithoutCompanyAffiliationInput;
  update: OrganizationUpdateWithoutCompanyAffiliationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCompanyPartnersInput = {
  create: OrganizationCreateWithoutCompanyPartnersInput;
  update: OrganizationUpdateWithoutCompanyPartnersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCompanyVolunteerTimeOffsInput = {
  create: OrganizationCreateWithoutCompanyVolunteerTimeOffsInput;
  update: OrganizationUpdateWithoutCompanyVolunteerTimeOffsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCompanyVolunteerTimesInput = {
  create: OrganizationCreateWithoutCompanyVolunteerTimesInput;
  update: OrganizationUpdateWithoutCompanyVolunteerTimesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCorporateProgramsInput = {
  create: OrganizationCreateWithoutCorporateProgramsInput;
  update: OrganizationUpdateWithoutCorporateProgramsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDonationSchedulesCompaniesInput = {
  create: OrganizationCreateWithoutDonationSchedulesCompaniesInput;
  update: OrganizationUpdateWithoutDonationSchedulesCompaniesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDonationsInput = {
  create: OrganizationCreateWithoutDonationsInput;
  update: OrganizationUpdateWithoutDonationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutFormsInput = {
  create: OrganizationCreateWithoutFormsInput;
  update: OrganizationUpdateWithoutFormsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutGivingAccountsInput = {
  create: OrganizationCreateWithoutGivingAccountsInput;
  update: OrganizationUpdateWithoutGivingAccountsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonProfitAffiliationInput = {
  create: OrganizationCreateWithoutNonProfitAffiliationInput;
  update: OrganizationUpdateWithoutNonProfitAffiliationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitInput = {
  create: OrganizationCreateWithoutNonprofitInput;
  update: OrganizationUpdateWithoutNonprofitInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitNominationsForCompanyInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForCompanyInput;
  update: OrganizationUpdateWithoutNonprofitNominationsForCompanyInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitNominationsForExistingOrgInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForExistingOrgInput;
  update: OrganizationUpdateWithoutNonprofitNominationsForExistingOrgInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitNominationsForNonprofitInput = {
  create: OrganizationCreateWithoutNonprofitNominationsForNonprofitInput;
  update: OrganizationUpdateWithoutNonprofitNominationsForNonprofitInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitPartnersInput = {
  create: OrganizationCreateWithoutNonprofitPartnersInput;
  update: OrganizationUpdateWithoutNonprofitPartnersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitVolunteerRewardsInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerRewardsInput;
  update: OrganizationUpdateWithoutNonprofitVolunteerRewardsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitVolunteerTimeOffsInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerTimeOffsInput;
  update: OrganizationUpdateWithoutNonprofitVolunteerTimeOffsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutNonprofitVolunteerTimesInput = {
  create: OrganizationCreateWithoutNonprofitVolunteerTimesInput;
  update: OrganizationUpdateWithoutNonprofitVolunteerTimesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrganizationDeedsInput = {
  create: OrganizationCreateWithoutOrganizationDeedsInput;
  update: OrganizationUpdateWithoutOrganizationDeedsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPartnerDeedsInput = {
  create: OrganizationCreateWithoutPartnerDeedsInput;
  update: OrganizationUpdateWithoutPartnerDeedsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPayrollRunFlatFileInput = {
  create: OrganizationCreateWithoutPayrollRunFlatFileInput;
  update: OrganizationUpdateWithoutPayrollRunFlatFileInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPayrollRunRollupConfigurationInput = {
  create: OrganizationCreateWithoutPayrollRunRollupConfigurationInput;
  update: OrganizationUpdateWithoutPayrollRunRollupConfigurationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPointOfContactInput = {
  create: OrganizationCreateWithoutPointOfContactInput;
  update: OrganizationUpdateWithoutPointOfContactInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutReceiptInput = {
  create: OrganizationCreateWithoutReceiptInput;
  update: OrganizationUpdateWithoutReceiptInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSigmaDashboardInput = {
  create: OrganizationCreateWithoutSigmaDashboardInput;
  update: OrganizationUpdateWithoutSigmaDashboardInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSigmaReportInput = {
  create: OrganizationCreateWithoutSigmaReportInput;
  update: OrganizationUpdateWithoutSigmaReportInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutUserNotificationInput = {
  create: OrganizationCreateWithoutUserNotificationInput;
  update: OrganizationUpdateWithoutUserNotificationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutUsersInput = {
  create: OrganizationCreateWithoutUsersInput;
  update: OrganizationUpdateWithoutUsersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutVolunteerRewardBudgetAllocationInput = {
  create: OrganizationCreateWithoutVolunteerRewardBudgetAllocationInput;
  update: OrganizationUpdateWithoutVolunteerRewardBudgetAllocationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutVolunteerRewardsInput = {
  create: OrganizationCreateWithoutVolunteerRewardsInput;
  update: OrganizationUpdateWithoutVolunteerRewardsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutVolunteerTimeOffSummaryInput = {
  create: OrganizationCreateWithoutVolunteerTimeOffSummaryInput;
  update: OrganizationUpdateWithoutVolunteerTimeOffSummaryInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  ActionOrganizations?: InputMaybe<ActionListRelationFilter>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateListRelationFilter>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  ActivityOrganizations?: InputMaybe<ActivityListRelationFilter>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  Badges?: InputMaybe<BadgeListRelationFilter>;
  CampaignOrganizations?: InputMaybe<CampaignListRelationFilter>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionListRelationFilter>;
  Challenges?: InputMaybe<ChallengeListRelationFilter>;
  CommunityCompanies?: InputMaybe<CommunityListRelationFilter>;
  CommunityNonprofits?: InputMaybe<CommunityListRelationFilter>;
  CompanyAffiliation?: InputMaybe<AffiliationListRelationFilter>;
  CompanyPartners?: InputMaybe<PartnerListRelationFilter>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  CorporatePrograms?: InputMaybe<CorporateProgramListRelationFilter>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleListRelationFilter>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleListRelationFilter>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleListRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  DonationsReceived?: InputMaybe<DonationListRelationFilter>;
  DonationsReceivedPayee?: InputMaybe<DonationListRelationFilter>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  Forms?: InputMaybe<FormListRelationFilter>;
  GivingAccounts?: InputMaybe<GivingAccountListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  NonProfitAffiliation?: InputMaybe<AffiliationListRelationFilter>;
  Nonprofit?: InputMaybe<NonprofitListRelationFilter>;
  NonprofitDeeds?: InputMaybe<DeedListRelationFilter>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitPartners?: InputMaybe<PartnerListRelationFilter>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  OptedInCampaigns?: InputMaybe<CampaignListRelationFilter>;
  OptedInDeeds?: InputMaybe<DeedListRelationFilter>;
  OrganizationDeeds?: InputMaybe<DeedListRelationFilter>;
  PartnerDeeds?: InputMaybe<DeedListRelationFilter>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileListRelationFilter>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationListRelationFilter>;
  PointOfContact?: InputMaybe<BaseUserNullableRelationFilter>;
  Receipt?: InputMaybe<ReceiptListRelationFilter>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  SharedWithCompanies?: InputMaybe<DeedListRelationFilter>;
  SigmaDashboard?: InputMaybe<SigmaDashboardListRelationFilter>;
  SigmaReport?: InputMaybe<SigmaReportListRelationFilter>;
  UserNotification?: InputMaybe<UserNotificationListRelationFilter>;
  Users?: InputMaybe<BaseUserListRelationFilter>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryListRelationFilter>;
  acceptsDonations?: InputMaybe<BoolNullableFilter>;
  actionNonprofitIds?: InputMaybe<StringNullableListFilter>;
  actionOrganizationIds?: InputMaybe<StringNullableListFilter>;
  actionTemplateOrganizationIds?: InputMaybe<StringNullableListFilter>;
  activityOrganizationIds?: InputMaybe<StringNullableListFilter>;
  appVanityDomain?: InputMaybe<StringNullableFilter>;
  approved?: InputMaybe<BoolNullableFilter>;
  badgeCertificateHeaderImage?: InputMaybe<StringNullableFilter>;
  brandColor?: InputMaybe<StringNullableFilter>;
  brief?: InputMaybe<StringNullableFilter>;
  campaignOrganizationIds?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityCompanyIds?: InputMaybe<StringNullableListFilter>;
  communityNonprofitIds?: InputMaybe<StringNullableListFilter>;
  contentFilters?: InputMaybe<ContentFiltersNullableCompositeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerObjectEqualityInput>>>;
  donateViaNonprofitId?: InputMaybe<StringNullableFilter>;
  donationProviders?: InputMaybe<DonationProvidersNullableCompositeFilter>;
  donationSchedulesNonprofits?: InputMaybe<StringNullableListFilter>;
  donationSchedulesPayeeNonprofits?: InputMaybe<StringNullableListFilter>;
  donationsReceivedIds?: InputMaybe<StringNullableListFilter>;
  donationsReceivedPayeeIds?: InputMaybe<StringNullableListFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailSenderName?: InputMaybe<StringNullableFilter>;
  emailSignature?: InputMaybe<EmailSignatureNullableCompositeFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  features?: InputMaybe<FeaturesNullableCompositeFilter>;
  finchApi?: InputMaybe<FinchApiConfigNullableCompositeFilter>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCompositeFilter>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCompositeFilter>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryObjectEqualityInput>>>;
  invisible?: InputMaybe<BoolNullableFilter>;
  legalName?: InputMaybe<StringNullableFilter>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCompositeFilter>;
  locationMap?: InputMaybe<JsonNullableFilter>;
  locationObject?: InputMaybe<LocationObjectNullableCompositeFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCompositeFilter>;
  metadata?: InputMaybe<OrganizationMetadataNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  msTeams?: InputMaybe<MsTeamsNullableCompositeFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDeedIds?: InputMaybe<StringNullableListFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  optedInCampaignIds?: InputMaybe<StringNullableListFilter>;
  optedInDeedIds?: InputMaybe<StringNullableListFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  parentNonprofitId?: InputMaybe<StringNullableFilter>;
  payPalModel?: InputMaybe<StringNullableFilter>;
  payroll?: InputMaybe<PayrollConfigNullableCompositeFilter>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCompositeFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  pointOfContactId?: InputMaybe<StringNullableFilter>;
  settings?: InputMaybe<CompanySettingsNullableCompositeFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sso?: InputMaybe<SsoCompanyNullableCompositeFilter>;
  sso2?: InputMaybe<SsoCompanyNullableCompositeFilter>;
  tagLine?: InputMaybe<StringNullableFilter>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigObjectEqualityInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesNullableFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type OrganizationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  ActionOrganizations?: InputMaybe<ActionListRelationFilter>;
  ActionTemplateOrganizations?: InputMaybe<ActionTemplateListRelationFilter>;
  Actions?: InputMaybe<ActionListRelationFilter>;
  ActivityOrganizations?: InputMaybe<ActivityListRelationFilter>;
  AwardedBadge?: InputMaybe<AwardedBadgeListRelationFilter>;
  Badges?: InputMaybe<BadgeListRelationFilter>;
  CampaignOrganizations?: InputMaybe<CampaignListRelationFilter>;
  ChallengeContributionGroups?: InputMaybe<ChallengeContributionListRelationFilter>;
  Challenges?: InputMaybe<ChallengeListRelationFilter>;
  CommunityCompanies?: InputMaybe<CommunityListRelationFilter>;
  CommunityNonprofits?: InputMaybe<CommunityListRelationFilter>;
  CompanyAffiliation?: InputMaybe<AffiliationListRelationFilter>;
  CompanyPartners?: InputMaybe<PartnerListRelationFilter>;
  CompanyVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  CompanyVolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  CorporatePrograms?: InputMaybe<CorporateProgramListRelationFilter>;
  DonationSchedulesCompanies?: InputMaybe<DonationScheduleListRelationFilter>;
  DonationSchedulesNonprofits?: InputMaybe<DonationScheduleListRelationFilter>;
  DonationSchedulesPayeeNonprofits?: InputMaybe<DonationScheduleListRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  DonationsReceived?: InputMaybe<DonationListRelationFilter>;
  DonationsReceivedPayee?: InputMaybe<DonationListRelationFilter>;
  ERGs?: InputMaybe<StringNullableListFilter>;
  Forms?: InputMaybe<FormListRelationFilter>;
  GivingAccounts?: InputMaybe<GivingAccountListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  NonProfitAffiliation?: InputMaybe<AffiliationListRelationFilter>;
  Nonprofit?: InputMaybe<NonprofitListRelationFilter>;
  NonprofitDeeds?: InputMaybe<DeedListRelationFilter>;
  NonprofitNominationsForCompany?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitNominationsForExistingOrg?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitNominationsForNonprofit?: InputMaybe<NonprofitNominationListRelationFilter>;
  NonprofitPartners?: InputMaybe<PartnerListRelationFilter>;
  NonprofitVolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  NonprofitVolunteerTimeOffs?: InputMaybe<VolunteerTimeOffListRelationFilter>;
  NonprofitVolunteerTimes?: InputMaybe<VolunteerTimeListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<OrganizationWhereInput>>>;
  OptedInCampaigns?: InputMaybe<CampaignListRelationFilter>;
  OptedInDeeds?: InputMaybe<DeedListRelationFilter>;
  OrganizationDeeds?: InputMaybe<DeedListRelationFilter>;
  PartnerDeeds?: InputMaybe<DeedListRelationFilter>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileListRelationFilter>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationListRelationFilter>;
  PointOfContact?: InputMaybe<BaseUserNullableRelationFilter>;
  Receipt?: InputMaybe<ReceiptListRelationFilter>;
  SDGs?: InputMaybe<StringNullableListFilter>;
  SharedWithCompanies?: InputMaybe<DeedListRelationFilter>;
  SigmaDashboard?: InputMaybe<SigmaDashboardListRelationFilter>;
  SigmaReport?: InputMaybe<SigmaReportListRelationFilter>;
  UserNotification?: InputMaybe<UserNotificationListRelationFilter>;
  Users?: InputMaybe<BaseUserListRelationFilter>;
  VolunteerRewardBudgetAllocation?: InputMaybe<BudgetAllocationListRelationFilter>;
  VolunteerRewards?: InputMaybe<VolunteerRewardListRelationFilter>;
  VolunteerTimeOffSummary?: InputMaybe<VolunteerTimeOffSummaryListRelationFilter>;
  acceptsDonations?: InputMaybe<BoolNullableFilter>;
  actionNonprofitIds?: InputMaybe<StringNullableListFilter>;
  actionOrganizationIds?: InputMaybe<StringNullableListFilter>;
  actionTemplateOrganizationIds?: InputMaybe<StringNullableListFilter>;
  activityOrganizationIds?: InputMaybe<StringNullableListFilter>;
  appVanityDomain?: InputMaybe<StringNullableFilter>;
  approved?: InputMaybe<BoolNullableFilter>;
  badgeCertificateHeaderImage?: InputMaybe<StringNullableFilter>;
  brandColor?: InputMaybe<StringNullableFilter>;
  brief?: InputMaybe<StringNullableFilter>;
  campaignOrganizationIds?: InputMaybe<StringNullableListFilter>;
  categories?: InputMaybe<StringNullableListFilter>;
  code?: InputMaybe<StringNullableFilter>;
  communityCompanyIds?: InputMaybe<StringNullableListFilter>;
  communityNonprofitIds?: InputMaybe<StringNullableListFilter>;
  contentFilters?: InputMaybe<ContentFiltersNullableCompositeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyCode?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclaimers?: InputMaybe<Array<InputMaybe<DisclaimerObjectEqualityInput>>>;
  donateViaNonprofitId?: InputMaybe<StringNullableFilter>;
  donationProviders?: InputMaybe<DonationProvidersNullableCompositeFilter>;
  donationSchedulesNonprofits?: InputMaybe<StringNullableListFilter>;
  donationSchedulesPayeeNonprofits?: InputMaybe<StringNullableListFilter>;
  donationsReceivedIds?: InputMaybe<StringNullableListFilter>;
  donationsReceivedPayeeIds?: InputMaybe<StringNullableListFilter>;
  ein?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailSenderName?: InputMaybe<StringNullableFilter>;
  emailSignature?: InputMaybe<EmailSignatureNullableCompositeFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<FeaturesNullableCompositeFilter>;
  finchApi?: InputMaybe<FinchApiConfigNullableCompositeFilter>;
  flatFileSync?: InputMaybe<FlatFileSyncConfigNullableCompositeFilter>;
  givingGoalConfig?: InputMaybe<GivingGoalConfigNullableCompositeFilter>;
  governmentInformationLetter?: InputMaybe<FileUploadNullableCompositeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryObjectEqualityInput>>>;
  invisible?: InputMaybe<BoolNullableFilter>;
  legalName?: InputMaybe<StringNullableFilter>;
  letterOfAssociation?: InputMaybe<FileUploadNullableCompositeFilter>;
  locationMap?: InputMaybe<JsonNullableFilter>;
  locationObject?: InputMaybe<LocationObjectNullableCompositeFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  mainPicture?: InputMaybe<StringNullableFilter>;
  mergeApi?: InputMaybe<MergeApiConfigNullableCompositeFilter>;
  metadata?: InputMaybe<OrganizationMetadataNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  msTeams?: InputMaybe<MsTeamsNullableCompositeFilter>;
  name?: InputMaybe<StringFilter>;
  nonprofitDeedIds?: InputMaybe<StringNullableListFilter>;
  nonprofitEntityType?: InputMaybe<EnumNonprofitEntityTypeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  optedInCampaignIds?: InputMaybe<StringNullableListFilter>;
  optedInDeedIds?: InputMaybe<StringNullableListFilter>;
  origin?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  parentNonprofitId?: InputMaybe<StringNullableFilter>;
  payPalModel?: InputMaybe<StringNullableFilter>;
  payroll?: InputMaybe<PayrollConfigNullableCompositeFilter>;
  payrollFlatFile?: InputMaybe<PayrollFlatFileConfigNullableCompositeFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pictures?: InputMaybe<StringNullableListFilter>;
  pillars?: InputMaybe<StringNullableListFilter>;
  pointOfContactId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CompanySettingsNullableCompositeFilter>;
  sharedWithCompanyIds?: InputMaybe<StringNullableListFilter>;
  sso?: InputMaybe<SsoCompanyNullableCompositeFilter>;
  sso2?: InputMaybe<SsoCompanyNullableCompositeFilter>;
  tagLine?: InputMaybe<StringNullableFilter>;
  timeOffSync?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigObjectEqualityInput>>>;
  type?: InputMaybe<EnumOrganizationTypeFilter>;
  verificationStatus?: InputMaybe<EnumVerificationStatusesNullableFilter>;
  verificationStatusSyncedAt?: InputMaybe<DateTimeNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

/** Outreach email ids */
export enum OutreachEmailId {
  NonprofitNominationOutreachFinal = 'nonprofitNominationOutreachFinal',
  NonprofitNominationOutreachInitial = 'nonprofitNominationOutreachInitial'
}

export type PaginatedDonations = {
  __typename?: 'PaginatedDonations';
  count: Scalars['Int']['output'];
  items: Array<Donation>;
};

export type PaginatedEmployees = {
  __typename?: 'PaginatedEmployees';
  total: Scalars['Int']['output'];
  users: Array<BaseUser>;
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ParticipatingTeams = {
  __typename?: 'ParticipatingTeams';
  ids: Array<Scalars['String']['output']>;
  isExclude: Scalars['Boolean']['output'];
};

export type ParticipatingTeamsCompositeFilter = {
  equals?: InputMaybe<ParticipatingTeamsObjectEqualityInput>;
  is?: InputMaybe<ParticipatingTeamsWhereInput>;
  isNot?: InputMaybe<ParticipatingTeamsWhereInput>;
};

export type ParticipatingTeamsCreateEnvelopeInput = {
  set?: InputMaybe<ParticipatingTeamsCreateInput>;
};

export type ParticipatingTeamsCreateInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParticipatingTeamsCreateidsInput = {
  set: Scalars['String']['input'];
};

export type ParticipatingTeamsObjectEqualityInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude: Scalars['Boolean']['input'];
};

export type ParticipatingTeamsOrderByInput = {
  ids?: InputMaybe<SortOrder>;
  isExclude?: InputMaybe<SortOrder>;
};

export type ParticipatingTeamsUpdateEnvelopeInput = {
  set?: InputMaybe<ParticipatingTeamsCreateInput>;
  update?: InputMaybe<ParticipatingTeamsUpdateInput>;
};

export type ParticipatingTeamsUpdateInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExclude?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ParticipatingTeamsUpdateidsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ParticipatingTeamsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ParticipatingTeamsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ParticipatingTeamsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ParticipatingTeamsWhereInput>>>;
  ids?: InputMaybe<StringNullableListFilter>;
  isExclude?: InputMaybe<BoolFilter>;
};

export type Partner = {
  __typename?: 'Partner';
  Company: Organization;
  CorporateProgram: CorporateProgram;
  Nonprofit: Organization;
  company: Scalars['String']['output'];
  corporateProgramId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nonprofit: Scalars['String']['output'];
  organizersThatRequestedAutoAffiliation: Array<Scalars['String']['output']>;
  status: PartnerStatus;
};

export type PartnerCompanyNonprofitCompoundUniqueInput = {
  company: Scalars['String']['input'];
  nonprofit: Scalars['String']['input'];
};

export type PartnerCountAggregateOutputType = {
  __typename?: 'PartnerCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  corporateProgramId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nonprofit: Scalars['Int']['output'];
  organizersThatRequestedAutoAffiliation: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type PartnerCountOrderByAggregateInput = {
  company?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PartnerCreateInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyPartnersInput;
  CorporateProgram: CorporateProgramCreateNestedOneWithoutPartnersInput;
  Nonprofit: OrganizationCreateNestedOneWithoutNonprofitPartnersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateManyCompanyInput = {
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateManyCompanyInputEnvelope = {
  data: PartnerCreateManyCompanyInput;
};

export type PartnerCreateManyCorporateProgramInput = {
  company: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateManyCorporateProgramInputEnvelope = {
  data: PartnerCreateManyCorporateProgramInput;
};

export type PartnerCreateManyInput = {
  company: Scalars['String']['input'];
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateManyNonprofitInput = {
  company: Scalars['String']['input'];
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateManyNonprofitInputEnvelope = {
  data: PartnerCreateManyNonprofitInput;
};

export type PartnerCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCompanyInputEnvelope>;
};

export type PartnerCreateNestedManyWithoutCorporateProgramInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCorporateProgramInputEnvelope>;
};

export type PartnerCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<PartnerCreateManyNonprofitInputEnvelope>;
};

export type PartnerCreateOrConnectWithoutCompanyInput = {
  create: PartnerCreateWithoutCompanyInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerCreateOrConnectWithoutCorporateProgramInput = {
  create: PartnerCreateWithoutCorporateProgramInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerCreateOrConnectWithoutNonprofitInput = {
  create: PartnerCreateWithoutNonprofitInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerCreateWithoutCompanyInput = {
  CorporateProgram: CorporateProgramCreateNestedOneWithoutPartnersInput;
  Nonprofit: OrganizationCreateNestedOneWithoutNonprofitPartnersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateWithoutCorporateProgramInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyPartnersInput;
  Nonprofit: OrganizationCreateNestedOneWithoutNonprofitPartnersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateWithoutNonprofitInput = {
  Company: OrganizationCreateNestedOneWithoutCompanyPartnersInput;
  CorporateProgram: CorporateProgramCreateNestedOneWithoutPartnersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerCreateorganizersThatRequestedAutoAffiliationInput = {
  set: Scalars['String']['input'];
};

export type PartnerListRelationFilter = {
  every?: InputMaybe<PartnerWhereInput>;
  none?: InputMaybe<PartnerWhereInput>;
  some?: InputMaybe<PartnerWhereInput>;
};

export type PartnerMaxAggregateOutputType = {
  __typename?: 'PartnerMaxAggregateOutputType';
  company?: Maybe<Scalars['String']['output']>;
  corporateProgramId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nonprofit?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PartnerStatus>;
};

export type PartnerMaxOrderByAggregateInput = {
  company?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PartnerMinAggregateOutputType = {
  __typename?: 'PartnerMinAggregateOutputType';
  company?: Maybe<Scalars['String']['output']>;
  corporateProgramId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  nonprofit?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PartnerStatus>;
};

export type PartnerMinOrderByAggregateInput = {
  company?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

/** List partner nonprofits */
export type PartnerNonprofit = {
  __typename?: 'PartnerNonprofit';
  partners?: Maybe<Array<Maybe<ExtendedDeedNonprofit>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PartnerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartnerOrderByWithAggregationInput = {
  _count?: InputMaybe<PartnerCountOrderByAggregateInput>;
  _max?: InputMaybe<PartnerMaxOrderByAggregateInput>;
  _min?: InputMaybe<PartnerMinOrderByAggregateInput>;
  company?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PartnerOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  CorporateProgram?: InputMaybe<CorporateProgramOrderByWithRelationInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  company?: InputMaybe<SortOrder>;
  corporateProgramId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum PartnerScalarFieldEnum {
  Company = 'company',
  CorporateProgramId = 'corporateProgramId',
  Id = 'id',
  Nonprofit = 'nonprofit',
  OrganizersThatRequestedAutoAffiliation = 'organizersThatRequestedAutoAffiliation',
  Status = 'status'
}

export type PartnerScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  company?: InputMaybe<StringFilter>;
  corporateProgramId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  nonprofit?: InputMaybe<StringFilter>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<EnumPartnerStatusFilter>;
};

export type PartnerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PartnerScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PartnerScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PartnerScalarWhereWithAggregatesInput>>>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  corporateProgramId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  nonprofit?: InputMaybe<StringWithAggregatesFilter>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<EnumPartnerStatusWithAggregatesFilter>;
};

export enum PartnerStatus {
  Accepted = 'accepted',
  Inactive = 'inactive',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type PartnerUncheckedCreateInput = {
  company: Scalars['String']['input'];
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCompanyInputEnvelope>;
};

export type PartnerUncheckedCreateNestedManyWithoutCorporateProgramInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCorporateProgramInputEnvelope>;
};

export type PartnerUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<PartnerCreateManyNonprofitInputEnvelope>;
};

export type PartnerUncheckedCreateWithoutCompanyInput = {
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerUncheckedCreateWithoutCorporateProgramInput = {
  company: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit: Scalars['String']['input'];
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerUncheckedCreateWithoutNonprofitInput = {
  company: Scalars['String']['input'];
  corporateProgramId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: PartnerStatus;
};

export type PartnerUncheckedUpdateInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateManyInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateManyWithoutCompanyInput = {
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type PartnerUncheckedUpdateManyWithoutCorporateProgramInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateManyWithoutCorporateProgramNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCorporateProgramInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutCorporateProgramInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutCorporateProgramInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutCorporateProgramInput>>>;
};

export type PartnerUncheckedUpdateManyWithoutNonprofitInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<PartnerCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type PartnerUncheckedUpdateWithoutCompanyInput = {
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateWithoutCorporateProgramInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUncheckedUpdateWithoutNonprofitInput = {
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  corporateProgramId?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyPartnersNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneRequiredWithoutPartnersNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitPartnersNestedInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateManyMutationInput = {
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateManyWithWhereWithoutCompanyInput = {
  data: PartnerUpdateManyMutationInput;
  where: PartnerScalarWhereInput;
};

export type PartnerUpdateManyWithWhereWithoutCorporateProgramInput = {
  data: PartnerUpdateManyMutationInput;
  where: PartnerScalarWhereInput;
};

export type PartnerUpdateManyWithWhereWithoutNonprofitInput = {
  data: PartnerUpdateManyMutationInput;
  where: PartnerScalarWhereInput;
};

export type PartnerUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type PartnerUpdateManyWithoutCorporateProgramNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutCorporateProgramInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutCorporateProgramInput>>>;
  createMany?: InputMaybe<PartnerCreateManyCorporateProgramInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutCorporateProgramInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutCorporateProgramInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutCorporateProgramInput>>>;
};

export type PartnerUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PartnerCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<PartnerCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<PartnerCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PartnerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PartnerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PartnerUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PartnerUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PartnerUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type PartnerUpdateWithWhereUniqueWithoutCompanyInput = {
  data: PartnerUpdateWithoutCompanyInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpdateWithWhereUniqueWithoutCorporateProgramInput = {
  data: PartnerUpdateWithoutCorporateProgramInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: PartnerUpdateWithoutNonprofitInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpdateWithoutCompanyInput = {
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneRequiredWithoutPartnersNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitPartnersNestedInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateWithoutCorporateProgramInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyPartnersNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneRequiredWithoutNonprofitPartnersNestedInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutCompanyPartnersNestedInput>;
  CorporateProgram?: InputMaybe<CorporateProgramUpdateOneRequiredWithoutPartnersNestedInput>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<EnumPartnerStatusFieldUpdateOperationsInput>;
};

export type PartnerUpdateorganizersThatRequestedAutoAffiliationInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerUpsertWithWhereUniqueWithoutCompanyInput = {
  create: PartnerCreateWithoutCompanyInput;
  update: PartnerUpdateWithoutCompanyInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpsertWithWhereUniqueWithoutCorporateProgramInput = {
  create: PartnerCreateWithoutCorporateProgramInput;
  update: PartnerUpdateWithoutCorporateProgramInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: PartnerCreateWithoutNonprofitInput;
  update: PartnerUpdateWithoutNonprofitInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  CorporateProgram?: InputMaybe<CorporateProgramRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  company?: InputMaybe<StringFilter>;
  corporateProgramId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  nonprofit?: InputMaybe<StringFilter>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<EnumPartnerStatusFilter>;
};

export type PartnerWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  CorporateProgram?: InputMaybe<CorporateProgramRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<PartnerWhereInput>>>;
  company?: InputMaybe<StringFilter>;
  company_nonprofit?: InputMaybe<PartnerCompanyNonprofitCompoundUniqueInput>;
  corporateProgramId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  nonprofit?: InputMaybe<StringFilter>;
  organizersThatRequestedAutoAffiliation?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<EnumPartnerStatusFilter>;
};

export type PayGroup = {
  __typename?: 'PayGroup';
  externalId?: Maybe<Scalars['String']['output']>;
  mergeId?: Maybe<Scalars['String']['output']>;
  workdayId?: Maybe<Scalars['String']['output']>;
};

export type PayGroupCreateInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  workdayId?: InputMaybe<Scalars['String']['input']>;
};

export type PayGroupNullableCompositeFilter = {
  equals?: InputMaybe<PayGroupObjectEqualityInput>;
  is?: InputMaybe<PayGroupWhereInput>;
  isNot?: InputMaybe<PayGroupWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayGroupNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PayGroupCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PayGroupUpsertInput>;
};

export type PayGroupObjectEqualityInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  workdayId?: InputMaybe<Scalars['String']['input']>;
};

export type PayGroupOrderByInput = {
  externalId?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  workdayId?: InputMaybe<SortOrder>;
};

export enum PayGroupStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type PayGroupUpdateInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workdayId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayGroupUpsertInput = {
  set: PayGroupCreateInput;
  update: PayGroupUpdateInput;
};

export type PayGroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayGroupWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayGroupWhereInput>>>;
  externalId?: InputMaybe<StringNullableFilter>;
  mergeId?: InputMaybe<StringNullableFilter>;
  workdayId?: InputMaybe<StringNullableFilter>;
};

export enum PayPalVerificationStatus {
  Approved = 'Approved',
  New = 'New',
  Processing = 'Processing',
  Rejected = 'Rejected'
}

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  additionalData?: Maybe<Scalars['Json']['output']>;
  card?: Maybe<PaymentMethodDetailsCard>;
  type?: Maybe<PaymentMethodType>;
};

export type PaymentMethodDetailsCard = {
  __typename?: 'PaymentMethodDetailsCard';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  funding?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodDetailsCardCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  exp_month?: InputMaybe<Scalars['Int']['input']>;
  exp_year?: InputMaybe<Scalars['Int']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  funding?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodDetailsCardNullableCompositeFilter = {
  equals?: InputMaybe<PaymentMethodDetailsCardObjectEqualityInput>;
  is?: InputMaybe<PaymentMethodDetailsCardWhereInput>;
  isNot?: InputMaybe<PaymentMethodDetailsCardWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentMethodDetailsCardNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PaymentMethodDetailsCardCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PaymentMethodDetailsCardUpsertInput>;
};

export type PaymentMethodDetailsCardObjectEqualityInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  exp_month?: InputMaybe<Scalars['Int']['input']>;
  exp_year?: InputMaybe<Scalars['Int']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  funding?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodDetailsCardOrderByInput = {
  brand?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  exp_month?: InputMaybe<SortOrder>;
  exp_year?: InputMaybe<SortOrder>;
  fingerprint?: InputMaybe<SortOrder>;
  funding?: InputMaybe<SortOrder>;
  last4?: InputMaybe<SortOrder>;
};

export type PaymentMethodDetailsCardUpdateInput = {
  brand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exp_month?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exp_year?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fingerprint?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funding?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last4?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaymentMethodDetailsCardUpsertInput = {
  set: PaymentMethodDetailsCardCreateInput;
  update: PaymentMethodDetailsCardUpdateInput;
};

export type PaymentMethodDetailsCardWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsCardWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsCardWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsCardWhereInput>>>;
  brand?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  exp_month?: InputMaybe<IntNullableFilter>;
  exp_year?: InputMaybe<IntNullableFilter>;
  fingerprint?: InputMaybe<StringNullableFilter>;
  funding?: InputMaybe<StringNullableFilter>;
  last4?: InputMaybe<StringNullableFilter>;
};

export type PaymentMethodDetailsCompositeFilter = {
  equals?: InputMaybe<PaymentMethodDetailsObjectEqualityInput>;
  is?: InputMaybe<PaymentMethodDetailsWhereInput>;
  isNot?: InputMaybe<PaymentMethodDetailsWhereInput>;
};

export type PaymentMethodDetailsCreateEnvelopeInput = {
  set?: InputMaybe<PaymentMethodDetailsCreateInput>;
};

export type PaymentMethodDetailsCreateInput = {
  additionalData?: InputMaybe<Scalars['Json']['input']>;
  card?: InputMaybe<PaymentMethodDetailsCardCreateInput>;
  type?: InputMaybe<PaymentMethodType>;
};

export type PaymentMethodDetailsNullableCompositeFilter = {
  equals?: InputMaybe<PaymentMethodDetailsObjectEqualityInput>;
  is?: InputMaybe<PaymentMethodDetailsWhereInput>;
  isNot?: InputMaybe<PaymentMethodDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentMethodDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<PaymentMethodDetailsCreateInput>;
};

export type PaymentMethodDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PaymentMethodDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PaymentMethodDetailsUpsertInput>;
};

export type PaymentMethodDetailsObjectEqualityInput = {
  additionalData?: InputMaybe<Scalars['Json']['input']>;
  card?: InputMaybe<PaymentMethodDetailsCardObjectEqualityInput>;
  type?: InputMaybe<PaymentMethodType>;
};

export type PaymentMethodDetailsOrderByInput = {
  additionalData?: InputMaybe<SortOrder>;
  card?: InputMaybe<PaymentMethodDetailsCardOrderByInput>;
  type?: InputMaybe<SortOrder>;
};

export type PaymentMethodDetailsUpdateEnvelopeInput = {
  set?: InputMaybe<PaymentMethodDetailsCreateInput>;
  update?: InputMaybe<PaymentMethodDetailsUpdateInput>;
};

export type PaymentMethodDetailsUpdateInput = {
  additionalData?: InputMaybe<Scalars['Json']['input']>;
  card?: InputMaybe<PaymentMethodDetailsCardNullableUpdateEnvelopeInput>;
  type?: InputMaybe<NullableEnumPaymentMethodTypeFieldUpdateOperationsInput>;
};

export type PaymentMethodDetailsUpsertInput = {
  set: PaymentMethodDetailsCreateInput;
  update: PaymentMethodDetailsUpdateInput;
};

export type PaymentMethodDetailsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentMethodDetailsWhereInput>>>;
  additionalData?: InputMaybe<JsonNullableFilter>;
  card?: InputMaybe<PaymentMethodDetailsCardNullableCompositeFilter>;
  type?: InputMaybe<EnumPaymentMethodTypeNullableFilter>;
};

export enum PaymentMethodType {
  Card = 'Card',
  CorporateBudget = 'CorporateBudget',
  DeedCredit = 'DeedCredit',
  External = 'External',
  PayPal = 'PayPal',
  Payroll = 'Payroll'
}

export type PayrollConfig = {
  __typename?: 'PayrollConfig';
  enabledPayGroupMergeIds: Array<Scalars['String']['output']>;
  payDateOffsetDays?: Maybe<Scalars['Int']['output']>;
  payrollDonationsCancellation?: Maybe<Scalars['Boolean']['output']>;
};

export type PayrollConfigCreateInput = {
  enabledPayGroupMergeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  payrollDonationsCancellation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollConfigCreateenabledPayGroupMergeIdsInput = {
  set: Scalars['String']['input'];
};

export type PayrollConfigNullableCompositeFilter = {
  equals?: InputMaybe<PayrollConfigObjectEqualityInput>;
  is?: InputMaybe<PayrollConfigWhereInput>;
  isNot?: InputMaybe<PayrollConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<PayrollConfigCreateInput>;
};

export type PayrollConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PayrollConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PayrollConfigUpsertInput>;
};

export type PayrollConfigObjectEqualityInput = {
  enabledPayGroupMergeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  payrollDonationsCancellation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollConfigOrderByInput = {
  enabledPayGroupMergeIds?: InputMaybe<SortOrder>;
  payDateOffsetDays?: InputMaybe<SortOrder>;
  payrollDonationsCancellation?: InputMaybe<SortOrder>;
};

export type PayrollConfigUpdateInput = {
  enabledPayGroupMergeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payDateOffsetDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  payrollDonationsCancellation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type PayrollConfigUpdateenabledPayGroupMergeIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PayrollConfigUpsertInput = {
  set: PayrollConfigCreateInput;
  update: PayrollConfigUpdateInput;
};

export type PayrollConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollConfigWhereInput>>>;
  enabledPayGroupMergeIds?: InputMaybe<StringNullableListFilter>;
  payDateOffsetDays?: InputMaybe<IntNullableFilter>;
  payrollDonationsCancellation?: InputMaybe<BoolNullableFilter>;
};

export type PayrollDeduction = {
  __typename?: 'PayrollDeduction';
  companyDeduction: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  employeeDeduction: Scalars['Float']['output'];
  employeePayrollRun: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteData?: Maybe<Scalars['Json']['output']>;
};

export type PayrollDeductionCreateInput = {
  companyDeduction: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  employeeDeduction: Scalars['Float']['input'];
  employeePayrollRun: Scalars['String']['input'];
  name: Scalars['String']['input'];
  remoteData?: InputMaybe<Scalars['Json']['input']>;
};

export type PayrollDeductionNullableCompositeFilter = {
  equals?: InputMaybe<PayrollDeductionObjectEqualityInput>;
  is?: InputMaybe<PayrollDeductionWhereInput>;
  isNot?: InputMaybe<PayrollDeductionWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollDeductionNullableCreateEnvelopeInput = {
  set?: InputMaybe<PayrollDeductionCreateInput>;
};

export type PayrollDeductionNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PayrollDeductionCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PayrollDeductionUpsertInput>;
};

export type PayrollDeductionObjectEqualityInput = {
  companyDeduction: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  employeeDeduction: Scalars['Float']['input'];
  employeePayrollRun: Scalars['String']['input'];
  name: Scalars['String']['input'];
  remoteData?: InputMaybe<Scalars['Json']['input']>;
};

export type PayrollDeductionOrderByInput = {
  companyDeduction?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  employeeDeduction?: InputMaybe<SortOrder>;
  employeePayrollRun?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  remoteData?: InputMaybe<SortOrder>;
};

export type PayrollDeductionUpdateInput = {
  companyDeduction?: InputMaybe<FloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  employeeDeduction?: InputMaybe<FloatFieldUpdateOperationsInput>;
  employeePayrollRun?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  remoteData?: InputMaybe<Scalars['Json']['input']>;
};

export type PayrollDeductionUpsertInput = {
  set: PayrollDeductionCreateInput;
  update: PayrollDeductionUpdateInput;
};

export type PayrollDeductionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollDeductionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollDeductionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollDeductionWhereInput>>>;
  companyDeduction?: InputMaybe<FloatFilter>;
  currency?: InputMaybe<StringFilter>;
  employeeDeduction?: InputMaybe<FloatFilter>;
  employeePayrollRun?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  remoteData?: InputMaybe<JsonNullableFilter>;
};

export enum PayrollDonationFrequencyOptions {
  Monthly = 'Monthly',
  Onetime = 'Onetime'
}

export type PayrollFlatFileConfig = {
  __typename?: 'PayrollFlatFileConfig';
  adminEmail?: Maybe<Scalars['String']['output']>;
  ccEmails: Array<Scalars['String']['output']>;
  defaultCorporateProgam?: Maybe<DefaultCorporateProgam>;
  enabled: Scalars['Boolean']['output'];
  encryption?: Maybe<EncryptionConfiguration>;
  fileNamingConfig: FileNamingConfigurationByFileType;
  isDefaultPaymentMethod: Scalars['Boolean']['output'];
  isNewDashboardEnabled?: Maybe<Scalars['Boolean']['output']>;
  isReconciliationV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  paymentMethodEnabled: Scalars['Boolean']['output'];
  paymentOptions: Array<PayrollPaymentOption>;
  payrollParentId?: Maybe<Scalars['String']['output']>;
  processorType: PayrollProcessorType;
  reconciliation?: Maybe<ReconciliationConfiguration>;
  sftp?: Maybe<SftpConfig>;
  template?: Maybe<FlatFileTemplate>;
  transferDirectories: PayrollTransferDirectories;
  transferMode?: Maybe<DeductionTransferMode>;
};

export type PayrollFlatFileConfigCreateInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  ccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultCorporateProgam?: InputMaybe<DefaultCorporateProgamCreateInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationCreateInput>;
  fileNamingConfig: FileNamingConfigurationByFileTypeCreateInput;
  isDefaultPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isNewDashboardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciliationV2Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionCreateInput>>>;
  payrollParentId?: InputMaybe<Scalars['String']['input']>;
  processorType?: InputMaybe<PayrollProcessorType>;
  reconciliation?: InputMaybe<ReconciliationConfigurationCreateInput>;
  sftp?: InputMaybe<SftpConfigCreateInput>;
  template?: InputMaybe<FlatFileTemplate>;
  transferDirectories: PayrollTransferDirectoriesCreateInput;
  transferMode?: InputMaybe<DeductionTransferMode>;
};

export type PayrollFlatFileConfigCreateccEmailsInput = {
  set: Scalars['String']['input'];
};

export type PayrollFlatFileConfigNullableCompositeFilter = {
  equals?: InputMaybe<PayrollFlatFileConfigObjectEqualityInput>;
  is?: InputMaybe<PayrollFlatFileConfigWhereInput>;
  isNot?: InputMaybe<PayrollFlatFileConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollFlatFileConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<PayrollFlatFileConfigCreateInput>;
};

export type PayrollFlatFileConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PayrollFlatFileConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PayrollFlatFileConfigUpsertInput>;
};

export type PayrollFlatFileConfigObjectEqualityInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  ccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultCorporateProgam?: InputMaybe<DefaultCorporateProgamObjectEqualityInput>;
  enabled: Scalars['Boolean']['input'];
  encryption?: InputMaybe<EncryptionConfigurationObjectEqualityInput>;
  fileNamingConfig: FileNamingConfigurationByFileTypeObjectEqualityInput;
  isDefaultPaymentMethod: Scalars['Boolean']['input'];
  isNewDashboardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReconciliationV2Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodEnabled: Scalars['Boolean']['input'];
  paymentOptions?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionObjectEqualityInput>>>;
  payrollParentId?: InputMaybe<Scalars['String']['input']>;
  processorType: PayrollProcessorType;
  reconciliation?: InputMaybe<ReconciliationConfigurationObjectEqualityInput>;
  sftp?: InputMaybe<SftpConfigObjectEqualityInput>;
  template?: InputMaybe<FlatFileTemplate>;
  transferDirectories: PayrollTransferDirectoriesObjectEqualityInput;
  transferMode?: InputMaybe<DeductionTransferMode>;
};

export type PayrollFlatFileConfigOrderByInput = {
  adminEmail?: InputMaybe<SortOrder>;
  ccEmails?: InputMaybe<SortOrder>;
  defaultCorporateProgam?: InputMaybe<DefaultCorporateProgamOrderByInput>;
  enabled?: InputMaybe<SortOrder>;
  encryption?: InputMaybe<EncryptionConfigurationOrderByInput>;
  fileNamingConfig?: InputMaybe<FileNamingConfigurationByFileTypeOrderByInput>;
  isDefaultPaymentMethod?: InputMaybe<SortOrder>;
  isNewDashboardEnabled?: InputMaybe<SortOrder>;
  isReconciliationV2Enabled?: InputMaybe<SortOrder>;
  paymentMethodEnabled?: InputMaybe<SortOrder>;
  paymentOptions?: InputMaybe<PayrollPaymentOptionOrderByCompositeAggregateInput>;
  payrollParentId?: InputMaybe<SortOrder>;
  processorType?: InputMaybe<SortOrder>;
  reconciliation?: InputMaybe<ReconciliationConfigurationOrderByInput>;
  sftp?: InputMaybe<SftpConfigOrderByInput>;
  template?: InputMaybe<SortOrder>;
  transferDirectories?: InputMaybe<PayrollTransferDirectoriesOrderByInput>;
  transferMode?: InputMaybe<SortOrder>;
};

export type PayrollFlatFileConfigUpdateInput = {
  adminEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ccEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultCorporateProgam?: InputMaybe<DefaultCorporateProgamNullableUpdateEnvelopeInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  encryption?: InputMaybe<EncryptionConfigurationNullableUpdateEnvelopeInput>;
  fileNamingConfig?: InputMaybe<FileNamingConfigurationByFileTypeUpdateEnvelopeInput>;
  isDefaultPaymentMethod?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNewDashboardEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isReconciliationV2Enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethodEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionCreateInput>>>;
  payrollParentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processorType?: InputMaybe<EnumPayrollProcessorTypeFieldUpdateOperationsInput>;
  reconciliation?: InputMaybe<ReconciliationConfigurationNullableUpdateEnvelopeInput>;
  sftp?: InputMaybe<SftpConfigNullableUpdateEnvelopeInput>;
  template?: InputMaybe<NullableEnumFlatFileTemplateFieldUpdateOperationsInput>;
  transferDirectories?: InputMaybe<PayrollTransferDirectoriesUpdateEnvelopeInput>;
  transferMode?: InputMaybe<NullableEnumDeductionTransferModeFieldUpdateOperationsInput>;
};

export type PayrollFlatFileConfigUpdateccEmailsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PayrollFlatFileConfigUpsertInput = {
  set: PayrollFlatFileConfigCreateInput;
  update: PayrollFlatFileConfigUpdateInput;
};

export type PayrollFlatFileConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollFlatFileConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollFlatFileConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollFlatFileConfigWhereInput>>>;
  adminEmail?: InputMaybe<StringNullableFilter>;
  ccEmails?: InputMaybe<StringNullableListFilter>;
  defaultCorporateProgam?: InputMaybe<DefaultCorporateProgamNullableCompositeFilter>;
  enabled?: InputMaybe<BoolFilter>;
  encryption?: InputMaybe<EncryptionConfigurationNullableCompositeFilter>;
  fileNamingConfig?: InputMaybe<FileNamingConfigurationByFileTypeCompositeFilter>;
  isDefaultPaymentMethod?: InputMaybe<BoolFilter>;
  isNewDashboardEnabled?: InputMaybe<BoolNullableFilter>;
  isReconciliationV2Enabled?: InputMaybe<BoolNullableFilter>;
  paymentMethodEnabled?: InputMaybe<BoolFilter>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionObjectEqualityInput>>>;
  payrollParentId?: InputMaybe<StringNullableFilter>;
  processorType?: InputMaybe<EnumPayrollProcessorTypeFilter>;
  reconciliation?: InputMaybe<ReconciliationConfigurationNullableCompositeFilter>;
  sftp?: InputMaybe<SftpConfigNullableCompositeFilter>;
  template?: InputMaybe<EnumFlatFileTemplateNullableFilter>;
  transferDirectories?: InputMaybe<PayrollTransferDirectoriesCompositeFilter>;
  transferMode?: InputMaybe<EnumDeductionTransferModeNullableFilter>;
};

export enum PayrollFlatFileFileExtension {
  Csv = 'csv',
  Gpg = 'gpg',
  Txt = 'txt'
}

export type PayrollPayGroup = {
  __typename?: 'PayrollPayGroup';
  BaseUser: Array<BaseUser>;
  Donation: Array<Donation>;
  PayrollRunFlatFile: Array<PayrollRunFlatFile>;
  PayrollRunRollupConfiguration: Array<PayrollRunRollupConfiguration>;
  _count: PayrollPayGroupCountOutputType;
  adapterProvider?: Maybe<AdapterProvider>;
  adapterProviderId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  externalPayGroupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  leaderPayGroupId?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  payGroupDisplayName: Scalars['String']['output'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['output'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone: Scalars['String']['output'];
};


export type PayrollPayGroupBaseUserArgs = {
  cursor?: InputMaybe<BaseUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BaseUserScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BaseUserOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BaseUserWhereInput>;
};


export type PayrollPayGroupDonationArgs = {
  cursor?: InputMaybe<DonationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DonationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DonationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DonationWhereInput>;
};


export type PayrollPayGroupPayrollRunFlatFileArgs = {
  cursor?: InputMaybe<PayrollRunFlatFileWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayrollRunFlatFileWhereInput>;
};


export type PayrollPayGroupPayrollRunRollupConfigurationArgs = {
  cursor?: InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayrollRunRollupConfigurationWhereInput>;
};

export type PayrollPayGroupCountAggregateOutputType = {
  __typename?: 'PayrollPayGroupCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  adapterProvider: Scalars['Int']['output'];
  adapterProviderId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  externalPayGroupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isLeader: Scalars['Int']['output'];
  leaderPayGroupId: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  payGroupDisplayName: Scalars['Int']['output'];
  payrollProvider: Scalars['Int']['output'];
  payrollProviderId: Scalars['Int']['output'];
  payrollProviderType: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  timeZone: Scalars['Int']['output'];
};

export type PayrollPayGroupCountOrderByAggregateInput = {
  adapterProvider?: InputMaybe<SortOrder>;
  adapterProviderId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalPayGroupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLeader?: InputMaybe<SortOrder>;
  leaderPayGroupId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupDisplayName?: InputMaybe<SortOrder>;
  payrollProvider?: InputMaybe<SortOrder>;
  payrollProviderId?: InputMaybe<SortOrder>;
  payrollProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
};

export type PayrollPayGroupCountOutputType = {
  __typename?: 'PayrollPayGroupCountOutputType';
  BaseUser: Scalars['Int']['output'];
  Donation: Scalars['Int']['output'];
  PayrollRunFlatFile: Scalars['Int']['output'];
  PayrollRunRollupConfiguration: Scalars['Int']['output'];
};

export type PayrollPayGroupCreateInput = {
  BaseUser?: InputMaybe<BaseUserCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupCreateManyInput = {
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupCreateNestedOneWithoutBaseUserInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutBaseUserInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutBaseUserInput>;
};

export type PayrollPayGroupCreateNestedOneWithoutDonationInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutDonationInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutDonationInput>;
};

export type PayrollPayGroupCreateNestedOneWithoutPayrollRunFlatFileInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutPayrollRunFlatFileInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutPayrollRunFlatFileInput>;
};

export type PayrollPayGroupCreateNestedOneWithoutPayrollRunRollupConfigurationInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutPayrollRunRollupConfigurationInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutPayrollRunRollupConfigurationInput>;
};

export type PayrollPayGroupCreateOrConnectWithoutBaseUserInput = {
  create: PayrollPayGroupCreateWithoutBaseUserInput;
  where: PayrollPayGroupWhereUniqueInput;
};

export type PayrollPayGroupCreateOrConnectWithoutDonationInput = {
  create: PayrollPayGroupCreateWithoutDonationInput;
  where: PayrollPayGroupWhereUniqueInput;
};

export type PayrollPayGroupCreateOrConnectWithoutPayrollRunFlatFileInput = {
  create: PayrollPayGroupCreateWithoutPayrollRunFlatFileInput;
  where: PayrollPayGroupWhereUniqueInput;
};

export type PayrollPayGroupCreateOrConnectWithoutPayrollRunRollupConfigurationInput = {
  create: PayrollPayGroupCreateWithoutPayrollRunRollupConfigurationInput;
  where: PayrollPayGroupWhereUniqueInput;
};

export type PayrollPayGroupCreateWithoutBaseUserInput = {
  Donation?: InputMaybe<DonationCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupCreateWithoutDonationInput = {
  BaseUser?: InputMaybe<BaseUserCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupCreateWithoutPayrollRunFlatFileInput = {
  BaseUser?: InputMaybe<BaseUserCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupCreateWithoutPayrollRunRollupConfigurationInput = {
  BaseUser?: InputMaybe<BaseUserCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupExternalPayGroupIdCompanyIdPayrollProviderPayrollProviderIdPayrollProviderTypeCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  externalPayGroupId: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
};

export type PayrollPayGroupMaxAggregateOutputType = {
  __typename?: 'PayrollPayGroupMaxAggregateOutputType';
  adapterProvider?: Maybe<AdapterProvider>;
  adapterProviderId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalPayGroupId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  leaderPayGroupId?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payGroupDisplayName?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  payrollProviderId?: Maybe<Scalars['String']['output']>;
  payrollProviderType?: Maybe<PayrollProviderType>;
  status?: Maybe<PayGroupStatus>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type PayrollPayGroupMaxOrderByAggregateInput = {
  adapterProvider?: InputMaybe<SortOrder>;
  adapterProviderId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalPayGroupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLeader?: InputMaybe<SortOrder>;
  leaderPayGroupId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupDisplayName?: InputMaybe<SortOrder>;
  payrollProvider?: InputMaybe<SortOrder>;
  payrollProviderId?: InputMaybe<SortOrder>;
  payrollProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
};

export type PayrollPayGroupMinAggregateOutputType = {
  __typename?: 'PayrollPayGroupMinAggregateOutputType';
  adapterProvider?: Maybe<AdapterProvider>;
  adapterProviderId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalPayGroupId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  leaderPayGroupId?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payGroupDisplayName?: Maybe<Scalars['String']['output']>;
  payrollProvider?: Maybe<PayrollProvider>;
  payrollProviderId?: Maybe<Scalars['String']['output']>;
  payrollProviderType?: Maybe<PayrollProviderType>;
  status?: Maybe<PayGroupStatus>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type PayrollPayGroupMinOrderByAggregateInput = {
  adapterProvider?: InputMaybe<SortOrder>;
  adapterProviderId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalPayGroupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLeader?: InputMaybe<SortOrder>;
  leaderPayGroupId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupDisplayName?: InputMaybe<SortOrder>;
  payrollProvider?: InputMaybe<SortOrder>;
  payrollProviderId?: InputMaybe<SortOrder>;
  payrollProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
};

export type PayrollPayGroupNullableRelationFilter = {
  is?: InputMaybe<PayrollPayGroupWhereInput>;
  isNot?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupOrderByWithAggregationInput = {
  _count?: InputMaybe<PayrollPayGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<PayrollPayGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayrollPayGroupMinOrderByAggregateInput>;
  adapterProvider?: InputMaybe<SortOrder>;
  adapterProviderId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalPayGroupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLeader?: InputMaybe<SortOrder>;
  leaderPayGroupId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupDisplayName?: InputMaybe<SortOrder>;
  payrollProvider?: InputMaybe<SortOrder>;
  payrollProviderId?: InputMaybe<SortOrder>;
  payrollProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
};

export type PayrollPayGroupOrderByWithRelationInput = {
  BaseUser?: InputMaybe<BaseUserOrderByRelationAggregateInput>;
  Donation?: InputMaybe<DonationOrderByRelationAggregateInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileOrderByRelationAggregateInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationOrderByRelationAggregateInput>;
  adapterProvider?: InputMaybe<SortOrder>;
  adapterProviderId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  externalPayGroupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLeader?: InputMaybe<SortOrder>;
  leaderPayGroupId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupDisplayName?: InputMaybe<SortOrder>;
  payrollProvider?: InputMaybe<SortOrder>;
  payrollProviderId?: InputMaybe<SortOrder>;
  payrollProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeZone?: InputMaybe<SortOrder>;
};

export type PayrollPayGroupPayGroupDisplayNameCompanyIdPayrollProviderPayrollProviderIdPayrollProviderTypeCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
};

export type PayrollPayGroupRelationFilter = {
  is?: InputMaybe<PayrollPayGroupWhereInput>;
  isNot?: InputMaybe<PayrollPayGroupWhereInput>;
};

export enum PayrollPayGroupScalarFieldEnum {
  AdapterProvider = 'adapterProvider',
  AdapterProviderId = 'adapterProviderId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  ExternalPayGroupId = 'externalPayGroupId',
  Id = 'id',
  IsLeader = 'isLeader',
  LeaderPayGroupId = 'leaderPayGroupId',
  ModifiedAt = 'modifiedAt',
  PayGroupDisplayName = 'payGroupDisplayName',
  PayrollProvider = 'payrollProvider',
  PayrollProviderId = 'payrollProviderId',
  PayrollProviderType = 'payrollProviderType',
  Status = 'status',
  TimeZone = 'timeZone'
}

export type PayrollPayGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollPayGroupScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollPayGroupScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollPayGroupScalarWhereWithAggregatesInput>>>;
  adapterProvider?: InputMaybe<EnumAdapterProviderNullableWithAggregatesFilter>;
  adapterProviderId?: InputMaybe<StringNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  externalPayGroupId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isLeader?: InputMaybe<BoolNullableWithAggregatesFilter>;
  leaderPayGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  payGroupDisplayName?: InputMaybe<StringWithAggregatesFilter>;
  payrollProvider?: InputMaybe<EnumPayrollProviderWithAggregatesFilter>;
  payrollProviderId?: InputMaybe<StringWithAggregatesFilter>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeWithAggregatesFilter>;
  status?: InputMaybe<EnumPayGroupStatusWithAggregatesFilter>;
  timeZone?: InputMaybe<StringWithAggregatesFilter>;
};

export type PayrollPayGroupUncheckedCreateInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupUncheckedCreateWithoutBaseUserInput = {
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupUncheckedCreateWithoutDonationInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupUncheckedCreateWithoutPayrollRunFlatFileInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupUncheckedCreateWithoutPayrollRunRollupConfigurationInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  Donation?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedCreateNestedManyWithoutPayrollPayGroupInput>;
  adapterProvider?: InputMaybe<AdapterProvider>;
  adapterProviderId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalPayGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<Scalars['Boolean']['input']>;
  leaderPayGroupId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupDisplayName: Scalars['String']['input'];
  payrollProvider: PayrollProvider;
  payrollProviderId: Scalars['String']['input'];
  payrollProviderType: PayrollProviderType;
  status: PayGroupStatus;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollPayGroupUncheckedUpdateInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUncheckedUpdateManyInput = {
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUncheckedUpdateWithoutBaseUserInput = {
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUncheckedUpdateWithoutDonationInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUncheckedUpdateWithoutPayrollRunFlatFileInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUncheckedUpdateWithoutPayrollRunRollupConfigurationInput = {
  BaseUser?: InputMaybe<BaseUserUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateInput = {
  BaseUser?: InputMaybe<BaseUserUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateManyMutationInput = {
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutPayrollRunFlatFileInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutPayrollRunFlatFileInput>;
  update?: InputMaybe<PayrollPayGroupUpdateToOneWithWhereWithoutPayrollRunFlatFileInput>;
  upsert?: InputMaybe<PayrollPayGroupUpsertWithoutPayrollRunFlatFileInput>;
};

export type PayrollPayGroupUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutPayrollRunRollupConfigurationInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutPayrollRunRollupConfigurationInput>;
  update?: InputMaybe<PayrollPayGroupUpdateToOneWithWhereWithoutPayrollRunRollupConfigurationInput>;
  upsert?: InputMaybe<PayrollPayGroupUpsertWithoutPayrollRunRollupConfigurationInput>;
};

export type PayrollPayGroupUpdateOneWithoutBaseUserNestedInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutBaseUserInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutBaseUserInput>;
  delete?: InputMaybe<PayrollPayGroupWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PayrollPayGroupUpdateToOneWithWhereWithoutBaseUserInput>;
  upsert?: InputMaybe<PayrollPayGroupUpsertWithoutBaseUserInput>;
};

export type PayrollPayGroupUpdateOneWithoutDonationNestedInput = {
  connect?: InputMaybe<PayrollPayGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollPayGroupCreateOrConnectWithoutDonationInput>;
  create?: InputMaybe<PayrollPayGroupCreateWithoutDonationInput>;
  delete?: InputMaybe<PayrollPayGroupWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PayrollPayGroupUpdateToOneWithWhereWithoutDonationInput>;
  upsert?: InputMaybe<PayrollPayGroupUpsertWithoutDonationInput>;
};

export type PayrollPayGroupUpdateToOneWithWhereWithoutBaseUserInput = {
  data: PayrollPayGroupUpdateWithoutBaseUserInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpdateToOneWithWhereWithoutDonationInput = {
  data: PayrollPayGroupUpdateWithoutDonationInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpdateToOneWithWhereWithoutPayrollRunFlatFileInput = {
  data: PayrollPayGroupUpdateWithoutPayrollRunFlatFileInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpdateToOneWithWhereWithoutPayrollRunRollupConfigurationInput = {
  data: PayrollPayGroupUpdateWithoutPayrollRunRollupConfigurationInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpdateWithoutBaseUserInput = {
  Donation?: InputMaybe<DonationUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateWithoutDonationInput = {
  BaseUser?: InputMaybe<BaseUserUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateWithoutPayrollRunFlatFileInput = {
  BaseUser?: InputMaybe<BaseUserUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpdateWithoutPayrollRunRollupConfigurationInput = {
  BaseUser?: InputMaybe<BaseUserUpdateManyWithoutPayrollPayGroupNestedInput>;
  Donation?: InputMaybe<DonationUpdateManyWithoutPayrollPayGroupNestedInput>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileUpdateManyWithoutPayrollPayGroupNestedInput>;
  adapterProvider?: InputMaybe<NullableEnumAdapterProviderFieldUpdateOperationsInput>;
  adapterProviderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isLeader?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  leaderPayGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupDisplayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFieldUpdateOperationsInput>;
  payrollProviderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayGroupStatusFieldUpdateOperationsInput>;
  timeZone?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollPayGroupUpsertWithoutBaseUserInput = {
  create: PayrollPayGroupCreateWithoutBaseUserInput;
  update: PayrollPayGroupUpdateWithoutBaseUserInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpsertWithoutDonationInput = {
  create: PayrollPayGroupCreateWithoutDonationInput;
  update: PayrollPayGroupUpdateWithoutDonationInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpsertWithoutPayrollRunFlatFileInput = {
  create: PayrollPayGroupCreateWithoutPayrollRunFlatFileInput;
  update: PayrollPayGroupUpdateWithoutPayrollRunFlatFileInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupUpsertWithoutPayrollRunRollupConfigurationInput = {
  create: PayrollPayGroupCreateWithoutPayrollRunRollupConfigurationInput;
  update: PayrollPayGroupUpdateWithoutPayrollRunRollupConfigurationInput;
  where?: InputMaybe<PayrollPayGroupWhereInput>;
};

export type PayrollPayGroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  BaseUser?: InputMaybe<BaseUserListRelationFilter>;
  Donation?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileListRelationFilter>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationListRelationFilter>;
  adapterProvider?: InputMaybe<EnumAdapterProviderNullableFilter>;
  adapterProviderId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalPayGroupId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isLeader?: InputMaybe<BoolNullableFilter>;
  leaderPayGroupId?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payGroupDisplayName?: InputMaybe<StringFilter>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFilter>;
  payrollProviderId?: InputMaybe<StringFilter>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFilter>;
  status?: InputMaybe<EnumPayGroupStatusFilter>;
  timeZone?: InputMaybe<StringFilter>;
};

export type PayrollPayGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  BaseUser?: InputMaybe<BaseUserListRelationFilter>;
  Donation?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollPayGroupWhereInput>>>;
  PayrollRunFlatFile?: InputMaybe<PayrollRunFlatFileListRelationFilter>;
  PayrollRunRollupConfiguration?: InputMaybe<PayrollRunRollupConfigurationListRelationFilter>;
  adapterProvider?: InputMaybe<EnumAdapterProviderNullableFilter>;
  adapterProviderId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalPayGroupId?: InputMaybe<StringFilter>;
  externalPayGroupId_companyId_payrollProvider_payrollProviderId_payrollProviderType?: InputMaybe<PayrollPayGroupExternalPayGroupIdCompanyIdPayrollProviderPayrollProviderIdPayrollProviderTypeCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isLeader?: InputMaybe<BoolNullableFilter>;
  leaderPayGroupId?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payGroupDisplayName?: InputMaybe<StringFilter>;
  payGroupDisplayName_companyId_payrollProvider_payrollProviderId_payrollProviderType?: InputMaybe<PayrollPayGroupPayGroupDisplayNameCompanyIdPayrollProviderPayrollProviderIdPayrollProviderTypeCompoundUniqueInput>;
  payrollProvider?: InputMaybe<EnumPayrollProviderFilter>;
  payrollProviderId?: InputMaybe<StringFilter>;
  payrollProviderType?: InputMaybe<EnumPayrollProviderTypeFilter>;
  status?: InputMaybe<EnumPayGroupStatusFilter>;
  timeZone?: InputMaybe<StringFilter>;
};

export type PayrollPaymentOption = {
  __typename?: 'PayrollPaymentOption';
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  frequencyOptions: Array<PayrollDonationFrequencyOptions>;
  status?: Maybe<DonationPayrollPaymentOptionStatus>;
};

export type PayrollPaymentOptionCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionObjectEqualityInput>>>;
  every?: InputMaybe<PayrollPaymentOptionWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PayrollPaymentOptionWhereInput>;
  some?: InputMaybe<PayrollPaymentOptionWhereInput>;
};

export type PayrollPaymentOptionCreateInput = {
  code: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  frequencyOptions?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  status?: InputMaybe<DonationPayrollPaymentOptionStatus>;
};

export type PayrollPaymentOptionCreatefrequencyOptionsInput = {
  set: PayrollDonationFrequencyOptions;
};

export type PayrollPaymentOptionDeleteManyInput = {
  where: PayrollPaymentOptionWhereInput;
};

export type PayrollPaymentOptionListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<PayrollPaymentOptionDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionCreateInput>>>;
  updateMany?: InputMaybe<PayrollPaymentOptionUpdateManyInput>;
};

export type PayrollPaymentOptionObjectEqualityInput = {
  code: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  frequencyOptions?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  status?: InputMaybe<DonationPayrollPaymentOptionStatus>;
};

export type PayrollPaymentOptionOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PayrollPaymentOptionUpdateInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<StringFieldUpdateOperationsInput>;
  frequencyOptions?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  status?: InputMaybe<NullableEnumDonationPayrollPaymentOptionStatusFieldUpdateOperationsInput>;
};

export type PayrollPaymentOptionUpdateManyInput = {
  data: PayrollPaymentOptionUpdateInput;
  where: PayrollPaymentOptionWhereInput;
};

export type PayrollPaymentOptionUpdatefrequencyOptionsInput = {
  push?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollDonationFrequencyOptions>>>;
};

export type PayrollPaymentOptionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollPaymentOptionWhereInput>>>;
  code?: InputMaybe<StringFilter>;
  displayName?: InputMaybe<StringFilter>;
  frequencyOptions?: InputMaybe<EnumPayrollDonationFrequencyOptionsNullableListFilter>;
  status?: InputMaybe<EnumDonationPayrollPaymentOptionStatusNullableFilter>;
};

export enum PayrollProcessorType {
  PayCycle = 'PayCycle',
  Signal = 'Signal'
}

export enum PayrollProvider {
  Adp = 'ADP',
  BambooHr = 'BambooHr',
  CeridianDayforce = 'CeridianDayforce',
  ChartHop = 'ChartHop',
  DeedFlatFileSftp = 'DeedFlatFileSFTP',
  Paylocity = 'Paylocity',
  Sap = 'SAP',
  UkgPro = 'UkgPro',
  Workday = 'Workday'
}

export enum PayrollProviderType {
  Api = 'API',
  FlatFile = 'FLAT_FILE'
}

export type PayrollRun = {
  __typename?: 'PayrollRun';
  _count: PayrollRunCountOutputType;
  checkDate?: Maybe<Scalars['DateTime']['output']>;
  company: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mergeId?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payGroupMergeId: Scalars['String']['output'];
  runState: PayrollRunStateType;
  runType?: Maybe<PayrollRunType>;
  startDate: Scalars['DateTime']['output'];
  /** Get payroll donations stats for a payroll */
  stats: PayrollRunStats;
};

export type PayrollRunCompact = {
  __typename?: 'PayrollRunCompact';
  currencyCode: Currency;
  endDateExternal: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payrollPayGroupId: Scalars['String']['output'];
  startDateExternal: Scalars['DateTime']['output'];
  total: Scalars['Float']['output'];
};

export type PayrollRunCountAggregateOutputType = {
  __typename?: 'PayrollRunCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  checkDate: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mergeId: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  payDate: Scalars['Int']['output'];
  payGroupMergeId: Scalars['Int']['output'];
  runState: Scalars['Int']['output'];
  runType: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
};

export type PayrollRunCountOrderByAggregateInput = {
  checkDate?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payGroupMergeId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  runType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type PayrollRunCountOutputType = {
  __typename?: 'PayrollRunCountOutputType';
  Donations: Scalars['Int']['output'];
};

export type PayrollRunCreateInput = {
  Donations?: InputMaybe<DonationCreateNestedManyWithoutPayrollRunInput>;
  checkDate?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupMergeId: Scalars['String']['input'];
  runState: PayrollRunStateType;
  runType?: InputMaybe<PayrollRunType>;
  startDate: Scalars['DateTime']['input'];
};

export type PayrollRunCreateManyInput = {
  checkDate?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupMergeId: Scalars['String']['input'];
  runState: PayrollRunStateType;
  runType?: InputMaybe<PayrollRunType>;
  startDate: Scalars['DateTime']['input'];
};

export type PayrollRunCreateNestedOneWithoutDonationsInput = {
  connect?: InputMaybe<PayrollRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollRunCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<PayrollRunCreateWithoutDonationsInput>;
};

export type PayrollRunCreateOrConnectWithoutDonationsInput = {
  create: PayrollRunCreateWithoutDonationsInput;
  where: PayrollRunWhereUniqueInput;
};

export type PayrollRunCreateWithoutDonationsInput = {
  checkDate?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupMergeId: Scalars['String']['input'];
  runState: PayrollRunStateType;
  runType?: InputMaybe<PayrollRunType>;
  startDate: Scalars['DateTime']['input'];
};

export type PayrollRunDeduction = {
  __typename?: 'PayrollRunDeduction';
  createdAt: Scalars['DateTime']['output'];
  deductionAmount: Scalars['Float']['output'];
  deductionCurrency: Currency;
  deductionFilename?: Maybe<Scalars['String']['output']>;
  donationIds: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  metadata?: Maybe<PayrollRunDeductionMetadata>;
  modifiedAt: Scalars['DateTime']['output'];
  payGroupId: Scalars['String']['output'];
  payrollRunId: Scalars['String']['output'];
  rollupKey: Scalars['String']['output'];
  status: PayrollRunDeductionStatus;
};

export type PayrollRunDeductionAvgAggregateOutputType = {
  __typename?: 'PayrollRunDeductionAvgAggregateOutputType';
  deductionAmount?: Maybe<Scalars['Float']['output']>;
};

export type PayrollRunDeductionAvgOrderByAggregateInput = {
  deductionAmount?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionCountAggregateOutputType = {
  __typename?: 'PayrollRunDeductionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deductionAmount: Scalars['Int']['output'];
  deductionCurrency: Scalars['Int']['output'];
  deductionFilename: Scalars['Int']['output'];
  donationIds: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  employeeId: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  payGroupId: Scalars['Int']['output'];
  payrollRunId: Scalars['Int']['output'];
  rollupKey: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
};

export type PayrollRunDeductionCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deductionAmount?: InputMaybe<SortOrder>;
  deductionCurrency?: InputMaybe<SortOrder>;
  deductionFilename?: InputMaybe<SortOrder>;
  donationIds?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deductionAmount: Scalars['Float']['input'];
  deductionCurrency: Currency;
  deductionFilename?: InputMaybe<Scalars['String']['input']>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupId: Scalars['String']['input'];
  payrollRunId: Scalars['String']['input'];
  rollupKey: Scalars['String']['input'];
  status: PayrollRunDeductionStatus;
};

export type PayrollRunDeductionCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deductionAmount: Scalars['Float']['input'];
  deductionCurrency: Currency;
  deductionFilename?: InputMaybe<Scalars['String']['input']>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupId: Scalars['String']['input'];
  payrollRunId: Scalars['String']['input'];
  rollupKey: Scalars['String']['input'];
  status: PayrollRunDeductionStatus;
};

export type PayrollRunDeductionCreatedonationIdsInput = {
  set: Scalars['String']['input'];
};

export enum PayrollRunDeductionFrequency {
  OneTime = 'OneTime',
  Payroll = 'Payroll'
}

export type PayrollRunDeductionMaxAggregateOutputType = {
  __typename?: 'PayrollRunDeductionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deductionAmount?: Maybe<Scalars['Float']['output']>;
  deductionCurrency?: Maybe<Currency>;
  deductionFilename?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payGroupId?: Maybe<Scalars['String']['output']>;
  payrollRunId?: Maybe<Scalars['String']['output']>;
  rollupKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayrollRunDeductionStatus>;
};

export type PayrollRunDeductionMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deductionAmount?: InputMaybe<SortOrder>;
  deductionCurrency?: InputMaybe<SortOrder>;
  deductionFilename?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionMetadata = {
  __typename?: 'PayrollRunDeductionMetadata';
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<PayrollRunDeductionFrequency>;
  lastName?: Maybe<Scalars['String']['output']>;
  payrollRunEndDate?: Maybe<Scalars['String']['output']>;
  payrollRunExternalEndDate?: Maybe<Scalars['String']['output']>;
  payrollRunExternalStartDate?: Maybe<Scalars['String']['output']>;
  payrollRunStartDate?: Maybe<Scalars['String']['output']>;
  rollupKey?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
};

export type PayrollRunDeductionMetadataCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<PayrollRunDeductionFrequency>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payrollRunEndDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunExternalEndDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunExternalStartDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunStartDate?: InputMaybe<Scalars['String']['input']>;
  rollupKey?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollRunDeductionMetadataNullableCompositeFilter = {
  equals?: InputMaybe<PayrollRunDeductionMetadataObjectEqualityInput>;
  is?: InputMaybe<PayrollRunDeductionMetadataWhereInput>;
  isNot?: InputMaybe<PayrollRunDeductionMetadataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PayrollRunDeductionMetadataNullableCreateEnvelopeInput = {
  set?: InputMaybe<PayrollRunDeductionMetadataCreateInput>;
};

export type PayrollRunDeductionMetadataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PayrollRunDeductionMetadataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PayrollRunDeductionMetadataUpsertInput>;
};

export type PayrollRunDeductionMetadataObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<PayrollRunDeductionFrequency>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payrollRunEndDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunExternalEndDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunExternalStartDate?: InputMaybe<Scalars['String']['input']>;
  payrollRunStartDate?: InputMaybe<Scalars['String']['input']>;
  rollupKey?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollRunDeductionMetadataOrderByInput = {
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  frequency?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  payrollRunEndDate?: InputMaybe<SortOrder>;
  payrollRunExternalEndDate?: InputMaybe<SortOrder>;
  payrollRunExternalStartDate?: InputMaybe<SortOrder>;
  payrollRunStartDate?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  subType?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionMetadataUpdateInput = {
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frequency?: InputMaybe<NullableEnumPayrollRunDeductionFrequencyFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunEndDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunExternalEndDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunExternalStartDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payrollRunStartDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rollupKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PayrollRunDeductionMetadataUpsertInput = {
  set: PayrollRunDeductionMetadataCreateInput;
  update: PayrollRunDeductionMetadataUpdateInput;
};

export type PayrollRunDeductionMetadataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunDeductionMetadataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunDeductionMetadataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunDeductionMetadataWhereInput>>>;
  email?: InputMaybe<StringNullableFilter>;
  employeeId?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  frequency?: InputMaybe<EnumPayrollRunDeductionFrequencyNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  payrollRunEndDate?: InputMaybe<StringNullableFilter>;
  payrollRunExternalEndDate?: InputMaybe<StringNullableFilter>;
  payrollRunExternalStartDate?: InputMaybe<StringNullableFilter>;
  payrollRunStartDate?: InputMaybe<StringNullableFilter>;
  rollupKey?: InputMaybe<StringNullableFilter>;
  subType?: InputMaybe<StringNullableFilter>;
};

export type PayrollRunDeductionMinAggregateOutputType = {
  __typename?: 'PayrollRunDeductionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deductionAmount?: Maybe<Scalars['Float']['output']>;
  deductionCurrency?: Maybe<Currency>;
  deductionFilename?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payGroupId?: Maybe<Scalars['String']['output']>;
  payrollRunId?: Maybe<Scalars['String']['output']>;
  rollupKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayrollRunDeductionStatus>;
};

export type PayrollRunDeductionMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deductionAmount?: InputMaybe<SortOrder>;
  deductionCurrency?: InputMaybe<SortOrder>;
  deductionFilename?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionOrderByWithAggregationInput = {
  _avg?: InputMaybe<PayrollRunDeductionAvgOrderByAggregateInput>;
  _count?: InputMaybe<PayrollRunDeductionCountOrderByAggregateInput>;
  _max?: InputMaybe<PayrollRunDeductionMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayrollRunDeductionMinOrderByAggregateInput>;
  _sum?: InputMaybe<PayrollRunDeductionSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deductionAmount?: InputMaybe<SortOrder>;
  deductionCurrency?: InputMaybe<SortOrder>;
  deductionFilename?: InputMaybe<SortOrder>;
  donationIds?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deductionAmount?: InputMaybe<SortOrder>;
  deductionCurrency?: InputMaybe<SortOrder>;
  deductionFilename?: InputMaybe<SortOrder>;
  donationIds?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataOrderByInput>;
  modifiedAt?: InputMaybe<SortOrder>;
  payGroupId?: InputMaybe<SortOrder>;
  payrollRunId?: InputMaybe<SortOrder>;
  rollupKey?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionRollupKeyPayrollRunIdCompoundUniqueInput = {
  payrollRunId: Scalars['String']['input'];
  rollupKey: Scalars['String']['input'];
};

export enum PayrollRunDeductionScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeductionAmount = 'deductionAmount',
  DeductionCurrency = 'deductionCurrency',
  DeductionFilename = 'deductionFilename',
  DonationIds = 'donationIds',
  Email = 'email',
  EmployeeId = 'employeeId',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  ModifiedAt = 'modifiedAt',
  PayGroupId = 'payGroupId',
  PayrollRunId = 'payrollRunId',
  RollupKey = 'rollupKey',
  Status = 'status'
}

export type PayrollRunDeductionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunDeductionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunDeductionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunDeductionScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deductionAmount?: InputMaybe<FloatWithAggregatesFilter>;
  deductionCurrency?: InputMaybe<EnumCurrencyWithAggregatesFilter>;
  deductionFilename?: InputMaybe<StringNullableWithAggregatesFilter>;
  donationIds?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  employeeId?: InputMaybe<StringWithAggregatesFilter>;
  firstName?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastName?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  payGroupId?: InputMaybe<StringWithAggregatesFilter>;
  payrollRunId?: InputMaybe<StringWithAggregatesFilter>;
  rollupKey?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusWithAggregatesFilter>;
};

export enum PayrollRunDeductionStatus {
  Canceled = 'Canceled',
  Deducted = 'Deducted',
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Unresolved = 'Unresolved'
}

export type PayrollRunDeductionSumAggregateOutputType = {
  __typename?: 'PayrollRunDeductionSumAggregateOutputType';
  deductionAmount?: Maybe<Scalars['Float']['output']>;
};

export type PayrollRunDeductionSumOrderByAggregateInput = {
  deductionAmount?: InputMaybe<SortOrder>;
};

export type PayrollRunDeductionUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deductionAmount: Scalars['Float']['input'];
  deductionCurrency: Currency;
  deductionFilename?: InputMaybe<Scalars['String']['input']>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupId: Scalars['String']['input'];
  payrollRunId: Scalars['String']['input'];
  rollupKey: Scalars['String']['input'];
  status: PayrollRunDeductionStatus;
};

export type PayrollRunDeductionUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deductionAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  deductionCurrency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  deductionFilename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  employeeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFieldUpdateOperationsInput>;
};

export type PayrollRunDeductionUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deductionAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  deductionCurrency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  deductionFilename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  employeeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFieldUpdateOperationsInput>;
};

export type PayrollRunDeductionUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deductionAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  deductionCurrency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  deductionFilename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  employeeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFieldUpdateOperationsInput>;
};

export type PayrollRunDeductionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deductionAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  deductionCurrency?: InputMaybe<EnumCurrencyFieldUpdateOperationsInput>;
  deductionFilename?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  employeeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  payrollRunId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFieldUpdateOperationsInput>;
};

export type PayrollRunDeductionUpdatedonationIdsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PayrollRunDeductionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deductionAmount?: InputMaybe<FloatFilter>;
  deductionCurrency?: InputMaybe<EnumCurrencyFilter>;
  deductionFilename?: InputMaybe<StringNullableFilter>;
  donationIds?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payGroupId?: InputMaybe<StringFilter>;
  payrollRunId?: InputMaybe<StringFilter>;
  rollupKey?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFilter>;
};

export type PayrollRunDeductionWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunDeductionWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deductionAmount?: InputMaybe<FloatFilter>;
  deductionCurrency?: InputMaybe<EnumCurrencyFilter>;
  deductionFilename?: InputMaybe<StringNullableFilter>;
  donationIds?: InputMaybe<StringNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<PayrollRunDeductionMetadataNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payGroupId?: InputMaybe<StringFilter>;
  payrollRunId?: InputMaybe<StringFilter>;
  rollupKey?: InputMaybe<StringFilter>;
  rollupKey_payrollRunId?: InputMaybe<PayrollRunDeductionRollupKeyPayrollRunIdCompoundUniqueInput>;
  status?: InputMaybe<EnumPayrollRunDeductionStatusFilter>;
};

export type PayrollRunFlatFile = {
  __typename?: 'PayrollRunFlatFile';
  Company: Organization;
  PayrollPayGroup: PayrollPayGroup;
  _count: PayrollRunFlatFileCountOutputType;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Get payroll donations for payrollrunsflatfile */
  donations: PaginatedDonations;
  endDate: Scalars['DateTime']['output'];
  endDateExternal?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefaultPaymentMethod: Scalars['Boolean']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  payDate?: Maybe<Scalars['DateTime']['output']>;
  paymentOptions: Array<PayrollPaymentOption>;
  payrollPayGroupId: Scalars['String']['output'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  startDateExternal?: Maybe<Scalars['DateTime']['output']>;
  /** Get payroll donations stats for a payroll flat file */
  stats: PayrollRunFlatFileStats;
  transmissionDate?: Maybe<Scalars['DateTime']['output']>;
};


export type PayrollRunFlatFileDonationsArgs = {
  employeeTerm?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  nonprofitTerm?: InputMaybe<Scalars['String']['input']>;
  paymentStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollRunFlatFileCountAggregateOutputType = {
  __typename?: 'PayrollRunFlatFileCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  endDateExternal: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  payDate: Scalars['Int']['output'];
  payrollPayGroupId: Scalars['Int']['output'];
  runState: Scalars['Int']['output'];
  sourceFileName: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  startDateExternal: Scalars['Int']['output'];
  transmissionDate: Scalars['Int']['output'];
};

export type PayrollRunFlatFileCountOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endDateExternal?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  sourceFileName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startDateExternal?: InputMaybe<SortOrder>;
  transmissionDate?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFileCountOutputType = {
  __typename?: 'PayrollRunFlatFileCountOutputType';
  Donations: Scalars['Int']['output'];
};

export type PayrollRunFlatFileCreateInput = {
  Company: OrganizationCreateNestedOneWithoutPayrollRunFlatFileInput;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutPayrollRunFlatFileInput>;
  PayrollPayGroup: PayrollPayGroupCreateNestedOneWithoutPayrollRunFlatFileInput;
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateManyCompanyInput = {
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateManyCompanyInputEnvelope = {
  data: PayrollRunFlatFileCreateManyCompanyInput;
};

export type PayrollRunFlatFileCreateManyInput = {
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateManyPayrollPayGroupInput = {
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateManyPayrollPayGroupInputEnvelope = {
  data: PayrollRunFlatFileCreateManyPayrollPayGroupInput;
};

export type PayrollRunFlatFileCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyCompanyInputEnvelope>;
};

export type PayrollRunFlatFileCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyPayrollPayGroupInputEnvelope>;
};

export type PayrollRunFlatFileCreateNestedOneWithoutDonationsInput = {
  connect?: InputMaybe<PayrollRunFlatFileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<PayrollRunFlatFileCreateWithoutDonationsInput>;
};

export type PayrollRunFlatFileCreateOrConnectWithoutCompanyInput = {
  create: PayrollRunFlatFileCreateWithoutCompanyInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileCreateOrConnectWithoutDonationsInput = {
  create: PayrollRunFlatFileCreateWithoutDonationsInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileCreateOrConnectWithoutPayrollPayGroupInput = {
  create: PayrollRunFlatFileCreateWithoutPayrollPayGroupInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileCreateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationCreateNestedManyWithoutPayrollRunFlatFileInput>;
  PayrollPayGroup: PayrollPayGroupCreateNestedOneWithoutPayrollRunFlatFileInput;
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateWithoutDonationsInput = {
  Company: OrganizationCreateNestedOneWithoutPayrollRunFlatFileInput;
  PayrollPayGroup: PayrollPayGroupCreateNestedOneWithoutPayrollRunFlatFileInput;
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileCreateWithoutPayrollPayGroupInput = {
  Company: OrganizationCreateNestedOneWithoutPayrollRunFlatFileInput;
  Donations?: InputMaybe<DonationCreateNestedManyWithoutPayrollRunFlatFileInput>;
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileListRelationFilter = {
  every?: InputMaybe<PayrollRunFlatFileWhereInput>;
  none?: InputMaybe<PayrollRunFlatFileWhereInput>;
  some?: InputMaybe<PayrollRunFlatFileWhereInput>;
};

export type PayrollRunFlatFileMaxAggregateOutputType = {
  __typename?: 'PayrollRunFlatFileMaxAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endDateExternal?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  runState?: Maybe<PayrollRunFlatFileStateType>;
  sourceFileName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startDateExternal?: Maybe<Scalars['DateTime']['output']>;
  transmissionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PayrollRunFlatFileMaxOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endDateExternal?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  sourceFileName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startDateExternal?: InputMaybe<SortOrder>;
  transmissionDate?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFileMinAggregateOutputType = {
  __typename?: 'PayrollRunFlatFileMinAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endDateExternal?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
  runState?: Maybe<PayrollRunFlatFileStateType>;
  sourceFileName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startDateExternal?: Maybe<Scalars['DateTime']['output']>;
  transmissionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PayrollRunFlatFileMinOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endDateExternal?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  sourceFileName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startDateExternal?: InputMaybe<SortOrder>;
  transmissionDate?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFileNullableRelationFilter = {
  is?: InputMaybe<PayrollRunFlatFileWhereInput>;
  isNot?: InputMaybe<PayrollRunFlatFileWhereInput>;
};

export type PayrollRunFlatFileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFileOrderByWithAggregationInput = {
  _count?: InputMaybe<PayrollRunFlatFileCountOrderByAggregateInput>;
  _max?: InputMaybe<PayrollRunFlatFileMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayrollRunFlatFileMinOrderByAggregateInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endDateExternal?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  sourceFileName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startDateExternal?: InputMaybe<SortOrder>;
  transmissionDate?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFileOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Donations?: InputMaybe<DonationOrderByRelationAggregateInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endDateExternal?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  sourceFileName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startDateExternal?: InputMaybe<SortOrder>;
  transmissionDate?: InputMaybe<SortOrder>;
};

export type PayrollRunFlatFilePayrollPayGroupIdEndDateCompoundUniqueInput = {
  endDate: Scalars['DateTime']['input'];
  payrollPayGroupId: Scalars['String']['input'];
};

export enum PayrollRunFlatFileScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  EndDateExternal = 'endDateExternal',
  ExternalId = 'externalId',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  PayDate = 'payDate',
  PayrollPayGroupId = 'payrollPayGroupId',
  RunState = 'runState',
  SourceFileName = 'sourceFileName',
  StartDate = 'startDate',
  StartDateExternal = 'startDateExternal',
  TransmissionDate = 'transmissionDate'
}

export type PayrollRunFlatFileScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  endDateExternal?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payDate?: InputMaybe<DateTimeNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFilter>;
  sourceFileName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  startDateExternal?: InputMaybe<DateTimeNullableFilter>;
  transmissionDate?: InputMaybe<DateTimeNullableFilter>;
};

export type PayrollRunFlatFileScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereWithAggregatesInput>>>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDateExternal?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  payDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  payrollPayGroupId?: InputMaybe<StringWithAggregatesFilter>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeWithAggregatesFilter>;
  sourceFileName?: InputMaybe<StringWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  startDateExternal?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  transmissionDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export enum PayrollRunFlatFileStateType {
  New = 'NEW',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

/** Stats of a payrollRun */
export type PayrollRunFlatFileStats = {
  __typename?: 'PayrollRunFlatFileStats';
  donationCount: Scalars['Int']['output'];
  donationCountPendingOrUnresolved: Scalars['Int']['output'];
  donationCountSuccess: Scalars['Int']['output'];
  isDonatable: Scalars['Boolean']['output'];
  totalUsd: Scalars['Float']['output'];
  totalUsdSuccess: Scalars['Float']['output'];
};

export type PayrollRunFlatFileUncheckedCreateInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollRunFlatFileInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyCompanyInputEnvelope>;
};

export type PayrollRunFlatFileUncheckedCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyPayrollPayGroupInputEnvelope>;
};

export type PayrollRunFlatFileUncheckedCreateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollRunFlatFileInput>;
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileUncheckedCreateWithoutDonationsInput = {
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileUncheckedCreateWithoutPayrollPayGroupInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollRunFlatFileInput>;
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  endDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  runState: PayrollRunFlatFileStateType;
  sourceFileName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateExternal?: InputMaybe<Scalars['DateTime']['input']>;
  transmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PayrollRunFlatFileUncheckedUpdateInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateManyInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type PayrollRunFlatFileUncheckedUpdateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateWithoutDonationsInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUncheckedUpdateWithoutPayrollPayGroupInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpdateManyWithWhereWithoutCompanyInput = {
  data: PayrollRunFlatFileUpdateManyMutationInput;
  where: PayrollRunFlatFileScalarWhereInput;
};

export type PayrollRunFlatFileUpdateManyWithWhereWithoutPayrollPayGroupInput = {
  data: PayrollRunFlatFileUpdateManyMutationInput;
  where: PayrollRunFlatFileScalarWhereInput;
};

export type PayrollRunFlatFileUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type PayrollRunFlatFileUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunFlatFileCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type PayrollRunFlatFileUpdateOneWithoutDonationsNestedInput = {
  connect?: InputMaybe<PayrollRunFlatFileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollRunFlatFileCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<PayrollRunFlatFileCreateWithoutDonationsInput>;
  delete?: InputMaybe<PayrollRunFlatFileWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PayrollRunFlatFileUpdateToOneWithWhereWithoutDonationsInput>;
  upsert?: InputMaybe<PayrollRunFlatFileUpsertWithoutDonationsInput>;
};

export type PayrollRunFlatFileUpdateToOneWithWhereWithoutDonationsInput = {
  data: PayrollRunFlatFileUpdateWithoutDonationsInput;
  where?: InputMaybe<PayrollRunFlatFileWhereInput>;
};

export type PayrollRunFlatFileUpdateWithWhereUniqueWithoutCompanyInput = {
  data: PayrollRunFlatFileUpdateWithoutCompanyInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileUpdateWithWhereUniqueWithoutPayrollPayGroupInput = {
  data: PayrollRunFlatFileUpdateWithoutPayrollPayGroupInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileUpdateWithoutCompanyInput = {
  Donations?: InputMaybe<DonationUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpdateWithoutDonationsInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpdateWithoutPayrollPayGroupInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayrollRunFlatFileNestedInput>;
  Donations?: InputMaybe<DonationUpdateManyWithoutPayrollRunFlatFileNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFieldUpdateOperationsInput>;
  sourceFileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDateExternal?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transmissionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunFlatFileUpsertWithWhereUniqueWithoutCompanyInput = {
  create: PayrollRunFlatFileCreateWithoutCompanyInput;
  update: PayrollRunFlatFileUpdateWithoutCompanyInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileUpsertWithWhereUniqueWithoutPayrollPayGroupInput = {
  create: PayrollRunFlatFileCreateWithoutPayrollPayGroupInput;
  update: PayrollRunFlatFileUpdateWithoutPayrollPayGroupInput;
  where: PayrollRunFlatFileWhereUniqueInput;
};

export type PayrollRunFlatFileUpsertWithoutDonationsInput = {
  create: PayrollRunFlatFileCreateWithoutDonationsInput;
  update: PayrollRunFlatFileUpdateWithoutDonationsInput;
  where?: InputMaybe<PayrollRunFlatFileWhereInput>;
};

export type PayrollRunFlatFileWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  endDateExternal?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payDate?: InputMaybe<DateTimeNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFilter>;
  sourceFileName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  startDateExternal?: InputMaybe<DateTimeNullableFilter>;
  transmissionDate?: InputMaybe<DateTimeNullableFilter>;
};

export type PayrollRunFlatFileWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunFlatFileWhereInput>>>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  endDateExternal?: InputMaybe<DateTimeNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payDate?: InputMaybe<DateTimeNullableFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  payrollPayGroupId_endDate?: InputMaybe<PayrollRunFlatFilePayrollPayGroupIdEndDateCompoundUniqueInput>;
  runState?: InputMaybe<EnumPayrollRunFlatFileStateTypeFilter>;
  sourceFileName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  startDateExternal?: InputMaybe<DateTimeNullableFilter>;
  transmissionDate?: InputMaybe<DateTimeNullableFilter>;
};

export type PayrollRunMaxAggregateOutputType = {
  __typename?: 'PayrollRunMaxAggregateOutputType';
  checkDate?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mergeId?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payGroupMergeId?: Maybe<Scalars['String']['output']>;
  runState?: Maybe<PayrollRunStateType>;
  runType?: Maybe<PayrollRunType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PayrollRunMaxOrderByAggregateInput = {
  checkDate?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payGroupMergeId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  runType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type PayrollRunMinAggregateOutputType = {
  __typename?: 'PayrollRunMinAggregateOutputType';
  checkDate?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mergeId?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payGroupMergeId?: Maybe<Scalars['String']['output']>;
  runState?: Maybe<PayrollRunStateType>;
  runType?: Maybe<PayrollRunType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PayrollRunMinOrderByAggregateInput = {
  checkDate?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payGroupMergeId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  runType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type PayrollRunNullableRelationFilter = {
  is?: InputMaybe<PayrollRunWhereInput>;
  isNot?: InputMaybe<PayrollRunWhereInput>;
};

export type PayrollRunOrderByWithAggregationInput = {
  _count?: InputMaybe<PayrollRunCountOrderByAggregateInput>;
  _max?: InputMaybe<PayrollRunMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayrollRunMinOrderByAggregateInput>;
  checkDate?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payGroupMergeId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  runType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type PayrollRunOrderByWithRelationInput = {
  Donations?: InputMaybe<DonationOrderByRelationAggregateInput>;
  checkDate?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mergeId?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payDate?: InputMaybe<SortOrder>;
  payGroupMergeId?: InputMaybe<SortOrder>;
  runState?: InputMaybe<SortOrder>;
  runType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfiguration = {
  __typename?: 'PayrollRunRollupConfiguration';
  Organization: Organization;
  PayrollPayGroup: PayrollPayGroup;
  active: Scalars['Boolean']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  payrollPayGroupId: Scalars['String']['output'];
  rollupKeyDefinition: Array<PayrollRunRollupLevel>;
};

export type PayrollRunRollupConfigurationCountAggregateOutputType = {
  __typename?: 'PayrollRunRollupConfigurationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  payrollPayGroupId: Scalars['Int']['output'];
  rollupKeyDefinition: Scalars['Int']['output'];
};

export type PayrollRunRollupConfigurationCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  rollupKeyDefinition?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationCreateInput = {
  Organization: OrganizationCreateNestedOneWithoutPayrollRunRollupConfigurationInput;
  PayrollPayGroup: PayrollPayGroupCreateNestedOneWithoutPayrollRunRollupConfigurationInput;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreateManyOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreateManyOrganizationInputEnvelope = {
  data: PayrollRunRollupConfigurationCreateManyOrganizationInput;
};

export type PayrollRunRollupConfigurationCreateManyPayrollPayGroupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreateManyPayrollPayGroupInputEnvelope = {
  data: PayrollRunRollupConfigurationCreateManyPayrollPayGroupInput;
};

export type PayrollRunRollupConfigurationCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyOrganizationInputEnvelope>;
};

export type PayrollRunRollupConfigurationCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyPayrollPayGroupInputEnvelope>;
};

export type PayrollRunRollupConfigurationCreateOrConnectWithoutOrganizationInput = {
  create: PayrollRunRollupConfigurationCreateWithoutOrganizationInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationCreateOrConnectWithoutPayrollPayGroupInput = {
  create: PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationCreateWithoutOrganizationInput = {
  PayrollPayGroup: PayrollPayGroupCreateNestedOneWithoutPayrollRunRollupConfigurationInput;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput = {
  Organization: OrganizationCreateNestedOneWithoutPayrollRunRollupConfigurationInput;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationCreaterollupKeyDefinitionInput = {
  set: PayrollRunRollupLevel;
};

export type PayrollRunRollupConfigurationListRelationFilter = {
  every?: InputMaybe<PayrollRunRollupConfigurationWhereInput>;
  none?: InputMaybe<PayrollRunRollupConfigurationWhereInput>;
  some?: InputMaybe<PayrollRunRollupConfigurationWhereInput>;
};

export type PayrollRunRollupConfigurationMaxAggregateOutputType = {
  __typename?: 'PayrollRunRollupConfigurationMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
};

export type PayrollRunRollupConfigurationMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationMinAggregateOutputType = {
  __typename?: 'PayrollRunRollupConfigurationMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  payrollPayGroupId?: Maybe<Scalars['String']['output']>;
};

export type PayrollRunRollupConfigurationMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationOrderByWithAggregationInput = {
  _count?: InputMaybe<PayrollRunRollupConfigurationCountOrderByAggregateInput>;
  _max?: InputMaybe<PayrollRunRollupConfigurationMaxOrderByAggregateInput>;
  _min?: InputMaybe<PayrollRunRollupConfigurationMinOrderByAggregateInput>;
  active?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  rollupKeyDefinition?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationOrderByWithRelationInput = {
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupOrderByWithRelationInput>;
  active?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  payrollPayGroupId?: InputMaybe<SortOrder>;
  rollupKeyDefinition?: InputMaybe<SortOrder>;
};

export type PayrollRunRollupConfigurationRollupKeyDefinitionCompanyIdPayrollPayGroupIdCompoundUniqueInput = {
  companyId: Scalars['String']['input'];
  payrollPayGroupId: Scalars['String']['input'];
  rollupKeyDefinition: PayrollRunRollupLevel;
};

export enum PayrollRunRollupConfigurationScalarFieldEnum {
  Active = 'active',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  PayrollPayGroupId = 'payrollPayGroupId',
  RollupKeyDefinition = 'rollupKeyDefinition'
}

export type PayrollRunRollupConfigurationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  active?: InputMaybe<BoolFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  rollupKeyDefinition?: InputMaybe<EnumPayrollRunRollupLevelNullableListFilter>;
};

export type PayrollRunRollupConfigurationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereWithAggregatesInput>>>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  payrollPayGroupId?: InputMaybe<StringWithAggregatesFilter>;
  rollupKeyDefinition?: InputMaybe<EnumPayrollRunRollupLevelNullableListFilter>;
};

export type PayrollRunRollupConfigurationUncheckedCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyOrganizationInputEnvelope>;
};

export type PayrollRunRollupConfigurationUncheckedCreateNestedManyWithoutPayrollPayGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyPayrollPayGroupInputEnvelope>;
};

export type PayrollRunRollupConfigurationUncheckedCreateWithoutOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payrollPayGroupId: Scalars['String']['input'];
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedCreateWithoutPayrollPayGroupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateManyInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateWithoutOrganizationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payrollPayGroupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUncheckedUpdateWithoutPayrollPayGroupInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpdateInput = {
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpdateManyWithWhereWithoutOrganizationInput = {
  data: PayrollRunRollupConfigurationUpdateManyMutationInput;
  where: PayrollRunRollupConfigurationScalarWhereInput;
};

export type PayrollRunRollupConfigurationUpdateManyWithWhereWithoutPayrollPayGroupInput = {
  data: PayrollRunRollupConfigurationUpdateManyMutationInput;
  where: PayrollRunRollupConfigurationScalarWhereInput;
};

export type PayrollRunRollupConfigurationUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type PayrollRunRollupConfigurationUpdateManyWithoutPayrollPayGroupNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateOrConnectWithoutPayrollPayGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput>>>;
  createMany?: InputMaybe<PayrollRunRollupConfigurationCreateManyPayrollPayGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutPayrollPayGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpdateManyWithWhereWithoutPayrollPayGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutPayrollPayGroupInput>>>;
};

export type PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: PayrollRunRollupConfigurationUpdateWithoutOrganizationInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationUpdateWithWhereUniqueWithoutPayrollPayGroupInput = {
  data: PayrollRunRollupConfigurationUpdateWithoutPayrollPayGroupInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationUpdateWithoutOrganizationInput = {
  PayrollPayGroup?: InputMaybe<PayrollPayGroupUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpdateWithoutPayrollPayGroupInput = {
  Organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPayrollRunRollupConfigurationNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rollupKeyDefinition?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpdaterollupKeyDefinitionInput = {
  push?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
  set?: InputMaybe<Array<InputMaybe<PayrollRunRollupLevel>>>;
};

export type PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: PayrollRunRollupConfigurationCreateWithoutOrganizationInput;
  update: PayrollRunRollupConfigurationUpdateWithoutOrganizationInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationUpsertWithWhereUniqueWithoutPayrollPayGroupInput = {
  create: PayrollRunRollupConfigurationCreateWithoutPayrollPayGroupInput;
  update: PayrollRunRollupConfigurationUpdateWithoutPayrollPayGroupInput;
  where: PayrollRunRollupConfigurationWhereUniqueInput;
};

export type PayrollRunRollupConfigurationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  rollupKeyDefinition?: InputMaybe<EnumPayrollRunRollupLevelNullableListFilter>;
};

export type PayrollRunRollupConfigurationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunRollupConfigurationWhereInput>>>;
  Organization?: InputMaybe<OrganizationRelationFilter>;
  PayrollPayGroup?: InputMaybe<PayrollPayGroupRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payrollPayGroupId?: InputMaybe<StringFilter>;
  rollupKeyDefinition?: InputMaybe<EnumPayrollRunRollupLevelNullableListFilter>;
  rollupKeyDefinition_companyId_payrollPayGroupId?: InputMaybe<PayrollRunRollupConfigurationRollupKeyDefinitionCompanyIdPayrollPayGroupIdCompoundUniqueInput>;
};

export enum PayrollRunRollupLevel {
  Currency = 'Currency',
  Donation = 'Donation',
  EmployeeId = 'EmployeeId',
  Frequency = 'Frequency',
  Nonprofit = 'Nonprofit',
  Organization = 'Organization',
  PayCycleEndDate = 'PayCycleEndDate',
  PayCycleExternalEndDate = 'PayCycleExternalEndDate',
  PaymentMethod = 'PaymentMethod',
  SubType = 'SubType',
  User = 'User'
}

export enum PayrollRunScalarFieldEnum {
  CheckDate = 'checkDate',
  Company = 'company',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  Id = 'id',
  MergeId = 'mergeId',
  ModifiedAt = 'modifiedAt',
  PayDate = 'payDate',
  PayGroupMergeId = 'payGroupMergeId',
  RunState = 'runState',
  RunType = 'runType',
  StartDate = 'startDate'
}

export type PayrollRunScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunScalarWhereWithAggregatesInput>>>;
  checkDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  mergeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  payDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  payGroupMergeId?: InputMaybe<StringWithAggregatesFilter>;
  runState?: InputMaybe<EnumPayrollRunStateTypeWithAggregatesFilter>;
  runType?: InputMaybe<EnumPayrollRunTypeNullableWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PayrollRunStateType {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Paid = 'PAID'
}

/** Stats of a payrollRun */
export type PayrollRunStats = {
  __typename?: 'PayrollRunStats';
  deductionActual?: Maybe<Scalars['Float']['output']>;
  deductionIntent?: Maybe<Scalars['Float']['output']>;
  donationCount?: Maybe<Scalars['Float']['output']>;
};

export enum PayrollRunType {
  ContractorLatePayments = 'CONTRACTOR_LATE_PAYMENTS',
  Correction = 'CORRECTION',
  CorrectionDisplay = 'CORRECTION_DISPLAY',
  ExcessHours = 'EXCESS_HOURS',
  FringeBenefits = 'FRINGE_BENEFITS',
  Init = 'INIT',
  NewHire = 'NEW_HIRE',
  OffCycle = 'OFF_CYCLE',
  Pop = 'POP',
  Reconciliation = 'RECONCILIATION',
  Regular = 'REGULAR',
  SignOnBonus = 'SIGN_ON_BONUS',
  SCorp = 'S_CORP',
  Termination = 'TERMINATION',
  Transition = 'TRANSITION'
}

export type PayrollRunUncheckedCreateInput = {
  Donations?: InputMaybe<DonationUncheckedCreateNestedManyWithoutPayrollRunInput>;
  checkDate?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupMergeId: Scalars['String']['input'];
  runState: PayrollRunStateType;
  runType?: InputMaybe<PayrollRunType>;
  startDate: Scalars['DateTime']['input'];
};

export type PayrollRunUncheckedCreateWithoutDonationsInput = {
  checkDate?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  payDate?: InputMaybe<Scalars['DateTime']['input']>;
  payGroupMergeId: Scalars['String']['input'];
  runState: PayrollRunStateType;
  runType?: InputMaybe<PayrollRunType>;
  startDate: Scalars['DateTime']['input'];
};

export type PayrollRunUncheckedUpdateInput = {
  Donations?: InputMaybe<DonationUncheckedUpdateManyWithoutPayrollRunNestedInput>;
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUncheckedUpdateManyInput = {
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUncheckedUpdateWithoutDonationsInput = {
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUpdateInput = {
  Donations?: InputMaybe<DonationUpdateManyWithoutPayrollRunNestedInput>;
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUpdateManyMutationInput = {
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUpdateOneWithoutDonationsNestedInput = {
  connect?: InputMaybe<PayrollRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PayrollRunCreateOrConnectWithoutDonationsInput>;
  create?: InputMaybe<PayrollRunCreateWithoutDonationsInput>;
  delete?: InputMaybe<PayrollRunWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PayrollRunUpdateToOneWithWhereWithoutDonationsInput>;
  upsert?: InputMaybe<PayrollRunUpsertWithoutDonationsInput>;
};

export type PayrollRunUpdateToOneWithWhereWithoutDonationsInput = {
  data: PayrollRunUpdateWithoutDonationsInput;
  where?: InputMaybe<PayrollRunWhereInput>;
};

export type PayrollRunUpdateWithoutDonationsInput = {
  checkDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  mergeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  payDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  payGroupMergeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFieldUpdateOperationsInput>;
  runType?: InputMaybe<NullableEnumPayrollRunTypeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PayrollRunUpsertWithoutDonationsInput = {
  create: PayrollRunCreateWithoutDonationsInput;
  update: PayrollRunUpdateWithoutDonationsInput;
  where?: InputMaybe<PayrollRunWhereInput>;
};

export type PayrollRunWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  checkDate?: InputMaybe<DateTimeNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  mergeId?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payDate?: InputMaybe<DateTimeNullableFilter>;
  payGroupMergeId?: InputMaybe<StringFilter>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFilter>;
  runType?: InputMaybe<EnumPayrollRunTypeNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type PayrollRunWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  Donations?: InputMaybe<DonationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollRunWhereInput>>>;
  checkDate?: InputMaybe<DateTimeNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  payDate?: InputMaybe<DateTimeNullableFilter>;
  payGroupMergeId?: InputMaybe<StringFilter>;
  runState?: InputMaybe<EnumPayrollRunStateTypeFilter>;
  runType?: InputMaybe<EnumPayrollRunTypeNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

/** Metadata pagination */
export type PayrollRunsMetaType = {
  __typename?: 'PayrollRunsMetaType';
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Volunteer Times and pagination meta */
export type PayrollRunsType = {
  __typename?: 'PayrollRunsType';
  items: Array<PayrollRunFlatFile>;
  metadata: PayrollRunsMetaType;
};

/** Payroll settings object */
export type PayrollSettings = {
  __typename?: 'PayrollSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  payGroupId?: Maybe<Scalars['String']['output']>;
  payrollDonationsCancellation?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<PayrollSettingsType>;
};

export enum PayrollSettingsType {
  Api = 'API',
  FlatFile = 'FLAT_FILE'
}

export type PayrollTransferDirectories = {
  __typename?: 'PayrollTransferDirectories';
  deduction: Scalars['String']['output'];
  reconciliation: Scalars['String']['output'];
};

export type PayrollTransferDirectoriesCompositeFilter = {
  equals?: InputMaybe<PayrollTransferDirectoriesObjectEqualityInput>;
  is?: InputMaybe<PayrollTransferDirectoriesWhereInput>;
  isNot?: InputMaybe<PayrollTransferDirectoriesWhereInput>;
};

export type PayrollTransferDirectoriesCreateInput = {
  deduction: Scalars['String']['input'];
  reconciliation: Scalars['String']['input'];
};

export type PayrollTransferDirectoriesObjectEqualityInput = {
  deduction: Scalars['String']['input'];
  reconciliation: Scalars['String']['input'];
};

export type PayrollTransferDirectoriesOrderByInput = {
  deduction?: InputMaybe<SortOrder>;
  reconciliation?: InputMaybe<SortOrder>;
};

export type PayrollTransferDirectoriesUpdateEnvelopeInput = {
  set?: InputMaybe<PayrollTransferDirectoriesCreateInput>;
  update?: InputMaybe<PayrollTransferDirectoriesUpdateInput>;
};

export type PayrollTransferDirectoriesUpdateInput = {
  deduction?: InputMaybe<StringFieldUpdateOperationsInput>;
  reconciliation?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PayrollTransferDirectoriesWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PayrollTransferDirectoriesWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PayrollTransferDirectoriesWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PayrollTransferDirectoriesWhereInput>>>;
  deduction?: InputMaybe<StringFilter>;
  reconciliation?: InputMaybe<StringFilter>;
};

export type PendingCorporateGivingDisbursements = {
  __typename?: 'PendingCorporateGivingDisbursements';
  items: Array<TotalByGivingAccountAndMonth>;
  metadata: PaginationMetadata;
};

export type PendingPayrollRunsPayload = {
  __typename?: 'PendingPayrollRunsPayload';
  items: Array<PayrollRunCompact>;
  metadata: PaginationMetadata;
};

export type Person = {
  __typename?: 'Person';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

export type PersonCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<PersonObjectEqualityInput>>>;
  every?: InputMaybe<PersonWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonWhereInput>;
  some?: InputMaybe<PersonWhereInput>;
};

export type PersonCreateInput = {
  createdAt: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  modifiedAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  owner: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  verified: Scalars['Boolean']['input'];
  verifiedAt: Scalars['DateTime']['input'];
};

export type PersonDeleteManyInput = {
  where: PersonWhereInput;
};

export type PersonListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
};

export type PersonListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<PersonDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<PersonCreateInput>>>;
  updateMany?: InputMaybe<PersonUpdateManyInput>;
};

export type PersonObjectEqualityInput = {
  createdAt: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  modifiedAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  owner: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  verified: Scalars['Boolean']['input'];
  verifiedAt: Scalars['DateTime']['input'];
};

export type PersonOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PersonUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  source?: InputMaybe<StringFieldUpdateOperationsInput>;
  sourceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  verifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PersonUpdateManyInput = {
  data: PersonUpdateInput;
  where: PersonWhereInput;
};

export type PersonWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PersonWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PersonWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PersonWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  owner?: InputMaybe<BoolFilter>;
  phone?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  sourceId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
  verified?: InputMaybe<BoolFilter>;
  verifiedAt?: InputMaybe<DateTimeFilter>;
};

export type Pledge = {
  __typename?: 'Pledge';
  donations?: Maybe<DonationsPledge>;
  /** config of giving goal */
  givingGoalConfig?: Maybe<GivingGoalConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validAt?: Maybe<Scalars['DateTime']['output']>;
  volunteering?: Maybe<VolunteeringPledge>;
  year: Scalars['Int']['output'];
};

export type PledgeCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<PledgeObjectEqualityInput>>>;
  every?: InputMaybe<PledgeWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PledgeWhereInput>;
  some?: InputMaybe<PledgeWhereInput>;
};

export type PledgeCreateInput = {
  donations?: InputMaybe<DonationsPledgeCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteering?: InputMaybe<VolunteeringPledgeCreateInput>;
  year: Scalars['Int']['input'];
};

export type PledgeDeleteManyInput = {
  where: PledgeWhereInput;
};

export type PledgeDonationInput = {
  amount: Scalars['Float']['input'];
  currencyCode: Currency;
};

export type PledgeListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
};

export type PledgeListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<PledgeDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<PledgeCreateInput>>>;
  updateMany?: InputMaybe<PledgeUpdateManyInput>;
};

export type PledgeObjectEqualityInput = {
  donations?: InputMaybe<DonationsPledgeObjectEqualityInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteering?: InputMaybe<VolunteeringPledgeObjectEqualityInput>;
  year: Scalars['Int']['input'];
};

export type PledgeOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PledgeUpdateInput = {
  donations?: InputMaybe<DonationsPledgeNullableUpdateEnvelopeInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteering?: InputMaybe<VolunteeringPledgeNullableUpdateEnvelopeInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PledgeUpdateManyInput = {
  data: PledgeUpdateInput;
  where: PledgeWhereInput;
};

export type PledgeVolunteeringInput = {
  minutes: Scalars['Int']['input'];
};

export type PledgeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PledgeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PledgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PledgeWhereInput>>>;
  donations?: InputMaybe<DonationsPledgeNullableCompositeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  validAt?: InputMaybe<DateTimeNullableFilter>;
  volunteering?: InputMaybe<VolunteeringPledgeNullableCompositeFilter>;
  year?: InputMaybe<IntFilter>;
};

export type PreferredName = {
  __typename?: 'PreferredName';
  first: Scalars['String']['output'];
  last?: Maybe<Scalars['String']['output']>;
};

export type PreferredNameCreateInput = {
  first: Scalars['String']['input'];
  last?: InputMaybe<Scalars['String']['input']>;
};

export type PreferredNameNullableCompositeFilter = {
  equals?: InputMaybe<PreferredNameObjectEqualityInput>;
  is?: InputMaybe<PreferredNameWhereInput>;
  isNot?: InputMaybe<PreferredNameWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreferredNameNullableCreateEnvelopeInput = {
  set?: InputMaybe<PreferredNameCreateInput>;
};

export type PreferredNameNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PreferredNameCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<PreferredNameUpsertInput>;
};

export type PreferredNameObjectEqualityInput = {
  first: Scalars['String']['input'];
  last?: InputMaybe<Scalars['String']['input']>;
};

export type PreferredNameOrderByInput = {
  first?: InputMaybe<SortOrder>;
  last?: InputMaybe<SortOrder>;
};

export type PreferredNameUpdateInput = {
  first?: InputMaybe<StringFieldUpdateOperationsInput>;
  last?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PreferredNameUpsertInput = {
  set: PreferredNameCreateInput;
  update: PreferredNameUpdateInput;
};

export type PreferredNameWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PreferredNameWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PreferredNameWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PreferredNameWhereInput>>>;
  first?: InputMaybe<StringFilter>;
  last?: InputMaybe<StringNullableFilter>;
};

export type ProjectedAt = {
  __typename?: 'ProjectedAt';
  userStatsVolunteerTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectedAtCreateInput = {
  userStatsVolunteerTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectedAtNullableCompositeFilter = {
  equals?: InputMaybe<ProjectedAtObjectEqualityInput>;
  is?: InputMaybe<ProjectedAtWhereInput>;
  isNot?: InputMaybe<ProjectedAtWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectedAtNullableCreateEnvelopeInput = {
  set?: InputMaybe<ProjectedAtCreateInput>;
};

export type ProjectedAtNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ProjectedAtCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ProjectedAtUpsertInput>;
};

export type ProjectedAtObjectEqualityInput = {
  userStatsVolunteerTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectedAtOrderByInput = {
  userStatsVolunteerTime?: InputMaybe<SortOrder>;
};

export type ProjectedAtUpdateInput = {
  userStatsVolunteerTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ProjectedAtUpsertInput = {
  set: ProjectedAtCreateInput;
  update: ProjectedAtUpdateInput;
};

export type ProjectedAtWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProjectedAtWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProjectedAtWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProjectedAtWhereInput>>>;
  userStatsVolunteerTime?: InputMaybe<DateTimeNullableFilter>;
};

export type ProofOfAssociationFile = {
  __typename?: 'ProofOfAssociationFile';
  file: Scalars['String']['output'];
  nonprofitId: Scalars['String']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type ProofOfAssociationFileCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileObjectEqualityInput>>>;
  every?: InputMaybe<ProofOfAssociationFileWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProofOfAssociationFileWhereInput>;
  some?: InputMaybe<ProofOfAssociationFileWhereInput>;
};

export type ProofOfAssociationFileCreateInput = {
  file: Scalars['String']['input'];
  nonprofitId: Scalars['String']['input'];
  uploadedAt: Scalars['DateTime']['input'];
};

export type ProofOfAssociationFileDeleteManyInput = {
  where: ProofOfAssociationFileWhereInput;
};

export type ProofOfAssociationFileListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<ProofOfAssociationFileDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileCreateInput>>>;
  updateMany?: InputMaybe<ProofOfAssociationFileUpdateManyInput>;
};

export type ProofOfAssociationFileObjectEqualityInput = {
  file: Scalars['String']['input'];
  nonprofitId: Scalars['String']['input'];
  uploadedAt: Scalars['DateTime']['input'];
};

export type ProofOfAssociationFileOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProofOfAssociationFileUpdateInput = {
  file?: InputMaybe<StringFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<StringFieldUpdateOperationsInput>;
  uploadedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProofOfAssociationFileUpdateManyInput = {
  data: ProofOfAssociationFileUpdateInput;
  where: ProofOfAssociationFileWhereInput;
};

export type ProofOfAssociationFileWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileWhereInput>>>;
  file?: InputMaybe<StringFilter>;
  nonprofitId?: InputMaybe<StringFilter>;
  uploadedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderDisbursementError = {
  __typename?: 'ProviderDisbursementError';
  date: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: ProviderPaymentReconciliationStatus;
};

export type ProviderDisbursementErrorCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorObjectEqualityInput>>>;
  every?: InputMaybe<ProviderDisbursementErrorWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProviderDisbursementErrorWhereInput>;
  some?: InputMaybe<ProviderDisbursementErrorWhereInput>;
};

export type ProviderDisbursementErrorCreateInput = {
  date: Scalars['DateTime']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  status: ProviderPaymentReconciliationStatus;
};

export type ProviderDisbursementErrorDeleteManyInput = {
  where: ProviderDisbursementErrorWhereInput;
};

export type ProviderDisbursementErrorListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
};

export type ProviderDisbursementErrorListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<ProviderDisbursementErrorDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorCreateInput>>>;
  updateMany?: InputMaybe<ProviderDisbursementErrorUpdateManyInput>;
};

export type ProviderDisbursementErrorObjectEqualityInput = {
  date: Scalars['DateTime']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  status: ProviderPaymentReconciliationStatus;
};

export type ProviderDisbursementErrorOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProviderDisbursementErrorUpdateInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProviderPaymentReconciliationStatusFieldUpdateOperationsInput>;
};

export type ProviderDisbursementErrorUpdateManyInput = {
  data: ProviderDisbursementErrorUpdateInput;
  where: ProviderDisbursementErrorWhereInput;
};

export type ProviderDisbursementErrorWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDisbursementErrorWhereInput>>>;
  date?: InputMaybe<DateTimeFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumProviderPaymentReconciliationStatusFilter>;
};

export enum ProviderPaymentReconciliationStatus {
  Blocked = 'Blocked',
  Completed = 'Completed',
  Denied = 'Denied',
  Pending = 'Pending',
  Returned = 'Returned',
  Unclaimed = 'Unclaimed'
}

export enum ProviderType {
  Betterplace = 'Betterplace',
  Caf = 'CAF',
  Dcgf = 'DCGF',
  GiveIndia = 'GiveIndia',
  GlobalGiving = 'GlobalGiving',
  Nfg = 'NFG',
  PayPal = 'PayPal',
  Stripe = 'Stripe'
}

export type Query = {
  __typename?: 'Query';
  /** Get the users wrapped for a period */
  Wrapped?: Maybe<Wrapped>;
  /** Get action templates */
  actionTemplateResults?: Maybe<ActionTemplatesResult>;
  /** Get actions */
  actions: Array<Action>;
  /** Get actions with pagination */
  actionsWithPagination?: Maybe<ActionsWithPaginationType>;
  /** Get actions activities */
  activities: Array<Activity>;
  /** Get one `Affiliation` by id */
  affiliation?: Maybe<Affiliation>;
  /** Get a list of all `Affiliation`s for the current user, or, users inside current organizer's organization */
  affiliations: Array<Affiliation>;
  /** Returns a list of affiliations of users in your organization to a specified nonprofit organization */
  affiliationsByNonprofit: Array<Affiliation>;
  /** Returns a count of affiliations */
  affiliationsCount?: Maybe<Scalars['Int']['output']>;
  /** Get a user`s badge certificate */
  badgeCertificate?: Maybe<BadgeCertificate>;
  /** Get a user`s badges and awarded badges */
  badges: Array<Badge>;
  /** Get challenges from your company */
  challenges?: Maybe<ChallengesType>;
  /** Get a specific chapter request by ID */
  chapterRequest?: Maybe<ChapterRequest>;
  /** Get chapter requests */
  chapterRequests?: Maybe<ChapterRequestsType>;
  /** Get child & parent chapters of the current user's nonprofit */
  chapters: Array<Maybe<NonprofitPartial>>;
  /** Get all communities (for own company, if not Admin) */
  communities: Array<Community>;
  /** Count all communities (for own company, if not Admin) */
  communitiesCount: Scalars['Int']['output'];
  /** Total donated amount aggregated across all company communities */
  communitiesTotalDonations: Scalars['Float']['output'];
  /** Total count of employees of the company that are in communities */
  communitiesTotalMembers: Scalars['Int']['output'];
  /** Total volunteering aggregated across all company communities */
  communitiesTotalVolunteering: Scalars['Float']['output'];
  /** Get a Community. Non-admins can only see communities belonging to their company */
  community?: Maybe<Community>;
  /** Get the Corporate Program between a company and a non-profit if it exists */
  corporateProgram?: Maybe<CorporateProgram>;
  /** Get a list of Locations */
  countries: Array<Country>;
  /** Get current payroll end date for an employee */
  currentPayrollRun: PayrollRun;
  /** Get pledge values for a date range, defaults to current year */
  currentPledge?: Maybe<Pledge>;
  /** Get deeds stats */
  deedsStats?: Maybe<DeedsStats>;
  /**
   * Get the `payrollRunFlatFile` that will gather the current donations
   * @deprecated Replace by nextPayrollRunFlatFile
   */
  donatablePayrollRunFlatFile?: Maybe<PayrollRunFlatFile>;
  /** Returns a list of batch types for a donation id */
  donationBatchTypes: Array<Maybe<Scalars['String']['output']>>;
  /** Get all giving accounts for given company (or for own company, if not Admin) */
  donationSchedules: Array<DonationSchedule>;
  /** Get email template metadata by ID */
  emailTemplate?: Maybe<EmailTemplate>;
  /** Get BaseUsers in organization */
  employees: PaginatedEmployees;
  /** Count all BaseUsers in the organization */
  employeesCount: Scalars['Int']['output'];
  /** Fetch external match request rules by user company */
  externalMatchRequestRules?: Maybe<Array<ExternalMatchRequestRule>>;
  /** Get the Sigma dashboard by type */
  getSigmaDashboard?: Maybe<SigmaDashboard>;
  /** Get the Sigma dashboard for a Sigma Dashboard URL */
  getSigmaDashboardForURL?: Maybe<Scalars['String']['output']>;
  /** Get the Sigma Report by type */
  getSigmaReport?: Maybe<SigmaReport>;
  /** Get a giving account */
  givingAccount?: Maybe<GivingAccount>;
  /** Get all giving accounts for given company */
  givingAccounts: Array<GivingAccount>;
  /** Fetch ImpactAiPresets with all referenced subPresets included */
  impactAiPresets?: Maybe<ImpactAiPresets>;
  /** Returns a list of invoices for the current user's company */
  invoices: InvoicesPayload;
  /** List the Sigma dashboard available for a user */
  listSigmaDashboards?: Maybe<Array<SigmaDashboard>>;
  /** List the Sigma reports available for a user */
  listSigmaReports?: Maybe<Array<SigmaReport>>;
  /** Get a list of Locations */
  locations: Array<Location>;
  /** Get migrated and to be migrated communities */
  migratedAndToBeMigratedCommunities: CommunitiesMigrationProjection;
  /** Get the `payrollRunFlatFile` that will gather the current donations */
  nextPayrollRunFlatFile?: Maybe<PayrollRunFlatFile>;
  /** Returns a count of nominations */
  nominationsCount?: Maybe<Scalars['Int']['output']>;
  /** Fetch nonprofit */
  nonprofit?: Maybe<ExtendedDeedNonprofit>;
  /** Check nonprofit availability */
  nonprofitAvailability?: Maybe<NonprofitAvailability>;
  /** Get misc info about my current nonprofit */
  nonprofitInfo?: Maybe<NonprofitInfo>;
  /** Get one `NonprofitNomination` by id */
  nonprofitNomination?: Maybe<NonprofitNomination>;
  /** Get a list nonprofit nominations for the current user, or, users inside current organizer's organization */
  nonprofitNominations: Array<NonprofitNomination>;
  /** Get all the information needed to render the notifications management UI */
  notificationMetadata?: Maybe<NotificationMetadata>;
  /** Fetch a single opportunity */
  opportunity?: Maybe<ReducedOpportunity>;
  /** Fetch org nonprofits */
  orgNonprofit?: Maybe<OrgNonprofit>;
  /** Get all the information needed to render the notifications management UI */
  organizationNotificationSettings?: Maybe<NotificationSettings>;
  /** Fetch partner nonprofits */
  partnerNonprofit?: Maybe<PartnerNonprofit>;
  /** Get SFTP config for the current user's company */
  payrollFlatFileSftpConfig?: Maybe<SftpConfigWithoutSecret>;
  /** Get a payroll pay group based on a company's payroll type */
  payrollPayGroup?: Maybe<PayrollPayGroup>;
  /** Get a list of all payroll pay groups based on a company's payroll type */
  payrollPayGroups: Array<PayrollPayGroup>;
  /** Get single PayrollRunFlatFile by ID */
  payrollRunFlatFile?: Maybe<PayrollRunFlatFile>;
  /** Get a list of all payrollRuns for the current user's organization */
  payrollRuns: Array<PayrollRun>;
  /** Get a list of all PayrollRunFlatFile in a PayrollPayGroup */
  payrollRunsFlatFile: Array<PayrollRunFlatFile>;
  /** Get payroll runs with pagination */
  payrollRunsFlatFileWithPagination?: Maybe<PayrollRunsType>;
  /** Check if payroll run is enabled for the employee and returns configuration */
  payrollSettings?: Maybe<PayrollSettings>;
  /** Returns a list of pending corporate giving disbursements, grouped by giving account and month */
  pendingCorporateGivingDisbursements: PendingCorporateGivingDisbursements;
  /** Returns a list of payroll runs that have disbursements that have not been invoiced yet, with their respective totals in the giving account currency */
  pendingPayrollRuns: PendingPayrollRunsPayload;
  /** Get receipts */
  receipts?: Maybe<Array<Receipt>>;
  /** Get deeds */
  searchDeeds?: Maybe<DeedsResult>;
  /** Search nonprofits database */
  searchNonprofits: Array<Maybe<DeedNonprofit>>;
  /** Search for opportunities */
  searchOpportunities?: Maybe<SearchOpportunitiesResult>;
  /** Get a Stream client token. Only used for posting reactions. */
  streamToken: Scalars['String']['output'];
  /** Get volunteerRewards from your company */
  volunteerRewards?: Maybe<VolunteerRewardsType>;
  /** Get summary of budgeting data for a specific user */
  volunteerRewardsUserBudget?: Maybe<VolunteerRewardsUserBudgetType>;
  /** Get a Volunteer Time Off by id */
  volunteerTimeOff?: Maybe<VolunteerTimeOff>;
  /** Get a volunteerTimeOffSummary for the current user, or, any user inside current organizer's organization */
  volunteerTimeOffSummary?: Maybe<VolunteerTimeOffSummary>;
  /** Get a list of all `VolunteerTimeOff`s for the current user, or, users inside current organizer's organization */
  volunteerTimeOffs: Array<VolunteerTimeOff>;
  /** Get all volunteer times for the given query */
  volunteerTimes: Array<VolunteerTime>;
  /** Get volunteerTimes from your company */
  volunteerTimesWithPagination?: Maybe<VolunteerTimesType>;
};


export type QueryWrappedArgs = {
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActionTemplateResultsArgs = {
  causes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ActionVisibilityStatus>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActionsArgs = {
  activityArgs?: InputMaybe<ActionActivityArgs>;
  cursor?: InputMaybe<ActionWhereUniqueInput>;
  orderBy?: InputMaybe<ActionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionWhereInput>;
};


export type QueryActionsWithPaginationArgs = {
  activityArgs?: InputMaybe<ActionActivityArgs>;
  cursor?: InputMaybe<ActionWhereUniqueInput>;
  orderBy?: InputMaybe<ActionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionWhereInput>;
};


export type QueryActivitiesArgs = {
  cursor?: InputMaybe<ActivityWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityWhereInput>;
};


export type QueryAffiliationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAffiliationsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAffiliationsByNonprofitArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nonprofitId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAffiliationsCountArgs = {
  nonprofitId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBadgeCertificateArgs = {
  where?: InputMaybe<CustomAwardedBadgeWhereInput>;
};


export type QueryBadgesArgs = {
  cursor?: InputMaybe<BadgeWhereUniqueInput>;
  orderBy?: InputMaybe<BadgeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BadgeWhereInput>;
};


export type QueryChallengesArgs = {
  cursor?: InputMaybe<ChallengeWhereUniqueInput>;
  orderBy?: InputMaybe<ChallengeOrderByWithRelationInput>;
  orderByList?: InputMaybe<Array<InputMaybe<ChallengeOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChallengeWhereInput>;
};


export type QueryChapterRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryChapterRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ChapterRequestStatusEnum>>>;
};


export type QueryCommunitiesArgs = {
  cursor?: InputMaybe<CommunityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CommunityScalarFieldEnum>>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityWhereInput>;
};


export type QueryCommunitiesCountArgs = {
  distinct?: InputMaybe<Array<InputMaybe<CommunityScalarFieldEnum>>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommunityWhereInput>;
};


export type QueryCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCorporateProgramArgs = {
  companyId: Scalars['String']['input'];
  nonprofitIds: Array<Scalars['String']['input']>;
};


export type QueryDeedsStatsArgs = {
  deedType?: InputMaybe<DeedTypeFilters>;
  providers?: InputMaybe<Array<OpportunityProvider>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  submitters?: InputMaybe<Array<DeedSubmitter>>;
  subsidiaries?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDonationBatchTypesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDonationSchedulesArgs = {
  cursor?: InputMaybe<DonationScheduleWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DonationScheduleScalarFieldEnum>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DonationScheduleWhereInput>;
};


export type QueryEmailTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeesArgs = {
  emails?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryGetSigmaDashboardArgs = {
  type: ExternalDashboardType;
};


export type QueryGetSigmaDashboardForUrlArgs = {
  dashboardURL: Scalars['String']['input'];
};


export type QueryGetSigmaReportArgs = {
  type: ExternalReportType;
};


export type QueryGivingAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGivingAccountsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoicesArgs = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DonationDisbursementType>;
};


export type QueryLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LocationScalarFieldEnum>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryNextPayrollRunFlatFileArgs = {
  onlyDonatable: Scalars['Boolean']['input'];
};


export type QueryNominationsCountArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNonprofitArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNonprofitAvailabilityArgs = {
  identifierType: NonprofitIdentifierType;
  identifierValue: Scalars['String']['input'];
};


export type QueryNonprofitNominationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNonprofitNominationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOpportunityArgs = {
  provider: OpportunityProvider;
  providerId: Scalars['String']['input'];
};


export type QueryOrgNonprofitArgs = {
  affiliated?: InputMaybe<Scalars['Boolean']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ergs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeUnapproved?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pillars?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sdgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerNonprofitArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayrollPayGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayrollRunFlatFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayrollRunsFlatFileArgs = {
  payrollPayGroupId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPayrollRunsFlatFileWithPaginationArgs = {
  payrollPayGroupId: Scalars['ID']['input'];
  skip: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryPendingCorporateGivingDisbursementsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo: Scalars['DateTime']['input'];
  donationDisbursementType: DonationDisbursementCorporateGivingType;
};


export type QueryReceiptsArgs = {
  cursor?: InputMaybe<ReceiptWhereUniqueInput>;
  orderBy?: InputMaybe<ReceiptOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReceiptWhereInput>;
};


export type QuerySearchDeedsArgs = {
  deedType?: InputMaybe<DeedTypeFilters>;
  filterOption?: InputMaybe<FilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providers?: InputMaybe<Array<OpportunityProvider>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  submitters?: InputMaybe<Array<DeedSubmitter>>;
  subsidiaries?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySearchNonprofitsArgs = {
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  cause?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  donationProvider?: InputMaybe<Scalars['String']['input']>;
  excludeDonationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  includeBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  populateMatchingResults?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchOpportunitiesArgs = {
  attendence?: InputMaybe<OpportunityAttendence>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Area>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  providers?: InputMaybe<Array<OpportunityProvider>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<OpportunityType>>;
};


export type QueryVolunteerRewardsArgs = {
  cursor?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  orderBy?: InputMaybe<VolunteerRewardOrderByWithRelationInput>;
  orderByList?: InputMaybe<Array<InputMaybe<VolunteerRewardOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipVolunteerTimeStatus?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VolunteerRewardWhereInput>;
};


export type QueryVolunteerRewardsUserBudgetArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryVolunteerTimeOffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVolunteerTimeOffSummaryArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVolunteerTimeOffsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVolunteerTimesArgs = {
  cursor?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarFieldEnum>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};


export type QueryVolunteerTimesWithPaginationArgs = {
  cursor?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  orderBy?: InputMaybe<VolunteerTimeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Question = {
  __typename?: 'Question';
  id: Scalars['String']['output'];
  inputType: InputType;
  isRequired: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  typeOptions: Array<TypeOption>;
};

export type QuestionCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<QuestionObjectEqualityInput>>>;
  every?: InputMaybe<QuestionWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<QuestionWhereInput>;
  some?: InputMaybe<QuestionWhereInput>;
};

export type QuestionCreateInput = {
  id: Scalars['String']['input'];
  inputType: InputType;
  isRequired: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  typeOptions?: InputMaybe<Array<InputMaybe<TypeOptionCreateInput>>>;
};

export type QuestionDeleteManyInput = {
  where: QuestionWhereInput;
};

export type QuestionListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<QuestionDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<QuestionCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuestionCreateInput>>>;
  updateMany?: InputMaybe<QuestionUpdateManyInput>;
};

export type QuestionObjectEqualityInput = {
  id: Scalars['String']['input'];
  inputType: InputType;
  isRequired: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  typeOptions?: InputMaybe<Array<InputMaybe<TypeOptionObjectEqualityInput>>>;
};

export type QuestionOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuestionUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputType?: InputMaybe<EnumInputTypeFieldUpdateOperationsInput>;
  isRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  typeOptions?: InputMaybe<Array<InputMaybe<TypeOptionCreateInput>>>;
};

export type QuestionUpdateManyInput = {
  data: QuestionUpdateInput;
  where: QuestionWhereInput;
};

export type QuestionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuestionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuestionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionWhereInput>>>;
  id?: InputMaybe<StringFilter>;
  inputType?: InputMaybe<EnumInputTypeFilter>;
  isRequired?: InputMaybe<BoolFilter>;
  title?: InputMaybe<StringFilter>;
  typeOptions?: InputMaybe<Array<InputMaybe<TypeOptionObjectEqualityInput>>>;
};

/** @Auth(read: [Admin, Organizer(type: Company, organizationField: organization)]) */
export type Receipt = {
  __typename?: 'Receipt';
  Organization?: Maybe<Organization>;
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  type: ReceiptType;
};


/** @Auth(read: [Admin, Organizer(type: Company, organizationField: organization)]) */
export type ReceiptOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type ReceiptCountAggregateOutputType = {
  __typename?: 'ReceiptCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type ReceiptCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReceiptCreateInput = {
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutReceiptInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReceiptType;
};

export type ReceiptCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  type: ReceiptType;
};

export type ReceiptCreateManyOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReceiptType;
};

export type ReceiptCreateManyOrganizationInputEnvelope = {
  data: ReceiptCreateManyOrganizationInput;
};

export type ReceiptCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ReceiptCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ReceiptCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ReceiptCreateManyOrganizationInputEnvelope>;
};

export type ReceiptCreateOrConnectWithoutOrganizationInput = {
  create: ReceiptCreateWithoutOrganizationInput;
  where: ReceiptWhereUniqueInput;
};

export type ReceiptCreateWithoutOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReceiptType;
};

export type ReceiptData = {
  __typename?: 'ReceiptData';
  amount?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  externalDonationType?: Maybe<ExternalDonationType>;
  nonprofitAddress?: Maybe<LocationObject>;
  nonprofitName?: Maybe<Scalars['String']['output']>;
  receiptId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ReceiptListRelationFilter = {
  every?: InputMaybe<ReceiptWhereInput>;
  none?: InputMaybe<ReceiptWhereInput>;
  some?: InputMaybe<ReceiptWhereInput>;
};

export type ReceiptMaxAggregateOutputType = {
  __typename?: 'ReceiptMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReceiptType>;
};

export type ReceiptMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReceiptMinAggregateOutputType = {
  __typename?: 'ReceiptMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReceiptType>;
};

export type ReceiptMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReceiptOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReceiptOrderByWithAggregationInput = {
  _count?: InputMaybe<ReceiptCountOrderByAggregateInput>;
  _max?: InputMaybe<ReceiptMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReceiptMinOrderByAggregateInput>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReceiptOrderByWithRelationInput = {
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum ReceiptScalarFieldEnum {
  Active = 'active',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  Metadata = 'metadata',
  ModifiedAt = 'modifiedAt',
  Organization = 'organization',
  Type = 'type'
}

export type ReceiptScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereInput>>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumReceiptTypeFilter>;
};

export type ReceiptScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereWithAggregatesInput>>>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  organization?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumReceiptTypeWithAggregatesFilter>;
};

export enum ReceiptType {
  ChapterImport = 'ChapterImport',
  ChapterRequest = 'ChapterRequest',
  DonationCreditSeed = 'DonationCreditSeed',
  GovernmentEntityImport = 'GovernmentEntityImport',
  GovernmentEntityRequest = 'GovernmentEntityRequest',
  ManualNonprofitMerge = 'ManualNonprofitMerge',
  ManualNonprofitMergeRequest = 'ManualNonprofitMergeRequest'
}

export type ReceiptUncheckedCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  type: ReceiptType;
};

export type ReceiptUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ReceiptCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ReceiptCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ReceiptCreateManyOrganizationInputEnvelope>;
};

export type ReceiptUncheckedCreateWithoutOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: ReceiptType;
};

export type ReceiptUncheckedUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUncheckedUpdateManyInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUncheckedUpdateManyWithoutOrganizationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ReceiptCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ReceiptCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ReceiptCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ReceiptUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ReceiptUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ReceiptUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ReceiptUncheckedUpdateWithoutOrganizationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUpdateInput = {
  Organization?: InputMaybe<OrganizationUpdateOneWithoutReceiptNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUpdateManyWithWhereWithoutOrganizationInput = {
  data: ReceiptUpdateManyMutationInput;
  where: ReceiptScalarWhereInput;
};

export type ReceiptUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ReceiptCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<ReceiptCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<ReceiptCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ReceiptScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ReceiptWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ReceiptUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ReceiptUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ReceiptUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type ReceiptUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ReceiptUpdateWithoutOrganizationInput;
  where: ReceiptWhereUniqueInput;
};

export type ReceiptUpdateWithoutOrganizationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumReceiptTypeFieldUpdateOperationsInput>;
};

export type ReceiptUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ReceiptCreateWithoutOrganizationInput;
  update: ReceiptUpdateWithoutOrganizationInput;
  where: ReceiptWhereUniqueInput;
};

export type ReceiptWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumReceiptTypeFilter>;
};

export type ReceiptWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ReceiptWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumReceiptTypeFilter>;
};

export enum RecipientTypesForUserNotification {
  Channel = 'channel',
  Email = 'email',
  User = 'user'
}

export type ReconciliationConfiguration = {
  __typename?: 'ReconciliationConfiguration';
  cycleCloseFallbackInDays?: Maybe<Scalars['Int']['output']>;
  failedStatusOverride?: Maybe<FailedPayrollRunDeductionStatusOverrides>;
  unresolvedStatusOverride?: Maybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  useAlternateRollupReconciliation?: Maybe<Scalars['Boolean']['output']>;
};

export type ReconciliationConfigurationCreateInput = {
  cycleCloseFallbackInDays?: InputMaybe<Scalars['Int']['input']>;
  failedStatusOverride?: InputMaybe<FailedPayrollRunDeductionStatusOverrides>;
  unresolvedStatusOverride?: InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  useAlternateRollupReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReconciliationConfigurationNullableCompositeFilter = {
  equals?: InputMaybe<ReconciliationConfigurationObjectEqualityInput>;
  is?: InputMaybe<ReconciliationConfigurationWhereInput>;
  isNot?: InputMaybe<ReconciliationConfigurationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReconciliationConfigurationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ReconciliationConfigurationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ReconciliationConfigurationUpsertInput>;
};

export type ReconciliationConfigurationObjectEqualityInput = {
  cycleCloseFallbackInDays?: InputMaybe<Scalars['Int']['input']>;
  failedStatusOverride?: InputMaybe<FailedPayrollRunDeductionStatusOverrides>;
  unresolvedStatusOverride?: InputMaybe<UnresolvedPayrollRunDeductionStatusOverrides>;
  useAlternateRollupReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReconciliationConfigurationOrderByInput = {
  cycleCloseFallbackInDays?: InputMaybe<SortOrder>;
  failedStatusOverride?: InputMaybe<SortOrder>;
  unresolvedStatusOverride?: InputMaybe<SortOrder>;
  useAlternateRollupReconciliation?: InputMaybe<SortOrder>;
};

export type ReconciliationConfigurationUpdateInput = {
  cycleCloseFallbackInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  failedStatusOverride?: InputMaybe<NullableEnumFailedPayrollRunDeductionStatusOverridesFieldUpdateOperationsInput>;
  unresolvedStatusOverride?: InputMaybe<NullableEnumUnresolvedPayrollRunDeductionStatusOverridesFieldUpdateOperationsInput>;
  useAlternateRollupReconciliation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type ReconciliationConfigurationUpsertInput = {
  set: ReconciliationConfigurationCreateInput;
  update: ReconciliationConfigurationUpdateInput;
};

export type ReconciliationConfigurationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ReconciliationConfigurationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ReconciliationConfigurationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ReconciliationConfigurationWhereInput>>>;
  cycleCloseFallbackInDays?: InputMaybe<IntNullableFilter>;
  failedStatusOverride?: InputMaybe<EnumFailedPayrollRunDeductionStatusOverridesNullableFilter>;
  unresolvedStatusOverride?: InputMaybe<EnumUnresolvedPayrollRunDeductionStatusOverridesNullableFilter>;
  useAlternateRollupReconciliation?: InputMaybe<BoolNullableFilter>;
};

export type ReducedDeed = {
  __typename?: 'ReducedDeed';
  allowedLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attendeeLimit?: Maybe<Scalars['Float']['output']>;
  attendees?: Maybe<Array<Maybe<UserObject>>>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<OpportunityContact>;
  description?: Maybe<Scalars['String']['output']>;
  ended?: Maybe<Scalars['Boolean']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  externalLinkFollows?: Maybe<Array<Maybe<UserObject>>>;
  externalLinkFollowsCount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isSharedWithSubsidiary?: Maybe<Scalars['Boolean']['output']>;
  linkOnly?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<LocationObject>;
  locationObject?: Maybe<LocationObject>;
  mustKnows?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonprofit?: Maybe<OpportunityNonprofit>;
  nonprofits?: Maybe<Array<Maybe<Nonprofit>>>;
  organization?: Maybe<Organization>;
  participantsLimit?: Maybe<Scalars['Float']['output']>;
  partner?: Maybe<Organization>;
  pictures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  provider?: Maybe<OpportunityProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  requireAuthentication?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<DeedRoleReduced>>>;
  sdgs?: Maybe<Array<Scalars['String']['output']>>;
  started?: Maybe<Scalars['Boolean']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submitter?: Maybe<Submitter>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
  waitlist?: Maybe<Array<Maybe<UserObject>>>;
};

export type ReducedOpportunity = {
  __typename?: 'ReducedOpportunity';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<OpportunityContact>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<LocationObject>;
  mustKnows?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nonprofit?: Maybe<OpportunityNonprofit>;
  participantsLimit?: Maybe<Scalars['Int']['output']>;
  pictures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  provider: OpportunityProvider;
  providerId: Scalars['String']['output'];
  registrationEndingAt?: Maybe<Scalars['DateTime']['output']>;
  sdgs?: Maybe<Array<Scalars['String']['output']>>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export type ReducedOrganization = {
  __typename?: 'ReducedOrganization';
  /** Organization id */
  id: Scalars['String']['output'];
  type: OrganizationType;
};

export type Role = {
  __typename?: 'Role';
  _count: RoleCountOutputType;
  code?: Maybe<RoleCode>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  privileges: Array<Scalars['String']['output']>;
};

export enum RoleCode {
  Administrator = 'Administrator',
  Ambassador = 'Ambassador',
  Blocked = 'Blocked',
  Organizer = 'Organizer',
  Owner = 'Owner',
  Verified = 'Verified'
}

export type RoleCountAggregateOutputType = {
  __typename?: 'RoleCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  privileges: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type RoleCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  privileges?: InputMaybe<SortOrder>;
  users?: InputMaybe<SortOrder>;
};

export type RoleCountOutputType = {
  __typename?: 'RoleCountOutputType';
  Users: Scalars['Int']['output'];
};

export type RoleCreateInput = {
  Users?: InputMaybe<BaseUserCreateNestedManyWithoutRolesInput>;
  code?: InputMaybe<RoleCode>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleCreateManyInput = {
  code?: InputMaybe<RoleCode>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<RoleCreateOrConnectWithoutUsersInput>>>;
  create?: InputMaybe<Array<InputMaybe<RoleCreateWithoutUsersInput>>>;
};

export type RoleCreateOrConnectWithoutUsersInput = {
  create: RoleCreateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateWithoutUsersInput = {
  code?: InputMaybe<RoleCode>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleCreateprivilegesInput = {
  set: Scalars['String']['input'];
};

export type RoleCreateusersInput = {
  set: Scalars['String']['input'];
};

export type RoleGrant = {
  __typename?: 'RoleGrant';
  context: RoleGrantContext;
  enabled: Scalars['Boolean']['output'];
  metadata?: Maybe<RoleGrantMetadata>;
  roleId: Scalars['String']['output'];
};

export type RoleGrantCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<RoleGrantObjectEqualityInput>>>;
  every?: InputMaybe<RoleGrantWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleGrantWhereInput>;
  some?: InputMaybe<RoleGrantWhereInput>;
};

export type RoleGrantContext = {
  __typename?: 'RoleGrantContext';
  locations: Array<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationTypes: Array<OrganizationType>;
};

export type RoleGrantContextCompositeFilter = {
  equals?: InputMaybe<RoleGrantContextObjectEqualityInput>;
  is?: InputMaybe<RoleGrantContextWhereInput>;
  isNot?: InputMaybe<RoleGrantContextWhereInput>;
};

export type RoleGrantContextCreateInput = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizationTypes?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type RoleGrantContextCreatelocationsInput = {
  set: Scalars['String']['input'];
};

export type RoleGrantContextCreateorganizationTypesInput = {
  set: OrganizationType;
};

export type RoleGrantContextObjectEqualityInput = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizationTypes?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type RoleGrantContextUpdateEnvelopeInput = {
  set?: InputMaybe<RoleGrantContextCreateInput>;
  update?: InputMaybe<RoleGrantContextUpdateInput>;
};

export type RoleGrantContextUpdateInput = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationTypes?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type RoleGrantContextUpdatelocationsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleGrantContextUpdateorganizationTypesInput = {
  push?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
  set?: InputMaybe<Array<InputMaybe<OrganizationType>>>;
};

export type RoleGrantContextWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleGrantContextWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleGrantContextWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleGrantContextWhereInput>>>;
  locations?: InputMaybe<StringNullableListFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  organizationTypes?: InputMaybe<EnumOrganizationTypeNullableListFilter>;
};

export type RoleGrantCreateInput = {
  context: RoleGrantContextCreateInput;
  enabled: Scalars['Boolean']['input'];
  metadata?: InputMaybe<RoleGrantMetadataCreateInput>;
  roleId: Scalars['String']['input'];
};

export type RoleGrantDeleteManyInput = {
  where: RoleGrantWhereInput;
};

export type RoleGrantListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
};

export type RoleGrantListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<RoleGrantDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<RoleGrantCreateInput>>>;
  updateMany?: InputMaybe<RoleGrantUpdateManyInput>;
};

export type RoleGrantMetadata = {
  __typename?: 'RoleGrantMetadata';
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedBy?: Maybe<Scalars['String']['output']>;
  assignmentNote?: Maybe<Scalars['String']['output']>;
  assignmentSource?: Maybe<RoleGrantSource>;
};

export type RoleGrantMetadataCreateInput = {
  assignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  assignedBy?: InputMaybe<Scalars['String']['input']>;
  assignmentNote?: InputMaybe<Scalars['String']['input']>;
  assignmentSource?: InputMaybe<RoleGrantSource>;
};

export type RoleGrantMetadataNullableCompositeFilter = {
  equals?: InputMaybe<RoleGrantMetadataObjectEqualityInput>;
  is?: InputMaybe<RoleGrantMetadataWhereInput>;
  isNot?: InputMaybe<RoleGrantMetadataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleGrantMetadataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<RoleGrantMetadataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<RoleGrantMetadataUpsertInput>;
};

export type RoleGrantMetadataObjectEqualityInput = {
  assignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  assignedBy?: InputMaybe<Scalars['String']['input']>;
  assignmentNote?: InputMaybe<Scalars['String']['input']>;
  assignmentSource?: InputMaybe<RoleGrantSource>;
};

export type RoleGrantMetadataUpdateInput = {
  assignedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  assignedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assignmentNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  assignmentSource?: InputMaybe<NullableEnumRoleGrantSourceFieldUpdateOperationsInput>;
};

export type RoleGrantMetadataUpsertInput = {
  set: RoleGrantMetadataCreateInput;
  update: RoleGrantMetadataUpdateInput;
};

export type RoleGrantMetadataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleGrantMetadataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleGrantMetadataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleGrantMetadataWhereInput>>>;
  assignedAt?: InputMaybe<DateTimeNullableFilter>;
  assignedBy?: InputMaybe<StringNullableFilter>;
  assignmentNote?: InputMaybe<StringNullableFilter>;
  assignmentSource?: InputMaybe<EnumRoleGrantSourceNullableFilter>;
};

export type RoleGrantObjectEqualityInput = {
  context: RoleGrantContextObjectEqualityInput;
  enabled: Scalars['Boolean']['input'];
  metadata?: InputMaybe<RoleGrantMetadataObjectEqualityInput>;
  roleId: Scalars['String']['input'];
};

export type RoleGrantOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum RoleGrantSource {
  Deed = 'Deed',
  InitialMigration = 'InitialMigration',
  Manual = 'Manual',
  PayPal = 'PayPal',
  SelfClaim = 'SelfClaim'
}

export type RoleGrantUpdateInput = {
  context?: InputMaybe<RoleGrantContextUpdateEnvelopeInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<RoleGrantMetadataNullableUpdateEnvelopeInput>;
  roleId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RoleGrantUpdateManyInput = {
  data: RoleGrantUpdateInput;
  where: RoleGrantWhereInput;
};

export type RoleGrantWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleGrantWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleGrantWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleGrantWhereInput>>>;
  context?: InputMaybe<RoleGrantContextCompositeFilter>;
  enabled?: InputMaybe<BoolFilter>;
  metadata?: InputMaybe<RoleGrantMetadataNullableCompositeFilter>;
  roleId?: InputMaybe<StringFilter>;
};

export type RoleListRelationFilter = {
  every?: InputMaybe<RoleWhereInput>;
  none?: InputMaybe<RoleWhereInput>;
  some?: InputMaybe<RoleWhereInput>;
};

export type RoleMaxAggregateOutputType = {
  __typename?: 'RoleMaxAggregateOutputType';
  code?: Maybe<RoleCode>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type RoleMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
};

export type RoleMinAggregateOutputType = {
  __typename?: 'RoleMinAggregateOutputType';
  code?: Maybe<RoleCode>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type RoleMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
};

export type RoleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithAggregationInput = {
  _count?: InputMaybe<RoleCountOrderByAggregateInput>;
  _max?: InputMaybe<RoleMaxOrderByAggregateInput>;
  _min?: InputMaybe<RoleMinOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  privileges?: InputMaybe<SortOrder>;
  users?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithRelationInput = {
  Users?: InputMaybe<BaseUserOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  privileges?: InputMaybe<SortOrder>;
  users?: InputMaybe<SortOrder>;
};

export enum RoleScalarFieldEnum {
  Code = 'code',
  Id = 'id',
  Name = 'name',
  OrganizationId = 'organizationId',
  Privileges = 'privileges',
  Users = 'users'
}

export type RoleScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleScalarWhereInput>>>;
  code?: InputMaybe<EnumRoleCodeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  privileges?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<StringNullableListFilter>;
};

export type RoleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  code?: InputMaybe<EnumRoleCodeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  privileges?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<StringNullableListFilter>;
};

export type RoleUncheckedCreateInput = {
  Users?: InputMaybe<BaseUserUncheckedCreateNestedManyWithoutRolesInput>;
  code?: InputMaybe<RoleCode>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUncheckedCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<RoleCreateOrConnectWithoutUsersInput>>>;
  create?: InputMaybe<Array<InputMaybe<RoleCreateWithoutUsersInput>>>;
};

export type RoleUncheckedCreateWithoutUsersInput = {
  code?: InputMaybe<RoleCode>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUncheckedUpdateInput = {
  Users?: InputMaybe<BaseUserUncheckedUpdateManyWithoutRolesNestedInput>;
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUncheckedUpdateManyInput = {
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUncheckedUpdateManyWithoutUsersInput = {
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUncheckedUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<RoleCreateOrConnectWithoutUsersInput>>>;
  create?: InputMaybe<Array<InputMaybe<RoleCreateWithoutUsersInput>>>;
  delete?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<RoleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<RoleUpdateWithWhereUniqueWithoutUsersInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<RoleUpdateManyWithWhereWithoutUsersInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<RoleUpsertWithWhereUniqueWithoutUsersInput>>>;
};

export type RoleUncheckedUpdateWithoutUsersInput = {
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpdateInput = {
  Users?: InputMaybe<BaseUserUpdateManyWithoutRolesNestedInput>;
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpdateManyMutationInput = {
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpdateManyWithWhereWithoutUsersInput = {
  data: RoleUpdateManyMutationInput;
  where: RoleScalarWhereInput;
};

export type RoleUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<RoleCreateOrConnectWithoutUsersInput>>>;
  create?: InputMaybe<Array<InputMaybe<RoleCreateWithoutUsersInput>>>;
  delete?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<RoleScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<RoleWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<RoleUpdateWithWhereUniqueWithoutUsersInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<RoleUpdateManyWithWhereWithoutUsersInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<RoleUpsertWithWhereUniqueWithoutUsersInput>>>;
};

export type RoleUpdateWithWhereUniqueWithoutUsersInput = {
  data: RoleUpdateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleUpdateWithoutUsersInput = {
  code?: InputMaybe<NullableEnumRoleCodeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privileges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpdateprivilegesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpdateusersInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoleUpsertWithWhereUniqueWithoutUsersInput = {
  create: RoleCreateWithoutUsersInput;
  update: RoleUpdateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  Users?: InputMaybe<BaseUserListRelationFilter>;
  code?: InputMaybe<EnumRoleCodeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  privileges?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<StringNullableListFilter>;
};

export type RoleWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  Users?: InputMaybe<BaseUserListRelationFilter>;
  code?: InputMaybe<EnumRoleCodeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  privileges?: InputMaybe<StringNullableListFilter>;
  users?: InputMaybe<StringNullableListFilter>;
};

export type SearchOpportunitiesResult = {
  __typename?: 'SearchOpportunitiesResult';
  opportunities: Array<ReducedOpportunity>;
  total: Scalars['Int']['output'];
};

export type SecretKeySettings = {
  __typename?: 'SecretKeySettings';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type SecretKeySettingsCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<SecretKeySettingsObjectEqualityInput>>>;
  every?: InputMaybe<SecretKeySettingsWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SecretKeySettingsWhereInput>;
  some?: InputMaybe<SecretKeySettingsWhereInput>;
};

export type SecretKeySettingsCreateInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type SecretKeySettingsDeleteManyInput = {
  where: SecretKeySettingsWhereInput;
};

export type SecretKeySettingsListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<SecretKeySettingsDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<SecretKeySettingsCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<SecretKeySettingsCreateInput>>>;
  updateMany?: InputMaybe<SecretKeySettingsUpdateManyInput>;
};

export type SecretKeySettingsObjectEqualityInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type SecretKeySettingsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SecretKeySettingsUpdateInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tokenId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SecretKeySettingsUpdateManyInput = {
  data: SecretKeySettingsUpdateInput;
  where: SecretKeySettingsWhereInput;
};

export type SecretKeySettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SecretKeySettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SecretKeySettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SecretKeySettingsWhereInput>>>;
  code?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  tokenId?: InputMaybe<StringNullableFilter>;
};

export type SelectedTeam = {
  __typename?: 'SelectedTeam';
  id: Scalars['String']['output'];
  tileImage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  contentFilters?: Maybe<ContentFilters>;
  id: Scalars['String']['output'];
  maxStrikes: Scalars['Int']['output'];
  minimumAppVersion: Scalars['Int']['output'];
  minimumAppVersionAndroid: Scalars['Int']['output'];
};

export type SettingsAvgAggregateOutputType = {
  __typename?: 'SettingsAvgAggregateOutputType';
  maxStrikes?: Maybe<Scalars['Float']['output']>;
  minimumAppVersion?: Maybe<Scalars['Float']['output']>;
  minimumAppVersionAndroid?: Maybe<Scalars['Float']['output']>;
};

export type SettingsAvgOrderByAggregateInput = {
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsCountAggregateOutputType = {
  __typename?: 'SettingsCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxStrikes: Scalars['Int']['output'];
  minimumAppVersion: Scalars['Int']['output'];
  minimumAppVersionAndroid: Scalars['Int']['output'];
};

export type SettingsCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsCreateInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxStrikes: Scalars['Int']['input'];
  minimumAppVersion: Scalars['Int']['input'];
  minimumAppVersionAndroid: Scalars['Int']['input'];
};

export type SettingsCreateManyInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxStrikes: Scalars['Int']['input'];
  minimumAppVersion: Scalars['Int']['input'];
  minimumAppVersionAndroid: Scalars['Int']['input'];
};

export type SettingsMaxAggregateOutputType = {
  __typename?: 'SettingsMaxAggregateOutputType';
  id?: Maybe<Scalars['String']['output']>;
  maxStrikes?: Maybe<Scalars['Int']['output']>;
  minimumAppVersion?: Maybe<Scalars['Int']['output']>;
  minimumAppVersionAndroid?: Maybe<Scalars['Int']['output']>;
};

export type SettingsMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsMinAggregateOutputType = {
  __typename?: 'SettingsMinAggregateOutputType';
  id?: Maybe<Scalars['String']['output']>;
  maxStrikes?: Maybe<Scalars['Int']['output']>;
  minimumAppVersion?: Maybe<Scalars['Int']['output']>;
  minimumAppVersionAndroid?: Maybe<Scalars['Int']['output']>;
};

export type SettingsMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsOrderByWithAggregationInput = {
  _avg?: InputMaybe<SettingsAvgOrderByAggregateInput>;
  _count?: InputMaybe<SettingsCountOrderByAggregateInput>;
  _max?: InputMaybe<SettingsMaxOrderByAggregateInput>;
  _min?: InputMaybe<SettingsMinOrderByAggregateInput>;
  _sum?: InputMaybe<SettingsSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsOrderByWithRelationInput = {
  contentFilters?: InputMaybe<ContentFiltersOrderByInput>;
  id?: InputMaybe<SortOrder>;
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export enum SettingsScalarFieldEnum {
  Id = 'id',
  MaxStrikes = 'maxStrikes',
  MinimumAppVersion = 'minimumAppVersion',
  MinimumAppVersionAndroid = 'minimumAppVersionAndroid'
}

export type SettingsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  maxStrikes?: InputMaybe<IntWithAggregatesFilter>;
  minimumAppVersion?: InputMaybe<IntWithAggregatesFilter>;
  minimumAppVersionAndroid?: InputMaybe<IntWithAggregatesFilter>;
};

export type SettingsSumAggregateOutputType = {
  __typename?: 'SettingsSumAggregateOutputType';
  maxStrikes?: Maybe<Scalars['Int']['output']>;
  minimumAppVersion?: Maybe<Scalars['Int']['output']>;
  minimumAppVersionAndroid?: Maybe<Scalars['Int']['output']>;
};

export type SettingsSumOrderByAggregateInput = {
  maxStrikes?: InputMaybe<SortOrder>;
  minimumAppVersion?: InputMaybe<SortOrder>;
  minimumAppVersionAndroid?: InputMaybe<SortOrder>;
};

export type SettingsUncheckedCreateInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableCreateEnvelopeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxStrikes: Scalars['Int']['input'];
  minimumAppVersion: Scalars['Int']['input'];
  minimumAppVersionAndroid: Scalars['Int']['input'];
};

export type SettingsUncheckedUpdateInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  maxStrikes?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersionAndroid?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SettingsUncheckedUpdateManyInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  maxStrikes?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersionAndroid?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SettingsUpdateInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  maxStrikes?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersionAndroid?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SettingsUpdateManyMutationInput = {
  contentFilters?: InputMaybe<ContentFiltersNullableUpdateEnvelopeInput>;
  maxStrikes?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  minimumAppVersionAndroid?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  maxStrikes?: InputMaybe<IntFilter>;
  minimumAppVersion?: InputMaybe<IntFilter>;
  minimumAppVersionAndroid?: InputMaybe<IntFilter>;
};

export type SettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  contentFilters?: InputMaybe<ContentFiltersNullableCompositeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxStrikes?: InputMaybe<IntFilter>;
  minimumAppVersion?: InputMaybe<IntFilter>;
  minimumAppVersionAndroid?: InputMaybe<IntFilter>;
};

export type SftpConfig = {
  __typename?: 'SftpConfig';
  host: Scalars['String']['output'];
  mode: SftpMode;
  port?: Maybe<Scalars['Int']['output']>;
  secretEncrypted: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SftpConfigCreateInput = {
  host: Scalars['String']['input'];
  mode?: InputMaybe<SftpMode>;
  port?: InputMaybe<Scalars['Int']['input']>;
  secretEncrypted: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SftpConfigNullableCompositeFilter = {
  equals?: InputMaybe<SftpConfigObjectEqualityInput>;
  is?: InputMaybe<SftpConfigWhereInput>;
  isNot?: InputMaybe<SftpConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SftpConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<SftpConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<SftpConfigUpsertInput>;
};

export type SftpConfigObjectEqualityInput = {
  host: Scalars['String']['input'];
  mode: SftpMode;
  port?: InputMaybe<Scalars['Int']['input']>;
  secretEncrypted: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SftpConfigOrderByInput = {
  host?: InputMaybe<SortOrder>;
  mode?: InputMaybe<SortOrder>;
  port?: InputMaybe<SortOrder>;
  secretEncrypted?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
};

export type SftpConfigSetInput = {
  host: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type SftpConfigUpdateInput = {
  host?: InputMaybe<StringFieldUpdateOperationsInput>;
  mode?: InputMaybe<EnumSftpModeFieldUpdateOperationsInput>;
  port?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  secretEncrypted?: InputMaybe<StringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SftpConfigUpsertInput = {
  set: SftpConfigCreateInput;
  update: SftpConfigUpdateInput;
};

export type SftpConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SftpConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SftpConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SftpConfigWhereInput>>>;
  host?: InputMaybe<StringFilter>;
  mode?: InputMaybe<EnumSftpModeFilter>;
  port?: InputMaybe<IntNullableFilter>;
  secretEncrypted?: InputMaybe<StringFilter>;
  username?: InputMaybe<StringFilter>;
};

/** Sftp config without secret */
export type SftpConfigWithoutSecret = {
  __typename?: 'SftpConfigWithoutSecret';
  host: Scalars['String']['output'];
  isSecretSet: Scalars['Boolean']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  username: Scalars['String']['output'];
};

export enum SftpMode {
  Key = 'Key',
  Password = 'Password'
}

export type SigmaDashboard = {
  __typename?: 'SigmaDashboard';
  audienceType: OrganizationType;
  dashboardId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  overrides?: Maybe<Scalars['Json']['output']>;
  scope?: Maybe<ExternalDashboardScope>;
  /** JWT Token to access a Sigma Dashboard */
  sigmaUrl: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ExternalDashboardType;
};


export type SigmaDashboardOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type SigmaDashboardAvgAggregateOutputType = {
  __typename?: 'SigmaDashboardAvgAggregateOutputType';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type SigmaDashboardAvgOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type SigmaDashboardCountAggregateOutputType = {
  __typename?: 'SigmaDashboardCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  audienceType: Scalars['Int']['output'];
  dashboardId: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  iconUrl: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  overrides: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type SigmaDashboardCountOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  dashboardId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaDashboardCreateInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutSigmaDashboardInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardCreateManyInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardCreateManyOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardCreateManyOrganizationInputEnvelope = {
  data: SigmaDashboardCreateManyOrganizationInput;
};

export type SigmaDashboardCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaDashboardCreateManyOrganizationInputEnvelope>;
};

export type SigmaDashboardCreateOrConnectWithoutOrganizationInput = {
  create: SigmaDashboardCreateWithoutOrganizationInput;
  where: SigmaDashboardWhereUniqueInput;
};

export type SigmaDashboardCreateWithoutOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardListRelationFilter = {
  every?: InputMaybe<SigmaDashboardWhereInput>;
  none?: InputMaybe<SigmaDashboardWhereInput>;
  some?: InputMaybe<SigmaDashboardWhereInput>;
};

export type SigmaDashboardMaxAggregateOutputType = {
  __typename?: 'SigmaDashboardMaxAggregateOutputType';
  audienceType?: Maybe<OrganizationType>;
  dashboardId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<ExternalDashboardScope>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExternalDashboardType>;
};

export type SigmaDashboardMaxOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  dashboardId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaDashboardMinAggregateOutputType = {
  __typename?: 'SigmaDashboardMinAggregateOutputType';
  audienceType?: Maybe<OrganizationType>;
  dashboardId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<ExternalDashboardScope>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExternalDashboardType>;
};

export type SigmaDashboardMinOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  dashboardId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaDashboardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SigmaDashboardOrderByWithAggregationInput = {
  _avg?: InputMaybe<SigmaDashboardAvgOrderByAggregateInput>;
  _count?: InputMaybe<SigmaDashboardCountOrderByAggregateInput>;
  _max?: InputMaybe<SigmaDashboardMaxOrderByAggregateInput>;
  _min?: InputMaybe<SigmaDashboardMinOrderByAggregateInput>;
  _sum?: InputMaybe<SigmaDashboardSumOrderByAggregateInput>;
  audienceType?: InputMaybe<SortOrder>;
  dashboardId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaDashboardOrderByWithRelationInput = {
  audienceType?: InputMaybe<SortOrder>;
  dashboardId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum SigmaDashboardScalarFieldEnum {
  AudienceType = 'audienceType',
  DashboardId = 'dashboardId',
  Description = 'description',
  IconUrl = 'iconUrl',
  Id = 'id',
  OrganizationId = 'organizationId',
  Overrides = 'overrides',
  Scope = 'scope',
  SortOrder = 'sortOrder',
  Title = 'title',
  Type = 'type'
}

export type SigmaDashboardScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  dashboardId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalDashboardTypeFilter>;
};

export type SigmaDashboardScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereWithAggregatesInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeWithAggregatesFilter>;
  dashboardId?: InputMaybe<StringWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  iconUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  overrides?: InputMaybe<JsonNullableWithAggregatesFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumExternalDashboardTypeWithAggregatesFilter>;
};

export type SigmaDashboardSumAggregateOutputType = {
  __typename?: 'SigmaDashboardSumAggregateOutputType';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type SigmaDashboardSumOrderByAggregateInput = {
  sortOrder?: InputMaybe<SortOrder>;
};

export type SigmaDashboardUncheckedCreateInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaDashboardCreateManyOrganizationInputEnvelope>;
};

export type SigmaDashboardUncheckedCreateWithoutOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<ExternalDashboardScope>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalDashboardType;
};

export type SigmaDashboardUncheckedUpdateInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUncheckedUpdateManyInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUncheckedUpdateManyWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaDashboardCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SigmaDashboardUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SigmaDashboardUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SigmaDashboardUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type SigmaDashboardUncheckedUpdateWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUpdateInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutSigmaDashboardNestedInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUpdateManyMutationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUpdateManyWithWhereWithoutOrganizationInput = {
  data: SigmaDashboardUpdateManyMutationInput;
  where: SigmaDashboardScalarWhereInput;
};

export type SigmaDashboardUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaDashboardCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaDashboardCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SigmaDashboardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SigmaDashboardUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SigmaDashboardUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SigmaDashboardUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type SigmaDashboardUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: SigmaDashboardUpdateWithoutOrganizationInput;
  where: SigmaDashboardWhereUniqueInput;
};

export type SigmaDashboardUpdateWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  dashboardId?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalDashboardTypeFieldUpdateOperationsInput>;
};

export type SigmaDashboardUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: SigmaDashboardCreateWithoutOrganizationInput;
  update: SigmaDashboardUpdateWithoutOrganizationInput;
  where: SigmaDashboardWhereUniqueInput;
};

export type SigmaDashboardWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  dashboardId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalDashboardTypeFilter>;
};

export type SigmaDashboardWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaDashboardWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  dashboardId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationNullableRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalDashboardTypeFilter>;
};

export type SigmaReport = {
  __typename?: 'SigmaReport';
  audienceType: OrganizationType;
  availableToRoles: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  overrides?: Maybe<Scalars['Json']['output']>;
  reportId: Scalars['String']['output'];
  scope?: Maybe<ExternalDashboardScope>;
  /** JWT Token to access a Sigma Report */
  sigmaUrl: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: ExternalReportType;
};


export type SigmaReportOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type SigmaReportCountAggregateOutputType = {
  __typename?: 'SigmaReportCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  audienceType: Scalars['Int']['output'];
  availableToRoles: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  icon: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  overrides: Scalars['Int']['output'];
  reportId: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type SigmaReportCountOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  availableToRoles?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  reportId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaReportCreateInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutSigmaReportInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportCreateManyInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportCreateManyOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportCreateManyOrganizationInputEnvelope = {
  data: SigmaReportCreateManyOrganizationInput;
};

export type SigmaReportCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaReportCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaReportCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaReportCreateManyOrganizationInputEnvelope>;
};

export type SigmaReportCreateOrConnectWithoutOrganizationInput = {
  create: SigmaReportCreateWithoutOrganizationInput;
  where: SigmaReportWhereUniqueInput;
};

export type SigmaReportCreateWithoutOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportCreateavailableToRolesInput = {
  set: Scalars['String']['input'];
};

export type SigmaReportListRelationFilter = {
  every?: InputMaybe<SigmaReportWhereInput>;
  none?: InputMaybe<SigmaReportWhereInput>;
  some?: InputMaybe<SigmaReportWhereInput>;
};

export type SigmaReportMaxAggregateOutputType = {
  __typename?: 'SigmaReportMaxAggregateOutputType';
  audienceType?: Maybe<OrganizationType>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<ExternalDashboardScope>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExternalReportType>;
};

export type SigmaReportMaxOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  reportId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaReportMinAggregateOutputType = {
  __typename?: 'SigmaReportMinAggregateOutputType';
  audienceType?: Maybe<OrganizationType>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<ExternalDashboardScope>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExternalReportType>;
};

export type SigmaReportMinOrderByAggregateInput = {
  audienceType?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  reportId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SigmaReportOrderByWithAggregationInput = {
  _count?: InputMaybe<SigmaReportCountOrderByAggregateInput>;
  _max?: InputMaybe<SigmaReportMaxOrderByAggregateInput>;
  _min?: InputMaybe<SigmaReportMinOrderByAggregateInput>;
  audienceType?: InputMaybe<SortOrder>;
  availableToRoles?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  reportId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type SigmaReportOrderByWithRelationInput = {
  audienceType?: InputMaybe<SortOrder>;
  availableToRoles?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  overrides?: InputMaybe<SortOrder>;
  reportId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum SigmaReportScalarFieldEnum {
  AudienceType = 'audienceType',
  AvailableToRoles = 'availableToRoles',
  Description = 'description',
  Icon = 'icon',
  Id = 'id',
  OrganizationId = 'organizationId',
  Overrides = 'overrides',
  ReportId = 'reportId',
  Scope = 'scope',
  Title = 'title',
  Type = 'type'
}

export type SigmaReportScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  availableToRoles?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  icon?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  reportId?: InputMaybe<StringFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalReportTypeFilter>;
};

export type SigmaReportScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereWithAggregatesInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeWithAggregatesFilter>;
  availableToRoles?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  icon?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  organizationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  overrides?: InputMaybe<JsonNullableWithAggregatesFilter>;
  reportId?: InputMaybe<StringWithAggregatesFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumExternalReportTypeWithAggregatesFilter>;
};

export type SigmaReportUncheckedCreateInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaReportCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaReportCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaReportCreateManyOrganizationInputEnvelope>;
};

export type SigmaReportUncheckedCreateWithoutOrganizationInput = {
  audienceType?: InputMaybe<OrganizationType>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId: Scalars['String']['input'];
  scope?: InputMaybe<ExternalDashboardScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: ExternalReportType;
};

export type SigmaReportUncheckedUpdateInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUncheckedUpdateManyInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUncheckedUpdateManyWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaReportCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaReportCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaReportCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SigmaReportUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SigmaReportUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SigmaReportUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type SigmaReportUncheckedUpdateWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUpdateInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutSigmaReportNestedInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUpdateManyMutationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUpdateManyWithWhereWithoutOrganizationInput = {
  data: SigmaReportUpdateManyMutationInput;
  where: SigmaReportScalarWhereInput;
};

export type SigmaReportUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SigmaReportCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<SigmaReportCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<SigmaReportCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SigmaReportScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SigmaReportWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SigmaReportUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SigmaReportUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SigmaReportUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type SigmaReportUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: SigmaReportUpdateWithoutOrganizationInput;
  where: SigmaReportWhereUniqueInput;
};

export type SigmaReportUpdateWithoutOrganizationInput = {
  audienceType?: InputMaybe<EnumOrganizationTypeFieldUpdateOperationsInput>;
  availableToRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
  reportId?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableEnumExternalDashboardScopeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumExternalReportTypeFieldUpdateOperationsInput>;
};

export type SigmaReportUpdateavailableToRolesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SigmaReportUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: SigmaReportCreateWithoutOrganizationInput;
  update: SigmaReportUpdateWithoutOrganizationInput;
  where: SigmaReportWhereUniqueInput;
};

export type SigmaReportWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  availableToRoles?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  icon?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  reportId?: InputMaybe<StringFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalReportTypeFilter>;
};

export type SigmaReportWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SigmaReportWhereInput>>>;
  audienceType?: InputMaybe<EnumOrganizationTypeFilter>;
  availableToRoles?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  icon?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationNullableRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  overrides?: InputMaybe<JsonNullableFilter>;
  reportId?: InputMaybe<StringFilter>;
  scope?: InputMaybe<EnumExternalDashboardScopeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumExternalReportTypeFilter>;
};

export type Skill = {
  __typename?: 'Skill';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SkillCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<SkillObjectEqualityInput>>>;
  every?: InputMaybe<SkillWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SkillWhereInput>;
  some?: InputMaybe<SkillWhereInput>;
};

export type SkillCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SkillDeleteManyInput = {
  where: SkillWhereInput;
};

export type SkillListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<SkillDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<SkillCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<SkillCreateInput>>>;
  updateMany?: InputMaybe<SkillUpdateManyInput>;
};

export type SkillObjectEqualityInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SkillOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SkillUpdateInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SkillUpdateManyInput = {
  data: SkillUpdateInput;
  where: SkillWhereInput;
};

export type SkillWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SkillWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SkillWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SkillWhereInput>>>;
  code?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
};

export type SoapConfig = {
  __typename?: 'SoapConfig';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SoapConfigCreateInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SoapConfigNullableCompositeFilter = {
  equals?: InputMaybe<SoapConfigObjectEqualityInput>;
  is?: InputMaybe<SoapConfigWhereInput>;
  isNot?: InputMaybe<SoapConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SoapConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<SoapConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<SoapConfigUpsertInput>;
};

export type SoapConfigObjectEqualityInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SoapConfigUpdateInput = {
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SoapConfigUpsertInput = {
  set: SoapConfigCreateInput;
  update: SoapConfigUpdateInput;
};

export type SoapConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SoapConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SoapConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SoapConfigWhereInput>>>;
  password?: InputMaybe<StringFilter>;
  username?: InputMaybe<StringFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SsoCompany = {
  __typename?: 'SsoCompany';
  adminSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  allowSiblingSubsidiaryLogin?: Maybe<Scalars['Boolean']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  organizerSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type SsoCompanyCreateInput = {
  adminSsoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  allowSiblingSubsidiaryLogin?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  organizerSsoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type SsoCompanyNullableCompositeFilter = {
  equals?: InputMaybe<SsoCompanyObjectEqualityInput>;
  is?: InputMaybe<SsoCompanyWhereInput>;
  isNot?: InputMaybe<SsoCompanyWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SsoCompanyNullableCreateEnvelopeInput = {
  set?: InputMaybe<SsoCompanyCreateInput>;
};

export type SsoCompanyNullableUpdateEnvelopeInput = {
  set?: InputMaybe<SsoCompanyCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<SsoCompanyUpsertInput>;
};

export type SsoCompanyObjectEqualityInput = {
  adminSsoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  allowSiblingSubsidiaryLogin?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  organizerSsoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type SsoCompanyOrderByInput = {
  adminSsoEnabled?: InputMaybe<SortOrder>;
  allowSiblingSubsidiaryLogin?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  organizerSsoEnabled?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
};

export type SsoCompanyUpdateInput = {
  adminSsoEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  allowSiblingSubsidiaryLogin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identifier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizerSsoEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SsoCompanyUpsertInput = {
  set: SsoCompanyCreateInput;
  update: SsoCompanyUpdateInput;
};

export type SsoCompanyWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SsoCompanyWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SsoCompanyWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SsoCompanyWhereInput>>>;
  adminSsoEnabled?: InputMaybe<BoolNullableFilter>;
  allowSiblingSubsidiaryLogin?: InputMaybe<BoolNullableFilter>;
  identifier?: InputMaybe<StringNullableFilter>;
  organizerSsoEnabled?: InputMaybe<BoolNullableFilter>;
  provider?: InputMaybe<StringNullableFilter>;
};

export type SsoUser = {
  __typename?: 'SsoUser';
  id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type SsoUserCreateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SsoUserNullableCompositeFilter = {
  equals?: InputMaybe<SsoUserObjectEqualityInput>;
  is?: InputMaybe<SsoUserWhereInput>;
  isNot?: InputMaybe<SsoUserWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SsoUserNullableCreateEnvelopeInput = {
  set?: InputMaybe<SsoUserCreateInput>;
};

export type SsoUserNullableUpdateEnvelopeInput = {
  set?: InputMaybe<SsoUserCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<SsoUserUpsertInput>;
};

export type SsoUserObjectEqualityInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SsoUserOrderByInput = {
  id?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
};

export type SsoUserUpdateInput = {
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SsoUserUpsertInput = {
  set: SsoUserCreateInput;
  update: SsoUserUpdateInput;
};

export type SsoUserWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SsoUserWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SsoUserWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SsoUserWhereInput>>>;
  id?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
};

export type StringAllowFilter = {
  __typename?: 'StringAllowFilter';
  allow: Array<Scalars['String']['output']>;
};

export type StringAllowFilterCreateInput = {
  allow?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringAllowFilterCreateallowInput = {
  set: Scalars['String']['input'];
};

export type StringAllowFilterNullableCompositeFilter = {
  equals?: InputMaybe<StringAllowFilterObjectEqualityInput>;
  is?: InputMaybe<StringAllowFilterWhereInput>;
  isNot?: InputMaybe<StringAllowFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringAllowFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StringAllowFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StringAllowFilterUpsertInput>;
};

export type StringAllowFilterObjectEqualityInput = {
  allow?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringAllowFilterOrderByInput = {
  allow?: InputMaybe<SortOrder>;
};

export type StringAllowFilterUpdateInput = {
  allow?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringAllowFilterUpdateallowInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringAllowFilterUpsertInput = {
  set: StringAllowFilterCreateInput;
  update: StringAllowFilterUpdateInput;
};

export type StringAllowFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<StringAllowFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<StringAllowFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<StringAllowFilterWhereInput>>>;
  allow?: InputMaybe<StringNullableListFilter>;
};

export type StringExcludeFilter = {
  __typename?: 'StringExcludeFilter';
  exclude: Array<Scalars['String']['output']>;
};

export type StringExcludeFilterCreateInput = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringExcludeFilterCreateexcludeInput = {
  set: Scalars['String']['input'];
};

export type StringExcludeFilterNullableCompositeFilter = {
  equals?: InputMaybe<StringExcludeFilterObjectEqualityInput>;
  is?: InputMaybe<StringExcludeFilterWhereInput>;
  isNot?: InputMaybe<StringExcludeFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringExcludeFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StringExcludeFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StringExcludeFilterUpsertInput>;
};

export type StringExcludeFilterObjectEqualityInput = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringExcludeFilterOrderByInput = {
  exclude?: InputMaybe<SortOrder>;
};

export type StringExcludeFilterUpdateInput = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringExcludeFilterUpdateexcludeInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringExcludeFilterUpsertInput = {
  set: StringExcludeFilterCreateInput;
  update: StringExcludeFilterUpdateInput;
};

export type StringExcludeFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<StringExcludeFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<StringExcludeFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<StringExcludeFilterWhereInput>>>;
  exclude?: InputMaybe<StringNullableListFilter>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasSome?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** nonprofit stripe info */
export type Stripe = {
  __typename?: 'Stripe';
  accountCountry?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Submitter = {
  __typename?: 'Submitter';
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<ReducedOrganization>;
  type?: Maybe<UserType>;
};

export enum SupportedEntitiesForUserNotification {
  Campaign = 'campaign',
  Deed = 'deed'
}

export type Taxonomy = {
  __typename?: 'Taxonomy';
  externalClassification?: Maybe<Scalars['String']['output']>;
  irsClassificationCode?: Maybe<Scalars['String']['output']>;
  irsFoundationCode?: Maybe<Scalars['String']['output']>;
  irsNteeCode?: Maybe<Scalars['String']['output']>;
  irsStatus?: Maybe<Scalars['String']['output']>;
  irsSubSectionCode?: Maybe<Scalars['String']['output']>;
  ncesSchoolDistrict?: Maybe<Scalars['String']['output']>;
  ncesSchoolType?: Maybe<Scalars['String']['output']>;
};

export type TaxonomyCreateInput = {
  externalClassification?: InputMaybe<Scalars['String']['input']>;
  irsClassificationCode?: InputMaybe<Scalars['String']['input']>;
  irsFoundationCode?: InputMaybe<Scalars['String']['input']>;
  irsNteeCode?: InputMaybe<Scalars['String']['input']>;
  irsStatus?: InputMaybe<Scalars['String']['input']>;
  irsSubSectionCode?: InputMaybe<Scalars['String']['input']>;
  ncesSchoolDistrict?: InputMaybe<Scalars['String']['input']>;
  ncesSchoolType?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyNullableCompositeFilter = {
  equals?: InputMaybe<TaxonomyObjectEqualityInput>;
  is?: InputMaybe<TaxonomyWhereInput>;
  isNot?: InputMaybe<TaxonomyWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxonomyNullableCreateEnvelopeInput = {
  set?: InputMaybe<TaxonomyCreateInput>;
};

export type TaxonomyNullableUpdateEnvelopeInput = {
  set?: InputMaybe<TaxonomyCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<TaxonomyUpsertInput>;
};

export type TaxonomyObjectEqualityInput = {
  externalClassification?: InputMaybe<Scalars['String']['input']>;
  irsClassificationCode?: InputMaybe<Scalars['String']['input']>;
  irsFoundationCode?: InputMaybe<Scalars['String']['input']>;
  irsNteeCode?: InputMaybe<Scalars['String']['input']>;
  irsStatus?: InputMaybe<Scalars['String']['input']>;
  irsSubSectionCode?: InputMaybe<Scalars['String']['input']>;
  ncesSchoolDistrict?: InputMaybe<Scalars['String']['input']>;
  ncesSchoolType?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyOrderByInput = {
  externalClassification?: InputMaybe<SortOrder>;
  irsClassificationCode?: InputMaybe<SortOrder>;
  irsFoundationCode?: InputMaybe<SortOrder>;
  irsNteeCode?: InputMaybe<SortOrder>;
  irsStatus?: InputMaybe<SortOrder>;
  irsSubSectionCode?: InputMaybe<SortOrder>;
  ncesSchoolDistrict?: InputMaybe<SortOrder>;
  ncesSchoolType?: InputMaybe<SortOrder>;
};

export type TaxonomyUpdateInput = {
  externalClassification?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  irsClassificationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  irsFoundationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  irsNteeCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  irsStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  irsSubSectionCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ncesSchoolDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ncesSchoolType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TaxonomyUpsertInput = {
  set: TaxonomyCreateInput;
  update: TaxonomyUpdateInput;
};

export type TaxonomyWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TaxonomyWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TaxonomyWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TaxonomyWhereInput>>>;
  externalClassification?: InputMaybe<StringNullableFilter>;
  irsClassificationCode?: InputMaybe<StringNullableFilter>;
  irsFoundationCode?: InputMaybe<StringNullableFilter>;
  irsNteeCode?: InputMaybe<StringNullableFilter>;
  irsStatus?: InputMaybe<StringNullableFilter>;
  irsSubSectionCode?: InputMaybe<StringNullableFilter>;
  ncesSchoolDistrict?: InputMaybe<StringNullableFilter>;
  ncesSchoolType?: InputMaybe<StringNullableFilter>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  fullName?: Maybe<FullName>;
  id: Scalars['String']['output'];
  mainPicture?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<FullName>;
};

export type TeamsInputType = {
  ids: Array<Scalars['String']['input']>;
  isExclude: Scalars['Boolean']['input'];
};

export enum TimeOffStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Requested = 'REQUESTED'
}

export type TimeOffSyncConfig = {
  __typename?: 'TimeOffSyncConfig';
  baseUri?: Maybe<Scalars['String']['output']>;
  columnHeaderMapping?: Maybe<Scalars['Json']['output']>;
  directory?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  encryption?: Maybe<EncryptionConfiguration>;
  id: Scalars['String']['output'];
  oauth?: Maybe<OauthCredential>;
  sftp?: Maybe<SftpConfig>;
  soap?: Maybe<SoapConfig>;
  syncNames: Array<Scalars['String']['output']>;
  syncType: Scalars['String']['output'];
  tenant?: Maybe<Scalars['String']['output']>;
};

export type TimeOffSyncConfigCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigObjectEqualityInput>>>;
  every?: InputMaybe<TimeOffSyncConfigWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TimeOffSyncConfigWhereInput>;
  some?: InputMaybe<TimeOffSyncConfigWhereInput>;
};

export type TimeOffSyncConfigCreateInput = {
  baseUri?: InputMaybe<Scalars['String']['input']>;
  columnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  directory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationCreateInput>;
  id: Scalars['String']['input'];
  oauth?: InputMaybe<OauthCredentialCreateInput>;
  sftp?: InputMaybe<SftpConfigCreateInput>;
  soap?: InputMaybe<SoapConfigCreateInput>;
  syncNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncType: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type TimeOffSyncConfigCreatesyncNamesInput = {
  set: Scalars['String']['input'];
};

export type TimeOffSyncConfigDeleteManyInput = {
  where: TimeOffSyncConfigWhereInput;
};

export type TimeOffSyncConfigListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
};

export type TimeOffSyncConfigListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<TimeOffSyncConfigDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigCreateInput>>>;
  updateMany?: InputMaybe<TimeOffSyncConfigUpdateManyInput>;
};

export type TimeOffSyncConfigObjectEqualityInput = {
  baseUri?: InputMaybe<Scalars['String']['input']>;
  columnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  directory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  encryption?: InputMaybe<EncryptionConfigurationObjectEqualityInput>;
  id: Scalars['String']['input'];
  oauth?: InputMaybe<OauthCredentialObjectEqualityInput>;
  sftp?: InputMaybe<SftpConfigObjectEqualityInput>;
  soap?: InputMaybe<SoapConfigObjectEqualityInput>;
  syncNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncType: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};

export type TimeOffSyncConfigOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TimeOffSyncConfigUpdateInput = {
  baseUri?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  columnHeaderMapping?: InputMaybe<Scalars['Json']['input']>;
  directory?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  encryption?: InputMaybe<EncryptionConfigurationNullableUpdateEnvelopeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  oauth?: InputMaybe<OauthCredentialNullableUpdateEnvelopeInput>;
  sftp?: InputMaybe<SftpConfigNullableUpdateEnvelopeInput>;
  soap?: InputMaybe<SoapConfigNullableUpdateEnvelopeInput>;
  syncNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  syncType?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TimeOffSyncConfigUpdateManyInput = {
  data: TimeOffSyncConfigUpdateInput;
  where: TimeOffSyncConfigWhereInput;
};

export type TimeOffSyncConfigUpdatesyncNamesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TimeOffSyncConfigWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TimeOffSyncConfigWhereInput>>>;
  baseUri?: InputMaybe<StringNullableFilter>;
  columnHeaderMapping?: InputMaybe<JsonNullableFilter>;
  directory?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolNullableFilter>;
  encryption?: InputMaybe<EncryptionConfigurationNullableCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  oauth?: InputMaybe<OauthCredentialNullableCompositeFilter>;
  sftp?: InputMaybe<SftpConfigNullableCompositeFilter>;
  soap?: InputMaybe<SoapConfigNullableCompositeFilter>;
  syncNames?: InputMaybe<StringNullableListFilter>;
  syncType?: InputMaybe<StringFilter>;
  tenant?: InputMaybe<StringNullableFilter>;
};

export type TotalByGivingAccountAndMonth = {
  __typename?: 'TotalByGivingAccountAndMonth';
  currencyCode: Currency;
  givingAccountId: Scalars['ID']['output'];
  month: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  year: Scalars['String']['output'];
};

export enum TransactionType {
  GivingAccountFunding = 'GivingAccountFunding',
  GivingAccountTransferInbound = 'GivingAccountTransferInbound',
  GivingAccountTransferOutbound = 'GivingAccountTransferOutbound',
  GivingAccountWithdrawal = 'GivingAccountWithdrawal'
}

export type TypeOption = {
  __typename?: 'TypeOption';
  title: Scalars['String']['output'];
};

export type TypeOptionCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<TypeOptionObjectEqualityInput>>>;
  every?: InputMaybe<TypeOptionWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeOptionWhereInput>;
  some?: InputMaybe<TypeOptionWhereInput>;
};

export type TypeOptionCreateInput = {
  title: Scalars['String']['input'];
};

export type TypeOptionDeleteManyInput = {
  where: TypeOptionWhereInput;
};

export type TypeOptionListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<TypeOptionDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<TypeOptionCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<TypeOptionCreateInput>>>;
  updateMany?: InputMaybe<TypeOptionUpdateManyInput>;
};

export type TypeOptionObjectEqualityInput = {
  title: Scalars['String']['input'];
};

export type TypeOptionUpdateInput = {
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TypeOptionUpdateManyInput = {
  data: TypeOptionUpdateInput;
  where: TypeOptionWhereInput;
};

export type TypeOptionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TypeOptionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TypeOptionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TypeOptionWhereInput>>>;
  title?: InputMaybe<StringFilter>;
};

export enum UnresolvedPayrollRunDeductionStatusOverrides {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Unresolved = 'Unresolved'
}

export type UpdateChapterRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Array<InputMaybe<NonprofitIdentifierEntryStrictInput>>>;
  locationObject?: InputMaybe<LocationInput>;
  nonprofitName?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<ChapterRequestUserInput>>>;
};

export type UserAdditionalData = {
  __typename?: 'UserAdditionalData';
  employment?: Maybe<UserAdditionalDataEmployment>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  finchDataHash?: Maybe<Scalars['String']['output']>;
  finchId?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['DateTime']['output']>;
  hrisLocation?: Maybe<HrisLocation>;
  managerFinchId?: Maybe<Scalars['String']['output']>;
  nonprofitAddressChangeRequests: Array<NonprofitAddressChangeRequest>;
  payGroup?: Maybe<PayGroup>;
  proofOfAssociation: Array<ProofOfAssociationFile>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  workAddress?: Maybe<Scalars['String']['output']>;
  workdayId?: Maybe<Scalars['String']['output']>;
};

export type UserAdditionalDataCreateInput = {
  employment?: InputMaybe<UserAdditionalDataEmploymentCreateInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  finchDataHash?: InputMaybe<Scalars['String']['input']>;
  finchId?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['DateTime']['input']>;
  hrisLocation?: InputMaybe<HrisLocationCreateInput>;
  managerFinchId?: InputMaybe<Scalars['String']['input']>;
  nonprofitAddressChangeRequests?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestCreateInput>>>;
  payGroup?: InputMaybe<PayGroupCreateInput>;
  proofOfAssociation?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileCreateInput>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workAddress?: InputMaybe<Scalars['String']['input']>;
  workdayId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdditionalDataEmployment = {
  __typename?: 'UserAdditionalDataEmployment';
  employmentTitle?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
};

export type UserAdditionalDataEmploymentCreateInput = {
  employmentTitle?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdditionalDataEmploymentNullableCompositeFilter = {
  equals?: InputMaybe<UserAdditionalDataEmploymentObjectEqualityInput>;
  is?: InputMaybe<UserAdditionalDataEmploymentWhereInput>;
  isNot?: InputMaybe<UserAdditionalDataEmploymentWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAdditionalDataEmploymentNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserAdditionalDataEmploymentCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserAdditionalDataEmploymentUpsertInput>;
};

export type UserAdditionalDataEmploymentObjectEqualityInput = {
  employmentTitle?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdditionalDataEmploymentOrderByInput = {
  employmentTitle?: InputMaybe<SortOrder>;
  employmentType?: InputMaybe<SortOrder>;
};

export type UserAdditionalDataEmploymentUpdateInput = {
  employmentTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employmentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserAdditionalDataEmploymentUpsertInput = {
  set: UserAdditionalDataEmploymentCreateInput;
  update: UserAdditionalDataEmploymentUpdateInput;
};

export type UserAdditionalDataEmploymentWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserAdditionalDataEmploymentWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserAdditionalDataEmploymentWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserAdditionalDataEmploymentWhereInput>>>;
  employmentTitle?: InputMaybe<StringNullableFilter>;
  employmentType?: InputMaybe<StringNullableFilter>;
};

export type UserAdditionalDataNullableCompositeFilter = {
  equals?: InputMaybe<UserAdditionalDataObjectEqualityInput>;
  is?: InputMaybe<UserAdditionalDataWhereInput>;
  isNot?: InputMaybe<UserAdditionalDataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAdditionalDataNullableCreateEnvelopeInput = {
  set?: InputMaybe<UserAdditionalDataCreateInput>;
};

export type UserAdditionalDataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserAdditionalDataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserAdditionalDataUpsertInput>;
};

export type UserAdditionalDataObjectEqualityInput = {
  employment?: InputMaybe<UserAdditionalDataEmploymentObjectEqualityInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  finchDataHash?: InputMaybe<Scalars['String']['input']>;
  finchId?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['DateTime']['input']>;
  hrisLocation?: InputMaybe<HrisLocationObjectEqualityInput>;
  managerFinchId?: InputMaybe<Scalars['String']['input']>;
  nonprofitAddressChangeRequests?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestObjectEqualityInput>>>;
  payGroup?: InputMaybe<PayGroupObjectEqualityInput>;
  proofOfAssociation?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileObjectEqualityInput>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workAddress?: InputMaybe<Scalars['String']['input']>;
  workdayId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAdditionalDataOrderByInput = {
  employment?: InputMaybe<UserAdditionalDataEmploymentOrderByInput>;
  endDate?: InputMaybe<SortOrder>;
  finchDataHash?: InputMaybe<SortOrder>;
  finchId?: InputMaybe<SortOrder>;
  hireDate?: InputMaybe<SortOrder>;
  hrisLocation?: InputMaybe<HrisLocationOrderByInput>;
  managerFinchId?: InputMaybe<SortOrder>;
  nonprofitAddressChangeRequests?: InputMaybe<NonprofitAddressChangeRequestOrderByCompositeAggregateInput>;
  payGroup?: InputMaybe<PayGroupOrderByInput>;
  proofOfAssociation?: InputMaybe<ProofOfAssociationFileOrderByCompositeAggregateInput>;
  startDate?: InputMaybe<SortOrder>;
  workAddress?: InputMaybe<SortOrder>;
  workdayId?: InputMaybe<SortOrder>;
};

export type UserAdditionalDataUpdateInput = {
  employment?: InputMaybe<UserAdditionalDataEmploymentNullableUpdateEnvelopeInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  finchDataHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  finchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hireDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hrisLocation?: InputMaybe<HrisLocationNullableUpdateEnvelopeInput>;
  managerFinchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nonprofitAddressChangeRequests?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestCreateInput>>>;
  payGroup?: InputMaybe<PayGroupNullableUpdateEnvelopeInput>;
  proofOfAssociation?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileCreateInput>>>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  workAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workdayId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserAdditionalDataUpsertInput = {
  set: UserAdditionalDataCreateInput;
  update: UserAdditionalDataUpdateInput;
};

export type UserAdditionalDataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserAdditionalDataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserAdditionalDataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserAdditionalDataWhereInput>>>;
  employment?: InputMaybe<UserAdditionalDataEmploymentNullableCompositeFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  finchDataHash?: InputMaybe<StringNullableFilter>;
  finchId?: InputMaybe<StringNullableFilter>;
  hireDate?: InputMaybe<DateTimeNullableFilter>;
  hrisLocation?: InputMaybe<HrisLocationNullableCompositeFilter>;
  managerFinchId?: InputMaybe<StringNullableFilter>;
  nonprofitAddressChangeRequests?: InputMaybe<Array<InputMaybe<NonprofitAddressChangeRequestObjectEqualityInput>>>;
  payGroup?: InputMaybe<PayGroupNullableCompositeFilter>;
  proofOfAssociation?: InputMaybe<Array<InputMaybe<ProofOfAssociationFileObjectEqualityInput>>>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  workAddress?: InputMaybe<StringNullableFilter>;
  workdayId?: InputMaybe<StringNullableFilter>;
};

export enum UserFacingVolunteerRewardCreationFailureReason {
  GracePeriodOver = 'gracePeriodOver',
  NoBudgetRule = 'noBudgetRule'
}

export type UserNotification = {
  __typename?: 'UserNotification';
  Organization?: Maybe<Organization>;
  channel: UserNotificationChannel;
  createdAt: Scalars['DateTime']['output'];
  entity: UserNotificationEntity;
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  recipient: UserNotificationRecipient;
};


export type UserNotificationOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type UserNotificationChannel = {
  __typename?: 'UserNotificationChannel';
  msteams?: Maybe<UserNotificationMsTeamsChannel>;
  slack?: Maybe<UserNotificationSlackChannel>;
};

export type UserNotificationChannelCompositeFilter = {
  equals?: InputMaybe<UserNotificationChannelObjectEqualityInput>;
  is?: InputMaybe<UserNotificationChannelWhereInput>;
  isNot?: InputMaybe<UserNotificationChannelWhereInput>;
};

export type UserNotificationChannelCreateEnvelopeInput = {
  set?: InputMaybe<UserNotificationChannelCreateInput>;
};

export type UserNotificationChannelCreateInput = {
  msteams?: InputMaybe<UserNotificationMsTeamsChannelCreateInput>;
  slack?: InputMaybe<UserNotificationSlackChannelCreateInput>;
};

export type UserNotificationChannelObjectEqualityInput = {
  msteams?: InputMaybe<UserNotificationMsTeamsChannelObjectEqualityInput>;
  slack?: InputMaybe<UserNotificationSlackChannelObjectEqualityInput>;
};

export type UserNotificationChannelOrderByInput = {
  msteams?: InputMaybe<UserNotificationMsTeamsChannelOrderByInput>;
  slack?: InputMaybe<UserNotificationSlackChannelOrderByInput>;
};

export type UserNotificationChannelUpdateEnvelopeInput = {
  set?: InputMaybe<UserNotificationChannelCreateInput>;
  update?: InputMaybe<UserNotificationChannelUpdateInput>;
};

export type UserNotificationChannelUpdateInput = {
  msteams?: InputMaybe<UserNotificationMsTeamsChannelNullableUpdateEnvelopeInput>;
  slack?: InputMaybe<UserNotificationSlackChannelNullableUpdateEnvelopeInput>;
};

export type UserNotificationChannelWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationChannelWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationChannelWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationChannelWhereInput>>>;
  msteams?: InputMaybe<UserNotificationMsTeamsChannelNullableCompositeFilter>;
  slack?: InputMaybe<UserNotificationSlackChannelNullableCompositeFilter>;
};

export type UserNotificationCountAggregateOutputType = {
  __typename?: 'UserNotificationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  organization: Scalars['Int']['output'];
};

export type UserNotificationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
};

export type UserNotificationCreateInput = {
  Organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserNotificationInput>;
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationCreateManyInput = {
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationCreateManyOrganizationInput = {
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationCreateManyOrganizationInputEnvelope = {
  data: UserNotificationCreateManyOrganizationInput;
};

export type UserNotificationCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserNotificationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserNotificationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<UserNotificationCreateManyOrganizationInputEnvelope>;
};

export type UserNotificationCreateOrConnectWithoutOrganizationInput = {
  create: UserNotificationCreateWithoutOrganizationInput;
  where: UserNotificationWhereUniqueInput;
};

export type UserNotificationCreateWithoutOrganizationInput = {
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationEntity = {
  __typename?: 'UserNotificationEntity';
  id: Scalars['String']['output'];
  type: SupportedEntitiesForUserNotification;
};

export type UserNotificationEntityCompositeFilter = {
  equals?: InputMaybe<UserNotificationEntityObjectEqualityInput>;
  is?: InputMaybe<UserNotificationEntityWhereInput>;
  isNot?: InputMaybe<UserNotificationEntityWhereInput>;
};

export type UserNotificationEntityCreateEnvelopeInput = {
  set?: InputMaybe<UserNotificationEntityCreateInput>;
};

export type UserNotificationEntityCreateInput = {
  id: Scalars['String']['input'];
  type: SupportedEntitiesForUserNotification;
};

export type UserNotificationEntityObjectEqualityInput = {
  id: Scalars['String']['input'];
  type: SupportedEntitiesForUserNotification;
};

export type UserNotificationEntityOrderByInput = {
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type UserNotificationEntityUpdateEnvelopeInput = {
  set?: InputMaybe<UserNotificationEntityCreateInput>;
  update?: InputMaybe<UserNotificationEntityUpdateInput>;
};

export type UserNotificationEntityUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumSupportedEntitiesForUserNotificationFieldUpdateOperationsInput>;
};

export type UserNotificationEntityWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationEntityWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationEntityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationEntityWhereInput>>>;
  id?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumSupportedEntitiesForUserNotificationFilter>;
};

export type UserNotificationListRelationFilter = {
  every?: InputMaybe<UserNotificationWhereInput>;
  none?: InputMaybe<UserNotificationWhereInput>;
  some?: InputMaybe<UserNotificationWhereInput>;
};

export type UserNotificationMsTeamsChannel = {
  __typename?: 'UserNotificationMSTeamsChannel';
  messageRecords: Array<UserNotificationMsTeamsMessageRecord>;
  placeholders?: Maybe<Scalars['Json']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: UserNotificationStatus;
  templateId?: Maybe<Scalars['String']['output']>;
  tenantIdOnMsTeams?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationMsTeamsChannelCreateInput = {
  messageRecords?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordCreateInput>>>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: UserNotificationStatus;
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationMsTeamsChannelNullableCompositeFilter = {
  equals?: InputMaybe<UserNotificationMsTeamsChannelObjectEqualityInput>;
  is?: InputMaybe<UserNotificationMsTeamsChannelWhereInput>;
  isNot?: InputMaybe<UserNotificationMsTeamsChannelWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationMsTeamsChannelNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserNotificationMsTeamsChannelCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserNotificationMsTeamsChannelUpsertInput>;
};

export type UserNotificationMsTeamsChannelObjectEqualityInput = {
  messageRecords?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordObjectEqualityInput>>>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: UserNotificationStatus;
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationMsTeamsChannelOrderByInput = {
  messageRecords?: InputMaybe<UserNotificationMsTeamsMessageRecordOrderByCompositeAggregateInput>;
  placeholders?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  tenantIdOnMsTeams?: InputMaybe<SortOrder>;
};

export type UserNotificationMsTeamsChannelUpdateInput = {
  messageRecords?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordCreateInput>>>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserNotificationStatusFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenantIdOnMsTeams?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserNotificationMsTeamsChannelUpsertInput = {
  set: UserNotificationMsTeamsChannelCreateInput;
  update: UserNotificationMsTeamsChannelUpdateInput;
};

export type UserNotificationMsTeamsChannelWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsChannelWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsChannelWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsChannelWhereInput>>>;
  messageRecords?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordObjectEqualityInput>>>;
  placeholders?: InputMaybe<JsonNullableFilter>;
  sentAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumUserNotificationStatusFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  tenantIdOnMsTeams?: InputMaybe<StringNullableFilter>;
};

export type UserNotificationMsTeamsMessageRecord = {
  __typename?: 'UserNotificationMSTeamsMessageRecord';
  conversationIdOnMsTeams?: Maybe<Scalars['String']['output']>;
  messageIdOnMsTeams?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationMsTeamsMessageRecordCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordObjectEqualityInput>>>;
  every?: InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>;
  some?: InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>;
};

export type UserNotificationMsTeamsMessageRecordCreateInput = {
  conversationIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
  messageIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationMsTeamsMessageRecordDeleteManyInput = {
  where: UserNotificationMsTeamsMessageRecordWhereInput;
};

export type UserNotificationMsTeamsMessageRecordListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<UserNotificationMsTeamsMessageRecordDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordCreateInput>>>;
  updateMany?: InputMaybe<UserNotificationMsTeamsMessageRecordUpdateManyInput>;
};

export type UserNotificationMsTeamsMessageRecordObjectEqualityInput = {
  conversationIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
  messageIdOnMsTeams?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationMsTeamsMessageRecordOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserNotificationMsTeamsMessageRecordUpdateInput = {
  conversationIdOnMsTeams?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  messageIdOnMsTeams?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserNotificationMsTeamsMessageRecordUpdateManyInput = {
  data: UserNotificationMsTeamsMessageRecordUpdateInput;
  where: UserNotificationMsTeamsMessageRecordWhereInput;
};

export type UserNotificationMsTeamsMessageRecordWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationMsTeamsMessageRecordWhereInput>>>;
  conversationIdOnMsTeams?: InputMaybe<StringNullableFilter>;
  messageIdOnMsTeams?: InputMaybe<StringNullableFilter>;
};

export type UserNotificationMaxAggregateOutputType = {
  __typename?: 'UserNotificationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
};

export type UserNotificationMinAggregateOutputType = {
  __typename?: 'UserNotificationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
};

export type UserNotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserNotificationOrderByWithAggregationInput = {
  _count?: InputMaybe<UserNotificationCountOrderByAggregateInput>;
  _max?: InputMaybe<UserNotificationMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserNotificationMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
};

export type UserNotificationOrderByWithRelationInput = {
  Organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  channel?: InputMaybe<UserNotificationChannelOrderByInput>;
  createdAt?: InputMaybe<SortOrder>;
  entity?: InputMaybe<UserNotificationEntityOrderByInput>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  organization?: InputMaybe<SortOrder>;
  recipient?: InputMaybe<UserNotificationRecipientOrderByInput>;
};

export type UserNotificationRecipient = {
  __typename?: 'UserNotificationRecipient';
  email?: Maybe<Scalars['String']['output']>;
  type: RecipientTypesForUserNotification;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationRecipientCompositeFilter = {
  equals?: InputMaybe<UserNotificationRecipientObjectEqualityInput>;
  is?: InputMaybe<UserNotificationRecipientWhereInput>;
  isNot?: InputMaybe<UserNotificationRecipientWhereInput>;
};

export type UserNotificationRecipientCreateEnvelopeInput = {
  set?: InputMaybe<UserNotificationRecipientCreateInput>;
};

export type UserNotificationRecipientCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  type: RecipientTypesForUserNotification;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationRecipientObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  type: RecipientTypesForUserNotification;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationRecipientOrderByInput = {
  email?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserNotificationRecipientUpdateEnvelopeInput = {
  set?: InputMaybe<UserNotificationRecipientCreateInput>;
  update?: InputMaybe<UserNotificationRecipientUpdateInput>;
};

export type UserNotificationRecipientUpdateInput = {
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRecipientTypesForUserNotificationFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserNotificationRecipientWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationRecipientWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationRecipientWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationRecipientWhereInput>>>;
  email?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumRecipientTypesForUserNotificationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export enum UserNotificationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Organization = 'organization'
}

export type UserNotificationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
};

export type UserNotificationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  organization?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type UserNotificationSlackChannel = {
  __typename?: 'UserNotificationSlackChannel';
  messageIdOnSlack?: Maybe<Scalars['String']['output']>;
  placeholders?: Maybe<Scalars['Json']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: UserNotificationStatus;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationSlackChannelCreateInput = {
  messageIdOnSlack?: InputMaybe<Scalars['String']['input']>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: UserNotificationStatus;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationSlackChannelNullableCompositeFilter = {
  equals?: InputMaybe<UserNotificationSlackChannelObjectEqualityInput>;
  is?: InputMaybe<UserNotificationSlackChannelWhereInput>;
  isNot?: InputMaybe<UserNotificationSlackChannelWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationSlackChannelNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserNotificationSlackChannelCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserNotificationSlackChannelUpsertInput>;
};

export type UserNotificationSlackChannelObjectEqualityInput = {
  messageIdOnSlack?: InputMaybe<Scalars['String']['input']>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: UserNotificationStatus;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationSlackChannelOrderByInput = {
  messageIdOnSlack?: InputMaybe<SortOrder>;
  placeholders?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type UserNotificationSlackChannelUpdateInput = {
  messageIdOnSlack?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeholders?: InputMaybe<Scalars['Json']['input']>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserNotificationStatusFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserNotificationSlackChannelUpsertInput = {
  set: UserNotificationSlackChannelCreateInput;
  update: UserNotificationSlackChannelUpdateInput;
};

export type UserNotificationSlackChannelWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationSlackChannelWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationSlackChannelWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationSlackChannelWhereInput>>>;
  messageIdOnSlack?: InputMaybe<StringNullableFilter>;
  placeholders?: InputMaybe<JsonNullableFilter>;
  sentAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumUserNotificationStatusFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
};

export enum UserNotificationStatus {
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export type UserNotificationUncheckedCreateInput = {
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationUncheckedCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserNotificationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserNotificationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<UserNotificationCreateManyOrganizationInputEnvelope>;
};

export type UserNotificationUncheckedCreateWithoutOrganizationInput = {
  channel: UserNotificationChannelCreateEnvelopeInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entity: UserNotificationEntityCreateEnvelopeInput;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recipient: UserNotificationRecipientCreateEnvelopeInput;
};

export type UserNotificationUncheckedUpdateInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUncheckedUpdateManyInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  organization?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUncheckedUpdateManyWithoutOrganizationInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUncheckedUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserNotificationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserNotificationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<UserNotificationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserNotificationUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserNotificationUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserNotificationUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type UserNotificationUncheckedUpdateWithoutOrganizationInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUpdateInput = {
  Organization?: InputMaybe<OrganizationUpdateOneWithoutUserNotificationNestedInput>;
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUpdateManyMutationInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUpdateManyWithWhereWithoutOrganizationInput = {
  data: UserNotificationUpdateManyMutationInput;
  where: UserNotificationScalarWhereInput;
};

export type UserNotificationUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserNotificationCreateOrConnectWithoutOrganizationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserNotificationCreateWithoutOrganizationInput>>>;
  createMany?: InputMaybe<UserNotificationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserNotificationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserNotificationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserNotificationUpdateWithWhereUniqueWithoutOrganizationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserNotificationUpdateManyWithWhereWithoutOrganizationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserNotificationUpsertWithWhereUniqueWithoutOrganizationInput>>>;
};

export type UserNotificationUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: UserNotificationUpdateWithoutOrganizationInput;
  where: UserNotificationWhereUniqueInput;
};

export type UserNotificationUpdateWithoutOrganizationInput = {
  channel?: InputMaybe<UserNotificationChannelUpdateEnvelopeInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entity?: InputMaybe<UserNotificationEntityUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserNotificationRecipientUpdateEnvelopeInput>;
};

export type UserNotificationUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: UserNotificationCreateWithoutOrganizationInput;
  update: UserNotificationUpdateWithoutOrganizationInput;
  where: UserNotificationWhereUniqueInput;
};

export type UserNotificationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  channel?: InputMaybe<UserNotificationChannelCompositeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entity?: InputMaybe<UserNotificationEntityCompositeFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  recipient?: InputMaybe<UserNotificationRecipientCompositeFilter>;
};

export type UserNotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserNotificationWhereInput>>>;
  Organization?: InputMaybe<OrganizationNullableRelationFilter>;
  channel?: InputMaybe<UserNotificationChannelCompositeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entity?: InputMaybe<UserNotificationEntityCompositeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  organization?: InputMaybe<StringNullableFilter>;
  recipient?: InputMaybe<UserNotificationRecipientCompositeFilter>;
};

export type UserObject = {
  __typename?: 'UserObject';
  _volunteerMinutes?: Maybe<Scalars['Float']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deeds?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mainPicture?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pictures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferredName?: Maybe<FullName>;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum UserType {
  Admin = 'Admin',
  Organizer = 'Organizer',
  User = 'User'
}

export type VerificationFailure = {
  __typename?: 'VerificationFailure';
  accountVerified: Scalars['Boolean']['output'];
  deedName?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  failedAt: Scalars['DateTime']['output'];
  matchDeviation?: Maybe<Scalars['Int']['output']>;
  nonprofit: Scalars['String']['output'];
  payPalBusinessName?: Maybe<Scalars['String']['output']>;
  similarityScore?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<PayPalVerificationStatus>;
  userVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type VerificationFailureCompositeListFilter = {
  equals?: InputMaybe<Array<InputMaybe<VerificationFailureObjectEqualityInput>>>;
  every?: InputMaybe<VerificationFailureWhereInput>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<VerificationFailureWhereInput>;
  some?: InputMaybe<VerificationFailureWhereInput>;
};

export type VerificationFailureCreateInput = {
  accountVerified: Scalars['Boolean']['input'];
  deedName?: InputMaybe<Scalars['String']['input']>;
  emailVerified: Scalars['Boolean']['input'];
  failedAt: Scalars['DateTime']['input'];
  matchDeviation?: InputMaybe<Scalars['Int']['input']>;
  nonprofit: Scalars['String']['input'];
  payPalBusinessName?: InputMaybe<Scalars['String']['input']>;
  similarityScore?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PayPalVerificationStatus>;
  userVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationFailureDeleteManyInput = {
  where: VerificationFailureWhereInput;
};

export type VerificationFailureListCreateEnvelopeInput = {
  set?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
};

export type VerificationFailureListUpdateEnvelopeInput = {
  deleteMany?: InputMaybe<VerificationFailureDeleteManyInput>;
  push?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<VerificationFailureCreateInput>>>;
  updateMany?: InputMaybe<VerificationFailureUpdateManyInput>;
};

export type VerificationFailureObjectEqualityInput = {
  accountVerified: Scalars['Boolean']['input'];
  deedName?: InputMaybe<Scalars['String']['input']>;
  emailVerified: Scalars['Boolean']['input'];
  failedAt: Scalars['DateTime']['input'];
  matchDeviation?: InputMaybe<Scalars['Int']['input']>;
  nonprofit: Scalars['String']['input'];
  payPalBusinessName?: InputMaybe<Scalars['String']['input']>;
  similarityScore?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PayPalVerificationStatus>;
  userVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationFailureOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VerificationFailureUpdateInput = {
  accountVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  failedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  matchDeviation?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<StringFieldUpdateOperationsInput>;
  payPalBusinessName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  similarityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumPayPalVerificationStatusFieldUpdateOperationsInput>;
  userVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type VerificationFailureUpdateManyInput = {
  data: VerificationFailureUpdateInput;
  where: VerificationFailureWhereInput;
};

export type VerificationFailureWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VerificationFailureWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VerificationFailureWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VerificationFailureWhereInput>>>;
  accountVerified?: InputMaybe<BoolFilter>;
  deedName?: InputMaybe<StringNullableFilter>;
  emailVerified?: InputMaybe<BoolFilter>;
  failedAt?: InputMaybe<DateTimeFilter>;
  matchDeviation?: InputMaybe<IntNullableFilter>;
  nonprofit?: InputMaybe<StringFilter>;
  payPalBusinessName?: InputMaybe<StringNullableFilter>;
  similarityScore?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumPayPalVerificationStatusNullableFilter>;
  userVerified?: InputMaybe<BoolNullableFilter>;
};

export type VerificationStatusExcludeFilter = {
  __typename?: 'VerificationStatusExcludeFilter';
  exclude: Array<VerificationStatuses>;
};

export type VerificationStatusExcludeFilterCreateInput = {
  exclude?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type VerificationStatusExcludeFilterCreateexcludeInput = {
  set: VerificationStatuses;
};

export type VerificationStatusExcludeFilterNullableCompositeFilter = {
  equals?: InputMaybe<VerificationStatusExcludeFilterObjectEqualityInput>;
  is?: InputMaybe<VerificationStatusExcludeFilterWhereInput>;
  isNot?: InputMaybe<VerificationStatusExcludeFilterWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationStatusExcludeFilterNullableUpdateEnvelopeInput = {
  set?: InputMaybe<VerificationStatusExcludeFilterCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<VerificationStatusExcludeFilterUpsertInput>;
};

export type VerificationStatusExcludeFilterObjectEqualityInput = {
  exclude?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type VerificationStatusExcludeFilterOrderByInput = {
  exclude?: InputMaybe<SortOrder>;
};

export type VerificationStatusExcludeFilterUpdateInput = {
  exclude?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type VerificationStatusExcludeFilterUpdateexcludeInput = {
  push?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
  set?: InputMaybe<Array<InputMaybe<VerificationStatuses>>>;
};

export type VerificationStatusExcludeFilterUpsertInput = {
  set: VerificationStatusExcludeFilterCreateInput;
  update: VerificationStatusExcludeFilterUpdateInput;
};

export type VerificationStatusExcludeFilterWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VerificationStatusExcludeFilterWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VerificationStatusExcludeFilterWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VerificationStatusExcludeFilterWhereInput>>>;
  exclude?: InputMaybe<EnumVerificationStatusesNullableListFilter>;
};

export enum VerificationStatuses {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type VerifiedUser = {
  __typename?: 'VerifiedUser';
  email: Scalars['String']['output'];
};

/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerReward = {
  __typename?: 'VolunteerReward';
  ApprovalStatusChangedBy?: Maybe<BaseUser>;
  Company: Organization;
  Deed?: Maybe<Deed>;
  Donation?: Maybe<Donation>;
  Form?: Maybe<Form>;
  FormResponse?: Maybe<FormResponse>;
  Nonprofit?: Maybe<Organization>;
  User: BaseUser;
  VolunteerTime: VolunteerTime;
  amount: Scalars['Int']['output'];
  approvalStatus: VolunteerRewardApprovalStatus;
  approvalStatusChangedBy?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Information whether a volunteer reward is in the user personal budget and returns additional budgeting data. */
  budgetingData?: Maybe<VolunteerRewardBudgetingType>;
  company: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  deed?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Scalars['String']['output']>;
  exceededBudget?: Maybe<Scalars['Boolean']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  formResponse?: Maybe<Scalars['String']['output']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofit?: Maybe<Scalars['String']['output']>;
  optedOutAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  user: Scalars['String']['output'];
  volunteerDuration: Scalars['Int']['output'];
  volunteerTime: Scalars['String']['output'];
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardApprovalStatusChangedByArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardDeedArgs = {
  where?: InputMaybe<DeedWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardDonationArgs = {
  where?: InputMaybe<DonationWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardFormArgs = {
  where?: InputMaybe<FormWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardFormResponseArgs = {
  where?: InputMaybe<FormResponseWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardNonprofitArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Organizer(type: Company, privilege: volunteerReward:view, organizationField: company), Organizer(type: Nonprofit, privilege: volunteerReward:view, organizationField: nonprofit), Employee(companyField: company)]) */
export type VolunteerRewardBudgetingDataArgs = {
  where?: InputMaybe<VolunteerRewardWhereInput>;
};

export enum VolunteerRewardApprovalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type VolunteerRewardAvgAggregateOutputType = {
  __typename?: 'VolunteerRewardAvgAggregateOutputType';
  amount?: Maybe<Scalars['Float']['output']>;
  volunteerDuration?: Maybe<Scalars['Float']['output']>;
};

export type VolunteerRewardAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
};

export type VolunteerRewardBudgetingType = {
  __typename?: 'VolunteerRewardBudgetingType';
  amountApprovedInMinutes?: Maybe<Scalars['Int']['output']>;
  amountEligiblePendingInMinutes?: Maybe<Scalars['Int']['output']>;
  budgetRuleEndDate?: Maybe<Scalars['DateTime']['output']>;
  budgetRuleStartDate?: Maybe<Scalars['DateTime']['output']>;
  isVolunteerRewardAmountInPersonalBudget?: Maybe<Scalars['Boolean']['output']>;
  limitPerUserInMinutes?: Maybe<Scalars['Int']['output']>;
  requestedVolunteerRewardAmountInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type VolunteerRewardCountAggregateOutputType = {
  __typename?: 'VolunteerRewardCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  approvalStatus: Scalars['Int']['output'];
  approvalStatusChangedBy: Scalars['Int']['output'];
  approvedAt: Scalars['Int']['output'];
  company: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  deed: Scalars['Int']['output'];
  donation: Scalars['Int']['output'];
  exceededBudget: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  formResponse: Scalars['Int']['output'];
  formStatus: Scalars['Int']['output'];
  formSubmittedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofit: Scalars['Int']['output'];
  optedOutAt: Scalars['Int']['output'];
  rejectedAt: Scalars['Int']['output'];
  user: Scalars['Int']['output'];
  volunteerDuration: Scalars['Int']['output'];
  volunteerTime: Scalars['Int']['output'];
};

export type VolunteerRewardCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<SortOrder>;
  approvalStatusChangedBy?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  donation?: InputMaybe<SortOrder>;
  exceededBudget?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  formResponse?: InputMaybe<SortOrder>;
  formStatus?: InputMaybe<SortOrder>;
  formSubmittedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  optedOutAt?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type VolunteerRewardCreateInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateManyApprovalStatusChangedByInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyApprovalStatusChangedByInputEnvelope = {
  data: VolunteerRewardCreateManyApprovalStatusChangedByInput;
};

export type VolunteerRewardCreateManyCompanyInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyCompanyInputEnvelope = {
  data: VolunteerRewardCreateManyCompanyInput;
};

export type VolunteerRewardCreateManyDeedInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyDeedInputEnvelope = {
  data: VolunteerRewardCreateManyDeedInput;
};

export type VolunteerRewardCreateManyDonationInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyDonationInputEnvelope = {
  data: VolunteerRewardCreateManyDonationInput;
};

export type VolunteerRewardCreateManyFormInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyFormInputEnvelope = {
  data: VolunteerRewardCreateManyFormInput;
};

export type VolunteerRewardCreateManyFormResponseInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyFormResponseInputEnvelope = {
  data: VolunteerRewardCreateManyFormResponseInput;
};

export type VolunteerRewardCreateManyInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyNonprofitInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyNonprofitInputEnvelope = {
  data: VolunteerRewardCreateManyNonprofitInput;
};

export type VolunteerRewardCreateManyUserInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardCreateManyUserInputEnvelope = {
  data: VolunteerRewardCreateManyUserInput;
};

export type VolunteerRewardCreateNestedManyWithoutApprovalStatusChangedByInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutApprovalStatusChangedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutApprovalStatusChangedByInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyApprovalStatusChangedByInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyCompanyInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDeedInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutDonationInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDonationInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutFormInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutFormResponseInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormResponseInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormResponseInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormResponseInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyNonprofitInputEnvelope>;
};

export type VolunteerRewardCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyUserInputEnvelope>;
};

export type VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput = {
  connect?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerRewardCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerRewardCreateWithoutVolunteerTimeInput>;
};

export type VolunteerRewardCreateOrConnectWithoutApprovalStatusChangedByInput = {
  create: VolunteerRewardCreateWithoutApprovalStatusChangedByInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutCompanyInput = {
  create: VolunteerRewardCreateWithoutCompanyInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutDeedInput = {
  create: VolunteerRewardCreateWithoutDeedInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutDonationInput = {
  create: VolunteerRewardCreateWithoutDonationInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutFormInput = {
  create: VolunteerRewardCreateWithoutFormInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutFormResponseInput = {
  create: VolunteerRewardCreateWithoutFormResponseInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutNonprofitInput = {
  create: VolunteerRewardCreateWithoutNonprofitInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutUserInput = {
  create: VolunteerRewardCreateWithoutUserInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateOrConnectWithoutVolunteerTimeInput = {
  create: VolunteerRewardCreateWithoutVolunteerTimeInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardCreateWithoutApprovalStatusChangedByInput = {
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutCompanyInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutDeedInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutDonationInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutFormInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutFormResponseInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutNonprofitInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutUserInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  VolunteerTime: VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardCreateWithoutVolunteerTimeInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerRewardChangedByInput>;
  Company: OrganizationCreateNestedOneWithoutVolunteerRewardsInput;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerRewardsInput>;
  Donation?: InputMaybe<DonationCreateNestedOneWithoutVolunteerRewardsInput>;
  Form?: InputMaybe<FormCreateNestedOneWithoutVolunteerRewardsInput>;
  FormResponse?: InputMaybe<FormResponseCreateNestedOneWithoutVolunteerRewardsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerRewardsInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerRewardsInput;
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardInputType = {
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  optedOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VolunteerRewardListRelationFilter = {
  every?: InputMaybe<VolunteerRewardWhereInput>;
  none?: InputMaybe<VolunteerRewardWhereInput>;
  some?: InputMaybe<VolunteerRewardWhereInput>;
};

export type VolunteerRewardMaxAggregateOutputType = {
  __typename?: 'VolunteerRewardMaxAggregateOutputType';
  amount?: Maybe<Scalars['Int']['output']>;
  approvalStatus?: Maybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deed?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Scalars['String']['output']>;
  exceededBudget?: Maybe<Scalars['Boolean']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  formResponse?: Maybe<Scalars['String']['output']>;
  formStatus?: Maybe<EligibilityFormStatus>;
  formSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofit?: Maybe<Scalars['String']['output']>;
  optedOutAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  volunteerDuration?: Maybe<Scalars['Int']['output']>;
  volunteerTime?: Maybe<Scalars['String']['output']>;
};

export type VolunteerRewardMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<SortOrder>;
  approvalStatusChangedBy?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  donation?: InputMaybe<SortOrder>;
  exceededBudget?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  formResponse?: InputMaybe<SortOrder>;
  formStatus?: InputMaybe<SortOrder>;
  formSubmittedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  optedOutAt?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type VolunteerRewardMinAggregateOutputType = {
  __typename?: 'VolunteerRewardMinAggregateOutputType';
  amount?: Maybe<Scalars['Int']['output']>;
  approvalStatus?: Maybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deed?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Scalars['String']['output']>;
  exceededBudget?: Maybe<Scalars['Boolean']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  formResponse?: Maybe<Scalars['String']['output']>;
  formStatus?: Maybe<EligibilityFormStatus>;
  formSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofit?: Maybe<Scalars['String']['output']>;
  optedOutAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  volunteerDuration?: Maybe<Scalars['Int']['output']>;
  volunteerTime?: Maybe<Scalars['String']['output']>;
};

export type VolunteerRewardMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<SortOrder>;
  approvalStatusChangedBy?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  donation?: InputMaybe<SortOrder>;
  exceededBudget?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  formResponse?: InputMaybe<SortOrder>;
  formStatus?: InputMaybe<SortOrder>;
  formSubmittedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  optedOutAt?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type VolunteerRewardNullableRelationFilter = {
  is?: InputMaybe<VolunteerRewardWhereInput>;
  isNot?: InputMaybe<VolunteerRewardWhereInput>;
};

export type VolunteerRewardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VolunteerRewardOrderByWithAggregationInput = {
  _avg?: InputMaybe<VolunteerRewardAvgOrderByAggregateInput>;
  _count?: InputMaybe<VolunteerRewardCountOrderByAggregateInput>;
  _max?: InputMaybe<VolunteerRewardMaxOrderByAggregateInput>;
  _min?: InputMaybe<VolunteerRewardMinOrderByAggregateInput>;
  _sum?: InputMaybe<VolunteerRewardSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<SortOrder>;
  approvalStatusChangedBy?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  donation?: InputMaybe<SortOrder>;
  exceededBudget?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  formResponse?: InputMaybe<SortOrder>;
  formStatus?: InputMaybe<SortOrder>;
  formSubmittedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  optedOutAt?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export type VolunteerRewardOrderByWithRelationInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserOrderByWithRelationInput>;
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Deed?: InputMaybe<DeedOrderByWithRelationInput>;
  Donation?: InputMaybe<DonationOrderByWithRelationInput>;
  Form?: InputMaybe<FormOrderByWithRelationInput>;
  FormResponse?: InputMaybe<FormResponseOrderByWithRelationInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<SortOrder>;
  approvalStatusChangedBy?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  deed?: InputMaybe<SortOrder>;
  donation?: InputMaybe<SortOrder>;
  exceededBudget?: InputMaybe<SortOrder>;
  form?: InputMaybe<SortOrder>;
  formResponse?: InputMaybe<SortOrder>;
  formStatus?: InputMaybe<SortOrder>;
  formSubmittedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofit?: InputMaybe<SortOrder>;
  optedOutAt?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
  volunteerTime?: InputMaybe<SortOrder>;
};

export enum VolunteerRewardScalarFieldEnum {
  Amount = 'amount',
  ApprovalStatus = 'approvalStatus',
  ApprovalStatusChangedBy = 'approvalStatusChangedBy',
  ApprovedAt = 'approvedAt',
  Company = 'company',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Deed = 'deed',
  Donation = 'donation',
  ExceededBudget = 'exceededBudget',
  Form = 'form',
  FormResponse = 'formResponse',
  FormStatus = 'formStatus',
  FormSubmittedAt = 'formSubmittedAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  Nonprofit = 'nonprofit',
  OptedOutAt = 'optedOutAt',
  RejectedAt = 'rejectedAt',
  User = 'user',
  VolunteerDuration = 'volunteerDuration',
  VolunteerTime = 'volunteerTime'
}

export type VolunteerRewardScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  amount?: InputMaybe<IntFilter>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFilter>;
  approvalStatusChangedBy?: InputMaybe<StringNullableFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  donation?: InputMaybe<StringNullableFilter>;
  exceededBudget?: InputMaybe<BoolNullableFilter>;
  form?: InputMaybe<StringNullableFilter>;
  formResponse?: InputMaybe<StringNullableFilter>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFilter>;
  formSubmittedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofit?: InputMaybe<StringNullableFilter>;
  optedOutAt?: InputMaybe<DateTimeNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<StringFilter>;
  volunteerDuration?: InputMaybe<IntFilter>;
  volunteerTime?: InputMaybe<StringFilter>;
};

export type VolunteerRewardScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<IntWithAggregatesFilter>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusWithAggregatesFilter>;
  approvalStatusChangedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  approvedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  company?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  currency?: InputMaybe<StringWithAggregatesFilter>;
  deed?: InputMaybe<StringNullableWithAggregatesFilter>;
  donation?: InputMaybe<StringNullableWithAggregatesFilter>;
  exceededBudget?: InputMaybe<BoolNullableWithAggregatesFilter>;
  form?: InputMaybe<StringNullableWithAggregatesFilter>;
  formResponse?: InputMaybe<StringNullableWithAggregatesFilter>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusWithAggregatesFilter>;
  formSubmittedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofit?: InputMaybe<StringNullableWithAggregatesFilter>;
  optedOutAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  user?: InputMaybe<StringWithAggregatesFilter>;
  volunteerDuration?: InputMaybe<IntWithAggregatesFilter>;
  volunteerTime?: InputMaybe<StringWithAggregatesFilter>;
};

export type VolunteerRewardSettings = {
  __typename?: 'VolunteerRewardSettings';
  blockedNonprofitEntityTypes: Array<NonprofitEntityType>;
  externalLink?: Maybe<Scalars['String']['output']>;
  fallbackNonprofit?: Maybe<Scalars['String']['output']>;
  gracePeriodInDays?: Maybe<Scalars['Int']['output']>;
  oldValidationForms: Array<Scalars['String']['output']>;
  validationForm?: Maybe<Scalars['String']['output']>;
};

export type VolunteerRewardSettingsCreateInput = {
  blockedNonprofitEntityTypes?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  fallbackNonprofit?: InputMaybe<Scalars['String']['input']>;
  gracePeriodInDays?: InputMaybe<Scalars['Int']['input']>;
  oldValidationForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validationForm?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerRewardSettingsCreateblockedNonprofitEntityTypesInput = {
  set: NonprofitEntityType;
};

export type VolunteerRewardSettingsCreateoldValidationFormsInput = {
  set: Scalars['String']['input'];
};

export type VolunteerRewardSettingsNullableCompositeFilter = {
  equals?: InputMaybe<VolunteerRewardSettingsObjectEqualityInput>;
  is?: InputMaybe<VolunteerRewardSettingsWhereInput>;
  isNot?: InputMaybe<VolunteerRewardSettingsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VolunteerRewardSettingsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<VolunteerRewardSettingsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<VolunteerRewardSettingsUpsertInput>;
};

export type VolunteerRewardSettingsObjectEqualityInput = {
  blockedNonprofitEntityTypes?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  fallbackNonprofit?: InputMaybe<Scalars['String']['input']>;
  gracePeriodInDays?: InputMaybe<Scalars['Int']['input']>;
  oldValidationForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validationForm?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerRewardSettingsOrderByInput = {
  blockedNonprofitEntityTypes?: InputMaybe<SortOrder>;
  externalLink?: InputMaybe<SortOrder>;
  fallbackNonprofit?: InputMaybe<SortOrder>;
  gracePeriodInDays?: InputMaybe<SortOrder>;
  oldValidationForms?: InputMaybe<SortOrder>;
  validationForm?: InputMaybe<SortOrder>;
};

export type VolunteerRewardSettingsUpdateInput = {
  blockedNonprofitEntityTypes?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  externalLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fallbackNonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gracePeriodInDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  oldValidationForms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validationForm?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerRewardSettingsUpdateblockedNonprofitEntityTypesInput = {
  push?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
  set?: InputMaybe<Array<InputMaybe<NonprofitEntityType>>>;
};

export type VolunteerRewardSettingsUpdateoldValidationFormsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VolunteerRewardSettingsUpsertInput = {
  set: VolunteerRewardSettingsCreateInput;
  update: VolunteerRewardSettingsUpdateInput;
};

export type VolunteerRewardSettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerRewardSettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerRewardSettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerRewardSettingsWhereInput>>>;
  blockedNonprofitEntityTypes?: InputMaybe<EnumNonprofitEntityTypeNullableListFilter>;
  externalLink?: InputMaybe<StringNullableFilter>;
  fallbackNonprofit?: InputMaybe<StringNullableFilter>;
  gracePeriodInDays?: InputMaybe<IntNullableFilter>;
  oldValidationForms?: InputMaybe<StringNullableListFilter>;
  validationForm?: InputMaybe<StringNullableFilter>;
};

export type VolunteerRewardSumAggregateOutputType = {
  __typename?: 'VolunteerRewardSumAggregateOutputType';
  amount?: Maybe<Scalars['Int']['output']>;
  volunteerDuration?: Maybe<Scalars['Int']['output']>;
};

export type VolunteerRewardSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  volunteerDuration?: InputMaybe<SortOrder>;
};

export type VolunteerRewardUncheckedCreateInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutApprovalStatusChangedByInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutApprovalStatusChangedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutApprovalStatusChangedByInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyApprovalStatusChangedByInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyCompanyInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDeedInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutDonationInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDonationInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutFormInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutFormResponseInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormResponseInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormResponseInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormResponseInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyNonprofitInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyUserInputEnvelope>;
};

export type VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput = {
  connect?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerRewardCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerRewardCreateWithoutVolunteerTimeInput>;
};

export type VolunteerRewardUncheckedCreateWithoutApprovalStatusChangedByInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutCompanyInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutDeedInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutDonationInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutFormInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutFormResponseInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutNonprofitInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutUserInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  volunteerDuration: Scalars['Int']['input'];
  volunteerTime: Scalars['String']['input'];
};

export type VolunteerRewardUncheckedCreateWithoutVolunteerTimeInput = {
  amount: Scalars['Int']['input'];
  approvalStatus?: InputMaybe<VolunteerRewardApprovalStatus>;
  approvalStatusChangedBy?: InputMaybe<Scalars['String']['input']>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  company: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency: Scalars['String']['input'];
  deed?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['String']['input']>;
  exceededBudget?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Scalars['String']['input']>;
  formResponse?: InputMaybe<Scalars['String']['input']>;
  formStatus: EligibilityFormStatus;
  formSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  optedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: Scalars['String']['input'];
  volunteerDuration: Scalars['Int']['input'];
};

export type VolunteerRewardUncheckedUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutApprovalStatusChangedByNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutApprovalStatusChangedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutApprovalStatusChangedByInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyApprovalStatusChangedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutApprovalStatusChangedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutApprovalStatusChangedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutApprovalStatusChangedByInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutCompanyInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutDeedInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutDonationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutDonationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDonationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutDonationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutDonationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutDonationInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutFormInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutFormNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutFormInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutFormInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutFormInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutFormResponseInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutFormResponseNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormResponseInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormResponseInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormResponseInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutFormResponseInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutFormResponseInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutFormResponseInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutNonprofitInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutUserInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerRewardCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerRewardCreateWithoutVolunteerTimeInput>;
  delete?: InputMaybe<VolunteerRewardWhereInput>;
  disconnect?: InputMaybe<VolunteerRewardWhereInput>;
  update?: InputMaybe<VolunteerRewardUpdateToOneWithWhereWithoutVolunteerTimeInput>;
  upsert?: InputMaybe<VolunteerRewardUpsertWithoutVolunteerTimeInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutApprovalStatusChangedByInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutCompanyInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutDeedInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutDonationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutFormInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutFormResponseInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutNonprofitInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutUserInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
  volunteerTime?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerRewardUncheckedUpdateWithoutVolunteerTimeInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvalStatusChangedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  company?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  deed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  donation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  form?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formResponse?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateManyMutationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateManyWithWhereWithoutApprovalStatusChangedByInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutCompanyInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutDeedInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutDonationInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutFormInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutFormResponseInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutNonprofitInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithWhereWithoutUserInput = {
  data: VolunteerRewardUpdateManyMutationInput;
  where: VolunteerRewardScalarWhereInput;
};

export type VolunteerRewardUpdateManyWithoutApprovalStatusChangedByNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutApprovalStatusChangedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutApprovalStatusChangedByInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyApprovalStatusChangedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutApprovalStatusChangedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutApprovalStatusChangedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutApprovalStatusChangedByInput>>>;
};

export type VolunteerRewardUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerRewardUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerRewardUpdateManyWithoutDonationNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutDonationInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutDonationInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyDonationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutDonationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutDonationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutDonationInput>>>;
};

export type VolunteerRewardUpdateManyWithoutFormNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutFormInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutFormInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutFormInput>>>;
};

export type VolunteerRewardUpdateManyWithoutFormResponseNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutFormResponseInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutFormResponseInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyFormResponseInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutFormResponseInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutFormResponseInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutFormResponseInput>>>;
};

export type VolunteerRewardUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerRewardUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerRewardCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerRewardCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerRewardScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerRewardUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerRewardUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerRewardCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerRewardCreateWithoutVolunteerTimeInput>;
  delete?: InputMaybe<VolunteerRewardWhereInput>;
  disconnect?: InputMaybe<VolunteerRewardWhereInput>;
  update?: InputMaybe<VolunteerRewardUpdateToOneWithWhereWithoutVolunteerTimeInput>;
  upsert?: InputMaybe<VolunteerRewardUpsertWithoutVolunteerTimeInput>;
};

export type VolunteerRewardUpdateToOneWithWhereWithoutVolunteerTimeInput = {
  data: VolunteerRewardUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<VolunteerRewardWhereInput>;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutApprovalStatusChangedByInput = {
  data: VolunteerRewardUpdateWithoutApprovalStatusChangedByInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutCompanyInput = {
  data: VolunteerRewardUpdateWithoutCompanyInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutDeedInput = {
  data: VolunteerRewardUpdateWithoutDeedInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutDonationInput = {
  data: VolunteerRewardUpdateWithoutDonationInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutFormInput = {
  data: VolunteerRewardUpdateWithoutFormInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutFormResponseInput = {
  data: VolunteerRewardUpdateWithoutFormResponseInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: VolunteerRewardUpdateWithoutNonprofitInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithWhereUniqueWithoutUserInput = {
  data: VolunteerRewardUpdateWithoutUserInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpdateWithoutApprovalStatusChangedByInput = {
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutCompanyInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutDeedInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutDonationInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutFormInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutFormResponseInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutNonprofitInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutUserInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpdateWithoutVolunteerTimeInput = {
  ApprovalStatusChangedBy?: InputMaybe<BaseUserUpdateOneWithoutVolunteerRewardChangedByNestedInput>;
  Company?: InputMaybe<OrganizationUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerRewardsNestedInput>;
  Donation?: InputMaybe<DonationUpdateOneWithoutVolunteerRewardsNestedInput>;
  Form?: InputMaybe<FormUpdateOneWithoutVolunteerRewardsNestedInput>;
  FormResponse?: InputMaybe<FormResponseUpdateOneWithoutVolunteerRewardsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerRewardsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerRewardsNestedInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  exceededBudget?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFieldUpdateOperationsInput>;
  formSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  optedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  volunteerDuration?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutApprovalStatusChangedByInput = {
  create: VolunteerRewardCreateWithoutApprovalStatusChangedByInput;
  update: VolunteerRewardUpdateWithoutApprovalStatusChangedByInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutCompanyInput = {
  create: VolunteerRewardCreateWithoutCompanyInput;
  update: VolunteerRewardUpdateWithoutCompanyInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutDeedInput = {
  create: VolunteerRewardCreateWithoutDeedInput;
  update: VolunteerRewardUpdateWithoutDeedInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutDonationInput = {
  create: VolunteerRewardCreateWithoutDonationInput;
  update: VolunteerRewardUpdateWithoutDonationInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutFormInput = {
  create: VolunteerRewardCreateWithoutFormInput;
  update: VolunteerRewardUpdateWithoutFormInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutFormResponseInput = {
  create: VolunteerRewardCreateWithoutFormResponseInput;
  update: VolunteerRewardUpdateWithoutFormResponseInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: VolunteerRewardCreateWithoutNonprofitInput;
  update: VolunteerRewardUpdateWithoutNonprofitInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithWhereUniqueWithoutUserInput = {
  create: VolunteerRewardCreateWithoutUserInput;
  update: VolunteerRewardUpdateWithoutUserInput;
  where: VolunteerRewardWhereUniqueInput;
};

export type VolunteerRewardUpsertWithoutVolunteerTimeInput = {
  create: VolunteerRewardCreateWithoutVolunteerTimeInput;
  update: VolunteerRewardUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<VolunteerRewardWhereInput>;
};

export type VolunteerRewardWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  ApprovalStatusChangedBy?: InputMaybe<BaseUserNullableRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  Donation?: InputMaybe<DonationNullableRelationFilter>;
  Form?: InputMaybe<FormNullableRelationFilter>;
  FormResponse?: InputMaybe<FormResponseNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  User?: InputMaybe<BaseUserRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeRelationFilter>;
  amount?: InputMaybe<IntFilter>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFilter>;
  approvalStatusChangedBy?: InputMaybe<StringNullableFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  donation?: InputMaybe<StringNullableFilter>;
  exceededBudget?: InputMaybe<BoolNullableFilter>;
  form?: InputMaybe<StringNullableFilter>;
  formResponse?: InputMaybe<StringNullableFilter>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFilter>;
  formSubmittedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofit?: InputMaybe<StringNullableFilter>;
  optedOutAt?: InputMaybe<DateTimeNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<StringFilter>;
  volunteerDuration?: InputMaybe<IntFilter>;
  volunteerTime?: InputMaybe<StringFilter>;
};

export type VolunteerRewardWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  ApprovalStatusChangedBy?: InputMaybe<BaseUserNullableRelationFilter>;
  Company?: InputMaybe<OrganizationRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  Donation?: InputMaybe<DonationNullableRelationFilter>;
  Form?: InputMaybe<FormNullableRelationFilter>;
  FormResponse?: InputMaybe<FormResponseNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerRewardWhereInput>>>;
  User?: InputMaybe<BaseUserRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeRelationFilter>;
  amount?: InputMaybe<IntFilter>;
  approvalStatus?: InputMaybe<EnumVolunteerRewardApprovalStatusFilter>;
  approvalStatusChangedBy?: InputMaybe<StringNullableFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  deed?: InputMaybe<StringNullableFilter>;
  donation?: InputMaybe<StringNullableFilter>;
  exceededBudget?: InputMaybe<BoolNullableFilter>;
  form?: InputMaybe<StringNullableFilter>;
  formResponse?: InputMaybe<StringNullableFilter>;
  formStatus?: InputMaybe<EnumEligibilityFormStatusFilter>;
  formSubmittedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofit?: InputMaybe<StringNullableFilter>;
  optedOutAt?: InputMaybe<DateTimeNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<StringFilter>;
  volunteerDuration?: InputMaybe<IntFilter>;
  volunteerTime?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination data */
export type VolunteerRewardsMetaType = {
  __typename?: 'VolunteerRewardsMetaType';
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Volunteer Rewards and pagination meta */
export type VolunteerRewardsType = {
  __typename?: 'VolunteerRewardsType';
  /** volunteerRewards from your company */
  items?: Maybe<Array<VolunteerReward>>;
  /** pagination data for volunteer rewards */
  metadata: VolunteerRewardsMetaType;
};

/** Summary of volunteer reward budgeting data for a user */
export type VolunteerRewardsUserBudgetType = {
  __typename?: 'VolunteerRewardsUserBudgetType';
  amountApprovedInMinutes?: Maybe<Scalars['Int']['output']>;
  amountApprovedInMoney?: Maybe<Scalars['Int']['output']>;
  amountEligiblePendingInMinutes?: Maybe<Scalars['Int']['output']>;
  amountEligiblePendingInMoney?: Maybe<Scalars['Int']['output']>;
  budgetRuleEndDate?: Maybe<Scalars['DateTime']['output']>;
  budgetRuleStartDate?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  limitPerUserInMinutes?: Maybe<Scalars['Int']['output']>;
  limitPerUserInMoney?: Maybe<Scalars['Int']['output']>;
};

/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTime = {
  __typename?: 'VolunteerTime';
  Company?: Maybe<Organization>;
  Deed?: Maybe<Deed>;
  ExternalNonprofitCauses: Array<Cause>;
  Nonprofit?: Maybe<Organization>;
  /** The target a deed role */
  Role?: Maybe<DeedRole>;
  User: BaseUser;
  VolunteerReward?: Maybe<VolunteerReward>;
  VolunteerTimeOff?: Maybe<VolunteerTimeOff>;
  _count: VolunteerTimeCountOutputType;
  additionalQuestionsAnswers: Array<Answers>;
  approval: VolunteerTimeApproval;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  deedId?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  externalNonprofitCauses: Array<Scalars['String']['output']>;
  externalNonprofitCountry?: Maybe<Scalars['String']['output']>;
  externalNonprofitId?: Maybe<Scalars['String']['output']>;
  externalNonprofitName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imported?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Metadata>;
  milestone?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  projectedAt?: Maybe<ProjectedAt>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  volunteerReward?: Maybe<Scalars['String']['output']>;
  volunteerRewardFailureReason?: Maybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: Maybe<Scalars['String']['output']>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeDeedArgs = {
  where?: InputMaybe<DeedWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeExternalNonprofitCausesArgs = {
  cursor?: InputMaybe<CauseWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CauseScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CauseOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CauseWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeNonprofitArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeVolunteerRewardArgs = {
  where?: InputMaybe<VolunteerRewardWhereInput>;
};


/** @Auth(read: [Admin, Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId), Organizer(type: Nonprofit, privilege: volunteertime, organizationField: nonprofitId)]) */
export type VolunteerTimeVolunteerTimeOffArgs = {
  where?: InputMaybe<VolunteerTimeOffWhereInput>;
};

export enum VolunteerTimeApproval {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type VolunteerTimeAvgAggregateOutputType = {
  __typename?: 'VolunteerTimeAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']['output']>;
};

export type VolunteerTimeAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type VolunteerTimeCountAggregateOutputType = {
  __typename?: 'VolunteerTimeCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  approval: Scalars['Int']['output'];
  approvedAt: Scalars['Int']['output'];
  campaignId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  deedId: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  externalNonprofitCauses: Scalars['Int']['output'];
  externalNonprofitCountry: Scalars['Int']['output'];
  externalNonprofitId: Scalars['Int']['output'];
  externalNonprofitName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imported: Scalars['Int']['output'];
  milestone: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  rejectedAt: Scalars['Int']['output'];
  roleId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  volunteerReward: Scalars['Int']['output'];
  volunteerRewardFailureReason: Scalars['Int']['output'];
  volunteerTimeOffId: Scalars['Int']['output'];
};

export type VolunteerTimeCountOrderByAggregateInput = {
  approval?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  externalNonprofitCauses?: InputMaybe<SortOrder>;
  externalNonprofitCountry?: InputMaybe<SortOrder>;
  externalNonprofitId?: InputMaybe<SortOrder>;
  externalNonprofitName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  milestone?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<SortOrder>;
  volunteerRewardFailureReason?: InputMaybe<SortOrder>;
  volunteerTimeOffId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeCountOutputType = {
  __typename?: 'VolunteerTimeCountOutputType';
  ExternalNonprofitCauses: Scalars['Int']['output'];
  FormResponses: Scalars['Int']['output'];
};

export type VolunteerTimeCreateInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateInputType = {
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AdditionalQuestionsAnswersInputType>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deed?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  nonprofit?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  vtoDuration?: InputMaybe<Scalars['Float']['input']>;
};

export type VolunteerTimeCreateManyCompanyInput = {
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeCreateManyCompanyInputEnvelope = {
  data: VolunteerTimeCreateManyCompanyInput;
};

export type VolunteerTimeCreateManyDeedInput = {
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeCreateManyDeedInputEnvelope = {
  data: VolunteerTimeCreateManyDeedInput;
};

export type VolunteerTimeCreateManyInput = {
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeCreateManyNonprofitInput = {
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeCreateManyNonprofitInputEnvelope = {
  data: VolunteerTimeCreateManyNonprofitInput;
};

export type VolunteerTimeCreateManyUserInput = {
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeCreateManyUserInputEnvelope = {
  data: VolunteerTimeCreateManyUserInput;
};

export type VolunteerTimeCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyDeedInputEnvelope>;
};

export type VolunteerTimeCreateNestedManyWithoutExternalNonprofitCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutExternalNonprofitCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutExternalNonprofitCausesInput>>>;
};

export type VolunteerTimeCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyNonprofitInputEnvelope>;
};

export type VolunteerTimeCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyUserInputEnvelope>;
};

export type VolunteerTimeCreateNestedOneWithoutFormResponsesInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutFormResponsesInput>;
};

export type VolunteerTimeCreateNestedOneWithoutVolunteerRewardInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerRewardInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerRewardInput>;
};

export type VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerTimeOffInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerTimeOffInput>;
};

export type VolunteerTimeCreateOrConnectWithoutCompanyInput = {
  create: VolunteerTimeCreateWithoutCompanyInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutDeedInput = {
  create: VolunteerTimeCreateWithoutDeedInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutExternalNonprofitCausesInput = {
  create: VolunteerTimeCreateWithoutExternalNonprofitCausesInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutFormResponsesInput = {
  create: VolunteerTimeCreateWithoutFormResponsesInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutNonprofitInput = {
  create: VolunteerTimeCreateWithoutNonprofitInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutUserInput = {
  create: VolunteerTimeCreateWithoutUserInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutVolunteerRewardInput = {
  create: VolunteerTimeCreateWithoutVolunteerRewardInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateOrConnectWithoutVolunteerTimeOffInput = {
  create: VolunteerTimeCreateWithoutVolunteerTimeOffInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeCreateWithoutCompanyInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutDeedInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutExternalNonprofitCausesInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutFormResponsesInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutUserInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutVolunteerRewardInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateWithoutVolunteerTimeOffInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimesInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseCreateNestedManyWithoutVolunteerTimeInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  User: BaseUserCreateNestedOneWithoutVolunteerTimeInput;
  VolunteerReward?: InputMaybe<VolunteerRewardCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeCreateexternalNonprofitCausesInput = {
  set: Scalars['String']['input'];
};

export type VolunteerTimeListRelationFilter = {
  every?: InputMaybe<VolunteerTimeWhereInput>;
  none?: InputMaybe<VolunteerTimeWhereInput>;
  some?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeMaxAggregateOutputType = {
  __typename?: 'VolunteerTimeMaxAggregateOutputType';
  approval?: Maybe<VolunteerTimeApproval>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  deedId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  externalNonprofitCountry?: Maybe<Scalars['String']['output']>;
  externalNonprofitId?: Maybe<Scalars['String']['output']>;
  externalNonprofitName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  milestone?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  volunteerReward?: Maybe<Scalars['String']['output']>;
  volunteerRewardFailureReason?: Maybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeMaxOrderByAggregateInput = {
  approval?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  externalNonprofitCountry?: InputMaybe<SortOrder>;
  externalNonprofitId?: InputMaybe<SortOrder>;
  externalNonprofitName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  milestone?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<SortOrder>;
  volunteerRewardFailureReason?: InputMaybe<SortOrder>;
  volunteerTimeOffId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeMinAggregateOutputType = {
  __typename?: 'VolunteerTimeMinAggregateOutputType';
  approval?: Maybe<VolunteerTimeApproval>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  deedId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  externalNonprofitCountry?: Maybe<Scalars['String']['output']>;
  externalNonprofitId?: Maybe<Scalars['String']['output']>;
  externalNonprofitName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imported?: Maybe<Scalars['Boolean']['output']>;
  milestone?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  volunteerReward?: Maybe<Scalars['String']['output']>;
  volunteerRewardFailureReason?: Maybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeMinOrderByAggregateInput = {
  approval?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  externalNonprofitCountry?: InputMaybe<SortOrder>;
  externalNonprofitId?: InputMaybe<SortOrder>;
  externalNonprofitName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  milestone?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<SortOrder>;
  volunteerRewardFailureReason?: InputMaybe<SortOrder>;
  volunteerTimeOffId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeNullableRelationFilter = {
  is?: InputMaybe<VolunteerTimeWhereInput>;
  isNot?: InputMaybe<VolunteerTimeWhereInput>;
};

/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOff = {
  __typename?: 'VolunteerTimeOff';
  Company?: Maybe<Organization>;
  Deed?: Maybe<Deed>;
  Nonprofit?: Maybe<Organization>;
  User?: Maybe<BaseUser>;
  VolunteerTime?: Maybe<VolunteerTime>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deedId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  merge?: Maybe<VtoMerge>;
  modifiedAt: Scalars['DateTime']['output'];
  nonprofitId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  remoteId?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TimeOffStatus>;
  userId: Scalars['String']['output'];
  workday?: Maybe<WorkdayVto>;
};


/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOffCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOffDeedArgs = {
  where?: InputMaybe<DeedWhereInput>;
};


/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOffNonprofitArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOffUserArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};


/** @Auth(read: [Owner, Organizer(type: Company, privilege: volunteertime, organizationField: companyId)]) */
export type VolunteerTimeOffVolunteerTimeArgs = {
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeOffAvgAggregateOutputType = {
  __typename?: 'VolunteerTimeOffAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']['output']>;
};

export type VolunteerTimeOffAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffCountAggregateOutputType = {
  __typename?: 'VolunteerTimeOffCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deedId: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  endingAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  nonprofitId: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  requestedAt: Scalars['Int']['output'];
  startingAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type VolunteerTimeOffCountOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  requestedAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffCreateInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeOffsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyCompanyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyCompanyInputEnvelope = {
  data: VolunteerTimeOffCreateManyCompanyInput;
};

export type VolunteerTimeOffCreateManyDeedInput = {
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyDeedInputEnvelope = {
  data: VolunteerTimeOffCreateManyDeedInput;
};

export type VolunteerTimeOffCreateManyInput = {
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyNonprofitInput = {
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyNonprofitInputEnvelope = {
  data: VolunteerTimeOffCreateManyNonprofitInput;
};

export type VolunteerTimeOffCreateManyUserInput = {
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateManyUserInputEnvelope = {
  data: VolunteerTimeOffCreateManyUserInput;
};

export type VolunteerTimeOffCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeOffCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyDeedInputEnvelope>;
};

export type VolunteerTimeOffCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyNonprofitInputEnvelope>;
};

export type VolunteerTimeOffCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyUserInputEnvelope>;
};

export type VolunteerTimeOffCreateNestedOneWithoutVolunteerTimeInput = {
  connect?: InputMaybe<VolunteerTimeOffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerTimeOffCreateWithoutVolunteerTimeInput>;
};

export type VolunteerTimeOffCreateOrConnectWithoutCompanyInput = {
  create: VolunteerTimeOffCreateWithoutCompanyInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffCreateOrConnectWithoutDeedInput = {
  create: VolunteerTimeOffCreateWithoutDeedInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffCreateOrConnectWithoutNonprofitInput = {
  create: VolunteerTimeOffCreateWithoutNonprofitInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffCreateOrConnectWithoutUserInput = {
  create: VolunteerTimeOffCreateWithoutUserInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffCreateOrConnectWithoutVolunteerTimeInput = {
  create: VolunteerTimeOffCreateWithoutVolunteerTimeInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffCreateWithoutCompanyInput = {
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeOffsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateWithoutDeedInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeOffsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateWithoutUserInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeOffsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffCreateWithoutVolunteerTimeInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutCompanyVolunteerTimeOffsInput>;
  Deed?: InputMaybe<DeedCreateNestedOneWithoutVolunteerTimeOffsInput>;
  Nonprofit?: InputMaybe<OrganizationCreateNestedOneWithoutNonprofitVolunteerTimeOffsInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffListRelationFilter = {
  every?: InputMaybe<VolunteerTimeOffWhereInput>;
  none?: InputMaybe<VolunteerTimeOffWhereInput>;
  some?: InputMaybe<VolunteerTimeOffWhereInput>;
};

export type VolunteerTimeOffMaxAggregateOutputType = {
  __typename?: 'VolunteerTimeOffMaxAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deedId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TimeOffStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeOffMaxOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  requestedAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffMinAggregateOutputType = {
  __typename?: 'VolunteerTimeOffMinAggregateOutputType';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deedId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  endingAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  nonprofitId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  startingAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TimeOffStatus>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeOffMinOrderByAggregateInput = {
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  requestedAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffNullableRelationFilter = {
  is?: InputMaybe<VolunteerTimeOffWhereInput>;
  isNot?: InputMaybe<VolunteerTimeOffWhereInput>;
};

export type VolunteerTimeOffOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffOrderByWithAggregationInput = {
  _avg?: InputMaybe<VolunteerTimeOffAvgOrderByAggregateInput>;
  _count?: InputMaybe<VolunteerTimeOffCountOrderByAggregateInput>;
  _max?: InputMaybe<VolunteerTimeOffMaxOrderByAggregateInput>;
  _min?: InputMaybe<VolunteerTimeOffMinOrderByAggregateInput>;
  _sum?: InputMaybe<VolunteerTimeOffSumOrderByAggregateInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  requestedAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Deed?: InputMaybe<DeedOrderByWithRelationInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endingAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  merge?: InputMaybe<VtoMergeOrderByInput>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  requestedAt?: InputMaybe<SortOrder>;
  startingAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  workday?: InputMaybe<WorkdayVtoOrderByInput>;
};

export enum VolunteerTimeOffScalarFieldEnum {
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  DeedId = 'deedId',
  DeletedAt = 'deletedAt',
  Duration = 'duration',
  EndingAt = 'endingAt',
  Id = 'id',
  ModifiedAt = 'modifiedAt',
  NonprofitId = 'nonprofitId',
  Note = 'note',
  RequestedAt = 'requestedAt',
  StartingAt = 'startingAt',
  Status = 'status',
  UserId = 'userId'
}

export type VolunteerTimeOffScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<FloatNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  requestedAt?: InputMaybe<DateTimeNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumTimeOffStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type VolunteerTimeOffScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereWithAggregatesInput>>>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deedId?: InputMaybe<StringNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  duration?: InputMaybe<FloatNullableWithAggregatesFilter>;
  endingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  note?: InputMaybe<StringNullableWithAggregatesFilter>;
  requestedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  startingAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumTimeOffStatusNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type VolunteerTimeOffSumAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSumAggregateOutputType';
  duration?: Maybe<Scalars['Float']['output']>;
};

export type VolunteerTimeOffSumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummary = {
  __typename?: 'VolunteerTimeOffSummary';
  Company?: Maybe<Organization>;
  User?: Maybe<BaseUser>;
  balance: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  merge: Scalars['Json']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  /** Get the outstanding/requested time-off for a user */
  requested: Scalars['Int']['output'];
  /** Get total time-off allocation for a user */
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};


export type VolunteerTimeOffSummaryCompanyArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type VolunteerTimeOffSummaryUserArgs = {
  where?: InputMaybe<BaseUserWhereInput>;
};

export type VolunteerTimeOffSummaryAvgAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSummaryAvgAggregateOutputType';
  balance?: Maybe<Scalars['Float']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
};

export type VolunteerTimeOffSummaryAvgOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryCountAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSummaryCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  merge: Scalars['Int']['output'];
  modifiedAt: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type VolunteerTimeOffSummaryCountOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  merge?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryCreateInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutVolunteerTimeOffSummaryInput>;
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffSummaryInput>;
  balance: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
};

export type VolunteerTimeOffSummaryCreateManyCompanyInput = {
  balance: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type VolunteerTimeOffSummaryCreateManyCompanyInputEnvelope = {
  data: VolunteerTimeOffSummaryCreateManyCompanyInput;
};

export type VolunteerTimeOffSummaryCreateManyInput = {
  balance: Scalars['Int']['input'];
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type VolunteerTimeOffSummaryCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffSummaryCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeOffSummaryCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<VolunteerTimeOffSummaryCreateWithoutUserInput>;
};

export type VolunteerTimeOffSummaryCreateOrConnectWithoutCompanyInput = {
  create: VolunteerTimeOffSummaryCreateWithoutCompanyInput;
  where: VolunteerTimeOffSummaryWhereUniqueInput;
};

export type VolunteerTimeOffSummaryCreateOrConnectWithoutUserInput = {
  create: VolunteerTimeOffSummaryCreateWithoutUserInput;
  where: VolunteerTimeOffSummaryWhereUniqueInput;
};

export type VolunteerTimeOffSummaryCreateWithoutCompanyInput = {
  User?: InputMaybe<BaseUserCreateNestedOneWithoutVolunteerTimeOffSummaryInput>;
  balance: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
};

export type VolunteerTimeOffSummaryCreateWithoutUserInput = {
  Company?: InputMaybe<OrganizationCreateNestedOneWithoutVolunteerTimeOffSummaryInput>;
  balance: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
};

export type VolunteerTimeOffSummaryListRelationFilter = {
  every?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  none?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  some?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
};

export type VolunteerTimeOffSummaryMaxAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSummaryMaxAggregateOutputType';
  balance?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeOffSummaryMaxOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryMinAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSummaryMinAggregateOutputType';
  balance?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VolunteerTimeOffSummaryMinOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryNullableRelationFilter = {
  is?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  isNot?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
};

export type VolunteerTimeOffSummaryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryOrderByWithAggregationInput = {
  _avg?: InputMaybe<VolunteerTimeOffSummaryAvgOrderByAggregateInput>;
  _count?: InputMaybe<VolunteerTimeOffSummaryCountOrderByAggregateInput>;
  _max?: InputMaybe<VolunteerTimeOffSummaryMaxOrderByAggregateInput>;
  _min?: InputMaybe<VolunteerTimeOffSummaryMinOrderByAggregateInput>;
  _sum?: InputMaybe<VolunteerTimeOffSummarySumOrderByAggregateInput>;
  balance?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  merge?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  balance?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  merge?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum VolunteerTimeOffSummaryScalarFieldEnum {
  Balance = 'balance',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Merge = 'merge',
  ModifiedAt = 'modifiedAt',
  Used = 'used',
  UserId = 'userId'
}

export type VolunteerTimeOffSummaryScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereInput>>>;
  balance?: InputMaybe<IntFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  merge?: InputMaybe<JsonFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  used?: InputMaybe<IntFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type VolunteerTimeOffSummaryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereWithAggregatesInput>>>;
  balance?: InputMaybe<IntWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  merge?: InputMaybe<JsonWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  used?: InputMaybe<IntWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type VolunteerTimeOffSummarySumAggregateOutputType = {
  __typename?: 'VolunteerTimeOffSummarySumAggregateOutputType';
  balance?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type VolunteerTimeOffSummarySumOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  used?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOffSummaryUncheckedCreateInput = {
  balance: Scalars['Int']['input'];
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type VolunteerTimeOffSummaryUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffSummaryCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeOffSummaryUncheckedCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<VolunteerTimeOffSummaryCreateWithoutUserInput>;
};

export type VolunteerTimeOffSummaryUncheckedCreateWithoutCompanyInput = {
  balance: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type VolunteerTimeOffSummaryUncheckedCreateWithoutUserInput = {
  balance: Scalars['Int']['input'];
  companyId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  merge: Scalars['Json']['input'];
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  used: Scalars['Int']['input'];
};

export type VolunteerTimeOffSummaryUncheckedUpdateInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateManyInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffSummaryCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<VolunteerTimeOffSummaryCreateWithoutUserInput>;
  delete?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  disconnect?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  update?: InputMaybe<VolunteerTimeOffSummaryUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<VolunteerTimeOffSummaryUpsertWithoutUserInput>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateWithoutCompanyInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUncheckedUpdateWithoutUserInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutVolunteerTimeOffSummaryNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffSummaryNestedInput>;
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUpdateManyMutationInput = {
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUpdateManyWithWhereWithoutCompanyInput = {
  data: VolunteerTimeOffSummaryUpdateManyMutationInput;
  where: VolunteerTimeOffSummaryScalarWhereInput;
};

export type VolunteerTimeOffSummaryUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffSummaryCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeOffSummaryUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<VolunteerTimeOffSummaryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffSummaryCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<VolunteerTimeOffSummaryCreateWithoutUserInput>;
  delete?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  disconnect?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
  update?: InputMaybe<VolunteerTimeOffSummaryUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<VolunteerTimeOffSummaryUpsertWithoutUserInput>;
};

export type VolunteerTimeOffSummaryUpdateToOneWithWhereWithoutUserInput = {
  data: VolunteerTimeOffSummaryUpdateWithoutUserInput;
  where?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
};

export type VolunteerTimeOffSummaryUpdateWithWhereUniqueWithoutCompanyInput = {
  data: VolunteerTimeOffSummaryUpdateWithoutCompanyInput;
  where: VolunteerTimeOffSummaryWhereUniqueInput;
};

export type VolunteerTimeOffSummaryUpdateWithoutCompanyInput = {
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffSummaryNestedInput>;
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUpdateWithoutUserInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutVolunteerTimeOffSummaryNestedInput>;
  balance?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<Scalars['Json']['input']>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  used?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteerTimeOffSummaryUpsertWithWhereUniqueWithoutCompanyInput = {
  create: VolunteerTimeOffSummaryCreateWithoutCompanyInput;
  update: VolunteerTimeOffSummaryUpdateWithoutCompanyInput;
  where: VolunteerTimeOffSummaryWhereUniqueInput;
};

export type VolunteerTimeOffSummaryUpsertWithoutUserInput = {
  create: VolunteerTimeOffSummaryCreateWithoutUserInput;
  update: VolunteerTimeOffSummaryUpdateWithoutUserInput;
  where?: InputMaybe<VolunteerTimeOffSummaryWhereInput>;
};

export type VolunteerTimeOffSummaryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  balance?: InputMaybe<IntFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  merge?: InputMaybe<JsonFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  used?: InputMaybe<IntFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type VolunteerTimeOffSummaryWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffSummaryWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  balance?: InputMaybe<IntFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<JsonFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  used?: InputMaybe<IntFilter>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeOffUncheckedCreateInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeOffUncheckedCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyDeedInputEnvelope>;
};

export type VolunteerTimeOffUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyNonprofitInputEnvelope>;
};

export type VolunteerTimeOffUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyUserInputEnvelope>;
};

export type VolunteerTimeOffUncheckedCreateWithoutCompanyInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedCreateWithoutDeedInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedCreateWithoutNonprofitInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedCreateWithoutUserInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput>;
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedCreateWithoutVolunteerTimeInput = {
  companyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deedId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  endingAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCreateEnvelopeInput>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TimeOffStatus>;
  userId: Scalars['String']['input'];
  workday?: InputMaybe<WorkdayVtoNullableCreateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutCompanyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutDeedInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutUserInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerTimeOffUncheckedUpdateWithoutCompanyInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateWithoutDeedInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateWithoutNonprofitInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateWithoutUserInput = {
  VolunteerTime?: InputMaybe<VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput>;
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUncheckedUpdateWithoutVolunteerTimeInput = {
  companyId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateInputType = {
  duration: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeOffUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateManyWithWhereWithoutCompanyInput = {
  data: VolunteerTimeOffUpdateManyMutationInput;
  where: VolunteerTimeOffScalarWhereInput;
};

export type VolunteerTimeOffUpdateManyWithWhereWithoutDeedInput = {
  data: VolunteerTimeOffUpdateManyMutationInput;
  where: VolunteerTimeOffScalarWhereInput;
};

export type VolunteerTimeOffUpdateManyWithWhereWithoutNonprofitInput = {
  data: VolunteerTimeOffUpdateManyMutationInput;
  where: VolunteerTimeOffScalarWhereInput;
};

export type VolunteerTimeOffUpdateManyWithWhereWithoutUserInput = {
  data: VolunteerTimeOffUpdateManyMutationInput;
  where: VolunteerTimeOffScalarWhereInput;
};

export type VolunteerTimeOffUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeOffUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerTimeOffUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerTimeOffUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeOffCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeOffCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeOffUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput = {
  connect?: InputMaybe<VolunteerTimeOffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeOffCreateOrConnectWithoutVolunteerTimeInput>;
  create?: InputMaybe<VolunteerTimeOffCreateWithoutVolunteerTimeInput>;
  delete?: InputMaybe<VolunteerTimeOffWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<VolunteerTimeOffUpdateToOneWithWhereWithoutVolunteerTimeInput>;
  upsert?: InputMaybe<VolunteerTimeOffUpsertWithoutVolunteerTimeInput>;
};

export type VolunteerTimeOffUpdateToOneWithWhereWithoutVolunteerTimeInput = {
  data: VolunteerTimeOffUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<VolunteerTimeOffWhereInput>;
};

export type VolunteerTimeOffUpdateWithWhereUniqueWithoutCompanyInput = {
  data: VolunteerTimeOffUpdateWithoutCompanyInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpdateWithWhereUniqueWithoutDeedInput = {
  data: VolunteerTimeOffUpdateWithoutDeedInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: VolunteerTimeOffUpdateWithoutNonprofitInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpdateWithWhereUniqueWithoutUserInput = {
  data: VolunteerTimeOffUpdateWithoutUserInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpdateWithoutCompanyInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateWithoutDeedInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateWithoutUserInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput>;
  VolunteerTime?: InputMaybe<VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpdateWithoutVolunteerTimeInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimeOffsNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimeOffsNestedInput>;
  User?: InputMaybe<BaseUserUpdateOneWithoutVolunteerTimeOffsNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  endingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  merge?: InputMaybe<VtoMergeNullableUpdateEnvelopeInput>;
  modifiedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startingAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumTimeOffStatusFieldUpdateOperationsInput>;
  workday?: InputMaybe<WorkdayVtoNullableUpdateEnvelopeInput>;
};

export type VolunteerTimeOffUpsertWithWhereUniqueWithoutCompanyInput = {
  create: VolunteerTimeOffCreateWithoutCompanyInput;
  update: VolunteerTimeOffUpdateWithoutCompanyInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpsertWithWhereUniqueWithoutDeedInput = {
  create: VolunteerTimeOffCreateWithoutDeedInput;
  update: VolunteerTimeOffUpdateWithoutDeedInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: VolunteerTimeOffCreateWithoutNonprofitInput;
  update: VolunteerTimeOffUpdateWithoutNonprofitInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpsertWithWhereUniqueWithoutUserInput = {
  create: VolunteerTimeOffCreateWithoutUserInput;
  update: VolunteerTimeOffUpdateWithoutUserInput;
  where: VolunteerTimeOffWhereUniqueInput;
};

export type VolunteerTimeOffUpsertWithoutVolunteerTimeInput = {
  create: VolunteerTimeOffCreateWithoutVolunteerTimeInput;
  update: VolunteerTimeOffUpdateWithoutVolunteerTimeInput;
  where?: InputMaybe<VolunteerTimeOffWhereInput>;
};

export type VolunteerTimeOffWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeNullableRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<FloatNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  merge?: InputMaybe<VtoMergeNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  requestedAt?: InputMaybe<DateTimeNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumTimeOffStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  workday?: InputMaybe<WorkdayVtoNullableCompositeFilter>;
};

export type VolunteerTimeOffWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeOffWhereInput>>>;
  User?: InputMaybe<BaseUserNullableRelationFilter>;
  VolunteerTime?: InputMaybe<VolunteerTimeNullableRelationFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<FloatNullableFilter>;
  endingAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  merge?: InputMaybe<VtoMergeNullableCompositeFilter>;
  modifiedAt?: InputMaybe<DateTimeFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  requestedAt?: InputMaybe<DateTimeNullableFilter>;
  startingAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumTimeOffStatusNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  workday?: InputMaybe<WorkdayVtoNullableCompositeFilter>;
};

export type VolunteerTimeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOrderByWithAggregationInput = {
  _avg?: InputMaybe<VolunteerTimeAvgOrderByAggregateInput>;
  _count?: InputMaybe<VolunteerTimeCountOrderByAggregateInput>;
  _max?: InputMaybe<VolunteerTimeMaxOrderByAggregateInput>;
  _min?: InputMaybe<VolunteerTimeMinOrderByAggregateInput>;
  _sum?: InputMaybe<VolunteerTimeSumOrderByAggregateInput>;
  approval?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  externalNonprofitCauses?: InputMaybe<SortOrder>;
  externalNonprofitCountry?: InputMaybe<SortOrder>;
  externalNonprofitId?: InputMaybe<SortOrder>;
  externalNonprofitName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  milestone?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  rejectedAt?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<SortOrder>;
  volunteerRewardFailureReason?: InputMaybe<SortOrder>;
  volunteerTimeOffId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeOrderByWithRelationInput = {
  Company?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Deed?: InputMaybe<DeedOrderByWithRelationInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseOrderByRelationAggregateInput>;
  FormResponses?: InputMaybe<FormResponseOrderByRelationAggregateInput>;
  Nonprofit?: InputMaybe<OrganizationOrderByWithRelationInput>;
  Role?: InputMaybe<DeedRoleOrderByInput>;
  User?: InputMaybe<BaseUserOrderByWithRelationInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardOrderByWithRelationInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffOrderByWithRelationInput>;
  additionalQuestionsAnswers?: InputMaybe<AnswersOrderByCompositeAggregateInput>;
  approval?: InputMaybe<SortOrder>;
  approvedAt?: InputMaybe<SortOrder>;
  campaignId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deedId?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  externalNonprofitCauses?: InputMaybe<SortOrder>;
  externalNonprofitCountry?: InputMaybe<SortOrder>;
  externalNonprofitId?: InputMaybe<SortOrder>;
  externalNonprofitName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imported?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<MetadataOrderByInput>;
  milestone?: InputMaybe<SortOrder>;
  modifiedAt?: InputMaybe<SortOrder>;
  nonprofitId?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  projectedAt?: InputMaybe<ProjectedAtOrderByInput>;
  rejectedAt?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  volunteerReward?: InputMaybe<SortOrder>;
  volunteerRewardFailureReason?: InputMaybe<SortOrder>;
  volunteerTimeOffId?: InputMaybe<SortOrder>;
};

export type VolunteerTimeRelationFilter = {
  is?: InputMaybe<VolunteerTimeWhereInput>;
  isNot?: InputMaybe<VolunteerTimeWhereInput>;
};

export enum VolunteerTimeScalarFieldEnum {
  Approval = 'approval',
  ApprovedAt = 'approvedAt',
  CampaignId = 'campaignId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  Date = 'date',
  DeedId = 'deedId',
  Duration = 'duration',
  ExternalNonprofitCauses = 'externalNonprofitCauses',
  ExternalNonprofitCountry = 'externalNonprofitCountry',
  ExternalNonprofitId = 'externalNonprofitId',
  ExternalNonprofitName = 'externalNonprofitName',
  Id = 'id',
  Imported = 'imported',
  Milestone = 'milestone',
  ModifiedAt = 'modifiedAt',
  NonprofitId = 'nonprofitId',
  Notes = 'notes',
  RejectedAt = 'rejectedAt',
  RoleId = 'roleId',
  UserId = 'userId',
  VolunteerReward = 'volunteerReward',
  VolunteerRewardFailureReason = 'volunteerRewardFailureReason',
  VolunteerTimeOffId = 'volunteerTimeOffId'
}

export type VolunteerTimeScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntFilter>;
  externalNonprofitCauses?: InputMaybe<StringNullableListFilter>;
  externalNonprofitCountry?: InputMaybe<StringNullableFilter>;
  externalNonprofitId?: InputMaybe<StringNullableFilter>;
  externalNonprofitName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imported?: InputMaybe<BoolNullableFilter>;
  milestone?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  roleId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  volunteerReward?: InputMaybe<StringNullableFilter>;
  volunteerRewardFailureReason?: InputMaybe<EnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  volunteerTimeOffId?: InputMaybe<StringNullableFilter>;
};

export type VolunteerTimeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereWithAggregatesInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalWithAggregatesFilter>;
  approvedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  campaignId?: InputMaybe<StringNullableWithAggregatesFilter>;
  companyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  date?: InputMaybe<DateTimeWithAggregatesFilter>;
  deedId?: InputMaybe<StringNullableWithAggregatesFilter>;
  duration?: InputMaybe<IntWithAggregatesFilter>;
  externalNonprofitCauses?: InputMaybe<StringNullableListFilter>;
  externalNonprofitCountry?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalNonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalNonprofitName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imported?: InputMaybe<BoolNullableWithAggregatesFilter>;
  milestone?: InputMaybe<StringNullableWithAggregatesFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  nonprofitId?: InputMaybe<StringNullableWithAggregatesFilter>;
  notes?: InputMaybe<StringNullableWithAggregatesFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  roleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
  volunteerReward?: InputMaybe<StringNullableWithAggregatesFilter>;
  volunteerRewardFailureReason?: InputMaybe<EnumUserFacingVolunteerRewardCreationFailureReasonNullableWithAggregatesFilter>;
  volunteerTimeOffId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type VolunteerTimeSumAggregateOutputType = {
  __typename?: 'VolunteerTimeSumAggregateOutputType';
  duration?: Maybe<Scalars['Int']['output']>;
};

export type VolunteerTimeSumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type VolunteerTimeUncheckedCreateInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyCompanyInputEnvelope>;
};

export type VolunteerTimeUncheckedCreateNestedManyWithoutDeedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyDeedInputEnvelope>;
};

export type VolunteerTimeUncheckedCreateNestedManyWithoutExternalNonprofitCausesInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutExternalNonprofitCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutExternalNonprofitCausesInput>>>;
};

export type VolunteerTimeUncheckedCreateNestedManyWithoutNonprofitInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyNonprofitInputEnvelope>;
};

export type VolunteerTimeUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyUserInputEnvelope>;
};

export type VolunteerTimeUncheckedCreateNestedOneWithoutVolunteerTimeOffInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerTimeOffInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerTimeOffInput>;
};

export type VolunteerTimeUncheckedCreateWithoutCompanyInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutDeedInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutExternalNonprofitCausesInput = {
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutFormResponsesInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutNonprofitInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutUserInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutVolunteerRewardInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUncheckedCreateWithoutVolunteerTimeOffInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedCreateNestedManyWithoutVolunteerTimesInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedCreateNestedManyWithoutVolunteerTimeInput>;
  Role?: InputMaybe<DeedRoleNullableCreateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedCreateNestedOneWithoutVolunteerTimeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<VolunteerTimeApproval>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  deedId?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitId?: InputMaybe<Scalars['String']['input']>;
  externalNonprofitName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataNullableCreateEnvelopeInput>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nonprofitId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectedAt?: InputMaybe<ProjectedAtNullableCreateEnvelopeInput>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<UserFacingVolunteerRewardCreationFailureReason>;
};

export type VolunteerTimeUncheckedUpdateInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutCompanyInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutDeedInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutExternalNonprofitCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutExternalNonprofitCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutExternalNonprofitCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutExternalNonprofitCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutExternalNonprofitCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutExternalNonprofitCausesInput>>>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutNonprofitInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutUserInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerTimeUncheckedUpdateOneWithoutVolunteerTimeOffNestedInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerTimeOffInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerTimeOffInput>;
  delete?: InputMaybe<VolunteerTimeWhereInput>;
  disconnect?: InputMaybe<VolunteerTimeWhereInput>;
  update?: InputMaybe<VolunteerTimeUpdateToOneWithWhereWithoutVolunteerTimeOffInput>;
  upsert?: InputMaybe<VolunteerTimeUpsertWithoutVolunteerTimeOffInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutCompanyInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutDeedInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutExternalNonprofitCausesInput = {
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutFormResponsesInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutNonprofitInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutUserInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutVolunteerRewardInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
  volunteerTimeOffId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type VolunteerTimeUncheckedUpdateWithoutVolunteerTimeOffInput = {
  ExternalNonprofitCauses?: InputMaybe<CauseUncheckedUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUncheckedUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUncheckedUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  companyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCauses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  nonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateInputType = {
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AdditionalQuestionsAnswersInputType>>>;
  date?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  milestone?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type VolunteerTimeUpdateManyMutationInput = {
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateManyWithWhereWithoutCompanyInput = {
  data: VolunteerTimeUpdateManyMutationInput;
  where: VolunteerTimeScalarWhereInput;
};

export type VolunteerTimeUpdateManyWithWhereWithoutDeedInput = {
  data: VolunteerTimeUpdateManyMutationInput;
  where: VolunteerTimeScalarWhereInput;
};

export type VolunteerTimeUpdateManyWithWhereWithoutExternalNonprofitCausesInput = {
  data: VolunteerTimeUpdateManyMutationInput;
  where: VolunteerTimeScalarWhereInput;
};

export type VolunteerTimeUpdateManyWithWhereWithoutNonprofitInput = {
  data: VolunteerTimeUpdateManyMutationInput;
  where: VolunteerTimeScalarWhereInput;
};

export type VolunteerTimeUpdateManyWithWhereWithoutUserInput = {
  data: VolunteerTimeUpdateManyMutationInput;
  where: VolunteerTimeScalarWhereInput;
};

export type VolunteerTimeUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutCompanyInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutCompanyInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutCompanyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutCompanyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutCompanyInput>>>;
};

export type VolunteerTimeUpdateManyWithoutDeedNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutDeedInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutDeedInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyDeedInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutDeedInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutDeedInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutDeedInput>>>;
};

export type VolunteerTimeUpdateManyWithoutExternalNonprofitCausesNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutExternalNonprofitCausesInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutExternalNonprofitCausesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutExternalNonprofitCausesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutExternalNonprofitCausesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutExternalNonprofitCausesInput>>>;
};

export type VolunteerTimeUpdateManyWithoutNonprofitNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutNonprofitInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutNonprofitInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyNonprofitInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutNonprofitInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutNonprofitInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutNonprofitInput>>>;
};

export type VolunteerTimeUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<VolunteerTimeCreateWithoutUserInput>>>;
  createMany?: InputMaybe<VolunteerTimeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<VolunteerTimeScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<VolunteerTimeUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<VolunteerTimeUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type VolunteerTimeUpdateOneRequiredWithoutVolunteerRewardNestedInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerRewardInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerRewardInput>;
  update?: InputMaybe<VolunteerTimeUpdateToOneWithWhereWithoutVolunteerRewardInput>;
  upsert?: InputMaybe<VolunteerTimeUpsertWithoutVolunteerRewardInput>;
};

export type VolunteerTimeUpdateOneWithoutFormResponsesNestedInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutFormResponsesInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutFormResponsesInput>;
  delete?: InputMaybe<VolunteerTimeWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<VolunteerTimeUpdateToOneWithWhereWithoutFormResponsesInput>;
  upsert?: InputMaybe<VolunteerTimeUpsertWithoutFormResponsesInput>;
};

export type VolunteerTimeUpdateOneWithoutVolunteerTimeOffNestedInput = {
  connect?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VolunteerTimeCreateOrConnectWithoutVolunteerTimeOffInput>;
  create?: InputMaybe<VolunteerTimeCreateWithoutVolunteerTimeOffInput>;
  delete?: InputMaybe<VolunteerTimeWhereInput>;
  disconnect?: InputMaybe<VolunteerTimeWhereInput>;
  update?: InputMaybe<VolunteerTimeUpdateToOneWithWhereWithoutVolunteerTimeOffInput>;
  upsert?: InputMaybe<VolunteerTimeUpsertWithoutVolunteerTimeOffInput>;
};

export type VolunteerTimeUpdateToOneWithWhereWithoutFormResponsesInput = {
  data: VolunteerTimeUpdateWithoutFormResponsesInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeUpdateToOneWithWhereWithoutVolunteerRewardInput = {
  data: VolunteerTimeUpdateWithoutVolunteerRewardInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeUpdateToOneWithWhereWithoutVolunteerTimeOffInput = {
  data: VolunteerTimeUpdateWithoutVolunteerTimeOffInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeUpdateWithWhereUniqueWithoutCompanyInput = {
  data: VolunteerTimeUpdateWithoutCompanyInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpdateWithWhereUniqueWithoutDeedInput = {
  data: VolunteerTimeUpdateWithoutDeedInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpdateWithWhereUniqueWithoutExternalNonprofitCausesInput = {
  data: VolunteerTimeUpdateWithoutExternalNonprofitCausesInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpdateWithWhereUniqueWithoutNonprofitInput = {
  data: VolunteerTimeUpdateWithoutNonprofitInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpdateWithWhereUniqueWithoutUserInput = {
  data: VolunteerTimeUpdateWithoutUserInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpdateWithoutCompanyInput = {
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutDeedInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutExternalNonprofitCausesInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutFormResponsesInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutNonprofitInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutUserInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutVolunteerRewardInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateWithoutVolunteerTimeOffInput = {
  Company?: InputMaybe<OrganizationUpdateOneWithoutCompanyVolunteerTimesNestedInput>;
  Deed?: InputMaybe<DeedUpdateOneWithoutVolunteerTimeNestedInput>;
  ExternalNonprofitCauses?: InputMaybe<CauseUpdateManyWithoutVolunteerTimesNestedInput>;
  FormResponses?: InputMaybe<FormResponseUpdateManyWithoutVolunteerTimeNestedInput>;
  Nonprofit?: InputMaybe<OrganizationUpdateOneWithoutNonprofitVolunteerTimesNestedInput>;
  Role?: InputMaybe<DeedRoleNullableUpdateEnvelopeInput>;
  User?: InputMaybe<BaseUserUpdateOneRequiredWithoutVolunteerTimeNestedInput>;
  VolunteerReward?: InputMaybe<VolunteerRewardUpdateOneWithoutVolunteerTimeNestedInput>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersCreateInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  campaignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  externalNonprofitCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalNonprofitName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imported?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<MetadataNullableUpdateEnvelopeInput>;
  milestone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  modifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectedAt?: InputMaybe<ProjectedAtNullableUpdateEnvelopeInput>;
  rejectedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerReward?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  volunteerRewardFailureReason?: InputMaybe<NullableEnumUserFacingVolunteerRewardCreationFailureReasonFieldUpdateOperationsInput>;
};

export type VolunteerTimeUpdateexternalNonprofitCausesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VolunteerTimeUpsertWithWhereUniqueWithoutCompanyInput = {
  create: VolunteerTimeCreateWithoutCompanyInput;
  update: VolunteerTimeUpdateWithoutCompanyInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpsertWithWhereUniqueWithoutDeedInput = {
  create: VolunteerTimeCreateWithoutDeedInput;
  update: VolunteerTimeUpdateWithoutDeedInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpsertWithWhereUniqueWithoutExternalNonprofitCausesInput = {
  create: VolunteerTimeCreateWithoutExternalNonprofitCausesInput;
  update: VolunteerTimeUpdateWithoutExternalNonprofitCausesInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpsertWithWhereUniqueWithoutNonprofitInput = {
  create: VolunteerTimeCreateWithoutNonprofitInput;
  update: VolunteerTimeUpdateWithoutNonprofitInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpsertWithWhereUniqueWithoutUserInput = {
  create: VolunteerTimeCreateWithoutUserInput;
  update: VolunteerTimeUpdateWithoutUserInput;
  where: VolunteerTimeWhereUniqueInput;
};

export type VolunteerTimeUpsertWithoutFormResponsesInput = {
  create: VolunteerTimeCreateWithoutFormResponsesInput;
  update: VolunteerTimeUpdateWithoutFormResponsesInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeUpsertWithoutVolunteerRewardInput = {
  create: VolunteerTimeCreateWithoutVolunteerRewardInput;
  update: VolunteerTimeUpdateWithoutVolunteerRewardInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeUpsertWithoutVolunteerTimeOffInput = {
  create: VolunteerTimeCreateWithoutVolunteerTimeOffInput;
  update: VolunteerTimeUpdateWithoutVolunteerTimeOffInput;
  where?: InputMaybe<VolunteerTimeWhereInput>;
};

export type VolunteerTimeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  ExternalNonprofitCauses?: InputMaybe<CauseListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Role?: InputMaybe<DeedRoleNullableCompositeFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  VolunteerReward?: InputMaybe<VolunteerRewardNullableRelationFilter>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffNullableRelationFilter>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersObjectEqualityInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntFilter>;
  externalNonprofitCauses?: InputMaybe<StringNullableListFilter>;
  externalNonprofitCountry?: InputMaybe<StringNullableFilter>;
  externalNonprofitId?: InputMaybe<StringNullableFilter>;
  externalNonprofitName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imported?: InputMaybe<BoolNullableFilter>;
  metadata?: InputMaybe<MetadataNullableCompositeFilter>;
  milestone?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  projectedAt?: InputMaybe<ProjectedAtNullableCompositeFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  roleId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  volunteerReward?: InputMaybe<StringNullableFilter>;
  volunteerRewardFailureReason?: InputMaybe<EnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  volunteerTimeOffId?: InputMaybe<StringNullableFilter>;
};

export type VolunteerTimeWhereUniqueInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Company?: InputMaybe<OrganizationNullableRelationFilter>;
  Deed?: InputMaybe<DeedNullableRelationFilter>;
  ExternalNonprofitCauses?: InputMaybe<CauseListRelationFilter>;
  FormResponses?: InputMaybe<FormResponseListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Nonprofit?: InputMaybe<OrganizationNullableRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<VolunteerTimeWhereInput>>>;
  Role?: InputMaybe<DeedRoleNullableCompositeFilter>;
  User?: InputMaybe<BaseUserRelationFilter>;
  VolunteerReward?: InputMaybe<VolunteerRewardNullableRelationFilter>;
  VolunteerTimeOff?: InputMaybe<VolunteerTimeOffNullableRelationFilter>;
  additionalQuestionsAnswers?: InputMaybe<Array<InputMaybe<AnswersObjectEqualityInput>>>;
  approval?: InputMaybe<EnumVolunteerTimeApprovalFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  campaignId?: InputMaybe<StringNullableFilter>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deedId?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntFilter>;
  externalNonprofitCauses?: InputMaybe<StringNullableListFilter>;
  externalNonprofitCountry?: InputMaybe<StringNullableFilter>;
  externalNonprofitId?: InputMaybe<StringNullableFilter>;
  externalNonprofitName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imported?: InputMaybe<BoolNullableFilter>;
  metadata?: InputMaybe<MetadataNullableCompositeFilter>;
  milestone?: InputMaybe<StringNullableFilter>;
  modifiedAt?: InputMaybe<DateTimeNullableFilter>;
  nonprofitId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  projectedAt?: InputMaybe<ProjectedAtNullableCompositeFilter>;
  rejectedAt?: InputMaybe<DateTimeNullableFilter>;
  roleId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
  volunteerReward?: InputMaybe<Scalars['String']['input']>;
  volunteerRewardFailureReason?: InputMaybe<EnumUserFacingVolunteerRewardCreationFailureReasonNullableFilter>;
  volunteerTimeOffId?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination data */
export type VolunteerTimesMetaType = {
  __typename?: 'VolunteerTimesMetaType';
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Volunteer Times and pagination meta */
export type VolunteerTimesType = {
  __typename?: 'VolunteerTimesType';
  /** volunteerTimes from your company */
  items?: Maybe<Array<VolunteerTime>>;
  /** pagination data for volunteer times */
  metadata: VolunteerTimesMetaType;
};

export type VolunteerTimesUpdateInputType = {
  approval: Scalars['String']['input'];
};

export type VolunteeringPledge = {
  __typename?: 'VolunteeringPledge';
  minutes: Scalars['Int']['output'];
};

export type VolunteeringPledgeCreateInput = {
  minutes: Scalars['Int']['input'];
};

export type VolunteeringPledgeNullableCompositeFilter = {
  equals?: InputMaybe<VolunteeringPledgeObjectEqualityInput>;
  is?: InputMaybe<VolunteeringPledgeWhereInput>;
  isNot?: InputMaybe<VolunteeringPledgeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VolunteeringPledgeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<VolunteeringPledgeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<VolunteeringPledgeUpsertInput>;
};

export type VolunteeringPledgeObjectEqualityInput = {
  minutes: Scalars['Int']['input'];
};

export type VolunteeringPledgeUpdateInput = {
  minutes?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type VolunteeringPledgeUpsertInput = {
  set: VolunteeringPledgeCreateInput;
  update: VolunteeringPledgeUpdateInput;
};

export type VolunteeringPledgeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VolunteeringPledgeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VolunteeringPledgeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VolunteeringPledgeWhereInput>>>;
  minutes?: InputMaybe<IntFilter>;
};

export type VtoMerge = {
  __typename?: 'VtoMerge';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  units: Scalars['String']['output'];
};

export type VtoMergeCreateInput = {
  amount: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  units: Scalars['String']['input'];
};

export type VtoMergeNullableCompositeFilter = {
  equals?: InputMaybe<VtoMergeObjectEqualityInput>;
  is?: InputMaybe<VtoMergeWhereInput>;
  isNot?: InputMaybe<VtoMergeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VtoMergeNullableCreateEnvelopeInput = {
  set?: InputMaybe<VtoMergeCreateInput>;
};

export type VtoMergeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<VtoMergeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<VtoMergeUpsertInput>;
};

export type VtoMergeObjectEqualityInput = {
  amount: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
  units: Scalars['String']['input'];
};

export type VtoMergeOrderByInput = {
  amount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  remoteId?: InputMaybe<SortOrder>;
  units?: InputMaybe<SortOrder>;
};

export type VtoMergeUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  remoteId?: InputMaybe<StringFieldUpdateOperationsInput>;
  units?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VtoMergeUpsertInput = {
  set: VtoMergeCreateInput;
  update: VtoMergeUpdateInput;
};

export type VtoMergeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VtoMergeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VtoMergeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VtoMergeWhereInput>>>;
  amount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  remoteId?: InputMaybe<StringFilter>;
  units?: InputMaybe<StringFilter>;
};

export type WorkdayVto = {
  __typename?: 'WorkdayVto';
  comment?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timeOffType?: Maybe<Scalars['String']['output']>;
  timeOffTypeId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  workerId?: Maybe<Scalars['String']['output']>;
};

export type WorkdayVtoCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timeOffType?: InputMaybe<Scalars['String']['input']>;
  timeOffTypeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkdayVtoNullableCompositeFilter = {
  equals?: InputMaybe<WorkdayVtoObjectEqualityInput>;
  is?: InputMaybe<WorkdayVtoWhereInput>;
  isNot?: InputMaybe<WorkdayVtoWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkdayVtoNullableCreateEnvelopeInput = {
  set?: InputMaybe<WorkdayVtoCreateInput>;
};

export type WorkdayVtoNullableUpdateEnvelopeInput = {
  set?: InputMaybe<WorkdayVtoCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<WorkdayVtoUpsertInput>;
};

export type WorkdayVtoObjectEqualityInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timeOffType?: InputMaybe<Scalars['String']['input']>;
  timeOffTypeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  workerId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkdayVtoOrderByInput = {
  comment?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeOffType?: InputMaybe<SortOrder>;
  timeOffTypeId?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkdayVtoUpdateInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  date?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeOffTypeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type WorkdayVtoUpsertInput = {
  set: WorkdayVtoCreateInput;
  update: WorkdayVtoUpdateInput;
};

export type WorkdayVtoWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<WorkdayVtoWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<WorkdayVtoWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<WorkdayVtoWhereInput>>>;
  comment?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<StringNullableFilter>;
  reason?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  timeOffType?: InputMaybe<StringNullableFilter>;
  timeOffTypeId?: InputMaybe<StringNullableFilter>;
  unit?: InputMaybe<StringNullableFilter>;
  workerId?: InputMaybe<StringNullableFilter>;
};

export type Wrapped = {
  __typename?: 'Wrapped';
  actionIncentives?: Maybe<Scalars['Json']['output']>;
  activitiesCount?: Maybe<Scalars['Int']['output']>;
  awardedBadges?: Maybe<Array<Maybe<Badge>>>;
  awardedBadgesCount?: Maybe<Scalars['Int']['output']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  campaignsCount?: Maybe<Scalars['Int']['output']>;
  causes?: Maybe<Array<Maybe<Cause>>>;
  donatedAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  donatedCount?: Maybe<Scalars['Int']['output']>;
  hasEnoughData?: Maybe<Scalars['Boolean']['output']>;
  matchedAmountCurrencies?: Maybe<Scalars['Json']['output']>;
  nonprofits?: Maybe<Array<Maybe<Nonprofit>>>;
  nonprofitsCount?: Maybe<Scalars['Int']['output']>;
  volunteerTimeMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ZendeskMetadata = {
  __typename?: 'ZendeskMetadata';
  encodedId?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['Int']['output']>;
};

export type ZendeskMetadataCreateInput = {
  encodedId?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['Int']['input']>;
};

export type ZendeskMetadataNullableCompositeFilter = {
  equals?: InputMaybe<ZendeskMetadataObjectEqualityInput>;
  is?: InputMaybe<ZendeskMetadataWhereInput>;
  isNot?: InputMaybe<ZendeskMetadataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZendeskMetadataNullableCreateEnvelopeInput = {
  set?: InputMaybe<ZendeskMetadataCreateInput>;
};

export type ZendeskMetadataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ZendeskMetadataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ZendeskMetadataUpsertInput>;
};

export type ZendeskMetadataObjectEqualityInput = {
  encodedId?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['Int']['input']>;
};

export type ZendeskMetadataOrderByInput = {
  encodedId?: InputMaybe<SortOrder>;
  ticketId?: InputMaybe<SortOrder>;
};

export type ZendeskMetadataUpdateInput = {
  encodedId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ticketId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZendeskMetadataUpsertInput = {
  set: ZendeskMetadataCreateInput;
  update: ZendeskMetadataUpdateInput;
};

export type ZendeskMetadataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ZendeskMetadataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ZendeskMetadataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZendeskMetadataWhereInput>>>;
  encodedId?: InputMaybe<StringNullableFilter>;
  ticketId?: InputMaybe<IntNullableFilter>;
};

export type ImpactAiGenerationMutationVariables = Exact<{
  generationId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
  metadata?: InputMaybe<Scalars['Json']['input']>;
}>;


export type ImpactAiGenerationMutation = { __typename?: 'Mutation', impactAiGeneration?: any | null };

export type ImpactAiPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpactAiPresetsQuery = { __typename?: 'Query', impactAiPresets?: { __typename?: 'ImpactAiPresets', totalCount: number, items: Array<{ __typename?: 'ImpactAiPreset', id: string, title: string, description: string, iconName: string, color: string, enabled?: boolean | null, organizations?: Array<string | null> | null, initialContext?: any | null, relatedPresets?: Array<string | null> | null, requiredPrivileges?: Array<string | null> | null, sortIndex?: number | null, actions: Array<{ __typename?: 'ImpactAiPresetAction', type: string, data?: any | null }> }> } | null };

export type ImpactAiNonprofitQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImpactAiNonprofitQuery = { __typename?: 'Query', nonprofit?: { __typename?: 'ExtendedDeedNonprofit', id?: string | null, nonprofitId?: string | null, name?: string | null, ein?: string | null, brief?: string | null, categories?: Array<string | null> | null, identifiers?: Array<{ __typename?: 'NonprofitIdentifierEntryType', type?: string | null, id?: string | null, countryCode?: string | null } | null> | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null };

export type ImpactAiNonprofitSearchQueryVariables = Exact<{
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  donationProvider?: InputMaybe<Scalars['String']['input']>;
  excludeDonationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImpactAiNonprofitSearchQuery = { __typename?: 'Query', searchNonprofits: Array<{ __typename?: 'DeedNonprofit', id?: string | null, type?: string | null, approved?: boolean | null, brief?: string | null, currencyCode?: string | null, ein?: string | null, email?: string | null, externalId?: string | null, name?: string | null, nonprofitEntityType?: string | null, categories?: Array<string | null> | null, searchTermMatchScore?: number | null, matchForSearchTerm?: string | null, identifiers?: Array<{ __typename?: 'NonprofitIdentifierEntryType', countryCode?: string | null, id?: string | null, type?: string | null } | null> | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, address2?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null, geo?: { __typename?: 'GeoJSON', coordinates: Array<number>, type?: string | null } | null } | null, meta?: { __typename?: 'NonprofitMeta', totalItems?: number | null, totalPages?: number | null, offset?: number | null, limit?: number | null } | null } | null> };

export type UpsertActionTemplateMutationVariables = Exact<{
  data: ActionTemplateUpsertInputType;
}>;


export type UpsertActionTemplateMutation = { __typename?: 'Mutation', mutationUpsertActionTemplate?: { __typename?: 'ActionTemplate', id: string, status: ActionVisibilityStatus, title: string, subTitle?: string | null, description?: string | null, bannerImage?: string | null, organizationId?: string | null, public?: boolean | null, causes: Array<string>, incentives: Array<{ __typename?: 'Incentive', type: IncentiveType, amount: number, unit: string }> } | null };

export type CreateActionFromTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type CreateActionFromTemplateMutation = { __typename?: 'Mutation', createActionFromTemplate?: { __typename?: 'Action', id: string } | null };

export type ActionTemplateResultsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  causes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<ActionVisibilityStatus> | ActionVisibilityStatus>;
  public?: InputMaybe<Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input']>;
}>;


export type ActionTemplateResultsQuery = { __typename?: 'Query', actionTemplateResults?: { __typename?: 'ActionTemplatesResult', total: number, templates: Array<{ __typename?: 'ActionTemplate', id: string, status: ActionVisibilityStatus, title: string, subTitle?: string | null, description?: string | null, bannerImage?: string | null, organizationId?: string | null, public?: boolean | null, createdAt?: any | null, modifiedAt?: any | null, Causes: Array<{ __typename?: 'Cause', id: string, name: string, code?: string | null, type: CauseType }>, incentives: Array<{ __typename?: 'Incentive', type: IncentiveType, unit: string, amount: number }> }> } | null };

export type HandleNonprofitAddressChangeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  ticketId: Scalars['Int']['input'];
  nonprofitId: Scalars['ID']['input'];
  approve: Scalars['Boolean']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type HandleNonprofitAddressChangeMutation = { __typename?: 'Mutation', handleNonprofitAddressChange?: boolean | null };

export type AffiliationsListQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AffiliationsListQuery = { __typename?: 'Query', affiliations: Array<{ __typename?: 'Affiliation', id: string, userId: string, companyId: string, nonprofitId: string, startingAt?: any | null, endingAt?: any | null, affiliationType?: AffiliationType | null, boardPosition?: AffiliationBoardPosition | null, createdAt?: any | null, modifiedAt?: any | null, Nonprofit: { __typename?: 'Organization', name: string, mainPicture?: string | null } }> };

export type AffiliationByIdQueryVariables = Exact<{
  affiliationId: Scalars['ID']['input'];
}>;


export type AffiliationByIdQuery = { __typename?: 'Query', affiliation?: { __typename?: 'Affiliation', id: string, userId: string, companyId: string, nonprofitId: string, startingAt?: any | null, endingAt?: any | null, affiliationType?: AffiliationType | null, boardPosition?: AffiliationBoardPosition | null, createdAt?: any | null, modifiedAt?: any | null, Nonprofit: { __typename?: 'Organization', name: string, mainPicture?: string | null } } | null };

export type DeleteEmployeeAffiliationMutationVariables = Exact<{
  deleteEmployeeAffiliationId: Scalars['ID']['input'];
}>;


export type DeleteEmployeeAffiliationMutation = { __typename?: 'Mutation', deleteEmployeeAffiliation?: { __typename?: 'Affiliation', id: string } | null };

export type UpdateEmployeeAffiliationMutationVariables = Exact<{
  updateEmployeeAffiliationId: Scalars['ID']['input'];
  data: EmployeeAffiliationUpdateInputType;
}>;


export type UpdateEmployeeAffiliationMutation = { __typename?: 'Mutation', updateEmployeeAffiliation?: { __typename?: 'Affiliation', id: string, startingAt?: any | null, endingAt?: any | null, affiliationType?: AffiliationType | null, boardPosition?: AffiliationBoardPosition | null } | null };

export type CreateEmployeeAffiliationMutationVariables = Exact<{
  data: EmployeeAffiliationCreateInputType;
}>;


export type CreateEmployeeAffiliationMutation = { __typename?: 'Mutation', createEmployeeAffiliation?: { __typename?: 'Affiliation', id: string } | null };

export type CreateImpactAiPresetMutationVariables = Exact<{
  data: ImpactAiPresetCreateInput;
}>;


export type CreateImpactAiPresetMutation = { __typename?: 'Mutation', createImpactAiPreset?: { __typename?: 'ImpactAiPreset', id: string, title: string, description: string, iconName: string, color: string, enabled?: boolean | null, organizations?: Array<string | null> | null, initialContext?: any | null, sortIndex?: number | null, actions: Array<{ __typename?: 'ImpactAiPresetAction', type: string, data?: any | null }> } | null };

export type UpdateImpactAiPresetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: ImpactAiPresetUpdateInput;
}>;


export type UpdateImpactAiPresetMutation = { __typename?: 'Mutation', updateImpactAiPreset?: { __typename?: 'ImpactAiPreset', id: string, title: string, description: string, iconName: string, color: string, enabled?: boolean | null, organizations?: Array<string | null> | null, initialContext?: any | null, sortIndex?: number | null, actions: Array<{ __typename?: 'ImpactAiPresetAction', type: string, data?: any | null }> } | null };

export type DeleteImpactAiPresetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteImpactAiPresetMutation = { __typename?: 'Mutation', deleteImpactAiPreset?: boolean | null };

export type MigratedAndToBeMigratedCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type MigratedAndToBeMigratedCommunitiesQuery = { __typename?: 'Query', migratedAndToBeMigratedCommunities: { __typename?: 'CommunitiesMigrationProjection', migratedCommunities?: Array<{ __typename?: 'CommunityPartial', id?: string | null, title: string }> | null, toBeMigratedCommunities?: Array<{ __typename?: 'CommunityPartial', sourceERGId?: string | null, title: string }> | null } };

export type MigrateErGsToCommunitiesMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateErGsToCommunitiesMutation = { __typename?: 'Mutation', migrateERGsToCommunities: { __typename?: 'CommunitiesMigrationResult', updatedCommunities?: Array<{ __typename?: 'CommunityPartial', id?: string | null, title: string, sourceERGId?: string | null }> | null, newlyCreatedCommunities?: Array<{ __typename?: 'CommunityPartial', id?: string | null, title: string, sourceERGId?: string | null }> | null } };

export type ChallengeDetailsFragment = { __typename?: 'Challenge', id: string, title: string, totalText?: string | null, totalHeadline?: string | null, backgroundImage?: string | null, startDate?: any | null, endDate?: any | null, status: ChallengeStatus, sorting: number, rules: { __typename?: 'ChallengeRules', actionsCompleted: { __typename?: 'ChallengeRulesActionsCompleted', isExclude: boolean, ids: Array<string> } }, teams: { __typename?: 'ParticipatingTeams', isExclude: boolean, ids: Array<string> } };

export type ChallengeQueryVariables = Exact<{
  where: ChallengeWhereInput;
}>;


export type ChallengeQuery = { __typename?: 'Query', challenges?: { __typename?: 'ChallengesType', items?: Array<{ __typename?: 'Challenge', id: string, title: string, totalText?: string | null, totalHeadline?: string | null, backgroundImage?: string | null, startDate?: any | null, endDate?: any | null, status: ChallengeStatus, sorting: number, rules: { __typename?: 'ChallengeRules', actionsCompleted: { __typename?: 'ChallengeRulesActionsCompleted', isExclude: boolean, ids: Array<string> } }, teams: { __typename?: 'ParticipatingTeams', isExclude: boolean, ids: Array<string> } }> | null } | null };

export type UpsertChallengeMutationVariables = Exact<{
  data: ChallengeUpsertInputType;
}>;


export type UpsertChallengeMutation = { __typename?: 'Mutation', upsertChallenge?: { __typename?: 'Challenge', id: string, title: string, totalText?: string | null, totalHeadline?: string | null, backgroundImage?: string | null, startDate?: any | null, endDate?: any | null, status: ChallengeStatus, sorting: number, rules: { __typename?: 'ChallengeRules', actionsCompleted: { __typename?: 'ChallengeRulesActionsCompleted', isExclude: boolean, ids: Array<string> } }, teams: { __typename?: 'ParticipatingTeams', isExclude: boolean, ids: Array<string> } } | null };

export type CommunityTeamsQueryVariables = Exact<{
  where?: InputMaybe<CommunityWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommunityTeamsQuery = { __typename?: 'Query', communities: Array<{ __typename?: 'Community', id: string, title: string, type?: CommunityEntityType | null }> };

export type ChallengeFragment = { __typename?: 'Challenge', id: string, title: string, backgroundImage?: string | null, startDate?: any | null, endDate?: any | null, status: ChallengeStatus, totalText?: string | null, totalHeadline?: string | null, generalStats: { __typename?: 'ChallengeGeneralStats', totalParticipants: number, totalUsersWithActionsCompleted: number, totalTeams: number } };

export type ChallengesQueryVariables = Exact<{
  where?: InputMaybe<ChallengeWhereInput>;
  orderBy?: InputMaybe<ChallengeOrderByWithRelationInput>;
  orderByList?: InputMaybe<Array<InputMaybe<ChallengeOrderByWithRelationInput>> | InputMaybe<ChallengeOrderByWithRelationInput>>;
  cursor?: InputMaybe<ChallengeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChallengesQuery = { __typename?: 'Query', challenges?: { __typename?: 'ChallengesType', items?: Array<{ __typename?: 'Challenge', id: string, title: string, backgroundImage?: string | null, startDate?: any | null, endDate?: any | null, status: ChallengeStatus, totalText?: string | null, totalHeadline?: string | null, generalStats: { __typename?: 'ChallengeGeneralStats', totalParticipants: number, totalUsersWithActionsCompleted: number, totalTeams: number } }> | null, metadata: { __typename?: 'ChallengesMetaType', totalItems?: number | null, totalPages?: number | null, skip?: number | null, take?: number | null } } | null };

export type ChallengesTeamRankingsQueryVariables = Exact<{
  where?: InputMaybe<ChallengeWhereInput>;
  orderBy?: InputMaybe<ChallengeOrderByWithRelationInput>;
  orderByList?: InputMaybe<Array<InputMaybe<ChallengeOrderByWithRelationInput>> | InputMaybe<ChallengeOrderByWithRelationInput>>;
  cursor?: InputMaybe<ChallengeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  teamRankingsTake?: InputMaybe<Scalars['Int']['input']>;
  teamRankingsSkip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChallengesTeamRankingsQuery = { __typename?: 'Query', challenges?: { __typename?: 'ChallengesType', items?: Array<{ __typename?: 'Challenge', id: string, teamRankings: { __typename?: 'ChallengeTeamRanking', actionsCompleted: Array<{ __typename?: 'ChallengeTeamActionsCompleted', rank: number, totalCount: number, team: { __typename?: 'Community', id: string, title: string, tileImage?: string | null } }> } }> | null } | null };

export type AcceptChapterRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateChapterRequestInput;
  hash: Scalars['String']['input'];
}>;


export type AcceptChapterRequestMutation = { __typename?: 'Mutation', acceptChapterRequest?: { __typename?: 'AcceptChapterRequestResponse', success: boolean, status: ChapterRequestStatusEnum, validationMessages?: Array<{ __typename?: 'ChapterRequestValidationMessage', type: string, code: string, message: string, payload?: any | null } | null> | null } | null };

export type RejectChapterRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  hash: Scalars['String']['input'];
}>;


export type RejectChapterRequestMutation = { __typename?: 'Mutation', rejectChapterRequest?: boolean | null };

export type UpdateChapterRequestFromReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateChapterRequestInput;
}>;


export type UpdateChapterRequestFromReviewMutation = { __typename?: 'Mutation', updateChapterRequest?: { __typename?: 'ChapterRequest', id: string, nonprofitName: string, email: string, locationObject: { __typename?: 'LocationObject', address?: string | null, city?: string | null, state?: string | null, stateCode?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, geo?: { __typename?: 'GeoJSON', type?: string | null, coordinates: Array<number> } | null }, identifiers: Array<{ __typename?: 'NonprofitIdentifierEntryStrict', id: string, type?: NonprofitIdentifierTypeEnum | null } | null>, users: Array<{ __typename?: 'ChapterRequestUserByReference' } | { __typename?: 'ChapterRequestUserDirect', email: string, roles: Array<string | null>, fullName: { __typename?: 'FullName', first?: string | null, last?: string | null } } | null>, validationMessages?: Array<{ __typename?: 'ChapterRequestValidationMessage', type: string, code: string, message: string, payload?: any | null } | null> | null } | null };

export type ChapterRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ChapterRequestQuery = { __typename?: 'Query', chapterRequest?: { __typename?: 'ChapterRequest', id: string, nonprofitName: string, parentNonprofitId: string, parentName?: string | null, zendeskTicketId?: number | null, email: string, status: ChapterRequestStatusEnum, createdAt?: any | null, modifiedAt?: any | null, requestedBy: any, processedBy?: any | null, processedAt?: any | null, requestedByName?: string | null, locationObject: { __typename?: 'LocationObject', address?: string | null, city?: string | null, state?: string | null, stateCode?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, geo?: { __typename?: 'GeoJSON', type?: string | null, coordinates: Array<number> } | null }, identifiers: Array<{ __typename?: 'NonprofitIdentifierEntryStrict', id: string, type?: NonprofitIdentifierTypeEnum | null } | null>, users: Array<{ __typename?: 'ChapterRequestUserByReference', id: any, roles: Array<string | null> } | { __typename?: 'ChapterRequestUserDirect', email: string, roles: Array<string | null>, fullName: { __typename?: 'FullName', first?: string | null, last?: string | null } } | null>, metadata?: { __typename?: 'ChapterRequestMetadata', rejectionReason?: string | null } | null, validationMessages?: Array<{ __typename?: 'ChapterRequestValidationMessage', type: string, code: string, message: string, payload?: any | null } | null> | null } | null };

export type ChaptersQueryVariables = Exact<{ [key: string]: never; }>;


export type ChaptersQuery = { __typename?: 'Query', chapters: Array<{ __typename?: 'NonprofitPartial', nonprofitId?: string | null, name?: string | null, isParent?: boolean | null, access?: NonprofitAccess | null, invisible?: boolean | null, locationObject?: { __typename?: 'LocationObject', city?: string | null, area?: string | null, state?: string | null, stateCode?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null> };

export type RequestNonprofitAccessMutationVariables = Exact<{
  nonprofitId: Scalars['String']['input'];
}>;


export type RequestNonprofitAccessMutation = { __typename?: 'Mutation', requestNonprofitAccess?: boolean | null };

export type CreateChapterRequestMutationVariables = Exact<{
  input: CreateChapterRequestInput;
}>;


export type CreateChapterRequestMutation = { __typename?: 'Mutation', createChapterRequest: { __typename?: 'ChapterRequest', nonprofitName: string, parentNonprofitId: string, email: string, locationObject: { __typename?: 'LocationObject', address?: string | null, address2?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null, geo?: { __typename?: 'GeoJSON', type?: string | null, coordinates: Array<number> } | null }, identifiers: Array<{ __typename?: 'NonprofitIdentifierEntryStrict', id: string, type?: NonprofitIdentifierTypeEnum | null } | null>, users: Array<{ __typename?: 'ChapterRequestUserByReference' } | { __typename?: 'ChapterRequestUserDirect', email: string, roles: Array<string | null>, fullName: { __typename?: 'FullName', first?: string | null, last?: string | null } } | null> } };

export type UpdateChapterRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateChapterRequestInput;
}>;


export type UpdateChapterRequestMutation = { __typename?: 'Mutation', updateChapterRequest?: { __typename?: 'ChapterRequest', id: string } | null };

export type ChapterRequestsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<InputMaybe<ChapterRequestStatusEnum>> | InputMaybe<ChapterRequestStatusEnum>>;
  parentNonprofitId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChapterRequestsQuery = { __typename?: 'Query', chapterRequests?: { __typename?: 'ChapterRequestsType', limit?: number | null, offset?: number | null, total?: number | null, results?: Array<{ __typename?: 'ChapterRequest', id: string, nonprofitName: string, parentNonprofitId: string, parentName?: string | null, email: string, status: ChapterRequestStatusEnum, createdAt?: any | null, modifiedAt?: any | null, requestedBy: any, processedBy?: any | null, processedAt?: any | null, locationObject: { __typename?: 'LocationObject', address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, stateCode?: string | null, geo?: { __typename?: 'GeoJSON', type?: string | null, coordinates: Array<number> } | null }, identifiers: Array<{ __typename?: 'NonprofitIdentifierEntryStrict', type?: NonprofitIdentifierTypeEnum | null, id: string, countryCode?: string | null } | null>, users: Array<{ __typename?: 'ChapterRequestUserByReference', id: any, roles: Array<string | null> } | { __typename?: 'ChapterRequestUserDirect', email: string, roles: Array<string | null>, fullName: { __typename?: 'FullName', first?: string | null, last?: string | null } } | null>, metadata?: { __typename?: 'ChapterRequestMetadata', rejectionReason?: string | null } | null }> | null } | null };

export type RevokeChapterRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeChapterRequestMutation = { __typename?: 'Mutation', revokeChapterRequest?: boolean | null };

export type CommunitiesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityWhereInput>;
}>;


export type CommunitiesQuery = { __typename?: 'Query', communities: Array<{ __typename?: 'Community', id: string, title: string, description?: string | null, companyId?: string | null, headerImage?: string | null, tileImage?: string | null, enabled: boolean, isPrivate?: boolean | null, createdAt?: any | null, membersCount: number, modifiedAt?: any | null, totalVolunteering: number, totalDonations: number, _count: { __typename?: 'CommunityCountOutputType', Deeds: number } }> };

export type CommunitiesMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunitiesMetricsQuery = { __typename?: 'Query', employeesCount: number, communitiesTotalDonations: number, communitiesTotalMembers: number, communitiesTotalVolunteering: number };

export type CommunitiesCountQueryVariables = Exact<{
  where?: InputMaybe<CommunityWhereInput>;
}>;


export type CommunitiesCountQuery = { __typename?: 'Query', communitiesCount: number };

export type UserFragment = { __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> };

export type CommunityFragmentFragment = { __typename?: 'Community', id: string, title: string, description?: string | null, headerImage?: string | null, tileImage?: string | null, companyId?: string | null, enabled: boolean, allowAllyMembers?: boolean | null, allowAnonymousMembers?: boolean | null, isPrivate?: boolean | null, type?: CommunityEntityType | null, leadMembers: Array<{ __typename?: 'CommunityUserMembership', User: { __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> } }>, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, locationMap?: any | null }>, Deeds: Array<{ __typename?: 'Deed', id: string }> };

export type CommunityQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type CommunityQuery = { __typename?: 'Query', community?: { __typename?: 'Community', id: string, title: string, description?: string | null, headerImage?: string | null, tileImage?: string | null, companyId?: string | null, enabled: boolean, allowAllyMembers?: boolean | null, allowAnonymousMembers?: boolean | null, isPrivate?: boolean | null, type?: CommunityEntityType | null, leadMembers: Array<{ __typename?: 'CommunityUserMembership', User: { __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> } }>, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, locationMap?: any | null }>, Deeds: Array<{ __typename?: 'Deed', id: string }> } | null };

export type CreateCommunityMutationVariables = Exact<{
  data: CommunityCreateInputType;
}>;


export type CreateCommunityMutation = { __typename?: 'Mutation', createCommunity?: { __typename?: 'Community', id: string, title: string, description?: string | null, headerImage?: string | null, tileImage?: string | null, companyId?: string | null, enabled: boolean, allowAllyMembers?: boolean | null, allowAnonymousMembers?: boolean | null, isPrivate?: boolean | null, type?: CommunityEntityType | null, leadMembers: Array<{ __typename?: 'CommunityUserMembership', User: { __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> } }>, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, locationMap?: any | null }>, Deeds: Array<{ __typename?: 'Deed', id: string }> } | null };

export type UpdateCommunityMutationVariables = Exact<{
  communityId: Scalars['ID']['input'];
  data: CommunityUpdateInputType;
}>;


export type UpdateCommunityMutation = { __typename?: 'Mutation', updateCommunity?: { __typename?: 'Community', id: string, title: string, description?: string | null, headerImage?: string | null, tileImage?: string | null, companyId?: string | null, enabled: boolean, allowAllyMembers?: boolean | null, allowAnonymousMembers?: boolean | null, isPrivate?: boolean | null, type?: CommunityEntityType | null, leadMembers: Array<{ __typename?: 'CommunityUserMembership', User: { __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> } }>, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, locationMap?: any | null }>, Deeds: Array<{ __typename?: 'Deed', id: string }> } | null };

export type AddCommunityUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  communityId: Scalars['ID']['input'];
}>;


export type AddCommunityUsersMutation = { __typename?: 'Mutation', addCommunityUsers?: boolean | null };

export type RemoveCommunityUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  communityId: Scalars['ID']['input'];
  isExcludingMembers: Scalars['Boolean']['input'];
}>;


export type RemoveCommunityUsersMutation = { __typename?: 'Mutation', removeCommunityUsers?: boolean | null };

export type DeedFieldsFragment = { __typename?: 'Deed', id: string, name?: string | null, description?: string | null, pictures: Array<string>, createdAt: any, modifiedAt: any, type: DeedType, milestones?: any | null, attendees: Array<string>, externalId?: string | null, status?: DeedStatus | null, editors: Array<string>, startingAt?: any | null, endingAt?: any | null, featured?: boolean | null, categories: Array<string>, SDGs: Array<string>, pillars: Array<string>, ERGs: Array<string>, campaigns: Array<string>, rating?: number | null, code?: string | null, timeZone?: string | null, organizerPhone?: string | null, organizerName?: string | null, linkOnly?: boolean | null, Organization?: { __typename?: 'Organization', id: string, name: string, mainPicture?: string | null, logo?: string | null } | null, Partner?: { __typename?: 'Organization', id: string, name: string } | null, OrganizingCommunities: Array<{ __typename?: 'Community', id: string, title: string }> };

export type CommunityFullQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type CommunityFullQuery = { __typename?: 'Query', community?: { __typename?: 'Community', id: string, title: string, description?: string | null, headerImage?: string | null, tileImage?: string | null, enabled: boolean, isPrivate?: boolean | null, type?: CommunityEntityType | null, Company?: { __typename?: 'Organization', id: string, name: string } | null, Deeds: Array<{ __typename?: 'Deed', id: string, name?: string | null, description?: string | null, pictures: Array<string>, createdAt: any, modifiedAt: any, type: DeedType, milestones?: any | null, attendees: Array<string>, externalId?: string | null, status?: DeedStatus | null, editors: Array<string>, startingAt?: any | null, endingAt?: any | null, featured?: boolean | null, categories: Array<string>, SDGs: Array<string>, pillars: Array<string>, ERGs: Array<string>, campaigns: Array<string>, rating?: number | null, code?: string | null, timeZone?: string | null, organizerPhone?: string | null, organizerName?: string | null, linkOnly?: boolean | null, Organization?: { __typename?: 'Organization', id: string, name: string, mainPicture?: string | null, logo?: string | null } | null, Partner?: { __typename?: 'Organization', id: string, name: string } | null, OrganizingCommunities: Array<{ __typename?: 'Community', id: string, title: string }> }>, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null }>, leads: Array<{ __typename?: 'CommunityUserMembership', role: CommunityUserRole, User: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, email: string, phone?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } }> } | null };

export type CommunityMembersQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
  take: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  excludeUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CommunityMembersQuery = { __typename?: 'Query', community?: { __typename?: 'Community', id: string, membersCount: number, members: Array<{ __typename?: 'CommunityUserMembership', role: CommunityUserRole, User: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, email: string, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> } }> } | null };

export type PendingPayrollRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingPayrollRunsQuery = { __typename?: 'Query', pendingPayrollRuns: { __typename?: 'PendingPayrollRunsPayload', items: Array<{ __typename?: 'PayrollRunCompact', id: string, payrollPayGroupId: string, total: number, currencyCode: Currency, startDateExternal: any, endDateExternal: any }>, metadata: { __typename?: 'PaginationMetadata', totalItems: number, totalPages: number } } };

export type CreateInvoiceForPayrollMutationVariables = Exact<{
  payrollRunIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  poNumber?: InputMaybe<Scalars['String']['input']>;
  paymentDueDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateInvoiceForPayrollMutation = { __typename?: 'Mutation', createInvoiceForPayroll?: { __typename?: 'Invoice', id: string, amount: number, currencyCode: Currency, status: InvoiceStatus, invoiceNumber: string } | null };

export type PendingCorporateGivingDisbursementsQueryVariables = Exact<{
  dateTo: Scalars['DateTime']['input'];
  donationDisbursementType: DonationDisbursementCorporateGivingType;
}>;


export type PendingCorporateGivingDisbursementsQuery = { __typename?: 'Query', pendingCorporateGivingDisbursements: { __typename?: 'PendingCorporateGivingDisbursements', items: Array<{ __typename?: 'TotalByGivingAccountAndMonth', givingAccountId: string, year: string, month: string, total: number, currencyCode: Currency }>, metadata: { __typename?: 'PaginationMetadata', totalItems: number } } };

export type CreateInvoiceForCorporateGivingMutationVariables = Exact<{
  dateTo: Scalars['DateTime']['input'];
  donationDisbursementType: DonationDisbursementCorporateGivingType;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  paymentDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  givingAccountId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateInvoiceForCorporateGivingMutation = { __typename?: 'Mutation', createInvoiceForCorporateGiving?: { __typename?: 'Invoice', id: string, amount: number, currencyCode: Currency, status: InvoiceStatus, invoiceNumber: string, poNumber?: string | null, paymentDueDate?: any | null, invoiceLines: Array<{ __typename?: 'InvoiceLine', itemType: DonationDisbursementType, itemLabel?: string | null, amount: number }> } | null };

export type AvailableDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableDashboardsQuery = { __typename?: 'Query', dashboards?: Array<{ __typename?: 'SigmaDashboard', type: ExternalDashboardType, title?: string | null, description?: string | null, iconUrl?: string | null, sortOrder?: number | null }> | null };

export type CommunitiesBriefQueryVariables = Exact<{
  includeDisabled: Scalars['Boolean']['input'];
}>;


export type CommunitiesBriefQuery = { __typename?: 'Query', communities: Array<{ __typename?: 'Community', id: string, title: string, enabled: boolean }> };

export type SendSegmentEventMutationVariables = Exact<{
  event: Scalars['String']['input'];
}>;


export type SendSegmentEventMutation = { __typename?: 'Mutation', sendSegmentEvent?: boolean | null };

export type MinActionFragmentFragment = { __typename?: 'Action', id: string, title?: string | null, startingAt?: any | null, endingAt?: any | null, status: ActionVisibilityStatus, campaignIds: Array<string> };

export type ActivityUserFragment = { __typename?: 'Activity', id: string, status: ActivityStatus };

export type ActionFragmentFragment = { __typename?: 'Action', subTitle?: string | null, description?: string | null, bannerImage?: string | null, nonprofitId?: string | null, enabled: boolean, actionTemplateId?: string | null, id: string, title?: string | null, startingAt?: any | null, endingAt?: any | null, status: ActionVisibilityStatus, campaignIds: Array<string>, ActionTemplate?: { __typename?: 'ActionTemplate', organizationId?: string | null, public?: boolean | null } | null, Campaigns: Array<{ __typename?: 'Campaign', id: string, title: string }>, Causes: Array<{ __typename?: 'Cause', name: string, code?: string | null, type: CauseType, id: string }>, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, incentives: Array<{ __typename?: 'Incentive', type: IncentiveType, unit: string, amount: number }>, Activities: Array<{ __typename?: 'Activity', id: string, status: ActivityStatus }> };

export type ActionsWithPaginationQueryVariables = Exact<{
  where?: InputMaybe<ActionWhereInput>;
  orderBy?: InputMaybe<ActionOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActionsWithPaginationQuery = { __typename?: 'Query', actionsWithPagination?: { __typename?: 'ActionsWithPaginationType', items?: Array<{ __typename?: 'Action', subTitle?: string | null, description?: string | null, bannerImage?: string | null, nonprofitId?: string | null, enabled: boolean, actionTemplateId?: string | null, id: string, title?: string | null, startingAt?: any | null, endingAt?: any | null, status: ActionVisibilityStatus, campaignIds: Array<string>, ActionTemplate?: { __typename?: 'ActionTemplate', organizationId?: string | null, public?: boolean | null } | null, Campaigns: Array<{ __typename?: 'Campaign', id: string, title: string }>, Causes: Array<{ __typename?: 'Cause', name: string, code?: string | null, type: CauseType, id: string }>, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, incentives: Array<{ __typename?: 'Incentive', type: IncentiveType, unit: string, amount: number }>, Activities: Array<{ __typename?: 'Activity', id: string, status: ActivityStatus }> }> | null, metadata: { __typename?: 'ActionsMetaType', totalItems?: number | null, totalPages?: number | null, skip?: number | null, take?: number | null } } | null };

export type MinActionsQueryVariables = Exact<{
  where?: InputMaybe<ActionWhereInput>;
  orderBy?: InputMaybe<ActionOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MinActionsQuery = { __typename?: 'Query', actionsWithPagination?: { __typename?: 'ActionsWithPaginationType', items?: Array<{ __typename?: 'Action', id: string, title?: string | null, startingAt?: any | null, endingAt?: any | null, status: ActionVisibilityStatus, campaignIds: Array<string> }> | null } | null };

export type SetCampaignActionsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  actionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetCampaignActionsMutation = { __typename?: 'Mutation', setCampaignActions?: boolean | null };

export type UpsertActionMutationVariables = Exact<{
  actionData: ActionUpsertInputType;
}>;


export type UpsertActionMutation = { __typename?: 'Mutation', mutationUpsertAction?: { __typename?: 'Action', subTitle?: string | null, description?: string | null, bannerImage?: string | null, nonprofitId?: string | null, enabled: boolean, actionTemplateId?: string | null, id: string, title?: string | null, startingAt?: any | null, endingAt?: any | null, status: ActionVisibilityStatus, campaignIds: Array<string>, ActionTemplate?: { __typename?: 'ActionTemplate', organizationId?: string | null, public?: boolean | null } | null, Campaigns: Array<{ __typename?: 'Campaign', id: string, title: string }>, Causes: Array<{ __typename?: 'Cause', name: string, code?: string | null, type: CauseType, id: string }>, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, incentives: Array<{ __typename?: 'Incentive', type: IncentiveType, unit: string, amount: number }>, Activities: Array<{ __typename?: 'Activity', id: string, status: ActivityStatus }> } | null };

export type UserObjectFragment = { __typename?: 'UserObject', id?: string | null, name?: string | null, mainPicture?: string | null, instagram?: string | null, location?: string | null, summary?: string | null, pictures?: Array<string | null> | null, createdAt?: any | null, clickable?: boolean | null, deeds?: number | null, _volunteerMinutes?: number | null, locale?: string | null, email?: string | null, preferredName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null };

export type DeedFragment = { __typename?: 'ReducedDeed', id: string, providerId?: string | null, provider?: OpportunityProvider | null, categories?: Array<string> | null, sdgs?: Array<string> | null, type?: string | null, startingAt?: any | null, endingAt?: any | null, registrationEndingAt?: any | null, participantsLimit?: number | null, virtual?: boolean | null, timeZone?: string | null, name?: string | null, description?: string | null, mustKnows?: string | null, pictures?: Array<string | null> | null, externalLink?: string | null, status?: string | null, attendeeLimit?: number | null, ended?: boolean | null, started?: boolean | null, public?: boolean | null, linkOnly?: boolean | null, requireAuthentication?: boolean | null, externalLinkFollowsCount?: number | null, allowedLocations?: Array<string | null> | null, isSharedWithSubsidiary?: boolean | null, nonprofits?: Array<{ __typename?: 'Nonprofit', name: string } | null> | null, location?: { __typename?: 'LocationObject', country?: string | null } | null, contact?: { __typename?: 'OpportunityContact', email?: string | null } | null, submitter?: { __typename?: 'Submitter', id?: string | null, type?: UserType | null, name?: string | null, mainPicture?: string | null, organization?: { __typename?: 'ReducedOrganization', type: OrganizationType } | null } | null, waitlist?: Array<{ __typename?: 'UserObject', id?: string | null, name?: string | null, mainPicture?: string | null, instagram?: string | null, location?: string | null, summary?: string | null, pictures?: Array<string | null> | null, createdAt?: any | null, clickable?: boolean | null, deeds?: number | null, _volunteerMinutes?: number | null, locale?: string | null, email?: string | null, preferredName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null> | null, attendees?: Array<{ __typename?: 'UserObject', id?: string | null, name?: string | null, mainPicture?: string | null, instagram?: string | null, location?: string | null, summary?: string | null, pictures?: Array<string | null> | null, createdAt?: any | null, clickable?: boolean | null, deeds?: number | null, _volunteerMinutes?: number | null, locale?: string | null, email?: string | null, preferredName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null } | null, roles?: Array<{ __typename?: 'DeedRoleReduced', name?: string | null, requiredAmount?: number | null, applicants?: Array<{ __typename?: 'UserObject', id?: string | null } | null> | null } | null> | null, partner?: { __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null } | null };

export type SearchDeedsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  deedType?: InputMaybe<DeedTypeFilters>;
  filterOption?: InputMaybe<FilterOptions>;
  submitter?: InputMaybe<Array<DeedSubmitter> | DeedSubmitter>;
  provider?: InputMaybe<Array<OpportunityProvider> | OpportunityProvider>;
  subsidiary?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchDeedsQuery = { __typename?: 'Query', searchDeeds?: { __typename?: 'DeedsResult', total: number, deeds: Array<{ __typename?: 'ReducedDeed', id: string, providerId?: string | null, provider?: OpportunityProvider | null, categories?: Array<string> | null, sdgs?: Array<string> | null, type?: string | null, startingAt?: any | null, endingAt?: any | null, registrationEndingAt?: any | null, participantsLimit?: number | null, virtual?: boolean | null, timeZone?: string | null, name?: string | null, description?: string | null, mustKnows?: string | null, pictures?: Array<string | null> | null, externalLink?: string | null, status?: string | null, attendeeLimit?: number | null, ended?: boolean | null, started?: boolean | null, public?: boolean | null, linkOnly?: boolean | null, requireAuthentication?: boolean | null, externalLinkFollowsCount?: number | null, allowedLocations?: Array<string | null> | null, isSharedWithSubsidiary?: boolean | null, nonprofits?: Array<{ __typename?: 'Nonprofit', name: string } | null> | null, location?: { __typename?: 'LocationObject', country?: string | null } | null, contact?: { __typename?: 'OpportunityContact', email?: string | null } | null, submitter?: { __typename?: 'Submitter', id?: string | null, type?: UserType | null, name?: string | null, mainPicture?: string | null, organization?: { __typename?: 'ReducedOrganization', type: OrganizationType } | null } | null, waitlist?: Array<{ __typename?: 'UserObject', id?: string | null, name?: string | null, mainPicture?: string | null, instagram?: string | null, location?: string | null, summary?: string | null, pictures?: Array<string | null> | null, createdAt?: any | null, clickable?: boolean | null, deeds?: number | null, _volunteerMinutes?: number | null, locale?: string | null, email?: string | null, preferredName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null> | null, attendees?: Array<{ __typename?: 'UserObject', id?: string | null, name?: string | null, mainPicture?: string | null, instagram?: string | null, location?: string | null, summary?: string | null, pictures?: Array<string | null> | null, createdAt?: any | null, clickable?: boolean | null, deeds?: number | null, _volunteerMinutes?: number | null, locale?: string | null, email?: string | null, preferredName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null } | null, roles?: Array<{ __typename?: 'DeedRoleReduced', name?: string | null, requiredAmount?: number | null, applicants?: Array<{ __typename?: 'UserObject', id?: string | null } | null> | null } | null> | null, partner?: { __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null } | null }> } | null };

export type DeedsStatsQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  deedType?: InputMaybe<DeedTypeFilters>;
  submitter?: InputMaybe<Array<DeedSubmitter> | DeedSubmitter>;
  provider?: InputMaybe<Array<OpportunityProvider> | OpportunityProvider>;
  subsidiary?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeedsStatsQuery = { __typename?: 'Query', deedsStats?: { __typename?: 'DeedsStats', pendingReviewDeedsTotal?: number | null, draftDeedsTotal?: number | null, sharedDeedsTotal?: number | null } | null };

export type ReceiptFragmentFragment = { __typename?: 'Receipt', id: string, type: ReceiptType, organization?: string | null, active: boolean, data: any, metadata?: any | null, createdAt?: any | null, modifiedAt?: any | null };

export type ReceiptQueryVariables = Exact<{
  where?: InputMaybe<ReceiptWhereInput>;
  orderBy?: InputMaybe<ReceiptOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReceiptQuery = { __typename?: 'Query', receipts?: Array<{ __typename?: 'Receipt', id: string, type: ReceiptType, organization?: string | null, active: boolean, data: any, metadata?: any | null, createdAt?: any | null, modifiedAt?: any | null }> | null };

export type CreateDonationCreditSeedReceiptMutationVariables = Exact<{
  importedUrl: Scalars['String']['input'];
  donationCreditRuleId: Scalars['String']['input'];
  createUsers: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  notifyUser: Scalars['Boolean']['input'];
}>;


export type CreateDonationCreditSeedReceiptMutation = { __typename?: 'Mutation', mutationCreateDonationCreditSeedReceipt: { __typename?: 'Receipt', id: string, type: ReceiptType, organization?: string | null, active: boolean, data: any, metadata?: any | null, createdAt?: any | null, modifiedAt?: any | null } };

export type GetExternalMatchRequestRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalMatchRequestRulesQuery = { __typename?: 'Query', externalMatchRequestRules?: Array<{ __typename?: 'ExternalMatchRequestRule', id: string, type: ExternalMatchRequestRuleType, active: boolean, minAmount: number, maxAmount: number, startingAt?: string | null, endingAt?: string | null, employeeLocations?: Array<string> | null, confidenceScore?: { __typename?: 'ConfidenceScore', operator: ConfidenceScoreOperator, value: number } | null }> | null };

export type SetExternalMatchRequestRulesMutationVariables = Exact<{
  rules: Array<ExternalMatchRequestRuleInput> | ExternalMatchRequestRuleInput;
}>;


export type SetExternalMatchRequestRulesMutation = { __typename?: 'Mutation', setExternalMatchRequestRules?: Array<{ __typename?: 'ExternalMatchRequestRule', id: string, type: ExternalMatchRequestRuleType, active: boolean, minAmount: number, maxAmount: number, startingAt?: string | null, endingAt?: string | null, employeeLocations?: Array<string> | null, confidenceScore?: { __typename?: 'ConfidenceScore', operator: ConfidenceScoreOperator, value: number } | null }> | null };

export type AddGivingAccountFundingTransactionMutationVariables = Exact<{
  data: GivingAccountFundingCreateInputType;
}>;


export type AddGivingAccountFundingTransactionMutation = { __typename?: 'Mutation', createGivingAccountFunding?: { __typename?: 'GivingAccountFunding', type?: TransactionType | null, id: string, provider: ProviderType, amount: number, processedAt?: any | null, createdAt: any, modifiedAt?: any | null, author: string, note?: string | null, receiptUrl?: string | null, identifier?: string | null, GivingAccount: { __typename?: 'GivingAccount', id: string } } | null };

export type GivingAccountSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GivingAccountSummaryQuery = { __typename?: 'Query', givingAccount?: { __typename?: 'GivingAccount', id: string, name?: string | null, currencyCode: string, provider: ProviderType, balance: number, balanceUserCurrency: number } | null, givingAccounts: Array<{ __typename?: 'GivingAccount', id: string }> };

export type GivingAccountTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  createdAtSince?: InputMaybe<Scalars['String']['input']>;
  createdAtTill?: InputMaybe<Scalars['String']['input']>;
}>;


export type GivingAccountTransactionsQuery = { __typename?: 'Query', givingAccount?: { __typename?: 'GivingAccount', id: string, name?: string | null, companyId: string, transactions: Array<{ __typename: 'GivingAccountFunding', id: string, identifier?: string | null, description: string, amount: number, createdAt: any, processedAt?: any | null, provider: ProviderType, balance?: number | null, note?: string | null } | { __typename: 'GivingAccountTransferInbound', id: string, amount: number, createdAt: any, balance?: number | null, note?: string | null, GivingAccountTransferOutbound: { __typename?: 'GivingAccountTransferOutbound', amount: number, GivingAccount: { __typename?: 'GivingAccount', id: string, currencyCode: string, provider: ProviderType } } } | { __typename: 'GivingAccountTransferOutbound', id: string, amount: number, createdAt: any, balance?: number | null, note?: string | null, GivingAccountTransferInbound?: { __typename?: 'GivingAccountTransferInbound', amount: number, GivingAccount: { __typename?: 'GivingAccount', id: string, currencyCode: string, provider: ProviderType } } | null } | { __typename: 'GivingAccountWithdrawal', id: string, amount: number, createdAt: any, processedAt?: any | null, balance?: number | null, identifier?: string | null, description: string, provider: ProviderType, currencyCode: string, total: number, totalAccountCurrency?: number | null, feeAmount: number, feeAmountAccountCurrency?: number | null, status: GivingAccountWithdrawalStatus, batchFilename: string, note?: string | null }> } | null };

export type UpdateGivingAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateGivingAccountMutation = { __typename?: 'Mutation', updateGivingAccount?: { __typename?: 'GivingAccount', id: string, name?: string | null, currencyCode: string, provider: ProviderType, balance: number, balanceUserCurrency: number } | null };

export type MarkGivingAccountWithdrawalAsPendingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkGivingAccountWithdrawalAsPendingMutation = { __typename?: 'Mutation', markGivingAccountWithdrawalAsPending?: { __typename: 'GivingAccountWithdrawal', id: string, amount: number, createdAt: any, processedAt?: any | null, balance?: number | null, identifier?: string | null, provider: ProviderType, currencyCode: string, total: number, totalAccountCurrency?: number | null, feeAmount: number, feeAmountAccountCurrency?: number | null } | null };

export type MarkGivingAccountWithdrawalAsProcessedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: GivingAccountWithdrawalMarkAsProcessedInputType;
}>;


export type MarkGivingAccountWithdrawalAsProcessedMutation = { __typename?: 'Mutation', markGivingAccountWithdrawalAsProcessed?: { __typename: 'GivingAccountWithdrawal', id: string, amount: number, createdAt: any, processedAt?: any | null, balance?: number | null, identifier?: string | null, provider: ProviderType, currencyCode: string, total: number, totalAccountCurrency?: number | null, feeAmount: number, feeAmountAccountCurrency?: number | null } | null };

export type MarkGivingAccountWithdrawalAsReadyForProcessingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: GivingAccountWithdrawalMarkAsReadyForProcessingInputType;
}>;


export type MarkGivingAccountWithdrawalAsReadyForProcessingMutation = { __typename?: 'Mutation', markGivingAccountWithdrawalAsReadyForProcessing?: { __typename: 'GivingAccountWithdrawal', id: string, amount: number, createdAt: any, processedAt?: any | null, balance?: number | null, identifier?: string | null, provider: ProviderType, currencyCode: string, total: number, totalAccountCurrency?: number | null, feeAmount: number, feeAmountAccountCurrency?: number | null } | null };

export type MarkGivingAccountWithdrawalAsProcessingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data?: InputMaybe<GivingAccountWithdrawalMarkAsProcessingInputType>;
}>;


export type MarkGivingAccountWithdrawalAsProcessingMutation = { __typename?: 'Mutation', markGivingAccountWithdrawalAsProcessing?: { __typename: 'GivingAccountWithdrawal', id: string, amount: number, createdAt: any, processedAt?: any | null, balance?: number | null, identifier?: string | null, provider: ProviderType, currencyCode: string, total: number, totalAccountCurrency?: number | null, feeAmount: number, feeAmountAccountCurrency?: number | null } | null };

export type GivingAccountFragmentFragment = { __typename?: 'GivingAccount', id: string, name?: string | null, currencyCode: string, provider: ProviderType, balance: number, balanceUserCurrency: number };

export type GivingAccountsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GivingAccountsSummaryQuery = { __typename?: 'Query', givingAccounts: Array<{ __typename?: 'GivingAccount', id: string, name?: string | null, currencyCode: string, provider: ProviderType, balance: number, balanceUserCurrency: number }> };

export type CreateGivingAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  currencyCode: Currency;
  provider: ProviderType;
}>;


export type CreateGivingAccountMutation = { __typename?: 'Mutation', createGivingAccount?: { __typename?: 'GivingAccount', id: string, name?: string | null, currencyCode: string, provider: ProviderType, balance: number, balanceUserCurrency: number } | null };

export type InvoicesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  type?: InputMaybe<DonationDisbursementType>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoicesPayload', items: Array<{ __typename?: 'Invoice', id: string, types: Array<DonationDisbursementType>, status: InvoiceStatus, createdAt: any, amount: number, currencyCode: Currency, paymentDueDate?: any | null, invoiceNumber: string, disbursementsDocumentURL: string, invoiceDocumentURL: string, invoiceLines: Array<{ __typename?: 'InvoiceLine', amount: number, itemLabel?: string | null }> }>, metadata: { __typename?: 'PaginationMetadata', totalItems: number, totalPages: number } } };

export type MarkInvoiceAsPaidMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  paymentDocumentURL: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt: Scalars['String']['input'];
}>;


export type MarkInvoiceAsPaidMutation = { __typename?: 'Mutation', markInvoiceAsPaid?: { __typename?: 'Invoice', id: string, status: InvoiceStatus, paidAt?: any | null } | null };

export type MarkInvoiceAsVoidedMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type MarkInvoiceAsVoidedMutation = { __typename?: 'Mutation', markInvoiceAsVoided?: { __typename?: 'Invoice', id: string, status: InvoiceStatus, voidedAt?: any | null } | null };

export type MarkInvoiceAsSentMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type MarkInvoiceAsSentMutation = { __typename?: 'Mutation', markInvoiceAsSent?: { __typename?: 'Invoice', id: string, status: InvoiceStatus, sentAt?: any | null } | null };

export type HandleNonprofitNameChangeMutationVariables = Exact<{
  newName: Scalars['String']['input'];
  ticketId: Scalars['Int']['input'];
  nonprofitId: Scalars['ID']['input'];
}>;


export type HandleNonprofitNameChangeMutation = { __typename?: 'Mutation', handleNonprofitNameChange?: boolean | null };

export type NominationsCountQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NominationsCountQuery = { __typename?: 'Query', nominationsCount?: number | null };

export type NonprofitNominationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortedBy?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NonprofitNominationsQuery = { __typename?: 'Query', nonprofitNominations: Array<{ __typename?: 'NonprofitNomination', id: string, userId: string, companyId: string, nonprofitName: string, ein?: string | null, ncesIdentifier?: string | null, nonprofitEntityType?: NonprofitEntityType | null, country: string, email?: string | null, website?: string | null, phone?: string | null, engagementType: EngagementType, otherNote?: string | null, internalNote?: string | null, status: NonprofitNominationStatusType, createdAt?: any | null, User?: { __typename?: 'BaseUser', fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null, Company: { __typename?: 'Organization', name: string }, emails?: { __typename?: 'NonprofitNominationEmails', nonprofitNominationOutreachInitial?: any | null, nonprofitNominationOutreachReminder?: any | null, nonprofitNominationOutreachFinal?: any | null } | null }> };

export type OutreachNonprofitNominationMutationVariables = Exact<{
  nominationId: Scalars['ID']['input'];
  emailId: OutreachEmailId;
  templateLocaleCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type OutreachNonprofitNominationMutation = { __typename?: 'Mutation', outreachNonprofitNomination?: { __typename?: 'NonprofitNomination', id: string, internalNote?: string | null, status: NonprofitNominationStatusType, emails?: { __typename?: 'NonprofitNominationEmails', nonprofitNominationOutreachInitial?: any | null, nonprofitNominationOutreachReminder?: any | null, nonprofitNominationOutreachFinal?: any | null } | null } | null };

export type UpdateNonprofitNominationMutationVariables = Exact<{
  updateNonprofitNominationId: Scalars['ID']['input'];
  data: NonprofitNominationUpdateInputType;
}>;


export type UpdateNonprofitNominationMutation = { __typename?: 'Mutation', updateNonprofitNomination?: { __typename?: 'NonprofitNomination', id: string, internalNote?: string | null, status: NonprofitNominationStatusType, emails?: { __typename?: 'NonprofitNominationEmails', nonprofitNominationOutreachInitial?: any | null, nonprofitNominationOutreachReminder?: any | null, nonprofitNominationOutreachFinal?: any | null } | null } | null };

export type NotificationSettingsFragment = { __typename?: 'NotificationSettings', email?: { __typename?: 'NotificationChannel', mutedMessages: Array<string>, mutedCategories: Array<string> } | null };

export type NotificationSettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationSettingsPageQuery = { __typename?: 'Query', organizationNotificationSettings?: { __typename?: 'NotificationSettings', email?: { __typename?: 'NotificationChannel', mutedMessages: Array<string>, mutedCategories: Array<string> } | null } | null, notificationMetadata?: { __typename?: 'NotificationMetadata', messages: Array<{ __typename?: 'NotificationMessage', id: string, label: string, unignorable?: boolean | null, category: string, channel?: NotificationChannelType | null } | null>, categories: Array<{ __typename?: 'NotificationMessageCategory', id: string, label: string } | null> } | null };

export type EmailTemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmailTemplateQuery = { __typename?: 'Query', emailTemplate?: { __typename?: 'EmailTemplate', id: string, subject: string, preHeader: string, bodyHtml: string } | null };

export type SetOrganizationNotificationMessageSettingMutationVariables = Exact<{
  channel: NotificationChannelType;
  messageId: IgnorableNotificationMessageIds;
  muted: Scalars['Boolean']['input'];
}>;


export type SetOrganizationNotificationMessageSettingMutation = { __typename?: 'Mutation', setOrganizationNotificationMessageSetting?: { __typename?: 'NotificationSettings', email?: { __typename?: 'NotificationChannel', mutedMessages: Array<string>, mutedCategories: Array<string> } | null } | null };

export type SetOrganizationNotificationCategorySettingMutationVariables = Exact<{
  channel: NotificationChannelType;
  categoryId: IgnorableNotificationMessageCategory;
  muted: Scalars['Boolean']['input'];
}>;


export type SetOrganizationNotificationCategorySettingMutation = { __typename?: 'Mutation', setOrganizationNotificationCategorySetting?: { __typename?: 'NotificationSettings', email?: { __typename?: 'NotificationChannel', mutedMessages: Array<string>, mutedCategories: Array<string> } | null } | null };

export type NonprofitInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type NonprofitInfoQuery = { __typename?: 'Query', nonprofitInfo?: { __typename?: 'NonprofitInfo', hasVerifiedUsers?: boolean | null, hasAdmins?: boolean | null, verifiedUsers?: Array<{ __typename?: 'VerifiedUser', email: string }> | null } | null };

export type SearchOpportunitiesQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<OpportunityType> | OpportunityType>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<Area> | Area>;
  categories?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  providers?: InputMaybe<Array<OpportunityProvider> | OpportunityProvider>;
}>;


export type SearchOpportunitiesQuery = { __typename?: 'Query', searchOpportunities?: { __typename?: 'SearchOpportunitiesResult', total: number, opportunities: Array<{ __typename?: 'ReducedOpportunity', providerId: string, provider: OpportunityProvider, categories?: Array<string> | null, name: string, description?: string | null, mustKnows?: string | null, duration?: number | null, pictures?: Array<string | null> | null, virtual?: boolean | null, type?: OpportunityType | null, startingAt?: any | null, endingAt?: any | null, timeZone?: string | null, externalLink?: string | null, contact?: { __typename?: 'OpportunityContact', name?: string | null, email?: string | null } | null, nonprofit?: { __typename?: 'OpportunityNonprofit', name: string, pictures: Array<string> } | null, location?: { __typename?: 'LocationObject', address?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null } | null }> } | null };

export type ImportOpportunityMutationVariables = Exact<{
  providerId: Scalars['String']['input'];
  provider: OpportunityProvider;
  gooderaBookOpportunityPayload?: InputMaybe<GooderaBookOpportunityPayload>;
}>;


export type ImportOpportunityMutation = { __typename?: 'Mutation', importOpportunity?: { __typename?: 'Deed', id: string } | null };

export type AffiliationsCountQueryVariables = Exact<{
  nonprofitId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AffiliationsCountQuery = { __typename?: 'Query', affiliationsCount?: number | null };

export type AffiliationsByNonprofitQueryVariables = Exact<{
  nonprofitId: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AffiliationsByNonprofitQuery = { __typename?: 'Query', affiliationsByNonprofit: Array<{ __typename?: 'Affiliation', id: string, affiliationType?: AffiliationType | null, userId: string, User: { __typename?: 'BaseUser', fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } }> };

export type RequestNonprofitAddressChangeMutationVariables = Exact<{
  newAddress: LocationInput;
  reason: Scalars['String']['input'];
}>;


export type RequestNonprofitAddressChangeMutation = { __typename?: 'Mutation', requestNonprofitAddressChange?: boolean | null };

export type RequestNonprofitNameChangeMutationVariables = Exact<{
  newName: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RequestNonprofitNameChangeMutation = { __typename?: 'Mutation', requestNonprofitNameChange?: boolean | null };

export type VerifyOrganizerUserByDeedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyOrganizerUserByDeedMutation = { __typename?: 'Mutation', verifyOrganizerUserByDeed?: boolean | null };

export type PayrollRunsListQueryVariables = Exact<{ [key: string]: never; }>;


export type PayrollRunsListQuery = { __typename?: 'Query', payrollRuns: Array<{ __typename?: 'PayrollRun', id: string, runState: PayrollRunStateType, startDate: any, payDate?: any | null, endDate: any, checkDate?: any | null, stats: { __typename?: 'PayrollRunStats', donationCount?: number | null, deductionIntent?: number | null, deductionActual?: number | null } }> };

export type RecreateDonationForTheNextPayrollRunMutationVariables = Exact<{
  recreateDonationForTheNextPayrollRunId: Scalars['ID']['input'];
}>;


export type RecreateDonationForTheNextPayrollRunMutation = { __typename?: 'Mutation', recreateDonationForTheNextPayrollRun?: boolean | null };

export type PayrollRunsFlatFileListQueryVariables = Exact<{
  payrollPayGroupId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayrollRunsFlatFileListQuery = { __typename?: 'Query', payrollRunsFlatFile: Array<{ __typename?: 'PayrollRunFlatFile', id: string, companyId: string, payrollPayGroupId: string, runState: PayrollRunFlatFileStateType, startDate: any, payDate?: any | null, endDate: any, modifiedAt: any, startDateExternal?: any | null, endDateExternal?: any | null, stats: { __typename?: 'PayrollRunFlatFileStats', donationCount: number, donationCountPendingOrUnresolved: number, totalUsd: number, donationCountSuccess: number, totalUsdSuccess: number, isDonatable: boolean } }> };

export type PayrollRunsFlatFileListWithPaginationQueryVariables = Exact<{
  payrollPayGroupId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type PayrollRunsFlatFileListWithPaginationQuery = { __typename?: 'Query', payrollRunsFlatFileWithPagination?: { __typename?: 'PayrollRunsType', metadata: { __typename?: 'PayrollRunsMetaType', totalItems?: number | null, totalPages?: number | null, take?: number | null, skip?: number | null }, items: Array<{ __typename?: 'PayrollRunFlatFile', id: string, companyId: string, payrollPayGroupId: string, runState: PayrollRunFlatFileStateType, startDate: any, payDate?: any | null, endDate: any, modifiedAt: any, startDateExternal?: any | null, endDateExternal?: any | null, stats: { __typename?: 'PayrollRunFlatFileStats', donationCount: number, donationCountPendingOrUnresolved: number, totalUsd: number, donationCountSuccess: number, totalUsdSuccess: number, isDonatable: boolean } }> } | null };

export type PayrollPayGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PayrollPayGroupsQuery = { __typename?: 'Query', payrollPayGroups: Array<{ __typename?: 'PayrollPayGroup', id: string, payGroupDisplayName: string }> };

export type PayrollRunFlatFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  payrollPayGroupId: Scalars['ID']['input'];
}>;


export type PayrollRunFlatFileQuery = { __typename?: 'Query', payrollPayGroup?: { __typename?: 'PayrollPayGroup', id: string, payGroupDisplayName: string } | null, payrollRunFlatFile?: { __typename?: 'PayrollRunFlatFile', id: string, companyId: string, payrollPayGroupId: string, runState: PayrollRunFlatFileStateType, startDate: any, payDate?: any | null, endDate: any, modifiedAt: any, startDateExternal?: any | null, endDateExternal?: any | null, stats: { __typename?: 'PayrollRunFlatFileStats', donationCount: number, donationCountPendingOrUnresolved: number, totalUsd: number, donationCountSuccess: number, totalUsdSuccess: number, isDonatable: boolean } } | null };

export type PayrollRunFlatFileDonationsQueryVariables = Exact<{
  payrollRunFlatFileId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  paymentStatuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  employeeTerm?: InputMaybe<Scalars['String']['input']>;
  nonprofitTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type PayrollRunFlatFileDonationsQuery = { __typename?: 'Query', payrollRunFlatFile?: { __typename?: 'PayrollRunFlatFile', id: string, donations: { __typename?: 'PaginatedDonations', count: number, items: Array<{ __typename?: 'Donation', id: string, donationSchedule?: string | null, rescheduledFrom?: string | null, total: number, currency: Currency, status: DonationStatus, rescheduledTo?: string | null, amountCurrencies?: any | null, userId?: string | null, nonprofits: Array<string>, executionFailure?: { __typename?: 'DonationExecutionFailure', errorCode: DonationExecutionFailureErrorCode, date: any } | null, User?: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, preferredName?: { __typename?: 'PreferredName', first: string, last?: string | null } | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null } | null, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, mainPicture?: string | null }>, DonationSchedule?: { __typename?: 'DonationSchedule', frequency: DonationFrequency } | null }> } } | null };

export type RecreateDonationForTheNextPayrollRunFlatFileMutationVariables = Exact<{
  donationId: Scalars['ID']['input'];
  shouldCancel: Scalars['Boolean']['input'];
  markAsResolved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RecreateDonationForTheNextPayrollRunFlatFileMutation = { __typename?: 'Mutation', recreateDonationForTheNextPayrollRunFlatFile?: boolean | null };

export type NonprofitQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NonprofitQuery = { __typename?: 'Query', nonprofit?: { __typename?: 'ExtendedDeedNonprofit', id?: string | null, nonprofitId?: string | null, name?: string | null, ein?: string | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null };

export type AvailableReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableReportsQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'SigmaReport', type: ExternalReportType }> | null };

export type SetPayrollFlatFileSftpConfigMutationVariables = Exact<{
  data: SftpConfigSetInput;
}>;


export type SetPayrollFlatFileSftpConfigMutation = { __typename?: 'Mutation', setPayrollFlatFileSftpConfig?: { __typename?: 'SftpConfigWithoutSecret', host: string, username: string, port?: number | null, isSecretSet: boolean } | null };

export type DeletePayrollFlatFileSftpConfigMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePayrollFlatFileSftpConfigMutation = { __typename?: 'Mutation', deletePayrollFlatFileSftpConfig?: boolean | null };

export type PayrollFlatFileSftpConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PayrollFlatFileSftpConfigQuery = { __typename?: 'Query', payrollFlatFileSftpConfig?: { __typename?: 'SftpConfigWithoutSecret', host: string, username: string, port?: number | null, isSecretSet: boolean } | null };

export type SigmaDashboardByTypeQueryVariables = Exact<{
  type: ExternalDashboardType;
}>;


export type SigmaDashboardByTypeQuery = { __typename?: 'Query', getSigmaDashboard?: { __typename?: 'SigmaDashboard', id: string, dashboardId: string, sigmaUrl: string, type: ExternalDashboardType } | null };

export type SigmaReportByTypeQueryVariables = Exact<{
  type: ExternalReportType;
}>;


export type SigmaReportByTypeQuery = { __typename?: 'Query', getSigmaReport?: { __typename?: 'SigmaReport', id: string, reportId: string, sigmaUrl: string, type: ExternalReportType } | null };

export type SigmaDashboardByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type SigmaDashboardByUrlQuery = { __typename?: 'Query', getSigmaDashboardForURL?: string | null };

export type HandleVerificationRequestMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  ticketId: Scalars['Int']['input'];
  nonprofitId: Scalars['ID']['input'];
}>;


export type HandleVerificationRequestMutation = { __typename?: 'Mutation', handleVerificationRequest?: boolean | null };

export type VolunteerTimeOffsListQueryVariables = Exact<{
  volunteerTimeOffsUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type VolunteerTimeOffsListQuery = { __typename?: 'Query', volunteerTimeOffs: Array<{ __typename?: 'VolunteerTimeOff', id: string, userId: string, status?: TimeOffStatus | null, startingAt?: any | null, requestedAt?: any | null, duration?: number | null, Deed?: { __typename?: 'Deed', id: string, type: DeedType, name?: string | null } | null }> };

export type VolunteerTimeOffSummaryQueryVariables = Exact<{
  volunteerTimeOffSummaryUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type VolunteerTimeOffSummaryQuery = { __typename?: 'Query', volunteerTimeOffSummary?: { __typename?: 'VolunteerTimeOffSummary', balance: number, used: number, total: number } | null };

export type VolunteerRewardFragment = { __typename?: 'VolunteerReward', id: string, approvalStatus: VolunteerRewardApprovalStatus, optedOutAt?: any | null, amount: number, currency: string, volunteerTime: string, volunteerDuration: number, deed?: string | null, nonprofit?: string | null, createdAt?: any | null, user: string, formStatus: EligibilityFormStatus, formSubmittedAt?: any | null, User: { __typename?: 'BaseUser', mainPicture?: string | null, id: string, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, additionalData?: { __typename?: 'UserAdditionalData', hireDate?: any | null } | null }, VolunteerTime: { __typename?: 'VolunteerTime', id: string, notes?: string | null, date: any, approvedAt?: any | null, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null }, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null };

export type VolunteerRewardsQueryVariables = Exact<{
  where?: InputMaybe<VolunteerRewardWhereInput>;
  orderBy?: InputMaybe<VolunteerRewardOrderByWithRelationInput>;
  orderByList?: InputMaybe<Array<InputMaybe<VolunteerRewardOrderByWithRelationInput>> | InputMaybe<VolunteerRewardOrderByWithRelationInput>>;
  cursor?: InputMaybe<VolunteerRewardWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VolunteerRewardsQuery = { __typename?: 'Query', volunteerRewards?: { __typename?: 'VolunteerRewardsType', items?: Array<{ __typename?: 'VolunteerReward', id: string, approvalStatus: VolunteerRewardApprovalStatus, optedOutAt?: any | null, amount: number, currency: string, volunteerTime: string, volunteerDuration: number, deed?: string | null, nonprofit?: string | null, createdAt?: any | null, user: string, formStatus: EligibilityFormStatus, formSubmittedAt?: any | null, User: { __typename?: 'BaseUser', mainPicture?: string | null, id: string, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, additionalData?: { __typename?: 'UserAdditionalData', hireDate?: any | null } | null }, VolunteerTime: { __typename?: 'VolunteerTime', id: string, notes?: string | null, date: any, approvedAt?: any | null, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null }, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null }> | null, metadata: { __typename?: 'VolunteerRewardsMetaType', totalItems?: number | null, totalPages?: number | null, skip?: number | null, take?: number | null } } | null };

export type UpdateVolunteerRewardMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  data: VolunteerRewardInputType;
}>;


export type UpdateVolunteerRewardMutation = { __typename?: 'Mutation', updateVolunteerRewards?: Array<{ __typename?: 'VolunteerReward', id: string, approvalStatus: VolunteerRewardApprovalStatus } | null> | null };

export type DonationScheduleFragment = { __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> };

export type DonationScheduleFullFragment = { __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, Campaign?: { __typename?: 'Campaign', id: string, title: string, isPledge: boolean, pledgedDonationStartingAt?: any | null, pledgedDonationEndingAt?: any | null } | null, executionFailure: Array<{ __typename?: 'DonationScheduleExecutionFailure', message?: string | null, code?: string | null, failedAt: any }>, paymentMethod: { __typename?: 'PaymentMethodDetails', type?: PaymentMethodType | null }, Donations: Array<{ __typename?: 'Donation', id: string, date: any, type?: DonationType | null, nonprofits: Array<string>, amount: number, amountCurrencies?: any | null, matchedAmount?: number | null, matchedAmountCurrencies?: any | null, paymentMethodDetails?: { __typename?: 'PaymentMethodDetails', additionalData?: any | null } | null, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> }>, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> };

export type DonationSchedulesQueryVariables = Exact<{
  where: DonationScheduleWhereInput;
}>;


export type DonationSchedulesQuery = { __typename?: 'Query', donationSchedules: Array<{ __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> }> };

export type DonationScheduleFullQueryVariables = Exact<{
  where: DonationScheduleWhereInput;
}>;


export type DonationScheduleFullQuery = { __typename?: 'Query', donationSchedules: Array<{ __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, Campaign?: { __typename?: 'Campaign', id: string, title: string, isPledge: boolean, pledgedDonationStartingAt?: any | null, pledgedDonationEndingAt?: any | null } | null, executionFailure: Array<{ __typename?: 'DonationScheduleExecutionFailure', message?: string | null, code?: string | null, failedAt: any }>, paymentMethod: { __typename?: 'PaymentMethodDetails', type?: PaymentMethodType | null }, Donations: Array<{ __typename?: 'Donation', id: string, date: any, type?: DonationType | null, nonprofits: Array<string>, amount: number, amountCurrencies?: any | null, matchedAmount?: number | null, matchedAmountCurrencies?: any | null, paymentMethodDetails?: { __typename?: 'PaymentMethodDetails', additionalData?: any | null } | null, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> }>, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> }> };

export type CancelDonationScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelDonationScheduleMutation = { __typename?: 'Mutation', cancelDonationSchedule?: { __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> } | null };

export type UpdateDonationScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: DonationScheduleUpdateInputType;
}>;


export type UpdateDonationScheduleMutation = { __typename?: 'Mutation', updateDonationSchedule?: { __typename?: 'DonationSchedule', id: string, frequency: DonationFrequency, startingAt: any, endingAt?: any | null, createdAt?: any | null, amount: number, currencyCode: string, status?: DonationScheduleStatus | null, privacy?: DonationPrivacy | null, provider: ProviderType, description?: string | null, User: { __typename?: 'BaseUser', id: string }, Nonprofits: Array<{ __typename?: 'Organization', id: string, name: string, logo?: string | null, mainPicture?: string | null }> } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code?: string | null, countryCode?: string | null, country?: string | null }> };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, code?: string | null, country?: string | null, countryCode?: string | null, currencyCode?: string | null, createdAt: any, modifiedAt?: any | null, coordinates: Array<number>, public?: boolean | null, state?: string | null, picture?: string | null, stateCode?: string | null, region?: string | null }> };

export type PersistGovernmentInformationLetterMutationVariables = Exact<{
  governmentInformationLetterUri: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  letterOfAssociationUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersistGovernmentInformationLetterMutation = { __typename?: 'Mutation', persistGovernmentInformationLetter?: boolean | null };

export type RequestVerificationMutationVariables = Exact<{
  supportingDocuments: Array<Scalars['String']['input']> | Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type RequestVerificationMutation = { __typename?: 'Mutation', requestVerification?: boolean | null };

export type VerifyOrganizerUserWithPayPalMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyOrganizerUserWithPayPalMutation = { __typename?: 'Mutation', verifyOrganizerUserWithPayPal?: boolean | null };

export type UnblockOrganizerUserInOrganizationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UnblockOrganizerUserInOrganizationMutation = { __typename?: 'Mutation', unblockOrganizerUserInOrganization?: boolean | null };

export type BlockOrganizerUserInOrganizationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type BlockOrganizerUserInOrganizationMutation = { __typename?: 'Mutation', blockOrganizerUserInOrganization?: boolean | null };

export type SwitchOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SwitchOrganizationMutation = { __typename?: 'Mutation', switchOrganization?: boolean | null };

export type VolunteerTimesWithPaginationQueryVariables = Exact<{
  where?: InputMaybe<VolunteerTimeWhereInput>;
  orderBy?: InputMaybe<VolunteerTimeOrderByWithRelationInput>;
  cursor?: InputMaybe<VolunteerTimeWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VolunteerTimesWithPaginationQuery = { __typename?: 'Query', volunteerTimesWithPagination?: { __typename?: 'VolunteerTimesType', items?: Array<{ __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, notes?: string | null, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, volunteerReward?: string | null, roleId?: string | null, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null, User: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, locationId?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null }, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, Company?: { __typename?: 'Organization', id: string, name: string } | null, VolunteerReward?: { __typename?: 'VolunteerReward', formStatus: EligibilityFormStatus, amount: number } | null }> | null, metadata: { __typename?: 'VolunteerTimesMetaType', totalItems?: number | null, totalPages?: number | null, skip?: number | null, take?: number | null } } | null };

export type VolunteerTimeFragment = { __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, notes?: string | null, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, volunteerReward?: string | null, roleId?: string | null, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null, User: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, locationId?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null }, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, Company?: { __typename?: 'Organization', id: string, name: string } | null, VolunteerReward?: { __typename?: 'VolunteerReward', formStatus: EligibilityFormStatus, amount: number } | null };

export type LimitedVolunteerTimeFragment = { __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, roleId?: string | null, User: { __typename?: 'BaseUser', id: string }, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null };

export type VolunteerTimesQueryVariables = Exact<{
  where: VolunteerTimeWhereInput;
}>;


export type VolunteerTimesQuery = { __typename?: 'Query', volunteerTimes: Array<{ __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, notes?: string | null, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, volunteerReward?: string | null, roleId?: string | null, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null, User: { __typename?: 'BaseUser', id: string, mainPicture?: string | null, locationId?: string | null, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null }, Nonprofit?: { __typename?: 'Organization', id: string, name: string } | null, Company?: { __typename?: 'Organization', id: string, name: string } | null, VolunteerReward?: { __typename?: 'VolunteerReward', formStatus: EligibilityFormStatus, amount: number } | null }> };

export type ApproveVolunteerTimeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveVolunteerTimeMutation = { __typename?: 'Mutation', approveVolunteerTime?: { __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, roleId?: string | null, User: { __typename?: 'BaseUser', id: string }, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null } | null };

export type RejectVolunteerTimeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectVolunteerTimeMutation = { __typename?: 'Mutation', rejectVolunteerTime?: { __typename?: 'VolunteerTime', id: string, userId: string, companyId?: string | null, nonprofitId?: string | null, duration: number, date: any, approval: VolunteerTimeApproval, createdAt?: any | null, externalNonprofitId?: string | null, externalNonprofitName?: string | null, roleId?: string | null, User: { __typename?: 'BaseUser', id: string }, Deed?: { __typename?: 'Deed', id: string, name?: string | null, type: DeedType } | null } | null };

export type UpdateVolunteerTimesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  data: VolunteerTimesUpdateInputType;
}>;


export type UpdateVolunteerTimesMutation = { __typename?: 'Mutation', updateVolunteerTimes?: Array<{ __typename?: 'VolunteerTime', id: string, approval: VolunteerTimeApproval } | null> | null };

export type SearchNonprofitsQueryVariables = Exact<{
  acceptsDonations?: InputMaybe<Scalars['Boolean']['input']>;
  causes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  donationProvider?: InputMaybe<Scalars['String']['input']>;
  excludeDonationProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  includeBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchNonprofitsQuery = { __typename?: 'Query', searchNonprofits: Array<{ __typename?: 'DeedNonprofit', id?: string | null, type?: string | null, approved?: boolean | null, brief?: string | null, currencyCode?: string | null, ein?: string | null, email?: string | null, externalId?: string | null, logo?: string | null, mainPicture?: string | null, name?: string | null, nonprofitEntityType?: string | null, nonprofitId?: string | null, payPalModel?: string | null, paypalCharityType?: string | null, phone?: string | null, website?: string | null, categories?: Array<string | null> | null, searchTermMatchScore?: number | null, matchForSearchTerm?: string | null, acceptsDonations?: boolean | null, isChapter?: boolean | null, identifiers?: Array<{ __typename?: 'NonprofitIdentifierEntryType', countryCode?: string | null, id?: string | null, type?: string | null } | null> | null, locationObject?: { __typename?: 'LocationObject', address?: string | null, address2?: string | null, area?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, postalCode?: string | null, state?: string | null, stateCode?: string | null, geo?: { __typename?: 'GeoJSON', coordinates: Array<number>, type?: string | null } | null } | null, taxonomy?: { __typename?: 'Taxonomy', externalClassification?: string | null, irsClassificationCode?: string | null, irsFoundationCode?: string | null, irsSubSectionCode?: string | null, ncesSchoolDistrict?: string | null, ncesSchoolType?: string | null } | null, donationProviders?: { __typename?: 'DonationProviderMapType', Stripe?: boolean | null, NFG?: boolean | null, GlobalGiving?: boolean | null, Betterplace?: boolean | null, PayPal?: boolean | null, External?: boolean | null, CAF?: boolean | null } | null, meta?: { __typename?: 'NonprofitMeta', totalItems?: number | null, totalPages?: number | null, offset?: number | null, limit?: number | null } | null } | null> };

export type EmployeesQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'PaginatedEmployees', total: number, users: Array<{ __typename?: 'BaseUser', id: string, organizationDepartment?: string | null, mainPicture?: string | null, email: string, fullName?: { __typename?: 'FullName', first?: string | null, last?: string | null } | null, communities: Array<{ __typename?: 'CommunityMembership', communityId: string }> }> } };

export const ChallengeDetailsFragmentDoc = gql`
    fragment challengeDetails on Challenge {
  id
  title
  totalText
  totalHeadline
  backgroundImage
  startDate
  endDate
  status
  sorting
  rules {
    actionsCompleted {
      isExclude
      ids
    }
  }
  teams {
    isExclude
    ids
  }
}
    `;
export const ChallengeFragmentDoc = gql`
    fragment challenge on Challenge {
  id
  title
  backgroundImage
  startDate
  endDate
  status
  totalText
  totalHeadline
  generalStats {
    totalParticipants
    totalUsersWithActionsCompleted
    totalTeams
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment user on BaseUser {
  id
  fullName {
    first
    last
  }
  organizationDepartment
  mainPicture
  communities {
    communityId
  }
}
    `;
export const CommunityFragmentFragmentDoc = gql`
    fragment communityFragment on Community {
  id
  title
  description
  headerImage
  tileImage
  companyId
  enabled
  allowAllyMembers
  allowAnonymousMembers
  isPrivate
  type
  leadMembers: members(role: Lead) {
    User {
      ...user
    }
  }
  Nonprofits {
    id
    name
    logo
    locationMap
  }
  Deeds(includePastDeeds: true, includeLinkOnlyDeeds: true) {
    id
  }
}
    ${UserFragmentDoc}`;
export const DeedFieldsFragmentDoc = gql`
    fragment DeedFields on Deed {
  id
  name
  description
  pictures
  createdAt
  modifiedAt
  type
  milestones
  Organization {
    id
    name
    mainPicture
    logo
  }
  Partner {
    id
    name
  }
  OrganizingCommunities {
    id
    title
  }
  attendees
  externalId
  status
  editors
  startingAt
  endingAt
  featured
  categories
  SDGs
  pillars
  ERGs
  campaigns
  rating
  code
  timeZone
  organizerPhone
  organizerName
  linkOnly
}
    `;
export const MinActionFragmentFragmentDoc = gql`
    fragment MinActionFragment on Action {
  id
  title
  startingAt
  endingAt
  status
  campaignIds
}
    `;
export const ActivityUserFragmentDoc = gql`
    fragment ActivityUser on Activity {
  id
  status
}
    `;
export const ActionFragmentFragmentDoc = gql`
    fragment ActionFragment on Action {
  ...MinActionFragment
  subTitle
  description
  bannerImage
  nonprofitId
  enabled
  actionTemplateId
  ActionTemplate {
    organizationId
    public
  }
  Campaigns {
    id
    title
  }
  Causes {
    name
    code
    type
    id
  }
  Nonprofit {
    id
    name
  }
  incentives {
    type
    unit
    amount
  }
  Activities {
    ...ActivityUser
  }
}
    ${MinActionFragmentFragmentDoc}
${ActivityUserFragmentDoc}`;
export const UserObjectFragmentDoc = gql`
    fragment userObject on UserObject {
  id
  name
  preferredName {
    first
    last
  }
  mainPicture
  instagram
  location
  summary
  pictures
  createdAt
  clickable
  deeds
  _volunteerMinutes
  locale
  email
}
    `;
export const DeedFragmentDoc = gql`
    fragment Deed on ReducedDeed {
  id
  providerId
  provider
  categories
  sdgs
  nonprofits {
    name
  }
  type
  startingAt
  endingAt
  registrationEndingAt
  participantsLimit
  virtual
  location {
    country
  }
  timeZone
  name
  description
  mustKnows
  pictures
  contact {
    email
  }
  externalLink
  submitter {
    id
    type
    name
    mainPicture
    organization {
      type
    }
  }
  status
  waitlist {
    ...userObject
  }
  attendees {
    ...userObject
  }
  attendeeLimit
  ended
  started
  public
  linkOnly
  requireAuthentication
  externalLink
  organization {
    id
    name
  }
  locationObject {
    address
    area
    city
    country
    countryCode
    postalCode
    state
    stateCode
  }
  externalLinkFollowsCount
  roles {
    name
    requiredAmount
    applicants {
      id
    }
  }
  allowedLocations
  partner {
    id
    name
    logo
    mainPicture
  }
  isSharedWithSubsidiary
}
    ${UserObjectFragmentDoc}`;
export const ReceiptFragmentFragmentDoc = gql`
    fragment ReceiptFragment on Receipt {
  id
  type
  organization
  active
  data
  metadata
  createdAt
  modifiedAt
}
    `;
export const GivingAccountFragmentFragmentDoc = gql`
    fragment GivingAccountFragment on GivingAccount {
  id
  name
  currencyCode
  provider
  balance
  balanceUserCurrency
}
    `;
export const NotificationSettingsFragmentDoc = gql`
    fragment NotificationSettings on NotificationSettings {
  email {
    mutedMessages
    mutedCategories
  }
}
    `;
export const VolunteerRewardFragmentDoc = gql`
    fragment volunteerReward on VolunteerReward {
  id
  approvalStatus
  optedOutAt
  amount
  currency
  volunteerTime
  volunteerDuration
  deed
  nonprofit
  createdAt
  user
  formStatus
  formSubmittedAt
  User {
    fullName {
      first
      last
    }
    mainPicture
    id
    additionalData {
      hireDate
    }
  }
  VolunteerTime {
    id
    notes
    date
    approvedAt
    Nonprofit {
      id
      name
    }
  }
  Deed {
    id
    name
    type
  }
}
    `;
export const DonationScheduleFragmentDoc = gql`
    fragment donationSchedule on DonationSchedule {
  id
  frequency
  startingAt
  endingAt
  createdAt
  amount
  currencyCode
  status
  privacy
  provider
  description
  User {
    id
  }
  Nonprofits {
    id
    name
    logo
    mainPicture
  }
}
    `;
export const DonationScheduleFullFragmentDoc = gql`
    fragment donationScheduleFull on DonationSchedule {
  ...donationSchedule
  Campaign {
    id
    title
    isPledge
    pledgedDonationStartingAt
    pledgedDonationEndingAt
  }
  executionFailure {
    message
    code
    failedAt
  }
  paymentMethod {
    type
  }
  Donations {
    id
    date
    type
    nonprofits
    amount
    amountCurrencies
    matchedAmount
    matchedAmountCurrencies
    paymentMethodDetails {
      additionalData
    }
    Nonprofits {
      id
      name
      logo
      mainPicture
    }
  }
}
    ${DonationScheduleFragmentDoc}`;
export const VolunteerTimeFragmentDoc = gql`
    fragment volunteerTime on VolunteerTime {
  Deed {
    id
    name
    type
  }
  User {
    id
    mainPicture
    fullName {
      first
      last
    }
    locationId
  }
  Nonprofit {
    id
    name
  }
  Company {
    id
    name
  }
  id
  userId
  companyId
  nonprofitId
  duration
  notes
  date
  approval
  createdAt
  externalNonprofitId
  externalNonprofitName
  volunteerReward
  VolunteerReward {
    formStatus
    amount
  }
  roleId
}
    `;
export const LimitedVolunteerTimeFragmentDoc = gql`
    fragment limitedVolunteerTime on VolunteerTime {
  User {
    id
  }
  Deed {
    id
    name
    type
  }
  id
  userId
  companyId
  nonprofitId
  duration
  date
  approval
  createdAt
  externalNonprofitId
  externalNonprofitName
  roleId
}
    `;
export const ImpactAiGenerationDocument = gql`
    mutation impactAiGeneration($generationId: String!, $variables: Json!, $metadata: Json) @api(name: opportunities) {
  impactAiGeneration(
    generationId: $generationId
    variables: $variables
    metadata: $metadata
  )
}
    `;
export type ImpactAiGenerationMutationFn = Apollo.MutationFunction<ImpactAiGenerationMutation, ImpactAiGenerationMutationVariables>;

/**
 * __useImpactAiGenerationMutation__
 *
 * To run a mutation, you first call `useImpactAiGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpactAiGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impactAiGenerationMutation, { data, loading, error }] = useImpactAiGenerationMutation({
 *   variables: {
 *      generationId: // value for 'generationId'
 *      variables: // value for 'variables'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useImpactAiGenerationMutation(baseOptions?: Apollo.MutationHookOptions<ImpactAiGenerationMutation, ImpactAiGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpactAiGenerationMutation, ImpactAiGenerationMutationVariables>(ImpactAiGenerationDocument, options);
      }
export type ImpactAiGenerationMutationHookResult = ReturnType<typeof useImpactAiGenerationMutation>;
export type ImpactAiGenerationMutationResult = Apollo.MutationResult<ImpactAiGenerationMutation>;
export type ImpactAiGenerationMutationOptions = Apollo.BaseMutationOptions<ImpactAiGenerationMutation, ImpactAiGenerationMutationVariables>;
export const ImpactAiPresetsDocument = gql`
    query impactAiPresets @api(name: opportunities) {
  impactAiPresets {
    items {
      id
      title
      description
      iconName
      color
      enabled
      organizations
      initialContext
      relatedPresets
      requiredPrivileges
      sortIndex
      actions {
        type
        data
      }
    }
    totalCount
  }
}
    `;

/**
 * __useImpactAiPresetsQuery__
 *
 * To run a query within a React component, call `useImpactAiPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactAiPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactAiPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactAiPresetsQuery(baseOptions?: Apollo.QueryHookOptions<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>(ImpactAiPresetsDocument, options);
      }
export function useImpactAiPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>(ImpactAiPresetsDocument, options);
        }
export function useImpactAiPresetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>(ImpactAiPresetsDocument, options);
        }
export type ImpactAiPresetsQueryHookResult = ReturnType<typeof useImpactAiPresetsQuery>;
export type ImpactAiPresetsLazyQueryHookResult = ReturnType<typeof useImpactAiPresetsLazyQuery>;
export type ImpactAiPresetsSuspenseQueryHookResult = ReturnType<typeof useImpactAiPresetsSuspenseQuery>;
export type ImpactAiPresetsQueryResult = Apollo.QueryResult<ImpactAiPresetsQuery, ImpactAiPresetsQueryVariables>;
export const ImpactAiNonprofitDocument = gql`
    query impactAiNonprofit($organizationId: String) @api(name: nonprofit) {
  nonprofit(organizationId: $organizationId) {
    id
    nonprofitId
    name
    ein
    identifiers {
      type
      id
      countryCode
    }
    locationObject {
      address
      city
      state
      postalCode
      country
      countryCode
    }
    brief
    categories
  }
}
    `;

/**
 * __useImpactAiNonprofitQuery__
 *
 * To run a query within a React component, call `useImpactAiNonprofitQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactAiNonprofitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactAiNonprofitQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useImpactAiNonprofitQuery(baseOptions?: Apollo.QueryHookOptions<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>(ImpactAiNonprofitDocument, options);
      }
export function useImpactAiNonprofitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>(ImpactAiNonprofitDocument, options);
        }
export function useImpactAiNonprofitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>(ImpactAiNonprofitDocument, options);
        }
export type ImpactAiNonprofitQueryHookResult = ReturnType<typeof useImpactAiNonprofitQuery>;
export type ImpactAiNonprofitLazyQueryHookResult = ReturnType<typeof useImpactAiNonprofitLazyQuery>;
export type ImpactAiNonprofitSuspenseQueryHookResult = ReturnType<typeof useImpactAiNonprofitSuspenseQuery>;
export type ImpactAiNonprofitQueryResult = Apollo.QueryResult<ImpactAiNonprofitQuery, ImpactAiNonprofitQueryVariables>;
export const ImpactAiNonprofitSearchDocument = gql`
    query impactAiNonprofitSearch($acceptsDonations: Boolean, $causes: [String], $countryCode: String, $donationProvider: String, $excludeDonationProviders: [String], $includeApproved: Boolean, $limit: Int, $offset: Int, $searchTerm: String, $stateCode: String) @api(name: nonprofit) {
  searchNonprofits(
    acceptsDonations: $acceptsDonations
    causes: $causes
    countryCode: $countryCode
    donationProvider: $donationProvider
    excludeDonationProviders: $excludeDonationProviders
    includeApproved: $includeApproved
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
    stateCode: $stateCode
  ) {
    id
    type
    approved
    brief
    currencyCode
    ein
    email
    externalId
    identifiers {
      countryCode
      id
      type
    }
    locationObject {
      address
      address2
      area
      city
      country
      countryCode
      geo {
        coordinates
        type
      }
      postalCode
      state
      stateCode
    }
    name
    nonprofitEntityType
    categories
    searchTermMatchScore
    matchForSearchTerm
    meta {
      totalItems
      totalPages
      offset
      limit
    }
  }
}
    `;

/**
 * __useImpactAiNonprofitSearchQuery__
 *
 * To run a query within a React component, call `useImpactAiNonprofitSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactAiNonprofitSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactAiNonprofitSearchQuery({
 *   variables: {
 *      acceptsDonations: // value for 'acceptsDonations'
 *      causes: // value for 'causes'
 *      countryCode: // value for 'countryCode'
 *      donationProvider: // value for 'donationProvider'
 *      excludeDonationProviders: // value for 'excludeDonationProviders'
 *      includeApproved: // value for 'includeApproved'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useImpactAiNonprofitSearchQuery(baseOptions?: Apollo.QueryHookOptions<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>(ImpactAiNonprofitSearchDocument, options);
      }
export function useImpactAiNonprofitSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>(ImpactAiNonprofitSearchDocument, options);
        }
export function useImpactAiNonprofitSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>(ImpactAiNonprofitSearchDocument, options);
        }
export type ImpactAiNonprofitSearchQueryHookResult = ReturnType<typeof useImpactAiNonprofitSearchQuery>;
export type ImpactAiNonprofitSearchLazyQueryHookResult = ReturnType<typeof useImpactAiNonprofitSearchLazyQuery>;
export type ImpactAiNonprofitSearchSuspenseQueryHookResult = ReturnType<typeof useImpactAiNonprofitSearchSuspenseQuery>;
export type ImpactAiNonprofitSearchQueryResult = Apollo.QueryResult<ImpactAiNonprofitSearchQuery, ImpactAiNonprofitSearchQueryVariables>;
export const UpsertActionTemplateDocument = gql`
    mutation UpsertActionTemplate($data: ActionTemplateUpsertInputType!) @api(name: graph) {
  mutationUpsertActionTemplate(data: $data) {
    id
    status
    title
    subTitle
    description
    bannerImage
    organizationId
    public
    causes
    incentives {
      type
      amount
      unit
    }
  }
}
    `;
export type UpsertActionTemplateMutationFn = Apollo.MutationFunction<UpsertActionTemplateMutation, UpsertActionTemplateMutationVariables>;

/**
 * __useUpsertActionTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertActionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActionTemplateMutation, { data, loading, error }] = useUpsertActionTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertActionTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActionTemplateMutation, UpsertActionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActionTemplateMutation, UpsertActionTemplateMutationVariables>(UpsertActionTemplateDocument, options);
      }
export type UpsertActionTemplateMutationHookResult = ReturnType<typeof useUpsertActionTemplateMutation>;
export type UpsertActionTemplateMutationResult = Apollo.MutationResult<UpsertActionTemplateMutation>;
export type UpsertActionTemplateMutationOptions = Apollo.BaseMutationOptions<UpsertActionTemplateMutation, UpsertActionTemplateMutationVariables>;
export const CreateActionFromTemplateDocument = gql`
    mutation createActionFromTemplate($templateId: String!) @api(name: graph) {
  createActionFromTemplate(templateId: $templateId) {
    id
  }
}
    `;
export type CreateActionFromTemplateMutationFn = Apollo.MutationFunction<CreateActionFromTemplateMutation, CreateActionFromTemplateMutationVariables>;

/**
 * __useCreateActionFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateActionFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionFromTemplateMutation, { data, loading, error }] = useCreateActionFromTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useCreateActionFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionFromTemplateMutation, CreateActionFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionFromTemplateMutation, CreateActionFromTemplateMutationVariables>(CreateActionFromTemplateDocument, options);
      }
export type CreateActionFromTemplateMutationHookResult = ReturnType<typeof useCreateActionFromTemplateMutation>;
export type CreateActionFromTemplateMutationResult = Apollo.MutationResult<CreateActionFromTemplateMutation>;
export type CreateActionFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateActionFromTemplateMutation, CreateActionFromTemplateMutationVariables>;
export const ActionTemplateResultsDocument = gql`
    query actionTemplateResults($offset: Int, $limit: Int, $templateId: String, $searchTerm: String, $causes: [String!], $status: [ActionVisibilityStatus!], $public: [Boolean!]) @api(name: graph) {
  actionTemplateResults(
    offset: $offset
    limit: $limit
    templateId: $templateId
    searchTerm: $searchTerm
    causes: $causes
    status: $status
    public: $public
  ) {
    total
    templates {
      id
      status
      title
      subTitle
      description
      bannerImage
      organizationId
      public
      Causes {
        id
        name
        code
        type
      }
      createdAt
      modifiedAt
      incentives {
        type
        unit
        amount
      }
    }
  }
}
    `;

/**
 * __useActionTemplateResultsQuery__
 *
 * To run a query within a React component, call `useActionTemplateResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionTemplateResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionTemplateResultsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      templateId: // value for 'templateId'
 *      searchTerm: // value for 'searchTerm'
 *      causes: // value for 'causes'
 *      status: // value for 'status'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useActionTemplateResultsQuery(baseOptions?: Apollo.QueryHookOptions<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>(ActionTemplateResultsDocument, options);
      }
export function useActionTemplateResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>(ActionTemplateResultsDocument, options);
        }
export function useActionTemplateResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>(ActionTemplateResultsDocument, options);
        }
export type ActionTemplateResultsQueryHookResult = ReturnType<typeof useActionTemplateResultsQuery>;
export type ActionTemplateResultsLazyQueryHookResult = ReturnType<typeof useActionTemplateResultsLazyQuery>;
export type ActionTemplateResultsSuspenseQueryHookResult = ReturnType<typeof useActionTemplateResultsSuspenseQuery>;
export type ActionTemplateResultsQueryResult = Apollo.QueryResult<ActionTemplateResultsQuery, ActionTemplateResultsQueryVariables>;
export const HandleNonprofitAddressChangeDocument = gql`
    mutation handleNonprofitAddressChange($userId: ID!, $ticketId: Int!, $nonprofitId: ID!, $approve: Boolean!, $rejectionReason: String) @api(name: nonprofit) {
  handleNonprofitAddressChange(
    userId: $userId
    ticketId: $ticketId
    nonprofitId: $nonprofitId
    approve: $approve
    rejectionReason: $rejectionReason
  )
}
    `;
export type HandleNonprofitAddressChangeMutationFn = Apollo.MutationFunction<HandleNonprofitAddressChangeMutation, HandleNonprofitAddressChangeMutationVariables>;

/**
 * __useHandleNonprofitAddressChangeMutation__
 *
 * To run a mutation, you first call `useHandleNonprofitAddressChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleNonprofitAddressChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleNonprofitAddressChangeMutation, { data, loading, error }] = useHandleNonprofitAddressChangeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      ticketId: // value for 'ticketId'
 *      nonprofitId: // value for 'nonprofitId'
 *      approve: // value for 'approve'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useHandleNonprofitAddressChangeMutation(baseOptions?: Apollo.MutationHookOptions<HandleNonprofitAddressChangeMutation, HandleNonprofitAddressChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleNonprofitAddressChangeMutation, HandleNonprofitAddressChangeMutationVariables>(HandleNonprofitAddressChangeDocument, options);
      }
export type HandleNonprofitAddressChangeMutationHookResult = ReturnType<typeof useHandleNonprofitAddressChangeMutation>;
export type HandleNonprofitAddressChangeMutationResult = Apollo.MutationResult<HandleNonprofitAddressChangeMutation>;
export type HandleNonprofitAddressChangeMutationOptions = Apollo.BaseMutationOptions<HandleNonprofitAddressChangeMutation, HandleNonprofitAddressChangeMutationVariables>;
export const AffiliationsListDocument = gql`
    query affiliationsList($userId: ID) @api(name: nonprofit) {
  affiliations(userId: $userId) {
    id
    userId
    companyId
    nonprofitId
    Nonprofit {
      name
      mainPicture
    }
    startingAt
    endingAt
    affiliationType
    boardPosition
    createdAt
    modifiedAt
  }
}
    `;

/**
 * __useAffiliationsListQuery__
 *
 * To run a query within a React component, call `useAffiliationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationsListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAffiliationsListQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationsListQuery, AffiliationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationsListQuery, AffiliationsListQueryVariables>(AffiliationsListDocument, options);
      }
export function useAffiliationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationsListQuery, AffiliationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationsListQuery, AffiliationsListQueryVariables>(AffiliationsListDocument, options);
        }
export function useAffiliationsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationsListQuery, AffiliationsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationsListQuery, AffiliationsListQueryVariables>(AffiliationsListDocument, options);
        }
export type AffiliationsListQueryHookResult = ReturnType<typeof useAffiliationsListQuery>;
export type AffiliationsListLazyQueryHookResult = ReturnType<typeof useAffiliationsListLazyQuery>;
export type AffiliationsListSuspenseQueryHookResult = ReturnType<typeof useAffiliationsListSuspenseQuery>;
export type AffiliationsListQueryResult = Apollo.QueryResult<AffiliationsListQuery, AffiliationsListQueryVariables>;
export const AffiliationByIdDocument = gql`
    query affiliationById($affiliationId: ID!) @api(name: nonprofit) {
  affiliation(id: $affiliationId) {
    id
    userId
    companyId
    nonprofitId
    Nonprofit {
      name
      mainPicture
    }
    startingAt
    endingAt
    affiliationType
    boardPosition
    createdAt
    modifiedAt
  }
}
    `;

/**
 * __useAffiliationByIdQuery__
 *
 * To run a query within a React component, call `useAffiliationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationByIdQuery({
 *   variables: {
 *      affiliationId: // value for 'affiliationId'
 *   },
 * });
 */
export function useAffiliationByIdQuery(baseOptions: Apollo.QueryHookOptions<AffiliationByIdQuery, AffiliationByIdQueryVariables> & ({ variables: AffiliationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationByIdQuery, AffiliationByIdQueryVariables>(AffiliationByIdDocument, options);
      }
export function useAffiliationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationByIdQuery, AffiliationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationByIdQuery, AffiliationByIdQueryVariables>(AffiliationByIdDocument, options);
        }
export function useAffiliationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationByIdQuery, AffiliationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationByIdQuery, AffiliationByIdQueryVariables>(AffiliationByIdDocument, options);
        }
export type AffiliationByIdQueryHookResult = ReturnType<typeof useAffiliationByIdQuery>;
export type AffiliationByIdLazyQueryHookResult = ReturnType<typeof useAffiliationByIdLazyQuery>;
export type AffiliationByIdSuspenseQueryHookResult = ReturnType<typeof useAffiliationByIdSuspenseQuery>;
export type AffiliationByIdQueryResult = Apollo.QueryResult<AffiliationByIdQuery, AffiliationByIdQueryVariables>;
export const DeleteEmployeeAffiliationDocument = gql`
    mutation deleteEmployeeAffiliation($deleteEmployeeAffiliationId: ID!) @api(name: nonprofit) {
  deleteEmployeeAffiliation(id: $deleteEmployeeAffiliationId) {
    id
  }
}
    `;
export type DeleteEmployeeAffiliationMutationFn = Apollo.MutationFunction<DeleteEmployeeAffiliationMutation, DeleteEmployeeAffiliationMutationVariables>;

/**
 * __useDeleteEmployeeAffiliationMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeAffiliationMutation, { data, loading, error }] = useDeleteEmployeeAffiliationMutation({
 *   variables: {
 *      deleteEmployeeAffiliationId: // value for 'deleteEmployeeAffiliationId'
 *   },
 * });
 */
export function useDeleteEmployeeAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeAffiliationMutation, DeleteEmployeeAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeAffiliationMutation, DeleteEmployeeAffiliationMutationVariables>(DeleteEmployeeAffiliationDocument, options);
      }
export type DeleteEmployeeAffiliationMutationHookResult = ReturnType<typeof useDeleteEmployeeAffiliationMutation>;
export type DeleteEmployeeAffiliationMutationResult = Apollo.MutationResult<DeleteEmployeeAffiliationMutation>;
export type DeleteEmployeeAffiliationMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeAffiliationMutation, DeleteEmployeeAffiliationMutationVariables>;
export const UpdateEmployeeAffiliationDocument = gql`
    mutation updateEmployeeAffiliation($updateEmployeeAffiliationId: ID!, $data: EmployeeAffiliationUpdateInputType!) @api(name: nonprofit) {
  updateEmployeeAffiliation(id: $updateEmployeeAffiliationId, data: $data) {
    id
    startingAt
    endingAt
    affiliationType
    boardPosition
  }
}
    `;
export type UpdateEmployeeAffiliationMutationFn = Apollo.MutationFunction<UpdateEmployeeAffiliationMutation, UpdateEmployeeAffiliationMutationVariables>;

/**
 * __useUpdateEmployeeAffiliationMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeAffiliationMutation, { data, loading, error }] = useUpdateEmployeeAffiliationMutation({
 *   variables: {
 *      updateEmployeeAffiliationId: // value for 'updateEmployeeAffiliationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmployeeAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeAffiliationMutation, UpdateEmployeeAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeAffiliationMutation, UpdateEmployeeAffiliationMutationVariables>(UpdateEmployeeAffiliationDocument, options);
      }
export type UpdateEmployeeAffiliationMutationHookResult = ReturnType<typeof useUpdateEmployeeAffiliationMutation>;
export type UpdateEmployeeAffiliationMutationResult = Apollo.MutationResult<UpdateEmployeeAffiliationMutation>;
export type UpdateEmployeeAffiliationMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeAffiliationMutation, UpdateEmployeeAffiliationMutationVariables>;
export const CreateEmployeeAffiliationDocument = gql`
    mutation createEmployeeAffiliation($data: EmployeeAffiliationCreateInputType!) @api(name: nonprofit) {
  createEmployeeAffiliation(data: $data) {
    id
  }
}
    `;
export type CreateEmployeeAffiliationMutationFn = Apollo.MutationFunction<CreateEmployeeAffiliationMutation, CreateEmployeeAffiliationMutationVariables>;

/**
 * __useCreateEmployeeAffiliationMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeAffiliationMutation, { data, loading, error }] = useCreateEmployeeAffiliationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeAffiliationMutation, CreateEmployeeAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeAffiliationMutation, CreateEmployeeAffiliationMutationVariables>(CreateEmployeeAffiliationDocument, options);
      }
export type CreateEmployeeAffiliationMutationHookResult = ReturnType<typeof useCreateEmployeeAffiliationMutation>;
export type CreateEmployeeAffiliationMutationResult = Apollo.MutationResult<CreateEmployeeAffiliationMutation>;
export type CreateEmployeeAffiliationMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeAffiliationMutation, CreateEmployeeAffiliationMutationVariables>;
export const CreateImpactAiPresetDocument = gql`
    mutation createImpactAiPreset($data: ImpactAiPresetCreateInput!) @api(name: opportunities) {
  createImpactAiPreset(data: $data) {
    id
    title
    description
    iconName
    color
    enabled
    organizations
    initialContext
    sortIndex
    actions {
      type
      data
    }
  }
}
    `;
export type CreateImpactAiPresetMutationFn = Apollo.MutationFunction<CreateImpactAiPresetMutation, CreateImpactAiPresetMutationVariables>;

/**
 * __useCreateImpactAiPresetMutation__
 *
 * To run a mutation, you first call `useCreateImpactAiPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImpactAiPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImpactAiPresetMutation, { data, loading, error }] = useCreateImpactAiPresetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateImpactAiPresetMutation(baseOptions?: Apollo.MutationHookOptions<CreateImpactAiPresetMutation, CreateImpactAiPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImpactAiPresetMutation, CreateImpactAiPresetMutationVariables>(CreateImpactAiPresetDocument, options);
      }
export type CreateImpactAiPresetMutationHookResult = ReturnType<typeof useCreateImpactAiPresetMutation>;
export type CreateImpactAiPresetMutationResult = Apollo.MutationResult<CreateImpactAiPresetMutation>;
export type CreateImpactAiPresetMutationOptions = Apollo.BaseMutationOptions<CreateImpactAiPresetMutation, CreateImpactAiPresetMutationVariables>;
export const UpdateImpactAiPresetDocument = gql`
    mutation updateImpactAiPreset($id: String!, $data: ImpactAiPresetUpdateInput!) @api(name: opportunities) {
  updateImpactAiPreset(id: $id, data: $data) {
    id
    title
    description
    iconName
    color
    enabled
    organizations
    initialContext
    sortIndex
    actions {
      type
      data
    }
  }
}
    `;
export type UpdateImpactAiPresetMutationFn = Apollo.MutationFunction<UpdateImpactAiPresetMutation, UpdateImpactAiPresetMutationVariables>;

/**
 * __useUpdateImpactAiPresetMutation__
 *
 * To run a mutation, you first call `useUpdateImpactAiPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImpactAiPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImpactAiPresetMutation, { data, loading, error }] = useUpdateImpactAiPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateImpactAiPresetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImpactAiPresetMutation, UpdateImpactAiPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImpactAiPresetMutation, UpdateImpactAiPresetMutationVariables>(UpdateImpactAiPresetDocument, options);
      }
export type UpdateImpactAiPresetMutationHookResult = ReturnType<typeof useUpdateImpactAiPresetMutation>;
export type UpdateImpactAiPresetMutationResult = Apollo.MutationResult<UpdateImpactAiPresetMutation>;
export type UpdateImpactAiPresetMutationOptions = Apollo.BaseMutationOptions<UpdateImpactAiPresetMutation, UpdateImpactAiPresetMutationVariables>;
export const DeleteImpactAiPresetDocument = gql`
    mutation deleteImpactAiPreset($id: String!) @api(name: opportunities) {
  deleteImpactAiPreset(id: $id)
}
    `;
export type DeleteImpactAiPresetMutationFn = Apollo.MutationFunction<DeleteImpactAiPresetMutation, DeleteImpactAiPresetMutationVariables>;

/**
 * __useDeleteImpactAiPresetMutation__
 *
 * To run a mutation, you first call `useDeleteImpactAiPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImpactAiPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImpactAiPresetMutation, { data, loading, error }] = useDeleteImpactAiPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImpactAiPresetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImpactAiPresetMutation, DeleteImpactAiPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImpactAiPresetMutation, DeleteImpactAiPresetMutationVariables>(DeleteImpactAiPresetDocument, options);
      }
export type DeleteImpactAiPresetMutationHookResult = ReturnType<typeof useDeleteImpactAiPresetMutation>;
export type DeleteImpactAiPresetMutationResult = Apollo.MutationResult<DeleteImpactAiPresetMutation>;
export type DeleteImpactAiPresetMutationOptions = Apollo.BaseMutationOptions<DeleteImpactAiPresetMutation, DeleteImpactAiPresetMutationVariables>;
export const MigratedAndToBeMigratedCommunitiesDocument = gql`
    query migratedAndToBeMigratedCommunities @api(name: graph) {
  migratedAndToBeMigratedCommunities {
    migratedCommunities {
      id
      title
    }
    toBeMigratedCommunities {
      sourceERGId
      title
    }
  }
}
    `;

/**
 * __useMigratedAndToBeMigratedCommunitiesQuery__
 *
 * To run a query within a React component, call `useMigratedAndToBeMigratedCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigratedAndToBeMigratedCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigratedAndToBeMigratedCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMigratedAndToBeMigratedCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>(MigratedAndToBeMigratedCommunitiesDocument, options);
      }
export function useMigratedAndToBeMigratedCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>(MigratedAndToBeMigratedCommunitiesDocument, options);
        }
export function useMigratedAndToBeMigratedCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>(MigratedAndToBeMigratedCommunitiesDocument, options);
        }
export type MigratedAndToBeMigratedCommunitiesQueryHookResult = ReturnType<typeof useMigratedAndToBeMigratedCommunitiesQuery>;
export type MigratedAndToBeMigratedCommunitiesLazyQueryHookResult = ReturnType<typeof useMigratedAndToBeMigratedCommunitiesLazyQuery>;
export type MigratedAndToBeMigratedCommunitiesSuspenseQueryHookResult = ReturnType<typeof useMigratedAndToBeMigratedCommunitiesSuspenseQuery>;
export type MigratedAndToBeMigratedCommunitiesQueryResult = Apollo.QueryResult<MigratedAndToBeMigratedCommunitiesQuery, MigratedAndToBeMigratedCommunitiesQueryVariables>;
export const MigrateErGsToCommunitiesDocument = gql`
    mutation migrateERGsToCommunities @api(name: graph) {
  migrateERGsToCommunities {
    updatedCommunities {
      id
      title
      sourceERGId
    }
    newlyCreatedCommunities {
      id
      title
      sourceERGId
    }
  }
}
    `;
export type MigrateErGsToCommunitiesMutationFn = Apollo.MutationFunction<MigrateErGsToCommunitiesMutation, MigrateErGsToCommunitiesMutationVariables>;

/**
 * __useMigrateErGsToCommunitiesMutation__
 *
 * To run a mutation, you first call `useMigrateErGsToCommunitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateErGsToCommunitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateErGsToCommunitiesMutation, { data, loading, error }] = useMigrateErGsToCommunitiesMutation({
 *   variables: {
 *   },
 * });
 */
export function useMigrateErGsToCommunitiesMutation(baseOptions?: Apollo.MutationHookOptions<MigrateErGsToCommunitiesMutation, MigrateErGsToCommunitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateErGsToCommunitiesMutation, MigrateErGsToCommunitiesMutationVariables>(MigrateErGsToCommunitiesDocument, options);
      }
export type MigrateErGsToCommunitiesMutationHookResult = ReturnType<typeof useMigrateErGsToCommunitiesMutation>;
export type MigrateErGsToCommunitiesMutationResult = Apollo.MutationResult<MigrateErGsToCommunitiesMutation>;
export type MigrateErGsToCommunitiesMutationOptions = Apollo.BaseMutationOptions<MigrateErGsToCommunitiesMutation, MigrateErGsToCommunitiesMutationVariables>;
export const ChallengeDocument = gql`
    query Challenge($where: ChallengeWhereInput!) @api(name: graph) {
  challenges(where: $where, take: 1) {
    items {
      ...challengeDetails
    }
  }
}
    ${ChallengeDetailsFragmentDoc}`;

/**
 * __useChallengeQuery__
 *
 * To run a query within a React component, call `useChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChallengeQuery(baseOptions: Apollo.QueryHookOptions<ChallengeQuery, ChallengeQueryVariables> & ({ variables: ChallengeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeQuery, ChallengeQueryVariables>(ChallengeDocument, options);
      }
export function useChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeQuery, ChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeQuery, ChallengeQueryVariables>(ChallengeDocument, options);
        }
export function useChallengeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChallengeQuery, ChallengeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChallengeQuery, ChallengeQueryVariables>(ChallengeDocument, options);
        }
export type ChallengeQueryHookResult = ReturnType<typeof useChallengeQuery>;
export type ChallengeLazyQueryHookResult = ReturnType<typeof useChallengeLazyQuery>;
export type ChallengeSuspenseQueryHookResult = ReturnType<typeof useChallengeSuspenseQuery>;
export type ChallengeQueryResult = Apollo.QueryResult<ChallengeQuery, ChallengeQueryVariables>;
export const UpsertChallengeDocument = gql`
    mutation UpsertChallenge($data: ChallengeUpsertInputType!) @api(name: graph) {
  upsertChallenge(data: $data) {
    ...challengeDetails
  }
}
    ${ChallengeDetailsFragmentDoc}`;
export type UpsertChallengeMutationFn = Apollo.MutationFunction<UpsertChallengeMutation, UpsertChallengeMutationVariables>;

/**
 * __useUpsertChallengeMutation__
 *
 * To run a mutation, you first call `useUpsertChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertChallengeMutation, { data, loading, error }] = useUpsertChallengeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertChallengeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertChallengeMutation, UpsertChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertChallengeMutation, UpsertChallengeMutationVariables>(UpsertChallengeDocument, options);
      }
export type UpsertChallengeMutationHookResult = ReturnType<typeof useUpsertChallengeMutation>;
export type UpsertChallengeMutationResult = Apollo.MutationResult<UpsertChallengeMutation>;
export type UpsertChallengeMutationOptions = Apollo.BaseMutationOptions<UpsertChallengeMutation, UpsertChallengeMutationVariables>;
export const CommunityTeamsDocument = gql`
    query CommunityTeams($where: CommunityWhereInput, $take: Int) @api(name: graph) {
  communities(where: $where, take: $take, includeDisabled: false) {
    id
    title
    type
  }
}
    `;

/**
 * __useCommunityTeamsQuery__
 *
 * To run a query within a React component, call `useCommunityTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCommunityTeamsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityTeamsQuery, CommunityTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamsQuery, CommunityTeamsQueryVariables>(CommunityTeamsDocument, options);
      }
export function useCommunityTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamsQuery, CommunityTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamsQuery, CommunityTeamsQueryVariables>(CommunityTeamsDocument, options);
        }
export function useCommunityTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityTeamsQuery, CommunityTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityTeamsQuery, CommunityTeamsQueryVariables>(CommunityTeamsDocument, options);
        }
export type CommunityTeamsQueryHookResult = ReturnType<typeof useCommunityTeamsQuery>;
export type CommunityTeamsLazyQueryHookResult = ReturnType<typeof useCommunityTeamsLazyQuery>;
export type CommunityTeamsSuspenseQueryHookResult = ReturnType<typeof useCommunityTeamsSuspenseQuery>;
export type CommunityTeamsQueryResult = Apollo.QueryResult<CommunityTeamsQuery, CommunityTeamsQueryVariables>;
export const ChallengesDocument = gql`
    query Challenges($where: ChallengeWhereInput, $orderBy: ChallengeOrderByWithRelationInput, $orderByList: [ChallengeOrderByWithRelationInput], $cursor: ChallengeWhereUniqueInput, $take: Int, $skip: Int) @api(name: graph) {
  challenges(
    where: $where
    orderBy: $orderBy
    orderByList: $orderByList
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    items {
      ...challenge
    }
    metadata {
      totalItems
      totalPages
      skip
      take
    }
  }
}
    ${ChallengeFragmentDoc}`;

/**
 * __useChallengesQuery__
 *
 * To run a query within a React component, call `useChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      orderByList: // value for 'orderByList'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useChallengesQuery(baseOptions?: Apollo.QueryHookOptions<ChallengesQuery, ChallengesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengesQuery, ChallengesQueryVariables>(ChallengesDocument, options);
      }
export function useChallengesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengesQuery, ChallengesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengesQuery, ChallengesQueryVariables>(ChallengesDocument, options);
        }
export function useChallengesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChallengesQuery, ChallengesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChallengesQuery, ChallengesQueryVariables>(ChallengesDocument, options);
        }
export type ChallengesQueryHookResult = ReturnType<typeof useChallengesQuery>;
export type ChallengesLazyQueryHookResult = ReturnType<typeof useChallengesLazyQuery>;
export type ChallengesSuspenseQueryHookResult = ReturnType<typeof useChallengesSuspenseQuery>;
export type ChallengesQueryResult = Apollo.QueryResult<ChallengesQuery, ChallengesQueryVariables>;
export const ChallengesTeamRankingsDocument = gql`
    query ChallengesTeamRankings($where: ChallengeWhereInput, $orderBy: ChallengeOrderByWithRelationInput, $orderByList: [ChallengeOrderByWithRelationInput], $cursor: ChallengeWhereUniqueInput, $take: Int, $skip: Int, $teamRankingsTake: Int, $teamRankingsSkip: Int) @api(name: graph) {
  challenges(
    where: $where
    orderBy: $orderBy
    orderByList: $orderByList
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    items {
      id
      teamRankings(take: $teamRankingsTake, skip: $teamRankingsSkip) {
        actionsCompleted {
          rank
          totalCount
          team {
            id
            title
            tileImage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useChallengesTeamRankingsQuery__
 *
 * To run a query within a React component, call `useChallengesTeamRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengesTeamRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengesTeamRankingsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      orderByList: // value for 'orderByList'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      teamRankingsTake: // value for 'teamRankingsTake'
 *      teamRankingsSkip: // value for 'teamRankingsSkip'
 *   },
 * });
 */
export function useChallengesTeamRankingsQuery(baseOptions?: Apollo.QueryHookOptions<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>(ChallengesTeamRankingsDocument, options);
      }
export function useChallengesTeamRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>(ChallengesTeamRankingsDocument, options);
        }
export function useChallengesTeamRankingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>(ChallengesTeamRankingsDocument, options);
        }
export type ChallengesTeamRankingsQueryHookResult = ReturnType<typeof useChallengesTeamRankingsQuery>;
export type ChallengesTeamRankingsLazyQueryHookResult = ReturnType<typeof useChallengesTeamRankingsLazyQuery>;
export type ChallengesTeamRankingsSuspenseQueryHookResult = ReturnType<typeof useChallengesTeamRankingsSuspenseQuery>;
export type ChallengesTeamRankingsQueryResult = Apollo.QueryResult<ChallengesTeamRankingsQuery, ChallengesTeamRankingsQueryVariables>;
export const AcceptChapterRequestDocument = gql`
    mutation AcceptChapterRequest($id: ID!, $input: UpdateChapterRequestInput!, $hash: String!) @api(name: nonprofit) {
  acceptChapterRequest(id: $id, input: $input, hash: $hash) {
    success
    status
    validationMessages {
      type
      code
      message
      payload
    }
  }
}
    `;
export type AcceptChapterRequestMutationFn = Apollo.MutationFunction<AcceptChapterRequestMutation, AcceptChapterRequestMutationVariables>;

/**
 * __useAcceptChapterRequestMutation__
 *
 * To run a mutation, you first call `useAcceptChapterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptChapterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptChapterRequestMutation, { data, loading, error }] = useAcceptChapterRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useAcceptChapterRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptChapterRequestMutation, AcceptChapterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptChapterRequestMutation, AcceptChapterRequestMutationVariables>(AcceptChapterRequestDocument, options);
      }
export type AcceptChapterRequestMutationHookResult = ReturnType<typeof useAcceptChapterRequestMutation>;
export type AcceptChapterRequestMutationResult = Apollo.MutationResult<AcceptChapterRequestMutation>;
export type AcceptChapterRequestMutationOptions = Apollo.BaseMutationOptions<AcceptChapterRequestMutation, AcceptChapterRequestMutationVariables>;
export const RejectChapterRequestDocument = gql`
    mutation RejectChapterRequest($id: String!, $reason: String!, $hash: String!) @api(name: nonprofit) {
  rejectChapterRequest(id: $id, reason: $reason, hash: $hash)
}
    `;
export type RejectChapterRequestMutationFn = Apollo.MutationFunction<RejectChapterRequestMutation, RejectChapterRequestMutationVariables>;

/**
 * __useRejectChapterRequestMutation__
 *
 * To run a mutation, you first call `useRejectChapterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectChapterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectChapterRequestMutation, { data, loading, error }] = useRejectChapterRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useRejectChapterRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectChapterRequestMutation, RejectChapterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectChapterRequestMutation, RejectChapterRequestMutationVariables>(RejectChapterRequestDocument, options);
      }
export type RejectChapterRequestMutationHookResult = ReturnType<typeof useRejectChapterRequestMutation>;
export type RejectChapterRequestMutationResult = Apollo.MutationResult<RejectChapterRequestMutation>;
export type RejectChapterRequestMutationOptions = Apollo.BaseMutationOptions<RejectChapterRequestMutation, RejectChapterRequestMutationVariables>;
export const UpdateChapterRequestFromReviewDocument = gql`
    mutation UpdateChapterRequestFromReview($id: ID!, $input: UpdateChapterRequestInput!) @api(name: nonprofit) {
  updateChapterRequest(id: $id, input: $input) {
    id
    nonprofitName
    locationObject {
      address
      city
      state
      stateCode
      postalCode
      country
      countryCode
      geo {
        type
        coordinates
      }
    }
    identifiers {
      id
      type
    }
    email
    users {
      ... on ChapterRequestUserDirect {
        fullName {
          first
          last
        }
        email
        roles
      }
    }
    validationMessages {
      type
      code
      message
      payload
    }
  }
}
    `;
export type UpdateChapterRequestFromReviewMutationFn = Apollo.MutationFunction<UpdateChapterRequestFromReviewMutation, UpdateChapterRequestFromReviewMutationVariables>;

/**
 * __useUpdateChapterRequestFromReviewMutation__
 *
 * To run a mutation, you first call `useUpdateChapterRequestFromReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChapterRequestFromReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChapterRequestFromReviewMutation, { data, loading, error }] = useUpdateChapterRequestFromReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChapterRequestFromReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChapterRequestFromReviewMutation, UpdateChapterRequestFromReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChapterRequestFromReviewMutation, UpdateChapterRequestFromReviewMutationVariables>(UpdateChapterRequestFromReviewDocument, options);
      }
export type UpdateChapterRequestFromReviewMutationHookResult = ReturnType<typeof useUpdateChapterRequestFromReviewMutation>;
export type UpdateChapterRequestFromReviewMutationResult = Apollo.MutationResult<UpdateChapterRequestFromReviewMutation>;
export type UpdateChapterRequestFromReviewMutationOptions = Apollo.BaseMutationOptions<UpdateChapterRequestFromReviewMutation, UpdateChapterRequestFromReviewMutationVariables>;
export const ChapterRequestDocument = gql`
    query ChapterRequest($id: String!) @api(name: nonprofit) {
  chapterRequest(id: $id) {
    id
    nonprofitName
    locationObject {
      address
      city
      state
      stateCode
      postalCode
      country
      countryCode
      geo {
        type
        coordinates
      }
    }
    identifiers {
      id
      type
    }
    parentNonprofitId
    parentName
    zendeskTicketId
    email
    status
    createdAt
    modifiedAt
    users {
      ... on ChapterRequestUserDirect {
        fullName {
          first
          last
        }
        email
        roles
      }
      ... on ChapterRequestUserByReference {
        id
        roles
      }
    }
    requestedBy
    processedBy
    processedAt
    nonprofitName
    requestedByName
    metadata {
      rejectionReason
    }
    validationMessages {
      type
      code
      message
      payload
    }
  }
}
    `;

/**
 * __useChapterRequestQuery__
 *
 * To run a query within a React component, call `useChapterRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useChapterRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChapterRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChapterRequestQuery(baseOptions: Apollo.QueryHookOptions<ChapterRequestQuery, ChapterRequestQueryVariables> & ({ variables: ChapterRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChapterRequestQuery, ChapterRequestQueryVariables>(ChapterRequestDocument, options);
      }
export function useChapterRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChapterRequestQuery, ChapterRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChapterRequestQuery, ChapterRequestQueryVariables>(ChapterRequestDocument, options);
        }
export function useChapterRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChapterRequestQuery, ChapterRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChapterRequestQuery, ChapterRequestQueryVariables>(ChapterRequestDocument, options);
        }
export type ChapterRequestQueryHookResult = ReturnType<typeof useChapterRequestQuery>;
export type ChapterRequestLazyQueryHookResult = ReturnType<typeof useChapterRequestLazyQuery>;
export type ChapterRequestSuspenseQueryHookResult = ReturnType<typeof useChapterRequestSuspenseQuery>;
export type ChapterRequestQueryResult = Apollo.QueryResult<ChapterRequestQuery, ChapterRequestQueryVariables>;
export const ChaptersDocument = gql`
    query chapters @api(name: nonprofit) {
  chapters {
    nonprofitId
    name
    isParent
    access
    locationObject {
      city
      area
      state
      stateCode
      postalCode
      country
      countryCode
    }
    invisible
  }
}
    `;

/**
 * __useChaptersQuery__
 *
 * To run a query within a React component, call `useChaptersQuery` and pass it any options that fit your needs.
 * When your component renders, `useChaptersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChaptersQuery({
 *   variables: {
 *   },
 * });
 */
export function useChaptersQuery(baseOptions?: Apollo.QueryHookOptions<ChaptersQuery, ChaptersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChaptersQuery, ChaptersQueryVariables>(ChaptersDocument, options);
      }
export function useChaptersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChaptersQuery, ChaptersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChaptersQuery, ChaptersQueryVariables>(ChaptersDocument, options);
        }
export function useChaptersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChaptersQuery, ChaptersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChaptersQuery, ChaptersQueryVariables>(ChaptersDocument, options);
        }
export type ChaptersQueryHookResult = ReturnType<typeof useChaptersQuery>;
export type ChaptersLazyQueryHookResult = ReturnType<typeof useChaptersLazyQuery>;
export type ChaptersSuspenseQueryHookResult = ReturnType<typeof useChaptersSuspenseQuery>;
export type ChaptersQueryResult = Apollo.QueryResult<ChaptersQuery, ChaptersQueryVariables>;
export const RequestNonprofitAccessDocument = gql`
    mutation requestNonprofitAccess($nonprofitId: String!) @api(name: nonprofit) {
  requestNonprofitAccess(nonprofitId: $nonprofitId)
}
    `;
export type RequestNonprofitAccessMutationFn = Apollo.MutationFunction<RequestNonprofitAccessMutation, RequestNonprofitAccessMutationVariables>;

/**
 * __useRequestNonprofitAccessMutation__
 *
 * To run a mutation, you first call `useRequestNonprofitAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNonprofitAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNonprofitAccessMutation, { data, loading, error }] = useRequestNonprofitAccessMutation({
 *   variables: {
 *      nonprofitId: // value for 'nonprofitId'
 *   },
 * });
 */
export function useRequestNonprofitAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestNonprofitAccessMutation, RequestNonprofitAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNonprofitAccessMutation, RequestNonprofitAccessMutationVariables>(RequestNonprofitAccessDocument, options);
      }
export type RequestNonprofitAccessMutationHookResult = ReturnType<typeof useRequestNonprofitAccessMutation>;
export type RequestNonprofitAccessMutationResult = Apollo.MutationResult<RequestNonprofitAccessMutation>;
export type RequestNonprofitAccessMutationOptions = Apollo.BaseMutationOptions<RequestNonprofitAccessMutation, RequestNonprofitAccessMutationVariables>;
export const CreateChapterRequestDocument = gql`
    mutation createChapterRequest($input: CreateChapterRequestInput!) @api(name: nonprofit) {
  createChapterRequest(input: $input) {
    nonprofitName
    parentNonprofitId
    nonprofitName
    locationObject {
      address
      address2
      area
      city
      country
      countryCode
      geo {
        type
        coordinates
      }
      postalCode
      state
      stateCode
    }
    email
    identifiers {
      id
      type
    }
    users {
      ... on ChapterRequestUserDirect {
        fullName {
          first
          last
        }
        email
        roles
      }
    }
  }
}
    `;
export type CreateChapterRequestMutationFn = Apollo.MutationFunction<CreateChapterRequestMutation, CreateChapterRequestMutationVariables>;

/**
 * __useCreateChapterRequestMutation__
 *
 * To run a mutation, you first call `useCreateChapterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChapterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChapterRequestMutation, { data, loading, error }] = useCreateChapterRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChapterRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateChapterRequestMutation, CreateChapterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChapterRequestMutation, CreateChapterRequestMutationVariables>(CreateChapterRequestDocument, options);
      }
export type CreateChapterRequestMutationHookResult = ReturnType<typeof useCreateChapterRequestMutation>;
export type CreateChapterRequestMutationResult = Apollo.MutationResult<CreateChapterRequestMutation>;
export type CreateChapterRequestMutationOptions = Apollo.BaseMutationOptions<CreateChapterRequestMutation, CreateChapterRequestMutationVariables>;
export const UpdateChapterRequestDocument = gql`
    mutation UpdateChapterRequest($id: ID!, $input: UpdateChapterRequestInput!) @api(name: nonprofit) {
  updateChapterRequest(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateChapterRequestMutationFn = Apollo.MutationFunction<UpdateChapterRequestMutation, UpdateChapterRequestMutationVariables>;

/**
 * __useUpdateChapterRequestMutation__
 *
 * To run a mutation, you first call `useUpdateChapterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChapterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChapterRequestMutation, { data, loading, error }] = useUpdateChapterRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChapterRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChapterRequestMutation, UpdateChapterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChapterRequestMutation, UpdateChapterRequestMutationVariables>(UpdateChapterRequestDocument, options);
      }
export type UpdateChapterRequestMutationHookResult = ReturnType<typeof useUpdateChapterRequestMutation>;
export type UpdateChapterRequestMutationResult = Apollo.MutationResult<UpdateChapterRequestMutation>;
export type UpdateChapterRequestMutationOptions = Apollo.BaseMutationOptions<UpdateChapterRequestMutation, UpdateChapterRequestMutationVariables>;
export const ChapterRequestsDocument = gql`
    query chapterRequests($statuses: [ChapterRequestStatusEnum], $parentNonprofitId: String, $limit: Int, $offset: Int) @api(name: nonprofit) {
  chapterRequests(
    statuses: $statuses
    parentNonprofitId: $parentNonprofitId
    limit: $limit
    offset: $offset
  ) {
    results {
      id
      nonprofitName
      locationObject {
        address
        city
        state
        postalCode
        country
        countryCode
        stateCode
        geo {
          type
          coordinates
        }
      }
      parentNonprofitId
      parentName
      email
      status
      createdAt
      modifiedAt
      identifiers {
        type
        id
        countryCode
      }
      users {
        ... on ChapterRequestUserDirect {
          fullName {
            first
            last
          }
          email
          roles
        }
        ... on ChapterRequestUserByReference {
          id
          roles
        }
      }
      requestedBy
      processedBy
      processedAt
      metadata {
        rejectionReason
      }
    }
    limit
    offset
    total
  }
}
    `;

/**
 * __useChapterRequestsQuery__
 *
 * To run a query within a React component, call `useChapterRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChapterRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChapterRequestsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      parentNonprofitId: // value for 'parentNonprofitId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useChapterRequestsQuery(baseOptions?: Apollo.QueryHookOptions<ChapterRequestsQuery, ChapterRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChapterRequestsQuery, ChapterRequestsQueryVariables>(ChapterRequestsDocument, options);
      }
export function useChapterRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChapterRequestsQuery, ChapterRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChapterRequestsQuery, ChapterRequestsQueryVariables>(ChapterRequestsDocument, options);
        }
export function useChapterRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChapterRequestsQuery, ChapterRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChapterRequestsQuery, ChapterRequestsQueryVariables>(ChapterRequestsDocument, options);
        }
export type ChapterRequestsQueryHookResult = ReturnType<typeof useChapterRequestsQuery>;
export type ChapterRequestsLazyQueryHookResult = ReturnType<typeof useChapterRequestsLazyQuery>;
export type ChapterRequestsSuspenseQueryHookResult = ReturnType<typeof useChapterRequestsSuspenseQuery>;
export type ChapterRequestsQueryResult = Apollo.QueryResult<ChapterRequestsQuery, ChapterRequestsQueryVariables>;
export const RevokeChapterRequestDocument = gql`
    mutation RevokeChapterRequest($id: String!) @api(name: nonprofit) {
  revokeChapterRequest(id: $id)
}
    `;
export type RevokeChapterRequestMutationFn = Apollo.MutationFunction<RevokeChapterRequestMutation, RevokeChapterRequestMutationVariables>;

/**
 * __useRevokeChapterRequestMutation__
 *
 * To run a mutation, you first call `useRevokeChapterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeChapterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeChapterRequestMutation, { data, loading, error }] = useRevokeChapterRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeChapterRequestMutation(baseOptions?: Apollo.MutationHookOptions<RevokeChapterRequestMutation, RevokeChapterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeChapterRequestMutation, RevokeChapterRequestMutationVariables>(RevokeChapterRequestDocument, options);
      }
export type RevokeChapterRequestMutationHookResult = ReturnType<typeof useRevokeChapterRequestMutation>;
export type RevokeChapterRequestMutationResult = Apollo.MutationResult<RevokeChapterRequestMutation>;
export type RevokeChapterRequestMutationOptions = Apollo.BaseMutationOptions<RevokeChapterRequestMutation, RevokeChapterRequestMutationVariables>;
export const CommunitiesDocument = gql`
    query communities($take: Int, $skip: Int, $where: CommunityWhereInput) @api(name: graph) {
  communities(take: $take, skip: $skip, includeDisabled: true, where: $where) {
    id
    title
    description
    companyId
    headerImage
    tileImage
    enabled
    isPrivate
    _count {
      Deeds
    }
    createdAt
    membersCount
    modifiedAt
    totalVolunteering
    totalDonations
  }
}
    `;

/**
 * __useCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
      }
export function useCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export function useCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export type CommunitiesQueryHookResult = ReturnType<typeof useCommunitiesQuery>;
export type CommunitiesLazyQueryHookResult = ReturnType<typeof useCommunitiesLazyQuery>;
export type CommunitiesSuspenseQueryHookResult = ReturnType<typeof useCommunitiesSuspenseQuery>;
export type CommunitiesQueryResult = Apollo.QueryResult<CommunitiesQuery, CommunitiesQueryVariables>;
export const CommunitiesMetricsDocument = gql`
    query communitiesMetrics @api(name: graph) {
  employeesCount
  communitiesTotalDonations
  communitiesTotalMembers
  communitiesTotalVolunteering
}
    `;

/**
 * __useCommunitiesMetricsQuery__
 *
 * To run a query within a React component, call `useCommunitiesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunitiesMetricsQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>(CommunitiesMetricsDocument, options);
      }
export function useCommunitiesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>(CommunitiesMetricsDocument, options);
        }
export function useCommunitiesMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>(CommunitiesMetricsDocument, options);
        }
export type CommunitiesMetricsQueryHookResult = ReturnType<typeof useCommunitiesMetricsQuery>;
export type CommunitiesMetricsLazyQueryHookResult = ReturnType<typeof useCommunitiesMetricsLazyQuery>;
export type CommunitiesMetricsSuspenseQueryHookResult = ReturnType<typeof useCommunitiesMetricsSuspenseQuery>;
export type CommunitiesMetricsQueryResult = Apollo.QueryResult<CommunitiesMetricsQuery, CommunitiesMetricsQueryVariables>;
export const CommunitiesCountDocument = gql`
    query communitiesCount($where: CommunityWhereInput) @api(name: graph) {
  communitiesCount(includeDisabled: true, where: $where)
}
    `;

/**
 * __useCommunitiesCountQuery__
 *
 * To run a query within a React component, call `useCommunitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCommunitiesCountQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesCountQuery, CommunitiesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesCountQuery, CommunitiesCountQueryVariables>(CommunitiesCountDocument, options);
      }
export function useCommunitiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesCountQuery, CommunitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesCountQuery, CommunitiesCountQueryVariables>(CommunitiesCountDocument, options);
        }
export function useCommunitiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitiesCountQuery, CommunitiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesCountQuery, CommunitiesCountQueryVariables>(CommunitiesCountDocument, options);
        }
export type CommunitiesCountQueryHookResult = ReturnType<typeof useCommunitiesCountQuery>;
export type CommunitiesCountLazyQueryHookResult = ReturnType<typeof useCommunitiesCountLazyQuery>;
export type CommunitiesCountSuspenseQueryHookResult = ReturnType<typeof useCommunitiesCountSuspenseQuery>;
export type CommunitiesCountQueryResult = Apollo.QueryResult<CommunitiesCountQuery, CommunitiesCountQueryVariables>;
export const CommunityDocument = gql`
    query community($communityId: ID!) @api(name: graph) {
  community(id: $communityId) {
    ...communityFragment
  }
}
    ${CommunityFragmentFragmentDoc}`;

/**
 * __useCommunityQuery__
 *
 * To run a query within a React component, call `useCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityQuery(baseOptions: Apollo.QueryHookOptions<CommunityQuery, CommunityQueryVariables> & ({ variables: CommunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
      }
export function useCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityQuery, CommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
        }
export function useCommunitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityQuery, CommunityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityQuery, CommunityQueryVariables>(CommunityDocument, options);
        }
export type CommunityQueryHookResult = ReturnType<typeof useCommunityQuery>;
export type CommunityLazyQueryHookResult = ReturnType<typeof useCommunityLazyQuery>;
export type CommunitySuspenseQueryHookResult = ReturnType<typeof useCommunitySuspenseQuery>;
export type CommunityQueryResult = Apollo.QueryResult<CommunityQuery, CommunityQueryVariables>;
export const CreateCommunityDocument = gql`
    mutation createCommunity($data: CommunityCreateInputType!) @api(name: graph) {
  createCommunity(data: $data) {
    ...communityFragment
  }
}
    ${CommunityFragmentFragmentDoc}`;
export type CreateCommunityMutationFn = Apollo.MutationFunction<CreateCommunityMutation, CreateCommunityMutationVariables>;

/**
 * __useCreateCommunityMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMutation, { data, loading, error }] = useCreateCommunityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMutation, CreateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMutation, CreateCommunityMutationVariables>(CreateCommunityDocument, options);
      }
export type CreateCommunityMutationHookResult = ReturnType<typeof useCreateCommunityMutation>;
export type CreateCommunityMutationResult = Apollo.MutationResult<CreateCommunityMutation>;
export type CreateCommunityMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMutation, CreateCommunityMutationVariables>;
export const UpdateCommunityDocument = gql`
    mutation updateCommunity($communityId: ID!, $data: CommunityUpdateInputType!) @api(name: graph) {
  updateCommunity(id: $communityId, data: $data) {
    ...communityFragment
  }
}
    ${CommunityFragmentFragmentDoc}`;
export type UpdateCommunityMutationFn = Apollo.MutationFunction<UpdateCommunityMutation, UpdateCommunityMutationVariables>;

/**
 * __useUpdateCommunityMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityMutation, { data, loading, error }] = useUpdateCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityMutation, UpdateCommunityMutationVariables>(UpdateCommunityDocument, options);
      }
export type UpdateCommunityMutationHookResult = ReturnType<typeof useUpdateCommunityMutation>;
export type UpdateCommunityMutationResult = Apollo.MutationResult<UpdateCommunityMutation>;
export type UpdateCommunityMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>;
export const AddCommunityUsersDocument = gql`
    mutation addCommunityUsers($userIds: [ID!]!, $communityId: ID!) @api(name: graph) {
  addCommunityUsers(userIds: $userIds, communityId: $communityId)
}
    `;
export type AddCommunityUsersMutationFn = Apollo.MutationFunction<AddCommunityUsersMutation, AddCommunityUsersMutationVariables>;

/**
 * __useAddCommunityUsersMutation__
 *
 * To run a mutation, you first call `useAddCommunityUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommunityUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommunityUsersMutation, { data, loading, error }] = useAddCommunityUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useAddCommunityUsersMutation(baseOptions?: Apollo.MutationHookOptions<AddCommunityUsersMutation, AddCommunityUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommunityUsersMutation, AddCommunityUsersMutationVariables>(AddCommunityUsersDocument, options);
      }
export type AddCommunityUsersMutationHookResult = ReturnType<typeof useAddCommunityUsersMutation>;
export type AddCommunityUsersMutationResult = Apollo.MutationResult<AddCommunityUsersMutation>;
export type AddCommunityUsersMutationOptions = Apollo.BaseMutationOptions<AddCommunityUsersMutation, AddCommunityUsersMutationVariables>;
export const RemoveCommunityUsersDocument = gql`
    mutation removeCommunityUsers($userIds: [ID!]!, $communityId: ID!, $isExcludingMembers: Boolean!) @api(name: graph) {
  removeCommunityUsers(
    userIds: $userIds
    communityId: $communityId
    isExcludingMembers: $isExcludingMembers
  )
}
    `;
export type RemoveCommunityUsersMutationFn = Apollo.MutationFunction<RemoveCommunityUsersMutation, RemoveCommunityUsersMutationVariables>;

/**
 * __useRemoveCommunityUsersMutation__
 *
 * To run a mutation, you first call `useRemoveCommunityUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommunityUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommunityUsersMutation, { data, loading, error }] = useRemoveCommunityUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      communityId: // value for 'communityId'
 *      isExcludingMembers: // value for 'isExcludingMembers'
 *   },
 * });
 */
export function useRemoveCommunityUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommunityUsersMutation, RemoveCommunityUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommunityUsersMutation, RemoveCommunityUsersMutationVariables>(RemoveCommunityUsersDocument, options);
      }
export type RemoveCommunityUsersMutationHookResult = ReturnType<typeof useRemoveCommunityUsersMutation>;
export type RemoveCommunityUsersMutationResult = Apollo.MutationResult<RemoveCommunityUsersMutation>;
export type RemoveCommunityUsersMutationOptions = Apollo.BaseMutationOptions<RemoveCommunityUsersMutation, RemoveCommunityUsersMutationVariables>;
export const CommunityFullDocument = gql`
    query communityFull($communityId: ID!) @api(name: graph) {
  community(id: $communityId) {
    id
    title
    description
    headerImage
    tileImage
    enabled
    isPrivate
    type
    Company {
      id
      name
    }
    Deeds(includePastDeeds: true, includeLinkOnlyDeeds: true) {
      ...DeedFields
    }
    Nonprofits {
      id
      name
      logo
    }
    leads: members(role: Lead) {
      User {
        id
        fullName {
          first
          last
        }
        mainPicture
        email
        phone
      }
      role
    }
  }
}
    ${DeedFieldsFragmentDoc}`;

/**
 * __useCommunityFullQuery__
 *
 * To run a query within a React component, call `useCommunityFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityFullQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityFullQuery(baseOptions: Apollo.QueryHookOptions<CommunityFullQuery, CommunityFullQueryVariables> & ({ variables: CommunityFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityFullQuery, CommunityFullQueryVariables>(CommunityFullDocument, options);
      }
export function useCommunityFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityFullQuery, CommunityFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityFullQuery, CommunityFullQueryVariables>(CommunityFullDocument, options);
        }
export function useCommunityFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityFullQuery, CommunityFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityFullQuery, CommunityFullQueryVariables>(CommunityFullDocument, options);
        }
export type CommunityFullQueryHookResult = ReturnType<typeof useCommunityFullQuery>;
export type CommunityFullLazyQueryHookResult = ReturnType<typeof useCommunityFullLazyQuery>;
export type CommunityFullSuspenseQueryHookResult = ReturnType<typeof useCommunityFullSuspenseQuery>;
export type CommunityFullQueryResult = Apollo.QueryResult<CommunityFullQuery, CommunityFullQueryVariables>;
export const CommunityMembersDocument = gql`
    query communityMembers($communityId: ID!, $take: Int!, $skip: Int, $search: String, $excludeUserIds: [ID!]) @api(name: graph) {
  community(id: $communityId) {
    id
    members(
      take: $take
      skip: $skip
      search: $search
      excludeUserIds: $excludeUserIds
    ) {
      User {
        id
        fullName {
          first
          last
        }
        mainPicture
        email
        communities {
          communityId
        }
      }
      role
    }
    membersCount
  }
}
    `;

/**
 * __useCommunityMembersQuery__
 *
 * To run a query within a React component, call `useCommunityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityMembersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      excludeUserIds: // value for 'excludeUserIds'
 *   },
 * });
 */
export function useCommunityMembersQuery(baseOptions: Apollo.QueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables> & ({ variables: CommunityMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
      }
export function useCommunityMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
        }
export function useCommunityMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
        }
export type CommunityMembersQueryHookResult = ReturnType<typeof useCommunityMembersQuery>;
export type CommunityMembersLazyQueryHookResult = ReturnType<typeof useCommunityMembersLazyQuery>;
export type CommunityMembersSuspenseQueryHookResult = ReturnType<typeof useCommunityMembersSuspenseQuery>;
export type CommunityMembersQueryResult = Apollo.QueryResult<CommunityMembersQuery, CommunityMembersQueryVariables>;
export const PendingPayrollRunsDocument = gql`
    query pendingPayrollRuns @api(name: donationBatch) {
  pendingPayrollRuns {
    items {
      id
      payrollPayGroupId
      total
      currencyCode
      startDateExternal
      endDateExternal
    }
    metadata {
      totalItems
      totalPages
    }
  }
}
    `;

/**
 * __usePendingPayrollRunsQuery__
 *
 * To run a query within a React component, call `usePendingPayrollRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingPayrollRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingPayrollRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingPayrollRunsQuery(baseOptions?: Apollo.QueryHookOptions<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>(PendingPayrollRunsDocument, options);
      }
export function usePendingPayrollRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>(PendingPayrollRunsDocument, options);
        }
export function usePendingPayrollRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>(PendingPayrollRunsDocument, options);
        }
export type PendingPayrollRunsQueryHookResult = ReturnType<typeof usePendingPayrollRunsQuery>;
export type PendingPayrollRunsLazyQueryHookResult = ReturnType<typeof usePendingPayrollRunsLazyQuery>;
export type PendingPayrollRunsSuspenseQueryHookResult = ReturnType<typeof usePendingPayrollRunsSuspenseQuery>;
export type PendingPayrollRunsQueryResult = Apollo.QueryResult<PendingPayrollRunsQuery, PendingPayrollRunsQueryVariables>;
export const CreateInvoiceForPayrollDocument = gql`
    mutation createInvoiceForPayroll($payrollRunIds: [ID!]!, $poNumber: String, $paymentDueDate: DateTime) @api(name: donationBatch) {
  createInvoiceForPayroll(
    payrollRunIds: $payrollRunIds
    poNumber: $poNumber
    paymentDueDate: $paymentDueDate
  ) {
    id
    amount
    currencyCode
    status
    invoiceNumber
  }
}
    `;
export type CreateInvoiceForPayrollMutationFn = Apollo.MutationFunction<CreateInvoiceForPayrollMutation, CreateInvoiceForPayrollMutationVariables>;

/**
 * __useCreateInvoiceForPayrollMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceForPayrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceForPayrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceForPayrollMutation, { data, loading, error }] = useCreateInvoiceForPayrollMutation({
 *   variables: {
 *      payrollRunIds: // value for 'payrollRunIds'
 *      poNumber: // value for 'poNumber'
 *      paymentDueDate: // value for 'paymentDueDate'
 *   },
 * });
 */
export function useCreateInvoiceForPayrollMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceForPayrollMutation, CreateInvoiceForPayrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceForPayrollMutation, CreateInvoiceForPayrollMutationVariables>(CreateInvoiceForPayrollDocument, options);
      }
export type CreateInvoiceForPayrollMutationHookResult = ReturnType<typeof useCreateInvoiceForPayrollMutation>;
export type CreateInvoiceForPayrollMutationResult = Apollo.MutationResult<CreateInvoiceForPayrollMutation>;
export type CreateInvoiceForPayrollMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceForPayrollMutation, CreateInvoiceForPayrollMutationVariables>;
export const PendingCorporateGivingDisbursementsDocument = gql`
    query pendingCorporateGivingDisbursements($dateTo: DateTime!, $donationDisbursementType: DonationDisbursementCorporateGivingType!) @api(name: donationBatch) {
  pendingCorporateGivingDisbursements(
    dateTo: $dateTo
    donationDisbursementType: $donationDisbursementType
  ) {
    items {
      givingAccountId
      year
      month
      total
      currencyCode
    }
    metadata {
      totalItems
    }
  }
}
    `;

/**
 * __usePendingCorporateGivingDisbursementsQuery__
 *
 * To run a query within a React component, call `usePendingCorporateGivingDisbursementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingCorporateGivingDisbursementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingCorporateGivingDisbursementsQuery({
 *   variables: {
 *      dateTo: // value for 'dateTo'
 *      donationDisbursementType: // value for 'donationDisbursementType'
 *   },
 * });
 */
export function usePendingCorporateGivingDisbursementsQuery(baseOptions: Apollo.QueryHookOptions<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables> & ({ variables: PendingCorporateGivingDisbursementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>(PendingCorporateGivingDisbursementsDocument, options);
      }
export function usePendingCorporateGivingDisbursementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>(PendingCorporateGivingDisbursementsDocument, options);
        }
export function usePendingCorporateGivingDisbursementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>(PendingCorporateGivingDisbursementsDocument, options);
        }
export type PendingCorporateGivingDisbursementsQueryHookResult = ReturnType<typeof usePendingCorporateGivingDisbursementsQuery>;
export type PendingCorporateGivingDisbursementsLazyQueryHookResult = ReturnType<typeof usePendingCorporateGivingDisbursementsLazyQuery>;
export type PendingCorporateGivingDisbursementsSuspenseQueryHookResult = ReturnType<typeof usePendingCorporateGivingDisbursementsSuspenseQuery>;
export type PendingCorporateGivingDisbursementsQueryResult = Apollo.QueryResult<PendingCorporateGivingDisbursementsQuery, PendingCorporateGivingDisbursementsQueryVariables>;
export const CreateInvoiceForCorporateGivingDocument = gql`
    mutation createInvoiceForCorporateGiving($dateTo: DateTime!, $donationDisbursementType: DonationDisbursementCorporateGivingType!, $poNumber: String, $paymentDueDate: DateTime, $givingAccountId: ID) @api(name: donationBatch) {
  createInvoiceForCorporateGiving(
    dateTo: $dateTo
    donationDisbursementType: $donationDisbursementType
    poNumber: $poNumber
    paymentDueDate: $paymentDueDate
    givingAccountId: $givingAccountId
  ) {
    id
    amount
    currencyCode
    status
    invoiceNumber
    poNumber
    paymentDueDate
    invoiceLines {
      itemType
      itemLabel
      amount
    }
  }
}
    `;
export type CreateInvoiceForCorporateGivingMutationFn = Apollo.MutationFunction<CreateInvoiceForCorporateGivingMutation, CreateInvoiceForCorporateGivingMutationVariables>;

/**
 * __useCreateInvoiceForCorporateGivingMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceForCorporateGivingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceForCorporateGivingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceForCorporateGivingMutation, { data, loading, error }] = useCreateInvoiceForCorporateGivingMutation({
 *   variables: {
 *      dateTo: // value for 'dateTo'
 *      donationDisbursementType: // value for 'donationDisbursementType'
 *      poNumber: // value for 'poNumber'
 *      paymentDueDate: // value for 'paymentDueDate'
 *      givingAccountId: // value for 'givingAccountId'
 *   },
 * });
 */
export function useCreateInvoiceForCorporateGivingMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceForCorporateGivingMutation, CreateInvoiceForCorporateGivingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceForCorporateGivingMutation, CreateInvoiceForCorporateGivingMutationVariables>(CreateInvoiceForCorporateGivingDocument, options);
      }
export type CreateInvoiceForCorporateGivingMutationHookResult = ReturnType<typeof useCreateInvoiceForCorporateGivingMutation>;
export type CreateInvoiceForCorporateGivingMutationResult = Apollo.MutationResult<CreateInvoiceForCorporateGivingMutation>;
export type CreateInvoiceForCorporateGivingMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceForCorporateGivingMutation, CreateInvoiceForCorporateGivingMutationVariables>;
export const AvailableDashboardsDocument = gql`
    query availableDashboards @api(name: report) {
  dashboards: listSigmaDashboards {
    type
    title
    description
    iconUrl
    sortOrder
  }
}
    `;

/**
 * __useAvailableDashboardsQuery__
 *
 * To run a query within a React component, call `useAvailableDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>(AvailableDashboardsDocument, options);
      }
export function useAvailableDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>(AvailableDashboardsDocument, options);
        }
export function useAvailableDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>(AvailableDashboardsDocument, options);
        }
export type AvailableDashboardsQueryHookResult = ReturnType<typeof useAvailableDashboardsQuery>;
export type AvailableDashboardsLazyQueryHookResult = ReturnType<typeof useAvailableDashboardsLazyQuery>;
export type AvailableDashboardsSuspenseQueryHookResult = ReturnType<typeof useAvailableDashboardsSuspenseQuery>;
export type AvailableDashboardsQueryResult = Apollo.QueryResult<AvailableDashboardsQuery, AvailableDashboardsQueryVariables>;
export const CommunitiesBriefDocument = gql`
    query communitiesBrief($includeDisabled: Boolean!) @api(name: graph) {
  communities(includeDisabled: $includeDisabled) {
    id
    title
    enabled
  }
}
    `;

/**
 * __useCommunitiesBriefQuery__
 *
 * To run a query within a React component, call `useCommunitiesBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesBriefQuery({
 *   variables: {
 *      includeDisabled: // value for 'includeDisabled'
 *   },
 * });
 */
export function useCommunitiesBriefQuery(baseOptions: Apollo.QueryHookOptions<CommunitiesBriefQuery, CommunitiesBriefQueryVariables> & ({ variables: CommunitiesBriefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>(CommunitiesBriefDocument, options);
      }
export function useCommunitiesBriefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>(CommunitiesBriefDocument, options);
        }
export function useCommunitiesBriefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>(CommunitiesBriefDocument, options);
        }
export type CommunitiesBriefQueryHookResult = ReturnType<typeof useCommunitiesBriefQuery>;
export type CommunitiesBriefLazyQueryHookResult = ReturnType<typeof useCommunitiesBriefLazyQuery>;
export type CommunitiesBriefSuspenseQueryHookResult = ReturnType<typeof useCommunitiesBriefSuspenseQuery>;
export type CommunitiesBriefQueryResult = Apollo.QueryResult<CommunitiesBriefQuery, CommunitiesBriefQueryVariables>;
export const SendSegmentEventDocument = gql`
    mutation sendSegmentEvent($event: String!) @api(name: graph) {
  sendSegmentEvent(event: $event)
}
    `;
export type SendSegmentEventMutationFn = Apollo.MutationFunction<SendSegmentEventMutation, SendSegmentEventMutationVariables>;

/**
 * __useSendSegmentEventMutation__
 *
 * To run a mutation, you first call `useSendSegmentEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSegmentEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSegmentEventMutation, { data, loading, error }] = useSendSegmentEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useSendSegmentEventMutation(baseOptions?: Apollo.MutationHookOptions<SendSegmentEventMutation, SendSegmentEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSegmentEventMutation, SendSegmentEventMutationVariables>(SendSegmentEventDocument, options);
      }
export type SendSegmentEventMutationHookResult = ReturnType<typeof useSendSegmentEventMutation>;
export type SendSegmentEventMutationResult = Apollo.MutationResult<SendSegmentEventMutation>;
export type SendSegmentEventMutationOptions = Apollo.BaseMutationOptions<SendSegmentEventMutation, SendSegmentEventMutationVariables>;
export const ActionsWithPaginationDocument = gql`
    query ActionsWithPagination($where: ActionWhereInput, $orderBy: ActionOrderByWithRelationInput, $take: Int, $skip: Int) @api(name: graph) {
  actionsWithPagination(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    items {
      ...ActionFragment
    }
    metadata {
      totalItems
      totalPages
      skip
      take
    }
  }
}
    ${ActionFragmentFragmentDoc}`;

/**
 * __useActionsWithPaginationQuery__
 *
 * To run a query within a React component, call `useActionsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionsWithPaginationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useActionsWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>(ActionsWithPaginationDocument, options);
      }
export function useActionsWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>(ActionsWithPaginationDocument, options);
        }
export function useActionsWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>(ActionsWithPaginationDocument, options);
        }
export type ActionsWithPaginationQueryHookResult = ReturnType<typeof useActionsWithPaginationQuery>;
export type ActionsWithPaginationLazyQueryHookResult = ReturnType<typeof useActionsWithPaginationLazyQuery>;
export type ActionsWithPaginationSuspenseQueryHookResult = ReturnType<typeof useActionsWithPaginationSuspenseQuery>;
export type ActionsWithPaginationQueryResult = Apollo.QueryResult<ActionsWithPaginationQuery, ActionsWithPaginationQueryVariables>;
export const MinActionsDocument = gql`
    query MinActions($where: ActionWhereInput, $orderBy: ActionOrderByWithRelationInput, $take: Int, $skip: Int) @api(name: graph) {
  actionsWithPagination(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
  ) {
    items {
      ...MinActionFragment
    }
  }
}
    ${MinActionFragmentFragmentDoc}`;

/**
 * __useMinActionsQuery__
 *
 * To run a query within a React component, call `useMinActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinActionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useMinActionsQuery(baseOptions?: Apollo.QueryHookOptions<MinActionsQuery, MinActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinActionsQuery, MinActionsQueryVariables>(MinActionsDocument, options);
      }
export function useMinActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinActionsQuery, MinActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinActionsQuery, MinActionsQueryVariables>(MinActionsDocument, options);
        }
export function useMinActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MinActionsQuery, MinActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MinActionsQuery, MinActionsQueryVariables>(MinActionsDocument, options);
        }
export type MinActionsQueryHookResult = ReturnType<typeof useMinActionsQuery>;
export type MinActionsLazyQueryHookResult = ReturnType<typeof useMinActionsLazyQuery>;
export type MinActionsSuspenseQueryHookResult = ReturnType<typeof useMinActionsSuspenseQuery>;
export type MinActionsQueryResult = Apollo.QueryResult<MinActionsQuery, MinActionsQueryVariables>;
export const SetCampaignActionsDocument = gql`
    mutation setCampaignActions($campaignId: ID!, $actionIds: [ID!]!) @api(name: graph) {
  setCampaignActions(campaignId: $campaignId, actionIds: $actionIds)
}
    `;
export type SetCampaignActionsMutationFn = Apollo.MutationFunction<SetCampaignActionsMutation, SetCampaignActionsMutationVariables>;

/**
 * __useSetCampaignActionsMutation__
 *
 * To run a mutation, you first call `useSetCampaignActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCampaignActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCampaignActionsMutation, { data, loading, error }] = useSetCampaignActionsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      actionIds: // value for 'actionIds'
 *   },
 * });
 */
export function useSetCampaignActionsMutation(baseOptions?: Apollo.MutationHookOptions<SetCampaignActionsMutation, SetCampaignActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCampaignActionsMutation, SetCampaignActionsMutationVariables>(SetCampaignActionsDocument, options);
      }
export type SetCampaignActionsMutationHookResult = ReturnType<typeof useSetCampaignActionsMutation>;
export type SetCampaignActionsMutationResult = Apollo.MutationResult<SetCampaignActionsMutation>;
export type SetCampaignActionsMutationOptions = Apollo.BaseMutationOptions<SetCampaignActionsMutation, SetCampaignActionsMutationVariables>;
export const UpsertActionDocument = gql`
    mutation UpsertAction($actionData: ActionUpsertInputType!) @api(name: graph) {
  mutationUpsertAction(actionData: $actionData) {
    ...ActionFragment
  }
}
    ${ActionFragmentFragmentDoc}`;
export type UpsertActionMutationFn = Apollo.MutationFunction<UpsertActionMutation, UpsertActionMutationVariables>;

/**
 * __useUpsertActionMutation__
 *
 * To run a mutation, you first call `useUpsertActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActionMutation, { data, loading, error }] = useUpsertActionMutation({
 *   variables: {
 *      actionData: // value for 'actionData'
 *   },
 * });
 */
export function useUpsertActionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActionMutation, UpsertActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActionMutation, UpsertActionMutationVariables>(UpsertActionDocument, options);
      }
export type UpsertActionMutationHookResult = ReturnType<typeof useUpsertActionMutation>;
export type UpsertActionMutationResult = Apollo.MutationResult<UpsertActionMutation>;
export type UpsertActionMutationOptions = Apollo.BaseMutationOptions<UpsertActionMutation, UpsertActionMutationVariables>;
export const SearchDeedsDocument = gql`
    query searchDeeds($limit: Int, $offset: Int, $searchTerm: String, $deedType: DeedTypeFilters, $filterOption: FilterOptions, $submitter: [DeedSubmitter!], $provider: [OpportunityProvider!], $subsidiary: [String!]) @api(name: opportunities) {
  searchDeeds(
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
    deedType: $deedType
    filterOption: $filterOption
    submitters: $submitter
    providers: $provider
    subsidiaries: $subsidiary
  ) {
    deeds {
      ...Deed
    }
    total
  }
}
    ${DeedFragmentDoc}`;

/**
 * __useSearchDeedsQuery__
 *
 * To run a query within a React component, call `useSearchDeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDeedsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *      deedType: // value for 'deedType'
 *      filterOption: // value for 'filterOption'
 *      submitter: // value for 'submitter'
 *      provider: // value for 'provider'
 *      subsidiary: // value for 'subsidiary'
 *   },
 * });
 */
export function useSearchDeedsQuery(baseOptions?: Apollo.QueryHookOptions<SearchDeedsQuery, SearchDeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDeedsQuery, SearchDeedsQueryVariables>(SearchDeedsDocument, options);
      }
export function useSearchDeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDeedsQuery, SearchDeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDeedsQuery, SearchDeedsQueryVariables>(SearchDeedsDocument, options);
        }
export function useSearchDeedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDeedsQuery, SearchDeedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDeedsQuery, SearchDeedsQueryVariables>(SearchDeedsDocument, options);
        }
export type SearchDeedsQueryHookResult = ReturnType<typeof useSearchDeedsQuery>;
export type SearchDeedsLazyQueryHookResult = ReturnType<typeof useSearchDeedsLazyQuery>;
export type SearchDeedsSuspenseQueryHookResult = ReturnType<typeof useSearchDeedsSuspenseQuery>;
export type SearchDeedsQueryResult = Apollo.QueryResult<SearchDeedsQuery, SearchDeedsQueryVariables>;
export const DeedsStatsDocument = gql`
    query deedsStats($searchTerm: String, $deedType: DeedTypeFilters, $submitter: [DeedSubmitter!], $provider: [OpportunityProvider!], $subsidiary: [String!]) @api(name: opportunities) {
  deedsStats(
    searchTerm: $searchTerm
    deedType: $deedType
    submitters: $submitter
    providers: $provider
    subsidiaries: $subsidiary
  ) {
    pendingReviewDeedsTotal
    draftDeedsTotal
    sharedDeedsTotal
  }
}
    `;

/**
 * __useDeedsStatsQuery__
 *
 * To run a query within a React component, call `useDeedsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeedsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeedsStatsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      deedType: // value for 'deedType'
 *      submitter: // value for 'submitter'
 *      provider: // value for 'provider'
 *      subsidiary: // value for 'subsidiary'
 *   },
 * });
 */
export function useDeedsStatsQuery(baseOptions?: Apollo.QueryHookOptions<DeedsStatsQuery, DeedsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeedsStatsQuery, DeedsStatsQueryVariables>(DeedsStatsDocument, options);
      }
export function useDeedsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeedsStatsQuery, DeedsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeedsStatsQuery, DeedsStatsQueryVariables>(DeedsStatsDocument, options);
        }
export function useDeedsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeedsStatsQuery, DeedsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeedsStatsQuery, DeedsStatsQueryVariables>(DeedsStatsDocument, options);
        }
export type DeedsStatsQueryHookResult = ReturnType<typeof useDeedsStatsQuery>;
export type DeedsStatsLazyQueryHookResult = ReturnType<typeof useDeedsStatsLazyQuery>;
export type DeedsStatsSuspenseQueryHookResult = ReturnType<typeof useDeedsStatsSuspenseQuery>;
export type DeedsStatsQueryResult = Apollo.QueryResult<DeedsStatsQuery, DeedsStatsQueryVariables>;
export const ReceiptDocument = gql`
    query Receipt($where: ReceiptWhereInput, $orderBy: ReceiptOrderByWithRelationInput, $take: Int, $skip: Int) @api(name: graph) {
  receipts(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    ...ReceiptFragment
  }
}
    ${ReceiptFragmentFragmentDoc}`;

/**
 * __useReceiptQuery__
 *
 * To run a query within a React component, call `useReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useReceiptQuery(baseOptions?: Apollo.QueryHookOptions<ReceiptQuery, ReceiptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceiptQuery, ReceiptQueryVariables>(ReceiptDocument, options);
      }
export function useReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiptQuery, ReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceiptQuery, ReceiptQueryVariables>(ReceiptDocument, options);
        }
export function useReceiptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReceiptQuery, ReceiptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReceiptQuery, ReceiptQueryVariables>(ReceiptDocument, options);
        }
export type ReceiptQueryHookResult = ReturnType<typeof useReceiptQuery>;
export type ReceiptLazyQueryHookResult = ReturnType<typeof useReceiptLazyQuery>;
export type ReceiptSuspenseQueryHookResult = ReturnType<typeof useReceiptSuspenseQuery>;
export type ReceiptQueryResult = Apollo.QueryResult<ReceiptQuery, ReceiptQueryVariables>;
export const CreateDonationCreditSeedReceiptDocument = gql`
    mutation CreateDonationCreditSeedReceipt($importedUrl: String!, $donationCreditRuleId: String!, $createUsers: Boolean!, $note: String!, $notifyUser: Boolean!) @api(name: graph) {
  mutationCreateDonationCreditSeedReceipt(
    importedUrl: $importedUrl
    donationCreditRuleId: $donationCreditRuleId
    createUsers: $createUsers
    note: $note
    notifyUser: $notifyUser
  ) {
    ...ReceiptFragment
  }
}
    ${ReceiptFragmentFragmentDoc}`;
export type CreateDonationCreditSeedReceiptMutationFn = Apollo.MutationFunction<CreateDonationCreditSeedReceiptMutation, CreateDonationCreditSeedReceiptMutationVariables>;

/**
 * __useCreateDonationCreditSeedReceiptMutation__
 *
 * To run a mutation, you first call `useCreateDonationCreditSeedReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationCreditSeedReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationCreditSeedReceiptMutation, { data, loading, error }] = useCreateDonationCreditSeedReceiptMutation({
 *   variables: {
 *      importedUrl: // value for 'importedUrl'
 *      donationCreditRuleId: // value for 'donationCreditRuleId'
 *      createUsers: // value for 'createUsers'
 *      note: // value for 'note'
 *      notifyUser: // value for 'notifyUser'
 *   },
 * });
 */
export function useCreateDonationCreditSeedReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonationCreditSeedReceiptMutation, CreateDonationCreditSeedReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonationCreditSeedReceiptMutation, CreateDonationCreditSeedReceiptMutationVariables>(CreateDonationCreditSeedReceiptDocument, options);
      }
export type CreateDonationCreditSeedReceiptMutationHookResult = ReturnType<typeof useCreateDonationCreditSeedReceiptMutation>;
export type CreateDonationCreditSeedReceiptMutationResult = Apollo.MutationResult<CreateDonationCreditSeedReceiptMutation>;
export type CreateDonationCreditSeedReceiptMutationOptions = Apollo.BaseMutationOptions<CreateDonationCreditSeedReceiptMutation, CreateDonationCreditSeedReceiptMutationVariables>;
export const GetExternalMatchRequestRulesDocument = gql`
    query GetExternalMatchRequestRules @api(name: graph) {
  externalMatchRequestRules {
    id
    type
    active
    minAmount
    maxAmount
    confidenceScore {
      operator
      value
    }
    startingAt
    endingAt
    employeeLocations
  }
}
    `;

/**
 * __useGetExternalMatchRequestRulesQuery__
 *
 * To run a query within a React component, call `useGetExternalMatchRequestRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalMatchRequestRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalMatchRequestRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalMatchRequestRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>(GetExternalMatchRequestRulesDocument, options);
      }
export function useGetExternalMatchRequestRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>(GetExternalMatchRequestRulesDocument, options);
        }
export function useGetExternalMatchRequestRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>(GetExternalMatchRequestRulesDocument, options);
        }
export type GetExternalMatchRequestRulesQueryHookResult = ReturnType<typeof useGetExternalMatchRequestRulesQuery>;
export type GetExternalMatchRequestRulesLazyQueryHookResult = ReturnType<typeof useGetExternalMatchRequestRulesLazyQuery>;
export type GetExternalMatchRequestRulesSuspenseQueryHookResult = ReturnType<typeof useGetExternalMatchRequestRulesSuspenseQuery>;
export type GetExternalMatchRequestRulesQueryResult = Apollo.QueryResult<GetExternalMatchRequestRulesQuery, GetExternalMatchRequestRulesQueryVariables>;
export const SetExternalMatchRequestRulesDocument = gql`
    mutation SetExternalMatchRequestRules($rules: [ExternalMatchRequestRuleInput!]!) @api(name: graph) {
  setExternalMatchRequestRules(rules: $rules) {
    id
    type
    active
    minAmount
    maxAmount
    confidenceScore {
      operator
      value
    }
    startingAt
    endingAt
    employeeLocations
  }
}
    `;
export type SetExternalMatchRequestRulesMutationFn = Apollo.MutationFunction<SetExternalMatchRequestRulesMutation, SetExternalMatchRequestRulesMutationVariables>;

/**
 * __useSetExternalMatchRequestRulesMutation__
 *
 * To run a mutation, you first call `useSetExternalMatchRequestRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalMatchRequestRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExternalMatchRequestRulesMutation, { data, loading, error }] = useSetExternalMatchRequestRulesMutation({
 *   variables: {
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useSetExternalMatchRequestRulesMutation(baseOptions?: Apollo.MutationHookOptions<SetExternalMatchRequestRulesMutation, SetExternalMatchRequestRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetExternalMatchRequestRulesMutation, SetExternalMatchRequestRulesMutationVariables>(SetExternalMatchRequestRulesDocument, options);
      }
export type SetExternalMatchRequestRulesMutationHookResult = ReturnType<typeof useSetExternalMatchRequestRulesMutation>;
export type SetExternalMatchRequestRulesMutationResult = Apollo.MutationResult<SetExternalMatchRequestRulesMutation>;
export type SetExternalMatchRequestRulesMutationOptions = Apollo.BaseMutationOptions<SetExternalMatchRequestRulesMutation, SetExternalMatchRequestRulesMutationVariables>;
export const AddGivingAccountFundingTransactionDocument = gql`
    mutation addGivingAccountFundingTransaction($data: GivingAccountFundingCreateInputType!) @api(name: donationBatch) {
  createGivingAccountFunding(data: $data) {
    type
    id
    provider
    amount
    processedAt
    createdAt
    modifiedAt
    author
    note
    receiptUrl
    identifier
    GivingAccount {
      id
    }
  }
}
    `;
export type AddGivingAccountFundingTransactionMutationFn = Apollo.MutationFunction<AddGivingAccountFundingTransactionMutation, AddGivingAccountFundingTransactionMutationVariables>;

/**
 * __useAddGivingAccountFundingTransactionMutation__
 *
 * To run a mutation, you first call `useAddGivingAccountFundingTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGivingAccountFundingTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGivingAccountFundingTransactionMutation, { data, loading, error }] = useAddGivingAccountFundingTransactionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddGivingAccountFundingTransactionMutation(baseOptions?: Apollo.MutationHookOptions<AddGivingAccountFundingTransactionMutation, AddGivingAccountFundingTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGivingAccountFundingTransactionMutation, AddGivingAccountFundingTransactionMutationVariables>(AddGivingAccountFundingTransactionDocument, options);
      }
export type AddGivingAccountFundingTransactionMutationHookResult = ReturnType<typeof useAddGivingAccountFundingTransactionMutation>;
export type AddGivingAccountFundingTransactionMutationResult = Apollo.MutationResult<AddGivingAccountFundingTransactionMutation>;
export type AddGivingAccountFundingTransactionMutationOptions = Apollo.BaseMutationOptions<AddGivingAccountFundingTransactionMutation, AddGivingAccountFundingTransactionMutationVariables>;
export const GivingAccountSummaryDocument = gql`
    query givingAccountSummary($id: ID!) @api(name: donationBatch) {
  givingAccount(id: $id) {
    ...GivingAccountFragment
  }
  givingAccounts {
    id
  }
}
    ${GivingAccountFragmentFragmentDoc}`;

/**
 * __useGivingAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGivingAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGivingAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGivingAccountSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGivingAccountSummaryQuery(baseOptions: Apollo.QueryHookOptions<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables> & ({ variables: GivingAccountSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>(GivingAccountSummaryDocument, options);
      }
export function useGivingAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>(GivingAccountSummaryDocument, options);
        }
export function useGivingAccountSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>(GivingAccountSummaryDocument, options);
        }
export type GivingAccountSummaryQueryHookResult = ReturnType<typeof useGivingAccountSummaryQuery>;
export type GivingAccountSummaryLazyQueryHookResult = ReturnType<typeof useGivingAccountSummaryLazyQuery>;
export type GivingAccountSummarySuspenseQueryHookResult = ReturnType<typeof useGivingAccountSummarySuspenseQuery>;
export type GivingAccountSummaryQueryResult = Apollo.QueryResult<GivingAccountSummaryQuery, GivingAccountSummaryQueryVariables>;
export const GivingAccountTransactionsDocument = gql`
    query givingAccountTransactions($id: ID!, $createdAtSince: String, $createdAtTill: String) @api(name: donationBatch) {
  givingAccount(id: $id) {
    id
    name
    companyId
    transactions(createdAtSince: $createdAtSince, createdAtTill: $createdAtTill) {
      ... on GivingAccountFunding {
        __typename
        id
        identifier
        description
        amount
        createdAt
        processedAt
        provider
        balance
        note
      }
      ... on GivingAccountWithdrawal {
        __typename
        id
        amount
        createdAt
        processedAt
        balance
        identifier
        description
        provider
        currencyCode
        total
        totalAccountCurrency
        feeAmount
        feeAmountAccountCurrency
        status
        batchFilename
        note
      }
      ... on GivingAccountTransferOutbound {
        __typename
        id
        amount
        createdAt
        balance
        note
        GivingAccountTransferInbound {
          amount
          GivingAccount {
            id
            currencyCode
            provider
          }
        }
      }
      ... on GivingAccountTransferInbound {
        __typename
        id
        amount
        createdAt
        balance
        note
        GivingAccountTransferOutbound {
          amount
          GivingAccount {
            id
            currencyCode
            provider
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGivingAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useGivingAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGivingAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGivingAccountTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      createdAtSince: // value for 'createdAtSince'
 *      createdAtTill: // value for 'createdAtTill'
 *   },
 * });
 */
export function useGivingAccountTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables> & ({ variables: GivingAccountTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>(GivingAccountTransactionsDocument, options);
      }
export function useGivingAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>(GivingAccountTransactionsDocument, options);
        }
export function useGivingAccountTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>(GivingAccountTransactionsDocument, options);
        }
export type GivingAccountTransactionsQueryHookResult = ReturnType<typeof useGivingAccountTransactionsQuery>;
export type GivingAccountTransactionsLazyQueryHookResult = ReturnType<typeof useGivingAccountTransactionsLazyQuery>;
export type GivingAccountTransactionsSuspenseQueryHookResult = ReturnType<typeof useGivingAccountTransactionsSuspenseQuery>;
export type GivingAccountTransactionsQueryResult = Apollo.QueryResult<GivingAccountTransactionsQuery, GivingAccountTransactionsQueryVariables>;
export const UpdateGivingAccountDocument = gql`
    mutation updateGivingAccount($id: ID!, $name: String!) @api(name: donationBatch) {
  updateGivingAccount(id: $id, name: $name) {
    ...GivingAccountFragment
  }
}
    ${GivingAccountFragmentFragmentDoc}`;
export type UpdateGivingAccountMutationFn = Apollo.MutationFunction<UpdateGivingAccountMutation, UpdateGivingAccountMutationVariables>;

/**
 * __useUpdateGivingAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGivingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGivingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGivingAccountMutation, { data, loading, error }] = useUpdateGivingAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateGivingAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGivingAccountMutation, UpdateGivingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGivingAccountMutation, UpdateGivingAccountMutationVariables>(UpdateGivingAccountDocument, options);
      }
export type UpdateGivingAccountMutationHookResult = ReturnType<typeof useUpdateGivingAccountMutation>;
export type UpdateGivingAccountMutationResult = Apollo.MutationResult<UpdateGivingAccountMutation>;
export type UpdateGivingAccountMutationOptions = Apollo.BaseMutationOptions<UpdateGivingAccountMutation, UpdateGivingAccountMutationVariables>;
export const MarkGivingAccountWithdrawalAsPendingDocument = gql`
    mutation markGivingAccountWithdrawalAsPending($id: ID!) @api(name: donationBatch) {
  markGivingAccountWithdrawalAsPending(id: $id) {
    __typename
    id
    amount
    createdAt
    processedAt
    balance
    identifier
    provider
    currencyCode
    total
    totalAccountCurrency
    feeAmount
    feeAmountAccountCurrency
  }
}
    `;
export type MarkGivingAccountWithdrawalAsPendingMutationFn = Apollo.MutationFunction<MarkGivingAccountWithdrawalAsPendingMutation, MarkGivingAccountWithdrawalAsPendingMutationVariables>;

/**
 * __useMarkGivingAccountWithdrawalAsPendingMutation__
 *
 * To run a mutation, you first call `useMarkGivingAccountWithdrawalAsPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGivingAccountWithdrawalAsPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGivingAccountWithdrawalAsPendingMutation, { data, loading, error }] = useMarkGivingAccountWithdrawalAsPendingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkGivingAccountWithdrawalAsPendingMutation(baseOptions?: Apollo.MutationHookOptions<MarkGivingAccountWithdrawalAsPendingMutation, MarkGivingAccountWithdrawalAsPendingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkGivingAccountWithdrawalAsPendingMutation, MarkGivingAccountWithdrawalAsPendingMutationVariables>(MarkGivingAccountWithdrawalAsPendingDocument, options);
      }
export type MarkGivingAccountWithdrawalAsPendingMutationHookResult = ReturnType<typeof useMarkGivingAccountWithdrawalAsPendingMutation>;
export type MarkGivingAccountWithdrawalAsPendingMutationResult = Apollo.MutationResult<MarkGivingAccountWithdrawalAsPendingMutation>;
export type MarkGivingAccountWithdrawalAsPendingMutationOptions = Apollo.BaseMutationOptions<MarkGivingAccountWithdrawalAsPendingMutation, MarkGivingAccountWithdrawalAsPendingMutationVariables>;
export const MarkGivingAccountWithdrawalAsProcessedDocument = gql`
    mutation markGivingAccountWithdrawalAsProcessed($id: ID!, $data: GivingAccountWithdrawalMarkAsProcessedInputType!) @api(name: donationBatch) {
  markGivingAccountWithdrawalAsProcessed(id: $id, data: $data) {
    __typename
    id
    amount
    createdAt
    processedAt
    balance
    identifier
    provider
    currencyCode
    total
    totalAccountCurrency
    feeAmount
    feeAmountAccountCurrency
  }
}
    `;
export type MarkGivingAccountWithdrawalAsProcessedMutationFn = Apollo.MutationFunction<MarkGivingAccountWithdrawalAsProcessedMutation, MarkGivingAccountWithdrawalAsProcessedMutationVariables>;

/**
 * __useMarkGivingAccountWithdrawalAsProcessedMutation__
 *
 * To run a mutation, you first call `useMarkGivingAccountWithdrawalAsProcessedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGivingAccountWithdrawalAsProcessedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGivingAccountWithdrawalAsProcessedMutation, { data, loading, error }] = useMarkGivingAccountWithdrawalAsProcessedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMarkGivingAccountWithdrawalAsProcessedMutation(baseOptions?: Apollo.MutationHookOptions<MarkGivingAccountWithdrawalAsProcessedMutation, MarkGivingAccountWithdrawalAsProcessedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkGivingAccountWithdrawalAsProcessedMutation, MarkGivingAccountWithdrawalAsProcessedMutationVariables>(MarkGivingAccountWithdrawalAsProcessedDocument, options);
      }
export type MarkGivingAccountWithdrawalAsProcessedMutationHookResult = ReturnType<typeof useMarkGivingAccountWithdrawalAsProcessedMutation>;
export type MarkGivingAccountWithdrawalAsProcessedMutationResult = Apollo.MutationResult<MarkGivingAccountWithdrawalAsProcessedMutation>;
export type MarkGivingAccountWithdrawalAsProcessedMutationOptions = Apollo.BaseMutationOptions<MarkGivingAccountWithdrawalAsProcessedMutation, MarkGivingAccountWithdrawalAsProcessedMutationVariables>;
export const MarkGivingAccountWithdrawalAsReadyForProcessingDocument = gql`
    mutation markGivingAccountWithdrawalAsReadyForProcessing($id: ID!, $data: GivingAccountWithdrawalMarkAsReadyForProcessingInputType!) @api(name: donationBatch) {
  markGivingAccountWithdrawalAsReadyForProcessing(id: $id, data: $data) {
    __typename
    id
    amount
    createdAt
    processedAt
    balance
    identifier
    provider
    currencyCode
    total
    totalAccountCurrency
    feeAmount
    feeAmountAccountCurrency
  }
}
    `;
export type MarkGivingAccountWithdrawalAsReadyForProcessingMutationFn = Apollo.MutationFunction<MarkGivingAccountWithdrawalAsReadyForProcessingMutation, MarkGivingAccountWithdrawalAsReadyForProcessingMutationVariables>;

/**
 * __useMarkGivingAccountWithdrawalAsReadyForProcessingMutation__
 *
 * To run a mutation, you first call `useMarkGivingAccountWithdrawalAsReadyForProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGivingAccountWithdrawalAsReadyForProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGivingAccountWithdrawalAsReadyForProcessingMutation, { data, loading, error }] = useMarkGivingAccountWithdrawalAsReadyForProcessingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMarkGivingAccountWithdrawalAsReadyForProcessingMutation(baseOptions?: Apollo.MutationHookOptions<MarkGivingAccountWithdrawalAsReadyForProcessingMutation, MarkGivingAccountWithdrawalAsReadyForProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkGivingAccountWithdrawalAsReadyForProcessingMutation, MarkGivingAccountWithdrawalAsReadyForProcessingMutationVariables>(MarkGivingAccountWithdrawalAsReadyForProcessingDocument, options);
      }
export type MarkGivingAccountWithdrawalAsReadyForProcessingMutationHookResult = ReturnType<typeof useMarkGivingAccountWithdrawalAsReadyForProcessingMutation>;
export type MarkGivingAccountWithdrawalAsReadyForProcessingMutationResult = Apollo.MutationResult<MarkGivingAccountWithdrawalAsReadyForProcessingMutation>;
export type MarkGivingAccountWithdrawalAsReadyForProcessingMutationOptions = Apollo.BaseMutationOptions<MarkGivingAccountWithdrawalAsReadyForProcessingMutation, MarkGivingAccountWithdrawalAsReadyForProcessingMutationVariables>;
export const MarkGivingAccountWithdrawalAsProcessingDocument = gql`
    mutation markGivingAccountWithdrawalAsProcessing($id: ID!, $data: GivingAccountWithdrawalMarkAsProcessingInputType) @api(name: donationBatch) {
  markGivingAccountWithdrawalAsProcessing(id: $id, data: $data) {
    __typename
    id
    amount
    createdAt
    processedAt
    balance
    identifier
    provider
    currencyCode
    total
    totalAccountCurrency
    feeAmount
    feeAmountAccountCurrency
  }
}
    `;
export type MarkGivingAccountWithdrawalAsProcessingMutationFn = Apollo.MutationFunction<MarkGivingAccountWithdrawalAsProcessingMutation, MarkGivingAccountWithdrawalAsProcessingMutationVariables>;

/**
 * __useMarkGivingAccountWithdrawalAsProcessingMutation__
 *
 * To run a mutation, you first call `useMarkGivingAccountWithdrawalAsProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkGivingAccountWithdrawalAsProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markGivingAccountWithdrawalAsProcessingMutation, { data, loading, error }] = useMarkGivingAccountWithdrawalAsProcessingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMarkGivingAccountWithdrawalAsProcessingMutation(baseOptions?: Apollo.MutationHookOptions<MarkGivingAccountWithdrawalAsProcessingMutation, MarkGivingAccountWithdrawalAsProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkGivingAccountWithdrawalAsProcessingMutation, MarkGivingAccountWithdrawalAsProcessingMutationVariables>(MarkGivingAccountWithdrawalAsProcessingDocument, options);
      }
export type MarkGivingAccountWithdrawalAsProcessingMutationHookResult = ReturnType<typeof useMarkGivingAccountWithdrawalAsProcessingMutation>;
export type MarkGivingAccountWithdrawalAsProcessingMutationResult = Apollo.MutationResult<MarkGivingAccountWithdrawalAsProcessingMutation>;
export type MarkGivingAccountWithdrawalAsProcessingMutationOptions = Apollo.BaseMutationOptions<MarkGivingAccountWithdrawalAsProcessingMutation, MarkGivingAccountWithdrawalAsProcessingMutationVariables>;
export const GivingAccountsSummaryDocument = gql`
    query givingAccountsSummary @api(name: donationBatch) {
  givingAccounts {
    ...GivingAccountFragment
  }
}
    ${GivingAccountFragmentFragmentDoc}`;

/**
 * __useGivingAccountsSummaryQuery__
 *
 * To run a query within a React component, call `useGivingAccountsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGivingAccountsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGivingAccountsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGivingAccountsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>(GivingAccountsSummaryDocument, options);
      }
export function useGivingAccountsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>(GivingAccountsSummaryDocument, options);
        }
export function useGivingAccountsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>(GivingAccountsSummaryDocument, options);
        }
export type GivingAccountsSummaryQueryHookResult = ReturnType<typeof useGivingAccountsSummaryQuery>;
export type GivingAccountsSummaryLazyQueryHookResult = ReturnType<typeof useGivingAccountsSummaryLazyQuery>;
export type GivingAccountsSummarySuspenseQueryHookResult = ReturnType<typeof useGivingAccountsSummarySuspenseQuery>;
export type GivingAccountsSummaryQueryResult = Apollo.QueryResult<GivingAccountsSummaryQuery, GivingAccountsSummaryQueryVariables>;
export const CreateGivingAccountDocument = gql`
    mutation createGivingAccount($name: String!, $currencyCode: Currency!, $provider: ProviderType!) @api(name: donationBatch) {
  createGivingAccount(
    name: $name
    currencyCode: $currencyCode
    provider: $provider
  ) {
    ...GivingAccountFragment
  }
}
    ${GivingAccountFragmentFragmentDoc}`;
export type CreateGivingAccountMutationFn = Apollo.MutationFunction<CreateGivingAccountMutation, CreateGivingAccountMutationVariables>;

/**
 * __useCreateGivingAccountMutation__
 *
 * To run a mutation, you first call `useCreateGivingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGivingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGivingAccountMutation, { data, loading, error }] = useCreateGivingAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      currencyCode: // value for 'currencyCode'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useCreateGivingAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateGivingAccountMutation, CreateGivingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGivingAccountMutation, CreateGivingAccountMutationVariables>(CreateGivingAccountDocument, options);
      }
export type CreateGivingAccountMutationHookResult = ReturnType<typeof useCreateGivingAccountMutation>;
export type CreateGivingAccountMutationResult = Apollo.MutationResult<CreateGivingAccountMutation>;
export type CreateGivingAccountMutationOptions = Apollo.BaseMutationOptions<CreateGivingAccountMutation, CreateGivingAccountMutationVariables>;
export const InvoicesDocument = gql`
    query invoices($skip: Int, $take: Int, $status: InvoiceStatus, $type: DonationDisbursementType, $createdBefore: DateTime, $createdAfter: DateTime) @api(name: donationBatch) {
  invoices(
    skip: $skip
    take: $take
    status: $status
    type: $type
    createdBefore: $createdBefore
    createdAfter: $createdAfter
  ) {
    items {
      id
      types
      status
      createdAt
      amount
      currencyCode
      createdAt
      paymentDueDate
      status
      invoiceNumber
      invoiceLines {
        amount
        itemLabel
      }
      disbursementsDocumentURL
      invoiceDocumentURL
    }
    metadata {
      totalItems
      totalPages
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      createdBefore: // value for 'createdBefore'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const MarkInvoiceAsPaidDocument = gql`
    mutation markInvoiceAsPaid($invoiceId: ID!, $paymentDocumentURL: String!, $note: String, $processedAt: String!) @api(name: donationBatch) {
  markInvoiceAsPaid(
    invoiceId: $invoiceId
    paymentDocumentURL: $paymentDocumentURL
    note: $note
    processedAt: $processedAt
  ) {
    id
    status
    paidAt
  }
}
    `;
export type MarkInvoiceAsPaidMutationFn = Apollo.MutationFunction<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>;

/**
 * __useMarkInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidMutation, { data, loading, error }] = useMarkInvoiceAsPaidMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentDocumentURL: // value for 'paymentDocumentURL'
 *      note: // value for 'note'
 *      processedAt: // value for 'processedAt'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>(MarkInvoiceAsPaidDocument, options);
      }
export type MarkInvoiceAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationResult = Apollo.MutationResult<MarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>;
export const MarkInvoiceAsVoidedDocument = gql`
    mutation markInvoiceAsVoided($invoiceId: ID!) @api(name: donationBatch) {
  markInvoiceAsVoided(invoiceId: $invoiceId) {
    id
    status
    voidedAt
  }
}
    `;
export type MarkInvoiceAsVoidedMutationFn = Apollo.MutationFunction<MarkInvoiceAsVoidedMutation, MarkInvoiceAsVoidedMutationVariables>;

/**
 * __useMarkInvoiceAsVoidedMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsVoidedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsVoidedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsVoidedMutation, { data, loading, error }] = useMarkInvoiceAsVoidedMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsVoidedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsVoidedMutation, MarkInvoiceAsVoidedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsVoidedMutation, MarkInvoiceAsVoidedMutationVariables>(MarkInvoiceAsVoidedDocument, options);
      }
export type MarkInvoiceAsVoidedMutationHookResult = ReturnType<typeof useMarkInvoiceAsVoidedMutation>;
export type MarkInvoiceAsVoidedMutationResult = Apollo.MutationResult<MarkInvoiceAsVoidedMutation>;
export type MarkInvoiceAsVoidedMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsVoidedMutation, MarkInvoiceAsVoidedMutationVariables>;
export const MarkInvoiceAsSentDocument = gql`
    mutation markInvoiceAsSent($invoiceId: ID!) @api(name: donationBatch) {
  markInvoiceAsSent(invoiceId: $invoiceId) {
    id
    status
    sentAt
  }
}
    `;
export type MarkInvoiceAsSentMutationFn = Apollo.MutationFunction<MarkInvoiceAsSentMutation, MarkInvoiceAsSentMutationVariables>;

/**
 * __useMarkInvoiceAsSentMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsSentMutation, { data, loading, error }] = useMarkInvoiceAsSentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsSentMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsSentMutation, MarkInvoiceAsSentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsSentMutation, MarkInvoiceAsSentMutationVariables>(MarkInvoiceAsSentDocument, options);
      }
export type MarkInvoiceAsSentMutationHookResult = ReturnType<typeof useMarkInvoiceAsSentMutation>;
export type MarkInvoiceAsSentMutationResult = Apollo.MutationResult<MarkInvoiceAsSentMutation>;
export type MarkInvoiceAsSentMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsSentMutation, MarkInvoiceAsSentMutationVariables>;
export const HandleNonprofitNameChangeDocument = gql`
    mutation handleNonprofitNameChange($newName: String!, $ticketId: Int!, $nonprofitId: ID!) @api(name: nonprofit) {
  handleNonprofitNameChange(
    newName: $newName
    ticketId: $ticketId
    nonprofitId: $nonprofitId
  )
}
    `;
export type HandleNonprofitNameChangeMutationFn = Apollo.MutationFunction<HandleNonprofitNameChangeMutation, HandleNonprofitNameChangeMutationVariables>;

/**
 * __useHandleNonprofitNameChangeMutation__
 *
 * To run a mutation, you first call `useHandleNonprofitNameChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleNonprofitNameChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleNonprofitNameChangeMutation, { data, loading, error }] = useHandleNonprofitNameChangeMutation({
 *   variables: {
 *      newName: // value for 'newName'
 *      ticketId: // value for 'ticketId'
 *      nonprofitId: // value for 'nonprofitId'
 *   },
 * });
 */
export function useHandleNonprofitNameChangeMutation(baseOptions?: Apollo.MutationHookOptions<HandleNonprofitNameChangeMutation, HandleNonprofitNameChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleNonprofitNameChangeMutation, HandleNonprofitNameChangeMutationVariables>(HandleNonprofitNameChangeDocument, options);
      }
export type HandleNonprofitNameChangeMutationHookResult = ReturnType<typeof useHandleNonprofitNameChangeMutation>;
export type HandleNonprofitNameChangeMutationResult = Apollo.MutationResult<HandleNonprofitNameChangeMutation>;
export type HandleNonprofitNameChangeMutationOptions = Apollo.BaseMutationOptions<HandleNonprofitNameChangeMutation, HandleNonprofitNameChangeMutationVariables>;
export const NominationsCountDocument = gql`
    query nominationsCount($companyId: ID) @api(name: nonprofit) {
  nominationsCount(companyId: $companyId)
}
    `;

/**
 * __useNominationsCountQuery__
 *
 * To run a query within a React component, call `useNominationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNominationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNominationsCountQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useNominationsCountQuery(baseOptions?: Apollo.QueryHookOptions<NominationsCountQuery, NominationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NominationsCountQuery, NominationsCountQueryVariables>(NominationsCountDocument, options);
      }
export function useNominationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NominationsCountQuery, NominationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NominationsCountQuery, NominationsCountQueryVariables>(NominationsCountDocument, options);
        }
export function useNominationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NominationsCountQuery, NominationsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NominationsCountQuery, NominationsCountQueryVariables>(NominationsCountDocument, options);
        }
export type NominationsCountQueryHookResult = ReturnType<typeof useNominationsCountQuery>;
export type NominationsCountLazyQueryHookResult = ReturnType<typeof useNominationsCountLazyQuery>;
export type NominationsCountSuspenseQueryHookResult = ReturnType<typeof useNominationsCountSuspenseQuery>;
export type NominationsCountQueryResult = Apollo.QueryResult<NominationsCountQuery, NominationsCountQueryVariables>;
export const NonprofitNominationsDocument = gql`
    query nonprofitNominations($offset: Int, $limit: Int, $sortedBy: String, $order: String, $userId: ID, $companyId: ID) @api(name: nonprofit) {
  nonprofitNominations(
    offset: $offset
    limit: $limit
    sortedBy: $sortedBy
    order: $order
    userId: $userId
    companyId: $companyId
  ) {
    id
    userId
    User {
      fullName {
        first
        last
      }
    }
    companyId
    Company {
      name
    }
    nonprofitName
    ein
    ncesIdentifier
    nonprofitEntityType
    country
    email
    website
    phone
    engagementType
    otherNote
    internalNote
    status
    createdAt
    emails {
      nonprofitNominationOutreachInitial
      nonprofitNominationOutreachReminder
      nonprofitNominationOutreachFinal
    }
  }
}
    `;

/**
 * __useNonprofitNominationsQuery__
 *
 * To run a query within a React component, call `useNonprofitNominationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitNominationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitNominationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortedBy: // value for 'sortedBy'
 *      order: // value for 'order'
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useNonprofitNominationsQuery(baseOptions?: Apollo.QueryHookOptions<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>(NonprofitNominationsDocument, options);
      }
export function useNonprofitNominationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>(NonprofitNominationsDocument, options);
        }
export function useNonprofitNominationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>(NonprofitNominationsDocument, options);
        }
export type NonprofitNominationsQueryHookResult = ReturnType<typeof useNonprofitNominationsQuery>;
export type NonprofitNominationsLazyQueryHookResult = ReturnType<typeof useNonprofitNominationsLazyQuery>;
export type NonprofitNominationsSuspenseQueryHookResult = ReturnType<typeof useNonprofitNominationsSuspenseQuery>;
export type NonprofitNominationsQueryResult = Apollo.QueryResult<NonprofitNominationsQuery, NonprofitNominationsQueryVariables>;
export const OutreachNonprofitNominationDocument = gql`
    mutation outreachNonprofitNomination($nominationId: ID!, $emailId: OutreachEmailId!, $templateLocaleCode: String) @api(name: nonprofit) {
  outreachNonprofitNomination(
    id: $nominationId
    emailId: $emailId
    templateLocaleCode: $templateLocaleCode
  ) {
    id
    internalNote
    status
    emails {
      nonprofitNominationOutreachInitial
      nonprofitNominationOutreachReminder
      nonprofitNominationOutreachFinal
    }
  }
}
    `;
export type OutreachNonprofitNominationMutationFn = Apollo.MutationFunction<OutreachNonprofitNominationMutation, OutreachNonprofitNominationMutationVariables>;

/**
 * __useOutreachNonprofitNominationMutation__
 *
 * To run a mutation, you first call `useOutreachNonprofitNominationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOutreachNonprofitNominationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [outreachNonprofitNominationMutation, { data, loading, error }] = useOutreachNonprofitNominationMutation({
 *   variables: {
 *      nominationId: // value for 'nominationId'
 *      emailId: // value for 'emailId'
 *      templateLocaleCode: // value for 'templateLocaleCode'
 *   },
 * });
 */
export function useOutreachNonprofitNominationMutation(baseOptions?: Apollo.MutationHookOptions<OutreachNonprofitNominationMutation, OutreachNonprofitNominationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OutreachNonprofitNominationMutation, OutreachNonprofitNominationMutationVariables>(OutreachNonprofitNominationDocument, options);
      }
export type OutreachNonprofitNominationMutationHookResult = ReturnType<typeof useOutreachNonprofitNominationMutation>;
export type OutreachNonprofitNominationMutationResult = Apollo.MutationResult<OutreachNonprofitNominationMutation>;
export type OutreachNonprofitNominationMutationOptions = Apollo.BaseMutationOptions<OutreachNonprofitNominationMutation, OutreachNonprofitNominationMutationVariables>;
export const UpdateNonprofitNominationDocument = gql`
    mutation updateNonprofitNomination($updateNonprofitNominationId: ID!, $data: NonprofitNominationUpdateInputType!) @api(name: nonprofit) {
  updateNonprofitNomination(id: $updateNonprofitNominationId, data: $data) {
    id
    internalNote
    status
    emails {
      nonprofitNominationOutreachInitial
      nonprofitNominationOutreachReminder
      nonprofitNominationOutreachFinal
    }
  }
}
    `;
export type UpdateNonprofitNominationMutationFn = Apollo.MutationFunction<UpdateNonprofitNominationMutation, UpdateNonprofitNominationMutationVariables>;

/**
 * __useUpdateNonprofitNominationMutation__
 *
 * To run a mutation, you first call `useUpdateNonprofitNominationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNonprofitNominationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNonprofitNominationMutation, { data, loading, error }] = useUpdateNonprofitNominationMutation({
 *   variables: {
 *      updateNonprofitNominationId: // value for 'updateNonprofitNominationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNonprofitNominationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNonprofitNominationMutation, UpdateNonprofitNominationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNonprofitNominationMutation, UpdateNonprofitNominationMutationVariables>(UpdateNonprofitNominationDocument, options);
      }
export type UpdateNonprofitNominationMutationHookResult = ReturnType<typeof useUpdateNonprofitNominationMutation>;
export type UpdateNonprofitNominationMutationResult = Apollo.MutationResult<UpdateNonprofitNominationMutation>;
export type UpdateNonprofitNominationMutationOptions = Apollo.BaseMutationOptions<UpdateNonprofitNominationMutation, UpdateNonprofitNominationMutationVariables>;
export const NotificationSettingsPageDocument = gql`
    query notificationSettingsPage @api(name: graph) {
  organizationNotificationSettings {
    ...NotificationSettings
  }
  notificationMetadata {
    messages {
      id
      label
      unignorable
      category
      channel
    }
    categories {
      id
      label
    }
  }
}
    ${NotificationSettingsFragmentDoc}`;

/**
 * __useNotificationSettingsPageQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>(NotificationSettingsPageDocument, options);
      }
export function useNotificationSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>(NotificationSettingsPageDocument, options);
        }
export function useNotificationSettingsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>(NotificationSettingsPageDocument, options);
        }
export type NotificationSettingsPageQueryHookResult = ReturnType<typeof useNotificationSettingsPageQuery>;
export type NotificationSettingsPageLazyQueryHookResult = ReturnType<typeof useNotificationSettingsPageLazyQuery>;
export type NotificationSettingsPageSuspenseQueryHookResult = ReturnType<typeof useNotificationSettingsPageSuspenseQuery>;
export type NotificationSettingsPageQueryResult = Apollo.QueryResult<NotificationSettingsPageQuery, NotificationSettingsPageQueryVariables>;
export const EmailTemplateDocument = gql`
    query emailTemplate($id: String!) @api(name: graph) {
  emailTemplate(id: $id) {
    id
    subject
    preHeader
    bodyHtml
  }
}
    `;

/**
 * __useEmailTemplateQuery__
 *
 * To run a query within a React component, call `useEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables> & ({ variables: EmailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
      }
export function useEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
        }
export function useEmailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
        }
export type EmailTemplateQueryHookResult = ReturnType<typeof useEmailTemplateQuery>;
export type EmailTemplateLazyQueryHookResult = ReturnType<typeof useEmailTemplateLazyQuery>;
export type EmailTemplateSuspenseQueryHookResult = ReturnType<typeof useEmailTemplateSuspenseQuery>;
export type EmailTemplateQueryResult = Apollo.QueryResult<EmailTemplateQuery, EmailTemplateQueryVariables>;
export const SetOrganizationNotificationMessageSettingDocument = gql`
    mutation setOrganizationNotificationMessageSetting($channel: NotificationChannelType!, $messageId: IgnorableNotificationMessageIds!, $muted: Boolean!) @api(name: graph) {
  setOrganizationNotificationMessageSetting(
    channel: $channel
    messageId: $messageId
    muted: $muted
  ) {
    ...NotificationSettings
  }
}
    ${NotificationSettingsFragmentDoc}`;
export type SetOrganizationNotificationMessageSettingMutationFn = Apollo.MutationFunction<SetOrganizationNotificationMessageSettingMutation, SetOrganizationNotificationMessageSettingMutationVariables>;

/**
 * __useSetOrganizationNotificationMessageSettingMutation__
 *
 * To run a mutation, you first call `useSetOrganizationNotificationMessageSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationNotificationMessageSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationNotificationMessageSettingMutation, { data, loading, error }] = useSetOrganizationNotificationMessageSettingMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      messageId: // value for 'messageId'
 *      muted: // value for 'muted'
 *   },
 * });
 */
export function useSetOrganizationNotificationMessageSettingMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationNotificationMessageSettingMutation, SetOrganizationNotificationMessageSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationNotificationMessageSettingMutation, SetOrganizationNotificationMessageSettingMutationVariables>(SetOrganizationNotificationMessageSettingDocument, options);
      }
export type SetOrganizationNotificationMessageSettingMutationHookResult = ReturnType<typeof useSetOrganizationNotificationMessageSettingMutation>;
export type SetOrganizationNotificationMessageSettingMutationResult = Apollo.MutationResult<SetOrganizationNotificationMessageSettingMutation>;
export type SetOrganizationNotificationMessageSettingMutationOptions = Apollo.BaseMutationOptions<SetOrganizationNotificationMessageSettingMutation, SetOrganizationNotificationMessageSettingMutationVariables>;
export const SetOrganizationNotificationCategorySettingDocument = gql`
    mutation setOrganizationNotificationCategorySetting($channel: NotificationChannelType!, $categoryId: IgnorableNotificationMessageCategory!, $muted: Boolean!) @api(name: graph) {
  setOrganizationNotificationCategorySetting(
    channel: $channel
    categoryId: $categoryId
    muted: $muted
  ) {
    ...NotificationSettings
  }
}
    ${NotificationSettingsFragmentDoc}`;
export type SetOrganizationNotificationCategorySettingMutationFn = Apollo.MutationFunction<SetOrganizationNotificationCategorySettingMutation, SetOrganizationNotificationCategorySettingMutationVariables>;

/**
 * __useSetOrganizationNotificationCategorySettingMutation__
 *
 * To run a mutation, you first call `useSetOrganizationNotificationCategorySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationNotificationCategorySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationNotificationCategorySettingMutation, { data, loading, error }] = useSetOrganizationNotificationCategorySettingMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *      categoryId: // value for 'categoryId'
 *      muted: // value for 'muted'
 *   },
 * });
 */
export function useSetOrganizationNotificationCategorySettingMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationNotificationCategorySettingMutation, SetOrganizationNotificationCategorySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationNotificationCategorySettingMutation, SetOrganizationNotificationCategorySettingMutationVariables>(SetOrganizationNotificationCategorySettingDocument, options);
      }
export type SetOrganizationNotificationCategorySettingMutationHookResult = ReturnType<typeof useSetOrganizationNotificationCategorySettingMutation>;
export type SetOrganizationNotificationCategorySettingMutationResult = Apollo.MutationResult<SetOrganizationNotificationCategorySettingMutation>;
export type SetOrganizationNotificationCategorySettingMutationOptions = Apollo.BaseMutationOptions<SetOrganizationNotificationCategorySettingMutation, SetOrganizationNotificationCategorySettingMutationVariables>;
export const NonprofitInfoDocument = gql`
    query nonprofitInfo @api(name: nonprofit) {
  nonprofitInfo {
    hasVerifiedUsers
    verifiedUsers {
      email
    }
    hasAdmins
  }
}
    `;

/**
 * __useNonprofitInfoQuery__
 *
 * To run a query within a React component, call `useNonprofitInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useNonprofitInfoQuery(baseOptions?: Apollo.QueryHookOptions<NonprofitInfoQuery, NonprofitInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitInfoQuery, NonprofitInfoQueryVariables>(NonprofitInfoDocument, options);
      }
export function useNonprofitInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitInfoQuery, NonprofitInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitInfoQuery, NonprofitInfoQueryVariables>(NonprofitInfoDocument, options);
        }
export function useNonprofitInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonprofitInfoQuery, NonprofitInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonprofitInfoQuery, NonprofitInfoQueryVariables>(NonprofitInfoDocument, options);
        }
export type NonprofitInfoQueryHookResult = ReturnType<typeof useNonprofitInfoQuery>;
export type NonprofitInfoLazyQueryHookResult = ReturnType<typeof useNonprofitInfoLazyQuery>;
export type NonprofitInfoSuspenseQueryHookResult = ReturnType<typeof useNonprofitInfoSuspenseQuery>;
export type NonprofitInfoQueryResult = Apollo.QueryResult<NonprofitInfoQuery, NonprofitInfoQueryVariables>;
export const SearchOpportunitiesDocument = gql`
    query searchOpportunities($searchTerm: String, $offset: Int, $limit: Int, $types: [OpportunityType!], $dateFrom: String, $dateTo: String, $locations: [Area!], $categories: [String!], $providers: [OpportunityProvider!]) @api(name: opportunities) {
  searchOpportunities(
    searchTerm: $searchTerm
    offset: $offset
    limit: $limit
    types: $types
    dateFrom: $dateFrom
    dateTo: $dateTo
    locations: $locations
    categories: $categories
    providers: $providers
  ) {
    opportunities {
      providerId
      provider
      categories
      name
      description
      mustKnows
      duration
      pictures
      virtual
      type
      startingAt
      endingAt
      timeZone
      contact {
        name
        email
      }
      nonprofit {
        name
        pictures
      }
      externalLink
      location {
        address
        area
        city
        country
        countryCode
        postalCode
        state
        stateCode
      }
    }
    total
  }
}
    `;

/**
 * __useSearchOpportunitiesQuery__
 *
 * To run a query within a React component, call `useSearchOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOpportunitiesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      types: // value for 'types'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      locations: // value for 'locations'
 *      categories: // value for 'categories'
 *      providers: // value for 'providers'
 *   },
 * });
 */
export function useSearchOpportunitiesQuery(baseOptions?: Apollo.QueryHookOptions<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>(SearchOpportunitiesDocument, options);
      }
export function useSearchOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>(SearchOpportunitiesDocument, options);
        }
export function useSearchOpportunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>(SearchOpportunitiesDocument, options);
        }
export type SearchOpportunitiesQueryHookResult = ReturnType<typeof useSearchOpportunitiesQuery>;
export type SearchOpportunitiesLazyQueryHookResult = ReturnType<typeof useSearchOpportunitiesLazyQuery>;
export type SearchOpportunitiesSuspenseQueryHookResult = ReturnType<typeof useSearchOpportunitiesSuspenseQuery>;
export type SearchOpportunitiesQueryResult = Apollo.QueryResult<SearchOpportunitiesQuery, SearchOpportunitiesQueryVariables>;
export const ImportOpportunityDocument = gql`
    mutation importOpportunity($providerId: String!, $provider: OpportunityProvider!, $gooderaBookOpportunityPayload: GooderaBookOpportunityPayload) @api(name: opportunities) {
  importOpportunity(
    providerId: $providerId
    provider: $provider
    gooderaBookOpportunityPayload: $gooderaBookOpportunityPayload
  ) {
    id
  }
}
    `;
export type ImportOpportunityMutationFn = Apollo.MutationFunction<ImportOpportunityMutation, ImportOpportunityMutationVariables>;

/**
 * __useImportOpportunityMutation__
 *
 * To run a mutation, you first call `useImportOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOpportunityMutation, { data, loading, error }] = useImportOpportunityMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      provider: // value for 'provider'
 *      gooderaBookOpportunityPayload: // value for 'gooderaBookOpportunityPayload'
 *   },
 * });
 */
export function useImportOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<ImportOpportunityMutation, ImportOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOpportunityMutation, ImportOpportunityMutationVariables>(ImportOpportunityDocument, options);
      }
export type ImportOpportunityMutationHookResult = ReturnType<typeof useImportOpportunityMutation>;
export type ImportOpportunityMutationResult = Apollo.MutationResult<ImportOpportunityMutation>;
export type ImportOpportunityMutationOptions = Apollo.BaseMutationOptions<ImportOpportunityMutation, ImportOpportunityMutationVariables>;
export const AffiliationsCountDocument = gql`
    query affiliationsCount($nonprofitId: ID) @api(name: nonprofit) {
  affiliationsCount(nonprofitId: $nonprofitId)
}
    `;

/**
 * __useAffiliationsCountQuery__
 *
 * To run a query within a React component, call `useAffiliationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationsCountQuery({
 *   variables: {
 *      nonprofitId: // value for 'nonprofitId'
 *   },
 * });
 */
export function useAffiliationsCountQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationsCountQuery, AffiliationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationsCountQuery, AffiliationsCountQueryVariables>(AffiliationsCountDocument, options);
      }
export function useAffiliationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationsCountQuery, AffiliationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationsCountQuery, AffiliationsCountQueryVariables>(AffiliationsCountDocument, options);
        }
export function useAffiliationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationsCountQuery, AffiliationsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationsCountQuery, AffiliationsCountQueryVariables>(AffiliationsCountDocument, options);
        }
export type AffiliationsCountQueryHookResult = ReturnType<typeof useAffiliationsCountQuery>;
export type AffiliationsCountLazyQueryHookResult = ReturnType<typeof useAffiliationsCountLazyQuery>;
export type AffiliationsCountSuspenseQueryHookResult = ReturnType<typeof useAffiliationsCountSuspenseQuery>;
export type AffiliationsCountQueryResult = Apollo.QueryResult<AffiliationsCountQuery, AffiliationsCountQueryVariables>;
export const AffiliationsByNonprofitDocument = gql`
    query affiliationsByNonprofit($nonprofitId: String!, $offset: Int, $limit: Int) @api(name: nonprofit) {
  affiliationsByNonprofit(
    nonprofitId: $nonprofitId
    offset: $offset
    limit: $limit
  ) {
    id
    affiliationType
    userId
    User {
      fullName {
        first
        last
      }
    }
  }
}
    `;

/**
 * __useAffiliationsByNonprofitQuery__
 *
 * To run a query within a React component, call `useAffiliationsByNonprofitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationsByNonprofitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationsByNonprofitQuery({
 *   variables: {
 *      nonprofitId: // value for 'nonprofitId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAffiliationsByNonprofitQuery(baseOptions: Apollo.QueryHookOptions<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables> & ({ variables: AffiliationsByNonprofitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>(AffiliationsByNonprofitDocument, options);
      }
export function useAffiliationsByNonprofitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>(AffiliationsByNonprofitDocument, options);
        }
export function useAffiliationsByNonprofitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>(AffiliationsByNonprofitDocument, options);
        }
export type AffiliationsByNonprofitQueryHookResult = ReturnType<typeof useAffiliationsByNonprofitQuery>;
export type AffiliationsByNonprofitLazyQueryHookResult = ReturnType<typeof useAffiliationsByNonprofitLazyQuery>;
export type AffiliationsByNonprofitSuspenseQueryHookResult = ReturnType<typeof useAffiliationsByNonprofitSuspenseQuery>;
export type AffiliationsByNonprofitQueryResult = Apollo.QueryResult<AffiliationsByNonprofitQuery, AffiliationsByNonprofitQueryVariables>;
export const RequestNonprofitAddressChangeDocument = gql`
    mutation requestNonprofitAddressChange($newAddress: LocationInput!, $reason: String!) @api(name: nonprofit) {
  requestNonprofitAddressChange(newAddress: $newAddress, reason: $reason)
}
    `;
export type RequestNonprofitAddressChangeMutationFn = Apollo.MutationFunction<RequestNonprofitAddressChangeMutation, RequestNonprofitAddressChangeMutationVariables>;

/**
 * __useRequestNonprofitAddressChangeMutation__
 *
 * To run a mutation, you first call `useRequestNonprofitAddressChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNonprofitAddressChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNonprofitAddressChangeMutation, { data, loading, error }] = useRequestNonprofitAddressChangeMutation({
 *   variables: {
 *      newAddress: // value for 'newAddress'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestNonprofitAddressChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestNonprofitAddressChangeMutation, RequestNonprofitAddressChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNonprofitAddressChangeMutation, RequestNonprofitAddressChangeMutationVariables>(RequestNonprofitAddressChangeDocument, options);
      }
export type RequestNonprofitAddressChangeMutationHookResult = ReturnType<typeof useRequestNonprofitAddressChangeMutation>;
export type RequestNonprofitAddressChangeMutationResult = Apollo.MutationResult<RequestNonprofitAddressChangeMutation>;
export type RequestNonprofitAddressChangeMutationOptions = Apollo.BaseMutationOptions<RequestNonprofitAddressChangeMutation, RequestNonprofitAddressChangeMutationVariables>;
export const RequestNonprofitNameChangeDocument = gql`
    mutation requestNonprofitNameChange($newName: String!, $reason: String!) @api(name: nonprofit) {
  requestNonprofitNameChange(newName: $newName, reason: $reason)
}
    `;
export type RequestNonprofitNameChangeMutationFn = Apollo.MutationFunction<RequestNonprofitNameChangeMutation, RequestNonprofitNameChangeMutationVariables>;

/**
 * __useRequestNonprofitNameChangeMutation__
 *
 * To run a mutation, you first call `useRequestNonprofitNameChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNonprofitNameChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNonprofitNameChangeMutation, { data, loading, error }] = useRequestNonprofitNameChangeMutation({
 *   variables: {
 *      newName: // value for 'newName'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestNonprofitNameChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestNonprofitNameChangeMutation, RequestNonprofitNameChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNonprofitNameChangeMutation, RequestNonprofitNameChangeMutationVariables>(RequestNonprofitNameChangeDocument, options);
      }
export type RequestNonprofitNameChangeMutationHookResult = ReturnType<typeof useRequestNonprofitNameChangeMutation>;
export type RequestNonprofitNameChangeMutationResult = Apollo.MutationResult<RequestNonprofitNameChangeMutation>;
export type RequestNonprofitNameChangeMutationOptions = Apollo.BaseMutationOptions<RequestNonprofitNameChangeMutation, RequestNonprofitNameChangeMutationVariables>;
export const VerifyOrganizerUserByDeedDocument = gql`
    mutation verifyOrganizerUserByDeed($userId: String!, $note: String) @api(name: nonprofit) {
  verifyOrganizerUserByDeed(userId: $userId, note: $note)
}
    `;
export type VerifyOrganizerUserByDeedMutationFn = Apollo.MutationFunction<VerifyOrganizerUserByDeedMutation, VerifyOrganizerUserByDeedMutationVariables>;

/**
 * __useVerifyOrganizerUserByDeedMutation__
 *
 * To run a mutation, you first call `useVerifyOrganizerUserByDeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOrganizerUserByDeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOrganizerUserByDeedMutation, { data, loading, error }] = useVerifyOrganizerUserByDeedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useVerifyOrganizerUserByDeedMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOrganizerUserByDeedMutation, VerifyOrganizerUserByDeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOrganizerUserByDeedMutation, VerifyOrganizerUserByDeedMutationVariables>(VerifyOrganizerUserByDeedDocument, options);
      }
export type VerifyOrganizerUserByDeedMutationHookResult = ReturnType<typeof useVerifyOrganizerUserByDeedMutation>;
export type VerifyOrganizerUserByDeedMutationResult = Apollo.MutationResult<VerifyOrganizerUserByDeedMutation>;
export type VerifyOrganizerUserByDeedMutationOptions = Apollo.BaseMutationOptions<VerifyOrganizerUserByDeedMutation, VerifyOrganizerUserByDeedMutationVariables>;
export const PayrollRunsListDocument = gql`
    query payrollRunsList @api(name: payroll) {
  payrollRuns {
    id
    runState
    startDate
    payDate
    endDate
    checkDate
    stats {
      donationCount
      deductionIntent
      deductionActual
    }
  }
}
    `;

/**
 * __usePayrollRunsListQuery__
 *
 * To run a query within a React component, call `usePayrollRunsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollRunsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollRunsListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayrollRunsListQuery(baseOptions?: Apollo.QueryHookOptions<PayrollRunsListQuery, PayrollRunsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollRunsListQuery, PayrollRunsListQueryVariables>(PayrollRunsListDocument, options);
      }
export function usePayrollRunsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollRunsListQuery, PayrollRunsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollRunsListQuery, PayrollRunsListQueryVariables>(PayrollRunsListDocument, options);
        }
export function usePayrollRunsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollRunsListQuery, PayrollRunsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollRunsListQuery, PayrollRunsListQueryVariables>(PayrollRunsListDocument, options);
        }
export type PayrollRunsListQueryHookResult = ReturnType<typeof usePayrollRunsListQuery>;
export type PayrollRunsListLazyQueryHookResult = ReturnType<typeof usePayrollRunsListLazyQuery>;
export type PayrollRunsListSuspenseQueryHookResult = ReturnType<typeof usePayrollRunsListSuspenseQuery>;
export type PayrollRunsListQueryResult = Apollo.QueryResult<PayrollRunsListQuery, PayrollRunsListQueryVariables>;
export const RecreateDonationForTheNextPayrollRunDocument = gql`
    mutation recreateDonationForTheNextPayrollRun($recreateDonationForTheNextPayrollRunId: ID!) @api(name: payroll) {
  recreateDonationForTheNextPayrollRun(
    id: $recreateDonationForTheNextPayrollRunId
  )
}
    `;
export type RecreateDonationForTheNextPayrollRunMutationFn = Apollo.MutationFunction<RecreateDonationForTheNextPayrollRunMutation, RecreateDonationForTheNextPayrollRunMutationVariables>;

/**
 * __useRecreateDonationForTheNextPayrollRunMutation__
 *
 * To run a mutation, you first call `useRecreateDonationForTheNextPayrollRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateDonationForTheNextPayrollRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateDonationForTheNextPayrollRunMutation, { data, loading, error }] = useRecreateDonationForTheNextPayrollRunMutation({
 *   variables: {
 *      recreateDonationForTheNextPayrollRunId: // value for 'recreateDonationForTheNextPayrollRunId'
 *   },
 * });
 */
export function useRecreateDonationForTheNextPayrollRunMutation(baseOptions?: Apollo.MutationHookOptions<RecreateDonationForTheNextPayrollRunMutation, RecreateDonationForTheNextPayrollRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecreateDonationForTheNextPayrollRunMutation, RecreateDonationForTheNextPayrollRunMutationVariables>(RecreateDonationForTheNextPayrollRunDocument, options);
      }
export type RecreateDonationForTheNextPayrollRunMutationHookResult = ReturnType<typeof useRecreateDonationForTheNextPayrollRunMutation>;
export type RecreateDonationForTheNextPayrollRunMutationResult = Apollo.MutationResult<RecreateDonationForTheNextPayrollRunMutation>;
export type RecreateDonationForTheNextPayrollRunMutationOptions = Apollo.BaseMutationOptions<RecreateDonationForTheNextPayrollRunMutation, RecreateDonationForTheNextPayrollRunMutationVariables>;
export const PayrollRunsFlatFileListDocument = gql`
    query payrollRunsFlatFileList($payrollPayGroupId: ID!, $status: String) @api(name: payroll) {
  payrollRunsFlatFile(payrollPayGroupId: $payrollPayGroupId, status: $status) {
    id
    companyId
    payrollPayGroupId
    runState
    startDate
    payDate
    endDate
    modifiedAt
    startDateExternal
    endDateExternal
    stats {
      donationCount
      donationCountPendingOrUnresolved
      totalUsd
      donationCountSuccess
      totalUsdSuccess
      isDonatable
    }
  }
}
    `;

/**
 * __usePayrollRunsFlatFileListQuery__
 *
 * To run a query within a React component, call `usePayrollRunsFlatFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollRunsFlatFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollRunsFlatFileListQuery({
 *   variables: {
 *      payrollPayGroupId: // value for 'payrollPayGroupId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function usePayrollRunsFlatFileListQuery(baseOptions: Apollo.QueryHookOptions<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables> & ({ variables: PayrollRunsFlatFileListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>(PayrollRunsFlatFileListDocument, options);
      }
export function usePayrollRunsFlatFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>(PayrollRunsFlatFileListDocument, options);
        }
export function usePayrollRunsFlatFileListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>(PayrollRunsFlatFileListDocument, options);
        }
export type PayrollRunsFlatFileListQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListQuery>;
export type PayrollRunsFlatFileListLazyQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListLazyQuery>;
export type PayrollRunsFlatFileListSuspenseQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListSuspenseQuery>;
export type PayrollRunsFlatFileListQueryResult = Apollo.QueryResult<PayrollRunsFlatFileListQuery, PayrollRunsFlatFileListQueryVariables>;
export const PayrollRunsFlatFileListWithPaginationDocument = gql`
    query payrollRunsFlatFileListWithPagination($payrollPayGroupId: ID!, $status: String, $take: Int!, $skip: Int!) @api(name: payroll) {
  payrollRunsFlatFileWithPagination(
    payrollPayGroupId: $payrollPayGroupId
    status: $status
    take: $take
    skip: $skip
  ) {
    metadata {
      totalItems
      totalPages
      take
      skip
    }
    items {
      id
      companyId
      payrollPayGroupId
      runState
      startDate
      payDate
      endDate
      modifiedAt
      startDateExternal
      endDateExternal
      stats {
        donationCount
        donationCountPendingOrUnresolved
        totalUsd
        donationCountSuccess
        totalUsdSuccess
        isDonatable
      }
    }
  }
}
    `;

/**
 * __usePayrollRunsFlatFileListWithPaginationQuery__
 *
 * To run a query within a React component, call `usePayrollRunsFlatFileListWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollRunsFlatFileListWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollRunsFlatFileListWithPaginationQuery({
 *   variables: {
 *      payrollPayGroupId: // value for 'payrollPayGroupId'
 *      status: // value for 'status'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePayrollRunsFlatFileListWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables> & ({ variables: PayrollRunsFlatFileListWithPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>(PayrollRunsFlatFileListWithPaginationDocument, options);
      }
export function usePayrollRunsFlatFileListWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>(PayrollRunsFlatFileListWithPaginationDocument, options);
        }
export function usePayrollRunsFlatFileListWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>(PayrollRunsFlatFileListWithPaginationDocument, options);
        }
export type PayrollRunsFlatFileListWithPaginationQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListWithPaginationQuery>;
export type PayrollRunsFlatFileListWithPaginationLazyQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListWithPaginationLazyQuery>;
export type PayrollRunsFlatFileListWithPaginationSuspenseQueryHookResult = ReturnType<typeof usePayrollRunsFlatFileListWithPaginationSuspenseQuery>;
export type PayrollRunsFlatFileListWithPaginationQueryResult = Apollo.QueryResult<PayrollRunsFlatFileListWithPaginationQuery, PayrollRunsFlatFileListWithPaginationQueryVariables>;
export const PayrollPayGroupsDocument = gql`
    query payrollPayGroups @api(name: payroll) {
  payrollPayGroups {
    id
    payGroupDisplayName
  }
}
    `;

/**
 * __usePayrollPayGroupsQuery__
 *
 * To run a query within a React component, call `usePayrollPayGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollPayGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollPayGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayrollPayGroupsQuery(baseOptions?: Apollo.QueryHookOptions<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>(PayrollPayGroupsDocument, options);
      }
export function usePayrollPayGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>(PayrollPayGroupsDocument, options);
        }
export function usePayrollPayGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>(PayrollPayGroupsDocument, options);
        }
export type PayrollPayGroupsQueryHookResult = ReturnType<typeof usePayrollPayGroupsQuery>;
export type PayrollPayGroupsLazyQueryHookResult = ReturnType<typeof usePayrollPayGroupsLazyQuery>;
export type PayrollPayGroupsSuspenseQueryHookResult = ReturnType<typeof usePayrollPayGroupsSuspenseQuery>;
export type PayrollPayGroupsQueryResult = Apollo.QueryResult<PayrollPayGroupsQuery, PayrollPayGroupsQueryVariables>;
export const PayrollRunFlatFileDocument = gql`
    query payrollRunFlatFile($id: ID!, $payrollPayGroupId: ID!) @api(name: payroll) {
  payrollPayGroup(id: $payrollPayGroupId) {
    id
    payGroupDisplayName
  }
  payrollRunFlatFile(id: $id) {
    id
    companyId
    payrollPayGroupId
    runState
    startDate
    payDate
    endDate
    modifiedAt
    startDateExternal
    endDateExternal
    stats {
      donationCount
      donationCountPendingOrUnresolved
      totalUsd
      donationCountSuccess
      totalUsdSuccess
      isDonatable
    }
  }
}
    `;

/**
 * __usePayrollRunFlatFileQuery__
 *
 * To run a query within a React component, call `usePayrollRunFlatFileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollRunFlatFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollRunFlatFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      payrollPayGroupId: // value for 'payrollPayGroupId'
 *   },
 * });
 */
export function usePayrollRunFlatFileQuery(baseOptions: Apollo.QueryHookOptions<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables> & ({ variables: PayrollRunFlatFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>(PayrollRunFlatFileDocument, options);
      }
export function usePayrollRunFlatFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>(PayrollRunFlatFileDocument, options);
        }
export function usePayrollRunFlatFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>(PayrollRunFlatFileDocument, options);
        }
export type PayrollRunFlatFileQueryHookResult = ReturnType<typeof usePayrollRunFlatFileQuery>;
export type PayrollRunFlatFileLazyQueryHookResult = ReturnType<typeof usePayrollRunFlatFileLazyQuery>;
export type PayrollRunFlatFileSuspenseQueryHookResult = ReturnType<typeof usePayrollRunFlatFileSuspenseQuery>;
export type PayrollRunFlatFileQueryResult = Apollo.QueryResult<PayrollRunFlatFileQuery, PayrollRunFlatFileQueryVariables>;
export const PayrollRunFlatFileDonationsDocument = gql`
    query payrollRunFlatFileDonations($payrollRunFlatFileId: ID!, $take: Int, $skip: Int, $paymentStatuses: [String!], $frequency: String, $employeeTerm: String, $nonprofitTerm: String) @api(name: payroll) {
  payrollRunFlatFile(id: $payrollRunFlatFileId) {
    id
    donations(
      take: $take
      skip: $skip
      frequency: $frequency
      paymentStatuses: $paymentStatuses
      employeeTerm: $employeeTerm
      nonprofitTerm: $nonprofitTerm
    ) {
      count
      items {
        id
        donationSchedule
        rescheduledFrom
        total
        currency
        status
        rescheduledTo
        executionFailure {
          errorCode
          date
        }
        amountCurrencies
        userId
        User {
          id
          mainPicture
          preferredName {
            first
            last
          }
          fullName {
            first
            last
          }
        }
        nonprofits
        Nonprofits {
          id
          name
          mainPicture
        }
        DonationSchedule {
          frequency
        }
      }
    }
  }
}
    `;

/**
 * __usePayrollRunFlatFileDonationsQuery__
 *
 * To run a query within a React component, call `usePayrollRunFlatFileDonationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollRunFlatFileDonationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollRunFlatFileDonationsQuery({
 *   variables: {
 *      payrollRunFlatFileId: // value for 'payrollRunFlatFileId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      paymentStatuses: // value for 'paymentStatuses'
 *      frequency: // value for 'frequency'
 *      employeeTerm: // value for 'employeeTerm'
 *      nonprofitTerm: // value for 'nonprofitTerm'
 *   },
 * });
 */
export function usePayrollRunFlatFileDonationsQuery(baseOptions: Apollo.QueryHookOptions<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables> & ({ variables: PayrollRunFlatFileDonationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>(PayrollRunFlatFileDonationsDocument, options);
      }
export function usePayrollRunFlatFileDonationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>(PayrollRunFlatFileDonationsDocument, options);
        }
export function usePayrollRunFlatFileDonationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>(PayrollRunFlatFileDonationsDocument, options);
        }
export type PayrollRunFlatFileDonationsQueryHookResult = ReturnType<typeof usePayrollRunFlatFileDonationsQuery>;
export type PayrollRunFlatFileDonationsLazyQueryHookResult = ReturnType<typeof usePayrollRunFlatFileDonationsLazyQuery>;
export type PayrollRunFlatFileDonationsSuspenseQueryHookResult = ReturnType<typeof usePayrollRunFlatFileDonationsSuspenseQuery>;
export type PayrollRunFlatFileDonationsQueryResult = Apollo.QueryResult<PayrollRunFlatFileDonationsQuery, PayrollRunFlatFileDonationsQueryVariables>;
export const RecreateDonationForTheNextPayrollRunFlatFileDocument = gql`
    mutation recreateDonationForTheNextPayrollRunFlatFile($donationId: ID!, $shouldCancel: Boolean!, $markAsResolved: Boolean) @api(name: payroll) {
  recreateDonationForTheNextPayrollRunFlatFile(
    donationId: $donationId
    shouldCancel: $shouldCancel
    markAsResolved: $markAsResolved
  )
}
    `;
export type RecreateDonationForTheNextPayrollRunFlatFileMutationFn = Apollo.MutationFunction<RecreateDonationForTheNextPayrollRunFlatFileMutation, RecreateDonationForTheNextPayrollRunFlatFileMutationVariables>;

/**
 * __useRecreateDonationForTheNextPayrollRunFlatFileMutation__
 *
 * To run a mutation, you first call `useRecreateDonationForTheNextPayrollRunFlatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateDonationForTheNextPayrollRunFlatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateDonationForTheNextPayrollRunFlatFileMutation, { data, loading, error }] = useRecreateDonationForTheNextPayrollRunFlatFileMutation({
 *   variables: {
 *      donationId: // value for 'donationId'
 *      shouldCancel: // value for 'shouldCancel'
 *      markAsResolved: // value for 'markAsResolved'
 *   },
 * });
 */
export function useRecreateDonationForTheNextPayrollRunFlatFileMutation(baseOptions?: Apollo.MutationHookOptions<RecreateDonationForTheNextPayrollRunFlatFileMutation, RecreateDonationForTheNextPayrollRunFlatFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecreateDonationForTheNextPayrollRunFlatFileMutation, RecreateDonationForTheNextPayrollRunFlatFileMutationVariables>(RecreateDonationForTheNextPayrollRunFlatFileDocument, options);
      }
export type RecreateDonationForTheNextPayrollRunFlatFileMutationHookResult = ReturnType<typeof useRecreateDonationForTheNextPayrollRunFlatFileMutation>;
export type RecreateDonationForTheNextPayrollRunFlatFileMutationResult = Apollo.MutationResult<RecreateDonationForTheNextPayrollRunFlatFileMutation>;
export type RecreateDonationForTheNextPayrollRunFlatFileMutationOptions = Apollo.BaseMutationOptions<RecreateDonationForTheNextPayrollRunFlatFileMutation, RecreateDonationForTheNextPayrollRunFlatFileMutationVariables>;
export const NonprofitDocument = gql`
    query nonprofit($organizationId: String) @api(name: nonprofit) {
  nonprofit(organizationId: $organizationId) {
    id
    nonprofitId
    name
    ein
    locationObject {
      address
      city
      state
      postalCode
      country
      countryCode
    }
  }
}
    `;

/**
 * __useNonprofitQuery__
 *
 * To run a query within a React component, call `useNonprofitQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useNonprofitQuery(baseOptions?: Apollo.QueryHookOptions<NonprofitQuery, NonprofitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitQuery, NonprofitQueryVariables>(NonprofitDocument, options);
      }
export function useNonprofitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitQuery, NonprofitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitQuery, NonprofitQueryVariables>(NonprofitDocument, options);
        }
export function useNonprofitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonprofitQuery, NonprofitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonprofitQuery, NonprofitQueryVariables>(NonprofitDocument, options);
        }
export type NonprofitQueryHookResult = ReturnType<typeof useNonprofitQuery>;
export type NonprofitLazyQueryHookResult = ReturnType<typeof useNonprofitLazyQuery>;
export type NonprofitSuspenseQueryHookResult = ReturnType<typeof useNonprofitSuspenseQuery>;
export type NonprofitQueryResult = Apollo.QueryResult<NonprofitQuery, NonprofitQueryVariables>;
export const AvailableReportsDocument = gql`
    query availableReports @api(name: report) {
  reports: listSigmaReports {
    type
  }
}
    `;

/**
 * __useAvailableReportsQuery__
 *
 * To run a query within a React component, call `useAvailableReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableReportsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableReportsQuery, AvailableReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableReportsQuery, AvailableReportsQueryVariables>(AvailableReportsDocument, options);
      }
export function useAvailableReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableReportsQuery, AvailableReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableReportsQuery, AvailableReportsQueryVariables>(AvailableReportsDocument, options);
        }
export function useAvailableReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableReportsQuery, AvailableReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableReportsQuery, AvailableReportsQueryVariables>(AvailableReportsDocument, options);
        }
export type AvailableReportsQueryHookResult = ReturnType<typeof useAvailableReportsQuery>;
export type AvailableReportsLazyQueryHookResult = ReturnType<typeof useAvailableReportsLazyQuery>;
export type AvailableReportsSuspenseQueryHookResult = ReturnType<typeof useAvailableReportsSuspenseQuery>;
export type AvailableReportsQueryResult = Apollo.QueryResult<AvailableReportsQuery, AvailableReportsQueryVariables>;
export const SetPayrollFlatFileSftpConfigDocument = gql`
    mutation setPayrollFlatFileSftpConfig($data: SftpConfigSetInput!) @api(name: payroll) {
  setPayrollFlatFileSftpConfig(data: $data) {
    host
    username
    port
    isSecretSet
  }
}
    `;
export type SetPayrollFlatFileSftpConfigMutationFn = Apollo.MutationFunction<SetPayrollFlatFileSftpConfigMutation, SetPayrollFlatFileSftpConfigMutationVariables>;

/**
 * __useSetPayrollFlatFileSftpConfigMutation__
 *
 * To run a mutation, you first call `useSetPayrollFlatFileSftpConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPayrollFlatFileSftpConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPayrollFlatFileSftpConfigMutation, { data, loading, error }] = useSetPayrollFlatFileSftpConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetPayrollFlatFileSftpConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetPayrollFlatFileSftpConfigMutation, SetPayrollFlatFileSftpConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPayrollFlatFileSftpConfigMutation, SetPayrollFlatFileSftpConfigMutationVariables>(SetPayrollFlatFileSftpConfigDocument, options);
      }
export type SetPayrollFlatFileSftpConfigMutationHookResult = ReturnType<typeof useSetPayrollFlatFileSftpConfigMutation>;
export type SetPayrollFlatFileSftpConfigMutationResult = Apollo.MutationResult<SetPayrollFlatFileSftpConfigMutation>;
export type SetPayrollFlatFileSftpConfigMutationOptions = Apollo.BaseMutationOptions<SetPayrollFlatFileSftpConfigMutation, SetPayrollFlatFileSftpConfigMutationVariables>;
export const DeletePayrollFlatFileSftpConfigDocument = gql`
    mutation deletePayrollFlatFileSftpConfig @api(name: payroll) {
  deletePayrollFlatFileSftpConfig
}
    `;
export type DeletePayrollFlatFileSftpConfigMutationFn = Apollo.MutationFunction<DeletePayrollFlatFileSftpConfigMutation, DeletePayrollFlatFileSftpConfigMutationVariables>;

/**
 * __useDeletePayrollFlatFileSftpConfigMutation__
 *
 * To run a mutation, you first call `useDeletePayrollFlatFileSftpConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollFlatFileSftpConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollFlatFileSftpConfigMutation, { data, loading, error }] = useDeletePayrollFlatFileSftpConfigMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeletePayrollFlatFileSftpConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollFlatFileSftpConfigMutation, DeletePayrollFlatFileSftpConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollFlatFileSftpConfigMutation, DeletePayrollFlatFileSftpConfigMutationVariables>(DeletePayrollFlatFileSftpConfigDocument, options);
      }
export type DeletePayrollFlatFileSftpConfigMutationHookResult = ReturnType<typeof useDeletePayrollFlatFileSftpConfigMutation>;
export type DeletePayrollFlatFileSftpConfigMutationResult = Apollo.MutationResult<DeletePayrollFlatFileSftpConfigMutation>;
export type DeletePayrollFlatFileSftpConfigMutationOptions = Apollo.BaseMutationOptions<DeletePayrollFlatFileSftpConfigMutation, DeletePayrollFlatFileSftpConfigMutationVariables>;
export const PayrollFlatFileSftpConfigDocument = gql`
    query payrollFlatFileSftpConfig @api(name: payroll) {
  payrollFlatFileSftpConfig {
    host
    username
    port
    isSecretSet
  }
}
    `;

/**
 * __usePayrollFlatFileSftpConfigQuery__
 *
 * To run a query within a React component, call `usePayrollFlatFileSftpConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollFlatFileSftpConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollFlatFileSftpConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayrollFlatFileSftpConfigQuery(baseOptions?: Apollo.QueryHookOptions<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>(PayrollFlatFileSftpConfigDocument, options);
      }
export function usePayrollFlatFileSftpConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>(PayrollFlatFileSftpConfigDocument, options);
        }
export function usePayrollFlatFileSftpConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>(PayrollFlatFileSftpConfigDocument, options);
        }
export type PayrollFlatFileSftpConfigQueryHookResult = ReturnType<typeof usePayrollFlatFileSftpConfigQuery>;
export type PayrollFlatFileSftpConfigLazyQueryHookResult = ReturnType<typeof usePayrollFlatFileSftpConfigLazyQuery>;
export type PayrollFlatFileSftpConfigSuspenseQueryHookResult = ReturnType<typeof usePayrollFlatFileSftpConfigSuspenseQuery>;
export type PayrollFlatFileSftpConfigQueryResult = Apollo.QueryResult<PayrollFlatFileSftpConfigQuery, PayrollFlatFileSftpConfigQueryVariables>;
export const SigmaDashboardByTypeDocument = gql`
    query sigmaDashboardByType($type: ExternalDashboardType!) @api(name: report) {
  getSigmaDashboard(type: $type) {
    id
    dashboardId
    sigmaUrl
    type
  }
}
    `;

/**
 * __useSigmaDashboardByTypeQuery__
 *
 * To run a query within a React component, call `useSigmaDashboardByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSigmaDashboardByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSigmaDashboardByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSigmaDashboardByTypeQuery(baseOptions: Apollo.QueryHookOptions<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables> & ({ variables: SigmaDashboardByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>(SigmaDashboardByTypeDocument, options);
      }
export function useSigmaDashboardByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>(SigmaDashboardByTypeDocument, options);
        }
export function useSigmaDashboardByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>(SigmaDashboardByTypeDocument, options);
        }
export type SigmaDashboardByTypeQueryHookResult = ReturnType<typeof useSigmaDashboardByTypeQuery>;
export type SigmaDashboardByTypeLazyQueryHookResult = ReturnType<typeof useSigmaDashboardByTypeLazyQuery>;
export type SigmaDashboardByTypeSuspenseQueryHookResult = ReturnType<typeof useSigmaDashboardByTypeSuspenseQuery>;
export type SigmaDashboardByTypeQueryResult = Apollo.QueryResult<SigmaDashboardByTypeQuery, SigmaDashboardByTypeQueryVariables>;
export const SigmaReportByTypeDocument = gql`
    query sigmaReportByType($type: ExternalReportType!) @api(name: report) {
  getSigmaReport(type: $type) {
    id
    reportId
    sigmaUrl
    type
  }
}
    `;

/**
 * __useSigmaReportByTypeQuery__
 *
 * To run a query within a React component, call `useSigmaReportByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSigmaReportByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSigmaReportByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSigmaReportByTypeQuery(baseOptions: Apollo.QueryHookOptions<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables> & ({ variables: SigmaReportByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>(SigmaReportByTypeDocument, options);
      }
export function useSigmaReportByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>(SigmaReportByTypeDocument, options);
        }
export function useSigmaReportByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>(SigmaReportByTypeDocument, options);
        }
export type SigmaReportByTypeQueryHookResult = ReturnType<typeof useSigmaReportByTypeQuery>;
export type SigmaReportByTypeLazyQueryHookResult = ReturnType<typeof useSigmaReportByTypeLazyQuery>;
export type SigmaReportByTypeSuspenseQueryHookResult = ReturnType<typeof useSigmaReportByTypeSuspenseQuery>;
export type SigmaReportByTypeQueryResult = Apollo.QueryResult<SigmaReportByTypeQuery, SigmaReportByTypeQueryVariables>;
export const SigmaDashboardByUrlDocument = gql`
    query sigmaDashboardByUrl($url: String!) @api(name: report) {
  getSigmaDashboardForURL(dashboardURL: $url)
}
    `;

/**
 * __useSigmaDashboardByUrlQuery__
 *
 * To run a query within a React component, call `useSigmaDashboardByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSigmaDashboardByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSigmaDashboardByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSigmaDashboardByUrlQuery(baseOptions: Apollo.QueryHookOptions<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables> & ({ variables: SigmaDashboardByUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>(SigmaDashboardByUrlDocument, options);
      }
export function useSigmaDashboardByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>(SigmaDashboardByUrlDocument, options);
        }
export function useSigmaDashboardByUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>(SigmaDashboardByUrlDocument, options);
        }
export type SigmaDashboardByUrlQueryHookResult = ReturnType<typeof useSigmaDashboardByUrlQuery>;
export type SigmaDashboardByUrlLazyQueryHookResult = ReturnType<typeof useSigmaDashboardByUrlLazyQuery>;
export type SigmaDashboardByUrlSuspenseQueryHookResult = ReturnType<typeof useSigmaDashboardByUrlSuspenseQuery>;
export type SigmaDashboardByUrlQueryResult = Apollo.QueryResult<SigmaDashboardByUrlQuery, SigmaDashboardByUrlQueryVariables>;
export const HandleVerificationRequestDocument = gql`
    mutation handleVerificationRequest($userId: ID!, $ticketId: Int!, $nonprofitId: ID!) @api(name: nonprofit) {
  handleVerificationRequest(
    userId: $userId
    ticketId: $ticketId
    nonprofitId: $nonprofitId
  )
}
    `;
export type HandleVerificationRequestMutationFn = Apollo.MutationFunction<HandleVerificationRequestMutation, HandleVerificationRequestMutationVariables>;

/**
 * __useHandleVerificationRequestMutation__
 *
 * To run a mutation, you first call `useHandleVerificationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleVerificationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleVerificationRequestMutation, { data, loading, error }] = useHandleVerificationRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      ticketId: // value for 'ticketId'
 *      nonprofitId: // value for 'nonprofitId'
 *   },
 * });
 */
export function useHandleVerificationRequestMutation(baseOptions?: Apollo.MutationHookOptions<HandleVerificationRequestMutation, HandleVerificationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleVerificationRequestMutation, HandleVerificationRequestMutationVariables>(HandleVerificationRequestDocument, options);
      }
export type HandleVerificationRequestMutationHookResult = ReturnType<typeof useHandleVerificationRequestMutation>;
export type HandleVerificationRequestMutationResult = Apollo.MutationResult<HandleVerificationRequestMutation>;
export type HandleVerificationRequestMutationOptions = Apollo.BaseMutationOptions<HandleVerificationRequestMutation, HandleVerificationRequestMutationVariables>;
export const VolunteerTimeOffsListDocument = gql`
    query volunteerTimeOffsList($volunteerTimeOffsUserId: ID) @api(name: timeOff) {
  volunteerTimeOffs(userId: $volunteerTimeOffsUserId) {
    id
    Deed {
      id
      type
      name
    }
    userId
    status
    startingAt
    requestedAt
    duration
  }
}
    `;

/**
 * __useVolunteerTimeOffsListQuery__
 *
 * To run a query within a React component, call `useVolunteerTimeOffsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerTimeOffsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerTimeOffsListQuery({
 *   variables: {
 *      volunteerTimeOffsUserId: // value for 'volunteerTimeOffsUserId'
 *   },
 * });
 */
export function useVolunteerTimeOffsListQuery(baseOptions?: Apollo.QueryHookOptions<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>(VolunteerTimeOffsListDocument, options);
      }
export function useVolunteerTimeOffsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>(VolunteerTimeOffsListDocument, options);
        }
export function useVolunteerTimeOffsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>(VolunteerTimeOffsListDocument, options);
        }
export type VolunteerTimeOffsListQueryHookResult = ReturnType<typeof useVolunteerTimeOffsListQuery>;
export type VolunteerTimeOffsListLazyQueryHookResult = ReturnType<typeof useVolunteerTimeOffsListLazyQuery>;
export type VolunteerTimeOffsListSuspenseQueryHookResult = ReturnType<typeof useVolunteerTimeOffsListSuspenseQuery>;
export type VolunteerTimeOffsListQueryResult = Apollo.QueryResult<VolunteerTimeOffsListQuery, VolunteerTimeOffsListQueryVariables>;
export const VolunteerTimeOffSummaryDocument = gql`
    query VolunteerTimeOffSummary($volunteerTimeOffSummaryUserId: ID) @api(name: timeOff) {
  volunteerTimeOffSummary(userId: $volunteerTimeOffSummaryUserId) {
    balance
    used
    total
  }
}
    `;

/**
 * __useVolunteerTimeOffSummaryQuery__
 *
 * To run a query within a React component, call `useVolunteerTimeOffSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerTimeOffSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerTimeOffSummaryQuery({
 *   variables: {
 *      volunteerTimeOffSummaryUserId: // value for 'volunteerTimeOffSummaryUserId'
 *   },
 * });
 */
export function useVolunteerTimeOffSummaryQuery(baseOptions?: Apollo.QueryHookOptions<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>(VolunteerTimeOffSummaryDocument, options);
      }
export function useVolunteerTimeOffSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>(VolunteerTimeOffSummaryDocument, options);
        }
export function useVolunteerTimeOffSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>(VolunteerTimeOffSummaryDocument, options);
        }
export type VolunteerTimeOffSummaryQueryHookResult = ReturnType<typeof useVolunteerTimeOffSummaryQuery>;
export type VolunteerTimeOffSummaryLazyQueryHookResult = ReturnType<typeof useVolunteerTimeOffSummaryLazyQuery>;
export type VolunteerTimeOffSummarySuspenseQueryHookResult = ReturnType<typeof useVolunteerTimeOffSummarySuspenseQuery>;
export type VolunteerTimeOffSummaryQueryResult = Apollo.QueryResult<VolunteerTimeOffSummaryQuery, VolunteerTimeOffSummaryQueryVariables>;
export const VolunteerRewardsDocument = gql`
    query VolunteerRewards($where: VolunteerRewardWhereInput, $orderBy: VolunteerRewardOrderByWithRelationInput, $orderByList: [VolunteerRewardOrderByWithRelationInput], $cursor: VolunteerRewardWhereUniqueInput, $take: Int, $skip: Int) @api(name: loggedTime) {
  volunteerRewards(
    where: $where
    orderBy: $orderBy
    orderByList: $orderByList
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    items {
      ...volunteerReward
    }
    metadata {
      totalItems
      totalPages
      skip
      take
    }
  }
}
    ${VolunteerRewardFragmentDoc}`;

/**
 * __useVolunteerRewardsQuery__
 *
 * To run a query within a React component, call `useVolunteerRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerRewardsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      orderByList: // value for 'orderByList'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVolunteerRewardsQuery(baseOptions?: Apollo.QueryHookOptions<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>(VolunteerRewardsDocument, options);
      }
export function useVolunteerRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>(VolunteerRewardsDocument, options);
        }
export function useVolunteerRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>(VolunteerRewardsDocument, options);
        }
export type VolunteerRewardsQueryHookResult = ReturnType<typeof useVolunteerRewardsQuery>;
export type VolunteerRewardsLazyQueryHookResult = ReturnType<typeof useVolunteerRewardsLazyQuery>;
export type VolunteerRewardsSuspenseQueryHookResult = ReturnType<typeof useVolunteerRewardsSuspenseQuery>;
export type VolunteerRewardsQueryResult = Apollo.QueryResult<VolunteerRewardsQuery, VolunteerRewardsQueryVariables>;
export const UpdateVolunteerRewardDocument = gql`
    mutation updateVolunteerReward($ids: [ID!]!, $data: VolunteerRewardInputType!) @api(name: loggedTime) {
  updateVolunteerRewards(ids: $ids, data: $data) {
    id
    approvalStatus
  }
}
    `;
export type UpdateVolunteerRewardMutationFn = Apollo.MutationFunction<UpdateVolunteerRewardMutation, UpdateVolunteerRewardMutationVariables>;

/**
 * __useUpdateVolunteerRewardMutation__
 *
 * To run a mutation, you first call `useUpdateVolunteerRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolunteerRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolunteerRewardMutation, { data, loading, error }] = useUpdateVolunteerRewardMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateVolunteerRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVolunteerRewardMutation, UpdateVolunteerRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVolunteerRewardMutation, UpdateVolunteerRewardMutationVariables>(UpdateVolunteerRewardDocument, options);
      }
export type UpdateVolunteerRewardMutationHookResult = ReturnType<typeof useUpdateVolunteerRewardMutation>;
export type UpdateVolunteerRewardMutationResult = Apollo.MutationResult<UpdateVolunteerRewardMutation>;
export type UpdateVolunteerRewardMutationOptions = Apollo.BaseMutationOptions<UpdateVolunteerRewardMutation, UpdateVolunteerRewardMutationVariables>;
export const DonationSchedulesDocument = gql`
    query DonationSchedules($where: DonationScheduleWhereInput!) @api(name: graph) {
  donationSchedules(where: $where) {
    ...donationSchedule
  }
}
    ${DonationScheduleFragmentDoc}`;

/**
 * __useDonationSchedulesQuery__
 *
 * To run a query within a React component, call `useDonationSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonationSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonationSchedulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDonationSchedulesQuery(baseOptions: Apollo.QueryHookOptions<DonationSchedulesQuery, DonationSchedulesQueryVariables> & ({ variables: DonationSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonationSchedulesQuery, DonationSchedulesQueryVariables>(DonationSchedulesDocument, options);
      }
export function useDonationSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonationSchedulesQuery, DonationSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonationSchedulesQuery, DonationSchedulesQueryVariables>(DonationSchedulesDocument, options);
        }
export function useDonationSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DonationSchedulesQuery, DonationSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DonationSchedulesQuery, DonationSchedulesQueryVariables>(DonationSchedulesDocument, options);
        }
export type DonationSchedulesQueryHookResult = ReturnType<typeof useDonationSchedulesQuery>;
export type DonationSchedulesLazyQueryHookResult = ReturnType<typeof useDonationSchedulesLazyQuery>;
export type DonationSchedulesSuspenseQueryHookResult = ReturnType<typeof useDonationSchedulesSuspenseQuery>;
export type DonationSchedulesQueryResult = Apollo.QueryResult<DonationSchedulesQuery, DonationSchedulesQueryVariables>;
export const DonationScheduleFullDocument = gql`
    query DonationScheduleFull($where: DonationScheduleWhereInput!) @api(name: graph) {
  donationSchedules(where: $where) {
    ...donationScheduleFull
  }
}
    ${DonationScheduleFullFragmentDoc}`;

/**
 * __useDonationScheduleFullQuery__
 *
 * To run a query within a React component, call `useDonationScheduleFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonationScheduleFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonationScheduleFullQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDonationScheduleFullQuery(baseOptions: Apollo.QueryHookOptions<DonationScheduleFullQuery, DonationScheduleFullQueryVariables> & ({ variables: DonationScheduleFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>(DonationScheduleFullDocument, options);
      }
export function useDonationScheduleFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>(DonationScheduleFullDocument, options);
        }
export function useDonationScheduleFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>(DonationScheduleFullDocument, options);
        }
export type DonationScheduleFullQueryHookResult = ReturnType<typeof useDonationScheduleFullQuery>;
export type DonationScheduleFullLazyQueryHookResult = ReturnType<typeof useDonationScheduleFullLazyQuery>;
export type DonationScheduleFullSuspenseQueryHookResult = ReturnType<typeof useDonationScheduleFullSuspenseQuery>;
export type DonationScheduleFullQueryResult = Apollo.QueryResult<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>;
export const CancelDonationScheduleDocument = gql`
    mutation CancelDonationSchedule($id: ID!) @api(name: graph) {
  cancelDonationSchedule(id: $id) {
    ...donationSchedule
  }
}
    ${DonationScheduleFragmentDoc}`;
export type CancelDonationScheduleMutationFn = Apollo.MutationFunction<CancelDonationScheduleMutation, CancelDonationScheduleMutationVariables>;

/**
 * __useCancelDonationScheduleMutation__
 *
 * To run a mutation, you first call `useCancelDonationScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDonationScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDonationScheduleMutation, { data, loading, error }] = useCancelDonationScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDonationScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CancelDonationScheduleMutation, CancelDonationScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDonationScheduleMutation, CancelDonationScheduleMutationVariables>(CancelDonationScheduleDocument, options);
      }
export type CancelDonationScheduleMutationHookResult = ReturnType<typeof useCancelDonationScheduleMutation>;
export type CancelDonationScheduleMutationResult = Apollo.MutationResult<CancelDonationScheduleMutation>;
export type CancelDonationScheduleMutationOptions = Apollo.BaseMutationOptions<CancelDonationScheduleMutation, CancelDonationScheduleMutationVariables>;
export const UpdateDonationScheduleDocument = gql`
    mutation UpdateDonationSchedule($id: ID!, $data: DonationScheduleUpdateInputType!) @api(name: graph) {
  updateDonationSchedule(id: $id, data: $data) {
    ...donationSchedule
  }
}
    ${DonationScheduleFragmentDoc}`;
export type UpdateDonationScheduleMutationFn = Apollo.MutationFunction<UpdateDonationScheduleMutation, UpdateDonationScheduleMutationVariables>;

/**
 * __useUpdateDonationScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateDonationScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationScheduleMutation, { data, loading, error }] = useUpdateDonationScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDonationScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationScheduleMutation, UpdateDonationScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationScheduleMutation, UpdateDonationScheduleMutationVariables>(UpdateDonationScheduleDocument, options);
      }
export type UpdateDonationScheduleMutationHookResult = ReturnType<typeof useUpdateDonationScheduleMutation>;
export type UpdateDonationScheduleMutationResult = Apollo.MutationResult<UpdateDonationScheduleMutation>;
export type UpdateDonationScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateDonationScheduleMutation, UpdateDonationScheduleMutationVariables>;
export const CountriesDocument = gql`
    query countries @api(name: graph) {
  countries {
    code
    countryCode
    country
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const LocationsDocument = gql`
    query locations @api(name: graph) {
  locations {
    id
    name
    code
    country
    countryCode
    currencyCode
    createdAt
    modifiedAt
    coordinates
    public
    state
    picture
    stateCode
    region
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export function useLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const PersistGovernmentInformationLetterDocument = gql`
    mutation persistGovernmentInformationLetter($governmentInformationLetterUri: String!, $legalName: String!, $letterOfAssociationUri: String) @api(name: nonprofit) {
  persistGovernmentInformationLetter(
    governmentInformationLetterUri: $governmentInformationLetterUri
    letterOfAssociationUri: $letterOfAssociationUri
    legalName: $legalName
  )
}
    `;
export type PersistGovernmentInformationLetterMutationFn = Apollo.MutationFunction<PersistGovernmentInformationLetterMutation, PersistGovernmentInformationLetterMutationVariables>;

/**
 * __usePersistGovernmentInformationLetterMutation__
 *
 * To run a mutation, you first call `usePersistGovernmentInformationLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistGovernmentInformationLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistGovernmentInformationLetterMutation, { data, loading, error }] = usePersistGovernmentInformationLetterMutation({
 *   variables: {
 *      governmentInformationLetterUri: // value for 'governmentInformationLetterUri'
 *      legalName: // value for 'legalName'
 *      letterOfAssociationUri: // value for 'letterOfAssociationUri'
 *   },
 * });
 */
export function usePersistGovernmentInformationLetterMutation(baseOptions?: Apollo.MutationHookOptions<PersistGovernmentInformationLetterMutation, PersistGovernmentInformationLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersistGovernmentInformationLetterMutation, PersistGovernmentInformationLetterMutationVariables>(PersistGovernmentInformationLetterDocument, options);
      }
export type PersistGovernmentInformationLetterMutationHookResult = ReturnType<typeof usePersistGovernmentInformationLetterMutation>;
export type PersistGovernmentInformationLetterMutationResult = Apollo.MutationResult<PersistGovernmentInformationLetterMutation>;
export type PersistGovernmentInformationLetterMutationOptions = Apollo.BaseMutationOptions<PersistGovernmentInformationLetterMutation, PersistGovernmentInformationLetterMutationVariables>;
export const RequestVerificationDocument = gql`
    mutation requestVerification($supportingDocuments: [String!]!, $role: String!) @api(name: nonprofit) {
  requestVerification(supportingDocuments: $supportingDocuments, role: $role)
}
    `;
export type RequestVerificationMutationFn = Apollo.MutationFunction<RequestVerificationMutation, RequestVerificationMutationVariables>;

/**
 * __useRequestVerificationMutation__
 *
 * To run a mutation, you first call `useRequestVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestVerificationMutation, { data, loading, error }] = useRequestVerificationMutation({
 *   variables: {
 *      supportingDocuments: // value for 'supportingDocuments'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRequestVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestVerificationMutation, RequestVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestVerificationMutation, RequestVerificationMutationVariables>(RequestVerificationDocument, options);
      }
export type RequestVerificationMutationHookResult = ReturnType<typeof useRequestVerificationMutation>;
export type RequestVerificationMutationResult = Apollo.MutationResult<RequestVerificationMutation>;
export type RequestVerificationMutationOptions = Apollo.BaseMutationOptions<RequestVerificationMutation, RequestVerificationMutationVariables>;
export const VerifyOrganizerUserWithPayPalDocument = gql`
    mutation verifyOrganizerUserWithPayPal($code: String!) @api(name: nonprofit) {
  verifyOrganizerUserWithPayPal(code: $code)
}
    `;
export type VerifyOrganizerUserWithPayPalMutationFn = Apollo.MutationFunction<VerifyOrganizerUserWithPayPalMutation, VerifyOrganizerUserWithPayPalMutationVariables>;

/**
 * __useVerifyOrganizerUserWithPayPalMutation__
 *
 * To run a mutation, you first call `useVerifyOrganizerUserWithPayPalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOrganizerUserWithPayPalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOrganizerUserWithPayPalMutation, { data, loading, error }] = useVerifyOrganizerUserWithPayPalMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyOrganizerUserWithPayPalMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOrganizerUserWithPayPalMutation, VerifyOrganizerUserWithPayPalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOrganizerUserWithPayPalMutation, VerifyOrganizerUserWithPayPalMutationVariables>(VerifyOrganizerUserWithPayPalDocument, options);
      }
export type VerifyOrganizerUserWithPayPalMutationHookResult = ReturnType<typeof useVerifyOrganizerUserWithPayPalMutation>;
export type VerifyOrganizerUserWithPayPalMutationResult = Apollo.MutationResult<VerifyOrganizerUserWithPayPalMutation>;
export type VerifyOrganizerUserWithPayPalMutationOptions = Apollo.BaseMutationOptions<VerifyOrganizerUserWithPayPalMutation, VerifyOrganizerUserWithPayPalMutationVariables>;
export const UnblockOrganizerUserInOrganizationDocument = gql`
    mutation unblockOrganizerUserInOrganization($userId: ID!) @api(name: graph) {
  unblockOrganizerUserInOrganization(userId: $userId)
}
    `;
export type UnblockOrganizerUserInOrganizationMutationFn = Apollo.MutationFunction<UnblockOrganizerUserInOrganizationMutation, UnblockOrganizerUserInOrganizationMutationVariables>;

/**
 * __useUnblockOrganizerUserInOrganizationMutation__
 *
 * To run a mutation, you first call `useUnblockOrganizerUserInOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockOrganizerUserInOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockOrganizerUserInOrganizationMutation, { data, loading, error }] = useUnblockOrganizerUserInOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockOrganizerUserInOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UnblockOrganizerUserInOrganizationMutation, UnblockOrganizerUserInOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockOrganizerUserInOrganizationMutation, UnblockOrganizerUserInOrganizationMutationVariables>(UnblockOrganizerUserInOrganizationDocument, options);
      }
export type UnblockOrganizerUserInOrganizationMutationHookResult = ReturnType<typeof useUnblockOrganizerUserInOrganizationMutation>;
export type UnblockOrganizerUserInOrganizationMutationResult = Apollo.MutationResult<UnblockOrganizerUserInOrganizationMutation>;
export type UnblockOrganizerUserInOrganizationMutationOptions = Apollo.BaseMutationOptions<UnblockOrganizerUserInOrganizationMutation, UnblockOrganizerUserInOrganizationMutationVariables>;
export const BlockOrganizerUserInOrganizationDocument = gql`
    mutation blockOrganizerUserInOrganization($userId: ID!) @api(name: graph) {
  blockOrganizerUserInOrganization(userId: $userId)
}
    `;
export type BlockOrganizerUserInOrganizationMutationFn = Apollo.MutationFunction<BlockOrganizerUserInOrganizationMutation, BlockOrganizerUserInOrganizationMutationVariables>;

/**
 * __useBlockOrganizerUserInOrganizationMutation__
 *
 * To run a mutation, you first call `useBlockOrganizerUserInOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOrganizerUserInOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOrganizerUserInOrganizationMutation, { data, loading, error }] = useBlockOrganizerUserInOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockOrganizerUserInOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<BlockOrganizerUserInOrganizationMutation, BlockOrganizerUserInOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockOrganizerUserInOrganizationMutation, BlockOrganizerUserInOrganizationMutationVariables>(BlockOrganizerUserInOrganizationDocument, options);
      }
export type BlockOrganizerUserInOrganizationMutationHookResult = ReturnType<typeof useBlockOrganizerUserInOrganizationMutation>;
export type BlockOrganizerUserInOrganizationMutationResult = Apollo.MutationResult<BlockOrganizerUserInOrganizationMutation>;
export type BlockOrganizerUserInOrganizationMutationOptions = Apollo.BaseMutationOptions<BlockOrganizerUserInOrganizationMutation, BlockOrganizerUserInOrganizationMutationVariables>;
export const SwitchOrganizationDocument = gql`
    mutation switchOrganization($organizationId: ID!) @api(name: graph) {
  switchOrganization(organizationId: $organizationId)
}
    `;
export type SwitchOrganizationMutationFn = Apollo.MutationFunction<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>;

/**
 * __useSwitchOrganizationMutation__
 *
 * To run a mutation, you first call `useSwitchOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrganizationMutation, { data, loading, error }] = useSwitchOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSwitchOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>(SwitchOrganizationDocument, options);
      }
export type SwitchOrganizationMutationHookResult = ReturnType<typeof useSwitchOrganizationMutation>;
export type SwitchOrganizationMutationResult = Apollo.MutationResult<SwitchOrganizationMutation>;
export type SwitchOrganizationMutationOptions = Apollo.BaseMutationOptions<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>;
export const VolunteerTimesWithPaginationDocument = gql`
    query volunteerTimesWithPagination($where: VolunteerTimeWhereInput, $orderBy: VolunteerTimeOrderByWithRelationInput, $cursor: VolunteerTimeWhereUniqueInput, $take: Int, $skip: Int) @api(name: loggedTime) {
  volunteerTimesWithPagination(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    items {
      ...volunteerTime
    }
    metadata {
      totalItems
      totalPages
      skip
      take
    }
  }
}
    ${VolunteerTimeFragmentDoc}`;

/**
 * __useVolunteerTimesWithPaginationQuery__
 *
 * To run a query within a React component, call `useVolunteerTimesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerTimesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerTimesWithPaginationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useVolunteerTimesWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>(VolunteerTimesWithPaginationDocument, options);
      }
export function useVolunteerTimesWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>(VolunteerTimesWithPaginationDocument, options);
        }
export function useVolunteerTimesWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>(VolunteerTimesWithPaginationDocument, options);
        }
export type VolunteerTimesWithPaginationQueryHookResult = ReturnType<typeof useVolunteerTimesWithPaginationQuery>;
export type VolunteerTimesWithPaginationLazyQueryHookResult = ReturnType<typeof useVolunteerTimesWithPaginationLazyQuery>;
export type VolunteerTimesWithPaginationSuspenseQueryHookResult = ReturnType<typeof useVolunteerTimesWithPaginationSuspenseQuery>;
export type VolunteerTimesWithPaginationQueryResult = Apollo.QueryResult<VolunteerTimesWithPaginationQuery, VolunteerTimesWithPaginationQueryVariables>;
export const VolunteerTimesDocument = gql`
    query VolunteerTimes($where: VolunteerTimeWhereInput!) @api(name: loggedTime) {
  volunteerTimes(where: $where) {
    ...volunteerTime
  }
}
    ${VolunteerTimeFragmentDoc}`;

/**
 * __useVolunteerTimesQuery__
 *
 * To run a query within a React component, call `useVolunteerTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerTimesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVolunteerTimesQuery(baseOptions: Apollo.QueryHookOptions<VolunteerTimesQuery, VolunteerTimesQueryVariables> & ({ variables: VolunteerTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VolunteerTimesQuery, VolunteerTimesQueryVariables>(VolunteerTimesDocument, options);
      }
export function useVolunteerTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VolunteerTimesQuery, VolunteerTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VolunteerTimesQuery, VolunteerTimesQueryVariables>(VolunteerTimesDocument, options);
        }
export function useVolunteerTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VolunteerTimesQuery, VolunteerTimesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VolunteerTimesQuery, VolunteerTimesQueryVariables>(VolunteerTimesDocument, options);
        }
export type VolunteerTimesQueryHookResult = ReturnType<typeof useVolunteerTimesQuery>;
export type VolunteerTimesLazyQueryHookResult = ReturnType<typeof useVolunteerTimesLazyQuery>;
export type VolunteerTimesSuspenseQueryHookResult = ReturnType<typeof useVolunteerTimesSuspenseQuery>;
export type VolunteerTimesQueryResult = Apollo.QueryResult<VolunteerTimesQuery, VolunteerTimesQueryVariables>;
export const ApproveVolunteerTimeDocument = gql`
    mutation ApproveVolunteerTime($id: ID!) @api(name: loggedTime) {
  approveVolunteerTime(id: $id) {
    ...limitedVolunteerTime
  }
}
    ${LimitedVolunteerTimeFragmentDoc}`;
export type ApproveVolunteerTimeMutationFn = Apollo.MutationFunction<ApproveVolunteerTimeMutation, ApproveVolunteerTimeMutationVariables>;

/**
 * __useApproveVolunteerTimeMutation__
 *
 * To run a mutation, you first call `useApproveVolunteerTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveVolunteerTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveVolunteerTimeMutation, { data, loading, error }] = useApproveVolunteerTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveVolunteerTimeMutation(baseOptions?: Apollo.MutationHookOptions<ApproveVolunteerTimeMutation, ApproveVolunteerTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveVolunteerTimeMutation, ApproveVolunteerTimeMutationVariables>(ApproveVolunteerTimeDocument, options);
      }
export type ApproveVolunteerTimeMutationHookResult = ReturnType<typeof useApproveVolunteerTimeMutation>;
export type ApproveVolunteerTimeMutationResult = Apollo.MutationResult<ApproveVolunteerTimeMutation>;
export type ApproveVolunteerTimeMutationOptions = Apollo.BaseMutationOptions<ApproveVolunteerTimeMutation, ApproveVolunteerTimeMutationVariables>;
export const RejectVolunteerTimeDocument = gql`
    mutation RejectVolunteerTime($id: ID!) @api(name: loggedTime) {
  rejectVolunteerTime(id: $id) {
    ...limitedVolunteerTime
  }
}
    ${LimitedVolunteerTimeFragmentDoc}`;
export type RejectVolunteerTimeMutationFn = Apollo.MutationFunction<RejectVolunteerTimeMutation, RejectVolunteerTimeMutationVariables>;

/**
 * __useRejectVolunteerTimeMutation__
 *
 * To run a mutation, you first call `useRejectVolunteerTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectVolunteerTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectVolunteerTimeMutation, { data, loading, error }] = useRejectVolunteerTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectVolunteerTimeMutation(baseOptions?: Apollo.MutationHookOptions<RejectVolunteerTimeMutation, RejectVolunteerTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectVolunteerTimeMutation, RejectVolunteerTimeMutationVariables>(RejectVolunteerTimeDocument, options);
      }
export type RejectVolunteerTimeMutationHookResult = ReturnType<typeof useRejectVolunteerTimeMutation>;
export type RejectVolunteerTimeMutationResult = Apollo.MutationResult<RejectVolunteerTimeMutation>;
export type RejectVolunteerTimeMutationOptions = Apollo.BaseMutationOptions<RejectVolunteerTimeMutation, RejectVolunteerTimeMutationVariables>;
export const UpdateVolunteerTimesDocument = gql`
    mutation updateVolunteerTimes($ids: [ID!]!, $data: VolunteerTimesUpdateInputType!) @api(name: loggedTime) {
  updateVolunteerTimes(ids: $ids, data: $data) {
    id
    approval
  }
}
    `;
export type UpdateVolunteerTimesMutationFn = Apollo.MutationFunction<UpdateVolunteerTimesMutation, UpdateVolunteerTimesMutationVariables>;

/**
 * __useUpdateVolunteerTimesMutation__
 *
 * To run a mutation, you first call `useUpdateVolunteerTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolunteerTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolunteerTimesMutation, { data, loading, error }] = useUpdateVolunteerTimesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateVolunteerTimesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVolunteerTimesMutation, UpdateVolunteerTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVolunteerTimesMutation, UpdateVolunteerTimesMutationVariables>(UpdateVolunteerTimesDocument, options);
      }
export type UpdateVolunteerTimesMutationHookResult = ReturnType<typeof useUpdateVolunteerTimesMutation>;
export type UpdateVolunteerTimesMutationResult = Apollo.MutationResult<UpdateVolunteerTimesMutation>;
export type UpdateVolunteerTimesMutationOptions = Apollo.BaseMutationOptions<UpdateVolunteerTimesMutation, UpdateVolunteerTimesMutationVariables>;
export const SearchNonprofitsDocument = gql`
    query searchNonprofits($acceptsDonations: Boolean, $causes: [String], $countryCode: String, $donationProvider: String, $excludeDonationProviders: [String], $includeApproved: Boolean, $includeBlocked: Boolean, $limit: Int, $offset: Int, $searchTerm: String, $stateCode: String, $campaign: String) @api(name: nonprofit) {
  searchNonprofits(
    acceptsDonations: $acceptsDonations
    causes: $causes
    countryCode: $countryCode
    donationProvider: $donationProvider
    excludeDonationProviders: $excludeDonationProviders
    includeApproved: $includeApproved
    includeBlocked: $includeBlocked
    limit: $limit
    offset: $offset
    searchTerm: $searchTerm
    stateCode: $stateCode
    campaign: $campaign
  ) {
    id
    type
    approved
    brief
    currencyCode
    ein
    email
    externalId
    identifiers {
      countryCode
      id
      type
    }
    locationObject {
      address
      address2
      area
      city
      country
      countryCode
      geo {
        coordinates
        type
      }
      postalCode
      state
      stateCode
    }
    logo
    mainPicture
    name
    nonprofitEntityType
    nonprofitId
    payPalModel
    paypalCharityType
    phone
    taxonomy {
      externalClassification
      irsClassificationCode
      irsFoundationCode
      irsSubSectionCode
      ncesSchoolDistrict
      ncesSchoolType
    }
    website
    categories
    searchTermMatchScore
    matchForSearchTerm
    donationProviders {
      Stripe
      NFG
      GlobalGiving
      Betterplace
      PayPal
      External
      CAF
    }
    acceptsDonations
    meta {
      totalItems
      totalPages
      offset
      limit
    }
    isChapter
  }
}
    `;

/**
 * __useSearchNonprofitsQuery__
 *
 * To run a query within a React component, call `useSearchNonprofitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNonprofitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNonprofitsQuery({
 *   variables: {
 *      acceptsDonations: // value for 'acceptsDonations'
 *      causes: // value for 'causes'
 *      countryCode: // value for 'countryCode'
 *      donationProvider: // value for 'donationProvider'
 *      excludeDonationProviders: // value for 'excludeDonationProviders'
 *      includeApproved: // value for 'includeApproved'
 *      includeBlocked: // value for 'includeBlocked'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchTerm: // value for 'searchTerm'
 *      stateCode: // value for 'stateCode'
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useSearchNonprofitsQuery(baseOptions?: Apollo.QueryHookOptions<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>(SearchNonprofitsDocument, options);
      }
export function useSearchNonprofitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>(SearchNonprofitsDocument, options);
        }
export function useSearchNonprofitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>(SearchNonprofitsDocument, options);
        }
export type SearchNonprofitsQueryHookResult = ReturnType<typeof useSearchNonprofitsQuery>;
export type SearchNonprofitsLazyQueryHookResult = ReturnType<typeof useSearchNonprofitsLazyQuery>;
export type SearchNonprofitsSuspenseQueryHookResult = ReturnType<typeof useSearchNonprofitsSuspenseQuery>;
export type SearchNonprofitsQueryResult = Apollo.QueryResult<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>;
export const EmployeesDocument = gql`
    query employees($take: Int!, $skip: Int, $search: String, $emails: String) @api(name: graph) {
  employees(take: $take, skip: $skip, search: $search, emails: $emails) {
    users {
      id
      fullName {
        first
        last
      }
      organizationDepartment
      mainPicture
      communities {
        communityId
      }
      email
    }
    total
  }
}
    `;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables> & ({ variables: EmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesSuspenseQueryHookResult = ReturnType<typeof useEmployeesSuspenseQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;